/**
 * zones_dictionary.js
 * AUTO-GENERATED -- do not edit by hand.
 * Generated by generate_zone_dictionary.py using WordNet lexname mapping.
 * No API key or internet connection required.
 *
 * Total words processed : 68,477
 * Words mapped to a zone: 40,798
 * Words with no zone    : 27,679
 *
 * Zone breakdown:
 *   build       : 9,433
 *   beautiful   : 4,215
 *   sound       : 1,001
 *   taste       : 1,585
 *   story       : 5,586
 *   heal        : 12,279
 *   smart       : 4,792
 *   sell        : 1,907
 */

export const ZONE_DICTIONARY = {
  ".22": "build",
  "20/20": "smart",
  "3-d": "story",
  "3tc": "build",
  "401-k": "smart",
  "4wd": "build",
  "a-bomb": "build",
  "a-line": "build",
  "a-list": "story",
  "aah": "story",
  "aalii": "heal",
  "aardvark": "heal",
  "aardwolf": "heal",
  "aas": "story",
  "aave": "story",
  "aba": "build",
  "abaca": "heal",
  "abacinate": "sound",
  "abactinal": "beautiful",
  "abacus": "build",
  "abalone": "heal",
  "abamp": "smart",
  "abampere": "smart",
  "abandon": "sell",
  "abatis": "build",
  "abattis": "build",
  "abattoir": "build",
  "abaxial": "beautiful",
  "abaya": "build",
  "abbey": "build",
  "abbreviation": "story",
  "abc": "smart",
  "abc's": "smart",
  "abcoulomb": "smart",
  "abcs": "smart",
  "abdias": "story",
  "abdicate": "sell",
  "abdication": "story",
  "abdomen": "heal",
  "abdominal": "heal",
  "abdominocentesis": "heal",
  "abduce": "story",
  "abducens": "heal",
  "abducent": "heal",
  "abduct": "build",
  "abducting": "build",
  "abduction": "heal",
  "abductor": "heal",
  "abecedarian": "beautiful",
  "abecedarius": "story",
  "abele": "heal",
  "abelia": "heal",
  "abelmoschus": "heal",
  "abelmosk": "heal",
  "aberrant": "beautiful",
  "aberration": "sound",
  "abet": "sell",
  "abetment": "story",
  "abettal": "story",
  "abeyance": "sound",
  "abfarad": "smart",
  "abhenry": "smart",
  "abide": "smart",
  "abies": "heal",
  "ability": "smart",
  "abiogenesis": "sound",
  "abjuration": "story",
  "abjure": "story",
  "abkhasian": "story",
  "abkhazian": "story",
  "ablactate": "taste",
  "ablactation": "smart",
  "ablation": "smart",
  "ablative": "story",
  "ablaut": "story",
  "able": "beautiful",
  "abls": "story",
  "abm": "build",
  "abnaki": "story",
  "abnegate": "sell",
  "abnegation": "story",
  "abnormal": "beautiful",
  "abnormality": "smart",
  "abode": "build",
  "abohm": "smart",
  "abolish": "sell",
  "abolitionism": "smart",
  "abomasum": "heal",
  "abor": "story",
  "aboral": "beautiful",
  "aboriginal": "beautiful",
  "abort": "heal",
  "aborticide": "build",
  "abortifacient": "build",
  "abortus": "heal",
  "about-face": "smart",
  "above": "story",
  "abracadabra": "story",
  "abradant": "build",
  "abrade": "build",
  "abrader": "build",
  "abramis": "heal",
  "abranchial": "beautiful",
  "abranchiate": "beautiful",
  "abranchious": "beautiful",
  "abrase": "build",
  "abrasion": "smart",
  "abrasive": "beautiful",
  "abridged": "beautiful",
  "abridgement": "story",
  "abridgment": "story",
  "abrocoma": "heal",
  "abrocome": "heal",
  "abrogate": "sell",
  "abronia": "heal",
  "abs": "story",
  "abscise": "build",
  "abscissa": "smart",
  "abscission": "smart",
  "absent": "beautiful",
  "absentmindedness": "smart",
  "absinth": "taste",
  "absinthe": "heal",
  "absolute": "smart",
  "absolutism": "smart",
  "absolve": "story",
  "absorb": "build",
  "absorbable": "beautiful",
  "absorbent": "beautiful",
  "absorptance": "smart",
  "absorption": "smart",
  "absorptive": "beautiful",
  "abstain": "sell",
  "abstemious": "beautiful",
  "abstinent": "beautiful",
  "abstract": "beautiful",
  "abstractedness": "smart",
  "abstracter": "beautiful",
  "abstraction": "smart",
  "abstractionism": "build",
  "abstractionist": "beautiful",
  "abstruseness": "smart",
  "abstrusity": "smart",
  "absurd": "beautiful",
  "absurdity": "story",
  "absurdness": "story",
  "abudefduf": "heal",
  "abundant": "beautiful",
  "abuse": "story",
  "abused": "sell",
  "abut": "build",
  "abutilon": "heal",
  "abutment": "build",
  "abvolt": "smart",
  "abwatt": "smart",
  "aby": "sell",
  "abye": "sell",
  "abyssal": "beautiful",
  "abyssinian": "heal",
  "acacia": "heal",
  "academic": "beautiful",
  "academy": "build",
  "acalypha": "heal",
  "acanthaceae": "heal",
  "acanthion": "heal",
  "acanthisitta": "heal",
  "acanthisittidae": "heal",
  "acanthocephala": "heal",
  "acanthocephalan": "heal",
  "acanthocereus": "heal",
  "acanthocybium": "heal",
  "acanthocyte": "heal",
  "acanthophis": "heal",
  "acanthopterygian": "heal",
  "acanthopterygii": "heal",
  "acanthoscelides": "heal",
  "acanthuridae": "heal",
  "acanthurus": "heal",
  "acanthus": "heal",
  "acarid": "heal",
  "acaridae": "heal",
  "acarina": "heal",
  "acarine": "heal",
  "acarpellous": "beautiful",
  "acarpelous": "beautiful",
  "acarus": "heal",
  "acaryote": "heal",
  "acatalectic": "story",
  "acaudal": "beautiful",
  "acaudate": "beautiful",
  "acaulescent": "beautiful",
  "accede": "story",
  "accelerando": "beautiful",
  "accelerator": "build",
  "accelerometer": "build",
  "accent": "story",
  "accented": "story",
  "accenting": "story",
  "accentor": "heal",
  "accentual": "beautiful",
  "accentuate": "story",
  "accentuation": "story",
  "accept": "smart",
  "acceptable": "beautiful",
  "acceptance": "smart",
  "acceptation": "story",
  "acceptive": "beautiful",
  "access": "build",
  "accessary": "beautiful",
  "accessible": "beautiful",
  "accession": "smart",
  "accessory": "build",
  "acciaccatura": "story",
  "accidence": "smart",
  "accidental": "story",
  "accipiter": "heal",
  "accipitridae": "heal",
  "accipitriformes": "heal",
  "acclaim": "story",
  "acclamation": "story",
  "acclimation": "smart",
  "acclimatisation": "smart",
  "acclimatization": "smart",
  "accolade": "story",
  "accommodate": "taste",
  "accommodating": "taste",
  "accommodation": "story",
  "accommodative": "beautiful",
  "accompanied": "build",
  "accompaniment": "story",
  "accompany": "build",
  "accomplish": "build",
  "accomplishment": "smart",
  "accord": "story",
  "accordance": "story",
  "accordant": "beautiful",
  "accordion": "build",
  "accost": "story",
  "accouchement": "smart",
  "account": "story",
  "accounting": "sell",
  "accouter": "sell",
  "accouterment": "build",
  "accoutre": "sell",
  "accoutrement": "build",
  "accredit": "sell",
  "accretion": "smart",
  "accrue": "sell",
  "acculturation": "smart",
  "accumulate": "sell",
  "accumulation": "smart",
  "accumulator": "build",
  "accurate": "beautiful",
  "accurse": "story",
  "accusal": "story",
  "accusation": "story",
  "accusative": "story",
  "accuse": "story",
  "accused": "story",
  "accustomed": "beautiful",
  "ace": "smart",
  "acebutolol": "build",
  "acellular": "beautiful",
  "acentric": "beautiful",
  "acer": "heal",
  "aceraceae": "heal",
  "acerola": "heal",
  "acervulus": "heal",
  "acetabulum": "heal",
  "acetaminophen": "build",
  "acetanilid": "build",
  "acetanilide": "build",
  "acetate": "build",
  "acetify": "sound",
  "acetophenetidin": "build",
  "acetphenetidin": "build",
  "acetum": "taste",
  "acetylation": "smart",
  "acetylene": "build",
  "ache": "sound",
  "achene": "heal",
  "acherontia": "heal",
  "acheta": "heal",
  "achieve": "sell",
  "achillea": "heal",
  "achimenes": "heal",
  "aching": "sound",
  "achira": "heal",
  "achlamydeous": "beautiful",
  "achoerodus": "heal",
  "achomawi": "story",
  "achondritic": "beautiful",
  "achras": "heal",
  "achromatic": "beautiful",
  "achromatin": "heal",
  "achromia": "beautiful",
  "achromycin": "build",
  "acid": "build",
  "acid-loving": "beautiful",
  "acid-wash": "build",
  "acidic": "beautiful",
  "acidification": "smart",
  "acidify": "sound",
  "acidity": "smart",
  "acidophil": "heal",
  "acidophile": "heal",
  "acidophilus": "heal",
  "acidulate": "sound",
  "acidulousness": "smart",
  "acinonyx": "heal",
  "acinos": "heal",
  "acinus": "heal",
  "acipenser": "heal",
  "acipenseridae": "heal",
  "ack-ack": "build",
  "ackee": "taste",
  "acknowledge": "story",
  "acknowledged": "story",
  "acknowledgement": "story",
  "acknowledgment": "story",
  "acnidosporidia": "heal",
  "acocanthera": "heal",
  "acokanthera": "heal",
  "aconite": "heal",
  "aconitum": "heal",
  "acoraceae": "heal",
  "acorn": "heal",
  "acorus": "heal",
  "acoustic": "sound",
  "acoustical": "sound",
  "acoustician": "sound",
  "acousticophobia": "sound",
  "acoustics": "sound",
  "acquaint": "story",
  "acquaintance": "smart",
  "acquiesce": "story",
  "acquiescence": "story",
  "acquire": "sell",
  "acquirement": "smart",
  "acquiring": "sell",
  "acquisition": "sell",
  "acquisitive": "beautiful",
  "acquit": "story",
  "acquittance": "story",
  "acrasiomycetes": "heal",
  "acre": "smart",
  "acre-foot": "smart",
  "acres": "sell",
  "acridid": "heal",
  "acrididae": "heal",
  "acridity": "smart",
  "acridotheres": "heal",
  "acrilan": "build",
  "acris": "heal",
  "acrobates": "heal",
  "acrocarp": "heal",
  "acrocarpous": "beautiful",
  "acrocarpus": "heal",
  "acrocephalus": "heal",
  "acroclinium": "heal",
  "acrocomia": "heal",
  "acrodont": "heal",
  "acrogen": "heal",
  "acromion": "heal",
  "acronym": "story",
  "acropetal": "beautiful",
  "acrophony": "story",
  "acropolis": "build",
  "acropora": "heal",
  "acroscopic": "beautiful",
  "acrosome": "heal",
  "acrostic": "story",
  "acrostichum": "heal",
  "acrylic": "beautiful",
  "act": "story",
  "actable": "beautiful",
  "actaea": "heal",
  "acth": "heal",
  "actias": "heal",
  "actifed": "build",
  "actinal": "beautiful",
  "actinaria": "heal",
  "acting": "sell",
  "actinia": "heal",
  "actinian": "heal",
  "actiniaria": "heal",
  "actiniarian": "heal",
  "actinidia": "heal",
  "actinidiaceae": "heal",
  "actiniopteris": "heal",
  "actinoid": "beautiful",
  "actinomeris": "heal",
  "actinometer": "build",
  "actinomorphic": "beautiful",
  "actinomorphous": "beautiful",
  "actinomyces": "heal",
  "actinomycetaceae": "heal",
  "actinomycetales": "heal",
  "actinomycete": "heal",
  "actinomycin": "build",
  "actinomyxidia": "heal",
  "actinomyxidian": "heal",
  "actinopod": "heal",
  "actinopoda": "heal",
  "actinozoa": "heal",
  "actinozoan": "heal",
  "action": "smart",
  "actitis": "heal",
  "activase": "build",
  "activate": "build",
  "activating": "build",
  "activation": "smart",
  "active": "beautiful",
  "activewear": "build",
  "activism": "smart",
  "activist": "beautiful",
  "activity": "smart",
  "acts": "story",
  "actual": "beautiful",
  "actualise": "build",
  "actualize": "build",
  "actuate": "build",
  "actuator": "smart",
  "acuity": "smart",
  "acular": "build",
  "aculea": "heal",
  "aculeus": "heal",
  "acumen": "heal",
  "acuminate": "beautiful",
  "acute": "heal",
  "acuteness": "smart",
  "acyclic": "beautiful",
  "acyclovir": "build",
  "acylation": "smart",
  "ad-lib": "story",
  "adage": "story",
  "adagio": "beautiful",
  "adalia": "heal",
  "adam": "build",
  "adam-and-eve": "heal",
  "adamant": "beautiful",
  "adamantine": "beautiful",
  "adansonia": "heal",
  "adapid": "heal",
  "adapin": "build",
  "adaptable": "beautiful",
  "adaptation": "story",
  "adaptative": "beautiful",
  "adapter": "build",
  "adaption": "smart",
  "adaptive": "beautiful",
  "adaptor": "build",
  "adaxial": "beautiful",
  "add": "story",
  "add-in": "build",
  "add-on": "build",
  "addax": "heal",
  "addend": "smart",
  "addendum": "story",
  "adder": "build",
  "addict": "taste",
  "addicted": "taste",
  "addictive": "beautiful",
  "addition": "build",
  "additive": "build",
  "addle": "smart",
  "address": "story",
  "addressed": "story",
  "addressograph": "build",
  "adduce": "story",
  "adducent": "beautiful",
  "adducing": "story",
  "adduct": "build",
  "adducting": "build",
  "adduction": "heal",
  "adductive": "beautiful",
  "adductor": "heal",
  "ade": "taste",
  "adelges": "heal",
  "adelgid": "heal",
  "adelgidae": "heal",
  "adelie": "heal",
  "adenanthera": "heal",
  "adenium": "heal",
  "adenohypophysis": "heal",
  "adenoid": "heal",
  "adenoidal": "beautiful",
  "adenota": "heal",
  "adenovirus": "heal",
  "adept": "beautiful",
  "adeptness": "smart",
  "adequate": "beautiful",
  "adh": "heal",
  "adhere": "build",
  "adherent": "beautiful",
  "adhesion": "heal",
  "adhesive": "beautiful",
  "adiabatic": "beautiful",
  "adiantaceae": "heal",
  "adiantum": "heal",
  "adieu": "story",
  "adios": "story",
  "adit": "build",
  "adjective": "story",
  "adjoin": "build",
  "adjourn": "sell",
  "adjudge": "story",
  "adjudicate": "sell",
  "adjunct": "story",
  "adjuration": "story",
  "adjure": "story",
  "adjustment": "smart",
  "adjutant": "heal",
  "adjuvant": "build",
  "adlumia": "heal",
  "admeasure": "sell",
  "administer": "sell",
  "administrate": "sell",
  "admiral": "heal",
  "admire": "sound",
  "admissible": "beautiful",
  "admission": "story",
  "admit": "story",
  "admixture": "build",
  "admonish": "story",
  "admonishment": "story",
  "admonition": "story",
  "adnate": "beautiful",
  "adnexa": "heal",
  "adnoun": "story",
  "adobe": "build",
  "adobo": "taste",
  "adolescent": "beautiful",
  "adonic": "story",
  "adonis": "heal",
  "adopt": "sell",
  "adoptable": "beautiful",
  "adopted": "sell",
  "adoptive": "beautiful",
  "adorn": "build",
  "adorned": "build",
  "adornment": "build",
  "adp": "smart",
  "adps": "build",
  "adrenal": "heal",
  "adrenalin": "heal",
  "adrenaline": "heal",
  "adrenergic": "build",
  "adrenocorticotrophin": "heal",
  "adrenocorticotropin": "heal",
  "adrian": "heal",
  "adroit": "beautiful",
  "adroitness": "smart",
  "adscript": "beautiful",
  "adsorb": "build",
  "adsorbable": "beautiful",
  "adsorbate": "beautiful",
  "adsorbent": "beautiful",
  "adsorption": "smart",
  "adsorptive": "beautiful",
  "adulate": "story",
  "adulation": "story",
  "adult": "heal",
  "adulterant": "beautiful",
  "adulterate": "beautiful",
  "adulterating": "beautiful",
  "adumbrate": "story",
  "adumbration": "smart",
  "advance": "story",
  "advancement": "story",
  "advancer": "beautiful",
  "advantage": "smart",
  "advantageous": "beautiful",
  "advection": "smart",
  "adventism": "smart",
  "adventitia": "heal",
  "adventure": "sell",
  "adventuresome": "beautiful",
  "adventurous": "beautiful",
  "adverb": "story",
  "adverbial": "story",
  "advert": "story",
  "advertence": "smart",
  "advertency": "smart",
  "advertise": "story",
  "advertisement": "sell",
  "advertising": "sell",
  "advertize": "story",
  "advertizement": "story",
  "advertizing": "story",
  "advertorial": "story",
  "advice": "story",
  "advil": "build",
  "advisable": "beautiful",
  "advise": "story",
  "advised": "story",
  "advisement": "smart",
  "advisory": "story",
  "advocate": "story",
  "adynamic": "beautiful",
  "adz": "build",
  "adze": "build",
  "aeciospore": "heal",
  "aecium": "heal",
  "aedes": "heal",
  "aegiceras": "heal",
  "aegilops": "heal",
  "aegina": "heal",
  "aegis": "build",
  "aegypiidae": "heal",
  "aegypius": "heal",
  "aegyptopithecus": "heal",
  "aeneid": "story",
  "aeolic": "story",
  "aeonian": "beautiful",
  "aeonium": "heal",
  "aepyceros": "heal",
  "aepyornidae": "heal",
  "aepyorniformes": "heal",
  "aepyornis": "heal",
  "aerate": "sound",
  "aeration": "smart",
  "aerator": "build",
  "aerial": "build",
  "aerides": "heal",
  "aerobacter": "heal",
  "aerobe": "heal",
  "aerobic": "beautiful",
  "aerobiosis": "sound",
  "aerodrome": "build",
  "aerodynamic": "beautiful",
  "aerodynamics": "smart",
  "aerofoil": "build",
  "aerogenerator": "build",
  "aerogram": "story",
  "aerogramme": "story",
  "aerology": "smart",
  "aeromechanics": "smart",
  "aeromedicine": "smart",
  "aeronautics": "smart",
  "aerophilic": "beautiful",
  "aerophilous": "beautiful",
  "aerophyte": "heal",
  "aeroplane": "build",
  "aerosol": "sound",
  "aerosolise": "build",
  "aerosolize": "build",
  "aertex": "build",
  "aery": "beautiful",
  "aeschynanthus": "heal",
  "aesculus": "heal",
  "aesthesia": "smart",
  "aesthesis": "smart",
  "aesthetic": "beautiful",
  "aesthetical": "beautiful",
  "aesthetics": "beautiful",
  "aestivate": "heal",
  "aether": "story",
  "aethionema": "heal",
  "aethusa": "heal",
  "aetiology": "smart",
  "aetobatus": "heal",
  "affair": "smart",
  "affairs": "smart",
  "affect": "heal",
  "affected": "heal",
  "affenpinscher": "heal",
  "afferent": "heal",
  "affiance": "story",
  "affidavit": "story",
  "affiliate": "sell",
  "affine": "beautiful",
  "affinity": "sound",
  "affirm": "smart",
  "affirmation": "story",
  "affirmative": "story",
  "affirmatory": "beautiful",
  "affirmed": "heal",
  "affix": "story",
  "affixation": "smart",
  "affixed": "build",
  "afflatus": "smart",
  "affluent": "beautiful",
  "afford": "taste",
  "afforest": "build",
  "affranchise": "sell",
  "affray": "story",
  "affricate": "story",
  "affrication": "story",
  "affricative": "story",
  "affront": "story",
  "afghan": "build",
  "afghani": "smart",
  "aflaxen": "build",
  "afloat": "beautiful",
  "afraid": "beautiful",
  "aframomum": "heal",
  "afrasian": "story",
  "african-american": "beautiful",
  "africander": "heal",
  "afrikaans": "story",
  "afrl": "build",
  "afro": "heal",
  "afro-american": "beautiful",
  "afro-asiatic": "story",
  "afro-wig": "build",
  "afroasiatic": "story",
  "afrocarpus": "heal",
  "afropavo": "heal",
  "aft": "beautiful",
  "after-shave": "build",
  "afterbirth": "heal",
  "afterburner": "build",
  "afterdeck": "build",
  "aftereffect": "sound",
  "afterglow": "sound",
  "afterimage": "smart",
  "aftermath": "sound",
  "afternoon": "story",
  "afterpiece": "story",
  "afters": "taste",
  "aftersensation": "smart",
  "aftershaft": "heal",
  "aftertaste": "smart",
  "afterthought": "smart",
  "afterworld": "smart",
  "aga": "story",
  "agal": "build",
  "agalinis": "heal",
  "agama": "heal",
  "agamete": "heal",
  "agamid": "heal",
  "agamidae": "heal",
  "agammaglobulinemia": "heal",
  "agamogenesis": "smart",
  "agapanthus": "heal",
  "agape": "beautiful",
  "agapornis": "heal",
  "agaric": "heal",
  "agaricaceae": "heal",
  "agaricales": "heal",
  "agaricus": "heal",
  "agastache": "heal",
  "agateware": "build",
  "agathis": "heal",
  "agavaceae": "heal",
  "agave": "heal",
  "agdestis": "heal",
  "ageing": "smart",
  "agelaius": "heal",
  "agenda": "smart",
  "agendum": "story",
  "agenesia": "smart",
  "agenesis": "smart",
  "ageratina": "heal",
  "ageratum": "heal",
  "aggeus": "story",
  "agglomerate": "build",
  "agglomerator": "build",
  "agglutinate": "build",
  "agglutination": "smart",
  "aggrade": "build",
  "aggrandise": "story",
  "aggrandize": "story",
  "aggregate": "build",
  "aggressive": "beautiful",
  "aggrieve": "sell",
  "agha": "story",
  "aging": "smart",
  "agio": "sell",
  "agiotage": "sell",
  "agitate": "sell",
  "agitated": "sell",
  "agitprop": "story",
  "agkistrodon": "heal",
  "aglaomorpha": "heal",
  "aglaonema": "heal",
  "aglet": "build",
  "agnail": "heal",
  "agnate": "beautiful",
  "agnatha": "heal",
  "agnathan": "heal",
  "agnise": "smart",
  "agnize": "smart",
  "agnomen": "story",
  "agnostic": "beautiful",
  "agnostical": "beautiful",
  "agnosticism": "smart",
  "agonidae": "heal",
  "agonist": "heal",
  "agonistic": "beautiful",
  "agonus": "heal",
  "agora": "smart",
  "agouti": "heal",
  "agrapha": "story",
  "agree": "story",
  "agreeable": "beautiful",
  "agreement": "sell",
  "agricultural": "beautiful",
  "agrimonia": "heal",
  "agrimony": "heal",
  "agriocharis": "heal",
  "agrobacterium": "heal",
  "agrobiology": "smart",
  "agrology": "smart",
  "agronomy": "smart",
  "agropyron": "heal",
  "agrostemma": "heal",
  "agrostis": "heal",
  "aground": "beautiful",
  "agua": "heal",
  "aguacate": "taste",
  "ague": "story",
  "agueweed": "heal",
  "ahem": "story",
  "ahimsa": "story",
  "ahpcrc": "build",
  "ahuehuete": "heal",
  "aid": "sell",
  "aide-memoire": "story",
  "aided": "sell",
  "aides": "sell",
  "aids": "sell",
  "aiglet": "build",
  "aigret": "build",
  "aigrette": "build",
  "aiguilette": "build",
  "ail": "taste",
  "ailanthus": "heal",
  "aileron": "build",
  "ailuropoda": "heal",
  "ailuropodidae": "heal",
  "ailurus": "heal",
  "aim": "smart",
  "aioli": "taste",
  "air": "sound",
  "air-condition": "sell",
  "air-cool": "sell",
  "air-drop": "build",
  "air-intake": "build",
  "air-sleeve": "story",
  "air-to-air": "beautiful",
  "air-to-ground": "beautiful",
  "air-to-surface": "beautiful",
  "airbrake": "build",
  "airbrush": "build",
  "airbus": "build",
  "aircraft": "build",
  "airdock": "build",
  "airdrome": "build",
  "airedale": "heal",
  "airfare": "sell",
  "airfield": "build",
  "airfoil": "build",
  "airframe": "build",
  "airgun": "build",
  "airing": "story",
  "airlift": "build",
  "airline": "build",
  "airliner": "build",
  "airlock": "build",
  "airmail": "story",
  "airmailer": "build",
  "airmanship": "smart",
  "airplane": "build",
  "airport": "build",
  "airpost": "story",
  "airscrew": "build",
  "airship": "build",
  "airstream": "sound",
  "airstrip": "build",
  "airwave": "story",
  "airway": "build",
  "airworthy": "beautiful",
  "aisle": "build",
  "aitchbone": "taste",
  "aix": "heal",
  "aizoaceae": "heal",
  "ajaia": "heal",
  "ajuga": "heal",
  "akan": "story",
  "akaryocyte": "heal",
  "akaryote": "heal",
  "akee": "heal",
  "akeridae": "heal",
  "akha": "story",
  "akinesia": "sound",
  "akinesis": "sound",
  "akkadian": "story",
  "aku": "story",
  "akvavit": "taste",
  "akwa'ala": "story",
  "al-qur'an": "story",
  "ala": "heal",
  "alabama": "story",
  "alar": "beautiful",
  "alarm": "build",
  "alarming": "story",
  "alarmism": "story",
  "alarum": "story",
  "alauda": "heal",
  "alaudidae": "heal",
  "alb": "build",
  "albacore": "taste",
  "albanian": "story",
  "albatrellus": "heal",
  "albatross": "smart",
  "albigensianism": "smart",
  "albinism": "beautiful",
  "albizia": "heal",
  "albizzia": "heal",
  "albuca": "heal",
  "albuginaceae": "heal",
  "albuginea": "heal",
  "albugo": "heal",
  "albula": "heal",
  "albulidae": "heal",
  "album": "sound",
  "albumen": "taste",
  "albuterol": "build",
  "alca": "heal",
  "alcaic": "story",
  "alcazar": "build",
  "alcea": "heal",
  "alcedinidae": "heal",
  "alcedo": "heal",
  "alcelaphus": "heal",
  "alces": "heal",
  "alchemy": "smart",
  "alcidae": "heal",
  "alcohol": "taste",
  "alcoholic": "beautiful",
  "alcoholise": "taste",
  "alcoholize": "taste",
  "alcove": "build",
  "alcyonacea": "heal",
  "alcyonaria": "heal",
  "alder": "heal",
  "alderfly": "heal",
  "aldomet": "build",
  "aldrovanda": "heal",
  "ale": "taste",
  "alecost": "heal",
  "alectis": "heal",
  "alectoria": "heal",
  "alectoris": "heal",
  "alectura": "heal",
  "alehoof": "heal",
  "alehouse": "build",
  "alembic": "build",
  "alendronate": "build",
  "aleph": "story",
  "aleph-nought": "smart",
  "aleph-null": "smart",
  "aleph-zero": "smart",
  "alepisaurus": "heal",
  "alert": "story",
  "alerting": "story",
  "alertness": "smart",
  "aletris": "heal",
  "aleurites": "heal",
  "aleut": "story",
  "aleve": "build",
  "alewife": "taste",
  "alexander": "heal",
  "alexanders": "heal",
  "alexandrine": "story",
  "aleyrodes": "heal",
  "aleyrodidae": "heal",
  "alfalfa": "heal",
  "alfilaria": "heal",
  "alfileria": "heal",
  "alga": "heal",
  "algae": "heal",
  "algarobilla": "heal",
  "algarroba": "heal",
  "algarrobilla": "heal",
  "algebra": "smart",
  "algeripithecus": "heal",
  "algol": "story",
  "algology": "smart",
  "algometer": "build",
  "algonkian": "story",
  "algonkin": "story",
  "algonquian": "story",
  "algonquin": "story",
  "algorism": "story",
  "algorithm": "smart",
  "algorithmic": "smart",
  "alhambra": "build",
  "alias": "story",
  "alibi": "story",
  "alidad": "build",
  "alidade": "build",
  "alien": "sell",
  "alienable": "beautiful",
  "alienate": "sell",
  "alienism": "smart",
  "alight": "beautiful",
  "align": "smart",
  "aligned": "smart",
  "alike": "beautiful",
  "aliment": "taste",
  "alimentation": "taste",
  "alimony": "sell",
  "aliquant": "smart",
  "aliquot": "smart",
  "alisma": "heal",
  "alismales": "heal",
  "alismataceae": "heal",
  "alismatidae": "heal",
  "alive": "beautiful",
  "aliyah": "story",
  "alizarin": "beautiful",
  "alizarine": "beautiful",
  "alkalic": "beautiful",
  "alkaline": "beautiful",
  "alkaline-loving": "beautiful",
  "alkanet": "heal",
  "alkeran": "build",
  "alkyne": "build",
  "all": "beautiful",
  "all-rounder": "beautiful",
  "allamanda": "heal",
  "allantois": "heal",
  "allay": "taste",
  "allegation": "story",
  "allege": "story",
  "allegement": "story",
  "allegorise": "smart",
  "allegorize": "smart",
  "allegory": "story",
  "allegretto": "story",
  "allegro": "beautiful",
  "allele": "heal",
  "allelomorph": "heal",
  "allemande": "taste",
  "allergic": "beautiful",
  "allergist": "heal",
  "allergology": "smart",
  "alleviant": "build",
  "alleviate": "heal",
  "alleviator": "build",
  "alley": "build",
  "alleyway": "build",
  "allgood": "heal",
  "alliaceae": "heal",
  "alliaceous": "beautiful",
  "alliance": "story",
  "alliaria": "heal",
  "allice": "heal",
  "allied": "sell",
  "alligator": "heal",
  "alligatorfish": "heal",
  "alligatoridae": "heal",
  "allionia": "heal",
  "allioniaceae": "heal",
  "allis": "heal",
  "alliterate": "build",
  "alliteration": "story",
  "allium": "heal",
  "allmouth": "heal",
  "allocate": "sell",
  "allocation": "sell",
  "allochthonous": "beautiful",
  "allocution": "story",
  "allogeneic": "beautiful",
  "allograft": "heal",
  "allograph": "story",
  "allometry": "smart",
  "allomorph": "story",
  "allopatric": "beautiful",
  "allophone": "story",
  "allopurinol": "build",
  "allosaur": "heal",
  "allosaurus": "heal",
  "allot": "sell",
  "allotment": "sell",
  "allotropism": "sound",
  "allotropy": "sound",
  "allow": "sell",
  "allowable": "beautiful",
  "allowance": "sell",
  "allspice": "heal",
  "allude": "story",
  "allure": "story",
  "allurement": "smart",
  "allusion": "story",
  "alluviation": "sound",
  "alluvion": "smart",
  "ally": "sell",
  "almanac": "story",
  "almighty": "beautiful",
  "almond": "heal",
  "alnus": "heal",
  "alocasia": "heal",
  "aloe": "heal",
  "aloeaceae": "heal",
  "aloes": "build",
  "aloha": "story",
  "alopecurus": "heal",
  "alopex": "heal",
  "alopiidae": "heal",
  "alopius": "heal",
  "alosa": "heal",
  "alouatta": "heal",
  "alpaca": "build",
  "alpenstock": "build",
  "alpha": "story",
  "alpha-adrenoceptor": "heal",
  "alpha-blocker": "build",
  "alpha-interferon": "build",
  "alphabet": "story",
  "alphabetic": "beautiful",
  "alphabetical": "beautiful",
  "alphabetize": "sell",
  "alphanumerics": "story",
  "alphavirus": "heal",
  "alpine": "beautiful",
  "alpinia": "heal",
  "alprazolam": "build",
  "alsatian": "heal",
  "alsobia": "heal",
  "alsophila": "heal",
  "alstonia": "heal",
  "alstroemeria": "heal",
  "alstroemeriaceae": "heal",
  "altace": "build",
  "altaic": "story",
  "altar": "build",
  "altarpiece": "build",
  "altazimuth": "build",
  "alter": "build",
  "alterable": "beautiful",
  "altercate": "story",
  "altercation": "story",
  "altered": "build",
  "altering": "build",
  "alternanthera": "heal",
  "alternate": "sell",
  "alternating": "sell",
  "alternative": "smart",
  "alternator": "build",
  "althaea": "heal",
  "althea": "heal",
  "altimeter": "build",
  "alto": "sound",
  "altricial": "beautiful",
  "altruistic": "beautiful",
  "alula": "heal",
  "alum": "build",
  "alumbloom": "heal",
  "aluminise": "build",
  "aluminize": "build",
  "alumroot": "heal",
  "alupent": "build",
  "alveolar": "story",
  "alveolus": "heal",
  "alyssum": "heal",
  "alytes": "heal",
  "amadavat": "heal",
  "amalgamate": "build",
  "amanita": "heal",
  "amaranth": "heal",
  "amaranthaceae": "heal",
  "amaranthine": "beautiful",
  "amaranthus": "heal",
  "amarelle": "heal",
  "amaretto": "taste",
  "amaryllidaceae": "heal",
  "amaryllis": "heal",
  "amass": "sell",
  "amateur": "beautiful",
  "amateurishness": "smart",
  "amateurism": "smart",
  "amati": "build",
  "amatungulu": "heal",
  "amauropelta": "heal",
  "amaurosis": "heal",
  "amaze": "smart",
  "amazon": "heal",
  "amazona": "heal",
  "ambage": "story",
  "ambages": "story",
  "amber": "beautiful",
  "amberbell": "heal",
  "amberboa": "heal",
  "amberfish": "heal",
  "amberjack": "heal",
  "ambidextrous": "beautiful",
  "ambiguity": "story",
  "ambiguous": "beautiful",
  "ambitionless": "beautiful",
  "ambitious": "beautiful",
  "ambiversive": "beautiful",
  "ambloplites": "heal",
  "amblyopia": "heal",
  "amblyopic": "heal",
  "amblyrhynchus": "heal",
  "ambo": "build",
  "amboyna": "heal",
  "ambrosia": "heal",
  "ambrosiaceae": "heal",
  "ambrosian": "beautiful",
  "ambulacrum": "heal",
  "ambulance": "heal",
  "ambulatory": "build",
  "ambystoma": "heal",
  "ambystomatidae": "heal",
  "ambystomid": "heal",
  "ameba": "heal",
  "ameiuridae": "heal",
  "ameiurus": "heal",
  "amelanchier": "heal",
  "ameloblast": "heal",
  "amelogenesis": "smart",
  "amend": "story",
  "amended": "story",
  "amendment": "story",
  "amends": "sell",
  "amenities": "sell",
  "ament": "heal",
  "amentia": "smart",
  "amentiferae": "heal",
  "amerce": "sell",
  "amercement": "sell",
  "american": "story",
  "americana": "build",
  "americanisation": "smart",
  "americanism": "story",
  "americanization": "smart",
  "amerind": "story",
  "ametabolic": "beautiful",
  "ametabolous": "beautiful",
  "amethopterin": "build",
  "amethyst": "beautiful",
  "ametropic": "beautiful",
  "amex": "build",
  "amharic": "story",
  "amia": "heal",
  "amianthum": "heal",
  "amicable": "beautiful",
  "amidopyrine": "build",
  "amiidae": "heal",
  "aminophylline": "build",
  "aminopyrine": "build",
  "amiodarone": "build",
  "amitosis": "smart",
  "amitriptyline": "build",
  "ammeter": "build",
  "ammo": "build",
  "ammobium": "heal",
  "ammodytes": "heal",
  "ammodytidae": "heal",
  "ammonification": "smart",
  "ammotragus": "heal",
  "ammunition": "build",
  "amnesia": "smart",
  "amnesiac": "beautiful",
  "amnesic": "beautiful",
  "amnesty": "story",
  "amnio": "heal",
  "amniocentesis": "heal",
  "amnion": "heal",
  "amnios": "heal",
  "amniota": "heal",
  "amniote": "heal",
  "amobarbital": "build",
  "amoeba": "heal",
  "amoebida": "heal",
  "amoebina": "heal",
  "amontillado": "taste",
  "amoralism": "smart",
  "amorpha": "heal",
  "amorphophallus": "heal",
  "amortise": "sell",
  "amortize": "sell",
  "amos": "story",
  "amount": "sell",
  "amoxicillin": "build",
  "amoxil": "build",
  "amoy": "story",
  "amp": "smart",
  "amperage": "sound",
  "ampere": "smart",
  "ampere-hour": "smart",
  "ampere-minute": "smart",
  "ampere-second": "smart",
  "ampere-turn": "smart",
  "ampersand": "story",
  "amphetamine": "build",
  "amphibia": "heal",
  "amphibian": "build",
  "amphibious": "beautiful",
  "amphibolips": "heal",
  "amphibology": "story",
  "amphiboly": "story",
  "amphibrach": "story",
  "amphicarpa": "heal",
  "amphicarpaea": "heal",
  "amphidiploid": "heal",
  "amphigory": "story",
  "amphimixis": "smart",
  "amphineura": "heal",
  "amphioxidae": "heal",
  "amphioxus": "heal",
  "amphipod": "heal",
  "amphipoda": "heal",
  "amphiprion": "heal",
  "amphiprotic": "beautiful",
  "amphisbaena": "heal",
  "amphisbaenia": "heal",
  "amphisbaenidae": "heal",
  "amphitheater": "build",
  "amphitheatre": "build",
  "amphitropous": "beautiful",
  "amphiuma": "heal",
  "amphiumidae": "heal",
  "amphora": "build",
  "amphoteric": "beautiful",
  "amphotericin": "build",
  "ampicillin": "build",
  "ample": "beautiful",
  "amplifier": "sound",
  "amplify": "story",
  "ampoule": "build",
  "ampul": "build",
  "ampule": "build",
  "ampulla": "heal",
  "amputate": "build",
  "amrinone": "build",
  "amsinckia": "heal",
  "amsonia": "heal",
  "amulet": "build",
  "amusd": "story",
  "amuse": "sell",
  "amygdala": "heal",
  "amygdalaceae": "heal",
  "amygdaloid": "beautiful",
  "amygdalus": "heal",
  "amyloid": "beautiful",
  "amylolysis": "smart",
  "amytal": "build",
  "anabantidae": "heal",
  "anabaptism": "smart",
  "anabas": "heal",
  "anabatic": "beautiful",
  "anabolic": "beautiful",
  "anabolism": "smart",
  "anabrus": "heal",
  "anacanthini": "heal",
  "anacardiaceae": "heal",
  "anacardium": "heal",
  "anachronism": "build",
  "anaclinal": "beautiful",
  "anacoluthia": "story",
  "anacoluthon": "story",
  "anaconda": "heal",
  "anacyclus": "heal",
  "anadenanthera": "heal",
  "anadiplosis": "story",
  "anadromous": "beautiful",
  "anaemic": "beautiful",
  "anaerobe": "heal",
  "anaerobic": "beautiful",
  "anaerobiotic": "beautiful",
  "anaesthetic": "build",
  "anaesthetise": "heal",
  "anaesthetize": "heal",
  "anagallis": "heal",
  "anagasta": "heal",
  "anaglyph": "build",
  "anaglyphy": "smart",
  "anagoge": "smart",
  "anagram": "story",
  "anagrammatise": "smart",
  "anagrammatize": "smart",
  "anagrams": "story",
  "anagyris": "heal",
  "anal": "beautiful",
  "analecta": "story",
  "analects": "story",
  "analeptic": "build",
  "analgesic": "build",
  "analog": "beautiful",
  "analogise": "smart",
  "analogize": "smart",
  "analogous": "beautiful",
  "analogue": "beautiful",
  "analogy": "smart",
  "analphabetic": "beautiful",
  "analphabetism": "smart",
  "analyse": "smart",
  "analyser": "build",
  "analysis": "smart",
  "analytic": "beautiful",
  "analytical": "beautiful",
  "analyze": "smart",
  "analyzed": "smart",
  "analyzer": "build",
  "anamnesis": "story",
  "anamorphism": "smart",
  "anamorphosis": "smart",
  "ananas": "heal",
  "anapaest": "story",
  "anapest": "story",
  "anaphalis": "heal",
  "anaphase": "smart",
  "anaphor": "story",
  "anaphora": "story",
  "anaphrodisiac": "beautiful",
  "anaprox": "build",
  "anapsid": "heal",
  "anapsida": "heal",
  "anarchism": "smart",
  "anarhichadidae": "heal",
  "anarhichas": "heal",
  "anas": "heal",
  "anasa": "heal",
  "anaspid": "heal",
  "anaspida": "heal",
  "anastalsis": "smart",
  "anastatica": "heal",
  "anastigmat": "build",
  "anastigmatic": "beautiful",
  "anastomose": "build",
  "anastomosis": "heal",
  "anastomus": "heal",
  "anastrophe": "story",
  "anathema": "story",
  "anathematise": "story",
  "anathematize": "story",
  "anathemise": "story",
  "anathemize": "story",
  "anatidae": "heal",
  "anatolian": "story",
  "anatomic": "heal",
  "anatomical": "heal",
  "anatomise": "build",
  "anatomize": "build",
  "anatomy": "smart",
  "anatotitan": "heal",
  "anatropous": "beautiful",
  "ancestral": "beautiful",
  "anchor": "build",
  "anchorage": "sell",
  "anchovy": "taste",
  "anchusa": "heal",
  "ancient": "beautiful",
  "ancistrodon": "heal",
  "ancylidae": "heal",
  "ancylose": "heal",
  "ancylostomatidae": "heal",
  "ancylus": "heal",
  "andante": "story",
  "andelmin": "heal",
  "andira": "heal",
  "andiron": "build",
  "andreaea": "heal",
  "andreaeales": "heal",
  "andrena": "heal",
  "andrenid": "heal",
  "andrenidae": "heal",
  "andricus": "heal",
  "androecium": "heal",
  "androgenesis": "smart",
  "androgeny": "smart",
  "androgynous": "beautiful",
  "android": "build",
  "andromeda": "heal",
  "andropogon": "heal",
  "andryala": "heal",
  "anecdotal": "beautiful",
  "anecdote": "story",
  "aneides": "heal",
  "anele": "heal",
  "anemia": "heal",
  "anemic": "beautiful",
  "anemometer": "build",
  "anemone": "heal",
  "anemonella": "heal",
  "anemophilous": "beautiful",
  "anemopsis": "heal",
  "aneroid": "build",
  "anesthesiology": "smart",
  "anesthetic": "build",
  "anesthetise": "heal",
  "anesthetize": "heal",
  "anesthyl": "build",
  "anestrous": "beautiful",
  "anethum": "heal",
  "angas": "story",
  "angelfish": "heal",
  "angelic": "beautiful",
  "angelica": "heal",
  "angelical": "beautiful",
  "angelim": "heal",
  "angelique": "heal",
  "angelology": "smart",
  "angelus": "story",
  "angiocardiogram": "build",
  "angiocarp": "heal",
  "angiogenesis": "smart",
  "angiogram": "build",
  "angiology": "smart",
  "angiopteris": "heal",
  "angioscope": "build",
  "angiosperm": "heal",
  "angiospermae": "heal",
  "angiotensin": "build",
  "angiotonin": "build",
  "angle": "smart",
  "angledozer": "build",
  "angler": "heal",
  "anglerfish": "heal",
  "anglewing": "heal",
  "angleworm": "heal",
  "anglian": "story",
  "anglicanism": "smart",
  "anglicisation": "smart",
  "anglicism": "story",
  "anglicization": "smart",
  "angling": "build",
  "anglo-catholicism": "smart",
  "anglo-french": "story",
  "anglo-norman": "story",
  "anglo-saxon": "story",
  "anglomania": "smart",
  "angora": "heal",
  "angostura": "heal",
  "angraecum": "heal",
  "angrecum": "heal",
  "angry": "beautiful",
  "angstrom": "smart",
  "anguidae": "heal",
  "anguilla": "heal",
  "anguillidae": "heal",
  "anguilliformes": "heal",
  "anguillula": "heal",
  "anguis": "heal",
  "angular": "smart",
  "angulate": "beautiful",
  "angus": "heal",
  "angwantibo": "heal",
  "anhima": "heal",
  "anhimidae": "heal",
  "anhinga": "heal",
  "anhingidae": "heal",
  "anhydrous": "beautiful",
  "ani": "heal",
  "anicteric": "beautiful",
  "anigozanthus": "heal",
  "anil": "heal",
  "anima": "smart",
  "animadversion": "story",
  "animadvert": "story",
  "animal": "beautiful",
  "animalcule": "heal",
  "animalculum": "heal",
  "animalia": "heal",
  "animalise": "build",
  "animalism": "smart",
  "animalization": "build",
  "animalize": "build",
  "animate": "heal",
  "animated": "heal",
  "animatism": "smart",
  "animatronics": "smart",
  "animism": "smart",
  "anise": "heal",
  "aniseed": "taste",
  "anisette": "taste",
  "anisogamete": "heal",
  "anisogamy": "smart",
  "anisoptera": "heal",
  "anisotremus": "heal",
  "anisotropic": "beautiful",
  "anjou": "taste",
  "ankle": "heal",
  "anklebone": "heal",
  "anklet": "build",
  "anklets": "build",
  "ankus": "build",
  "ankylosaur": "heal",
  "ankylosaurus": "heal",
  "ankylose": "heal",
  "anlage": "heal",
  "anna": "smart",
  "annals": "story",
  "annamese": "story",
  "annamite": "story",
  "annelid": "heal",
  "annelida": "heal",
  "annex": "build",
  "annexa": "heal",
  "annexe": "build",
  "anniellidae": "heal",
  "annon": "taste",
  "annona": "heal",
  "annonaceae": "heal",
  "annotate": "build",
  "annotating": "build",
  "annotation": "story",
  "announce": "story",
  "announcement": "story",
  "annoyance": "smart",
  "annoying": "beautiful",
  "annual": "heal",
  "annualry": "heal",
  "annuity": "sell",
  "annul": "sell",
  "annulet": "build",
  "annulus": "heal",
  "annunciate": "story",
  "annunciation": "story",
  "annunciator": "build",
  "annwfn": "smart",
  "annwn": "smart",
  "anoa": "heal",
  "anobiidae": "heal",
  "anode": "build",
  "anodonta": "heal",
  "anodyne": "build",
  "anoectochilus": "heal",
  "anogramma": "heal",
  "anoint": "smart",
  "anointing": "smart",
  "anole": "heal",
  "anolis": "heal",
  "anomala": "heal",
  "anomalopidae": "heal",
  "anomalops": "heal",
  "anomalopteryx": "heal",
  "anomia": "heal",
  "anomiidae": "heal",
  "anon.": "beautiful",
  "anonym": "story",
  "anonymous": "beautiful",
  "anopheles": "heal",
  "anopheline": "heal",
  "anoplura": "heal",
  "anorak": "build",
  "anorectic": "beautiful",
  "anorexic": "beautiful",
  "anorthic": "beautiful",
  "anosmic": "beautiful",
  "anostraca": "heal",
  "anova": "smart",
  "anovulant": "build",
  "anovulation": "smart",
  "ans": "heal",
  "ansaid": "build",
  "anser": "heal",
  "anseres": "heal",
  "anseriformes": "heal",
  "anserinae": "heal",
  "anserine": "beautiful",
  "answer": "story",
  "ant": "heal",
  "antabuse": "build",
  "antacid": "beautiful",
  "antagonise": "sell",
  "antagonist": "story",
  "antagonistic": "beautiful",
  "antagonize": "sell",
  "antarctic": "beautiful",
  "antbird": "heal",
  "ante": "sell",
  "anteater": "heal",
  "antecedent": "story",
  "antechamber": "build",
  "antediluvian": "beautiful",
  "antedon": "heal",
  "antedonidae": "heal",
  "antefix": "build",
  "antelope": "heal",
  "antemeridian": "beautiful",
  "antemortem": "beautiful",
  "antenatal": "beautiful",
  "antenna": "build",
  "antennaria": "heal",
  "antennariidae": "heal",
  "antepartum": "beautiful",
  "antepenult": "story",
  "antepenultima": "story",
  "antepenultimate": "story",
  "anterior": "heal",
  "anterograde": "beautiful",
  "anteroom": "build",
  "anthelminthic": "build",
  "anthelmintic": "build",
  "anthem": "story",
  "anthemis": "heal",
  "anther": "heal",
  "antheraea": "heal",
  "anthericum": "heal",
  "antheridiophore": "heal",
  "antheridium": "heal",
  "antheropeas": "heal",
  "antherozoid": "heal",
  "anthesis": "smart",
  "anthidium": "heal",
  "anthoceropsida": "heal",
  "anthoceros": "heal",
  "anthocerotaceae": "heal",
  "anthocerotales": "heal",
  "anthologise": "build",
  "anthologize": "build",
  "anthology": "story",
  "anthonomus": "heal",
  "anthophyta": "heal",
  "anthozoa": "heal",
  "anthozoan": "heal",
  "anthriscus": "heal",
  "anthropocentricity": "smart",
  "anthropocentrism": "smart",
  "anthropogenesis": "smart",
  "anthropogeny": "smart",
  "anthropoid": "heal",
  "anthropoidea": "heal",
  "anthropology": "smart",
  "anthropomorphise": "smart",
  "anthropomorphism": "smart",
  "anthropomorphize": "smart",
  "anthroposophy": "smart",
  "anthurium": "heal",
  "anthus": "heal",
  "anthyllis": "heal",
  "anti": "beautiful",
  "anti-catholicism": "smart",
  "anti-inflammatory": "build",
  "anti-intellectual": "beautiful",
  "anti-semite": "beautiful",
  "anti-semitism": "smart",
  "antiaircraft": "build",
  "antialiasing": "smart",
  "antiarrhythmic": "sound",
  "antibacterial": "build",
  "antibiotic": "build",
  "antic": "heal",
  "anticholinergic": "build",
  "anticholinesterase": "build",
  "anticipant": "beautiful",
  "anticipate": "smart",
  "anticipation": "smart",
  "anticlimactic": "beautiful",
  "anticlimax": "story",
  "anticlinal": "beautiful",
  "anticlockwise": "beautiful",
  "anticoagulant": "build",
  "anticonvulsant": "build",
  "antidepressant": "build",
  "antidiabetic": "build",
  "antidiarrheal": "build",
  "antidiuretic": "build",
  "antido": "story",
  "antidorcas": "heal",
  "antidote": "build",
  "antiemetic": "build",
  "antiepileptic": "build",
  "antiestablishmentarianism": "smart",
  "antiestablishmentism": "smart",
  "antiferromagnetism": "sound",
  "antiflatulent": "build",
  "antifungal": "build",
  "antigonia": "heal",
  "antigram": "story",
  "antihistamine": "build",
  "antihypertensive": "build",
  "antiknock": "beautiful",
  "antilocapra": "heal",
  "antilocapridae": "heal",
  "antilog": "story",
  "antilogarithm": "story",
  "antilope": "heal",
  "antimacassar": "build",
  "antimagnetic": "beautiful",
  "antimalarial": "build",
  "antimetabolite": "build",
  "antimicrobial": "build",
  "antimicrobic": "build",
  "antimycin": "build",
  "antimycotic": "build",
  "antineoplastic": "build",
  "antinomasia": "story",
  "antinomianism": "smart",
  "antinomy": "story",
  "antipasto": "taste",
  "antipathy": "smart",
  "antiperspirant": "build",
  "antiphon": "story",
  "antiphonal": "story",
  "antiphonary": "story",
  "antiphony": "story",
  "antiphrasis": "story",
  "antiprotozoal": "build",
  "antipruritic": "build",
  "antipsychotic": "build",
  "antipyretic": "build",
  "antique": "build",
  "antiquity": "build",
  "antiredeposition": "smart",
  "antirrhinum": "heal",
  "antisemitism": "smart",
  "antisepsis": "smart",
  "antiseptic": "build",
  "antisepticize": "heal",
  "antiserum": "heal",
  "antispasmodic": "build",
  "antistrophe": "story",
  "antisyphilitic": "build",
  "antithesis": "story",
  "antitrade": "sound",
  "antitrades": "sound",
  "antitussive": "build",
  "antitype": "smart",
  "antivert": "build",
  "antiviral": "build",
  "antler": "heal",
  "antlion": "heal",
  "antonym": "story",
  "antonymous": "beautiful",
  "antrorse": "beautiful",
  "antrozous": "heal",
  "antrum": "heal",
  "anura": "heal",
  "anuran": "heal",
  "anus": "heal",
  "anvil": "build",
  "anxiolytic": "build",
  "aorist": "story",
  "aorta": "heal",
  "aotus": "heal",
  "aoudad": "heal",
  "apache": "story",
  "apadana": "build",
  "apanage": "sell",
  "apar": "heal",
  "apartheid": "story",
  "apartment": "build",
  "apatosaur": "heal",
  "apatosaurus": "heal",
  "apatura": "heal",
  "apc": "build",
  "ape": "heal",
  "apercu": "story",
  "aperea": "heal",
  "aperient": "build",
  "aperiodic": "beautiful",
  "aperitif": "taste",
  "aperture": "build",
  "apetalous": "beautiful",
  "aphaeresis": "smart",
  "aphasic": "beautiful",
  "aphasmidia": "sound",
  "apheresis": "smart",
  "aphesis": "smart",
  "aphid": "heal",
  "aphididae": "heal",
  "aphidoidea": "heal",
  "aphis": "heal",
  "aphorise": "story",
  "aphorism": "story",
  "aphoristic": "beautiful",
  "aphorize": "story",
  "aphriza": "heal",
  "aphrodisiac": "build",
  "aphrodisiacal": "beautiful",
  "aphrophora": "heal",
  "aphyllanthaceae": "heal",
  "aphyllanthes": "heal",
  "aphyllophorales": "heal",
  "apiaceae": "heal",
  "apiary": "build",
  "apidae": "heal",
  "apios": "heal",
  "apis": "heal",
  "apishamore": "build",
  "apium": "heal",
  "aplacental": "beautiful",
  "aplacophora": "heal",
  "aplacophoran": "heal",
  "aplectrum": "heal",
  "aplodontia": "heal",
  "aplodontiidae": "heal",
  "aplysia": "heal",
  "aplysiidae": "heal",
  "apocalypse": "story",
  "apocalyptic": "beautiful",
  "apocarpous": "beautiful",
  "apocope": "story",
  "apocrine": "beautiful",
  "apocrypha": "story",
  "apocryphal": "beautiful",
  "apocynaceae": "heal",
  "apocynum": "heal",
  "apodeme": "heal",
  "apodemus": "heal",
  "apodidae": "heal",
  "apodiformes": "heal",
  "apogamy": "smart",
  "apogon": "heal",
  "apogonidae": "heal",
  "apoidea": "heal",
  "apolemia": "heal",
  "apologetic": "beautiful",
  "apologetics": "smart",
  "apologia": "story",
  "apologise": "story",
  "apologize": "story",
  "apologue": "story",
  "apology": "story",
  "apomict": "heal",
  "apomictic": "beautiful",
  "apomixis": "smart",
  "apomorphine": "build",
  "aponeurosis": "heal",
  "apophasis": "story",
  "apophatism": "smart",
  "apophthegm": "story",
  "apophysis": "heal",
  "apoptosis": "sound",
  "aporocactus": "heal",
  "aposiopesis": "story",
  "apostate": "beautiful",
  "apostatise": "story",
  "apostatize": "story",
  "apostrophe": "story",
  "apostrophise": "story",
  "apostrophize": "story",
  "apothecium": "heal",
  "apothegm": "story",
  "apothegmatic": "beautiful",
  "apotheose": "smart",
  "apotheosise": "smart",
  "apotheosize": "smart",
  "appaloosa": "heal",
  "appanage": "sell",
  "apparatus": "build",
  "apparel": "build",
  "apparition": "smart",
  "appeal": "story",
  "appealable": "beautiful",
  "appealing": "sell",
  "appear": "sound",
  "appearance": "smart",
  "appearing": "sound",
  "appease": "taste",
  "appellation": "story",
  "appellative": "story",
  "append": "build",
  "appendage": "heal",
  "appendaged": "beautiful",
  "appendicle": "build",
  "appendicularia": "heal",
  "appendix": "story",
  "appenzeller": "heal",
  "apperceive": "sound",
  "apperception": "smart",
  "appetiser": "taste",
  "appetising": "beautiful",
  "appetizer": "taste",
  "appetizing": "beautiful",
  "applaud": "story",
  "applause": "story",
  "apple": "taste",
  "applecart": "smart",
  "applejack": "taste",
  "applemint": "heal",
  "applesauce": "taste",
  "applet": "story",
  "applewood": "heal",
  "appliance": "build",
  "application": "story",
  "applicator": "build",
  "applied": "taste",
  "applier": "build",
  "applique": "build",
  "apply": "taste",
  "appoggiatura": "story",
  "appoint": "sell",
  "appointed": "sell",
  "appointive": "beautiful",
  "appointment": "build",
  "apportion": "sell",
  "apportioning": "sell",
  "apposable": "beautiful",
  "appose": "build",
  "apposition": "smart",
  "appraisal": "smart",
  "appraise": "smart",
  "appreciate": "smart",
  "appreciation": "smart",
  "apprehend": "smart",
  "apprehension": "smart",
  "apprentice": "smart",
  "apprisal": "story",
  "apprise": "story",
  "apprize": "story",
  "approach": "build",
  "approachable": "beautiful",
  "approaching": "sound",
  "approbate": "story",
  "approbation": "story",
  "appropriate": "smart",
  "appropriation": "sell",
  "approval": "story",
  "approve": "story",
  "approving": "story",
  "approximate": "smart",
  "approximation": "smart",
  "appurtenance": "build",
  "apresoline": "build",
  "apricot": "heal",
  "apron": "build",
  "apropos": "beautiful",
  "apse": "build",
  "apsis": "build",
  "aptenodytes": "heal",
  "apteral": "beautiful",
  "apterygidae": "heal",
  "apterygiformes": "heal",
  "apteryx": "heal",
  "aptitude": "smart",
  "apus": "heal",
  "aqua-lung": "build",
  "aqualung": "build",
  "aquaplane": "build",
  "aquarium": "build",
  "aquatic": "heal",
  "aquatics": "heal",
  "aquatint": "build",
  "aquavit": "taste",
  "aqueduct": "build",
  "aqueous": "beautiful",
  "aquifoliaceae": "heal",
  "aquila": "heal",
  "aquilege": "heal",
  "aquilegia": "heal",
  "ara": "heal",
  "arab": "heal",
  "arabesque": "beautiful",
  "arabian": "heal",
  "arabic": "story",
  "arabidopsis": "heal",
  "arabis": "heal",
  "araceae": "heal",
  "arachis": "heal",
  "arachnid": "heal",
  "arachnida": "heal",
  "arachnoid": "heal",
  "arak": "taste",
  "arales": "heal",
  "aralia": "heal",
  "araliaceae": "heal",
  "aramaic": "story",
  "arame": "heal",
  "aramus": "heal",
  "aranea": "heal",
  "araneae": "heal",
  "araneida": "heal",
  "araneus": "heal",
  "aranyaka": "story",
  "arapaho": "story",
  "arapahoe": "story",
  "arariba": "heal",
  "araroba": "build",
  "aras": "heal",
  "araucaria": "heal",
  "araucariaceae": "heal",
  "araujia": "heal",
  "arava": "build",
  "arawak": "story",
  "arawakan": "story",
  "arbalest": "build",
  "arbalist": "build",
  "arbitrable": "beautiful",
  "arbitrage": "sell",
  "arbitrary": "beautiful",
  "arbitrate": "story",
  "arbitration": "story",
  "arbor": "heal",
  "arboreal": "beautiful",
  "arboreous": "beautiful",
  "arboretum": "build",
  "arborvirus": "heal",
  "arborvitae": "heal",
  "arbour": "build",
  "arbovirus": "heal",
  "arbutus": "heal",
  "arc": "sound",
  "arc-boutant": "build",
  "arca": "heal",
  "arcade": "build",
  "arcadian": "beautiful",
  "arcadic": "story",
  "arcanum": "story",
  "arcdegree": "smart",
  "arcella": "heal",
  "arcellidae": "heal",
  "arceuthobium": "heal",
  "arch": "build",
  "archaebacteria": "heal",
  "archaebacterium": "heal",
  "archaeobacteria": "heal",
  "archaeology": "smart",
  "archaeopteryx": "heal",
  "archaeornis": "heal",
  "archaeornithes": "heal",
  "archaeozoic": "beautiful",
  "archaicism": "story",
  "archaism": "story",
  "archangel": "heal",
  "archean": "beautiful",
  "arched": "beautiful",
  "archegonium": "heal",
  "archenteron": "heal",
  "archeobacteria": "heal",
  "archeology": "smart",
  "archeopteryx": "heal",
  "archeozoic": "beautiful",
  "archerfish": "heal",
  "archespore": "heal",
  "archesporium": "heal",
  "archetype": "smart",
  "archiannelid": "heal",
  "archiannelida": "heal",
  "archidiskidon": "heal",
  "archil": "heal",
  "archilochus": "heal",
  "archine": "smart",
  "archipallium": "heal",
  "architectonics": "smart",
  "architecture": "build",
  "architeuthis": "heal",
  "architrave": "build",
  "archive": "build",
  "archives": "story",
  "archosargus": "heal",
  "archosaur": "heal",
  "archosauria": "heal",
  "archosaurian": "heal",
  "archway": "build",
  "arcidae": "heal",
  "arcminute": "smart",
  "arcsecond": "smart",
  "arctic": "build",
  "arctictis": "heal",
  "arctiid": "heal",
  "arctiidae": "heal",
  "arctium": "heal",
  "arctocebus": "heal",
  "arctocephalus": "heal",
  "arctonyx": "heal",
  "arctostaphylos": "heal",
  "arctotis": "heal",
  "arcus": "heal",
  "ardea": "heal",
  "ardeb": "smart",
  "ardeidae": "heal",
  "ardisia": "heal",
  "are": "smart",
  "area": "smart",
  "areaway": "build",
  "areca": "heal",
  "arecaceae": "heal",
  "arecidae": "heal",
  "arena": "build",
  "arenaceous": "beautiful",
  "arenaria": "heal",
  "arenaria-melanocephala": "heal",
  "arenaviridae": "heal",
  "arenavirus": "heal",
  "arenga": "heal",
  "areola": "heal",
  "arere": "heal",
  "ares": "smart",
  "arethusa": "heal",
  "argal": "heal",
  "argali": "heal",
  "argasid": "heal",
  "argasidae": "heal",
  "argemone": "heal",
  "argent": "beautiful",
  "argentina": "heal",
  "argentine": "heal",
  "argentinidae": "heal",
  "argentinosaur": "heal",
  "argillaceous": "beautiful",
  "argiope": "heal",
  "argiopidae": "heal",
  "argle-bargle": "story",
  "argonaut": "heal",
  "argonauta": "heal",
  "argonautidae": "heal",
  "argot": "story",
  "argue": "story",
  "argufy": "story",
  "arguing": "story",
  "argument": "story",
  "argumentation": "story",
  "argumentative": "beautiful",
  "argus": "heal",
  "argusianus": "heal",
  "argy-bargy": "story",
  "argyle": "build",
  "argyll": "build",
  "argynnis": "heal",
  "argyranthemum": "heal",
  "argyreia": "heal",
  "argyrol": "build",
  "argyrotaenia": "heal",
  "argyroxiphium": "heal",
  "aria": "story",
  "arianism": "smart",
  "aricara": "story",
  "arietta": "story",
  "ariidae": "heal",
  "arikara": "story",
  "aril": "heal",
  "arilus": "heal",
  "ariocarpus": "heal",
  "ariomma": "heal",
  "arioso": "story",
  "arisaema": "heal",
  "arisarum": "heal",
  "arishth": "heal",
  "arista": "heal",
  "aristolochia": "heal",
  "aristolochiaceae": "heal",
  "aristolochiales": "heal",
  "aristotelia": "heal",
  "aristotelianism": "smart",
  "arithmancy": "smart",
  "arithmetic": "smart",
  "arity": "smart",
  "arius": "heal",
  "arizona": "heal",
  "ark": "build",
  "arles": "sell",
  "arm": "heal",
  "arm-twisting": "story",
  "armadillidiidae": "heal",
  "armadillidium": "heal",
  "armadillo": "heal",
  "armagnac": "taste",
  "armament": "build",
  "armature": "build",
  "armband": "story",
  "armchair": "build",
  "armed": "sell",
  "armenian": "story",
  "armeria": "heal",
  "armet": "build",
  "armful": "smart",
  "armguard": "build",
  "armhole": "build",
  "armilla": "build",
  "armillaria": "heal",
  "armillariella": "heal",
  "arming": "sell",
  "arminianism": "smart",
  "armless": "beautiful",
  "armlet": "build",
  "armoire": "build",
  "armor": "build",
  "armoracia": "heal",
  "armored": "sell",
  "armory": "smart",
  "armour": "build",
  "armoured": "sell",
  "armoury": "smart",
  "armpit": "heal",
  "armrest": "build",
  "arms": "build",
  "armyworm": "heal",
  "arnica": "heal",
  "arnoseris": "heal",
  "aroid": "heal",
  "aroma": "taste",
  "aromatic": "beautiful",
  "aromatise": "sound",
  "aromatize": "sound",
  "arousal": "smart",
  "arouse": "heal",
  "arpeggio": "sound",
  "arpent": "smart",
  "arquebus": "build",
  "arrack": "taste",
  "arraign": "sell",
  "arraignment": "story",
  "arrange": "build",
  "arranged": "build",
  "arrangement": "smart",
  "arranging": "build",
  "arras": "build",
  "array": "story",
  "arrears": "sell",
  "arrest": "build",
  "arrester": "build",
  "arrhenatherum": "heal",
  "arrive": "sell",
  "arrivederci": "story",
  "arroba": "smart",
  "arrogate": "sell",
  "arrow": "story",
  "arrowhead": "build",
  "arrowroot": "heal",
  "arrowworm": "heal",
  "arse": "heal",
  "arsehole": "heal",
  "arsenal": "build",
  "art": "beautiful",
  "artamidae": "heal",
  "artamus": "heal",
  "artemia": "heal",
  "artemisia": "heal",
  "arteria": "heal",
  "arteriogram": "build",
  "arteriola": "heal",
  "arteriole": "heal",
  "artery": "heal",
  "artesian": "beautiful",
  "artful": "beautiful",
  "arthritic": "beautiful",
  "arthrogram": "build",
  "arthromere": "heal",
  "arthropathy": "heal",
  "arthropod": "heal",
  "arthropoda": "heal",
  "arthropteris": "heal",
  "arthroscope": "build",
  "arthrospore": "heal",
  "artichoke": "heal",
  "article": "story",
  "articulate": "sell",
  "articulated": "sell",
  "articulatio": "heal",
  "articulation": "story",
  "articulator": "heal",
  "artificial": "smart",
  "artillery": "build",
  "artiodactyl": "heal",
  "artiodactyla": "heal",
  "artistic": "beautiful",
  "artistry": "beautiful",
  "artless": "beautiful",
  "artocarpus": "heal",
  "arts": "smart",
  "artsd": "story",
  "artwork": "beautiful",
  "arugula": "heal",
  "arui": "heal",
  "arulo": "story",
  "arum": "heal",
  "arundinaria": "heal",
  "arundo": "heal",
  "arvicola": "heal",
  "arytaenoid": "heal",
  "arytenoid": "heal",
  "asamiya": "story",
  "asarabacca": "heal",
  "asarum": "heal",
  "ascaphidae": "heal",
  "ascaphus": "heal",
  "ascaridae": "heal",
  "ascaridia": "heal",
  "ascaris": "heal",
  "ascend": "sell",
  "ascendant": "beautiful",
  "ascendent": "beautiful",
  "ascender": "story",
  "ascending": "sell",
  "ascertain": "story",
  "ascetic": "beautiful",
  "ascetical": "beautiful",
  "asceticism": "smart",
  "aschelminthes": "heal",
  "ascidiaceae": "heal",
  "ascidian": "heal",
  "ascii": "story",
  "asclepiad": "heal",
  "asclepiadaceae": "heal",
  "asclepias": "heal",
  "ascocarp": "heal",
  "ascolichen": "heal",
  "ascoma": "heal",
  "ascomycete": "heal",
  "ascomycetes": "heal",
  "ascomycota": "heal",
  "ascomycotina": "heal",
  "ascophyllum": "heal",
  "ascospore": "heal",
  "ascot": "build",
  "ascribe": "smart",
  "ascription": "smart",
  "ascus": "heal",
  "asdic": "build",
  "asepsis": "smart",
  "asexual": "beautiful",
  "asgard": "smart",
  "ash": "heal",
  "ash-bin": "build",
  "ash-key": "heal",
  "ash-pan": "build",
  "ashamed": "beautiful",
  "ashbin": "build",
  "ashcake": "taste",
  "ashcan": "build",
  "ashlar": "build",
  "ashtray": "build",
  "aside": "story",
  "asilidae": "heal",
  "asimina": "heal",
  "asio": "heal",
  "ask": "story",
  "asking": "story",
  "asl": "story",
  "asleep": "beautiful",
  "asp": "heal",
  "aspalathus": "heal",
  "asparagaceae": "heal",
  "asparaginase": "build",
  "asparagus": "heal",
  "aspartame": "taste",
  "aspect": "smart",
  "aspen": "heal",
  "asper": "smart",
  "aspergill": "build",
  "aspergillaceae": "heal",
  "aspergillales": "heal",
  "aspergillus": "heal",
  "asperse": "story",
  "aspersion": "story",
  "aspersorium": "build",
  "asperula": "heal",
  "asphalt": "build",
  "asphaltic": "beautiful",
  "asphodel": "heal",
  "asphodelaceae": "heal",
  "asphodeline": "heal",
  "asphodelus": "heal",
  "asphyxiate": "build",
  "asphyxiated": "build",
  "asphyxiator": "build",
  "aspic": "taste",
  "aspidelaps": "heal",
  "aspidiotus": "heal",
  "aspidistra": "heal",
  "aspidophoroides": "heal",
  "aspirant": "beautiful",
  "aspirate": "story",
  "aspiration": "story",
  "aspirator": "build",
  "aspire": "smart",
  "aspirin": "build",
  "aspis": "heal",
  "aspleniaceae": "heal",
  "asplenium": "heal",
  "ass": "heal",
  "assagai": "build",
  "assail": "story",
  "assamese": "story",
  "assassinate": "sell",
  "assassination": "story",
  "assault": "heal",
  "assay": "smart",
  "assay-mark": "story",
  "assegai": "build",
  "assemblage": "beautiful",
  "assemble": "build",
  "assembler": "story",
  "assembling": "build",
  "assembly": "build",
  "assent": "story",
  "assenting": "story",
  "assert": "story",
  "asserting": "story",
  "assertion": "story",
  "assertive": "beautiful",
  "assess": "smart",
  "assessment": "smart",
  "assets": "sell",
  "asseverate": "story",
  "asseveration": "story",
  "asshole": "heal",
  "assibilate": "story",
  "assibilation": "smart",
  "assign": "sell",
  "assigned": "sell",
  "assigning": "sell",
  "assignment": "story",
  "assimilate": "smart",
  "assimilation": "smart",
  "assist": "sell",
  "assistant": "beautiful",
  "assisted": "sell",
  "assize": "story",
  "assizes": "story",
  "association": "smart",
  "associationism": "smart",
  "associative": "beautiful",
  "associatory": "beautiful",
  "assoil": "story",
  "assonance": "story",
  "assort": "sell",
  "assuage": "taste",
  "assume": "smart",
  "assumption": "story",
  "assurance": "smart",
  "assure": "story",
  "assyrian": "story",
  "assyriology": "smart",
  "astacidae": "heal",
  "astacura": "heal",
  "astacus": "heal",
  "aster": "heal",
  "asteraceae": "heal",
  "asteridae": "heal",
  "asterion": "heal",
  "asterisk": "story",
  "asteroid": "beautiful",
  "asteroidea": "heal",
  "asthmatic": "beautiful",
  "astigmatic": "beautiful",
  "astilbe": "heal",
  "astomatous": "beautiful",
  "astonish": "smart",
  "astound": "smart",
  "astragal": "heal",
  "astragalus": "heal",
  "astrantia": "heal",
  "astreus": "heal",
  "astringe": "build",
  "astringence": "smart",
  "astringency": "smart",
  "astringent": "build",
  "astrobiology": "smart",
  "astrocyte": "heal",
  "astrodome": "build",
  "astrodynamics": "smart",
  "astroglia": "heal",
  "astrolabe": "build",
  "astrology": "smart",
  "astroloma": "heal",
  "astrometry": "smart",
  "astronautics": "smart",
  "astronium": "heal",
  "astronomic": "beautiful",
  "astronomical": "beautiful",
  "astronomy": "smart",
  "astrophysics": "smart",
  "astrophyton": "heal",
  "astropogon": "heal",
  "astuteness": "smart",
  "asylum": "build",
  "asymmetric": "beautiful",
  "asymmetrical": "beautiful",
  "asynchronous": "beautiful",
  "asyndetic": "beautiful",
  "asyndeton": "story",
  "atabrine": "build",
  "atakapa": "story",
  "atakapan": "story",
  "ataractic": "build",
  "atarax": "build",
  "atayalic": "story",
  "ate": "taste",
  "ateles": "heal",
  "atelier": "beautiful",
  "atenolol": "build",
  "athabascan": "story",
  "athabaskan": "story",
  "athanasianism": "smart",
  "athanor": "build",
  "athapascan": "story",
  "athapaskan": "story",
  "atharva-veda": "story",
  "atheism": "smart",
  "atheistic": "beautiful",
  "atheistical": "beautiful",
  "athenaeum": "build",
  "athene": "heal",
  "atheneum": "build",
  "atherinidae": "heal",
  "atherinopsis": "heal",
  "atherodyde": "build",
  "atheroma": "heal",
  "atherurus": "heal",
  "athiorhodaceae": "heal",
  "athletic": "beautiful",
  "athodyd": "build",
  "athrotaxis": "heal",
  "athyriaceae": "heal",
  "athyrium": "heal",
  "ativan": "build",
  "atlantis": "smart",
  "atlas": "story",
  "atm": "smart",
  "atmometer": "build",
  "atmosphere": "smart",
  "atole": "taste",
  "atomic": "beautiful",
  "atomise": "build",
  "atomiser": "build",
  "atomism": "smart",
  "atomistic": "beautiful",
  "atomistical": "beautiful",
  "atomize": "build",
  "atomizer": "build",
  "atonal": "beautiful",
  "atonalism": "story",
  "atonality": "sound",
  "atone": "sell",
  "atonement": "sell",
  "atonic": "beautiful",
  "atorvastatin": "build",
  "atoxic": "beautiful",
  "atrichornis": "heal",
  "atrichornithidae": "heal",
  "atriplex": "heal",
  "atrium": "heal",
  "atromid-s": "build",
  "atropa": "heal",
  "atrophied": "heal",
  "atrophy": "heal",
  "atropidae": "heal",
  "atropine": "build",
  "atrovent": "build",
  "atsugewi": "story",
  "attacapa": "story",
  "attacapan": "story",
  "attach": "build",
  "attachable": "beautiful",
  "attache": "build",
  "attached": "build",
  "attachment": "build",
  "attack": "story",
  "attain": "sell",
  "attainment": "smart",
  "attaint": "sell",
  "attalea": "heal",
  "attempt": "sell",
  "attend": "sell",
  "attendant": "beautiful",
  "attended": "sell",
  "attending": "smart",
  "attention": "smart",
  "attentive": "beautiful",
  "attentiveness": "smart",
  "attenuate": "beautiful",
  "attenuator": "build",
  "attest": "story",
  "attestation": "story",
  "attic": "build",
  "atticus": "heal",
  "attilio": "heal",
  "attire": "build",
  "attitude": "smart",
  "attitudinise": "sell",
  "attitudinize": "sell",
  "attorn": "smart",
  "attract": "build",
  "attracter": "smart",
  "attraction": "sound",
  "attractive": "beautiful",
  "attractor": "smart",
  "attributable": "beautiful",
  "attribute": "smart",
  "attribution": "smart",
  "attributive": "beautiful",
  "attrition": "smart",
  "atypical": "beautiful",
  "auberge": "build",
  "aubergine": "heal",
  "auction": "sell",
  "auctioneer": "sell",
  "aucuba": "heal",
  "audad": "heal",
  "audible": "beautiful",
  "audience": "story",
  "audio": "story",
  "audiocassette": "build",
  "audiogram": "build",
  "audiology": "smart",
  "audiometer": "build",
  "audiometry": "smart",
  "audiotape": "build",
  "audiovisual": "build",
  "audit": "sell",
  "audition": "smart",
  "auditorium": "build",
  "augend": "smart",
  "auger": "build",
  "aught": "smart",
  "augmentation": "story",
  "augmentin": "build",
  "augur": "story",
  "august": "beautiful",
  "auk": "heal",
  "auklet": "heal",
  "aulacorhyncus": "heal",
  "aulostomidae": "heal",
  "aulostomus": "heal",
  "aureolaria": "heal",
  "aureole": "sound",
  "aureomycin": "build",
  "auricle": "heal",
  "auricula": "heal",
  "auriculare": "heal",
  "auricularia": "heal",
  "auriculariaceae": "heal",
  "auriculariales": "heal",
  "auriparus": "heal",
  "auriscope": "build",
  "aurochs": "heal",
  "aurora": "sound",
  "auroscope": "build",
  "auschwitz": "build",
  "auscultate": "sound",
  "auspicate": "story",
  "auspicious": "beautiful",
  "austral": "smart",
  "australian": "story",
  "australopithecine": "heal",
  "australopithecus": "heal",
  "austro-asiatic": "story",
  "austrocedrus": "heal",
  "austronesian": "story",
  "austrotaxus": "heal",
  "autacoid": "heal",
  "autarkical": "beautiful",
  "authenticate": "smart",
  "authentication": "smart",
  "author": "story",
  "authorisation": "story",
  "authorise": "sell",
  "authorised": "sell",
  "authoritarian": "beautiful",
  "authority": "smart",
  "authorization": "smart",
  "authorize": "story",
  "authorized": "story",
  "autism": "heal",
  "auto": "build",
  "auto-changer": "build",
  "autobahn": "build",
  "autobiography": "story",
  "autobus": "build",
  "autocatalysis": "smart",
  "autochthonous": "beautiful",
  "autoclave": "build",
  "autocoid": "heal",
  "autocracy": "smart",
  "autocue": "build",
  "autoecious": "beautiful",
  "autofluorescence": "sound",
  "autofocus": "build",
  "autogamic": "beautiful",
  "autogamous": "beautiful",
  "autogenesis": "sound",
  "autogenic": "beautiful",
  "autogenous": "beautiful",
  "autogeny": "sound",
  "autogiro": "build",
  "autograft": "heal",
  "autograph": "story",
  "autogyro": "build",
  "autoinjector": "build",
  "autoloader": "build",
  "autologous": "beautiful",
  "autolysis": "smart",
  "automat": "build",
  "automatic": "build",
  "automation": "smart",
  "automaton": "build",
  "automeris": "heal",
  "automobile": "build",
  "automotive": "beautiful",
  "autophyte": "heal",
  "autopilot": "smart",
  "autoplasty": "heal",
  "autopsy": "sound",
  "autoradiograph": "build",
  "autoradiography": "smart",
  "autoregulation": "smart",
  "autosome": "heal",
  "autostrada": "build",
  "autotelism": "smart",
  "autotomise": "build",
  "autotomize": "build",
  "autotroph": "heal",
  "autotype": "smart",
  "autotypy": "smart",
  "autumnal": "beautiful",
  "auxesis": "smart",
  "auxiliary": "beautiful",
  "avadavat": "heal",
  "avahi": "heal",
  "avail": "taste",
  "available": "beautiful",
  "avant-garde": "beautiful",
  "avaram": "heal",
  "avena": "heal",
  "avens": "heal",
  "aventail": "build",
  "avenue": "build",
  "aver": "story",
  "average": "smart",
  "averment": "story",
  "averrhoa": "heal",
  "avert": "sell",
  "avertable": "beautiful",
  "avertible": "beautiful",
  "averting": "sell",
  "aves": "heal",
  "avesta": "story",
  "avestan": "story",
  "aviary": "build",
  "aviation": "smart",
  "avicennia": "heal",
  "avicenniaceae": "heal",
  "avionics": "smart",
  "avirulent": "beautiful",
  "avo": "smart",
  "avocado": "taste",
  "avocet": "heal",
  "avoid": "story",
  "avoidable": "beautiful",
  "avoirdupois": "smart",
  "avouch": "story",
  "avouchment": "story",
  "avow": "story",
  "avowal": "story",
  "await": "smart",
  "awake": "heal",
  "awaken": "heal",
  "awakened": "heal",
  "awakening": "heal",
  "award": "story",
  "awarding": "sell",
  "aware": "beautiful",
  "awareness": "smart",
  "away": "beautiful",
  "awed": "beautiful",
  "awestricken": "beautiful",
  "awestruck": "beautiful",
  "awful": "beautiful",
  "awkward": "beautiful",
  "awkwardness": "smart",
  "awl": "build",
  "awlwort": "heal",
  "awn": "heal",
  "awned": "beautiful",
  "awning": "build",
  "awnless": "beautiful",
  "awny": "beautiful",
  "awol": "beautiful",
  "axe": "build",
  "axial": "beautiful",
  "axil": "heal",
  "axilla": "heal",
  "axiology": "smart",
  "axiom": "story",
  "axiomatic": "beautiful",
  "axis": "smart",
  "axle": "build",
  "axletree": "build",
  "axolemma": "heal",
  "axolotl": "heal",
  "axon": "heal",
  "axone": "heal",
  "axseed": "heal",
  "ayapana": "heal",
  "aye-aye": "heal",
  "ayin": "story",
  "ayrshire": "heal",
  "aythya": "heal",
  "ayurveda": "story",
  "azactam": "build",
  "azadirachta": "heal",
  "azalea": "heal",
  "azaleastrum": "heal",
  "azathioprine": "build",
  "azedarach": "heal",
  "azederach": "heal",
  "azerbaijani": "story",
  "azithromycin": "build",
  "azolla": "heal",
  "azollaceae": "heal",
  "azonal": "beautiful",
  "azt": "build",
  "aztecan": "story",
  "aztreonam": "build",
  "azure": "beautiful",
  "b-52": "build",
  "b.t.u.": "smart",
  "b.th.u.": "smart",
  "baa": "story",
  "baa-lamb": "heal",
  "baas": "story",
  "baba": "taste",
  "babassu": "heal",
  "babbitt": "build",
  "babbitting": "build",
  "babble": "story",
  "babbler": "heal",
  "babbling": "story",
  "babel": "build",
  "babesiidae": "heal",
  "babies'-breath": "heal",
  "babiroussa": "heal",
  "babirusa": "heal",
  "babirussa": "heal",
  "babka": "taste",
  "baboon": "heal",
  "babushka": "build",
  "baby-sit": "sell",
  "baby-walker": "build",
  "babylonian": "story",
  "babyrousa": "heal",
  "babytalk": "story",
  "bacca": "heal",
  "baccalaureate": "story",
  "baccate": "beautiful",
  "bacchanal": "beautiful",
  "baccharis": "heal",
  "baccy": "build",
  "bach": "story",
  "bacillaceae": "heal",
  "bacillar": "beautiful",
  "bacillariophyceae": "heal",
  "bacillary": "beautiful",
  "bacillus": "heal",
  "bacitracin": "build",
  "back": "heal",
  "back-formation": "story",
  "backband": "build",
  "backbeat": "story",
  "backbench": "build",
  "backbite": "story",
  "backboard": "build",
  "backbone": "smart",
  "backchat": "story",
  "backcloth": "build",
  "backcross": "build",
  "backdate": "sell",
  "backdoor": "story",
  "backdown": "story",
  "backdrop": "build",
  "backed": "sell",
  "background": "smart",
  "backgrounder": "story",
  "backgrounding": "smart",
  "backhand": "build",
  "backhanded": "build",
  "backhander": "beautiful",
  "backhoe": "build",
  "backing": "build",
  "backlash": "sell",
  "backless": "beautiful",
  "backlighting": "build",
  "backlog": "sell",
  "backpack": "build",
  "backpedal": "smart",
  "backplate": "build",
  "backrest": "build",
  "backroom": "build",
  "backsaw": "build",
  "backscratcher": "build",
  "backseat": "build",
  "backsheesh": "sell",
  "backside": "heal",
  "backslap": "sell",
  "backspace": "build",
  "backspacer": "build",
  "backstage": "build",
  "backstairs": "build",
  "backstay": "build",
  "backstitch": "build",
  "backstop": "build",
  "backswimmer": "heal",
  "backsword": "build",
  "backtalk": "story",
  "backup": "smart",
  "backward": "beautiful",
  "backwardness": "smart",
  "backwash": "sound",
  "backyard": "build",
  "bacon": "taste",
  "bacteria": "heal",
  "bactericide": "build",
  "bacteriochlorophyll": "heal",
  "bacteriology": "smart",
  "bacteriolysis": "smart",
  "bacteriophage": "heal",
  "bacteriostasis": "smart",
  "bacterium": "heal",
  "bacteroid": "heal",
  "bacteroidaceae": "heal",
  "bacteroides": "heal",
  "bad": "beautiful",
  "badaga": "story",
  "bade": "story",
  "badge": "story",
  "badger": "heal",
  "badgering": "story",
  "badinage": "story",
  "badmouth": "story",
  "baedeker": "story",
  "baffle": "build",
  "baffled": "smart",
  "bafflement": "smart",
  "bag": "build",
  "bagatelle": "story",
  "bagel": "taste",
  "bagful": "smart",
  "baggage": "build",
  "bagger": "build",
  "bagging": "build",
  "bagnio": "build",
  "bagpipe": "build",
  "baguet": "taste",
  "baguette": "taste",
  "bahaism": "smart",
  "bahasa": "story",
  "baht": "smart",
  "bai": "story",
  "baic": "story",
  "bail": "sell",
  "bailey": "build",
  "bailiwick": "smart",
  "bain-marie": "build",
  "baiomys": "heal",
  "bairdiella": "heal",
  "baisa": "smart",
  "bait": "smart",
  "baiting": "story",
  "baiza": "smart",
  "baize": "build",
  "bake": "taste",
  "bakeapple": "heal",
  "bakehouse": "build",
  "bakery": "taste",
  "bakeshop": "build",
  "baking": "taste",
  "baklava": "taste",
  "baksheesh": "sell",
  "bakshis": "sell",
  "bakshish": "sell",
  "balaclava": "build",
  "balaena": "heal",
  "balaeniceps": "heal",
  "balaenicipitidae": "heal",
  "balaenidae": "heal",
  "balaenoptera": "heal",
  "balaenopteridae": "heal",
  "balalaika": "build",
  "balance": "sell",
  "balanced": "sell",
  "balancer": "heal",
  "balancing": "sell",
  "balanidae": "heal",
  "balanus": "heal",
  "balata": "heal",
  "balboa": "smart",
  "balbriggan": "build",
  "balconied": "beautiful",
  "balcony": "build",
  "bald": "beautiful",
  "baldachin": "build",
  "balder": "beautiful",
  "balderdash": "story",
  "baldpate": "heal",
  "baldric": "build",
  "baldrick": "build",
  "baldwin": "taste",
  "bale": "build",
  "balibago": "heal",
  "balinese": "story",
  "balistes": "heal",
  "balistidae": "heal",
  "balk": "smart",
  "balkanise": "sell",
  "balkanize": "sell",
  "ball": "build",
  "ballad": "story",
  "ballade": "story",
  "ballast": "build",
  "ballcock": "build",
  "balldress": "build",
  "ballet": "story",
  "balletomania": "smart",
  "ballista": "build",
  "ballistics": "sound",
  "ballistocardiogram": "story",
  "ballistocardiograph": "build",
  "ballock": "heal",
  "balloon": "build",
  "balloonfish": "heal",
  "ballot": "story",
  "ballota": "heal",
  "balloting": "sell",
  "ballpark": "build",
  "ballpen": "build",
  "ballpoint": "build",
  "ballroom": "build",
  "ballyhoo": "story",
  "balm": "build",
  "balmoral": "build",
  "balochi": "story",
  "baloney": "story",
  "balsa": "heal",
  "balsam": "heal",
  "balsaminaceae": "heal",
  "balsamorhiza": "heal",
  "balsamroot": "heal",
  "baltic": "story",
  "baltic-finnic": "story",
  "balto-slavic": "story",
  "balto-slavonic": "story",
  "baluchi": "story",
  "baluster": "build",
  "balusters": "build",
  "balustrade": "build",
  "bamboo": "heal",
  "bamboozle": "story",
  "bambusa": "heal",
  "bambuseae": "heal",
  "ban": "story",
  "banality": "story",
  "banana": "heal",
  "band": "build",
  "bandage": "heal",
  "bandaging": "build",
  "bandana": "build",
  "bandanna": "build",
  "bandbox": "build",
  "bandeau": "build",
  "banded": "build",
  "bandelet": "build",
  "bandelette": "build",
  "banderilla": "build",
  "bandicoot": "heal",
  "banding": "build",
  "bandlet": "build",
  "bandoleer": "build",
  "bandolier": "build",
  "bandoneon": "build",
  "bandsaw": "build",
  "bandstand": "build",
  "bandtail": "heal",
  "bandwagon": "smart",
  "bandwidth": "smart",
  "bandy": "story",
  "bandyleg": "heal",
  "baneberry": "heal",
  "bang": "heal",
  "banger": "taste",
  "bangiaceae": "heal",
  "banging": "build",
  "bangla": "story",
  "bangle": "build",
  "bangtail": "heal",
  "banian": "heal",
  "banish": "sell",
  "banister": "build",
  "banjo": "sound",
  "bankbook": "sell",
  "bankia": "heal",
  "banking": "build",
  "banknote": "sell",
  "bankroll": "sell",
  "bankrupt": "sell",
  "banksia": "heal",
  "banner": "build",
  "banning": "story",
  "banning-order": "story",
  "bannister": "build",
  "bannock": "taste",
  "banns": "story",
  "banquet": "taste",
  "banqueting": "taste",
  "banquette": "build",
  "bantam": "heal",
  "banteng": "heal",
  "banter": "story",
  "banting": "heal",
  "bantu": "story",
  "bantu-speaking": "beautiful",
  "banyan": "heal",
  "banzai": "story",
  "baobab": "heal",
  "bap": "taste",
  "baphia": "heal",
  "baptise": "story",
  "baptised": "story",
  "baptisia": "heal",
  "baptistery": "build",
  "baptistry": "build",
  "baptize": "story",
  "baptized": "story",
  "bar": "build",
  "baranduki": "heal",
  "barb": "story",
  "barbacan": "build",
  "barbarea": "heal",
  "barbarian": "beautiful",
  "barbasco": "heal",
  "barbecue": "taste",
  "barbel": "heal",
  "barbell": "build",
  "barbeque": "taste",
  "barber": "heal",
  "barberry": "heal",
  "barbershop": "build",
  "barbet": "heal",
  "barbette": "build",
  "barbican": "build",
  "barbital": "build",
  "barbitone": "build",
  "barbiturate": "build",
  "barbu": "heal",
  "barbwire": "build",
  "barcarole": "story",
  "barcarolle": "story",
  "bard": "build",
  "barde": "build",
  "bare": "build",
  "bareboat": "build",
  "barf": "heal",
  "bargain": "story",
  "bargaining": "story",
  "barge": "build",
  "bargello": "build",
  "barilla": "heal",
  "baring": "build",
  "barish": "story",
  "baritone": "sound",
  "bark": "heal",
  "bark-louse": "heal",
  "barker": "heal",
  "barley": "taste",
  "barley-sugar": "taste",
  "barleycorn": "heal",
  "barm": "taste",
  "barmbrack": "taste",
  "barn": "build",
  "barnacle": "heal",
  "barndoor": "build",
  "barnful": "smart",
  "barnyard": "build",
  "barograph": "build",
  "barometer": "build",
  "baronduki": "heal",
  "baronetcy": "story",
  "baronetise": "sell",
  "baronetize": "sell",
  "barong": "build",
  "barony": "sell",
  "baroque": "beautiful",
  "baroreceptor": "heal",
  "barosaur": "heal",
  "barosaurus": "heal",
  "barouche": "build",
  "barque": "build",
  "barrack": "build",
  "barracking": "story",
  "barracouta": "heal",
  "barracuda": "heal",
  "barrage": "story",
  "barramundi": "heal",
  "barratry": "taste",
  "barrel": "build",
  "barreled": "build",
  "barrelfish": "heal",
  "barrelful": "smart",
  "barrelhouse": "build",
  "barrelled": "build",
  "barrels": "smart",
  "barren": "beautiful",
  "barrenwort": "heal",
  "barrette": "build",
  "barretter": "build",
  "barricade": "build",
  "barrier": "build",
  "barring": "story",
  "barroom": "build",
  "barrow": "smart",
  "barrowful": "smart",
  "bars": "build",
  "barter": "sell",
  "bartlett": "taste",
  "bartonia": "heal",
  "bartramia": "heal",
  "baruch": "story",
  "barunduki": "heal",
  "barye": "smart",
  "basal": "beautiful",
  "bascule": "build",
  "base": "build",
  "baseball": "build",
  "baseboard": "build",
  "basement": "build",
  "basenji": "heal",
  "bash": "build",
  "basic": "story",
  "basics": "story",
  "basidiocarp": "heal",
  "basidiolichen": "heal",
  "basidiomycete": "heal",
  "basidiomycetes": "heal",
  "basidiomycota": "heal",
  "basidiomycotina": "heal",
  "basidiospore": "heal",
  "basidium": "heal",
  "basil": "heal",
  "basilica": "build",
  "basiliscus": "heal",
  "basilisk": "build",
  "basin": "build",
  "basinet": "build",
  "basinful": "smart",
  "basipetal": "beautiful",
  "basis": "smart",
  "basiscopic": "beautiful",
  "bask": "build",
  "basket": "build",
  "basketball": "build",
  "basketful": "smart",
  "basophil": "heal",
  "basophile": "heal",
  "basque": "story",
  "bass": "story",
  "bassariscidae": "heal",
  "bassariscus": "heal",
  "bassarisk": "heal",
  "basset": "heal",
  "bassia": "heal",
  "bassine": "heal",
  "bassinet": "build",
  "basso": "story",
  "bassoon": "build",
  "basswood": "heal",
  "bast": "heal",
  "bastard": "build",
  "bastardise": "sell",
  "bastardization": "story",
  "bastardize": "sell",
  "baste": "build",
  "baster": "build",
  "bastille": "build",
  "bastinado": "build",
  "basting": "build",
  "bastion": "build",
  "basuco": "build",
  "basuto": "story",
  "bat": "heal",
  "bata": "story",
  "batch": "smart",
  "bate": "sell",
  "batfish": "heal",
  "batfowl": "build",
  "bath": "build",
  "bathe": "heal",
  "bathhouse": "build",
  "bathing": "heal",
  "bathometer": "build",
  "bathos": "story",
  "bathrobe": "build",
  "bathroom": "build",
  "bathtub": "build",
  "bathyergidae": "heal",
  "bathyergus": "heal",
  "bathymeter": "build",
  "bathyscape": "build",
  "bathyscaph": "build",
  "bathyscaphe": "build",
  "bathysphere": "build",
  "batidaceae": "heal",
  "batik": "build",
  "batis": "heal",
  "batiste": "build",
  "batoidei": "heal",
  "baton": "build",
  "batrachia": "heal",
  "batrachian": "heal",
  "batrachoididae": "heal",
  "batrachomyomachia": "story",
  "batrachoseps": "heal",
  "battalion": "smart",
  "batten": "build",
  "batter": "taste",
  "battercake": "taste",
  "battering": "build",
  "battery": "build",
  "battery-acid": "build",
  "batting": "build",
  "battle-ax": "build",
  "battle-axe": "build",
  "battledore": "build",
  "battlement": "build",
  "battleship": "build",
  "battlesight": "build",
  "battlewagon": "build",
  "batwing": "build",
  "bauble": "story",
  "baud": "smart",
  "bauhaus": "smart",
  "bauhinia": "heal",
  "baulk": "smart",
  "bawbee": "sell",
  "bawdry": "story",
  "bawdy": "story",
  "bawdyhouse": "build",
  "bawl": "story",
  "bawling": "story",
  "bay": "heal",
  "baya": "heal",
  "bayat": "story",
  "bayberry": "heal",
  "baycol": "build",
  "bayer": "build",
  "bayes": "story",
  "bayonet": "build",
  "bazaar": "build",
  "bazar": "build",
  "bazooka": "build",
  "bbl": "smart",
  "bbs": "build",
  "beachball": "build",
  "beachwear": "build",
  "beacon": "story",
  "bead": "beautiful",
  "beading": "beautiful",
  "beads": "build",
  "beadwork": "build",
  "beagle": "heal",
  "beak": "heal",
  "beaked": "build",
  "beaker": "build",
  "beakless": "beautiful",
  "beam": "build",
  "bean": "taste",
  "beanbag": "build",
  "beanie": "build",
  "beanstalk": "heal",
  "beany": "build",
  "bear": "heal",
  "bearberry": "heal",
  "bearcat": "heal",
  "beard": "heal",
  "bearnaise": "taste",
  "bearskin": "build",
  "bearwood": "heal",
  "beat": "sound",
  "beaten": "build",
  "beater": "build",
  "beatify": "story",
  "beating": "build",
  "beatitude": "story",
  "beats": "sound",
  "beaugregory": "heal",
  "beaujolais": "taste",
  "beaumontia": "heal",
  "beaut": "smart",
  "beautiful": "beautiful",
  "beautify": "build",
  "beauty": "beautiful",
  "beaver": "heal",
  "bebop": "story",
  "bechamel": "taste",
  "becharm": "sell",
  "beck": "story",
  "becket": "build",
  "beckon": "story",
  "becloud": "sound",
  "bed": "build",
  "bed-and-breakfast": "build",
  "bed-wetting": "smart",
  "bedamn": "story",
  "bedaub": "build",
  "bedaze": "sound",
  "bedazzle": "sound",
  "bedbug": "heal",
  "bedchamber": "build",
  "bedclothes": "build",
  "bedcover": "build",
  "bedded": "sell",
  "bedder": "heal",
  "bedding": "build",
  "bedeck": "build",
  "bedevil": "smart",
  "bedfellow": "sound",
  "bedframe": "build",
  "bedight": "build",
  "bedizen": "build",
  "bedlam": "build",
  "bedless": "beautiful",
  "bedpan": "build",
  "bedpost": "build",
  "bedrock": "smart",
  "bedroll": "build",
  "bedroom": "build",
  "bedsit": "build",
  "bedsitter": "build",
  "bedspread": "build",
  "bedspring": "build",
  "bedstead": "build",
  "bedstraw": "heal",
  "bee": "heal",
  "beebalm": "heal",
  "beech": "heal",
  "beechnut": "taste",
  "beechwood": "heal",
  "beef": "taste",
  "beefalo": "heal",
  "beefburger": "taste",
  "beefcake": "build",
  "beefsteak": "taste",
  "beefwood": "heal",
  "beehive": "build",
  "beep": "sound",
  "beeper": "build",
  "beer": "taste",
  "beeswax": "build",
  "beet": "heal",
  "beethoven": "story",
  "beetle": "heal",
  "beetleweed": "heal",
  "beetroot": "heal",
  "befog": "sound",
  "befool": "sell",
  "befooling": "story",
  "befriend": "sell",
  "befuddle": "smart",
  "befuddlement": "smart",
  "beg": "story",
  "beget": "heal",
  "beggar": "sell",
  "beggar's-ticks": "heal",
  "beggar-ticks": "heal",
  "beggarweed": "heal",
  "beggary": "story",
  "begging": "story",
  "begild": "build",
  "begin": "sound",
  "beginning": "smart",
  "begonia": "heal",
  "begoniaceae": "heal",
  "begrime": "build",
  "beguile": "sell",
  "beguine": "story",
  "behave": "heal",
  "behaviorism": "smart",
  "behaviourism": "smart",
  "behead": "build",
  "beheading": "build",
  "behest": "story",
  "behind": "heal",
  "behmenism": "smart",
  "behold": "sound",
  "beholding": "smart",
  "beige": "beautiful",
  "beigel": "taste",
  "beignet": "taste",
  "bejewel": "build",
  "bel": "smart",
  "belabor": "sell",
  "belabour": "sell",
  "belamcanda": "heal",
  "belarusian": "story",
  "belay": "build",
  "belch": "heal",
  "belching": "heal",
  "belemnite": "heal",
  "belemnitidae": "heal",
  "belemnoidea": "heal",
  "belfry": "build",
  "belie": "story",
  "belief": "smart",
  "believable": "beautiful",
  "believe": "smart",
  "believing": "smart",
  "belittle": "story",
  "belittling": "story",
  "bell": "build",
  "bell-bottoms": "build",
  "belladonna": "heal",
  "bellarmine": "build",
  "bellbird": "heal",
  "belles-lettres": "story",
  "bellflower": "heal",
  "bellied": "beautiful",
  "belligerent": "beautiful",
  "belling": "story",
  "bellis": "heal",
  "bellow": "story",
  "bellowing": "story",
  "bellows": "build",
  "bellpull": "build",
  "bellwether": "heal",
  "bellwort": "heal",
  "belly": "heal",
  "bellyache": "story",
  "bellyband": "build",
  "bellybutton": "heal",
  "bellylaugh": "heal",
  "bellyless": "beautiful",
  "belmont": "build",
  "belong": "sell",
  "belonging": "sell",
  "belongings": "sell",
  "belonidae": "heal",
  "belostomatidae": "heal",
  "beloved": "beautiful",
  "belsen": "build",
  "belt": "build",
  "belted": "build",
  "belting": "build",
  "beltless": "beautiful",
  "beltway": "build",
  "beluga": "heal",
  "belvedere": "heal",
  "bema": "build",
  "bemire": "build",
  "bemisia": "heal",
  "bemoan": "story",
  "bemock": "story",
  "bemusement": "smart",
  "benadryl": "build",
  "bench": "build",
  "benchmark": "story",
  "bend": "build",
  "benday": "build",
  "bender": "build",
  "bends": "build",
  "benedictine": "taste",
  "benediction": "story",
  "benefact": "sell",
  "benefaction": "sell",
  "benefice": "sell",
  "beneficed": "sell",
  "beneficent": "beautiful",
  "beneficiary": "story",
  "beneficiation": "smart",
  "benefit": "sell",
  "benevolent": "beautiful",
  "bengali": "story",
  "benight": "build",
  "benign": "heal",
  "benignant": "beautiful",
  "benison": "story",
  "benne": "heal",
  "bennet": "heal",
  "bennettitaceae": "heal",
  "bennettitales": "heal",
  "bennettitis": "heal",
  "benni": "heal",
  "bennie": "build",
  "benniseed": "taste",
  "benny": "heal",
  "bent": "smart",
  "bent-grass": "heal",
  "bentwood": "build",
  "benumb": "sound",
  "benweed": "heal",
  "benzedrine": "build",
  "benzocaine": "build",
  "benzodiazepine": "build",
  "benzoin": "heal",
  "benzylpenicillin": "build",
  "beplaster": "build",
  "bequeath": "sell",
  "bequest": "sell",
  "berate": "story",
  "berating": "story",
  "berber": "story",
  "berberidaceae": "heal",
  "berberis": "heal",
  "berbers": "story",
  "berceuse": "story",
  "bercy": "taste",
  "bereave": "sell",
  "bereaved": "sell",
  "beret": "build",
  "bergall": "heal",
  "bergamot": "heal",
  "bergenia": "heal",
  "berlin": "build",
  "berm": "build",
  "bernard": "heal",
  "beroe": "heal",
  "berretta": "build",
  "berry": "taste",
  "berserk": "beautiful",
  "berserker": "beautiful",
  "berteroa": "heal",
  "berth": "build",
  "bertholletia": "heal",
  "berycomorphi": "heal",
  "beseech": "story",
  "beseeching": "story",
  "beset": "build",
  "beshrew": "story",
  "besiege": "story",
  "besieging": "story",
  "besmear": "build",
  "besmirch": "story",
  "besom": "build",
  "besot": "sound",
  "bespangle": "build",
  "bespatter": "build",
  "bespeak": "story",
  "bespeckle": "build",
  "bespot": "build",
  "bessera": "heal",
  "besseya": "heal",
  "best": "heal",
  "bestiary": "story",
  "bestow": "sell",
  "bestowal": "sell",
  "bestowment": "sell",
  "bestrew": "build",
  "bestseller": "story",
  "bet": "sell",
  "beta": "story",
  "beta-adrenoceptor": "heal",
  "beta-interferon": "build",
  "betatron": "build",
  "betel": "heal",
  "beth": "story",
  "bethel": "build",
  "bethink": "sound",
  "betoken": "story",
  "betray": "story",
  "betroth": "story",
  "betrothal": "story",
  "betrothed": "story",
  "bettering": "beautiful",
  "bettong": "heal",
  "bettongia": "heal",
  "betula": "heal",
  "betulaceae": "heal",
  "betweenbrain": "heal",
  "bevatron": "build",
  "bevel": "build",
  "beverage": "taste",
  "bewail": "story",
  "beware": "smart",
  "bewhisker": "sell",
  "bewilder": "smart",
  "bewilderment": "smart",
  "bewitch": "story",
  "bewitchment": "smart",
  "bewray": "story",
  "bextra": "build",
  "bezant": "sell",
  "bezel": "build",
  "bezzant": "sell",
  "bhagavad-gita": "story",
  "bhagavadgita": "story",
  "bhang": "build",
  "bialy": "taste",
  "bialystoker": "taste",
  "bias": "smart",
  "biaural": "beautiful",
  "bib": "build",
  "bib-and-tucker": "build",
  "bibbed": "beautiful",
  "bible": "story",
  "bibless": "beautiful",
  "bibliography": "story",
  "bibliotics": "smart",
  "bibos": "heal",
  "bicameral": "beautiful",
  "biceps": "heal",
  "bicker": "story",
  "bickering": "story",
  "bicorn": "build",
  "bicorne": "build",
  "bicuspid": "heal",
  "bicycle": "build",
  "bicycle-built-for-two": "build",
  "bid": "story",
  "bidding": "story",
  "biddy": "heal",
  "bidens": "heal",
  "bidet": "build",
  "bidirectional": "beautiful",
  "biennial": "heal",
  "bier": "build",
  "biff": "build",
  "bifocals": "build",
  "bifurcate": "beautiful",
  "big": "beautiful",
  "bigarade": "heal",
  "bigeye": "heal",
  "biggin": "build",
  "bighorn": "heal",
  "bight": "build",
  "bignonia": "heal",
  "bignoniaceae": "heal",
  "bignoniad": "heal",
  "bigos": "taste",
  "bigotry": "smart",
  "bigram": "story",
  "bihari": "story",
  "bijou": "build",
  "bike": "build",
  "bikini": "build",
  "bilabial": "story",
  "bilberry": "heal",
  "bilby": "heal",
  "bile": "heal",
  "bilge": "build",
  "bilges": "build",
  "bilgewater": "story",
  "bilimbi": "heal",
  "bilingual": "beautiful",
  "bilingualism": "smart",
  "bilious": "beautiful",
  "bilirubin": "beautiful",
  "bilk": "sell",
  "bill": "story",
  "billboard": "build",
  "billet": "story",
  "billfish": "heal",
  "billfold": "build",
  "billhook": "build",
  "billing": "story",
  "billings": "story",
  "billingsgate": "story",
  "billion": "smart",
  "billionth": "smart",
  "billy": "build",
  "billy-ho": "smart",
  "billyo": "smart",
  "billyoh": "smart",
  "billystick": "build",
  "biloxi": "story",
  "bilsted": "heal",
  "biltong": "taste",
  "bimetal": "beautiful",
  "bimetallic": "beautiful",
  "bimetallism": "sell",
  "bimli": "heal",
  "bimodal": "beautiful",
  "bimonthly": "story",
  "bin": "build",
  "binary": "smart",
  "binaural": "beautiful",
  "bind": "smart",
  "binder": "build",
  "bindery": "build",
  "binding": "build",
  "bindweed": "heal",
  "bine": "heal",
  "binful": "smart",
  "binge": "taste",
  "binnacle": "build",
  "binoculars": "build",
  "binomial": "smart",
  "binturong": "heal",
  "binuclear": "beautiful",
  "binucleate": "beautiful",
  "binucleated": "beautiful",
  "bio-assay": "smart",
  "bioarm": "build",
  "bioassay": "smart",
  "biochemistry": "smart",
  "biochip": "build",
  "bioclimatology": "smart",
  "bioelectricity": "sound",
  "bioengineering": "smart",
  "bioethics": "smart",
  "biofeedback": "smart",
  "biogenesis": "smart",
  "biogenic": "beautiful",
  "biogeography": "smart",
  "biography": "story",
  "biological": "beautiful",
  "biology": "smart",
  "bioluminescence": "sound",
  "biomedical": "heal",
  "biomedicine": "heal",
  "biometrics": "smart",
  "biometry": "smart",
  "bionic": "beautiful",
  "bionics": "smart",
  "bionomics": "smart",
  "biophysics": "smart",
  "biopsy": "smart",
  "bioremediation": "smart",
  "bioscience": "smart",
  "bioscope": "build",
  "biostatistics": "smart",
  "biosynthesis": "smart",
  "biosystematics": "smart",
  "biosystematy": "smart",
  "biotech": "smart",
  "biotechnology": "smart",
  "biovular": "beautiful",
  "bioweapon": "build",
  "biped": "heal",
  "bipedal": "beautiful",
  "biplane": "build",
  "bipolar": "beautiful",
  "biprism": "build",
  "biquadrate": "smart",
  "biquadratic": "smart",
  "birch": "heal",
  "birchbark": "build",
  "bird": "heal",
  "bird-nest": "build",
  "bird-on-the-wing": "heal",
  "bird-scarer": "build",
  "birdbath": "build",
  "birdcage": "build",
  "birdcall": "story",
  "birdfeeder": "build",
  "birdhouse": "build",
  "birdie": "smart",
  "birdnest": "build",
  "birdnesting": "build",
  "birdseed": "taste",
  "birdsong": "story",
  "birefringence": "sound",
  "biretta": "build",
  "biriani": "taste",
  "biro": "build",
  "birr": "smart",
  "birretta": "build",
  "birth": "smart",
  "birthing": "smart",
  "birthright": "sell",
  "birthroot": "heal",
  "birthwort": "heal",
  "biryani": "taste",
  "biscuit": "taste",
  "biscutella": "heal",
  "bise": "sound",
  "bisect": "build",
  "bisexual": "beautiful",
  "bishop": "taste",
  "bismark": "taste",
  "bison": "heal",
  "bisque": "taste",
  "bister": "beautiful",
  "bistre": "beautiful",
  "bistro": "taste",
  "bit": "smart",
  "bitch": "story",
  "bite": "taste",
  "biteplate": "build",
  "bitewing": "build",
  "bitis": "heal",
  "bitmap": "build",
  "bitok": "taste",
  "bitstock": "build",
  "bitt": "build",
  "bittacidae": "heal",
  "bitter": "taste",
  "bitter-bark": "heal",
  "bittercress": "heal",
  "bittern": "heal",
  "bitterness": "smart",
  "bitternut": "heal",
  "bitterroot": "heal",
  "bitters": "taste",
  "bittersweet": "heal",
  "bitterweed": "heal",
  "bitterwood": "heal",
  "bitthead": "build",
  "bitumastic": "build",
  "biu-mandara": "story",
  "bivalent": "beautiful",
  "bivalve": "heal",
  "bivalved": "beautiful",
  "bivalvia": "heal",
  "bivouac": "build",
  "biweekly": "story",
  "bize": "sound",
  "blab": "story",
  "blabber": "story",
  "blaberus": "heal",
  "black-and-white": "beautiful",
  "blackball": "sell",
  "blackbeetle": "heal",
  "blackberry": "taste",
  "blackberry-lily": "heal",
  "blackbird": "heal",
  "blackboard": "build",
  "blackbuck": "heal",
  "blackburn": "heal",
  "blackcap": "heal",
  "blackcock": "heal",
  "blackface": "build",
  "blackfish": "heal",
  "blackfly": "heal",
  "blackfoot": "story",
  "blackguard": "story",
  "blackhead": "heal",
  "blackheart": "taste",
  "blackjack": "heal",
  "blacklead": "build",
  "blackleg": "sell",
  "blacklist": "story",
  "blackmail": "sell",
  "blackout": "smart",
  "blackpoll": "heal",
  "blackseed": "heal",
  "blacksnake": "heal",
  "blacktail": "heal",
  "blackthorn": "heal",
  "blacktop": "build",
  "blackwash": "story",
  "blackwood": "heal",
  "bladder": "heal",
  "bladdernose": "heal",
  "bladderpod": "heal",
  "bladderwort": "heal",
  "bladderwrack": "heal",
  "blade": "heal",
  "bladed": "beautiful",
  "blaeberry": "heal",
  "blah": "story",
  "blahs": "story",
  "blame": "story",
  "blanc": "taste",
  "blanch": "heal",
  "blancmange": "taste",
  "blandfordia": "heal",
  "blandish": "story",
  "blandishment": "story",
  "blank": "story",
  "blanket": "build",
  "blanquillo": "heal",
  "blare": "sound",
  "blarina": "heal",
  "blaring": "sound",
  "blarney": "story",
  "blaspheme": "story",
  "blasphemy": "story",
  "blast": "sound",
  "blastema": "heal",
  "blastocele": "heal",
  "blastocladia": "heal",
  "blastocladiales": "heal",
  "blastocoel": "heal",
  "blastocoele": "heal",
  "blastocyst": "heal",
  "blastocyte": "heal",
  "blastoderm": "heal",
  "blastodiaceae": "heal",
  "blastodisc": "heal",
  "blastogenesis": "smart",
  "blastomere": "heal",
  "blastomyces": "heal",
  "blastomycete": "heal",
  "blastopore": "heal",
  "blastosphere": "heal",
  "blastula": "heal",
  "blat": "story",
  "blate": "story",
  "blather": "story",
  "blatherskite": "story",
  "blatta": "heal",
  "blattaria": "heal",
  "blattella": "heal",
  "blattidae": "heal",
  "blattodea": "heal",
  "blaze": "smart",
  "blazer": "build",
  "blazing": "smart",
  "blazon": "build",
  "blazonry": "build",
  "bleachers": "build",
  "blear": "beautiful",
  "bleat": "story",
  "bleb": "heal",
  "blechnaceae": "heal",
  "blechnum": "heal",
  "bleed": "heal",
  "bleeding": "heal",
  "bleep": "sound",
  "blemish": "build",
  "blemished": "build",
  "blench": "heal",
  "blend": "story",
  "blended": "build",
  "blender": "build",
  "blending": "build",
  "blenniidae": "heal",
  "blennioid": "heal",
  "blennioidea": "heal",
  "blennius": "heal",
  "blenny": "heal",
  "blephilia": "heal",
  "bless": "story",
  "blessed": "story",
  "blessing": "story",
  "blest": "story",
  "blether": "story",
  "bletia": "heal",
  "bletilla": "heal",
  "bleu": "taste",
  "blewits": "heal",
  "blighia": "heal",
  "blimp": "build",
  "blind": "build",
  "blinder": "build",
  "blindfold": "build",
  "blindside": "sell",
  "blindworm": "heal",
  "bling": "build",
  "blini": "taste",
  "blink": "heal",
  "blinker": "build",
  "blinking": "heal",
  "blinks": "heal",
  "blintz": "taste",
  "blintze": "taste",
  "bliny": "taste",
  "blip": "story",
  "blissus": "heal",
  "blister": "heal",
  "blistering": "smart",
  "blither": "story",
  "blitt": "story",
  "blizzard": "sound",
  "bloater": "taste",
  "blob": "build",
  "blocadren": "build",
  "block": "build",
  "blockade": "build",
  "blockade-runner": "build",
  "blockage": "build",
  "blockbuster": "build",
  "blocker": "build",
  "blockhouse": "build",
  "blocking": "build",
  "blog": "story",
  "blolly": "heal",
  "blond": "beautiful",
  "blonde": "beautiful",
  "blood": "heal",
  "blood-twig": "heal",
  "bloodberry": "heal",
  "bloodhound": "heal",
  "bloodleaf": "heal",
  "bloodless": "beautiful",
  "bloodmobile": "build",
  "bloodroot": "heal",
  "bloodstream": "heal",
  "bloodsucker": "heal",
  "bloodworm": "heal",
  "bloodwort": "heal",
  "bloody": "beautiful",
  "bloom": "smart",
  "bloomer": "heal",
  "bloomeria": "heal",
  "bloomers": "build",
  "blooming": "smart",
  "blossom": "heal",
  "blossoming": "smart",
  "blot": "build",
  "blotch": "build",
  "blotter": "story",
  "blouse": "build",
  "bloviate": "story",
  "blowback": "story",
  "blowball": "heal",
  "blower": "build",
  "blowfish": "taste",
  "blowfly": "heal",
  "blowgun": "build",
  "blowhole": "heal",
  "blowing": "smart",
  "blowlamp": "build",
  "blowpipe": "build",
  "blowtorch": "build",
  "blowtube": "build",
  "blowup": "story",
  "blt": "taste",
  "blu-82": "build",
  "blub": "heal",
  "blubber": "heal",
  "blucher": "build",
  "bludgeon": "build",
  "blue": "build",
  "blue-belly": "heal",
  "blue-collar": "beautiful",
  "bluebell": "heal",
  "blueberry": "heal",
  "bluebill": "heal",
  "bluebird": "heal",
  "bluebonnet": "heal",
  "bluebottle": "heal",
  "bluefin": "taste",
  "bluefish": "heal",
  "bluegill": "heal",
  "bluegrass": "heal",
  "bluehead": "heal",
  "blueing": "smart",
  "blueness": "beautiful",
  "bluepoint": "taste",
  "blueprint": "smart",
  "blues": "sound",
  "bluestem": "heal",
  "bluethroat": "heal",
  "bluetick": "heal",
  "blueweed": "heal",
  "bluewing": "heal",
  "bluff": "story",
  "bluffer": "beautiful",
  "bluing": "smart",
  "blunder": "sell",
  "blunderbuss": "build",
  "blunt": "sound",
  "blur": "smart",
  "blurb": "story",
  "blurt": "story",
  "blush": "heal",
  "blusher": "heal",
  "bluster": "story",
  "bmi": "story",
  "bmr": "smart",
  "bmus": "story",
  "bns": "story",
  "boa": "build",
  "boar": "heal",
  "board": "sell",
  "boarding": "build",
  "boardinghouse": "build",
  "boardroom": "build",
  "boards": "build",
  "boardwalk": "build",
  "boarfish": "heal",
  "boarhound": "heal",
  "boast": "story",
  "boasting": "story",
  "boat": "build",
  "boatbill": "heal",
  "boater": "build",
  "boathouse": "build",
  "boatload": "smart",
  "boatmanship": "smart",
  "boatyard": "build",
  "bob": "smart",
  "bobber": "build",
  "bobbin": "build",
  "bobble": "sell",
  "bobbysock": "build",
  "bobbysocks": "build",
  "bobcat": "heal",
  "bobfloat": "build",
  "bobolink": "heal",
  "bobsled": "build",
  "bobsleigh": "build",
  "bobtail": "heal",
  "bobwhite": "heal",
  "bocconia": "heal",
  "bock": "taste",
  "bod": "heal",
  "bode": "story",
  "bodega": "build",
  "bodge": "sell",
  "bodice": "build",
  "bodied": "beautiful",
  "bodily": "beautiful",
  "boding": "story",
  "bodkin": "build",
  "bodo-garo": "story",
  "bodoni": "story",
  "body": "heal",
  "bodypaint": "build",
  "bodywork": "build",
  "boehmenism": "smart",
  "boehmeria": "heal",
  "boeuf": "taste",
  "bogbean": "heal",
  "bogey": "smart",
  "boggle": "smart",
  "bogie": "build",
  "bogmat": "heal",
  "bogy": "build",
  "boidae": "heal",
  "boiler": "build",
  "boilerplate": "story",
  "boilersuit": "build",
  "boiling": "taste",
  "bokkos": "story",
  "bokmaal": "story",
  "bokmal": "story",
  "bola": "build",
  "bolanci": "story",
  "bolbitis": "heal",
  "bold": "story",
  "boldface": "story",
  "bole": "heal",
  "bolero": "story",
  "boletaceae": "heal",
  "bolete": "heal",
  "boletellus": "heal",
  "boletus": "heal",
  "bolide": "sound",
  "bolivar": "smart",
  "boliviano": "smart",
  "boll": "heal",
  "bollard": "build",
  "bollix": "sell",
  "bollock": "heal",
  "bollocks": "heal",
  "bollworm": "heal",
  "bolo": "build",
  "bologna": "taste",
  "bologram": "build",
  "bolograph": "build",
  "bolometer": "build",
  "boloney": "story",
  "bolshy": "beautiful",
  "bolster": "build",
  "bolt": "build",
  "bolti": "heal",
  "boltonia": "heal",
  "bolus": "build",
  "bomarea": "heal",
  "bomb": "build",
  "bombacaceae": "heal",
  "bombard": "build",
  "bombardment": "story",
  "bombardon": "build",
  "bombast": "story",
  "bombax": "heal",
  "bombazine": "build",
  "bomber": "build",
  "bombie": "build",
  "bombilate": "sound",
  "bombina": "heal",
  "bombinate": "sound",
  "bombing": "sell",
  "bomblet": "build",
  "bombproof": "build",
  "bombshell": "build",
  "bombsight": "build",
  "bombus": "heal",
  "bombycid": "heal",
  "bombycidae": "heal",
  "bombycilla": "heal",
  "bombycillidae": "heal",
  "bombyliidae": "heal",
  "bombyx": "heal",
  "bonasa": "heal",
  "bonavist": "heal",
  "bonbon": "taste",
  "bonce": "heal",
  "bond": "sell",
  "bonderise": "build",
  "bonderize": "build",
  "bonding": "smart",
  "bonduc": "heal",
  "bone": "heal",
  "bonefish": "heal",
  "boneless": "beautiful",
  "bonelet": "heal",
  "bones": "build",
  "boneset": "heal",
  "boneshaker": "build",
  "boney": "beautiful",
  "bong": "sound",
  "bongo": "build",
  "bonito": "taste",
  "bonk": "build",
  "bonnet": "build",
  "bonnethead": "heal",
  "bonobo": "heal",
  "bonsai": "heal",
  "bonus": "smart",
  "bonxie": "heal",
  "bony": "beautiful",
  "boo": "story",
  "boob": "heal",
  "booby": "heal",
  "boodle": "sell",
  "booger": "heal",
  "boogie": "story",
  "boogie-woogie": "story",
  "book": "story",
  "bookbindery": "build",
  "bookcase": "build",
  "bookend": "build",
  "booking": "smart",
  "booklet": "story",
  "booklouse": "heal",
  "bookmark": "build",
  "bookmarker": "build",
  "bookmobile": "build",
  "bookplate": "story",
  "bookshelf": "build",
  "bookshop": "build",
  "bookstall": "build",
  "bookstore": "build",
  "boom": "build",
  "boomerang": "build",
  "boon": "beautiful",
  "boondoggle": "sell",
  "booster": "build",
  "boot": "build",
  "bootee": "build",
  "bootes": "build",
  "booth": "build",
  "boothose": "build",
  "bootie": "build",
  "bootjack": "build",
  "bootlace": "build",
  "bootleg": "taste",
  "bootlegging": "sell",
  "bootlick": "story",
  "bootstrap": "smart",
  "booty": "sell",
  "booyong": "heal",
  "booze": "taste",
  "boozing": "taste",
  "bop": "story",
  "borage": "heal",
  "boraginaceae": "heal",
  "borago": "heal",
  "borassus": "heal",
  "bordeaux": "taste",
  "bordelaise": "taste",
  "bordello": "build",
  "border": "build",
  "bordered": "build",
  "borderline": "beautiful",
  "bore": "build",
  "bore-hole": "build",
  "boreal": "beautiful",
  "boreas": "sound",
  "borecole": "heal",
  "borer": "build",
  "boring": "build",
  "born": "heal",
  "borrelia": "heal",
  "borrow": "sell",
  "borrowing": "sell",
  "borsch": "taste",
  "borscht": "taste",
  "borsh": "taste",
  "borshch": "taste",
  "borsht": "taste",
  "borstal": "build",
  "bortsch": "taste",
  "borzoi": "heal",
  "bos": "heal",
  "bosc": "taste",
  "boselaphus": "heal",
  "bosh": "story",
  "bosom": "heal",
  "boswellia": "heal",
  "bot": "heal",
  "bota": "build",
  "botanical": "build",
  "botanise": "smart",
  "botanize": "smart",
  "botany": "smart",
  "botaurus": "heal",
  "botch": "sell",
  "botfly": "heal",
  "bother": "smart",
  "botheration": "smart",
  "bothidae": "heal",
  "bothrops": "heal",
  "botox": "sound",
  "botrychium": "heal",
  "bottle": "build",
  "bottle-fed": "beautiful",
  "bottle-grass": "heal",
  "bottle-tree": "heal",
  "bottlebrush": "build",
  "bottlecap": "build",
  "bottlefeed": "taste",
  "bottleful": "smart",
  "bottleneck": "build",
  "bottlenose": "heal",
  "bottom": "heal",
  "bottom-dweller": "heal",
  "bottom-feeder": "heal",
  "bottom-up": "beautiful",
  "bottomed": "sell",
  "bottomless": "beautiful",
  "botulinum": "heal",
  "botulinus": "heal",
  "bouchee": "taste",
  "boucle": "build",
  "boudoir": "build",
  "bouffant": "heal",
  "bouffe": "story",
  "bougainvillaea": "heal",
  "bougainvillea": "heal",
  "bough": "heal",
  "bouillabaisse": "taste",
  "bouillon": "taste",
  "boule": "build",
  "boulevard": "build",
  "boulle": "build",
  "bouncing": "build",
  "bounty": "sell",
  "bouquet": "beautiful",
  "bourbon": "taste",
  "bourdon": "build",
  "bourgeois": "beautiful",
  "bourguignon": "taste",
  "bourn": "smart",
  "bourne": "smart",
  "bourse": "build",
  "bourtree": "heal",
  "bouse": "build",
  "boustrophedon": "story",
  "bouteloua": "heal",
  "boutique": "beautiful",
  "boutonniere": "build",
  "bouyei": "story",
  "bovid": "heal",
  "bovidae": "heal",
  "bovinae": "heal",
  "bovine": "heal",
  "bovini": "heal",
  "bovril": "taste",
  "bow": "build",
  "bow-tie": "build",
  "bow-wow": "heal",
  "bowed": "story",
  "bowel": "heal",
  "bowels": "heal",
  "bower": "build",
  "bowerbird": "heal",
  "bowery": "beautiful",
  "bowfin": "heal",
  "bowhead": "heal",
  "bowiea": "heal",
  "bowing": "story",
  "bowknot": "build",
  "bowl": "taste",
  "bowleg": "heal",
  "bowler": "build",
  "bowlful": "smart",
  "bowline": "build",
  "bowls": "build",
  "bowse": "build",
  "bowsprit": "build",
  "bowstring": "build",
  "bowtie": "build",
  "box": "build",
  "boxberry": "heal",
  "boxcar": "build",
  "boxcars": "smart",
  "boxer": "heal",
  "boxers": "build",
  "boxershorts": "build",
  "boxfish": "heal",
  "boxful": "smart",
  "boxing": "build",
  "boxthorn": "heal",
  "boxwood": "heal",
  "boycott": "sell",
  "boykinia": "heal",
  "boys-and-girls": "heal",
  "boysenberry": "heal",
  "bra": "build",
  "brabble": "story",
  "brace": "build",
  "bracelet": "beautiful",
  "bracer": "build",
  "braces": "build",
  "brachiate": "beautiful",
  "brachinus": "heal",
  "brachiopod": "heal",
  "brachiopoda": "heal",
  "brachycephalic": "beautiful",
  "brachychiton": "heal",
  "brachycome": "heal",
  "brachycranial": "beautiful",
  "brachycranic": "beautiful",
  "brachystegia": "heal",
  "brachyura": "heal",
  "brachyuran": "heal",
  "bracing": "build",
  "bracken": "heal",
  "bracket": "build",
  "bract": "heal",
  "bracteole": "heal",
  "bractlet": "heal",
  "brad": "build",
  "bradawl": "build",
  "bradypodidae": "heal",
  "bradypus": "heal",
  "brag": "story",
  "braggadocio": "story",
  "braggart": "beautiful",
  "bragging": "story",
  "brahma": "heal",
  "brahman": "heal",
  "brahmana": "story",
  "brahmanism": "smart",
  "brahmi": "story",
  "brahmin": "heal",
  "brahminism": "smart",
  "brahms": "story",
  "brahui": "story",
  "braid": "heal",
  "braiding": "build",
  "brail": "build",
  "braille": "story",
  "brain": "heal",
  "brain-stem": "heal",
  "brain-teaser": "story",
  "braincase": "heal",
  "brainchild": "build",
  "brainpan": "heal",
  "brainpower": "smart",
  "brainstem": "heal",
  "brainstorm": "smart",
  "brainstorming": "smart",
  "brainwash": "story",
  "brainwashed": "story",
  "brainwashing": "story",
  "brainwave": "sound",
  "brake": "build",
  "brakes": "build",
  "brama": "heal",
  "bramble": "heal",
  "brambling": "heal",
  "bramidae": "heal",
  "bran": "taste",
  "branch": "heal",
  "branchia": "heal",
  "branchiate": "beautiful",
  "branching": "beautiful",
  "branchiobdella": "heal",
  "branchiobdellidae": "heal",
  "branchiopod": "heal",
  "branchiopoda": "heal",
  "branchiopodan": "heal",
  "branchiostegidae": "heal",
  "branchiostomidae": "heal",
  "branchiura": "heal",
  "branchless": "beautiful",
  "branchlet": "heal",
  "branchy": "beautiful",
  "brand": "sell",
  "branded": "sell",
  "branding": "sell",
  "brandish": "story",
  "brandmark": "build",
  "brandy": "taste",
  "brandyball": "taste",
  "brandysnap": "taste",
  "brant": "heal",
  "branta": "heal",
  "brasenia": "heal",
  "brasier": "build",
  "brass": "build",
  "brassard": "build",
  "brassavola": "heal",
  "brasserie": "build",
  "brassia": "heal",
  "brassica": "heal",
  "brassicaceae": "heal",
  "brassie": "build",
  "brassiere": "build",
  "brassy": "beautiful",
  "brat": "taste",
  "brattice": "build",
  "brattle": "sound",
  "bratwurst": "taste",
  "bravado": "story",
  "brave": "beautiful",
  "bravo": "story",
  "bravura": "smart",
  "brawl": "story",
  "bray": "story",
  "braze": "build",
  "brazen": "story",
  "brazier": "build",
  "brazil": "taste",
  "brazilwood": "heal",
  "breach": "sell",
  "bread": "taste",
  "bread-bin": "build",
  "bread-stick": "taste",
  "breadbasket": "heal",
  "breadboard": "smart",
  "breadbox": "build",
  "breadcrumb": "taste",
  "breadfruit": "heal",
  "breadroot": "heal",
  "breadstick": "taste",
  "breadstuff": "taste",
  "breadth": "smart",
  "break-axe": "heal",
  "breakable": "build",
  "breakage": "smart",
  "breakaway": "beautiful",
  "breakax": "heal",
  "breakaxe": "heal",
  "breakdown": "smart",
  "breaker": "build",
  "breakers": "build",
  "breakfast": "taste",
  "breakstone": "heal",
  "breakthrough": "smart",
  "breakwater": "build",
  "bream": "taste",
  "breast": "heal",
  "breast-fed": "beautiful",
  "breastbone": "heal",
  "breasted": "beautiful",
  "breastfeed": "taste",
  "breastless": "beautiful",
  "breastpin": "build",
  "breastplate": "build",
  "breastwork": "build",
  "breath": "story",
  "breathalyse": "sell",
  "breathalyser": "build",
  "breathalyze": "sell",
  "breathalyzer": "build",
  "breathe": "heal",
  "breather": "build",
  "breathing": "heal",
  "breathless": "beautiful",
  "brecciate": "build",
  "breech": "build",
  "breechblock": "build",
  "breechcloth": "build",
  "breechclout": "build",
  "breeches": "build",
  "breechloader": "build",
  "breed": "smart",
  "breeze": "sound",
  "bregma": "heal",
  "bren": "build",
  "brent": "heal",
  "breton": "story",
  "breve": "story",
  "brevet": "story",
  "breviary": "story",
  "brevibloc": "build",
  "brevicipitidae": "heal",
  "brevity": "story",
  "brevoortia": "heal",
  "brew": "taste",
  "brewage": "taste",
  "brewery": "build",
  "brewing": "taste",
  "brewpub": "build",
  "briar": "heal",
  "briard": "heal",
  "briarroot": "heal",
  "briarwood": "heal",
  "bribe": "sell",
  "bric-a-brac": "build",
  "brick": "build",
  "brickbat": "story",
  "brickellia": "heal",
  "brickfield": "build",
  "brickkiln": "build",
  "brickwork": "build",
  "brickyard": "build",
  "bricole": "build",
  "bridal-wreath": "heal",
  "bride-gift": "sell",
  "bridecake": "taste",
  "bridge": "build",
  "bridgeable": "beautiful",
  "bridged-t": "build",
  "bridges": "build",
  "bridgework": "build",
  "bridle": "build",
  "bridoon": "build",
  "brie": "taste",
  "brief": "story",
  "briefcase": "build",
  "briefing": "story",
  "briefness": "sound",
  "briefs": "build",
  "brier": "heal",
  "brier-wood": "heal",
  "brierpatch": "heal",
  "brierwood": "heal",
  "brig": "build",
  "brigandine": "build",
  "brigantine": "build",
  "bright": "beautiful",
  "brightness": "beautiful",
  "brill": "heal",
  "brilliance": "smart",
  "brilliantine": "build",
  "brim": "build",
  "brine": "taste",
  "bring": "build",
  "bringing": "build",
  "brinjal": "heal",
  "brinkmanship": "story",
  "briny": "beautiful",
  "brioche": "taste",
  "briony": "heal",
  "briquet": "build",
  "briquette": "build",
  "brisance": "sound",
  "brisk": "beautiful",
  "brisket": "taste",
  "brisling": "taste",
  "bristle": "build",
  "bristlegrass": "heal",
  "bristletail": "heal",
  "brit": "heal",
  "britches": "build",
  "briticism": "story",
  "britishism": "story",
  "brits": "heal",
  "britt": "heal",
  "brittanic": "story",
  "brittle": "taste",
  "brittle-star": "heal",
  "brittlebush": "heal",
  "broach": "build",
  "broad": "beautiful",
  "broad-bean": "heal",
  "broad-minded": "beautiful",
  "broad-mindedness": "smart",
  "broadax": "build",
  "broadaxe": "build",
  "broadbill": "heal",
  "broadcast": "story",
  "broadcaster": "build",
  "broadcasting": "story",
  "broadcloth": "build",
  "broadening": "smart",
  "broadloom": "build",
  "broadnosed": "beautiful",
  "broadsheet": "story",
  "broadside": "story",
  "broadsword": "build",
  "broadtail": "heal",
  "brobdingnag": "smart",
  "brobdingnagian": "beautiful",
  "brocade": "build",
  "broccoli": "heal",
  "brochette": "build",
  "brochure": "story",
  "brocket": "heal",
  "brodiaea": "heal",
  "brogan": "build",
  "brogue": "build",
  "broider": "build",
  "broiler": "build",
  "broken": "build",
  "broker": "sell",
  "brokerage": "build",
  "brolly": "build",
  "brome": "heal",
  "bromegrass": "heal",
  "bromelia": "heal",
  "bromeliaceae": "heal",
  "bromide": "story",
  "bromidic": "sound",
  "bromus": "heal",
  "bronc": "heal",
  "bronchiole": "heal",
  "broncho": "heal",
  "bronchodilator": "build",
  "bronchoscope": "build",
  "bronchus": "heal",
  "bronco": "heal",
  "brontosaur": "heal",
  "brontosaurus": "heal",
  "bronze": "build",
  "brooch": "beautiful",
  "brood": "smart",
  "brooder": "build",
  "brooding": "smart",
  "broodmare": "heal",
  "broody": "heal",
  "brook": "smart",
  "brooklime": "heal",
  "brooks": "smart",
  "brookweed": "heal",
  "broom": "build",
  "broom-weed": "heal",
  "broomcorn": "heal",
  "broomstick": "build",
  "broomweed": "heal",
  "brosmius": "heal",
  "broth": "taste",
  "brothel": "build",
  "brotherlike": "beautiful",
  "brotherly": "beautiful",
  "brotula": "heal",
  "brotulidae": "heal",
  "brougham": "build",
  "broussonetia": "heal",
  "brow": "heal",
  "browallia": "heal",
  "browbeat": "story",
  "brown": "build",
  "brown-nose": "story",
  "brownie": "taste",
  "brownstone": "build",
  "browntail": "heal",
  "browse": "story",
  "browser": "smart",
  "browsing": "story",
  "brucella": "heal",
  "bruchidae": "heal",
  "bruchus": "heal",
  "bruckenthalia": "heal",
  "brugmansia": "heal",
  "bruin": "heal",
  "bruise": "build",
  "bruit": "story",
  "brummagem": "beautiful",
  "brunch": "taste",
  "brunet": "beautiful",
  "brunette": "beautiful",
  "brunfelsia": "heal",
  "brush": "beautiful",
  "brushing": "build",
  "brushwork": "smart",
  "brutalise": "sell",
  "brutalize": "sell",
  "brute": "beautiful",
  "brya": "heal",
  "bryaceae": "heal",
  "bryales": "heal",
  "bryanthus": "heal",
  "bryony": "heal",
  "bryophyta": "heal",
  "bryophyte": "heal",
  "bryopsida": "heal",
  "bryozoa": "heal",
  "bryozoan": "heal",
  "brythonic": "story",
  "bryum": "heal",
  "bsarch": "story",
  "btu": "smart",
  "bubalus": "heal",
  "bubble": "smart",
  "bubblejet": "build",
  "bubbler": "build",
  "bubbly": "taste",
  "bubo": "heal",
  "bubulcus": "heal",
  "buccal": "beautiful",
  "buccinidae": "heal",
  "bucconidae": "heal",
  "buccula": "heal",
  "bucephala": "heal",
  "buceros": "heal",
  "bucerotidae": "heal",
  "buchenwald": "build",
  "buchloe": "heal",
  "buchner": "taste",
  "buck": "build",
  "buckbean": "heal",
  "buckboard": "build",
  "bucket": "build",
  "bucketful": "smart",
  "buckeye": "heal",
  "buckle": "build",
  "buckler": "build",
  "buckleya": "heal",
  "buckram": "build",
  "bucksaw": "build",
  "buckshot": "build",
  "buckskin": "heal",
  "buckskins": "build",
  "buckthorn": "heal",
  "bucktooth": "heal",
  "buckwheat": "heal",
  "bucolic": "story",
  "bud": "heal",
  "buddhism": "smart",
  "budding": "smart",
  "buddleia": "heal",
  "budgereegah": "heal",
  "budgerigar": "heal",
  "budgerygah": "heal",
  "budget": "sell",
  "budgie": "heal",
  "budorcas": "heal",
  "buff": "heal",
  "buffalo": "heal",
  "buffalofish": "taste",
  "buffer": "build",
  "bufferin": "build",
  "buffet": "taste",
  "buffeting": "build",
  "bufflehead": "heal",
  "bufo": "heal",
  "bufonidae": "heal",
  "bug": "heal",
  "bugaboo": "smart",
  "bugbane": "heal",
  "bugbear": "smart",
  "bugger": "sell",
  "buggy": "build",
  "bugle": "build",
  "bugleweed": "heal",
  "bugloss": "heal",
  "bugology": "smart",
  "buhl": "build",
  "build": "build",
  "building": "build",
  "buildup": "smart",
  "bulb": "heal",
  "bulbil": "heal",
  "bulblet": "heal",
  "bulbul": "heal",
  "bulgarian": "story",
  "bulghur": "taste",
  "bulgur": "taste",
  "bulimia": "heal",
  "bulkhead": "build",
  "bull": "heal",
  "bull's-eye": "build",
  "bull-snake": "heal",
  "bulla": "heal",
  "bullace": "heal",
  "bullbat": "heal",
  "bullbrier": "heal",
  "bulldog": "heal",
  "bulldoze": "build",
  "bulldozer": "build",
  "bullet": "build",
  "bullethead": "heal",
  "bulletin": "story",
  "bulletproof": "beautiful",
  "bullfight": "build",
  "bullfinch": "heal",
  "bullfrog": "heal",
  "bullhead": "heal",
  "bullhorn": "build",
  "bullion": "sell",
  "bullnose": "build",
  "bullock": "heal",
  "bullpen": "build",
  "bullring": "build",
  "bullrush": "heal",
  "bullshit": "story",
  "bullshot": "taste",
  "bullterrier": "heal",
  "bully": "story",
  "bullying": "story",
  "bulnesia": "heal",
  "bulrush": "heal",
  "bulwark": "build",
  "bum": "heal",
  "bumble": "sell",
  "bumblebee": "heal",
  "bumboat": "build",
  "bumelia": "heal",
  "bumf": "story",
  "bump": "build",
  "bumper": "build",
  "bumph": "story",
  "bumpy": "beautiful",
  "bun": "taste",
  "bunchberry": "heal",
  "bunchgrass": "heal",
  "bunco": "sell",
  "buncombe": "story",
  "bundle": "build",
  "bundling": "story",
  "bung": "build",
  "bungalow": "build",
  "bungarus": "heal",
  "bungee": "build",
  "bunghole": "heal",
  "bungle": "sell",
  "bunji-bunji": "heal",
  "bunk": "build",
  "bunker": "build",
  "bunkum": "story",
  "bunny": "heal",
  "buns": "heal",
  "bunsen": "build",
  "bunt": "heal",
  "bunting": "build",
  "bunyaviridae": "heal",
  "bunyavirus": "heal",
  "buoy": "story",
  "buphthalmum": "heal",
  "bur": "heal",
  "bura": "story",
  "burberry": "build",
  "burble": "sound",
  "burbot": "heal",
  "burden": "smart",
  "burdened": "build",
  "burdock": "heal",
  "bureau": "build",
  "buret": "build",
  "burette": "build",
  "burger": "taste",
  "burglarise": "sell",
  "burglarize": "sell",
  "burgle": "sell",
  "burgoo": "taste",
  "burgrass": "heal",
  "burgundy": "taste",
  "burhinidae": "heal",
  "burhinus": "heal",
  "buried": "sound",
  "burin": "build",
  "burka": "build",
  "burke": "sell",
  "burl": "heal",
  "burlap": "build",
  "burlesque": "story",
  "burmannia": "heal",
  "burmanniaceae": "heal",
  "burmeisteria": "heal",
  "burmese": "story",
  "burmese-yi": "story",
  "burner": "build",
  "burning": "smart",
  "burnish": "build",
  "burnoose": "build",
  "burnous": "build",
  "burnouse": "build",
  "burnside": "heal",
  "burp": "heal",
  "burping": "heal",
  "burqa": "build",
  "burr": "heal",
  "burrawong": "heal",
  "burrfish": "heal",
  "burrito": "taste",
  "burro": "heal",
  "bursa": "heal",
  "bursary": "sell",
  "bursera": "heal",
  "burseraceae": "heal",
  "burster": "build",
  "burt": "build",
  "burthen": "build",
  "burton": "taste",
  "burunduki": "heal",
  "bury": "sound",
  "burying": "sound",
  "bus": "build",
  "busbar": "build",
  "busby": "build",
  "bush": "heal",
  "bushbaby": "heal",
  "bushbuck": "heal",
  "bushel": "smart",
  "bushido": "story",
  "bushing": "build",
  "bushtit": "heal",
  "business": "sell",
  "busk": "build",
  "buskin": "build",
  "busload": "smart",
  "buspar": "build",
  "buspirone": "build",
  "buss": "build",
  "bust": "heal",
  "bust-up": "story",
  "bustard": "heal",
  "bustier": "build",
  "bustle": "build",
  "busy": "sell",
  "butacaine": "build",
  "butat": "smart",
  "butazolidin": "build",
  "butch": "beautiful",
  "butcherbird": "heal",
  "butchering": "build",
  "butchery": "build",
  "butea": "heal",
  "buteo": "heal",
  "buteonine": "heal",
  "butt": "build",
  "butt-weld": "build",
  "butt-welding": "build",
  "butter": "taste",
  "butter-and-eggs": "heal",
  "butter-flower": "heal",
  "butter-print": "heal",
  "butterball": "heal",
  "butterbean": "taste",
  "butterbur": "heal",
  "buttercrunch": "taste",
  "buttercup": "heal",
  "butterfish": "taste",
  "butterflower": "heal",
  "butterfly": "heal",
  "butterflyfish": "heal",
  "buttermilk": "taste",
  "butternut": "heal",
  "butterscotch": "taste",
  "butterweed": "heal",
  "butterwort": "heal",
  "buttery": "build",
  "buttock": "heal",
  "buttocks": "heal",
  "button": "build",
  "button-quail": "heal",
  "buttoned": "build",
  "buttonhole": "build",
  "buttonhook": "build",
  "buttonwood": "heal",
  "buttress": "build",
  "buttressing": "build",
  "buttweld": "build",
  "butty": "taste",
  "butut": "smart",
  "buxaceae": "heal",
  "buxus": "heal",
  "buy": "sell",
  "buyi": "story",
  "buying": "sell",
  "buzz": "sound",
  "buzzard": "heal",
  "buzzer": "build",
  "buzzword": "story",
  "bvd": "build",
  "bvd's": "build",
  "bwr": "build",
  "by-bid": "sell",
  "by-catch": "heal",
  "by-line": "story",
  "by-product": "sound",
  "bycatch": "heal",
  "bye": "story",
  "bye-bye": "story",
  "byelorussian": "story",
  "bygone": "beautiful",
  "bylaw": "story",
  "byname": "story",
  "bypass": "build",
  "bypath": "build",
  "byproduct": "sound",
  "byre": "build",
  "byrnie": "build",
  "byroad": "build",
  "byssus": "heal",
  "byte": "smart",
  "byway": "build",
  "byword": "story",
  "byzant": "sell",
  "byzantine": "beautiful",
  "byzantinism": "smart",
  "c-clamp": "build",
  "c-note": "sell",
  "c-ration": "taste",
  "c.p.u.": "build",
  "ca-ca": "heal",
  "caaba": "build",
  "cab": "build",
  "cabal": "smart",
  "cabala": "story",
  "cabalism": "smart",
  "cabana": "build",
  "cabaret": "build",
  "cabasset": "build",
  "cabassous": "heal",
  "cabbage": "taste",
  "cabbageworm": "heal",
  "cabbala": "story",
  "cabbalah": "story",
  "caber": "build",
  "cabernet": "taste",
  "cabin": "build",
  "cabinet": "build",
  "cabinetmaking": "build",
  "cabinetwork": "build",
  "cable": "story",
  "cablegram": "story",
  "cabomba": "heal",
  "cabombaceae": "heal",
  "caboose": "build",
  "cabriolet": "build",
  "cacajao": "heal",
  "cacalia": "heal",
  "cacao": "heal",
  "cacatua": "heal",
  "cachalot": "heal",
  "cache": "build",
  "cachet": "story",
  "cachinnate": "heal",
  "cachinnation": "story",
  "cachou": "taste",
  "cacicus": "heal",
  "cacique": "heal",
  "cackel": "story",
  "cackle": "story",
  "cackler": "heal",
  "cacogenics": "smart",
  "cacography": "story",
  "cacomistle": "heal",
  "cacomixle": "heal",
  "cacophonic": "beautiful",
  "cacophonous": "beautiful",
  "cactaceae": "heal",
  "cactus": "heal",
  "cad": "story",
  "cadaster": "story",
  "cadastre": "story",
  "cadaver": "heal",
  "cadaverous": "beautiful",
  "caddice-fly": "heal",
  "caddis-fly": "heal",
  "caddisworm": "heal",
  "caddo": "story",
  "caddoan": "story",
  "caddy": "build",
  "cadence": "sound",
  "cadency": "sound",
  "cadenza": "story",
  "cadge": "sell",
  "cadra": "heal",
  "caduceus": "story",
  "caducous": "beautiful",
  "caeciliadae": "heal",
  "caecilian": "heal",
  "caeciliidae": "heal",
  "caecum": "heal",
  "caenogenesis": "smart",
  "caenolestes": "heal",
  "caenolestidae": "heal",
  "caesalpinia": "heal",
  "caesalpiniaceae": "heal",
  "caesalpinioideae": "heal",
  "caesaropapism": "smart",
  "caesura": "story",
  "cafe": "taste",
  "cafeteria": "taste",
  "caff": "build",
  "caftan": "build",
  "cage": "build",
  "cagoule": "build",
  "cahita": "story",
  "cahoot": "story",
  "caiman": "heal",
  "caimitillo": "heal",
  "caimito": "heal",
  "cainogenesis": "smart",
  "cairina": "heal",
  "cairn": "story",
  "caisson": "build",
  "caitiff": "beautiful",
  "cajanus": "heal",
  "cajole": "story",
  "cajolery": "story",
  "cakchiquel": "story",
  "cake": "taste",
  "cakehole": "heal",
  "cakile": "heal",
  "calaba": "heal",
  "calabash": "heal",
  "calabazilla": "heal",
  "calabura": "heal",
  "caladenia": "heal",
  "caladium": "heal",
  "calamagrostis": "heal",
  "calamari": "taste",
  "calamary": "taste",
  "calamint": "heal",
  "calamintha": "heal",
  "calamus": "heal",
  "calan": "build",
  "calandrinia": "heal",
  "calanthe": "heal",
  "calash": "build",
  "calcaneus": "heal",
  "calced": "beautiful",
  "calceolaria": "heal",
  "calceus": "build",
  "calcicolous": "beautiful",
  "calcification": "smart",
  "calcifugous": "beautiful",
  "calcimine": "build",
  "calcination": "smart",
  "calcitonin": "heal",
  "calculable": "beautiful",
  "calculate": "smart",
  "calculation": "smart",
  "calculator": "build",
  "calculus": "smart",
  "caldron": "build",
  "calean": "build",
  "caleche": "build",
  "calendar": "story",
  "calender": "build",
  "calendula": "heal",
  "calf": "heal",
  "calibrate": "build",
  "calibrated": "build",
  "calico": "build",
  "caliculus": "heal",
  "calidris": "heal",
  "caliper": "build",
  "calisaya": "heal",
  "calk": "build",
  "calkin": "build",
  "call": "story",
  "call-back": "story",
  "call-board": "build",
  "call-in": "story",
  "call-out": "story",
  "calla": "heal",
  "callas": "heal",
  "callathump": "story",
  "callback": "story",
  "calliandra": "heal",
  "callicebus": "heal",
  "calligraph": "beautiful",
  "calligrapher": "beautiful",
  "calligraphic": "beautiful",
  "calligraphical": "beautiful",
  "calligraphist": "beautiful",
  "calligraphy": "beautiful",
  "callimorpha": "heal",
  "callinectes": "heal",
  "calling": "story",
  "callionymidae": "heal",
  "calliope": "build",
  "calliophis": "heal",
  "calliopsis": "heal",
  "calliper": "build",
  "calliphora": "heal",
  "calliphoridae": "heal",
  "callirhoe": "heal",
  "callisaurus": "heal",
  "callistephus": "heal",
  "callithricidae": "heal",
  "callithrix": "heal",
  "callithump": "story",
  "callitrichaceae": "heal",
  "callitriche": "heal",
  "callitris": "heal",
  "callophis": "heal",
  "callorhinus": "heal",
  "callous": "beautiful",
  "calluna": "heal",
  "callus": "heal",
  "calm": "sound",
  "calocarpum": "heal",
  "calocedrus": "heal",
  "calochortus": "heal",
  "calophyllum": "heal",
  "calopogon": "heal",
  "calorie": "smart",
  "calorimeter": "build",
  "calosoma": "heal",
  "calostomataceae": "heal",
  "calpac": "build",
  "calpack": "build",
  "calque": "story",
  "caltha": "heal",
  "caltrop": "heal",
  "calumet": "build",
  "calumniate": "story",
  "calumniation": "story",
  "calumny": "story",
  "calvados": "taste",
  "calvaria": "heal",
  "calvatia": "heal",
  "calve": "build",
  "calving": "smart",
  "calvinism": "smart",
  "calycanthaceae": "heal",
  "calycanthus": "heal",
  "calycle": "heal",
  "calycophyllum": "heal",
  "calyculus": "heal",
  "calymmatobacterium": "heal",
  "calypso": "heal",
  "calypter": "heal",
  "calyptra": "heal",
  "calystegia": "heal",
  "calyx": "heal",
  "cam": "build",
  "camachile": "heal",
  "camail": "build",
  "camas": "heal",
  "camash": "heal",
  "camass": "heal",
  "camassia": "heal",
  "cambarus": "heal",
  "cambium": "heal",
  "cambric": "build",
  "cambridge": "build",
  "camcorder": "build",
  "camel": "heal",
  "camelhair": "build",
  "camelia": "heal",
  "camelidae": "heal",
  "camelina": "heal",
  "camellia": "heal",
  "camelopard": "heal",
  "camelus": "heal",
  "camembert": "taste",
  "cameo": "build",
  "camera": "build",
  "camion": "build",
  "camise": "build",
  "camisole": "build",
  "camlet": "build",
  "camo": "build",
  "camomile": "heal",
  "camosh": "heal",
  "camouflage": "build",
  "camp": "build",
  "campaign": "sell",
  "campaigning": "sell",
  "campanile": "build",
  "campanula": "heal",
  "campanulaceae": "heal",
  "campanulales": "heal",
  "campeachy": "heal",
  "campephilus": "heal",
  "camper": "build",
  "camphorated": "beautiful",
  "camphorweed": "heal",
  "camping": "build",
  "campion": "heal",
  "camponotus": "heal",
  "campstool": "build",
  "camptosorus": "heal",
  "campyloneurum": "heal",
  "campylorhynchus": "heal",
  "campylotropous": "beautiful",
  "camshaft": "build",
  "camwood": "heal",
  "can": "build",
  "canaanite": "story",
  "canaanitic": "story",
  "canachites": "heal",
  "canafistola": "heal",
  "canafistula": "heal",
  "canal": "heal",
  "canaliculus": "heal",
  "canalise": "sell",
  "canalize": "sell",
  "cananga": "heal",
  "canangium": "heal",
  "canape": "taste",
  "canard": "story",
  "canary": "heal",
  "canavalia": "heal",
  "cancel": "story",
  "cancellation": "story",
  "cancelled": "sell",
  "cancerweed": "heal",
  "cancridae": "heal",
  "candela": "smart",
  "candelabra": "build",
  "candelabrum": "build",
  "candelilla": "heal",
  "candida": "heal",
  "candle": "build",
  "candleberry": "heal",
  "candlelight": "sound",
  "candlenut": "heal",
  "candlepin": "build",
  "candlepins": "build",
  "candlesnuffer": "build",
  "candlestick": "build",
  "candlewick": "build",
  "candlewood": "heal",
  "candor": "smart",
  "candour": "smart",
  "candy": "taste",
  "candyfloss": "taste",
  "candytuft": "heal",
  "candyweed": "heal",
  "cane": "build",
  "canecutter": "heal",
  "canella": "heal",
  "canella-alba": "heal",
  "canellaceae": "heal",
  "canful": "smart",
  "cangue": "build",
  "canid": "heal",
  "canidae": "heal",
  "canine": "heal",
  "caning": "build",
  "canis": "heal",
  "canistel": "heal",
  "canister": "build",
  "canker": "smart",
  "cankerweed": "heal",
  "cankerworm": "heal",
  "canna": "heal",
  "cannabidaceae": "heal",
  "cannabis": "heal",
  "cannaceae": "heal",
  "cannelloni": "taste",
  "cannery": "build",
  "cannibalise": "taste",
  "cannibalize": "taste",
  "cannikin": "build",
  "cannister": "build",
  "cannon": "build",
  "cannonball": "build",
  "cannula": "build",
  "cannulate": "build",
  "cannulise": "build",
  "cannulize": "build",
  "canoe": "build",
  "canola": "taste",
  "canon": "story",
  "canonic": "beautiful",
  "canonical": "beautiful",
  "canonise": "story",
  "canonize": "story",
  "canoodle": "build",
  "canopy": "build",
  "cant": "story",
  "cantala": "heal",
  "cantaloup": "heal",
  "cantaloupe": "heal",
  "cantata": "story",
  "canteen": "build",
  "cantharellus": "heal",
  "canthus": "heal",
  "canticle": "story",
  "canticles": "story",
  "cantilever": "build",
  "cantillate": "story",
  "cantle": "build",
  "canto": "story",
  "canton": "sell",
  "cantonese": "story",
  "cantonment": "build",
  "canulate": "build",
  "canvas": "beautiful",
  "canvasback": "heal",
  "canvass": "smart",
  "canvassing": "story",
  "cap": "build",
  "capability": "smart",
  "capable": "beautiful",
  "capableness": "smart",
  "capaciousness": "smart",
  "capacitance": "sound",
  "capacitate": "story",
  "capacitor": "smart",
  "capacity": "smart",
  "caparison": "build",
  "cape": "build",
  "capelan": "heal",
  "capelin": "heal",
  "capella": "heal",
  "caper": "heal",
  "capercaillie": "heal",
  "capercailzie": "heal",
  "capeweed": "heal",
  "capful": "smart",
  "capibara": "heal",
  "capillarity": "sound",
  "capillary": "build",
  "capital": "sell",
  "capitalisation": "story",
  "capitalise": "sell",
  "capitalist": "beautiful",
  "capitalistic": "beautiful",
  "capitalization": "story",
  "capitalize": "sell",
  "capitate": "heal",
  "capitation": "sell",
  "capitol": "build",
  "capitonidae": "heal",
  "capitulation": "story",
  "capitulum": "heal",
  "capiz": "heal",
  "caplin": "heal",
  "capon": "taste",
  "caponise": "heal",
  "caponize": "heal",
  "capote": "build",
  "capoten": "build",
  "capparidaceae": "heal",
  "capparis": "heal",
  "cappelletti": "taste",
  "cappuccino": "taste",
  "capra": "heal",
  "caprella": "heal",
  "capreolus": "heal",
  "capriccio": "story",
  "capricornis": "heal",
  "caprifig": "heal",
  "caprifoliaceae": "heal",
  "caprimulgid": "heal",
  "caprimulgidae": "heal",
  "caprimulgiformes": "heal",
  "caprimulgus": "heal",
  "caproidae": "heal",
  "capromyidae": "heal",
  "capros": "heal",
  "capsella": "heal",
  "capsicum": "heal",
  "capsid": "heal",
  "capsidae": "heal",
  "capstan": "build",
  "capstone": "smart",
  "capsulate": "build",
  "capsule": "build",
  "capsulise": "build",
  "capsulize": "build",
  "caption": "story",
  "captive": "beautiful",
  "captopril": "build",
  "capture": "smart",
  "capuchin": "build",
  "capulin": "heal",
  "caput": "heal",
  "capybara": "heal",
  "car": "build",
  "car-ferry": "build",
  "carabao": "heal",
  "carabidae": "heal",
  "carabiner": "build",
  "caracal": "heal",
  "caracara": "heal",
  "carack": "build",
  "caracolito": "heal",
  "caracul": "heal",
  "carafate": "build",
  "carafe": "build",
  "caragana": "heal",
  "carageen": "heal",
  "carambola": "heal",
  "caramel": "taste",
  "carancha": "heal",
  "caranda": "heal",
  "caranday": "heal",
  "carangid": "heal",
  "carangidae": "heal",
  "caranx": "heal",
  "carapace": "heal",
  "carapidae": "heal",
  "carassius": "heal",
  "carat": "smart",
  "caravan": "build",
  "caravansary": "build",
  "caravanserai": "build",
  "caraway": "heal",
  "carbamide": "sound",
  "carbine": "build",
  "carbomycin": "build",
  "carbon": "build",
  "carbonado": "taste",
  "carbonara": "taste",
  "carbonation": "smart",
  "carbonisation": "smart",
  "carbonization": "smart",
  "carboy": "build",
  "carburet": "build",
  "carburetor": "build",
  "carburettor": "build",
  "carcajou": "heal",
  "carcase": "heal",
  "carcass": "heal",
  "carcharhinidae": "heal",
  "carcharhinus": "heal",
  "carcharias": "heal",
  "carchariidae": "heal",
  "carcharodon": "heal",
  "card": "build",
  "card-house": "build",
  "cardamine": "heal",
  "cardamom": "heal",
  "cardamon": "heal",
  "cardamum": "taste",
  "cardboard": "beautiful",
  "cardcase": "build",
  "cardcastle": "build",
  "cardhouse": "build",
  "cardia": "heal",
  "cardigan": "build",
  "cardiidae": "heal",
  "cardinal": "smart",
  "cardinalfish": "heal",
  "cardinality": "smart",
  "cardiogram": "story",
  "cardiograph": "build",
  "cardiography": "heal",
  "cardiologic": "heal",
  "cardiologist": "heal",
  "cardiology": "heal",
  "cardiospermum": "heal",
  "cardium": "heal",
  "cardizem": "build",
  "cardoon": "heal",
  "cardroom": "build",
  "cards": "build",
  "carduelinae": "heal",
  "carduelis": "heal",
  "cardura": "build",
  "carduus": "heal",
  "care": "smart",
  "cared-for": "beautiful",
  "careful": "beautiful",
  "careless": "beautiful",
  "carelian": "story",
  "caress": "build",
  "caressing": "build",
  "caret": "story",
  "caretaker": "sound",
  "caretta": "heal",
  "carex": "heal",
  "carfare": "sell",
  "carful": "smart",
  "cargo": "build",
  "cariama": "heal",
  "cariamidae": "heal",
  "carib": "story",
  "caribe": "heal",
  "caribou": "heal",
  "carica": "heal",
  "caricaceae": "heal",
  "caricature": "story",
  "caries": "smart",
  "carillon": "build",
  "carina": "heal",
  "carinate": "heal",
  "caring": "sell",
  "carioca": "story",
  "carissa": "heal",
  "carjack": "build",
  "carjacking": "build",
  "carlina": "heal",
  "carload": "smart",
  "carminative": "build",
  "carmine": "beautiful",
  "carnal": "beautiful",
  "carnalize": "build",
  "carnation": "heal",
  "carnauba": "heal",
  "carnegiea": "heal",
  "carnivora": "heal",
  "carnivore": "heal",
  "carnivorous": "beautiful",
  "carnosaur": "heal",
  "carnosaura": "heal",
  "carob": "heal",
  "caroche": "build",
  "carol": "story",
  "caroling": "build",
  "carom": "build",
  "carotene": "beautiful",
  "carotenoid": "beautiful",
  "carouse": "sell",
  "carousel": "build",
  "carp": "taste",
  "carpal": "heal",
  "carpel": "heal",
  "carpellate": "beautiful",
  "carpentaria": "build",
  "carpenter": "build",
  "carpenteria": "build",
  "carpentry": "build",
  "carpet": "build",
  "carpetbag": "build",
  "carpeted": "build",
  "carpeting": "build",
  "carpetweed": "heal",
  "carphophis": "heal",
  "carpinaceae": "heal",
  "carping": "story",
  "carpinus": "heal",
  "carpobrotus": "heal",
  "carpocapsa": "heal",
  "carpodacus": "heal",
  "carpophore": "heal",
  "carport": "build",
  "carpospore": "heal",
  "carpus": "heal",
  "carrack": "build",
  "carrageen": "heal",
  "carragheen": "heal",
  "carrefour": "build",
  "carrel": "build",
  "carrell": "build",
  "carriage": "build",
  "carriageway": "build",
  "carrier": "build",
  "carrion": "heal",
  "carrizo": "heal",
  "carrot": "heal",
  "carrousel": "build",
  "carry": "build",
  "carry-forward": "sell",
  "carry-over": "smart",
  "carryall": "build",
  "carrycot": "build",
  "cart": "sell",
  "carte": "story",
  "carthamus": "heal",
  "carthorse": "heal",
  "cartilage": "heal",
  "cartilaginous": "beautiful",
  "carting": "build",
  "cartload": "smart",
  "carton": "smart",
  "cartonful": "smart",
  "cartoon": "story",
  "cartouch": "build",
  "cartouche": "build",
  "cartridge": "build",
  "cartroad": "build",
  "cartwheel": "build",
  "carum": "heal",
  "caruncle": "heal",
  "caruncula": "heal",
  "carve": "build",
  "carved": "build",
  "carvedilol": "build",
  "carvel-built": "beautiful",
  "carven": "beautiful",
  "carving": "build",
  "carya": "heal",
  "caryatid": "build",
  "caryocar": "heal",
  "caryocaraceae": "heal",
  "caryophyllaceae": "heal",
  "caryophyllales": "heal",
  "caryophyllidae": "heal",
  "caryopsis": "heal",
  "caryota": "heal",
  "casaba": "taste",
  "casava": "heal",
  "cascabel": "build",
  "cascara": "heal",
  "cascarilla": "heal",
  "case": "smart",
  "casebook": "story",
  "caseful": "smart",
  "casein": "build",
  "casement": "build",
  "casern": "build",
  "casework": "heal",
  "caseworm": "heal",
  "cash": "sell",
  "cashbox": "build",
  "cashcard": "sell",
  "cashew": "heal",
  "cashier": "sell",
  "cashmere": "build",
  "casing": "build",
  "casino": "build",
  "casino-hotel": "build",
  "cask": "smart",
  "casket": "build",
  "caskful": "smart",
  "casmerodius": "heal",
  "casque": "build",
  "casquet": "build",
  "casquetel": "build",
  "cassareep": "taste",
  "cassava": "heal",
  "casserole": "taste",
  "cassette": "build",
  "cassia": "heal",
  "cassie": "heal",
  "cassiope": "heal",
  "cassiri": "taste",
  "cassite": "story",
  "cassock": "build",
  "cassowary": "heal",
  "cast": "build",
  "castanea": "heal",
  "castanets": "build",
  "castanopsis": "heal",
  "castanospermum": "heal",
  "caster": "build",
  "castigate": "story",
  "castigation": "story",
  "castilian": "story",
  "castilleia": "heal",
  "castilleja": "heal",
  "casting": "build",
  "castle": "build",
  "castor": "build",
  "castoridae": "heal",
  "castoroides": "heal",
  "castrate": "heal",
  "castrated": "heal",
  "castroism": "smart",
  "casuaridae": "heal",
  "casuariiformes": "heal",
  "casuarina": "heal",
  "casuarinaceae": "heal",
  "casuarinales": "heal",
  "casuarius": "heal",
  "casuistry": "smart",
  "cat": "heal",
  "cat's-claw": "heal",
  "cat's-ear": "heal",
  "cat's-paw": "build",
  "cat's-tail": "heal",
  "cat-o'-nine-tails": "build",
  "catabatic": "beautiful",
  "catabiosis": "smart",
  "catabolic": "beautiful",
  "catabolism": "smart",
  "catacala": "heal",
  "catachresis": "story",
  "cataclinal": "beautiful",
  "cataclysm": "sound",
  "catacomb": "build",
  "catadromous": "beautiful",
  "catafalque": "build",
  "cataflam": "build",
  "catalan": "story",
  "catalectic": "story",
  "catalexis": "story",
  "catalog": "story",
  "catalogue": "story",
  "catalpa": "heal",
  "catalufa": "heal",
  "catalysis": "smart",
  "catamaran": "build",
  "catamenia": "smart",
  "catamount": "heal",
  "catamountain": "heal",
  "catananche": "heal",
  "cataphatism": "smart",
  "cataphoresis": "smart",
  "cataphract": "build",
  "cataphyll": "heal",
  "cataplasm": "build",
  "catapres": "build",
  "catapult": "build",
  "catarrhine": "heal",
  "catarrhinian": "beautiful",
  "catasetum": "heal",
  "catastrophe": "sound",
  "catawba": "taste",
  "catbird": "heal",
  "catboat": "build",
  "catbrier": "heal",
  "catcall": "story",
  "catch": "smart",
  "catchall": "build",
  "catchfly": "heal",
  "catching": "smart",
  "catchment": "build",
  "catchphrase": "story",
  "catchweed": "heal",
  "catchword": "story",
  "catclaw": "heal",
  "catechise": "story",
  "catechism": "story",
  "catechize": "story",
  "catechu": "heal",
  "categorem": "story",
  "categorematic": "beautiful",
  "categoreme": "story",
  "categoric": "beautiful",
  "categorical": "beautiful",
  "categorisation": "smart",
  "categorise": "smart",
  "categorization": "smart",
  "categorize": "smart",
  "category": "smart",
  "catenate": "build",
  "catenulate": "build",
  "cater": "taste",
  "catering": "taste",
  "caterpillar": "heal",
  "caterwaul": "story",
  "catfish": "taste",
  "catgut": "heal",
  "catha": "heal",
  "catharacta": "heal",
  "catharanthus": "heal",
  "catharism": "smart",
  "cathartes": "heal",
  "cathartic": "build",
  "cathartid": "heal",
  "cathartidae": "heal",
  "cathaya": "heal",
  "cathect": "heal",
  "cathedra": "build",
  "cathedral": "build",
  "catheter": "build",
  "cathode": "build",
  "catholic": "beautiful",
  "catholicism": "smart",
  "catholicity": "smart",
  "catholicon": "build",
  "cathouse": "build",
  "catkin": "heal",
  "catling": "build",
  "catmint": "heal",
  "catnap": "heal",
  "catnip": "heal",
  "catoptrics": "smart",
  "catoptrophorus": "heal",
  "catostomid": "heal",
  "catostomidae": "heal",
  "catostomus": "heal",
  "catsup": "taste",
  "cattail": "heal",
  "cattalo": "heal",
  "cattie": "smart",
  "cattle": "heal",
  "cattleship": "build",
  "cattleya": "heal",
  "catty": "smart",
  "catwalk": "build",
  "caucasian": "story",
  "caucus": "sell",
  "cauda": "heal",
  "caudal": "beautiful",
  "caudata": "heal",
  "caudate": "heal",
  "caudated": "beautiful",
  "caudex": "heal",
  "caul": "heal",
  "cauldron": "build",
  "caulescent": "beautiful",
  "cauliflower": "heal",
  "cauline": "beautiful",
  "caulk": "build",
  "caulked": "build",
  "caulking": "build",
  "caulophyllum": "heal",
  "causative": "beautiful",
  "cause": "story",
  "causerie": "story",
  "causeway": "build",
  "causing": "build",
  "caustic": "beautiful",
  "cauterant": "build",
  "cautery": "build",
  "caution": "story",
  "cautious": "beautiful",
  "cavalier": "beautiful",
  "cavalla": "heal",
  "cave": "build",
  "caveat": "story",
  "cavern": "build",
  "cavetto": "build",
  "cavia": "heal",
  "caviar": "taste",
  "caviare": "taste",
  "caviidae": "heal",
  "cavil": "story",
  "cavity": "smart",
  "cavum": "heal",
  "cavy": "heal",
  "caw": "story",
  "cayenne": "heal",
  "cayman": "heal",
  "cayuga": "story",
  "cayuse": "heal",
  "cazique": "heal",
  "cbr": "sound",
  "cd-r": "build",
  "cd-rom": "build",
  "cd-wo": "build",
  "cdc": "heal",
  "cdna": "sound",
  "cease": "sound",
  "cebidae": "heal",
  "cebuan": "story",
  "cebuano": "story",
  "cebuella": "heal",
  "cebus": "heal",
  "cecidomyidae": "heal",
  "cecropia": "heal",
  "cecropiaceae": "heal",
  "cecum": "heal",
  "cedar": "heal",
  "cedarbird": "heal",
  "cedarwood": "heal",
  "cede": "sell",
  "cedi": "smart",
  "cedilla": "story",
  "ceding": "sell",
  "cedrela": "heal",
  "cedrus": "heal",
  "cefadroxil": "build",
  "cefobid": "build",
  "cefoperazone": "build",
  "cefotaxime": "build",
  "ceftazidime": "build",
  "ceftin": "build",
  "ceftriaxone": "build",
  "cefuroxime": "build",
  "ceiba": "heal",
  "ceibo": "heal",
  "ceiling": "build",
  "ceilinged": "beautiful",
  "celandine": "heal",
  "celastraceae": "heal",
  "celastrus": "heal",
  "celebrate": "sell",
  "celebrex": "build",
  "celecoxib": "build",
  "celeriac": "heal",
  "celery": "heal",
  "celesta": "build",
  "celestial": "beautiful",
  "celibate": "beautiful",
  "cell": "heal",
  "cellar": "build",
  "cellarage": "sell",
  "cellaret": "build",
  "cellblock": "build",
  "cello": "sound",
  "cellophane": "build",
  "cellphone": "build",
  "cellular": "beautiful",
  "cellulite": "heal",
  "celluloid": "story",
  "celom": "heal",
  "celoma": "heal",
  "celosia": "heal",
  "celtic": "story",
  "celtis": "heal",
  "celtuce": "heal",
  "cembalo": "build",
  "cementum": "heal",
  "cenchrus": "heal",
  "cenogenesis": "smart",
  "cenotaph": "build",
  "cense": "sound",
  "censer": "build",
  "censor": "sell",
  "censored": "sell",
  "censoring": "sell",
  "censure": "story",
  "census": "story",
  "cent": "smart",
  "cental": "smart",
  "centare": "smart",
  "centas": "smart",
  "centaurea": "heal",
  "centaurium": "heal",
  "centaury": "heal",
  "centavo": "smart",
  "centenarian": "beautiful",
  "center": "build",
  "centerboard": "build",
  "centerfield": "build",
  "centerfold": "story",
  "centering": "smart",
  "centerpiece": "smart",
  "centesimal": "beautiful",
  "centesimo": "smart",
  "centile": "smart",
  "centiliter": "smart",
  "centilitre": "smart",
  "centime": "smart",
  "centimeter": "smart",
  "centimetre": "smart",
  "centimo": "smart",
  "centipede": "heal",
  "centner": "smart",
  "central": "build",
  "centralised": "beautiful",
  "centralising": "beautiful",
  "centralism": "smart",
  "centralized": "beautiful",
  "centralizing": "beautiful",
  "centranthus": "heal",
  "centrarchid": "heal",
  "centrarchidae": "heal",
  "centreboard": "build",
  "centrefold": "story",
  "centrepiece": "smart",
  "centrex": "build",
  "centrifugal": "beautiful",
  "centrifugation": "smart",
  "centrifuge": "build",
  "centriole": "heal",
  "centripetal": "beautiful",
  "centriscidae": "heal",
  "centrism": "smart",
  "centrist": "beautiful",
  "centrocercus": "heal",
  "centrolobium": "heal",
  "centromere": "heal",
  "centropomidae": "heal",
  "centropomus": "heal",
  "centropristis": "heal",
  "centropus": "heal",
  "centrosema": "heal",
  "centrosome": "heal",
  "centrospermae": "heal",
  "centrum": "heal",
  "centunculus": "heal",
  "century": "smart",
  "cephalanthera": "heal",
  "cephalaspid": "heal",
  "cephalaspida": "heal",
  "cephalexin": "build",
  "cephalobidae": "heal",
  "cephalochordata": "sound",
  "cephalochordate": "sound",
  "cephaloglycin": "build",
  "cephalopod": "heal",
  "cephalopoda": "heal",
  "cephalopterus": "heal",
  "cephaloridine": "build",
  "cephalosporin": "build",
  "cephalotaceae": "heal",
  "cephalotaxaceae": "heal",
  "cephalotaxus": "heal",
  "cephalothin": "build",
  "cephalotus": "heal",
  "cepphus": "heal",
  "cer": "smart",
  "cerambycidae": "heal",
  "ceramic": "beautiful",
  "ceramicist": "build",
  "ceramics": "beautiful",
  "ceramist": "build",
  "cerapteryx": "heal",
  "ceras": "heal",
  "cerastes": "heal",
  "cerastium": "heal",
  "cerate": "build",
  "ceratitis": "heal",
  "ceratodontidae": "heal",
  "ceratodus": "heal",
  "ceratonia": "heal",
  "ceratopetalum": "heal",
  "ceratophyllaceae": "heal",
  "ceratophyllum": "heal",
  "ceratopogon": "heal",
  "ceratopogonidae": "heal",
  "ceratopsia": "heal",
  "ceratopsian": "heal",
  "ceratopsidae": "heal",
  "ceratopteris": "heal",
  "ceratosaur": "heal",
  "ceratosaurus": "heal",
  "ceratostomataceae": "heal",
  "ceratostomella": "heal",
  "ceratotherium": "heal",
  "ceratozamia": "heal",
  "cercaria": "heal",
  "cercidiphyllaceae": "heal",
  "cercidiphyllum": "heal",
  "cercidium": "heal",
  "cercis": "heal",
  "cercocebus": "heal",
  "cercopidae": "heal",
  "cercopithecidae": "heal",
  "cercopithecus": "heal",
  "cercospora": "heal",
  "cercosporella": "heal",
  "cere": "heal",
  "cereal": "heal",
  "cerebellum": "heal",
  "cerebral": "beautiful",
  "cerebrate": "smart",
  "cerebration": "smart",
  "cerebrum": "heal",
  "cerecloth": "build",
  "cerement": "build",
  "ceremonial": "beautiful",
  "ceremonious": "beautiful",
  "ceres": "heal",
  "cereus": "heal",
  "ceriman": "heal",
  "cerise": "beautiful",
  "cerivastatin": "build",
  "cero": "heal",
  "ceroxylon": "heal",
  "certain": "beautiful",
  "certainty": "smart",
  "certhia": "heal",
  "certhiidae": "heal",
  "certificate": "story",
  "certification": "story",
  "certified": "story",
  "certify": "story",
  "certiorari": "story",
  "certitude": "smart",
  "cerulean": "beautiful",
  "ceruse": "beautiful",
  "cervid": "heal",
  "cervidae": "heal",
  "cervix": "heal",
  "cervus": "heal",
  "ceryle": "heal",
  "cesspit": "build",
  "cesspool": "build",
  "cestida": "heal",
  "cestidae": "heal",
  "cestoda": "heal",
  "cestode": "heal",
  "cestrum": "heal",
  "cestum": "heal",
  "cetacea": "heal",
  "cetacean": "heal",
  "cetchup": "taste",
  "ceterach": "heal",
  "cetonia": "heal",
  "cetoniidae": "heal",
  "cetorhinidae": "heal",
  "cetorhinus": "heal",
  "cetraria": "heal",
  "cftr": "heal",
  "cgs": "smart",
  "chabad": "smart",
  "chablis": "taste",
  "chachalaca": "heal",
  "chachka": "build",
  "chacma": "heal",
  "chad": "story",
  "chadar": "build",
  "chaddar": "build",
  "chadic": "story",
  "chadlock": "heal",
  "chador": "build",
  "chaenactis": "heal",
  "chaenomeles": "heal",
  "chaenopsis": "heal",
  "chaeta": "heal",
  "chaetodipterus": "heal",
  "chaetodon": "heal",
  "chaetodontidae": "heal",
  "chaetognath": "heal",
  "chaetognatha": "heal",
  "chafe": "sound",
  "chafeweed": "heal",
  "chaff": "build",
  "chaffer": "sell",
  "chaffinch": "heal",
  "chaffweed": "heal",
  "chaffy": "beautiful",
  "chafing": "sound",
  "chaga": "story",
  "chagatai": "story",
  "chagga": "story",
  "chahta": "story",
  "chain": "build",
  "chain-smoke": "taste",
  "chains": "build",
  "chainsaw": "build",
  "chair": "build",
  "chairlift": "build",
  "chairman": "sell",
  "chaise": "build",
  "chaja": "heal",
  "chalaza": "heal",
  "chalcid": "heal",
  "chalcidae": "heal",
  "chalcidfly": "heal",
  "chalcididae": "heal",
  "chalcis": "heal",
  "chalcostigma": "heal",
  "chaldron": "smart",
  "chalet": "build",
  "chalice": "build",
  "chalk": "build",
  "chalkboard": "build",
  "chalkpit": "build",
  "chalkstone": "heal",
  "chalky": "beautiful",
  "challah": "taste",
  "challenge": "story",
  "challis": "build",
  "chamaea": "heal",
  "chamaecrista": "heal",
  "chamaecyparis": "heal",
  "chamaecytisus": "heal",
  "chamaedaphne": "heal",
  "chamaeleo": "heal",
  "chamaeleon": "heal",
  "chamaeleonidae": "heal",
  "chamaeleontidae": "heal",
  "chamaemelum": "heal",
  "chamber": "build",
  "chamberpot": "build",
  "chambers": "build",
  "chambray": "build",
  "chameleon": "heal",
  "chamfer": "build",
  "chamfron": "build",
  "chamois": "heal",
  "chamomile": "heal",
  "champ": "taste",
  "champagne": "taste",
  "chanal": "heal",
  "chanar": "heal",
  "chance": "sound",
  "chancel": "build",
  "chancellery": "build",
  "chancery": "build",
  "chandelier": "build",
  "chandlery": "build",
  "chanfron": "build",
  "change": "sound",
  "changeable": "beautiful",
  "changeful": "beautiful",
  "changeless": "beautiful",
  "changer": "build",
  "channel": "story",
  "channelise": "build",
  "channelize": "build",
  "channels": "story",
  "channidae": "heal",
  "chant": "story",
  "chantarelle": "heal",
  "chanter": "build",
  "chanterelle": "heal",
  "chantey": "story",
  "chanting": "story",
  "chantry": "sell",
  "chanty": "story",
  "chaos": "sound",
  "chaotic": "beautiful",
  "chap": "build",
  "chapati": "taste",
  "chapatti": "taste",
  "chapeau": "build",
  "chapel": "build",
  "chapiter": "build",
  "chaplet": "build",
  "chapter": "story",
  "chapterhouse": "build",
  "char": "heal",
  "chara": "heal",
  "charabanc": "build",
  "characeae": "heal",
  "characid": "heal",
  "characidae": "heal",
  "characin": "heal",
  "characinidae": "heal",
  "character": "smart",
  "characterisation": "story",
  "characterise": "story",
  "characteristic": "smart",
  "characterization": "story",
  "characterize": "story",
  "charade": "story",
  "charades": "story",
  "charadrii": "heal",
  "charadriidae": "heal",
  "charadriiformes": "heal",
  "charadrius": "heal",
  "charales": "heal",
  "charcoal": "beautiful",
  "charcot": "heal",
  "charcuterie": "taste",
  "chard": "heal",
  "chardonnay": "heal",
  "charge": "story",
  "charged": "story",
  "charger": "heal",
  "chari-nile": "story",
  "charina": "heal",
  "chariot": "build",
  "charitable": "beautiful",
  "charity": "heal",
  "charivari": "story",
  "charlock": "heal",
  "charlotte": "taste",
  "charm": "story",
  "charnel": "build",
  "charolais": "heal",
  "charophyceae": "heal",
  "charr": "heal",
  "charronia": "heal",
  "chart": "story",
  "charter": "story",
  "chartered": "sell",
  "charterhouse": "build",
  "chartism": "smart",
  "chartreuse": "taste",
  "chase": "build",
  "chased": "sell",
  "chaser": "taste",
  "chasidism": "smart",
  "chassidism": "smart",
  "chassis": "heal",
  "chaste": "beautiful",
  "chasten": "story",
  "chastening": "story",
  "chastise": "story",
  "chastisement": "story",
  "chasuble": "build",
  "chat": "story",
  "chateau": "build",
  "chateaubriand": "taste",
  "chatelaine": "build",
  "chateura": "heal",
  "chatroom": "story",
  "chattel": "sell",
  "chatter": "story",
  "chatterbox": "heal",
  "chatterer": "heal",
  "chattering": "sound",
  "chaulmoogra": "heal",
  "chaulmugra": "heal",
  "chauna": "heal",
  "chauvinistic": "beautiful",
  "chaw": "taste",
  "cheap": "beautiful",
  "cheapjack": "beautiful",
  "cheat": "heal",
  "cheatgrass": "heal",
  "cheating": "sell",
  "chechen": "story",
  "check": "sell",
  "checkbook": "sell",
  "checker": "build",
  "checkerberry": "heal",
  "checkerbloom": "heal",
  "checkerboard": "build",
  "checkers": "build",
  "checklist": "story",
  "checkout": "sell",
  "checkrein": "build",
  "checkroom": "build",
  "checkrow": "build",
  "checksum": "smart",
  "cheddar": "taste",
  "cheek": "heal",
  "cheekbone": "heal",
  "cheekpiece": "build",
  "cheep": "story",
  "cheer": "story",
  "cheerful": "beautiful",
  "cheering": "story",
  "cheerio": "story",
  "cheerlead": "story",
  "cheerless": "beautiful",
  "cheese": "taste",
  "cheeseboard": "build",
  "cheeseburger": "taste",
  "cheesecake": "taste",
  "cheesecloth": "build",
  "cheeseflower": "heal",
  "cheetah": "heal",
  "cheewink": "heal",
  "chef-d'oeuvre": "build",
  "cheilanthes": "heal",
  "cheiranthus": "heal",
  "chela": "heal",
  "chelation": "smart",
  "chelicera": "heal",
  "chelicerata": "heal",
  "chelidonium": "heal",
  "chelifer": "heal",
  "chelone": "heal",
  "chelonethida": "heal",
  "chelonia": "heal",
  "chelonian": "heal",
  "chelonidae": "heal",
  "cheloniidae": "heal",
  "chelydra": "heal",
  "chelydridae": "heal",
  "chemakuan": "story",
  "chemakum": "story",
  "chemiluminescence": "sound",
  "chemise": "build",
  "chemisorb": "build",
  "chemisorption": "smart",
  "chemist's": "build",
  "chemistry": "smart",
  "chemoimmunology": "heal",
  "chemoreceptor": "heal",
  "chemosorption": "smart",
  "chemosynthesis": "smart",
  "chen": "heal",
  "chenfish": "heal",
  "chenille": "build",
  "chenopodiaceae": "heal",
  "chenopodiales": "heal",
  "chenopodium": "heal",
  "cheque": "sell",
  "chequebook": "sell",
  "chequer": "build",
  "cheremis": "story",
  "cheremiss": "story",
  "cherimolla": "taste",
  "cherimoya": "heal",
  "chermidae": "heal",
  "cherokee": "story",
  "cheroot": "build",
  "cherry": "heal",
  "cherrystone": "taste",
  "chervil": "heal",
  "chess": "heal",
  "chessboard": "build",
  "chessman": "build",
  "chest": "heal",
  "chesterfield": "build",
  "chestnut": "heal",
  "chetah": "heal",
  "chetrum": "smart",
  "cheval-de-frise": "build",
  "chevaux-de-frise": "build",
  "cheviot": "heal",
  "cheviots": "heal",
  "chevre": "taste",
  "chevron": "story",
  "chevrotain": "heal",
  "chew": "taste",
  "chewing": "taste",
  "chewink": "heal",
  "cheyenne": "story",
  "chi": "story",
  "chianti": "taste",
  "chiaroscuro": "beautiful",
  "chiasm": "heal",
  "chiasma": "heal",
  "chiasmus": "story",
  "chic": "beautiful",
  "chicane": "build",
  "chicha": "build",
  "chichewa": "story",
  "chichi": "beautiful",
  "chichipe": "heal",
  "chick": "heal",
  "chickadee": "heal",
  "chickasaw": "story",
  "chicken": "taste",
  "chickenfeed": "sell",
  "chickenshit": "story",
  "chickeree": "heal",
  "chickpea": "heal",
  "chickweed": "heal",
  "chicory": "heal",
  "chicot": "heal",
  "chide": "story",
  "chiding": "story",
  "chief": "beautiful",
  "chiffon": "build",
  "chiffonier": "build",
  "chigetai": "heal",
  "chigger": "heal",
  "chiggerflower": "heal",
  "chignon": "heal",
  "chigoe": "heal",
  "chihuahua": "heal",
  "childbearing": "smart",
  "childbirth": "smart",
  "chile": "taste",
  "chili": "taste",
  "chiliad": "smart",
  "chiliasm": "smart",
  "chilli": "taste",
  "chilling": "smart",
  "chilly": "taste",
  "chilomastix": "heal",
  "chilomeniscus": "heal",
  "chilomycterus": "heal",
  "chilopoda": "heal",
  "chilopsis": "heal",
  "chimaera": "smart",
  "chimaeridae": "heal",
  "chimaphila": "heal",
  "chimariko": "story",
  "chime": "build",
  "chimera": "smart",
  "chimerical": "beautiful",
  "chimney": "build",
  "chimneypiece": "build",
  "chimneypot": "build",
  "chimneystack": "build",
  "chimonanthus": "heal",
  "chimp": "heal",
  "chimpanzee": "heal",
  "chimwini": "story",
  "chin": "heal",
  "chin-wag": "story",
  "chin-wagging": "story",
  "china": "build",
  "chinaberry": "heal",
  "chinaware": "build",
  "chincapin": "taste",
  "chinch": "heal",
  "chincherinchee": "heal",
  "chinchilla": "build",
  "chinchillidae": "heal",
  "chinchillon": "heal",
  "chinchona": "heal",
  "chine": "taste",
  "chinese": "story",
  "chingpo": "story",
  "chink": "sound",
  "chinkapin": "taste",
  "chino": "build",
  "chinoiserie": "build",
  "chinook": "sound",
  "chinookan": "story",
  "chinquapin": "heal",
  "chintz": "build",
  "chiococca": "heal",
  "chionanthus": "heal",
  "chip": "build",
  "chipewyan": "story",
  "chipmunk": "heal",
  "chipolata": "taste",
  "chipotle": "taste",
  "chippendale": "sound",
  "chippewa": "story",
  "chippewaian": "story",
  "chippewyan": "story",
  "chipping": "build",
  "chips": "taste",
  "chirk": "story",
  "chirocephalus": "heal",
  "chirography": "story",
  "chirology": "smart",
  "chiromance": "sound",
  "chiromancy": "smart",
  "chironomidae": "heal",
  "chironomus": "heal",
  "chiropody": "smart",
  "chiroptera": "heal",
  "chiropteran": "heal",
  "chirp": "story",
  "chirpy": "beautiful",
  "chirr": "story",
  "chirrup": "story",
  "chisel": "build",
  "chishona": "story",
  "chit": "story",
  "chit-chat": "story",
  "chitchat": "story",
  "chitlings": "taste",
  "chitlins": "taste",
  "chiton": "build",
  "chittamwood": "heal",
  "chitter": "story",
  "chitterlings": "taste",
  "chittimwood": "heal",
  "chivalry": "smart",
  "chivaree": "story",
  "chive": "heal",
  "chives": "heal",
  "chiwere": "story",
  "chlamydeous": "beautiful",
  "chlamydera": "heal",
  "chlamydia": "heal",
  "chlamydiaceae": "heal",
  "chlamydomonadaceae": "heal",
  "chlamydomonas": "heal",
  "chlamydosaurus": "heal",
  "chlamydospore": "heal",
  "chlamyphore": "heal",
  "chlamyphorus": "heal",
  "chlamys": "heal",
  "chlor-trimeton": "build",
  "chlorambucil": "build",
  "chloramine": "build",
  "chloramine-t": "build",
  "chloramphenicol": "build",
  "chloranthaceae": "heal",
  "chloranthus": "heal",
  "chlordiazepoxide": "build",
  "chlorella": "heal",
  "chlorenchyma": "heal",
  "chlorhexidine": "build",
  "chlorinate": "heal",
  "chlorination": "smart",
  "chlorinity": "smart",
  "chloris": "heal",
  "chlorococcales": "heal",
  "chlorococcum": "heal",
  "chloroform": "build",
  "chlorofucin": "heal",
  "chloromycetin": "build",
  "chlorophis": "heal",
  "chlorophoneus": "heal",
  "chlorophthalmidae": "heal",
  "chlorophyceae": "heal",
  "chlorophyl": "heal",
  "chlorophyll": "heal",
  "chlorophyta": "heal",
  "chlorophyte": "heal",
  "chloroplast": "heal",
  "chloroquine": "build",
  "chlorothiazide": "build",
  "chloroxylon": "heal",
  "chlorpromazine": "build",
  "chlortetracycline": "build",
  "chlorthalidone": "build",
  "chlorura": "heal",
  "choanocyte": "heal",
  "choc": "taste",
  "choc-ice": "taste",
  "chock": "build",
  "chocolate": "taste",
  "choctaw": "story",
  "choeronycteris": "heal",
  "choice": "smart",
  "choir": "sound",
  "choke": "build",
  "chokecherry": "heal",
  "choker": "build",
  "chokey": "build",
  "choking": "heal",
  "choky": "build",
  "cholecystokinin": "heal",
  "choler": "heal",
  "cholesterin": "sound",
  "cholesterol": "sound",
  "cholinergic": "beautiful",
  "cholla": "heal",
  "choloepus": "heal",
  "chomp": "taste",
  "chomping": "taste",
  "chon": "smart",
  "chondrichthian": "heal",
  "chondrichthyes": "heal",
  "chondriosome": "heal",
  "chondritic": "beautiful",
  "chondrus": "heal",
  "choo-choo": "build",
  "choose": "smart",
  "chop": "sound",
  "chophouse": "build",
  "chopin": "story",
  "chopine": "build",
  "chopper": "heal",
  "chopsteak": "taste",
  "chopstick": "build",
  "choral": "sound",
  "chorale": "story",
  "chord": "sound",
  "chordal": "sound",
  "chordamesoderm": "sound",
  "chordata": "sound",
  "chordate": "sound",
  "chordeiles": "sound",
  "chorditis": "sound",
  "chordomesoderm": "sound",
  "chordophone": "sound",
  "chordospartium": "sound",
  "choreograph": "build",
  "choreography": "story",
  "chorioallantois": "heal",
  "chorion": "heal",
  "choriotis": "heal",
  "chorizagrotis": "heal",
  "chorizema": "heal",
  "chorizo": "taste",
  "choroid": "heal",
  "chortle": "story",
  "chorus": "story",
  "chosen": "smart",
  "chou": "taste",
  "chough": "heal",
  "chow": "taste",
  "chowchow": "taste",
  "chowder": "taste",
  "chrestomathy": "story",
  "chrism": "build",
  "chrisom": "build",
  "christ's-thorn": "heal",
  "christella": "heal",
  "christen": "story",
  "christening": "story",
  "christian": "beautiful",
  "christianity": "smart",
  "christmasberry": "heal",
  "christology": "smart",
  "chromaesthesia": "smart",
  "chromatic": "beautiful",
  "chromatid": "heal",
  "chromatin": "heal",
  "chromatism": "beautiful",
  "chromatogram": "build",
  "chromatography": "smart",
  "chrome": "build",
  "chromesthesia": "smart",
  "chromium-plate": "build",
  "chromogen": "beautiful",
  "chromolithography": "beautiful",
  "chromoplast": "heal",
  "chromosome": "heal",
  "chronic": "heal",
  "chronicle": "story",
  "chronograph": "build",
  "chronological": "sound",
  "chronology": "story",
  "chronometer": "build",
  "chronoperates": "heal",
  "chronoscope": "build",
  "chrysalis": "heal",
  "chrysanthemum": "heal",
  "chrysaora": "heal",
  "chrysarobin": "build",
  "chrysemys": "heal",
  "chrysobalanus": "heal",
  "chrysochloridae": "heal",
  "chrysochloris": "heal",
  "chrysolepis": "heal",
  "chrysolophus": "heal",
  "chrysomelid": "heal",
  "chrysomelidae": "heal",
  "chrysophrys": "heal",
  "chrysophyceae": "heal",
  "chrysophyllum": "heal",
  "chrysophyta": "heal",
  "chrysopid": "heal",
  "chrysopidae": "heal",
  "chrysopsis": "heal",
  "chrysosplenium": "heal",
  "chrysothamnus": "heal",
  "chub": "heal",
  "chuck": "taste",
  "chuck-will's-widow": "heal",
  "chuckle": "story",
  "chuckwalla": "heal",
  "chuddar": "build",
  "chufa": "heal",
  "chuff": "heal",
  "chug": "sound",
  "chukchi": "story",
  "chukka": "build",
  "chum": "build",
  "chunga": "heal",
  "chunk": "smart",
  "chunking": "smart",
  "chunnel": "build",
  "church": "build",
  "churidars": "build",
  "churn": "build",
  "churr": "story",
  "chute": "build",
  "chute-the-chute": "build",
  "chutney": "taste",
  "chuvash": "story",
  "chyle": "heal",
  "chytridiaceae": "heal",
  "chytridiales": "heal",
  "chytridiomycetes": "heal",
  "cialis": "build",
  "ciao": "story",
  "cibotium": "heal",
  "cicada": "heal",
  "cicadellidae": "heal",
  "cicadidae": "heal",
  "cicala": "heal",
  "cicatrise": "build",
  "cicatrize": "build",
  "cicer": "heal",
  "cicero": "smart",
  "cichlid": "heal",
  "cichlidae": "heal",
  "cichorium": "heal",
  "cicindelidae": "heal",
  "ciconia": "heal",
  "ciconiidae": "heal",
  "ciconiiformes": "heal",
  "cicuta": "heal",
  "cider": "taste",
  "ciderpress": "build",
  "cigar": "build",
  "cigaret": "build",
  "cigarette": "build",
  "cigarfish": "heal",
  "cigarillo": "build",
  "cilantro": "heal",
  "ciliata": "heal",
  "ciliate": "heal",
  "cilioflagellata": "heal",
  "ciliophora": "heal",
  "ciliophoran": "heal",
  "cilium": "heal",
  "cimarron": "heal",
  "cimetidine": "build",
  "cimex": "heal",
  "cimicidae": "heal",
  "cimicifuga": "heal",
  "cinch": "build",
  "cinchona": "heal",
  "cinclidae": "heal",
  "cinclus": "heal",
  "cincture": "build",
  "cine-camera": "build",
  "cine-film": "build",
  "cinema": "story",
  "cinematise": "build",
  "cinematize": "build",
  "cinematographer": "story",
  "cinematography": "story",
  "cineraria": "heal",
  "cinerarium": "build",
  "cingulum": "heal",
  "cinnabar": "heal",
  "cinnamomum": "heal",
  "cinnamon": "taste",
  "cinque": "smart",
  "cinquefoil": "heal",
  "cipher": "story",
  "cipro": "build",
  "ciprofloxacin": "build",
  "circaea": "heal",
  "circaetus": "heal",
  "circassian": "story",
  "circlet": "build",
  "circuit": "build",
  "circuitry": "build",
  "circular": "story",
  "circularise": "sell",
  "circularize": "sell",
  "circulate": "story",
  "circulation": "story",
  "circumcise": "build",
  "circumflex": "story",
  "circumlocution": "story",
  "circumscribe": "build",
  "circumspection": "smart",
  "circumstance": "smart",
  "circumstances": "sell",
  "circumstantiate": "story",
  "circumvent": "story",
  "circus": "build",
  "cirio": "heal",
  "cirrhus": "heal",
  "cirriped": "heal",
  "cirripede": "heal",
  "cirripedia": "heal",
  "cirrus": "heal",
  "cirsium": "heal",
  "cis": "smart",
  "cisco": "taste",
  "cismontane": "beautiful",
  "cistaceae": "heal",
  "cistern": "build",
  "cisterna": "heal",
  "cistothorus": "heal",
  "cistron": "heal",
  "cistus": "heal",
  "citadel": "build",
  "citation": "story",
  "cite": "story",
  "citellus": "heal",
  "citharichthys": "heal",
  "cither": "build",
  "cithern": "build",
  "citole": "build",
  "citrange": "heal",
  "citron": "taste",
  "citroncirus": "heal",
  "citronwood": "heal",
  "citrullus": "heal",
  "citrus": "taste",
  "cittern": "build",
  "cityscape": "smart",
  "cive": "heal",
  "civet": "heal",
  "civics": "smart",
  "civies": "build",
  "civil": "beautiful",
  "civilian": "beautiful",
  "civilisation": "smart",
  "civilise": "sell",
  "civilised": "sell",
  "civilization": "smart",
  "civilize": "sell",
  "civilized": "sell",
  "civvies": "build",
  "clabber": "taste",
  "clack": "build",
  "clad": "heal",
  "cladding": "build",
  "cladistics": "smart",
  "cladode": "heal",
  "cladonia": "heal",
  "cladoniaceae": "heal",
  "cladophyll": "heal",
  "cladorhyncus": "heal",
  "cladrastis": "heal",
  "claforan": "build",
  "claim": "story",
  "clairvoyance": "story",
  "clairvoyant": "beautiful",
  "clam": "heal",
  "clamatores": "heal",
  "clambake": "taste",
  "clammyweed": "heal",
  "clamor": "story",
  "clamoring": "story",
  "clamour": "story",
  "clamouring": "story",
  "clamp": "build",
  "clams": "sell",
  "clamshell": "heal",
  "clang": "sound",
  "clangor": "sound",
  "clangoring": "sound",
  "clangour": "sound",
  "clangula": "heal",
  "clank": "sound",
  "clap": "build",
  "clapboard": "build",
  "clapper": "heal",
  "clapperboard": "build",
  "clapperclaw": "build",
  "clappers": "build",
  "clapping": "story",
  "claptrap": "story",
  "clarence": "build",
  "claret": "taste",
  "clarification": "story",
  "clarify": "story",
  "clarinet": "sound",
  "clarion": "build",
  "claro": "build",
  "clary": "heal",
  "clasp": "build",
  "classic": "build",
  "classical": "story",
  "classicalism": "smart",
  "classicism": "smart",
  "classics": "smart",
  "classification": "smart",
  "classified": "story",
  "classifier": "story",
  "classify": "smart",
  "classroom": "build",
  "clathraceae": "heal",
  "clathrus": "heal",
  "clatter": "sound",
  "clause": "story",
  "claustrum": "heal",
  "clavariaceae": "heal",
  "claver": "story",
  "claviceps": "heal",
  "clavichord": "sound",
  "clavicipitaceae": "heal",
  "clavicle": "heal",
  "clavier": "build",
  "claw": "heal",
  "clawhammer": "build",
  "claxon": "build",
  "clayey": "beautiful",
  "claymore": "build",
  "claytonia": "heal",
  "clayware": "build",
  "clean": "build",
  "clean-handed": "beautiful",
  "cleaner": "build",
  "cleaners": "build",
  "cleaning": "build",
  "cleanse": "heal",
  "cleanser": "build",
  "cleansing": "heal",
  "cleanup": "sell",
  "clear-cut": "beautiful",
  "clear-thinking": "beautiful",
  "clearance": "smart",
  "cleared": "story",
  "clearheaded": "beautiful",
  "clearstory": "build",
  "clearway": "build",
  "clearweed": "heal",
  "cleat": "build",
  "cleats": "build",
  "cleavage": "smart",
  "cleave": "build",
  "cleaver": "build",
  "cleavers": "heal",
  "clef": "story",
  "cleft": "build",
  "cleg": "heal",
  "clegg": "heal",
  "cleistes": "heal",
  "cleistocarp": "heal",
  "cleistothecium": "heal",
  "clematis": "heal",
  "clement": "beautiful",
  "clementine": "heal",
  "clench": "build",
  "cleome": "heal",
  "clepsydra": "build",
  "clerestory": "build",
  "clerical": "beautiful",
  "clericalism": "story",
  "clerid": "heal",
  "cleridae": "heal",
  "clerihew": "story",
  "clerk": "sell",
  "clerking": "sell",
  "clethra": "heal",
  "clethraceae": "heal",
  "clethrionomys": "heal",
  "cleverness": "smart",
  "clevis": "build",
  "clew": "story",
  "clews": "build",
  "cli": "story",
  "clianthus": "heal",
  "cliche": "story",
  "click": "story",
  "clickety-clack": "sound",
  "clickety-click": "sound",
  "client": "sell",
  "cliff-brake": "heal",
  "cliffhanger": "story",
  "cliftonia": "heal",
  "climactic": "beautiful",
  "climatology": "smart",
  "climax": "story",
  "climb-down": "story",
  "climber": "heal",
  "clinch": "build",
  "clincher": "story",
  "clincher-built": "beautiful",
  "cling": "taste",
  "clingfilm": "build",
  "clingfish": "heal",
  "clingstone": "taste",
  "clinic": "heal",
  "clinical": "heal",
  "clinid": "heal",
  "clinidae": "heal",
  "clink": "build",
  "clinker": "build",
  "clinker-built": "beautiful",
  "clinometer": "build",
  "clinopodium": "heal",
  "clinoril": "build",
  "clintonia": "heal",
  "clioquinol": "build",
  "clip": "build",
  "clip-on": "build",
  "clipboard": "build",
  "clipper": "build",
  "clipping": "story",
  "clit": "heal",
  "clitocybe": "heal",
  "clitoria": "heal",
  "clitoris": "heal",
  "clitter": "sound",
  "clivers": "heal",
  "cloaca": "heal",
  "cloak": "build",
  "cloakroom": "build",
  "clobber": "sell",
  "cloche": "build",
  "clock": "build",
  "clock-watching": "smart",
  "clocks": "heal",
  "clockwise": "beautiful",
  "clockwork": "build",
  "clodhopper": "build",
  "clofibrate": "build",
  "clog": "build",
  "cloisonne": "build",
  "cloister": "build",
  "clomid": "build",
  "clomiphene": "build",
  "clomipramine": "build",
  "clone": "build",
  "clonidine": "build",
  "cloning": "build",
  "clop": "sound",
  "clopping": "sound",
  "close": "story",
  "closed": "build",
  "closer": "beautiful",
  "closet": "build",
  "closeup": "story",
  "closing": "story",
  "clostridia": "heal",
  "clostridium": "heal",
  "closure": "story",
  "clot": "heal",
  "clotbur": "heal",
  "cloth": "build",
  "clothe": "heal",
  "clothed": "heal",
  "clothes": "build",
  "clothesbrush": "build",
  "clotheshorse": "build",
  "clothesline": "build",
  "clothespin": "build",
  "clothespress": "build",
  "clothing": "build",
  "clotting": "smart",
  "cloture": "story",
  "cloud": "smart",
  "cloud-cuckoo-land": "smart",
  "cloudberry": "heal",
  "cloudburst": "sound",
  "clouding": "smart",
  "cloudy": "beautiful",
  "clout": "story",
  "clove": "heal",
  "clover": "heal",
  "clover-root": "heal",
  "cloverleaf": "build",
  "cloveroot": "heal",
  "clown": "heal",
  "clowning": "story",
  "cloy": "sell",
  "clozapine": "build",
  "clozaril": "build",
  "club": "build",
  "club-head": "build",
  "club-moss": "heal",
  "clubbing": "sell",
  "clubhead": "build",
  "clubhouse": "build",
  "clubroom": "build",
  "cluck": "story",
  "clucking": "story",
  "clue": "story",
  "clumber": "heal",
  "clump": "sound",
  "clumping": "sound",
  "clumsiness": "smart",
  "clunk": "sound",
  "clunking": "sound",
  "clupea": "heal",
  "clupeid": "heal",
  "clupeidae": "heal",
  "clusia": "heal",
  "clusiaceae": "heal",
  "cluster": "build",
  "clustering": "smart",
  "clutter": "story",
  "clydesdale": "heal",
  "clypeus": "heal",
  "clyster": "heal",
  "cmb": "sound",
  "cmbr": "sound",
  "cmv": "heal",
  "cnemidophorus": "heal",
  "cnicus": "heal",
  "cnidaria": "heal",
  "cnidarian": "heal",
  "cnidoscolus": "heal",
  "cnidosporidia": "heal",
  "cns": "heal",
  "co-author": "build",
  "co-ed": "beautiful",
  "co-educate": "sell",
  "co-occurrence": "sound",
  "co-opt": "sell",
  "co-ordinate": "smart",
  "co-sign": "sell",
  "co-star": "build",
  "coach": "build",
  "coach-and-four": "build",
  "coaching": "story",
  "coachwhip": "heal",
  "coact": "sell",
  "coagulate": "beautiful",
  "coagulation": "smart",
  "coagulum": "heal",
  "coal": "sell",
  "coalbin": "build",
  "coalesce": "build",
  "coalhole": "build",
  "coalpit": "build",
  "coaming": "build",
  "coapt": "build",
  "coarse": "beautiful",
  "coarsen": "build",
  "coarseness": "story",
  "coast": "smart",
  "coastal": "beautiful",
  "coaster": "build",
  "coat": "build",
  "coatdress": "build",
  "coated": "build",
  "coatee": "build",
  "coati": "heal",
  "coati-mondi": "heal",
  "coati-mundi": "heal",
  "coating": "build",
  "coatrack": "build",
  "coatroom": "build",
  "coattail": "build",
  "coax": "build",
  "coaxing": "story",
  "cob": "taste",
  "cobble": "build",
  "cobbler": "taste",
  "cobblers": "story",
  "cobblestone": "build",
  "cobbling": "build",
  "cobia": "heal",
  "cobitidae": "heal",
  "cobnut": "heal",
  "cobol": "story",
  "cobra": "heal",
  "cobweb": "build",
  "coca": "heal",
  "cocain": "build",
  "cocaine": "build",
  "cocainise": "heal",
  "cocainize": "heal",
  "cocci": "heal",
  "coccidae": "heal",
  "coccidia": "heal",
  "coccidium": "heal",
  "coccinellidae": "heal",
  "coccobacillus": "heal",
  "coccoidea": "heal",
  "coccothraustes": "heal",
  "cocculus": "heal",
  "coccus": "heal",
  "coccyx": "heal",
  "coccyzus": "heal",
  "cochimi": "story",
  "cochin": "heal",
  "cochineal": "heal",
  "cochlea": "heal",
  "cochlearia": "heal",
  "cochlearius": "heal",
  "cock": "heal",
  "cock-a-leekie": "taste",
  "cockade": "build",
  "cockaigne": "smart",
  "cockateel": "heal",
  "cockatiel": "heal",
  "cockatoo": "heal",
  "cockchafer": "heal",
  "cocker": "heal",
  "cockerel": "heal",
  "cockhorse": "build",
  "cockle": "taste",
  "cockle-bur": "heal",
  "cockle-burr": "heal",
  "cocklebur": "heal",
  "cockleburr": "heal",
  "cockleshell": "build",
  "cockloft": "build",
  "cockney": "story",
  "cockpit": "build",
  "cockroach": "heal",
  "cockscomb": "heal",
  "cocksfoot": "heal",
  "cockspur": "heal",
  "cocksureness": "smart",
  "cocktail": "taste",
  "cocky-leeky": "taste",
  "coco": "heal",
  "cocoa": "taste",
  "cocoanut": "taste",
  "cocobolo": "heal",
  "coconspire": "smart",
  "coconut": "taste",
  "cocoon": "heal",
  "cocooning": "build",
  "cocopa": "story",
  "cocopah": "story",
  "cocos": "heal",
  "cocoswood": "heal",
  "cocotte": "build",
  "cocoyam": "heal",
  "cocozelle": "heal",
  "cocuswood": "heal",
  "cod": "heal",
  "coda": "story",
  "codariocalyx": "heal",
  "coddle": "sell",
  "code": "smart",
  "codeine": "build",
  "codex": "story",
  "codfish": "taste",
  "codiaeum": "heal",
  "codicil": "story",
  "codification": "story",
  "coding": "smart",
  "codling": "heal",
  "codlins-and-cream": "heal",
  "codon": "sound",
  "codpiece": "build",
  "codswallop": "story",
  "coeducate": "sell",
  "coefficient": "smart",
  "coelacanth": "heal",
  "coelenterata": "heal",
  "coelenterate": "heal",
  "coelenteron": "heal",
  "coeloglossum": "heal",
  "coelogyne": "heal",
  "coelom": "heal",
  "coelophysis": "heal",
  "coelostat": "build",
  "coerce": "sell",
  "coereba": "heal",
  "coerebidae": "heal",
  "coeval": "beautiful",
  "coffea": "heal",
  "coffee": "taste",
  "coffeeberry": "heal",
  "coffeecake": "taste",
  "coffeehouse": "build",
  "coffeepot": "build",
  "coffer": "build",
  "cofferdam": "build",
  "coffin": "build",
  "cog": "build",
  "cogitate": "smart",
  "cogitation": "smart",
  "cogitative": "beautiful",
  "cognac": "taste",
  "cognate": "story",
  "cognisable": "beautiful",
  "cognisance": "smart",
  "cognisant": "beautiful",
  "cognise": "smart",
  "cognizable": "beautiful",
  "cognizance": "smart",
  "cognizant": "beautiful",
  "cognize": "smart",
  "cognomen": "story",
  "cognoscible": "beautiful",
  "cogwheel": "build",
  "cohere": "build",
  "coherent": "beautiful",
  "cohesion": "smart",
  "coho": "taste",
  "cohoe": "taste",
  "cohosh": "heal",
  "cohune": "heal",
  "coif": "heal",
  "coiffe": "heal",
  "coiffure": "heal",
  "coign": "build",
  "coigne": "build",
  "coigue": "heal",
  "coil": "build",
  "coiled": "build",
  "coin": "sell",
  "coinage": "sell",
  "coincidence": "sound",
  "coinsurance": "sell",
  "coinsure": "sell",
  "coir": "heal",
  "coke": "taste",
  "cola": "heal",
  "colander": "taste",
  "colaptes": "heal",
  "colbert": "taste",
  "colchicaceae": "heal",
  "colchicine": "build",
  "colchicum": "heal",
  "cold": "smart",
  "cold-blooded": "beautiful",
  "cold-cream": "build",
  "cold-shoulder": "smart",
  "coldcock": "build",
  "coldcream": "build",
  "coldhearted": "beautiful",
  "coldness": "smart",
  "coldwork": "build",
  "cole": "heal",
  "coleonyx": "heal",
  "coleoptera": "heal",
  "coleslaw": "taste",
  "coleus": "heal",
  "colewort": "heal",
  "colicroot": "heal",
  "colinus": "heal",
  "coliphage": "heal",
  "coliseum": "build",
  "collaborate": "sell",
  "collage": "beautiful",
  "collagen": "heal",
  "collapsable": "beautiful",
  "collapsible": "beautiful",
  "collar": "build",
  "collarbone": "heal",
  "collard": "heal",
  "collards": "taste",
  "collate": "smart",
  "collateral": "sell",
  "collateralize": "story",
  "collation": "taste",
  "collect": "story",
  "collectable": "build",
  "collected": "sell",
  "collectible": "build",
  "collecting": "sell",
  "collection": "story",
  "collective": "beautiful",
  "collectivise": "sell",
  "collectivism": "smart",
  "collectivist": "beautiful",
  "collectivize": "sell",
  "collector": "build",
  "college": "build",
  "collembola": "heal",
  "collembolan": "heal",
  "collet": "build",
  "collide": "build",
  "collider": "build",
  "collie": "heal",
  "colliery": "build",
  "colligate": "smart",
  "colligation": "smart",
  "collimator": "build",
  "collins": "taste",
  "collinsia": "heal",
  "collinsonia": "heal",
  "collision": "story",
  "collocalia": "heal",
  "collocate": "smart",
  "collocation": "story",
  "collogue": "story",
  "colloquialism": "story",
  "colloquium": "story",
  "colloquy": "story",
  "collotype": "story",
  "collude": "smart",
  "collusion": "smart",
  "colly": "build",
  "collyrium": "build",
  "colobus": "heal",
  "colocasia": "heal",
  "cologne": "build",
  "colon": "heal",
  "colonial": "beautiful",
  "colonise": "sell",
  "colonize": "sell",
  "colonnade": "build",
  "colonoscope": "build",
  "colophon": "build",
  "color": "beautiful",
  "coloradillo": "heal",
  "coloration": "sound",
  "colorcast": "story",
  "colored": "story",
  "colorful": "beautiful",
  "colorimeter": "build",
  "coloring": "taste",
  "colorless": "beautiful",
  "colors": "beautiful",
  "colosseum": "build",
  "colossians": "story",
  "colostrum": "heal",
  "colour": "beautiful",
  "colouration": "sound",
  "colourcast": "story",
  "coloured": "sell",
  "colourful": "beautiful",
  "colouring": "taste",
  "colourless": "beautiful",
  "colours": "beautiful",
  "colt": "heal",
  "colter": "build",
  "coltsfoot": "heal",
  "coluber": "heal",
  "colubrid": "heal",
  "colubridae": "heal",
  "colubrina": "heal",
  "colugo": "heal",
  "columba": "heal",
  "columbarium": "build",
  "columbary": "build",
  "columbidae": "heal",
  "columbiformes": "heal",
  "columbine": "heal",
  "columbo": "heal",
  "column": "build",
  "columnea": "heal",
  "columned": "beautiful",
  "colutea": "heal",
  "colymbiformes": "heal",
  "colza": "heal",
  "coma": "smart",
  "comanche": "story",
  "comandra": "heal",
  "comatose": "beautiful",
  "comatoseness": "smart",
  "comatula": "heal",
  "comatulid": "heal",
  "comatulidae": "heal",
  "comb": "build",
  "comb-plate": "heal",
  "combatant": "beautiful",
  "combed": "build",
  "comber": "build",
  "combinative": "beautiful",
  "combinatory": "beautiful",
  "combine": "build",
  "combined": "build",
  "combing": "build",
  "combretaceae": "heal",
  "combretum": "heal",
  "combustible": "beautiful",
  "combustion": "smart",
  "come": "heal",
  "come-on": "smart",
  "comeback": "story",
  "comedo": "heal",
  "comedy": "story",
  "comestible": "taste",
  "comfit": "taste",
  "comfortable": "beautiful",
  "comforter": "build",
  "comforts": "sell",
  "comfrey": "heal",
  "comfy": "beautiful",
  "comic": "beautiful",
  "coming": "sound",
  "comma": "story",
  "command": "story",
  "commandeer": "build",
  "commandment": "story",
  "commelina": "heal",
  "commelinaceae": "heal",
  "commelinales": "heal",
  "commelinidae": "heal",
  "commemorate": "smart",
  "commemorating": "smart",
  "commemoration": "story",
  "commence": "build",
  "commend": "story",
  "commendation": "story",
  "commensal": "heal",
  "commensurate": "beautiful",
  "comment": "story",
  "commentary": "story",
  "commentate": "story",
  "commerce": "story",
  "commercial": "sell",
  "commercialize": "taste",
  "comminate": "story",
  "commination": "story",
  "commingle": "build",
  "commiphora": "heal",
  "commiseration": "story",
  "commissariat": "taste",
  "commissary": "build",
  "commission": "sell",
  "commissioned": "sell",
  "commissioning": "sell",
  "commissure": "heal",
  "commit": "sell",
  "commitment": "story",
  "committed": "sell",
  "commix": "build",
  "commode": "build",
  "commodious": "beautiful",
  "commodity": "build",
  "common": "beautiful",
  "commonage": "sell",
  "commoner": "beautiful",
  "commonplace": "story",
  "commove": "build",
  "communal": "beautiful",
  "communalise": "sell",
  "communalize": "sell",
  "commune": "story",
  "communicate": "story",
  "communicating": "story",
  "communication": "story",
  "communications": "smart",
  "communicative": "beautiful",
  "communicatory": "beautiful",
  "communion": "story",
  "communique": "story",
  "communism": "smart",
  "community": "sell",
  "commutable": "beautiful",
  "commutation": "story",
  "commutator": "build",
  "commuter": "build",
  "comp": "story",
  "compact": "build",
  "companionway": "build",
  "comparable": "beautiful",
  "comparative": "story",
  "compare": "smart",
  "comparing": "smart",
  "comparison-shop": "sell",
  "compart": "build",
  "compartment": "build",
  "compartmented": "beautiful",
  "compass": "build",
  "compassionate": "beautiful",
  "compatible": "beautiful",
  "compel": "sell",
  "compendium": "story",
  "compensate": "sell",
  "compensation": "sell",
  "compere": "sell",
  "competent": "beautiful",
  "competitive": "beautiful",
  "competitory": "beautiful",
  "compilation": "story",
  "compile": "sell",
  "compiler": "smart",
  "compiling": "sell",
  "complain": "story",
  "complaining": "story",
  "complaint": "story",
  "complaintive": "beautiful",
  "complement": "story",
  "complementary": "beautiful",
  "complete": "sell",
  "complex": "smart",
  "complexion": "smart",
  "compliant": "beautiful",
  "compliment": "story",
  "complimentary": "beautiful",
  "compliments": "story",
  "complot": "smart",
  "comply": "sell",
  "component": "smart",
  "comport": "sell",
  "compose": "sound",
  "composed": "build",
  "composing": "sound",
  "compositae": "heal",
  "composite": "smart",
  "composition": "beautiful",
  "compote": "taste",
  "compound": "smart",
  "compounding": "sell",
  "comprehend": "smart",
  "comprehendible": "beautiful",
  "comprehensible": "beautiful",
  "comprehension": "smart",
  "comprehensive": "story",
  "comprehensiveness": "smart",
  "compress": "build",
  "compressible": "beautiful",
  "compressing": "build",
  "compressor": "sound",
  "compromise": "story",
  "compromising": "story",
  "compsognathus": "heal",
  "comptonia": "heal",
  "compulsive": "beautiful",
  "computation": "smart",
  "compute": "smart",
  "computer": "smart",
  "computerise": "sell",
  "computerize": "sell",
  "computing": "smart",
  "comtism": "smart",
  "con": "story",
  "conacaste": "heal",
  "concatenate": "build",
  "concave": "beautiful",
  "conceal": "sound",
  "concealed": "sound",
  "concealing": "sound",
  "concealment": "build",
  "concede": "story",
  "conceding": "story",
  "conceit": "story",
  "conceive": "build",
  "concenter": "smart",
  "concentrate": "taste",
  "concentrated": "smart",
  "concentre": "smart",
  "concentric": "beautiful",
  "concentrical": "beautiful",
  "concept": "smart",
  "conception": "smart",
  "conceptualisation": "smart",
  "conceptualise": "build",
  "conceptualism": "smart",
  "conceptuality": "smart",
  "conceptualization": "smart",
  "conceptualize": "build",
  "conceptus": "heal",
  "concern": "smart",
  "concerned": "beautiful",
  "concert": "sound",
  "concertina": "build",
  "concertise": "build",
  "concertize": "build",
  "concerto": "story",
  "concession": "story",
  "conch": "heal",
  "concha": "heal",
  "conchfish": "heal",
  "conciliate": "story",
  "conciliation": "story",
  "conciliative": "beautiful",
  "conciliatory": "beautiful",
  "concise": "beautiful",
  "conciseness": "story",
  "concision": "story",
  "conclude": "smart",
  "conclusion": "smart",
  "conclusive": "beautiful",
  "concoct": "build",
  "concoction": "taste",
  "concomitant": "beautiful",
  "concordance": "story",
  "concordat": "story",
  "concourse": "build",
  "concrete": "build",
  "concretion": "smart",
  "concretism": "smart",
  "concretize": "smart",
  "concur": "story",
  "concurrence": "story",
  "concurrency": "story",
  "concuss": "heal",
  "condemn": "story",
  "condemnation": "story",
  "condensate": "sound",
  "condensation": "smart",
  "condenser": "build",
  "condescend": "sell",
  "condescendingness": "sound",
  "condescension": "story",
  "condiment": "taste",
  "condition": "story",
  "conditional": "beautiful",
  "conditioned": "sell",
  "conditioner": "build",
  "conditioning": "smart",
  "conditions": "sound",
  "condo": "build",
  "condolence": "story",
  "condom": "build",
  "condominium": "build",
  "condone": "story",
  "condor": "heal",
  "conduce": "sell",
  "conduct": "sell",
  "conductance": "sound",
  "conducting": "sell",
  "conduction": "sound",
  "conductive": "beautiful",
  "conductivity": "sound",
  "conductor": "build",
  "conduit": "build",
  "condyle": "heal",
  "condylion": "heal",
  "condylura": "heal",
  "cone": "build",
  "coneflower": "heal",
  "conenose": "heal",
  "conepatus": "heal",
  "conessi": "heal",
  "conestoga": "build",
  "coney": "heal",
  "confab": "story",
  "confabulate": "build",
  "confabulation": "story",
  "confect": "taste",
  "confection": "taste",
  "confectionary": "taste",
  "confectioner": "taste",
  "confectionery": "taste",
  "confederacy": "story",
  "confederate": "sell",
  "confer": "story",
  "conference": "sell",
  "conferment": "taste",
  "conferva": "heal",
  "confess": "story",
  "confession": "story",
  "confessional": "build",
  "confetti": "build",
  "confide": "story",
  "confidence": "smart",
  "confident": "beautiful",
  "confidentiality": "smart",
  "configuration": "smart",
  "configurationism": "smart",
  "configure": "build",
  "confine": "build",
  "confined": "build",
  "confines": "build",
  "confirm": "smart",
  "confirmation": "smart",
  "confirmed": "smart",
  "confirming": "smart",
  "confiscate": "sell",
  "confit": "taste",
  "confiture": "taste",
  "confluent": "beautiful",
  "conformism": "smart",
  "conformist": "beautiful",
  "conformity": "smart",
  "confound": "smart",
  "confront": "story",
  "confrontation": "story",
  "confucianism": "smart",
  "confuse": "smart",
  "confused": "smart",
  "confusedness": "smart",
  "confusion": "smart",
  "confutation": "story",
  "confute": "smart",
  "conga": "story",
  "conge": "build",
  "congealment": "smart",
  "congee": "taste",
  "congelation": "smart",
  "congenator": "heal",
  "congener": "heal",
  "congeneric": "heal",
  "congenial": "beautiful",
  "conger": "heal",
  "congest": "build",
  "congius": "smart",
  "conglomerate": "beautiful",
  "conglutinate": "build",
  "conglutination": "smart",
  "congo": "taste",
  "congou": "taste",
  "congratulate": "story",
  "congratulation": "story",
  "congratulations": "story",
  "congregationalism": "smart",
  "congridae": "heal",
  "congruent": "beautiful",
  "congruous": "beautiful",
  "conidiophore": "heal",
  "conidiospore": "heal",
  "conidium": "heal",
  "conifer": "heal",
  "coniferales": "heal",
  "coniferophyta": "heal",
  "coniferophytina": "heal",
  "coniferopsida": "heal",
  "conilurus": "heal",
  "coniogramme": "heal",
  "conium": "heal",
  "conjecture": "smart",
  "conjoin": "build",
  "conjugate": "story",
  "conjunct": "beautiful",
  "conjunction": "story",
  "conjunctiva": "heal",
  "conjunctive": "story",
  "conjuration": "story",
  "conjure": "build",
  "conjuring": "smart",
  "conjury": "smart",
  "conk": "heal",
  "conker": "heal",
  "connaraceae": "heal",
  "connarus": "heal",
  "connate": "beautiful",
  "connect": "build",
  "connected": "build",
  "connecter": "build",
  "connection": "build",
  "connective": "story",
  "connector": "build",
  "connexion": "smart",
  "connivance": "story",
  "connive": "sell",
  "connochaetes": "heal",
  "connoisseurship": "smart",
  "connotation": "story",
  "connotative": "beautiful",
  "connote": "story",
  "conocarpus": "heal",
  "conoclinium": "heal",
  "conodont": "heal",
  "conodonta": "heal",
  "conodontophorida": "heal",
  "conopodium": "heal",
  "conospermum": "heal",
  "conquer": "sell",
  "conquerable": "beautiful",
  "conquering": "sell",
  "conradina": "heal",
  "conscientious": "beautiful",
  "conscious": "beautiful",
  "consciousness": "smart",
  "consecrate": "sell",
  "consecrated": "sell",
  "consent": "story",
  "consequence": "sound",
  "conservation": "smart",
  "conservatism": "smart",
  "conservative": "beautiful",
  "conservativism": "smart",
  "conservatoire": "build",
  "conservatory": "build",
  "conserve": "taste",
  "conserves": "taste",
  "consider": "smart",
  "considerable": "beautiful",
  "considerate": "beautiful",
  "consideration": "smart",
  "consign": "sell",
  "consignment": "build",
  "consistent": "beautiful",
  "consociate": "sell",
  "consolable": "beautiful",
  "console": "build",
  "consolida": "heal",
  "consomme": "taste",
  "consonance": "story",
  "consonant": "story",
  "consonantal": "beautiful",
  "consonate": "sound",
  "consort": "sell",
  "conspecific": "heal",
  "conspectus": "story",
  "conspicuous": "beautiful",
  "conspiracy": "story",
  "conspire": "smart",
  "constancy": "smart",
  "constant": "smart",
  "constatation": "smart",
  "constellation": "smart",
  "constipate": "heal",
  "constipated": "heal",
  "constituent": "build",
  "constitute": "sell",
  "constituted": "sell",
  "constitution": "story",
  "constitutional": "beautiful",
  "constitutionalism": "smart",
  "constitutionalize": "sell",
  "constrain": "build",
  "constraint": "build",
  "constrict": "build",
  "constricted": "build",
  "constriction": "smart",
  "constrictor": "heal",
  "construal": "story",
  "construct": "build",
  "construction": "build",
  "constructive": "beautiful",
  "construe": "smart",
  "consubstantiation": "smart",
  "consuetudinal": "story",
  "consuetudinary": "story",
  "consulate": "build",
  "consult": "story",
  "consultation": "story",
  "consume": "taste",
  "consumerism": "smart",
  "consummate": "build",
  "consummated": "build",
  "consumption": "smart",
  "consumptive": "beautiful",
  "contagion": "story",
  "contain": "sell",
  "container": "build",
  "containerful": "smart",
  "containerise": "build",
  "containerize": "smart",
  "containership": "build",
  "containment": "smart",
  "contaminated": "beautiful",
  "contaminating": "beautiful",
  "contemplate": "sound",
  "contemplation": "smart",
  "contemplative": "beautiful",
  "contemporaneity": "sound",
  "contemporaneousness": "sound",
  "contemporaries": "sound",
  "contemporary": "sound",
  "contemporise": "sound",
  "contemporize": "sound",
  "contempt": "story",
  "contemptible": "beautiful",
  "contend": "story",
  "content": "story",
  "contented": "taste",
  "contention": "story",
  "contents": "story",
  "contest": "story",
  "contestable": "beautiful",
  "contestation": "story",
  "contested": "story",
  "context": "story",
  "contextualism": "smart",
  "continent": "beautiful",
  "continental": "beautiful",
  "contingent": "beautiful",
  "continual": "beautiful",
  "continuant": "story",
  "continuation": "story",
  "continuative": "story",
  "continue": "story",
  "continued": "story",
  "continuity": "story",
  "continuo": "story",
  "continuous": "beautiful",
  "conto": "smart",
  "contopus": "heal",
  "contort": "build",
  "contour": "smart",
  "contraband": "build",
  "contrabass": "build",
  "contrabassoon": "build",
  "contraceptive": "build",
  "contraclockwise": "beautiful",
  "contract": "sell",
  "contracted": "story",
  "contracting": "story",
  "contraction": "story",
  "contractor": "heal",
  "contradict": "story",
  "contradiction": "story",
  "contradictory": "beautiful",
  "contradistinction": "smart",
  "contradistinguish": "smart",
  "contrafagotto": "build",
  "contraindicate": "story",
  "contraindication": "story",
  "contralateral": "beautiful",
  "contralto": "story",
  "contraption": "build",
  "contrapuntal": "beautiful",
  "contrary": "beautiful",
  "contrast": "beautiful",
  "contrasty": "beautiful",
  "contravene": "sell",
  "contribute": "sell",
  "contribution": "sell",
  "contrivance": "build",
  "contrive": "build",
  "control": "smart",
  "controlled": "sell",
  "controller": "build",
  "controversial": "beautiful",
  "controversy": "story",
  "controvert": "story",
  "contumely": "story",
  "contuse": "build",
  "conundrum": "story",
  "conuropsis": "heal",
  "convalesce": "heal",
  "convalescence": "smart",
  "convalescent": "beautiful",
  "convallaria": "heal",
  "convallariaceae": "heal",
  "convection": "smart",
  "convector": "build",
  "convene": "story",
  "convenience": "build",
  "conveniences": "sell",
  "convenient": "beautiful",
  "convening": "story",
  "convent": "build",
  "conventicle": "build",
  "convention": "smart",
  "conventional": "beautiful",
  "conventionality": "smart",
  "conventionalize": "build",
  "convergence": "smart",
  "convergency": "smart",
  "convergent": "beautiful",
  "conversance": "smart",
  "conversancy": "smart",
  "conversation": "story",
  "converse": "story",
  "conversion": "sell",
  "converter": "build",
  "convertible": "build",
  "convertor": "build",
  "convex": "beautiful",
  "convey": "story",
  "conveyance": "story",
  "conveyer": "build",
  "conveying": "story",
  "conveyor": "build",
  "convict": "story",
  "convictfish": "heal",
  "conviction": "smart",
  "convince": "story",
  "convinced": "story",
  "convincing": "story",
  "convoke": "story",
  "convolute": "build",
  "convolution": "heal",
  "convolve": "build",
  "convolvulaceae": "heal",
  "convolvulus": "heal",
  "convulse": "story",
  "cony": "heal",
  "conyza": "heal",
  "coo": "sell",
  "cook": "taste",
  "cookbook": "story",
  "cooked": "taste",
  "cooker": "build",
  "cookfire": "build",
  "cookhouse": "build",
  "cookie": "taste",
  "cooking": "taste",
  "cookout": "taste",
  "cookstove": "build",
  "cookware": "build",
  "cooky": "taste",
  "cooler": "build",
  "cooling": "smart",
  "coolwart": "heal",
  "coon": "heal",
  "coondog": "heal",
  "coonhound": "heal",
  "coonskin": "build",
  "coontie": "heal",
  "coop": "build",
  "cooperate": "sell",
  "cooperative": "beautiful",
  "coordinate": "smart",
  "coordinating": "sell",
  "coordination": "smart",
  "coordinative": "beautiful",
  "coot": "heal",
  "cooter": "heal",
  "cootie": "heal",
  "cop": "sell",
  "cope": "build",
  "copeck": "smart",
  "copehan": "story",
  "copepod": "heal",
  "copepoda": "heal",
  "copernicia": "heal",
  "copestone": "smart",
  "copier": "build",
  "coping": "build",
  "copper": "sell",
  "copper-bottom": "sell",
  "copperhead": "heal",
  "copperplate": "story",
  "copperware": "build",
  "copra": "taste",
  "coprinaceae": "heal",
  "coprinus": "heal",
  "coptic": "story",
  "coptis": "heal",
  "copula": "story",
  "copulate": "build",
  "copulative": "story",
  "copy": "story",
  "copybook": "story",
  "copyedit": "story",
  "copyhold": "sell",
  "copyholder": "build",
  "copying": "build",
  "copyread": "smart",
  "copyright": "story",
  "coquet": "story",
  "coquette": "story",
  "coquille": "taste",
  "coracan": "heal",
  "coracias": "heal",
  "coraciidae": "heal",
  "coraciiformes": "heal",
  "coracle": "build",
  "coragyps": "heal",
  "corakan": "heal",
  "coral": "taste",
  "coral-wood": "heal",
  "coralbells": "heal",
  "coralberry": "heal",
  "corallorhiza": "heal",
  "coralroot": "heal",
  "coralwood": "heal",
  "coralwort": "heal",
  "corbel": "build",
  "corbie-step": "build",
  "corbiestep": "build",
  "corbina": "heal",
  "corchorus": "heal",
  "cord": "build",
  "cordage": "smart",
  "cordaitaceae": "heal",
  "cordaitales": "heal",
  "cordaites": "heal",
  "cordarone": "build",
  "cordgrass": "heal",
  "cordia": "heal",
  "cordial": "taste",
  "cordite": "build",
  "cordoba": "smart",
  "cordon": "story",
  "cords": "build",
  "corduroy": "build",
  "corduroys": "build",
  "cordylidae": "heal",
  "cordyline": "heal",
  "cordylus": "heal",
  "core": "smart",
  "coregonidae": "heal",
  "coregonus": "heal",
  "coreid": "heal",
  "coreidae": "heal",
  "coreopsis": "heal",
  "corer": "build",
  "corgard": "build",
  "corgi": "heal",
  "coriander": "heal",
  "coriandrum": "heal",
  "coricidin": "build",
  "corium": "heal",
  "corixa": "heal",
  "corixidae": "heal",
  "cork": "build",
  "corkage": "sell",
  "corker": "story",
  "corkscrew": "build",
  "corkwood": "heal",
  "corm": "heal",
  "cormorant": "heal",
  "corn": "heal",
  "cornaceae": "heal",
  "cornbread": "taste",
  "corncrake": "heal",
  "corncrib": "build",
  "cornea": "heal",
  "cornel": "heal",
  "corner": "build",
  "cornerstone": "smart",
  "cornet": "build",
  "cornetfish": "heal",
  "corneum": "heal",
  "cornflower": "heal",
  "cornhusk": "heal",
  "cornice": "build",
  "cornish": "story",
  "cornmeal": "taste",
  "cornpone": "taste",
  "cornsilk": "heal",
  "cornsmut": "heal",
  "cornstalk": "heal",
  "cornu": "heal",
  "cornucopia": "story",
  "cornus": "heal",
  "corokia": "heal",
  "corolla": "heal",
  "corollary": "smart",
  "corona": "sound",
  "coronach": "story",
  "coronal": "build",
  "coronate": "sell",
  "coronet": "build",
  "coronilla": "heal",
  "coronion": "heal",
  "corozo": "heal",
  "corporal": "beautiful",
  "corporate": "beautiful",
  "corporation": "sell",
  "corporeal": "beautiful",
  "corposant": "sound",
  "corpse": "heal",
  "corpus": "sell",
  "corpuscle": "heal",
  "corrade": "build",
  "corral": "build",
  "corrasion": "smart",
  "correct": "sell",
  "corrected": "sell",
  "correction": "smart",
  "corrections": "smart",
  "corrective": "build",
  "correggio": "beautiful",
  "correlate": "smart",
  "correlation": "smart",
  "correlative": "smart",
  "correspond": "story",
  "correspondence": "story",
  "correspondent": "story",
  "corrida": "build",
  "corridor": "build",
  "corrigenda": "story",
  "corrigendum": "story",
  "corrigible": "beautiful",
  "corroborate": "smart",
  "corroboration": "story",
  "corrodentia": "heal",
  "corroding": "smart",
  "corrosion": "smart",
  "corrosive": "beautiful",
  "corrugate": "build",
  "corrupt": "sell",
  "corruption": "smart",
  "corsage": "build",
  "corsair": "build",
  "corselet": "build",
  "corset": "build",
  "corslet": "build",
  "cortaderia": "heal",
  "cortex": "heal",
  "corticium": "heal",
  "corticoid": "sound",
  "corticosteroid": "sound",
  "corticotrophin": "heal",
  "corticotropin": "heal",
  "cortina": "heal",
  "cortinariaceae": "heal",
  "cortinarius": "heal",
  "cortland": "taste",
  "coruscation": "smart",
  "corvette": "build",
  "corvidae": "heal",
  "corvus": "heal",
  "coryanthes": "heal",
  "corydalidae": "heal",
  "corydalis": "heal",
  "corydalus": "heal",
  "corylaceae": "heal",
  "corylopsis": "heal",
  "corylus": "heal",
  "corymb": "heal",
  "corynebacteriaceae": "heal",
  "corynebacterium": "heal",
  "corypha": "heal",
  "coryphaenidae": "heal",
  "coryphantha": "heal",
  "corythosaur": "heal",
  "corythosaurus": "heal",
  "cos": "taste",
  "coscoroba": "heal",
  "cosh": "build",
  "cosign": "sell",
  "cosignatory": "beautiful",
  "cosmea": "heal",
  "cosmetic": "beautiful",
  "cosmic": "beautiful",
  "cosmid": "heal",
  "cosmocampus": "heal",
  "cosmogeny": "smart",
  "cosmogony": "smart",
  "cosmography": "smart",
  "cosmology": "smart",
  "cosmopolitan": "beautiful",
  "cosmos": "heal",
  "cosmotron": "build",
  "cosponsor": "sell",
  "coss": "smart",
  "cosset": "sell",
  "cost": "sell",
  "costa": "heal",
  "costanoan": "story",
  "costia": "heal",
  "costive": "beautiful",
  "costmary": "heal",
  "costs": "sell",
  "costume": "build",
  "costusroot": "heal",
  "cosy": "build",
  "cot": "build",
  "cote": "build",
  "cotinga": "heal",
  "cotingidae": "heal",
  "cotinus": "heal",
  "cotoneaster": "heal",
  "cotswold": "heal",
  "cotswolds": "heal",
  "cottage": "build",
  "cottar": "build",
  "cotter": "build",
  "cottidae": "heal",
  "cotton": "beautiful",
  "cottonmouth": "heal",
  "cottonseed": "heal",
  "cottontail": "heal",
  "cottonweed": "heal",
  "cottonwick": "heal",
  "cottonwood": "heal",
  "cottus": "heal",
  "cotula": "heal",
  "coturnix": "heal",
  "cotyledon": "heal",
  "coucal": "heal",
  "couch": "build",
  "couchette": "build",
  "cougar": "heal",
  "cough": "heal",
  "coughing": "heal",
  "coulisse": "build",
  "coulomb": "smart",
  "coulter": "build",
  "coumadin": "build",
  "coumarouna": "heal",
  "counsel": "story",
  "counseling": "heal",
  "counselling": "story",
  "count": "smart",
  "countenance": "story",
  "counter": "build",
  "counter-drill": "build",
  "counteract": "sell",
  "counterargument": "story",
  "counterattraction": "story",
  "counterbalance": "build",
  "counterblast": "story",
  "counterbore": "build",
  "counterchallenge": "story",
  "countercharge": "story",
  "countercheck": "smart",
  "counterclaim": "story",
  "counterclockwise": "beautiful",
  "counterculture": "smart",
  "counterexample": "smart",
  "counterfeit": "build",
  "counterfoil": "story",
  "counterglow": "sound",
  "counterirritant": "build",
  "countermand": "story",
  "countermarch": "smart",
  "countermine": "sell",
  "counteroffer": "story",
  "counterpane": "build",
  "counterpart": "smart",
  "counterplan": "smart",
  "counterplea": "story",
  "counterplot": "smart",
  "counterpoint": "story",
  "counterpoise": "build",
  "counterpoison": "build",
  "counterproposal": "story",
  "counterrevolutionary": "beautiful",
  "countersign": "story",
  "countersignature": "story",
  "countersink": "build",
  "countertenor": "story",
  "counterterrorism": "smart",
  "countertop": "build",
  "countertransference": "smart",
  "countervail": "sell",
  "counterweight": "build",
  "counting": "story",
  "countinghouse": "build",
  "countryseat": "sell",
  "coupe": "build",
  "couple": "smart",
  "coupler": "build",
  "couplet": "smart",
  "coupling": "build",
  "coupon": "sell",
  "courageous": "beautiful",
  "courbaril": "heal",
  "courgette": "heal",
  "courlan": "heal",
  "courser": "heal",
  "court": "build",
  "court-martial": "sell",
  "courtelle": "build",
  "courteous": "beautiful",
  "courtesy": "story",
  "courthouse": "build",
  "courting": "story",
  "courtroom": "build",
  "courtship": "story",
  "courtyard": "build",
  "couscous": "taste",
  "cousinly": "beautiful",
  "couverture": "taste",
  "covariance": "smart",
  "covariation": "smart",
  "covenant": "story",
  "cover": "build",
  "coverage": "sell",
  "coverall": "build",
  "covered": "build",
  "covering": "build",
  "coverlet": "build",
  "covert": "build",
  "coville": "heal",
  "cow": "heal",
  "cowage": "heal",
  "coward": "sound",
  "cowardly": "beautiful",
  "cowbarn": "build",
  "cowbell": "build",
  "cowberry": "heal",
  "cowbird": "heal",
  "cowcatcher": "build",
  "cowfish": "heal",
  "cowherb": "heal",
  "cowhide": "build",
  "cowhouse": "build",
  "cowl": "build",
  "cowlick": "heal",
  "cowling": "build",
  "cowpea": "heal",
  "cowrie": "heal",
  "cowry": "heal",
  "cows": "heal",
  "cowshed": "build",
  "cowslip": "heal",
  "cox": "sell",
  "coxa": "heal",
  "coxcomb": "build",
  "coxsackievirus": "heal",
  "coydog": "heal",
  "coyol": "heal",
  "coyote": "heal",
  "coypu": "heal",
  "cozen": "sell",
  "cozy": "build",
  "cpi": "story",
  "cpu": "smart",
  "crab": "taste",
  "crabapple": "heal",
  "crabgrass": "heal",
  "crabmeat": "taste",
  "crabs": "heal",
  "cracidae": "heal",
  "crack": "build",
  "cracker": "taste",
  "crackerberry": "heal",
  "crackerjack": "build",
  "cracking": "smart",
  "crackle": "build",
  "crackleware": "build",
  "crackling": "sound",
  "cracklings": "taste",
  "cracticidae": "heal",
  "cracticus": "heal",
  "cradle": "build",
  "cradlesong": "story",
  "craft": "build",
  "craftiness": "smart",
  "craftsmanship": "smart",
  "crake": "heal",
  "cram": "build",
  "crambe": "heal",
  "crammer": "story",
  "cramp": "build",
  "crampbark": "heal",
  "crampfish": "heal",
  "crampon": "build",
  "crampoon": "build",
  "cran": "smart",
  "cranberry": "heal",
  "cranch": "build",
  "crane": "build",
  "cranesbill": "heal",
  "crangon": "heal",
  "crangonidae": "heal",
  "craniata": "heal",
  "craniate": "heal",
  "craniology": "smart",
  "craniometer": "build",
  "craniometry": "smart",
  "cranium": "heal",
  "crank": "build",
  "crankcase": "build",
  "crankshaft": "build",
  "crannied": "beautiful",
  "crap": "story",
  "crapaud": "heal",
  "crape": "taste",
  "crapper": "build",
  "crappie": "taste",
  "craps": "smart",
  "craspedia": "heal",
  "crassostrea": "heal",
  "crassula": "heal",
  "crassulaceae": "heal",
  "crataegus": "heal",
  "crate": "build",
  "crateful": "smart",
  "crateva": "heal",
  "craunch": "build",
  "cravat": "build",
  "crave": "taste",
  "craven": "beautiful",
  "craving": "taste",
  "craw": "heal",
  "crawdad": "taste",
  "crawdaddy": "heal",
  "crawfish": "taste",
  "crawler": "heal",
  "crax": "heal",
  "crayfish": "taste",
  "crayon": "beautiful",
  "craze": "smart",
  "craziness": "smart",
  "crazy": "beautiful",
  "crazyweed": "heal",
  "creak": "sound",
  "creaking": "sound",
  "cream": "taste",
  "creamcups": "heal",
  "creamer": "build",
  "creamery": "build",
  "crease": "build",
  "creashak": "heal",
  "create": "build",
  "creation": "build",
  "creationism": "smart",
  "creative": "beautiful",
  "creativeness": "smart",
  "creativity": "smart",
  "creche": "build",
  "credence": "smart",
  "credendum": "story",
  "credential": "story",
  "credentials": "story",
  "credenza": "build",
  "credible": "beautiful",
  "credit": "story",
  "credits": "story",
  "credo": "smart",
  "credulous": "beautiful",
  "cree": "story",
  "creed": "smart",
  "creel": "build",
  "creep": "build",
  "creeper": "heal",
  "creepiness": "smart",
  "creepy-crawlies": "heal",
  "creepy-crawly": "heal",
  "creese": "build",
  "cremains": "heal",
  "crematorium": "build",
  "crematory": "build",
  "crenel": "build",
  "crenelate": "sell",
  "crenelation": "build",
  "crenellate": "sell",
  "crenellation": "build",
  "crenelle": "build",
  "creole": "story",
  "creole-fish": "heal",
  "creosote": "taste",
  "crepe": "taste",
  "crepis": "heal",
  "crepitate": "sound",
  "crescendo": "beautiful",
  "crescent": "beautiful",
  "crescentia": "heal",
  "cress": "heal",
  "crest": "build",
  "cretonne": "build",
  "crewelwork": "build",
  "crewet": "build",
  "crex": "heal",
  "crib": "build",
  "cricetidae": "heal",
  "cricetus": "heal",
  "crick": "heal",
  "cricket": "heal",
  "criminal": "beautiful",
  "criminalise": "sell",
  "criminalize": "sell",
  "criminate": "story",
  "criminology": "smart",
  "crimp": "heal",
  "crimper": "build",
  "crimson": "heal",
  "cringle": "build",
  "crinkle": "build",
  "crinkle-root": "heal",
  "crinkleroot": "heal",
  "crinoid": "heal",
  "crinoidea": "heal",
  "crinoline": "build",
  "criollo": "taste",
  "cripple": "heal",
  "crisp": "taste",
  "crispness": "story",
  "crisscross": "build",
  "cristal": "build",
  "criterion": "story",
  "crith": "smart",
  "critical": "beautiful",
  "criticise": "story",
  "criticism": "story",
  "criticize": "story",
  "critique": "story",
  "critter": "heal",
  "crixivan": "build",
  "cro": "build",
  "cro-magnon": "heal",
  "croak": "story",
  "croaker": "taste",
  "croaking": "story",
  "crocethia": "heal",
  "crochet": "beautiful",
  "crocheting": "build",
  "crock": "story",
  "crockery": "build",
  "crocket": "build",
  "crocodile": "heal",
  "crocodilia": "heal",
  "crocodilian": "heal",
  "crocodilus": "heal",
  "crocodylia": "heal",
  "crocodylidae": "heal",
  "crocodylus": "heal",
  "crocus": "heal",
  "crocuta": "heal",
  "croft": "build",
  "croissant": "taste",
  "cromlech": "build",
  "cromorne": "build",
  "cronartium": "heal",
  "cronk": "story",
  "crook": "build",
  "crookback": "beautiful",
  "crooked": "beautiful",
  "crookneck": "taste",
  "croon": "story",
  "crooning": "story",
  "crop": "heal",
  "croquet": "build",
  "croquette": "taste",
  "crore": "smart",
  "crosier": "story",
  "cross": "build",
  "cross-check": "smart",
  "cross-classification": "smart",
  "cross-division": "smart",
  "cross-dress": "heal",
  "cross-examination": "story",
  "cross-eyed": "beautiful",
  "cross-fertilise": "heal",
  "cross-fertilize": "heal",
  "cross-file": "sell",
  "cross-index": "story",
  "cross-link": "sound",
  "cross-linkage": "sound",
  "cross-pollinate": "heal",
  "cross-pollinating": "heal",
  "cross-purpose": "smart",
  "cross-question": "story",
  "cross-refer": "story",
  "cross-reference": "story",
  "cross-sectional": "beautiful",
  "cross-stitch": "build",
  "crossbar": "build",
  "crossbeam": "build",
  "crossbench": "build",
  "crossbill": "heal",
  "crossbones": "story",
  "crossbow": "build",
  "crossbred": "build",
  "crossbreed": "heal",
  "crossbreeding": "build",
  "crosscheck": "smart",
  "crosscut": "build",
  "crosse": "build",
  "crossed": "sell",
  "crossfire": "story",
  "crosshairs": "smart",
  "crosshatch": "build",
  "crosshead": "story",
  "crossheading": "story",
  "crossing": "build",
  "crossjack": "build",
  "crossopterygian": "heal",
  "crossopterygii": "heal",
  "crossover": "smart",
  "crosspiece": "build",
  "crossroad": "build",
  "crossroads": "smart",
  "crosstie": "build",
  "crosswalk": "build",
  "crossway": "build",
  "crosswind": "sound",
  "crosswise": "beautiful",
  "crossword": "story",
  "crotal": "heal",
  "crotalaria": "heal",
  "crotalidae": "heal",
  "crotalus": "heal",
  "crotaphion": "heal",
  "crotaphytus": "heal",
  "crotch": "heal",
  "crotchet": "story",
  "croton": "heal",
  "crotonbug": "heal",
  "crotophaga": "heal",
  "crottal": "heal",
  "crottle": "heal",
  "crouch": "build",
  "croup": "heal",
  "croupe": "heal",
  "crouton": "taste",
  "crow": "heal",
  "crow-bait": "heal",
  "crowbait": "heal",
  "crowbar": "build",
  "crowberry": "heal",
  "crowfoot": "heal",
  "crowing": "story",
  "crown": "story",
  "crown-beard": "heal",
  "crown-of-the-field": "heal",
  "crownbeard": "heal",
  "crowned": "sell",
  "crownless": "beautiful",
  "crownwork": "build",
  "crozier": "story",
  "crt": "build",
  "crucial": "beautiful",
  "crucible": "build",
  "crucifer": "heal",
  "cruciferae": "heal",
  "crucifix": "build",
  "crucify": "sell",
  "crude": "beautiful",
  "crudites": "taste",
  "cruet": "build",
  "cruet-stand": "build",
  "cruise": "sound",
  "cruiser": "build",
  "cruller": "taste",
  "crumb": "smart",
  "crumhorn": "build",
  "crump": "sound",
  "crumpet": "taste",
  "crumple": "build",
  "crunch": "story",
  "crupper": "build",
  "crus": "heal",
  "crusade": "sell",
  "cruse": "build",
  "crush": "sound",
  "crusher": "build",
  "crushing": "sell",
  "crustacea": "heal",
  "crustacean": "heal",
  "crutch": "heal",
  "crux": "story",
  "cry": "story",
  "crying": "story",
  "cryobiology": "smart",
  "cryocautery": "build",
  "cryogenics": "smart",
  "cryogeny": "smart",
  "cryometer": "build",
  "cryonics": "smart",
  "cryoscope": "build",
  "cryostat": "build",
  "crypt": "build",
  "cryptacanthodes": "heal",
  "cryptanalysis": "smart",
  "cryptanalyst": "smart",
  "cryptanalytics": "smart",
  "cryptobranchidae": "heal",
  "cryptobranchus": "heal",
  "cryptocercidae": "heal",
  "cryptocercus": "heal",
  "cryptocoryne": "heal",
  "cryptogam": "smart",
  "cryptogamia": "smart",
  "cryptogamic": "smart",
  "cryptogamous": "smart",
  "cryptogram": "smart",
  "cryptogramma": "smart",
  "cryptogrammataceae": "smart",
  "cryptograph": "smart",
  "cryptographer": "smart",
  "cryptographic": "smart",
  "cryptographical": "smart",
  "cryptography": "smart",
  "cryptologist": "smart",
  "cryptology": "smart",
  "cryptomeria": "heal",
  "cryptomonad": "heal",
  "cryptophyceae": "heal",
  "cryptophyta": "heal",
  "cryptophyte": "heal",
  "cryptoprocta": "heal",
  "cryptotermes": "heal",
  "cryptotis": "heal",
  "crystal": "build",
  "crystalise": "smart",
  "crystalize": "smart",
  "crystalline": "beautiful",
  "crystallisation": "sound",
  "crystallise": "smart",
  "crystallised": "smart",
  "crystallization": "sound",
  "crystallize": "smart",
  "crystallized": "smart",
  "crystallizing": "sound",
  "crystallography": "smart",
  "ctene": "heal",
  "ctenidium": "heal",
  "ctenizidae": "heal",
  "ctenocephalides": "heal",
  "ctenocephalus": "heal",
  "ctenophora": "heal",
  "ctenophore": "heal",
  "cub": "heal",
  "cubby": "build",
  "cubbyhole": "build",
  "cube": "smart",
  "cubeb": "heal",
  "cubic": "beautiful",
  "cubicle": "build",
  "cubit": "smart",
  "cubitiere": "build",
  "cubitus": "heal",
  "cuboid": "beautiful",
  "cuckold": "sell",
  "cuckoo": "heal",
  "cuckoo-bumblebee": "heal",
  "cuckooflower": "heal",
  "cuckoopint": "heal",
  "cuculidae": "heal",
  "cuculiformes": "heal",
  "cuculus": "heal",
  "cucumber": "heal",
  "cucumis": "heal",
  "cucurbit": "heal",
  "cucurbita": "heal",
  "cucurbitaceae": "heal",
  "cud": "taste",
  "cuddle": "build",
  "cuddling": "build",
  "cuddy": "build",
  "cudgel": "build",
  "cudweed": "heal",
  "cue": "story",
  "cuff": "build",
  "cufflink": "build",
  "cuirass": "build",
  "cuisine": "taste",
  "cuisse": "build",
  "cuke": "taste",
  "cul": "build",
  "culcita": "heal",
  "culdoscope": "build",
  "culex": "heal",
  "culicidae": "heal",
  "culinary": "taste",
  "cull": "smart",
  "cullender": "build",
  "cullis": "build",
  "culm": "heal",
  "culminate": "sell",
  "culmination": "story",
  "culotte": "build",
  "cult": "smart",
  "cultivar": "heal",
  "cultivate": "build",
  "cultivated": "build",
  "cultivation": "smart",
  "cultivator": "build",
  "cultural": "beautiful",
  "culture": "smart",
  "cultus": "smart",
  "culverin": "build",
  "culvert": "build",
  "cum": "heal",
  "cumber": "build",
  "cumfrey": "heal",
  "cumin": "heal",
  "cuminum": "heal",
  "cummerbund": "build",
  "cumquat": "heal",
  "cuneiform": "story",
  "cuniculus": "heal",
  "cunner": "heal",
  "cunning": "smart",
  "cunoniaceae": "heal",
  "cunt": "heal",
  "cuon": "heal",
  "cup": "build",
  "cupboard": "build",
  "cupcake": "taste",
  "cupel": "build",
  "cupflower": "heal",
  "cupful": "smart",
  "cupid": "story",
  "cupola": "build",
  "cuppa": "taste",
  "cupper": "taste",
  "cupping": "heal",
  "cupressaceae": "heal",
  "cupressus": "heal",
  "cuprimine": "build",
  "cupule": "heal",
  "cur": "heal",
  "curable": "beautiful",
  "curacao": "taste",
  "curacoa": "taste",
  "curassow": "heal",
  "curative": "build",
  "curb": "build",
  "curbing": "build",
  "curbside": "build",
  "curbstone": "build",
  "curculionidae": "heal",
  "curcuma": "heal",
  "curd": "taste",
  "curdling": "smart",
  "cure": "build",
  "cure-all": "build",
  "curet": "build",
  "curette": "build",
  "curfew": "story",
  "curie": "smart",
  "curing": "smart",
  "curio": "build",
  "curiosa": "story",
  "curiosity": "smart",
  "curious": "beautiful",
  "curiousness": "smart",
  "curl": "heal",
  "curler": "build",
  "curlew": "heal",
  "curlicue": "story",
  "curling": "build",
  "curly": "beautiful",
  "curly-heads": "heal",
  "currajong": "heal",
  "currant": "taste",
  "currawong": "heal",
  "currency": "sell",
  "current": "sound",
  "curriculum": "story",
  "currier": "beautiful",
  "curry": "taste",
  "currycomb": "build",
  "curse": "story",
  "cursed": "story",
  "cursive": "story",
  "cursor": "build",
  "cursorial": "beautiful",
  "cursorius": "heal",
  "curst": "story",
  "curtailment": "sound",
  "curtain": "build",
  "curtained": "sell",
  "curtainless": "beautiful",
  "curtilage": "build",
  "curtisia": "heal",
  "curtsey": "story",
  "curtsy": "story",
  "curve": "story",
  "cuscus": "heal",
  "cuscuta": "heal",
  "cush-cush": "heal",
  "cushat": "heal",
  "cushaw": "heal",
  "cushing": "heal",
  "cushion": "build",
  "cushioning": "build",
  "cushitic": "story",
  "cusk": "taste",
  "cusk-eel": "heal",
  "cusp": "build",
  "cuspid": "heal",
  "cuspidation": "build",
  "cuspidor": "build",
  "cuss": "story",
  "custard": "taste",
  "custom": "smart",
  "custom-built": "build",
  "custom-made": "build",
  "custom-make": "build",
  "customhouse": "build",
  "customise": "build",
  "customize": "build",
  "customs": "sell",
  "customshouse": "build",
  "cut": "sell",
  "cutaway": "build",
  "cutch": "heal",
  "cuterebra": "heal",
  "cuterebridae": "heal",
  "cuticle": "heal",
  "cuticula": "heal",
  "cutis": "heal",
  "cutlas": "build",
  "cutlass": "build",
  "cutlassfish": "heal",
  "cutlery": "build",
  "cutlet": "taste",
  "cutoff": "smart",
  "cutout": "build",
  "cutter": "build",
  "cutthroat": "beautiful",
  "cutting": "heal",
  "cuttle": "heal",
  "cuttlefish": "heal",
  "cutwork": "build",
  "cutworm": "heal",
  "cwt": "smart",
  "cyamopsis": "heal",
  "cyamus": "heal",
  "cyan": "beautiful",
  "cyanobacteria": "heal",
  "cyanocitta": "heal",
  "cyanophyceae": "heal",
  "cyanophyta": "heal",
  "cyathea": "heal",
  "cyatheaceae": "heal",
  "cyber-terrorist": "smart",
  "cyberart": "build",
  "cybercafe": "build",
  "cyberculture": "smart",
  "cybernate": "build",
  "cybernetics": "smart",
  "cyberpunk": "story",
  "cyberspace": "build",
  "cycad": "heal",
  "cycadaceae": "heal",
  "cycadales": "heal",
  "cycadofilicales": "heal",
  "cycadophyta": "heal",
  "cycadophytina": "heal",
  "cycadopsida": "heal",
  "cycas": "heal",
  "cyclamen": "heal",
  "cyclic": "beautiful",
  "cyclical": "beautiful",
  "cycliophora": "heal",
  "cyclobenzaprine": "build",
  "cycloid": "beautiful",
  "cycloloma": "heal",
  "cyclone": "sound",
  "cyclopaedia": "story",
  "cyclopedia": "story",
  "cyclopes": "heal",
  "cyclophorus": "heal",
  "cyclopropane": "build",
  "cyclops": "heal",
  "cyclopteridae": "heal",
  "cyclopterus": "heal",
  "cyclorama": "build",
  "cycloserine": "build",
  "cyclosis": "sound",
  "cyclosorus": "heal",
  "cyclosporeae": "heal",
  "cyclostomata": "heal",
  "cyclostome": "heal",
  "cyclostyle": "build",
  "cyclotron": "build",
  "cycnoches": "heal",
  "cyder": "taste",
  "cydippea": "heal",
  "cydippida": "heal",
  "cydippidea": "heal",
  "cydonia": "heal",
  "cygnet": "heal",
  "cygnus": "heal",
  "cylinder": "build",
  "cylix": "build",
  "cyma": "build",
  "cymatiidae": "heal",
  "cymatium": "build",
  "cymbal": "build",
  "cymbid": "heal",
  "cymbidium": "heal",
  "cyme": "heal",
  "cymling": "heal",
  "cymograph": "build",
  "cymric": "story",
  "cymule": "heal",
  "cynancum": "heal",
  "cynara": "heal",
  "cynipidae": "heal",
  "cynips": "heal",
  "cynocephalidae": "heal",
  "cynocephalus": "heal",
  "cynodon": "heal",
  "cynodont": "heal",
  "cynodontia": "heal",
  "cynoglossidae": "heal",
  "cynoglossum": "heal",
  "cynomys": "heal",
  "cynopterus": "heal",
  "cynoscion": "heal",
  "cynosure": "story",
  "cyon": "heal",
  "cyperaceae": "heal",
  "cyperus": "heal",
  "cypher": "smart",
  "cyphomandra": "heal",
  "cypraea": "heal",
  "cypraeidae": "heal",
  "cypre": "heal",
  "cypress": "heal",
  "cyprian": "beautiful",
  "cyprinid": "heal",
  "cyprinidae": "heal",
  "cypriniformes": "heal",
  "cyprinodont": "heal",
  "cyprinodontidae": "heal",
  "cyprinus": "heal",
  "cypripedia": "heal",
  "cypripedium": "heal",
  "cyproheptadine": "build",
  "cyrilla": "heal",
  "cyrilliaceae": "heal",
  "cyrillic": "story",
  "cyrtomium": "heal",
  "cyst": "heal",
  "cystophora": "heal",
  "cystopteris": "heal",
  "cytisus": "heal",
  "cytogenesis": "smart",
  "cytogenetics": "smart",
  "cytogeny": "smart",
  "cytokinesis": "smart",
  "cytol": "heal",
  "cytology": "smart",
  "cytolysis": "smart",
  "cytomegalovirus": "heal",
  "cytomembrane": "heal",
  "cytophotometer": "build",
  "cytoplasm": "heal",
  "cytoplast": "heal",
  "cytosine": "sound",
  "cytoskeleton": "heal",
  "cytosmear": "heal",
  "cytosol": "heal",
  "cytostome": "heal",
  "cytotoxicity": "smart",
  "czech": "story",
  "d.a.": "story",
  "dab": "smart",
  "daba": "story",
  "dabble": "sell",
  "dabbler": "heal",
  "dabchick": "heal",
  "daboecia": "heal",
  "dace": "heal",
  "dacelo": "heal",
  "dacha": "build",
  "dachau": "build",
  "dachshund": "heal",
  "dachsie": "heal",
  "dacninae": "heal",
  "dacron": "build",
  "dacrycarpus": "heal",
  "dacrydium": "heal",
  "dacrymyces": "heal",
  "dacrymycetaceae": "heal",
  "dacryocyst": "heal",
  "dacryon": "heal",
  "dactyl": "story",
  "dactylis": "heal",
  "dactyloctenium": "heal",
  "dactylopiidae": "heal",
  "dactylopius": "heal",
  "dactylopteridae": "heal",
  "dactylopterus": "heal",
  "dactylorhiza": "heal",
  "dactyloscopidae": "heal",
  "dado": "build",
  "daedal": "beautiful",
  "daffo": "story",
  "daffodil": "heal",
  "dafla": "story",
  "dag": "smart",
  "dagame": "heal",
  "dagga": "heal",
  "dagger": "build",
  "daggerboard": "build",
  "daguerreotype": "build",
  "dah": "story",
  "dahl": "heal",
  "dahlia": "heal",
  "daikon": "heal",
  "daily": "story",
  "dainty": "taste",
  "daiquiri": "taste",
  "dairy": "build",
  "dais": "build",
  "daishiki": "build",
  "daisy": "heal",
  "daisy-bush": "heal",
  "daisy-chain": "build",
  "daisybush": "heal",
  "dak": "heal",
  "dakota": "story",
  "dal": "smart",
  "dalasi": "smart",
  "dalbergia": "heal",
  "dalea": "heal",
  "daleth": "story",
  "dallisgrass": "heal",
  "dally": "sell",
  "dalmane": "build",
  "dalmatian": "heal",
  "dalo": "heal",
  "dam": "build",
  "dama": "heal",
  "damage": "sell",
  "damaged": "beautiful",
  "damages": "sell",
  "damaliscus": "heal",
  "damascene": "build",
  "damask": "build",
  "damn": "story",
  "damnation": "story",
  "damned": "story",
  "damp": "sound",
  "dampen": "sound",
  "dampener": "build",
  "dampening": "sound",
  "damper": "build",
  "damselfish": "heal",
  "damselfly": "heal",
  "damson": "taste",
  "danaea": "heal",
  "danaid": "heal",
  "danaidae": "heal",
  "danaus": "heal",
  "dance": "story",
  "dancing": "beautiful",
  "dandelion": "heal",
  "dandify": "heal",
  "dandle": "build",
  "dandy": "build",
  "danewort": "heal",
  "dangaleat": "story",
  "dangerous": "beautiful",
  "dangla": "story",
  "dangle": "build",
  "dangle-berry": "heal",
  "dangleberry": "heal",
  "dangling": "build",
  "daniel": "story",
  "danish": "story",
  "dano-norwegian": "story",
  "daoism": "smart",
  "daphne": "heal",
  "daphnia": "heal",
  "dapsone": "build",
  "daraf": "smart",
  "dard": "story",
  "dardic": "story",
  "dare": "story",
  "daredevil": "beautiful",
  "dari": "story",
  "daricon": "build",
  "daring": "story",
  "darjeeling": "taste",
  "darken": "build",
  "darkening": "build",
  "darkness": "smart",
  "darkroom": "build",
  "darling": "beautiful",
  "darlingtonia": "heal",
  "darmera": "heal",
  "darn": "build",
  "darnel": "heal",
  "darning": "build",
  "darsana": "smart",
  "dart": "build",
  "dartboard": "build",
  "darter": "heal",
  "dartmouth": "build",
  "darts": "build",
  "darvon": "build",
  "darwinism": "smart",
  "das": "heal",
  "dash": "story",
  "dash-pot": "build",
  "dashboard": "build",
  "dasheen": "heal",
  "dashiki": "build",
  "dassie": "heal",
  "dastard": "beautiful",
  "dasyatidae": "heal",
  "dasyatis": "heal",
  "dasymeter": "build",
  "dasypodidae": "heal",
  "dasyprocta": "heal",
  "dasyproctidae": "heal",
  "dasypus": "heal",
  "dasyure": "heal",
  "dasyurid": "heal",
  "dasyuridae": "heal",
  "dasyurus": "heal",
  "dat": "build",
  "data": "smart",
  "database": "smart",
  "datable": "beautiful",
  "date-mark": "smart",
  "dateable": "beautiful",
  "dateline": "story",
  "datemark": "smart",
  "dating": "sell",
  "dative": "story",
  "datril": "build",
  "datum": "smart",
  "datura": "heal",
  "daub": "build",
  "daubentonia": "heal",
  "daubentoniidae": "heal",
  "daubing": "build",
  "daucus": "heal",
  "daumier": "beautiful",
  "davallia": "heal",
  "davalliaceae": "heal",
  "davenport": "build",
  "daviesia": "heal",
  "davit": "build",
  "daw": "heal",
  "dawn": "smart",
  "dawning": "smart",
  "daybed": "build",
  "daybook": "sell",
  "daydream": "smart",
  "daydreaming": "smart",
  "dayflower": "heal",
  "dayfly": "heal",
  "daylight": "sound",
  "daylily": "heal",
  "daypro": "build",
  "daze": "smart",
  "dazzle": "sound",
  "dba": "story",
  "dbms": "story",
  "ddc": "build",
  "ddi": "build",
  "dds": "story",
  "de-access": "sell",
  "de-aerate": "sell",
  "de-energise": "heal",
  "de-energize": "heal",
  "de-iodinating": "beautiful",
  "de-iodination": "smart",
  "de-nazification": "smart",
  "de-stalinisation": "smart",
  "de-stalinization": "smart",
  "deaccession": "sell",
  "dead": "beautiful",
  "dead-man's-fingers": "heal",
  "dead-men's-fingers": "heal",
  "deadbolt": "build",
  "deaden": "build",
  "deadening": "build",
  "deadeye": "build",
  "deadhead": "build",
  "deadlight": "build",
  "deadwood": "heal",
  "deaerate": "sell",
  "deaf": "sound",
  "deaf-aid": "build",
  "deaf-mute": "beautiful",
  "deafen": "sound",
  "deal": "sell",
  "dealfish": "heal",
  "dealignment": "smart",
  "dealing": "story",
  "deamination": "smart",
  "deaminization": "smart",
  "deanery": "build",
  "dear": "beautiful",
  "dearest": "beautiful",
  "death": "sound",
  "death-roll": "story",
  "deathbed": "build",
  "deathtrap": "build",
  "deathwatch": "heal",
  "debacle": "sound",
  "debar": "sell",
  "debase": "sell",
  "debate": "story",
  "debauch": "sell",
  "debenture": "sell",
  "debilitating": "beautiful",
  "debit": "sell",
  "debrief": "story",
  "debriefing": "story",
  "debt": "sell",
  "debugger": "smart",
  "debunk": "story",
  "debunking": "story",
  "debut": "story",
  "decade": "smart",
  "decadence": "sound",
  "decadent": "beautiful",
  "decaf": "taste",
  "decaffeinate": "sell",
  "decagram": "smart",
  "decal": "build",
  "decalcification": "smart",
  "decalcomania": "build",
  "decalescence": "sound",
  "decaliter": "smart",
  "decalitre": "smart",
  "decalogue": "story",
  "decameter": "smart",
  "decametre": "smart",
  "decanter": "build",
  "decapitate": "build",
  "decapod": "heal",
  "decapoda": "heal",
  "decapterus": "heal",
  "decarbonate": "sell",
  "decarboxylation": "smart",
  "decasyllable": "story",
  "decay": "smart",
  "deceased": "beautiful",
  "deceit": "story",
  "deceive": "sell",
  "decent": "beautiful",
  "decentalisation": "smart",
  "decentralised": "beautiful",
  "decentralising": "beautiful",
  "decentralization": "smart",
  "decentralized": "beautiful",
  "decentralizing": "beautiful",
  "deception": "story",
  "decerebrate": "sell",
  "decertify": "sell",
  "dechlorinate": "sell",
  "decibel": "sound",
  "decide": "smart",
  "deciding": "smart",
  "decidua": "heal",
  "deciduous": "beautiful",
  "decigram": "smart",
  "decile": "smart",
  "deciliter": "smart",
  "decilitre": "smart",
  "decimal": "smart",
  "decimeter": "smart",
  "decimetre": "smart",
  "decipher": "story",
  "deciphered": "story",
  "decision": "smart",
  "decisive": "beautiful",
  "deck": "build",
  "deck-house": "build",
  "decker": "build",
  "deckle": "build",
  "declaim": "story",
  "declamation": "story",
  "declaration": "story",
  "declarative": "beautiful",
  "declaratory": "beautiful",
  "declare": "story",
  "declared": "story",
  "declassify": "sell",
  "declension": "smart",
  "declination": "story",
  "decline": "smart",
  "declinometer": "build",
  "declomycin": "build",
  "decoagulant": "build",
  "decoction": "smart",
  "decode": "story",
  "decoder": "build",
  "decoding": "story",
  "decollate": "build",
  "decolletage": "build",
  "decolonise": "sell",
  "decolonize": "sell",
  "decommission": "sell",
  "decomposition": "smart",
  "decompress": "build",
  "decompressing": "build",
  "decongestant": "build",
  "deconsecrate": "story",
  "deconstruct": "story",
  "deconstruction": "smart",
  "deconstructionism": "smart",
  "decontrol": "sell",
  "decor": "beautiful",
  "decorate": "beautiful",
  "decorated": "build",
  "decoration": "beautiful",
  "decorous": "beautiful",
  "decorticate": "build",
  "decoupage": "build",
  "decouple": "build",
  "decoy": "build",
  "decrease": "smart",
  "decreased": "beautiful",
  "decreasing": "beautiful",
  "decree": "story",
  "decrement": "smart",
  "decrescendo": "beautiful",
  "decriminalise": "sell",
  "decriminalize": "sell",
  "decry": "story",
  "decrypt": "story",
  "decumaria": "heal",
  "decumary": "heal",
  "decussate": "beautiful",
  "decussation": "heal",
  "ded": "story",
  "dedicate": "story",
  "dedicated": "story",
  "dedication": "story",
  "dedifferentiation": "smart",
  "deduce": "smart",
  "deduct": "smart",
  "deductible": "sell",
  "deduction": "sell",
  "deductive": "beautiful",
  "deed": "story",
  "deedbox": "build",
  "deeds": "story",
  "deem": "smart",
  "deep": "beautiful",
  "deep-freeze": "build",
  "deep-six": "sell",
  "deepening": "smart",
  "deepfreeze": "build",
  "deepness": "smart",
  "deer": "heal",
  "deer's-ear": "heal",
  "deer's-ears": "heal",
  "deerberry": "heal",
  "deerhound": "heal",
  "deerstalker": "build",
  "deface": "build",
  "defalcate": "sell",
  "defalcation": "sell",
  "defamation": "story",
  "defame": "story",
  "defat": "sell",
  "default": "sell",
  "defeasible": "beautiful",
  "defeat": "sell",
  "defeated": "sell",
  "defecate": "heal",
  "defecation": "smart",
  "defeminise": "heal",
  "defeminize": "heal",
  "defence": "smart",
  "defend": "story",
  "defenestrate": "build",
  "defense": "story",
  "defensive": "smart",
  "defer": "story",
  "deferment": "taste",
  "defiance": "story",
  "defiant": "beautiful",
  "defibrillate": "sell",
  "defibrillator": "heal",
  "defibrinate": "sell",
  "deficient": "beautiful",
  "deficit": "smart",
  "defilade": "build",
  "defile": "build",
  "define": "story",
  "defined": "story",
  "defining": "smart",
  "definite": "beautiful",
  "definition": "story",
  "deflagration": "smart",
  "deflate": "build",
  "deflation": "smart",
  "deflationary": "beautiful",
  "deflator": "sell",
  "deflect": "sell",
  "deflector": "build",
  "deflower": "build",
  "defoliate": "beautiful",
  "defoliation": "smart",
  "defoliator": "heal",
  "deform": "build",
  "defraud": "sell",
  "defray": "sell",
  "defrock": "sell",
  "defroster": "build",
  "deftness": "smart",
  "defy": "story",
  "degaussing": "smart",
  "degenerate": "heal",
  "degeneration": "smart",
  "deglaze": "build",
  "degrade": "build",
  "degrease": "sell",
  "degree": "story",
  "degust": "taste",
  "degustation": "taste",
  "dehiscence": "sound",
  "dehiscent": "beautiful",
  "dehumidify": "sound",
  "dehydration": "smart",
  "deicer": "build",
  "deictic": "story",
  "deify": "smart",
  "deign": "sell",
  "deinocheirus": "heal",
  "deinonychus": "heal",
  "deionize": "sell",
  "deism": "smart",
  "deixis": "smart",
  "dejected": "beautiful",
  "dejeuner": "taste",
  "dekagram": "smart",
  "dekaliter": "smart",
  "dekalitre": "smart",
  "dekameter": "smart",
  "dekametre": "smart",
  "delairea": "heal",
  "delavirdine": "build",
  "delegate": "sell",
  "delegating": "sell",
  "delete": "build",
  "deletion": "smart",
  "delf": "build",
  "delft": "build",
  "deli": "build",
  "deliberate": "story",
  "deliberation": "story",
  "delicacy": "taste",
  "delicate": "beautiful",
  "delicatessen": "taste",
  "delichon": "heal",
  "delicious": "taste",
  "delight": "smart",
  "delimit": "smart",
  "delimitate": "smart",
  "delineate": "build",
  "delineated": "build",
  "delineation": "story",
  "delinquency": "sell",
  "delinquent": "beautiful",
  "delist": "sell",
  "deliver": "story",
  "deliverable": "build",
  "delivery": "story",
  "delocalize": "sell",
  "delonix": "heal",
  "delphic": "beautiful",
  "delphinapterus": "heal",
  "delphinidae": "heal",
  "delphinium": "heal",
  "delphinus": "heal",
  "delta": "story",
  "deltoid": "heal",
  "delude": "sell",
  "deluge": "smart",
  "delusion": "smart",
  "delve": "build",
  "demagnetisation": "smart",
  "demagnetise": "story",
  "demagnetization": "smart",
  "demagnetize": "story",
  "demagoguery": "story",
  "demagogy": "story",
  "demand": "sell",
  "demanding": "story",
  "demarcate": "smart",
  "demarcation": "smart",
  "demasculinise": "heal",
  "demasculinize": "heal",
  "dematiaceae": "heal",
  "demerara": "taste",
  "demerit": "story",
  "demerol": "build",
  "demesne": "sell",
  "demi-glaze": "build",
  "demiglace": "taste",
  "demijohn": "build",
  "demineralisation": "smart",
  "demineralization": "smart",
  "demise": "sell",
  "demisemiquaver": "story",
  "demister": "build",
  "demitasse": "taste",
  "demo": "story",
  "democracy": "smart",
  "democratic": "beautiful",
  "democratise": "sell",
  "democratize": "sell",
  "demodulate": "build",
  "demodulation": "story",
  "demodulator": "build",
  "demographic": "smart",
  "demography": "smart",
  "demoiselle": "heal",
  "demolish": "build",
  "demolishing": "build",
  "demonetization": "sell",
  "demonetize": "sell",
  "demoniac": "beautiful",
  "demonisation": "story",
  "demonism": "smart",
  "demonization": "story",
  "demonstrate": "sound",
  "demonstration": "story",
  "demonstrative": "story",
  "demoralise": "sell",
  "demoralize": "sell",
  "demote": "sell",
  "demotic": "story",
  "demulcent": "build",
  "demulen": "build",
  "demur": "story",
  "demurrage": "sell",
  "demurral": "story",
  "demurrer": "story",
  "demyelinate": "build",
  "demythologisation": "story",
  "demythologization": "story",
  "den": "build",
  "denazification": "smart",
  "dendranthema": "heal",
  "dendraspis": "heal",
  "dendrite": "heal",
  "dendroaspis": "heal",
  "dendrobium": "heal",
  "dendrocalamus": "heal",
  "dendrocolaptes": "heal",
  "dendrocolaptidae": "heal",
  "dendroctonus": "heal",
  "dendroica": "heal",
  "dendrolagus": "heal",
  "dendromecon": "heal",
  "deniable": "beautiful",
  "denial": "story",
  "denier": "smart",
  "denigrate": "story",
  "denigration": "story",
  "denim": "build",
  "denisonia": "heal",
  "denizen": "heal",
  "dennstaedtia": "heal",
  "dennstaedtiaceae": "heal",
  "denominate": "story",
  "denomination": "story",
  "denominational": "beautiful",
  "denominationalism": "smart",
  "denominator": "smart",
  "denotation": "story",
  "denotative": "beautiful",
  "denotatum": "story",
  "denote": "story",
  "denotive": "beautiful",
  "denouement": "story",
  "denounce": "story",
  "denouncement": "story",
  "denseness": "smart",
  "densimeter": "build",
  "densitometer": "build",
  "dent": "sound",
  "dental": "story",
  "dentaria": "heal",
  "denticle": "heal",
  "dentifrice": "build",
  "dentin": "heal",
  "dentine": "heal",
  "dentistry": "smart",
  "dentition": "smart",
  "denture": "build",
  "denudate": "beautiful",
  "denunciation": "story",
  "deny": "story",
  "deodar": "heal",
  "deodorant": "build",
  "deodorise": "sound",
  "deodorize": "sound",
  "deodourant": "build",
  "deodourise": "sound",
  "deossification": "smart",
  "deoxyephedrine": "build",
  "deoxygenate": "sell",
  "deoxythymidine": "sound",
  "deparia": "heal",
  "department": "smart",
  "depend": "smart",
  "dependable": "beautiful",
  "dependant": "beautiful",
  "dependent": "beautiful",
  "depict": "build",
  "depicting": "smart",
  "depiction": "story",
  "depigmentation": "beautiful",
  "depilate": "heal",
  "depilator": "build",
  "depilatory": "build",
  "deplete": "taste",
  "deplore": "story",
  "deploy": "smart",
  "deplumate": "build",
  "deplume": "sell",
  "depokene": "build",
  "depolarisation": "sound",
  "depolarization": "sound",
  "depone": "story",
  "deport": "sell",
  "depose": "sell",
  "deposit": "sound",
  "depositary": "build",
  "deposition": "story",
  "depository": "build",
  "depot": "build",
  "deprave": "sell",
  "deprecate": "story",
  "deprecation": "story",
  "depreciate": "story",
  "depreciation": "sell",
  "depress": "build",
  "depressant": "build",
  "depressing": "build",
  "depressor": "heal",
  "deprive": "sell",
  "depute": "sell",
  "deputise": "sell",
  "deputize": "sell",
  "deracinate": "sell",
  "derby": "build",
  "derecognise": "sell",
  "derecognize": "sell",
  "deregulate": "sell",
  "deregulating": "sell",
  "derelict": "build",
  "derequisition": "sell",
  "derestrict": "sell",
  "deride": "story",
  "derision": "story",
  "derivation": "story",
  "derivational": "beautiful",
  "derivative": "smart",
  "derive": "smart",
  "derived": "smart",
  "deriving": "story",
  "derma": "heal",
  "dermacentor": "heal",
  "dermaptera": "heal",
  "dermatobia": "heal",
  "dermatoglyphics": "smart",
  "dermatologist": "heal",
  "dermatology": "heal",
  "dermatome": "build",
  "dermestidae": "heal",
  "dermis": "heal",
  "dermochelyidae": "heal",
  "dermochelys": "heal",
  "dermoptera": "heal",
  "derogate": "story",
  "derogation": "story",
  "derrick": "build",
  "derriere": "heal",
  "derringer": "build",
  "derris": "heal",
  "des": "build",
  "desacralize": "sell",
  "desalination": "smart",
  "desalinisation": "smart",
  "desalinization": "smart",
  "descale": "build",
  "descant": "story",
  "descend": "sell",
  "descendant": "beautiful",
  "descendent": "beautiful",
  "descender": "story",
  "descending": "sell",
  "describe": "story",
  "description": "story",
  "descriptive": "beautiful",
  "descriptivism": "smart",
  "descriptor": "story",
  "descry": "sound",
  "descurainia": "heal",
  "desecrate": "sell",
  "desecrated": "sell",
  "desegregate": "sell",
  "desensitisation": "smart",
  "desensitise": "sound",
  "desensitising": "sound",
  "desensitization": "smart",
  "desensitize": "sound",
  "desensitizing": "sound",
  "desert": "smart",
  "desertification": "smart",
  "deserts": "smart",
  "deserved": "beautiful",
  "desex": "heal",
  "desexualise": "heal",
  "desexualize": "heal",
  "desiccate": "beautiful",
  "desiccation": "smart",
  "design": "smart",
  "designate": "story",
  "designation": "story",
  "designatum": "story",
  "designed": "build",
  "designing": "build",
  "desipramine": "build",
  "desirable": "beautiful",
  "desirous": "beautiful",
  "desist": "taste",
  "desk": "build",
  "desktop": "build",
  "desmanthus": "heal",
  "desmid": "heal",
  "desmidiaceae": "sound",
  "desmidium": "sound",
  "desmodium": "heal",
  "desmodontidae": "heal",
  "desmodus": "heal",
  "desmograthus": "heal",
  "desolate": "smart",
  "desorption": "smart",
  "despatch": "story",
  "desperate": "beautiful",
  "despoil": "sell",
  "despotic": "beautiful",
  "desquamate": "heal",
  "desquamation": "sound",
  "dessert": "taste",
  "dessertspoon": "smart",
  "dessertspoonful": "smart",
  "dessiatine": "smart",
  "destain": "sell",
  "destalinisation": "smart",
  "destalinization": "smart",
  "destination": "smart",
  "destine": "story",
  "destroy": "build",
  "destroyed": "build",
  "destroyer": "build",
  "destruct": "build",
  "destructible": "beautiful",
  "destructive": "beautiful",
  "desulfurize": "sell",
  "desulphurize": "sell",
  "desyrel": "build",
  "detach": "build",
  "detachable": "beautiful",
  "detached": "build",
  "detail": "smart",
  "detailing": "story",
  "details": "story",
  "detain": "sell",
  "detect": "sound",
  "detected": "sound",
  "detecting": "sound",
  "detection": "smart",
  "detector": "build",
  "detent": "build",
  "deter": "story",
  "deterge": "build",
  "detergent": "build",
  "deteriorate": "heal",
  "deterioration": "smart",
  "determent": "story",
  "determinable": "beautiful",
  "determinant": "smart",
  "determinate": "beautiful",
  "determination": "smart",
  "determinative": "story",
  "determine": "story",
  "determined": "story",
  "determiner": "story",
  "determinism": "smart",
  "deterrence": "story",
  "deterrent": "smart",
  "dethrone": "sell",
  "detick": "sell",
  "detonator": "build",
  "detour": "build",
  "detox": "build",
  "detoxification": "heal",
  "detoxify": "heal",
  "detraction": "story",
  "detrition": "smart",
  "detumescence": "smart",
  "deuce": "smart",
  "deuce-ace": "smart",
  "deuteromycetes": "heal",
  "deuteromycota": "heal",
  "deuteromycotina": "heal",
  "deuteronomy": "story",
  "deutschmark": "smart",
  "deutzia": "heal",
  "devanagari": "story",
  "devein": "sell",
  "develop": "build",
  "developed": "build",
  "developer": "build",
  "developing": "smart",
  "development": "smart",
  "deviant": "beautiful",
  "deviation": "smart",
  "device": "build",
  "devices": "smart",
  "devil": "story",
  "devilfish": "heal",
  "devilwood": "heal",
  "devise": "sell",
  "devising": "build",
  "devoice": "story",
  "devolution": "smart",
  "devolve": "sell",
  "devon": "heal",
  "devote": "story",
  "devotional": "beautiful",
  "devour": "build",
  "dewar": "build",
  "dewberry": "heal",
  "dewlap": "heal",
  "dexedrine": "build",
  "dexterity": "smart",
  "dextral": "beautiful",
  "dhak": "heal",
  "dhal": "heal",
  "dhava": "heal",
  "dhawa": "heal",
  "dhegiha": "story",
  "dhole": "heal",
  "dhoti": "build",
  "dhow": "build",
  "diabatic": "beautiful",
  "diabeta": "build",
  "diabetic": "beautiful",
  "diabolism": "smart",
  "diacalpa": "heal",
  "diacetylmorphine": "build",
  "diachronic": "beautiful",
  "diachrony": "smart",
  "diacritic": "story",
  "diadem": "build",
  "diadophis": "heal",
  "diadromous": "beautiful",
  "diaeresis": "story",
  "diaglyph": "build",
  "diagnose": "heal",
  "diagnosing": "heal",
  "diagnosis": "heal",
  "diagnostic": "heal",
  "diagnostician": "heal",
  "diagnostics": "heal",
  "diagonalisation": "smart",
  "diagonalization": "smart",
  "diagram": "build",
  "diagramming": "build",
  "diakinesis": "smart",
  "dial": "build",
  "dialect": "story",
  "dialectic": "story",
  "dialectics": "smart",
  "dialectology": "smart",
  "dialeurodes": "heal",
  "dialog": "story",
  "dialogue": "story",
  "dialyzer": "build",
  "diamagnetism": "sound",
  "diamante": "build",
  "diametric": "beautiful",
  "diametrical": "beautiful",
  "diamond": "sell",
  "diamondback": "heal",
  "dianthus": "heal",
  "diapason": "build",
  "diapedesis": "sound",
  "diapensia": "heal",
  "diapensiaceae": "heal",
  "diapensiales": "heal",
  "diaper": "build",
  "diapheromera": "heal",
  "diaphone": "build",
  "diaphoresis": "smart",
  "diaphoretic": "build",
  "diaphragm": "build",
  "diaphysis": "heal",
  "diapsid": "heal",
  "diapsida": "heal",
  "diarthrosis": "heal",
  "diary": "story",
  "diaspididae": "heal",
  "diastema": "heal",
  "diastrophism": "smart",
  "diatom": "heal",
  "diatomophyceae": "heal",
  "diatonic": "beautiful",
  "diatribe": "story",
  "diazepam": "build",
  "diazoxide": "build",
  "dibber": "build",
  "dibble": "build",
  "dibrach": "story",
  "dibranch": "heal",
  "dibranchia": "heal",
  "dibranchiata": "heal",
  "dibranchiate": "heal",
  "dibs": "story",
  "dibucaine": "build",
  "dicamptodon": "heal",
  "dicamptodontid": "heal",
  "dicamptodontidae": "heal",
  "dice": "build",
  "dicentra": "heal",
  "dicer": "build",
  "diceros": "heal",
  "dichondra": "heal",
  "dichotomise": "smart",
  "dichotomize": "smart",
  "dichroism": "sound",
  "dichromatic": "beautiful",
  "dick": "heal",
  "dickens": "story",
  "dicker": "sell",
  "dickey": "build",
  "dickey-bird": "heal",
  "dickey-seat": "build",
  "dickeybird": "heal",
  "dickie": "build",
  "dickie-seat": "build",
  "dicksonia": "heal",
  "dicksoniaceae": "heal",
  "dicky": "build",
  "dicky-bird": "heal",
  "dicky-seat": "build",
  "dickybird": "heal",
  "diclinous": "beautiful",
  "dicloxacillin": "build",
  "dicot": "heal",
  "dicotyledon": "heal",
  "dicotyledonae": "heal",
  "dicotyledones": "heal",
  "dicotyledonous": "beautiful",
  "dicoumarol": "build",
  "dicranaceae": "heal",
  "dicranales": "heal",
  "dicranopteris": "heal",
  "dicranum": "heal",
  "dicrostonyx": "heal",
  "dictamnus": "heal",
  "dictaphone": "build",
  "dictate": "story",
  "dictation": "story",
  "dictatorial": "beautiful",
  "diction": "story",
  "dictionary": "story",
  "dictostylium": "heal",
  "dictum": "story",
  "dictyophera": "heal",
  "dictyoptera": "heal",
  "dictyosome": "heal",
  "dicumarol": "build",
  "dicynodont": "heal",
  "dicynodontia": "heal",
  "didacticism": "story",
  "didanosine": "build",
  "didder": "heal",
  "diddle": "sell",
  "diddley": "smart",
  "diddly": "smart",
  "diddly-shit": "smart",
  "diddly-squat": "smart",
  "diddlyshit": "smart",
  "diddlysquat": "smart",
  "didelphidae": "heal",
  "didelphis": "heal",
  "dideoxycytosine": "build",
  "dideoxyinosine": "build",
  "die": "build",
  "dieffenbachia": "heal",
  "diegueno": "story",
  "dielectrolysis": "smart",
  "diencephalon": "heal",
  "dieresis": "story",
  "diervilla": "heal",
  "diesel": "build",
  "diesel-electric": "build",
  "diesel-hydraulic": "build",
  "diesis": "story",
  "diestock": "build",
  "diet": "heal",
  "dietary": "taste",
  "dietetics": "smart",
  "diethylmalonylurea": "build",
  "diethylstilbesterol": "build",
  "dieting": "taste",
  "differ": "story",
  "difference": "story",
  "different": "beautiful",
  "differentiable": "beautiful",
  "differential": "smart",
  "differentiate": "smart",
  "differentiated": "smart",
  "differentiation": "smart",
  "difficult": "beautiful",
  "difficulty": "smart",
  "diffident": "beautiful",
  "difflugia": "heal",
  "diffraction": "sound",
  "diffuse": "build",
  "diffused": "build",
  "diffuser": "build",
  "diffusion": "smart",
  "diffusor": "build",
  "diflunisal": "build",
  "dig": "story",
  "digenesis": "sound",
  "digest": "story",
  "digester": "build",
  "digestible": "beautiful",
  "digestion": "smart",
  "digger": "build",
  "digging": "build",
  "diggings": "build",
  "digit": "smart",
  "digital": "beautiful",
  "digitalis": "heal",
  "digitalize": "heal",
  "digitaria": "heal",
  "digitigrade": "heal",
  "digitisation": "smart",
  "digitiser": "build",
  "digitization": "smart",
  "digitizer": "build",
  "digitoxin": "build",
  "dignified": "sell",
  "dignify": "sell",
  "digoxin": "build",
  "digram": "story",
  "digraph": "story",
  "digress": "story",
  "digression": "story",
  "digs": "build",
  "dihybrid": "heal",
  "dihydrostreptomycin": "build",
  "dik-dik": "heal",
  "dika": "heal",
  "dike": "build",
  "dilantin": "build",
  "dilapidate": "build",
  "dilapidation": "smart",
  "dilate": "story",
  "dilater": "build",
  "dilation": "story",
  "dilator": "heal",
  "dilaudid": "build",
  "dildo": "build",
  "dilemma": "smart",
  "dilettante": "beautiful",
  "diligent": "beautiful",
  "dill": "heal",
  "dillenia": "heal",
  "dilleniaceae": "heal",
  "dilleniidae": "heal",
  "diltiazem": "build",
  "dilute": "beautiful",
  "diluted": "beautiful",
  "dim": "sound",
  "dime": "sell",
  "dimenhydrinate": "build",
  "dimension": "build",
  "dimensional": "beautiful",
  "dimetane": "build",
  "dimetapp": "build",
  "dimetrodon": "heal",
  "diminished": "beautiful",
  "diminuendo": "beautiful",
  "diminution": "smart",
  "diminutive": "story",
  "dimity": "build",
  "dimmed": "sound",
  "dimmer": "build",
  "dimocarpus": "heal",
  "dimorphism": "sound",
  "dimorphotheca": "heal",
  "dimple": "heal",
  "din": "sound",
  "dinar": "smart",
  "dine": "taste",
  "diner": "taste",
  "dinero": "sell",
  "dinette": "build",
  "ding": "sound",
  "dingdong": "sound",
  "dinghy": "build",
  "dingo": "heal",
  "dining": "taste",
  "dining-hall": "build",
  "dining-room": "build",
  "dinka": "story",
  "dinkey": "build",
  "dinky": "build",
  "dinner": "taste",
  "dinnerware": "build",
  "dinoceras": "heal",
  "dinocerata": "heal",
  "dinocerate": "heal",
  "dinoflagellata": "heal",
  "dinoflagellate": "heal",
  "dinornis": "heal",
  "dinornithidae": "heal",
  "dinornithiformes": "heal",
  "dinosaur": "heal",
  "diode": "smart",
  "diodon": "heal",
  "diodontidae": "heal",
  "dioecian": "beautiful",
  "dioecious": "beautiful",
  "diomedeidae": "heal",
  "dionaea": "heal",
  "dioon": "heal",
  "diopter": "smart",
  "dioptre": "smart",
  "diorama": "build",
  "dioscorea": "heal",
  "dioscoreaceae": "heal",
  "diospyros": "heal",
  "diovan": "build",
  "dip": "taste",
  "diphenhydramine": "build",
  "diphenylhydantoin": "build",
  "diphthong": "story",
  "diphthongise": "story",
  "diphthongize": "story",
  "diphylla": "heal",
  "dipladenia": "heal",
  "diplococcus": "heal",
  "diplodocus": "heal",
  "diploid": "heal",
  "diploma": "story",
  "diplomacy": "story",
  "diplomatic": "beautiful",
  "diplomatical": "beautiful",
  "diplopoda": "heal",
  "diplopterygium": "heal",
  "diplotaxis": "heal",
  "diplotene": "smart",
  "dipnoi": "heal",
  "dipodidae": "heal",
  "dipodomys": "heal",
  "dipogon": "heal",
  "dipole": "build",
  "dipper": "build",
  "dippers": "build",
  "dipsacaceae": "heal",
  "dipsacus": "heal",
  "dipsosaurus": "heal",
  "dipstick": "build",
  "diptera": "heal",
  "dipteran": "heal",
  "dipterocarp": "heal",
  "dipterocarpaceae": "heal",
  "dipteron": "heal",
  "dipteronia": "heal",
  "dipteryx": "heal",
  "diptych": "build",
  "dipus": "heal",
  "dirca": "heal",
  "direct": "story",
  "direction": "smart",
  "directional": "beautiful",
  "directive": "story",
  "directory": "story",
  "dirge": "story",
  "dirham": "smart",
  "dirigible": "build",
  "dirk": "build",
  "dirndl": "build",
  "dirt": "story",
  "dirty": "build",
  "dirtying": "build",
  "disa": "heal",
  "disable": "heal",
  "disabled": "heal",
  "disabling": "heal",
  "disabuse": "story",
  "disadvantage": "sell",
  "disadvantageous": "beautiful",
  "disaffirmation": "story",
  "disagree": "story",
  "disagreeable": "beautiful",
  "disagreement": "story",
  "disallow": "story",
  "disambiguate": "story",
  "disambiguation": "story",
  "disambiguator": "story",
  "disappear": "sound",
  "disappearing": "sound",
  "disapprobation": "story",
  "disapproval": "story",
  "disapprove": "smart",
  "disarrange": "build",
  "disarranged": "build",
  "disarray": "smart",
  "disarticulate": "build",
  "disassemble": "build",
  "disassociate": "sell",
  "disavow": "story",
  "disavowal": "story",
  "disbar": "sell",
  "disbelief": "smart",
  "disbelieve": "smart",
  "disbud": "build",
  "disburden": "build",
  "disbursal": "sell",
  "disburse": "sell",
  "disbursement": "sell",
  "disc": "build",
  "disc-jockey": "story",
  "discalceate": "beautiful",
  "discalced": "beautiful",
  "discant": "story",
  "discard": "sell",
  "discase": "heal",
  "disceptation": "story",
  "discern": "sound",
  "discernable": "beautiful",
  "discernible": "beautiful",
  "discerning": "sound",
  "discernment": "smart",
  "discerp": "build",
  "discharge": "smart",
  "discina": "heal",
  "disciplinary": "beautiful",
  "discipline": "smart",
  "disclaim": "story",
  "disclaimer": "story",
  "disclose": "story",
  "disclosure": "story",
  "disco": "sound",
  "discocephali": "heal",
  "discoglossidae": "heal",
  "discography": "story",
  "discombobulate": "smart",
  "discomfited": "beautiful",
  "discommode": "sell",
  "discomposed": "beautiful",
  "discomycete": "heal",
  "discomycetes": "heal",
  "disconfirming": "beautiful",
  "disconnect": "build",
  "disconnected": "build",
  "disconsolate": "beautiful",
  "discontent": "beautiful",
  "discontented": "beautiful",
  "discontinuance": "sound",
  "discontinuation": "sound",
  "discontinued": "beautiful",
  "discontinuous": "beautiful",
  "discord": "story",
  "discordant": "beautiful",
  "discotheque": "build",
  "discount": "sell",
  "discountenance": "smart",
  "discounter": "build",
  "discourage": "story",
  "discouragement": "story",
  "discouraging": "story",
  "discourse": "story",
  "discourteous": "beautiful",
  "discourtesy": "story",
  "discover": "sound",
  "discovery": "story",
  "discredit": "smart",
  "discreet": "beautiful",
  "discreetness": "smart",
  "discretion": "smart",
  "discriminate": "smart",
  "discriminating": "smart",
  "discrimination": "smart",
  "discriminatory": "story",
  "discus": "build",
  "discuss": "build",
  "discussion": "story",
  "disdain": "story",
  "disembarrass": "sell",
  "disembody": "sell",
  "disenchanted": "beautiful",
  "disenchantment": "smart",
  "disencumber": "build",
  "disenfranchise": "sell",
  "disenfranchised": "sell",
  "disenfranchisement": "sell",
  "disengage": "build",
  "disentangle": "build",
  "disesteem": "smart",
  "disfavor": "smart",
  "disfavour": "smart",
  "disfigure": "build",
  "disfluency": "smart",
  "disfranchise": "sell",
  "disfranchised": "sell",
  "disfranchisement": "sell",
  "disgorge": "build",
  "disgrace": "sell",
  "disguise": "build",
  "disgust": "sound",
  "dish": "taste",
  "dishcloth": "build",
  "disheartenment": "story",
  "dishevel": "build",
  "dishful": "smart",
  "dishonest": "beautiful",
  "dishonor": "sell",
  "dishonorable": "beautiful",
  "dishonour": "sell",
  "dishonourable": "beautiful",
  "dishpan": "build",
  "dishrag": "build",
  "dishtowel": "build",
  "dishware": "build",
  "dishwasher": "build",
  "disillusion": "smart",
  "disillusionment": "smart",
  "disincarnate": "build",
  "disincline": "smart",
  "disinclined": "smart",
  "disinfect": "heal",
  "disinfectant": "build",
  "disinfest": "sell",
  "disinflation": "smart",
  "disinformation": "story",
  "disingenuous": "beautiful",
  "disinherit": "sell",
  "disintegration": "smart",
  "disintegrative": "beautiful",
  "disinter": "sell",
  "disinterest": "smart",
  "disinterestedness": "smart",
  "disinvest": "sell",
  "disjoin": "build",
  "disjoint": "sell",
  "disjunct": "beautiful",
  "disjunctive": "beautiful",
  "disk": "build",
  "disk-jockey": "story",
  "diskette": "build",
  "dislike": "smart",
  "disliked": "beautiful",
  "dislodge": "build",
  "disloyal": "beautiful",
  "dismantle": "build",
  "dismantling": "build",
  "dismember": "build",
  "dismiss": "story",
  "dismissal": "story",
  "dismission": "story",
  "disobedient": "beautiful",
  "disobey": "sell",
  "disoblige": "sell",
  "disordered": "beautiful",
  "disorderly": "beautiful",
  "disorganise": "sell",
  "disorganised": "sell",
  "disorganize": "sell",
  "disorganized": "sell",
  "disorient": "sound",
  "disorientate": "sound",
  "disorientation": "smart",
  "disorienting": "sound",
  "disown": "sell",
  "disowning": "story",
  "disownment": "story",
  "disparage": "story",
  "disparagement": "story",
  "dispatch": "story",
  "dispensable": "beautiful",
  "dispensary": "build",
  "dispensation": "sell",
  "dispense": "sell",
  "dispenser": "build",
  "disperse": "build",
  "displace": "sell",
  "displacement": "smart",
  "display": "story",
  "displeased": "beautiful",
  "displeasing": "beautiful",
  "displume": "sell",
  "disport": "sell",
  "disposable": "build",
  "disposal": "build",
  "dispose": "sell",
  "disposition": "smart",
  "dispossess": "sell",
  "dispossession": "smart",
  "disproof": "smart",
  "disproportional": "beautiful",
  "disproportionate": "beautiful",
  "disprove": "smart",
  "disputation": "story",
  "dispute": "story",
  "disqualify": "story",
  "disqualifying": "story",
  "disquisition": "story",
  "disregard": "smart",
  "disreputable": "beautiful",
  "disrespect": "story",
  "disrespectful": "beautiful",
  "disrobe": "heal",
  "disrupt": "story",
  "diss": "story",
  "dissect": "build",
  "dissection": "smart",
  "dissemble": "story",
  "dissembling": "story",
  "disseminate": "story",
  "dissemination": "story",
  "dissension": "story",
  "dissent": "story",
  "dissertate": "story",
  "dissertation": "story",
  "dissever": "sell",
  "dissidence": "story",
  "dissident": "beautiful",
  "dissimilar": "beautiful",
  "dissimilation": "smart",
  "dissimulate": "sound",
  "dissipate": "taste",
  "dissociate": "sell",
  "dissociation": "smart",
  "dissolution": "smart",
  "dissolve": "story",
  "dissolving": "smart",
  "dissonance": "smart",
  "dissonate": "sound",
  "dissuade": "story",
  "dissuasion": "story",
  "dissuasive": "beautiful",
  "dissyllable": "story",
  "distaff": "build",
  "distal": "beautiful",
  "distant": "beautiful",
  "distemper": "build",
  "distich": "smart",
  "distil": "heal",
  "distill": "taste",
  "distillate": "taste",
  "distillation": "taste",
  "distiller": "taste",
  "distillery": "taste",
  "distillment": "taste",
  "distinct": "beautiful",
  "distinction": "smart",
  "distinguish": "smart",
  "distinguishable": "beautiful",
  "distort": "story",
  "distortion": "sound",
  "distraction": "smart",
  "distrain": "sell",
  "distressed": "sell",
  "distribute": "sell",
  "distributed": "sell",
  "distributer": "build",
  "distribution": "smart",
  "distributive": "beautiful",
  "distributor": "sell",
  "district": "sell",
  "distrust": "smart",
  "distrustful": "beautiful",
  "disturb": "build",
  "disulfiram": "build",
  "disunite": "sell",
  "disyllable": "story",
  "dit": "story",
  "dita": "heal",
  "ditch": "build",
  "ditchmoss": "heal",
  "dithering": "smart",
  "dithyramb": "story",
  "dittany": "heal",
  "ditto": "story",
  "ditty": "story",
  "diuretic": "build",
  "diuril": "build",
  "diurnal": "beautiful",
  "divagate": "story",
  "divagation": "story",
  "divan": "build",
  "divaricate": "build",
  "dive": "build",
  "diver": "heal",
  "divergence": "smart",
  "divergency": "smart",
  "divergent": "beautiful",
  "diversified": "beautiful",
  "divert": "sell",
  "divertimento": "story",
  "divest": "sell",
  "divestiture": "story",
  "divi-divi": "heal",
  "divide": "sell",
  "divided": "sell",
  "dividend": "sell",
  "divider": "build",
  "divination": "story",
  "divine": "sound",
  "diviner": "beautiful",
  "divinity": "taste",
  "divisible": "beautiful",
  "division": "smart",
  "divisional": "beautiful",
  "divisor": "smart",
  "divorce": "sell",
  "divulge": "story",
  "divulgement": "story",
  "divulgence": "story",
  "divvy": "sell",
  "diwan": "story",
  "dixie": "build",
  "dizen": "heal",
  "dizzy": "beautiful",
  "dkg": "smart",
  "dkl": "smart",
  "dkm": "smart",
  "dmd": "story",
  "dmus": "story",
  "do-nothing": "beautiful",
  "dobbin": "heal",
  "doberman": "heal",
  "dobra": "smart",
  "dobson": "heal",
  "dobsonfly": "heal",
  "docetism": "smart",
  "docile": "beautiful",
  "dock": "build",
  "dockage": "sell",
  "docket": "story",
  "docking": "sell",
  "doctor-fish": "heal",
  "doctorate": "story",
  "doctorfish": "heal",
  "doctorspeak": "story",
  "doctrinaire": "beautiful",
  "doctrine": "smart",
  "docudrama": "story",
  "document": "story",
  "documentary": "story",
  "documentation": "story",
  "documented": "story",
  "dodder": "heal",
  "dodge": "smart",
  "dodgem": "build",
  "dodger": "taste",
  "dodging": "story",
  "dodo": "heal",
  "dodonaea": "heal",
  "doe": "heal",
  "doeskin": "build",
  "doff": "build",
  "dog": "heal",
  "dog-ear": "story",
  "dog-iron": "build",
  "dogbane": "heal",
  "dogcart": "build",
  "dogfish": "heal",
  "doggerel": "story",
  "doggie": "heal",
  "doggy": "heal",
  "doghouse": "build",
  "dogie": "heal",
  "dogleg": "build",
  "dogma": "story",
  "dogmatic": "beautiful",
  "dogmatise": "story",
  "dogmatism": "smart",
  "dogmatize": "story",
  "dogshit": "story",
  "dogsled": "build",
  "dogtooth": "heal",
  "dogwood": "heal",
  "dogy": "heal",
  "doh": "story",
  "doily": "build",
  "dol": "smart",
  "doldrums": "sound",
  "dole": "sell",
  "dolichocephalic": "beautiful",
  "dolichocranial": "beautiful",
  "dolichocranic": "beautiful",
  "dolichonyx": "heal",
  "dolichos": "heal",
  "dolichotis": "heal",
  "doliolidae": "heal",
  "doliolum": "heal",
  "doll": "build",
  "dollar": "smart",
  "dollarfish": "heal",
  "dollhouse": "build",
  "dollop": "smart",
  "dolly": "story",
  "dolman": "build",
  "dolmas": "taste",
  "dolmen": "build",
  "dolobid": "build",
  "dolphin": "heal",
  "dolphinfish": "taste",
  "domatium": "heal",
  "dombeya": "heal",
  "dome": "heal",
  "domestic": "beautiful",
  "domestication": "smart",
  "domicile": "build",
  "domiciliate": "sell",
  "domiciliation": "build",
  "dominance": "sound",
  "dominant": "story",
  "dominate": "sell",
  "domineering": "beautiful",
  "dominick": "heal",
  "dominique": "heal",
  "domino": "build",
  "dominoes": "build",
  "dominos": "build",
  "dona": "story",
  "donate": "sell",
  "donation": "sell",
  "donatism": "smart",
  "dong": "smart",
  "dongle": "build",
  "donjon": "build",
  "donkey": "story",
  "donut": "taste",
  "doo-wop": "story",
  "doob": "heal",
  "doodad": "build",
  "doodia": "heal",
  "doodle": "build",
  "doodlebug": "build",
  "doodly-squat": "smart",
  "doohickey": "build",
  "doojigger": "build",
  "doom": "story",
  "doomed": "story",
  "door": "build",
  "doorbell": "build",
  "doorcase": "build",
  "doorframe": "build",
  "doorhandle": "build",
  "doorjamb": "build",
  "doorknob": "build",
  "doorknocker": "build",
  "doorlock": "build",
  "doormat": "build",
  "doornail": "build",
  "doorplate": "build",
  "doorpost": "build",
  "doorsill": "build",
  "doorstep": "build",
  "doorstop": "build",
  "doorstopper": "build",
  "doorway": "build",
  "dooryard": "build",
  "dope": "build",
  "doppelzentner": "smart",
  "dorbeetle": "heal",
  "doric": "story",
  "doriden": "build",
  "dorking": "heal",
  "dorm": "build",
  "dormancy": "sound",
  "dormant": "beautiful",
  "dormer": "build",
  "dormitory": "build",
  "dormouse": "heal",
  "doronicum": "heal",
  "dorotheanthus": "heal",
  "dorsal": "beautiful",
  "dorsum": "heal",
  "dory": "build",
  "dorylinae": "heal",
  "doryopteris": "heal",
  "dos": "story",
  "dosage": "smart",
  "dose": "build",
  "dosemeter": "build",
  "dosimeter": "build",
  "doss": "story",
  "dossal": "build",
  "dossel": "build",
  "dosshouse": "build",
  "dossier": "story",
  "dot": "story",
  "dotrel": "heal",
  "dotterel": "heal",
  "double": "smart",
  "double-barreled": "beautiful",
  "double-barrelled": "beautiful",
  "double-bogey": "smart",
  "double-breasted": "beautiful",
  "double-check": "smart",
  "double-date": "sell",
  "double-dealing": "beautiful",
  "double-decker": "build",
  "double-glaze": "build",
  "double-magnum": "build",
  "double-prop": "build",
  "double-space": "story",
  "double-spacing": "story",
  "double-u": "story",
  "doubler": "build",
  "doublespeak": "story",
  "doublet": "build",
  "doublethink": "smart",
  "doubleton": "smart",
  "doubletree": "build",
  "doubling": "smart",
  "doubloon": "sell",
  "doubt": "smart",
  "doubtfulness": "smart",
  "douche": "build",
  "dough": "taste",
  "doughboy": "taste",
  "doughnut": "taste",
  "doura": "heal",
  "dourah": "heal",
  "douroucouli": "heal",
  "douse": "build",
  "dove": "heal",
  "dovecote": "build",
  "dovekie": "heal",
  "dovetail": "build",
  "dovishness": "smart",
  "dovyalis": "heal",
  "dowdy": "taste",
  "dowel": "build",
  "dower": "sell",
  "dowery": "sell",
  "dowitcher": "heal",
  "down": "heal",
  "down-and-out": "beautiful",
  "downbeat": "story",
  "downcast": "build",
  "downdraft": "sound",
  "downer": "build",
  "downfall": "sound",
  "downgrade": "smart",
  "downhill": "beautiful",
  "downing": "taste",
  "download": "sell",
  "downmarket": "beautiful",
  "downplay": "story",
  "downpour": "sound",
  "downside": "smart",
  "downsize": "sell",
  "downsizing": "sell",
  "downstage": "build",
  "downstair": "beautiful",
  "downstairs": "beautiful",
  "downstream": "beautiful",
  "downstroke": "story",
  "downtown": "beautiful",
  "dowry": "sell",
  "dowse": "smart",
  "dowser": "build",
  "dowsing": "smart",
  "doxazosin": "build",
  "doxepin": "build",
  "doxology": "story",
  "doxorubicin": "build",
  "doxycycline": "build",
  "doyley": "build",
  "doyly": "build",
  "doze": "heal",
  "dozen": "smart",
  "dozens": "smart",
  "dozer": "build",
  "dph": "story",
  "dphil": "story",
  "drab": "beautiful",
  "draba": "heal",
  "dracaena": "heal",
  "dracaenaceae": "heal",
  "dracenaceae": "heal",
  "drachm": "smart",
  "drachma": "smart",
  "draco": "heal",
  "dracocephalum": "heal",
  "dracontium": "heal",
  "dracula": "heal",
  "dracunculidae": "heal",
  "dracunculus": "heal",
  "draft": "sell",
  "drafting": "build",
  "drag": "sound",
  "dragee": "taste",
  "dragger": "build",
  "dragnet": "build",
  "dragon": "heal",
  "dragonet": "heal",
  "dragonfly": "heal",
  "dragonhead": "heal",
  "dragoon": "sell",
  "dragunov": "build",
  "drain": "build",
  "drainboard": "build",
  "drained": "taste",
  "drainpipe": "build",
  "drainplug": "build",
  "drake": "heal",
  "dram": "smart",
  "drama": "story",
  "dramamine": "build",
  "dramatic": "story",
  "dramatics": "story",
  "dramatise": "build",
  "dramatize": "build",
  "dramaturgy": "story",
  "drambuie": "taste",
  "drape": "build",
  "drapery": "build",
  "draught": "taste",
  "draughts": "taste",
  "dravidian": "story",
  "dravidic": "story",
  "draw": "build",
  "drawbar": "build",
  "drawbridge": "build",
  "drawer": "build",
  "drawers": "build",
  "drawing": "beautiful",
  "drawknife": "build",
  "drawl": "story",
  "drawnwork": "build",
  "drawshave": "build",
  "drawstring": "build",
  "dray": "build",
  "drayhorse": "heal",
  "dread": "beautiful",
  "dreadlock": "heal",
  "dreadnaught": "build",
  "dreadnought": "build",
  "dream": "smart",
  "dreaming": "smart",
  "dreamland": "smart",
  "dreamworld": "smart",
  "dreck": "build",
  "dredge": "build",
  "dredger": "build",
  "dreg": "smart",
  "dregs": "smart",
  "dreissena": "heal",
  "drench": "taste",
  "drenching": "taste",
  "drepanididae": "heal",
  "drepanis": "heal",
  "dress": "build",
  "dresser": "build",
  "dressing": "taste",
  "drew": "build",
  "drib": "smart",
  "dribble": "heal",
  "dribbling": "build",
  "driblet": "smart",
  "drier": "build",
  "drift": "sound",
  "driftfish": "heal",
  "drill": "build",
  "drilling": "build",
  "drimys": "heal",
  "drink": "taste",
  "drinkable": "taste",
  "drinking": "taste",
  "drip": "build",
  "drip-dry": "beautiful",
  "dripping": "build",
  "drippings": "taste",
  "dripstone": "build",
  "drive": "build",
  "drive-in": "build",
  "drivel": "story",
  "driver": "story",
  "driveshaft": "build",
  "driveway": "build",
  "drixoral": "build",
  "drizzle": "sound",
  "drms": "sell",
  "drogue": "story",
  "drollery": "story",
  "dromaeosaur": "heal",
  "dromaeosauridae": "heal",
  "dromaius": "heal",
  "drome": "build",
  "dromedary": "heal",
  "dronabinol": "build",
  "drone": "heal",
  "droning": "story",
  "drool": "story",
  "drop": "smart",
  "drop-kick": "build",
  "drop-leaf": "build",
  "drop-off": "smart",
  "drop-seed": "heal",
  "dropforge": "build",
  "dropkick": "build",
  "droplet": "smart",
  "dropline": "story",
  "dropper": "build",
  "dropseed": "heal",
  "drosera": "heal",
  "droseraceae": "heal",
  "droshky": "build",
  "drosky": "build",
  "drosophila": "heal",
  "drosophilidae": "heal",
  "drosophyllum": "heal",
  "drove": "build",
  "drown": "build",
  "drowse": "heal",
  "drub": "build",
  "drubbing": "build",
  "drudge": "sell",
  "drug": "build",
  "drugget": "build",
  "drugging": "heal",
  "drugstore": "build",
  "druidism": "smart",
  "drum": "sound",
  "drumbeat": "story",
  "drumfish": "heal",
  "drumhead": "build",
  "drumming": "sound",
  "drumstick": "taste",
  "drunk": "taste",
  "drunkenness": "sound",
  "drupe": "heal",
  "drupelet": "heal",
  "druthers": "smart",
  "dry": "beautiful",
  "dry-dock": "build",
  "dry-eyed": "beautiful",
  "dry-nurse": "taste",
  "dry-wall": "build",
  "dryadella": "heal",
  "dryas": "heal",
  "drydock": "build",
  "dryer": "build",
  "drygoods": "build",
  "drymarchon": "heal",
  "drymoglossum": "heal",
  "drynaria": "heal",
  "dryopithecine": "heal",
  "dryopithecus": "heal",
  "dryopteridaceae": "heal",
  "dryopteris": "heal",
  "drypis": "heal",
  "drywall": "build",
  "dsl": "build",
  "duad": "smart",
  "dualism": "smart",
  "dub": "smart",
  "dubbing": "story",
  "dubiety": "smart",
  "dubiousness": "smart",
  "dubonnet": "taste",
  "ducat": "sell",
  "duck": "heal",
  "duckbill": "heal",
  "duckboard": "build",
  "duckling": "taste",
  "duckpin": "build",
  "duckpins": "build",
  "duckweed": "heal",
  "duct": "heal",
  "ductule": "heal",
  "ductulus": "heal",
  "dud": "beautiful",
  "dudeen": "build",
  "duds": "build",
  "due": "sell",
  "duet": "sound",
  "duette": "story",
  "duff": "taste",
  "duffel": "build",
  "duffle": "build",
  "dug": "heal",
  "dugong": "heal",
  "dugongidae": "heal",
  "dugout": "build",
  "dulciana": "build",
  "dulcify": "sound",
  "dulcimer": "build",
  "dulcorate": "sound",
  "dull": "build",
  "dulles": "build",
  "dullness": "smart",
  "dulse": "heal",
  "dumbbell": "build",
  "dumbfound": "smart",
  "dumbness": "smart",
  "dumbwaiter": "build",
  "dumdum": "build",
  "dumetella": "heal",
  "dummy": "build",
  "dump": "smart",
  "dumpcart": "build",
  "dumper": "build",
  "dumping": "sell",
  "dumpling": "taste",
  "dumplings": "taste",
  "dumps": "smart",
  "dumpster": "build",
  "dumpy": "beautiful",
  "dun": "heal",
  "dung": "heal",
  "dungaree": "build",
  "dungeon": "build",
  "dunk": "build",
  "dunlin": "heal",
  "dunnock": "heal",
  "duo": "smart",
  "duodecimal": "smart",
  "duodenum": "heal",
  "duologue": "story",
  "duomo": "build",
  "dupe": "story",
  "duplex": "build",
  "duplicate": "build",
  "duplication": "build",
  "duplicator": "build",
  "duplicidentata": "heal",
  "duplicity": "story",
  "dura": "heal",
  "durables": "build",
  "duramen": "heal",
  "durbar": "build",
  "durham": "heal",
  "durian": "heal",
  "durio": "heal",
  "durion": "heal",
  "durmast": "heal",
  "durra": "heal",
  "durum": "heal",
  "dusicyon": "heal",
  "dust": "build",
  "dustbin": "build",
  "dustcart": "build",
  "dustcloth": "build",
  "duster": "sound",
  "dustmop": "build",
  "dustpan": "smart",
  "dustpanful": "smart",
  "dustrag": "build",
  "dustup": "story",
  "dutch": "story",
  "dutchman's-pipe": "heal",
  "duty": "sell",
  "duvet": "build",
  "dvd": "build",
  "dwell": "smart",
  "dwelling": "build",
  "dwindling": "beautiful",
  "dyad": "smart",
  "dye-works": "build",
  "dyer's-broom": "heal",
  "dyeweed": "heal",
  "dying": "sound",
  "dyirbal": "story",
  "dyke": "build",
  "dynamic": "beautiful",
  "dynamical": "beautiful",
  "dynamics": "smart",
  "dynamism": "smart",
  "dynamite": "build",
  "dynamo": "build",
  "dynamometer": "build",
  "dynapen": "build",
  "dyne": "smart",
  "dyscrasia": "heal",
  "dysdercus": "heal",
  "dysgenics": "smart",
  "dyslectic": "beautiful",
  "dyslexic": "beautiful",
  "dyspeptic": "beautiful",
  "dysphemism": "story",
  "dysphemistic": "beautiful",
  "dysphoric": "beautiful",
  "dyspneal": "beautiful",
  "dyspneic": "beautiful",
  "dyspnoeal": "beautiful",
  "dyspnoeic": "beautiful",
  "dystopia": "story",
  "dystopian": "beautiful",
  "dytiscidae": "heal",
  "dziggetai": "heal",
  "e-bomb": "build",
  "e-mail": "story",
  "e-mycin": "build",
  "e.s.p.": "story",
  "eacles": "heal",
  "eager": "beautiful",
  "eagle": "heal",
  "eaglet": "heal",
  "ear": "heal",
  "ear-shell": "heal",
  "eardrop": "build",
  "eardrum": "heal",
  "eared": "beautiful",
  "earflap": "build",
  "earful": "story",
  "earlap": "build",
  "earless": "beautiful",
  "earlobe": "heal",
  "early": "beautiful",
  "earmark": "story",
  "earmuff": "build",
  "earn": "sell",
  "earned": "sell",
  "earnest": "sell",
  "earnings": "sell",
  "earphone": "sound",
  "earpiece": "build",
  "earplug": "build",
  "earring": "beautiful",
  "earth-ball": "heal",
  "earth-closet": "build",
  "earth-tongue": "heal",
  "earthball": "heal",
  "earthenware": "beautiful",
  "earthing": "sound",
  "earthly": "beautiful",
  "earthnut": "heal",
  "earthstar": "heal",
  "earthtongue": "heal",
  "earthwork": "build",
  "earthworm": "heal",
  "earthy": "beautiful",
  "earwig": "heal",
  "eas": "story",
  "easel": "beautiful",
  "easing": "heal",
  "easter": "sound",
  "easterly": "sound",
  "eastern": "beautiful",
  "easterner": "beautiful",
  "eastward": "beautiful",
  "easy": "beautiful",
  "eat": "taste",
  "eatable": "taste",
  "eatage": "taste",
  "eater": "taste",
  "eatery": "taste",
  "eating": "taste",
  "eats": "taste",
  "eaves": "build",
  "eavesdrop": "sound",
  "ebb": "smart",
  "ebbing": "smart",
  "ebenaceae": "heal",
  "ebenales": "heal",
  "ebit": "smart",
  "ebitda": "sell",
  "ebonics": "story",
  "ebony": "heal",
  "ebs": "smart",
  "ebullition": "story",
  "eburnation": "smart",
  "eburophyton": "heal",
  "ebv": "heal",
  "ecballium": "heal",
  "ecc": "story",
  "eccentric": "beautiful",
  "ecchymosis": "smart",
  "eccles": "heal",
  "ecclesiastes": "story",
  "ecclesiasticism": "smart",
  "ecclesiasticus": "story",
  "ecclesiology": "smart",
  "eccrine": "beautiful",
  "ecdemic": "beautiful",
  "ecdysis": "smart",
  "ecesis": "smart",
  "ecf": "heal",
  "ecg": "story",
  "echelon": "build",
  "echeneididae": "heal",
  "echeneis": "heal",
  "echidna": "heal",
  "echidnophaga": "heal",
  "echinacea": "heal",
  "echinocactus": "heal",
  "echinocereus": "heal",
  "echinochloa": "heal",
  "echinococcus": "heal",
  "echinoderm": "heal",
  "echinodermata": "heal",
  "echinoidea": "heal",
  "echinops": "heal",
  "echinus": "build",
  "echium": "heal",
  "echo": "story",
  "echocardiogram": "story",
  "echocardiograph": "build",
  "echocardiography": "heal",
  "echoencephalogram": "story",
  "echoencephalograph": "build",
  "echoencephalography": "heal",
  "echogram": "build",
  "echoic": "beautiful",
  "echolalia": "story",
  "echovirus": "heal",
  "echt": "beautiful",
  "eclair": "taste",
  "eclat": "story",
  "eclectic": "beautiful",
  "eclecticism": "smart",
  "eclipse": "sound",
  "eclipsis": "smart",
  "eclogue": "story",
  "ecobabble": "story",
  "ecology": "smart",
  "econometrics": "smart",
  "economic": "sell",
  "economical": "beautiful",
  "economics": "sell",
  "economise": "sell",
  "economize": "sell",
  "economy": "sell",
  "ecphonesis": "story",
  "ecrevisse": "taste",
  "ecstasy": "build",
  "ectoblast": "heal",
  "ectoderm": "heal",
  "ectomorphic": "beautiful",
  "ectoparasite": "heal",
  "ectopistes": "heal",
  "ectoplasm": "heal",
  "ectoproct": "heal",
  "ectoprocta": "heal",
  "ectotherm": "heal",
  "ectozoan": "heal",
  "ectozoon": "heal",
  "ecumenicalism": "story",
  "ecumenicism": "story",
  "ecumenism": "story",
  "edam": "taste",
  "edaphosauridae": "heal",
  "edaphosaurus": "heal",
  "edd": "story",
  "edda": "taste",
  "eddo": "heal",
  "edecrin": "build",
  "edelweiss": "heal",
  "eden": "smart",
  "edentata": "heal",
  "edentate": "heal",
  "edge": "build",
  "edger": "build",
  "edging": "build",
  "edible": "taste",
  "edict": "story",
  "edification": "smart",
  "edifice": "build",
  "edify": "story",
  "edifying": "story",
  "edit": "story",
  "editing": "story",
  "edition": "story",
  "editor": "story",
  "editorial": "story",
  "editorialise": "story",
  "editorialize": "story",
  "edmontonia": "heal",
  "edmontosaurus": "heal",
  "edp": "smart",
  "edronax": "build",
  "eds": "build",
  "educate": "sell",
  "educated": "sell",
  "education": "smart",
  "educational": "beautiful",
  "educe": "build",
  "edulcorate": "sound",
  "eeg": "story",
  "eel": "taste",
  "eelblenny": "heal",
  "eelgrass": "heal",
  "eelpout": "heal",
  "eelworm": "heal",
  "eff": "build",
  "efface": "build",
  "effacement": "smart",
  "effect": "sound",
  "effective": "beautiful",
  "effectiveness": "heal",
  "effector": "heal",
  "effects": "sell",
  "effectual": "beautiful",
  "effectuate": "build",
  "efferent": "heal",
  "effervescence": "smart",
  "effervescent": "beautiful",
  "efficacious": "beautiful",
  "efficiency": "smart",
  "efficient": "beautiful",
  "effigy": "build",
  "effleurage": "sound",
  "efflorescence": "smart",
  "effluence": "smart",
  "effluent": "beautiful",
  "efflux": "smart",
  "effortful": "beautiful",
  "effortless": "beautiful",
  "effusion": "story",
  "eft": "heal",
  "egalitarian": "beautiful",
  "egalitarianism": "smart",
  "egeria": "heal",
  "egest": "heal",
  "egg": "taste",
  "egg-and-anchor": "build",
  "egg-and-dart": "build",
  "egg-and-tongue": "build",
  "eggar": "heal",
  "eggbeater": "build",
  "eggcup": "build",
  "egger": "heal",
  "eggfruit": "taste",
  "eggnog": "taste",
  "eggplant": "taste",
  "eggs": "taste",
  "eggshake": "taste",
  "eggwhisk": "build",
  "egis": "build",
  "eglantine": "heal",
  "ego": "smart",
  "egocentric": "beautiful",
  "egoism": "smart",
  "egoistic": "beautiful",
  "egoistical": "beautiful",
  "egotrip": "sell",
  "egret": "heal",
  "egretta": "heal",
  "egyptian": "story",
  "egyptology": "smart",
  "ehrlich": "heal",
  "eib": "smart",
  "eibit": "smart",
  "eichhornia": "heal",
  "eider": "heal",
  "eiderdown": "build",
  "eigenvalue": "smart",
  "eight": "smart",
  "eight-spot": "build",
  "eighteen": "smart",
  "eighteenth": "beautiful",
  "eighter": "smart",
  "eighth": "smart",
  "eighties": "smart",
  "eightieth": "beautiful",
  "eightpence": "sell",
  "eighty": "smart",
  "eimeria": "heal",
  "eimeriidae": "heal",
  "einthoven": "heal",
  "eira": "heal",
  "eisegesis": "story",
  "ejaculate": "heal",
  "ejaculation": "story",
  "eject": "build",
  "ejector": "build",
  "ekg": "story",
  "elaborate": "story",
  "elaboration": "story",
  "elaeagnaceae": "heal",
  "elaeagnus": "heal",
  "elaeis": "heal",
  "elaeocarpaceae": "heal",
  "elaeocarpus": "heal",
  "elagatis": "heal",
  "elamite": "story",
  "elamitic": "story",
  "eland": "heal",
  "elanoides": "heal",
  "elanus": "heal",
  "elaphe": "heal",
  "elaphure": "heal",
  "elaphurus": "heal",
  "elapid": "heal",
  "elapidae": "heal",
  "elasmobranch": "heal",
  "elasmobranchii": "heal",
  "elastance": "sound",
  "elastic": "build",
  "elastin": "heal",
  "elastoplast": "build",
  "elated": "beautiful",
  "elater": "heal",
  "elaterid": "heal",
  "elateridae": "heal",
  "elavil": "build",
  "elbow": "heal",
  "elbowing": "build",
  "elder": "heal",
  "elderberry": "heal",
  "elderly": "beautiful",
  "eldest": "beautiful",
  "eldorado": "smart",
  "elecampane": "heal",
  "elect": "sell",
  "elected": "sell",
  "election": "smart",
  "electioneer": "sell",
  "electioneering": "story",
  "elective": "beautiful",
  "electoral": "beautiful",
  "electorate": "sell",
  "electric": "build",
  "electricity": "sound",
  "electrocardiogram": "story",
  "electrocardiograph": "build",
  "electrocardiography": "heal",
  "electrochemistry": "smart",
  "electrocute": "sell",
  "electrode": "build",
  "electrodeposition": "smart",
  "electrodynamometer": "build",
  "electroencephalogram": "story",
  "electroencephalograph": "build",
  "electrograph": "build",
  "electrolysis": "smart",
  "electrolytic": "build",
  "electromagnet": "build",
  "electromagnetics": "smart",
  "electromagnetism": "sound",
  "electrometer": "build",
  "electromyogram": "story",
  "electromyograph": "build",
  "electromyography": "heal",
  "electronics": "smart",
  "electrophoresis": "smart",
  "electrophoridae": "heal",
  "electrophorus": "build",
  "electroplate": "build",
  "electroretinogram": "story",
  "electroscope": "build",
  "electrosleep": "smart",
  "electrostatics": "smart",
  "elegant": "beautiful",
  "elegiac": "beautiful",
  "elegise": "build",
  "elegize": "build",
  "elegy": "story",
  "element": "smart",
  "elemental": "beautiful",
  "elementary": "beautiful",
  "elements": "sound",
  "elemi": "heal",
  "eleocharis": "heal",
  "eleotridae": "heal",
  "elephant": "heal",
  "elephant's-foot": "heal",
  "elephant-tusk": "heal",
  "elephantidae": "heal",
  "elephantopus": "heal",
  "elephas": "heal",
  "elettaria": "heal",
  "eleusine": "heal",
  "eleutherodactylus": "heal",
  "elevate": "sell",
  "elevated": "build",
  "elevator": "build",
  "eleven": "smart",
  "eleventh": "beautiful",
  "elfin": "beautiful",
  "elicit": "build",
  "elicitation": "smart",
  "elide": "smart",
  "eligible": "beautiful",
  "eliminate": "smart",
  "elimination": "smart",
  "eliomys": "heal",
  "elision": "smart",
  "elite": "beautiful",
  "elitism": "smart",
  "elixir": "taste",
  "elixophyllin": "build",
  "elk": "heal",
  "elk-wood": "heal",
  "elkhound": "heal",
  "elkwood": "heal",
  "ell": "build",
  "ellipsis": "smart",
  "ellipsoid": "beautiful",
  "elm": "heal",
  "elmwood": "heal",
  "elocute": "story",
  "elocution": "story",
  "elocutionary": "beautiful",
  "elodea": "heal",
  "elongate": "beautiful",
  "elongation": "build",
  "elopidae": "heal",
  "elops": "heal",
  "eloquence": "story",
  "elsholtzia": "heal",
  "elspar": "build",
  "elucidate": "story",
  "elucidation": "story",
  "elude": "story",
  "eluding": "story",
  "elute": "build",
  "elution": "smart",
  "elver": "taste",
  "elves": "sound",
  "elvis": "build",
  "elymus": "heal",
  "elysian": "beautiful",
  "elysium": "smart",
  "elytron": "heal",
  "email": "story",
  "emanate": "heal",
  "emancipate": "sell",
  "emasculate": "heal",
  "embalm": "sell",
  "embankment": "build",
  "embargo": "story",
  "embark": "sell",
  "embarrass": "sell",
  "embassy": "build",
  "embattle": "sell",
  "embed": "build",
  "embellish": "story",
  "embellishment": "story",
  "emberiza": "heal",
  "emberizidae": "heal",
  "embezzle": "sell",
  "embiodea": "heal",
  "embioptera": "heal",
  "embiotocidae": "heal",
  "emblazon": "build",
  "emblem": "build",
  "embodiment": "smart",
  "embonpoint": "beautiful",
  "emboss": "build",
  "embossment": "story",
  "embothrium": "heal",
  "embouchure": "build",
  "embower": "build",
  "embracing": "build",
  "embrasure": "build",
  "embrocate": "heal",
  "embrocation": "build",
  "embroider": "beautiful",
  "embroidery": "beautiful",
  "embryo": "heal",
  "embryology": "smart",
  "emcee": "sell",
  "emerald": "sell",
  "emergency": "heal",
  "emeritus": "beautiful",
  "emeside": "build",
  "emetic": "build",
  "emetrol": "build",
  "emf": "sound",
  "emg": "story",
  "emilia": "heal",
  "eminence": "heal",
  "emission": "smart",
  "emit": "heal",
  "emitter": "build",
  "emmanthe": "heal",
  "emmental": "taste",
  "emmentaler": "taste",
  "emmenthal": "taste",
  "emmenthaler": "taste",
  "emmer": "heal",
  "emmet": "heal",
  "emmetropic": "beautiful",
  "emmy": "story",
  "emollient": "build",
  "emolument": "sell",
  "emoticon": "story",
  "emotional": "beautiful",
  "empale": "build",
  "empanel": "sell",
  "empathise": "smart",
  "empathize": "smart",
  "empennage": "build",
  "emperor": "taste",
  "empetraceae": "heal",
  "empetrum": "heal",
  "emphasis": "story",
  "emphasise": "story",
  "emphasize": "story",
  "emphasizing": "story",
  "empiric": "beautiful",
  "empirical": "smart",
  "empiricism": "smart",
  "empirin": "build",
  "emplace": "build",
  "emplacement": "build",
  "employ": "taste",
  "employable": "beautiful",
  "employed": "taste",
  "emporium": "build",
  "empower": "sell",
  "empty": "build",
  "empyreal": "beautiful",
  "empyrean": "beautiful",
  "emu": "smart",
  "emulation": "smart",
  "emulous": "beautiful",
  "emulsion": "build",
  "emydidae": "heal",
  "enabling": "beautiful",
  "enact": "sell",
  "enactment": "story",
  "enalapril": "build",
  "enallage": "story",
  "enamel": "heal",
  "enamelware": "build",
  "enarthrosis": "heal",
  "enate": "beautiful",
  "enation": "heal",
  "enbrel": "build",
  "encainide": "build",
  "encampment": "build",
  "encapsulate": "build",
  "encapsulation": "smart",
  "encase": "build",
  "encaustic": "build",
  "encelia": "heal",
  "enceliopsis": "heal",
  "encephalartos": "heal",
  "encephalogram": "story",
  "encephalon": "heal",
  "enchain": "build",
  "enchant": "story",
  "enchanted": "story",
  "enchantment": "smart",
  "enchilada": "taste",
  "enchiridion": "story",
  "encipher": "story",
  "encircle": "build",
  "enclose": "build",
  "enclosed": "build",
  "enclosing": "build",
  "enclosure": "build",
  "enclothe": "heal",
  "encode": "story",
  "encoding": "story",
  "encolure": "heal",
  "encomium": "story",
  "encore": "story",
  "encounter": "story",
  "encourage": "sell",
  "encouragement": "story",
  "encouraging": "sell",
  "encroach": "sell",
  "encrust": "build",
  "encrustation": "smart",
  "encrypt": "story",
  "encumber": "build",
  "encumbered": "build",
  "encumbrance": "smart",
  "encyclia": "heal",
  "encyclical": "story",
  "encyclopaedia": "story",
  "encyclopaedism": "smart",
  "encyclopedia": "story",
  "encyclopedism": "smart",
  "end": "smart",
  "end-all": "smart",
  "end-plate": "heal",
  "end-stopped": "beautiful",
  "endaemonism": "smart",
  "endameba": "heal",
  "endamoeba": "heal",
  "endamoebidae": "heal",
  "endanger": "story",
  "endeavor": "sell",
  "endeavour": "sell",
  "endemic": "heal",
  "endemical": "beautiful",
  "endergonic": "beautiful",
  "ending": "story",
  "endive": "heal",
  "endoblast": "heal",
  "endocardium": "heal",
  "endocarp": "heal",
  "endocentric": "beautiful",
  "endocranium": "heal",
  "endocrine": "heal",
  "endocrinologist": "heal",
  "endocrinology": "smart",
  "endoderm": "heal",
  "endodontia": "smart",
  "endodontics": "smart",
  "endoergic": "beautiful",
  "endogamic": "beautiful",
  "endogamous": "beautiful",
  "endogen": "heal",
  "endogenic": "beautiful",
  "endogenous": "beautiful",
  "endogeny": "sound",
  "endolymph": "heal",
  "endometrium": "heal",
  "endomorphic": "beautiful",
  "endomycetales": "heal",
  "endoneurium": "heal",
  "endoparasite": "heal",
  "endoplasm": "heal",
  "endoprocta": "heal",
  "endorse": "sell",
  "endorsement": "story",
  "endoscope": "build",
  "endoskeleton": "heal",
  "endosperm": "heal",
  "endospore": "heal",
  "endosteum": "heal",
  "endothelium": "heal",
  "endothermal": "beautiful",
  "endothermic": "beautiful",
  "endow": "sell",
  "endowed": "sell",
  "endowment": "smart",
  "endozoan": "heal",
  "endozoic": "beautiful",
  "endplate": "heal",
  "endue": "sell",
  "endure": "smart",
  "enema": "heal",
  "energetic": "beautiful",
  "energid": "heal",
  "energise": "heal",
  "energiser": "build",
  "energize": "heal",
  "energizer": "build",
  "energizing": "heal",
  "energy": "sound",
  "energy-absorbing": "beautiful",
  "energy-releasing": "beautiful",
  "enets": "story",
  "enfeoff": "sell",
  "enfeoffment": "story",
  "enflurane": "build",
  "enfold": "build",
  "enfolding": "build",
  "enforce": "sell",
  "enforceable": "beautiful",
  "enforced": "sell",
  "enfranchise": "sell",
  "enfranchised": "sell",
  "enfranchisement": "sell",
  "engage": "sell",
  "engagement": "story",
  "engelmannia": "heal",
  "engender": "build",
  "engild": "build",
  "engine": "build",
  "engineer": "smart",
  "engineering": "smart",
  "enginery": "build",
  "english": "story",
  "english-gothic": "smart",
  "english-weed": "heal",
  "englut": "taste",
  "engorge": "taste",
  "engraft": "build",
  "engram": "smart",
  "engraulidae": "heal",
  "engraulis": "heal",
  "engrave": "build",
  "engraver": "beautiful",
  "engraving": "build",
  "engross": "smart",
  "engrossment": "smart",
  "engulf": "smart",
  "enhancer": "smart",
  "enhydra": "heal",
  "enigma": "smart",
  "eniwetok": "sound",
  "enjambement": "story",
  "enjambment": "story",
  "enjoin": "story",
  "enjoining": "story",
  "enjoinment": "story",
  "enjoy": "taste",
  "enkaid": "build",
  "enlace": "build",
  "enlarge": "story",
  "enlarged": "story",
  "enlargement": "story",
  "enlarger": "build",
  "enlighten": "story",
  "enlightened": "story",
  "enlightening": "story",
  "enlightenment": "smart",
  "enlist": "sell",
  "enlisting": "sell",
  "enlivened": "beautiful",
  "enmesh": "build",
  "ennead": "smart",
  "ennoble": "sell",
  "enology": "smart",
  "enough": "smart",
  "enounce": "story",
  "enovid": "build",
  "enquire": "story",
  "enquiry": "story",
  "enrich": "sell",
  "enrichment": "sell",
  "enrobe": "build",
  "enrol": "sell",
  "enroll": "sell",
  "ensconce": "build",
  "ensete": "heal",
  "enshrine": "build",
  "enshroud": "build",
  "ensign": "story",
  "ensilage": "taste",
  "ensile": "sell",
  "ensis": "heal",
  "ensky": "story",
  "enslave": "sell",
  "ensnare": "sell",
  "ensnarl": "build",
  "ensure": "story",
  "entablature": "build",
  "entail": "sell",
  "entailment": "smart",
  "entandrophragma": "heal",
  "entangle": "build",
  "entanglement": "build",
  "entelea": "heal",
  "entellus": "heal",
  "entente": "story",
  "enter": "sell",
  "enterics": "heal",
  "enterobacteria": "heal",
  "enterobacteriaceae": "heal",
  "enterobius": "heal",
  "enteroceptor": "heal",
  "enterolobium": "heal",
  "enteron": "heal",
  "enterovirus": "heal",
  "enterprising": "beautiful",
  "entertain": "sell",
  "enthrone": "sell",
  "enthuse": "story",
  "enthusiasm": "smart",
  "enthusiastic": "beautiful",
  "entice": "story",
  "enticement": "smart",
  "entire": "heal",
  "entitle": "sell",
  "entlebucher": "heal",
  "entoblast": "heal",
  "entoderm": "heal",
  "entoloma": "heal",
  "entolomataceae": "heal",
  "entomb": "sell",
  "entomion": "heal",
  "entomology": "smart",
  "entomophilous": "beautiful",
  "entomophthora": "heal",
  "entomophthoraceae": "heal",
  "entomophthorales": "heal",
  "entomostraca": "heal",
  "entoparasite": "heal",
  "entoproct": "heal",
  "entoprocta": "heal",
  "entozoan": "heal",
  "entozoic": "beautiful",
  "entozoon": "heal",
  "entrails": "heal",
  "entrance": "build",
  "entranceway": "build",
  "entrant": "build",
  "entrap": "sell",
  "entreat": "story",
  "entreaty": "story",
  "entrecote": "taste",
  "entree": "taste",
  "entremets": "taste",
  "entrench": "build",
  "entrenchment": "build",
  "entrepot": "build",
  "entrepreneur": "sell",
  "entrepreneurial": "sell",
  "entresol": "build",
  "entric": "heal",
  "entrust": "sell",
  "entry": "story",
  "entryway": "build",
  "entsi": "story",
  "entsy": "story",
  "entwine": "build",
  "enumerate": "story",
  "enumeration": "story",
  "enunciate": "story",
  "enunciation": "story",
  "enuresis": "smart",
  "envelop": "build",
  "envelope": "build",
  "environ": "build",
  "environmentalism": "smart",
  "environs": "build",
  "envisage": "build",
  "envision": "build",
  "envisioning": "smart",
  "envoi": "story",
  "envoy": "story",
  "enwrap": "build",
  "enzymology": "smart",
  "eohippus": "heal",
  "eolic": "story",
  "eolith": "build",
  "eonian": "beautiful",
  "eoraptor": "heal",
  "eosinophil": "heal",
  "eosinophile": "heal",
  "epacridaceae": "heal",
  "epacris": "heal",
  "epanalepsis": "story",
  "epanaphora": "story",
  "epanodos": "story",
  "epanorthosis": "story",
  "epaulet": "build",
  "epaulette": "build",
  "epauliere": "build",
  "epee": "build",
  "ependyma": "heal",
  "epenthesis": "story",
  "epergne": "build",
  "epha": "smart",
  "ephah": "smart",
  "ephedra": "heal",
  "ephedraceae": "heal",
  "ephemera": "heal",
  "ephemeral": "heal",
  "ephemerid": "heal",
  "ephemerida": "heal",
  "ephemeridae": "heal",
  "ephemeris": "story",
  "ephemeron": "heal",
  "ephemeroptera": "heal",
  "ephemeropteran": "heal",
  "ephesians": "story",
  "ephestia": "heal",
  "ephippidae": "heal",
  "ephippiorhynchus": "heal",
  "epi": "story",
  "epic": "story",
  "epicalyx": "heal",
  "epicanthus": "heal",
  "epicardia": "heal",
  "epicardium": "heal",
  "epicarp": "heal",
  "epicene": "beautiful",
  "epicondyle": "heal",
  "epicranium": "heal",
  "epicurean": "beautiful",
  "epicureanism": "smart",
  "epidemic": "beautiful",
  "epidemiologic": "heal",
  "epidemiological": "heal",
  "epidemiologist": "heal",
  "epidemiology": "heal",
  "epidendron": "heal",
  "epidendrum": "heal",
  "epidermis": "heal",
  "epidiascope": "build",
  "epididymis": "heal",
  "epigaea": "heal",
  "epigastrium": "heal",
  "epigenesis": "smart",
  "epiglottis": "heal",
  "epigram": "story",
  "epigraph": "story",
  "epigraphy": "smart",
  "epilachna": "heal",
  "epilate": "heal",
  "epilation": "smart",
  "epilator": "build",
  "epilobium": "heal",
  "epilog": "story",
  "epilogue": "story",
  "epimedium": "heal",
  "epinephelus": "heal",
  "epinephrin": "heal",
  "epinephrine": "heal",
  "epipactis": "heal",
  "epiphenomenon": "sound",
  "epiphora": "story",
  "epiphyllum": "heal",
  "epiphysis": "heal",
  "epiphyte": "heal",
  "epiplexis": "story",
  "epipremnum": "heal",
  "episcia": "heal",
  "episcopalianism": "smart",
  "episode": "story",
  "episperm": "heal",
  "epistasis": "smart",
  "episteme": "smart",
  "epistemology": "smart",
  "epistle": "story",
  "epistrophe": "story",
  "epitaph": "story",
  "epitaxy": "smart",
  "epithalamium": "story",
  "epithelium": "heal",
  "epithet": "story",
  "epitome": "smart",
  "epizoan": "heal",
  "epizoic": "beautiful",
  "epizoon": "heal",
  "eponym": "story",
  "eponymy": "smart",
  "epos": "story",
  "epoxy": "build",
  "eprom": "build",
  "epsilon": "story",
  "eptatretus": "heal",
  "eptesicus": "heal",
  "equaliser": "build",
  "equalitarianism": "smart",
  "equalizer": "sound",
  "equanil": "build",
  "equate": "smart",
  "equating": "smart",
  "equation": "story",
  "equatorial": "build",
  "equetus": "heal",
  "equid": "heal",
  "equidae": "heal",
  "equidistribution": "smart",
  "equilateral": "beautiful",
  "equilibrium": "smart",
  "equine": "heal",
  "equip": "sell",
  "equipage": "build",
  "equipment": "build",
  "equipped": "sell",
  "equipping": "sell",
  "equipt": "beautiful",
  "equisetaceae": "heal",
  "equisetales": "heal",
  "equisetatae": "heal",
  "equisetum": "heal",
  "equitable": "beautiful",
  "equity": "sell",
  "equivalent": "smart",
  "equivocal": "beautiful",
  "equivocate": "story",
  "equivocation": "story",
  "equus": "heal",
  "era": "story",
  "eradicable": "beautiful",
  "eradicate": "build",
  "eragrostis": "heal",
  "eranthis": "heal",
  "erase": "build",
  "eraser": "build",
  "erastianism": "smart",
  "erasure": "story",
  "ercilla": "heal",
  "erect": "build",
  "erecting": "build",
  "erection": "build",
  "eremitic": "beautiful",
  "eremitical": "beautiful",
  "erethizon": "heal",
  "erethizontidae": "heal",
  "eretmochelys": "heal",
  "erewhon": "story",
  "erg": "smart",
  "ergometer": "build",
  "ergonomics": "smart",
  "ergot": "heal",
  "erianthus": "heal",
  "erica": "heal",
  "ericaceae": "heal",
  "ericales": "heal",
  "erigeron": "heal",
  "erignathus": "heal",
  "erinaceidae": "heal",
  "erinaceus": "heal",
  "eringo": "heal",
  "eriobotrya": "heal",
  "eriocaulaceae": "heal",
  "eriocaulon": "heal",
  "eriodictyon": "heal",
  "eriogonum": "heal",
  "eriophorum": "heal",
  "eriophyllum": "heal",
  "eriosoma": "heal",
  "eristic": "smart",
  "erithacus": "heal",
  "erlang": "smart",
  "ermine": "heal",
  "ern": "heal",
  "erne": "heal",
  "eroding": "smart",
  "erodium": "heal",
  "erolia": "heal",
  "erosion": "smart",
  "erotic": "beautiful",
  "err": "smart",
  "erratum": "story",
  "error": "smart",
  "ersatz": "smart",
  "erse": "story",
  "eruca": "heal",
  "eruct": "heal",
  "eruditeness": "smart",
  "erudition": "smart",
  "eruptive": "beautiful",
  "erwinia": "heal",
  "eryngium": "heal",
  "eryngo": "heal",
  "erysimum": "heal",
  "erysiphaceae": "heal",
  "erysiphales": "heal",
  "erysiphe": "heal",
  "erythrina": "heal",
  "erythroblast": "heal",
  "erythrocebus": "heal",
  "erythrocin": "build",
  "erythrocyte": "heal",
  "erythromycin": "build",
  "erythronium": "heal",
  "erythropoiesis": "smart",
  "erythroxylaceae": "heal",
  "erythroxylon": "heal",
  "erythroxylum": "heal",
  "escalator": "story",
  "escallop": "taste",
  "escapement": "build",
  "escapology": "smart",
  "escargot": "taste",
  "escarole": "taste",
  "escarp": "build",
  "escarpment": "build",
  "eschalot": "heal",
  "eschar": "heal",
  "eschatology": "smart",
  "escheat": "sell",
  "escherichia": "heal",
  "eschew": "story",
  "eschrichtiidae": "heal",
  "eschrichtius": "heal",
  "eschscholtzia": "heal",
  "escolar": "heal",
  "escritoire": "build",
  "escrow": "sell",
  "escudo": "smart",
  "escutcheon": "build",
  "esidrix": "build",
  "eskalith": "build",
  "eskimo": "story",
  "eskimo-aleut": "story",
  "esmolol": "build",
  "esocidae": "heal",
  "esop": "smart",
  "esophagoscope": "build",
  "esophagus": "heal",
  "esoteric": "beautiful",
  "esoterica": "story",
  "esox": "heal",
  "esp": "story",
  "espadrille": "build",
  "espagnole": "taste",
  "espalier": "build",
  "esparcet": "heal",
  "esperantido": "story",
  "esperanto": "story",
  "esplanade": "build",
  "espouse": "sell",
  "espresso": "taste",
  "espy": "sound",
  "esquimau": "story",
  "essay": "story",
  "esselen": "story",
  "essence": "smart",
  "essential": "beautiful",
  "establish": "sell",
  "established": "sell",
  "establishment": "build",
  "establishmentarianism": "smart",
  "establishmentism": "smart",
  "estaminet": "build",
  "estate": "sell",
  "estazolam": "build",
  "esteem": "smart",
  "esther": "story",
  "esthesia": "smart",
  "esthesis": "smart",
  "esthetic": "smart",
  "esthetical": "beautiful",
  "esthetics": "smart",
  "esthonian": "story",
  "estimable": "beautiful",
  "estimate": "smart",
  "estimation": "story",
  "estivate": "heal",
  "estonian": "story",
  "estoppel": "story",
  "estradiol": "sound",
  "estragon": "heal",
  "estrange": "sell",
  "estrilda": "heal",
  "estrone": "sound",
  "estronol": "sound",
  "estrous": "beautiful",
  "eta": "story",
  "etagere": "build",
  "etamin": "build",
  "etamine": "build",
  "etanercept": "build",
  "etcetera": "build",
  "etch": "build",
  "etching": "beautiful",
  "etd": "build",
  "etf": "sell",
  "ethanol": "taste",
  "ethchlorvynol": "build",
  "ether": "story",
  "ethereal": "beautiful",
  "etherise": "heal",
  "etherize": "heal",
  "ethernet": "build",
  "ethic": "smart",
  "ethical": "beautiful",
  "ethicism": "smart",
  "ethics": "smart",
  "ethmoid": "heal",
  "ethnic": "beautiful",
  "ethnocentrism": "smart",
  "ethnography": "smart",
  "ethnology": "smart",
  "ethocaine": "build",
  "ethology": "smart",
  "ethosuximide": "build",
  "ethoxyethane": "build",
  "ethrane": "build",
  "ethril": "build",
  "ethyne": "build",
  "etiolate": "heal",
  "etiology": "smart",
  "etiquette": "story",
  "etna": "build",
  "etodolac": "build",
  "etropus": "heal",
  "etude": "story",
  "etui": "build",
  "etymologise": "story",
  "etymologize": "story",
  "etymologizing": "story",
  "etymology": "story",
  "etymon": "story",
  "euarctos": "heal",
  "euascomycetes": "heal",
  "eubacteria": "heal",
  "eubacteriales": "heal",
  "eubacterium": "heal",
  "eubryales": "heal",
  "eucalypt": "heal",
  "eucalyptus": "heal",
  "eucarya": "heal",
  "eucaryote": "heal",
  "eucinostomus": "heal",
  "eudemonism": "smart",
  "euderma": "heal",
  "eudiometer": "build",
  "eudyptes": "heal",
  "eugenia": "heal",
  "eugenics": "smart",
  "euglena": "heal",
  "euglenaceae": "heal",
  "euglenid": "heal",
  "euglenoid": "heal",
  "euglenophyceae": "heal",
  "euglenophyta": "heal",
  "euglenophyte": "heal",
  "eukaryote": "heal",
  "eulogise": "story",
  "eulogium": "story",
  "eulogize": "story",
  "eulogy": "story",
  "eumeces": "heal",
  "eumenes": "heal",
  "eumetopias": "heal",
  "eumops": "heal",
  "eumycetes": "heal",
  "eumycota": "heal",
  "eunectes": "heal",
  "euonymus": "heal",
  "eupatorium": "heal",
  "euphagus": "heal",
  "euphausiacea": "heal",
  "euphemise": "story",
  "euphemism": "story",
  "euphemistic": "beautiful",
  "euphemize": "story",
  "euphonious": "beautiful",
  "euphonium": "build",
  "euphonous": "beautiful",
  "euphony": "smart",
  "euphorbia": "heal",
  "euphorbiaceae": "heal",
  "euphoriant": "build",
  "euphoric": "beautiful",
  "euphractus": "heal",
  "euphuism": "story",
  "euplectella": "heal",
  "eupneic": "beautiful",
  "eupnoeic": "beautiful",
  "euproctis": "heal",
  "eurhythmics": "sound",
  "euro": "smart",
  "eurobabble": "story",
  "eurocentrism": "smart",
  "eurocurrency": "sell",
  "eurodollar": "smart",
  "euronithopod": "heal",
  "euronithopoda": "heal",
  "europan": "story",
  "europeanisation": "smart",
  "europeanization": "smart",
  "eurotiales": "heal",
  "eurotium": "heal",
  "euryale": "heal",
  "euryalida": "heal",
  "eurylaimi": "heal",
  "eurylaimidae": "heal",
  "eurypterid": "heal",
  "eurypterida": "heal",
  "eusporangiate": "beautiful",
  "eusporangium": "heal",
  "eustoma": "heal",
  "eutamias": "heal",
  "euterpe": "heal",
  "euthenics": "smart",
  "eutheria": "heal",
  "eutherian": "heal",
  "euthynnus": "heal",
  "eutrophication": "smart",
  "evacuation": "smart",
  "evade": "story",
  "evaluate": "smart",
  "evaluation": "smart",
  "evangel": "story",
  "evangelical": "beautiful",
  "evangelicalism": "smart",
  "evangelise": "story",
  "evangelism": "story",
  "evangelistic": "beautiful",
  "evangelize": "story",
  "evaporation": "smart",
  "evaporometer": "build",
  "evasion": "story",
  "even": "build",
  "evening": "build",
  "evening-snow": "heal",
  "eveningwear": "build",
  "evenki": "story",
  "evensong": "story",
  "event": "sound",
  "eventful": "beautiful",
  "evergreen": "heal",
  "everlasting": "heal",
  "evernia": "heal",
  "evict": "build",
  "evidence": "smart",
  "evidentiary": "beautiful",
  "evil": "beautiful",
  "evince": "story",
  "eviscerate": "build",
  "evitable": "beautiful",
  "evocation": "smart",
  "evoke": "build",
  "evolution": "smart",
  "evolutionism": "smart",
  "evolve": "build",
  "ewe": "story",
  "ewenki": "story",
  "ewer": "build",
  "exabit": "smart",
  "exabyte": "smart",
  "exact": "story",
  "exacting": "story",
  "exacum": "heal",
  "exaeretodon": "heal",
  "exaggerate": "story",
  "exaggeration": "story",
  "exalt": "story",
  "exam": "story",
  "examen": "smart",
  "examination": "story",
  "examine": "smart",
  "example": "smart",
  "exaugural": "beautiful",
  "exbibit": "smart",
  "exbibyte": "smart",
  "excalibur": "build",
  "excavate": "sound",
  "excavation": "build",
  "excavator": "build",
  "excellence": "smart",
  "excellency": "smart",
  "except": "story",
  "exception": "smart",
  "excerpt": "story",
  "excerption": "story",
  "exchange": "sound",
  "exchangeable": "beautiful",
  "exchequer": "sell",
  "excise": "sell",
  "excision": "story",
  "excitability": "smart",
  "excitable": "beautiful",
  "excitant": "build",
  "excite": "sound",
  "excited": "sound",
  "exciting": "sound",
  "exclaim": "story",
  "exclaiming": "story",
  "exclamation": "story",
  "exclude": "smart",
  "exclusion": "smart",
  "exclusive": "story",
  "excogitate": "build",
  "excogitation": "smart",
  "excommunicate": "story",
  "excoriate": "story",
  "excoriation": "story",
  "excrescence": "heal",
  "excrete": "heal",
  "excreting": "smart",
  "excretion": "smart",
  "excruciate": "heal",
  "exculpate": "story",
  "exculpation": "story",
  "exculpatory": "beautiful",
  "excursus": "story",
  "excusable": "beautiful",
  "excusatory": "beautiful",
  "excuse": "story",
  "execrate": "story",
  "execration": "story",
  "execute": "sell",
  "executing": "sell",
  "execution": "smart",
  "exegesis": "story",
  "exemplar": "smart",
  "exemplification": "story",
  "exemplify": "story",
  "exempt": "sell",
  "exemption": "sell",
  "exerciser": "build",
  "exercising": "taste",
  "exercycle": "build",
  "exergonic": "beautiful",
  "exert": "taste",
  "exfoliate": "build",
  "exfoliation": "sound",
  "exhale": "heal",
  "exhaust": "build",
  "exhausted": "heal",
  "exhaustible": "beautiful",
  "exhibit": "beautiful",
  "exhibitionism": "story",
  "exhort": "story",
  "exhortation": "story",
  "exhume": "sell",
  "exile": "sell",
  "existent": "beautiful",
  "existential": "beautiful",
  "existentialism": "smart",
  "existing": "beautiful",
  "exit": "build",
  "exmoor": "heal",
  "exobiology": "smart",
  "exocarp": "heal",
  "exocentric": "beautiful",
  "exocet": "build",
  "exocoetidae": "heal",
  "exocrine": "heal",
  "exocycloida": "heal",
  "exode": "story",
  "exoderm": "heal",
  "exodontia": "smart",
  "exodontics": "smart",
  "exodus": "story",
  "exoergic": "beautiful",
  "exogamic": "beautiful",
  "exogamous": "beautiful",
  "exogen": "heal",
  "exogenic": "beautiful",
  "exogenous": "beautiful",
  "exonerate": "story",
  "exopterygota": "heal",
  "exorcise": "build",
  "exorcism": "smart",
  "exorcize": "build",
  "exordium": "story",
  "exoskeleton": "heal",
  "exoteric": "beautiful",
  "exothermal": "beautiful",
  "exothermic": "beautiful",
  "expansion": "story",
  "expansionism": "smart",
  "expansive": "beautiful",
  "expansivity": "smart",
  "expatiate": "story",
  "expatiation": "story",
  "expatriate": "sell",
  "expect": "smart",
  "expectancy": "smart",
  "expectation": "smart",
  "expected": "smart",
  "expectorant": "build",
  "expectorate": "heal",
  "expectoration": "smart",
  "expectorator": "build",
  "expedient": "beautiful",
  "expedite": "sell",
  "expel": "sell",
  "expelling": "smart",
  "expend": "taste",
  "expendable": "beautiful",
  "expending": "taste",
  "expenditure": "sell",
  "expense": "sell",
  "expensive": "beautiful",
  "experience": "smart",
  "experienced": "sound",
  "experient": "beautiful",
  "experiential": "beautiful",
  "experiment": "smart",
  "experimental": "beautiful",
  "experimentalism": "smart",
  "experimentation": "smart",
  "expert": "beautiful",
  "expertise": "smart",
  "expertness": "smart",
  "expiate": "sell",
  "expiation": "sell",
  "expire": "heal",
  "expired": "heal",
  "explain": "story",
  "explanandum": "story",
  "explanans": "story",
  "explanation": "story",
  "expletive": "story",
  "explicable": "beautiful",
  "explicandum": "story",
  "explicate": "story",
  "explication": "story",
  "explicit": "beautiful",
  "explode": "smart",
  "exploit": "taste",
  "exploited": "taste",
  "exploration": "smart",
  "explorative": "beautiful",
  "exploratory": "beautiful",
  "explore": "smart",
  "explorer": "story",
  "explosive": "build",
  "exponent": "story",
  "export": "build",
  "exportable": "beautiful",
  "exportation": "build",
  "exporting": "sell",
  "expose": "story",
  "exposit": "story",
  "exposition": "story",
  "expostulate": "story",
  "expostulation": "story",
  "exposure": "story",
  "expound": "story",
  "expounding": "story",
  "express": "smart",
  "express-mail": "story",
  "expressed": "story",
  "expressible": "beautiful",
  "expression": "story",
  "expressway": "build",
  "expropriate": "build",
  "expunge": "build",
  "expunging": "build",
  "exsert": "heal",
  "extant": "beautiful",
  "extemporisation": "sound",
  "extemporise": "sound",
  "extemporization": "sound",
  "extemporize": "sound",
  "extend": "sell",
  "extended": "sell",
  "extensible": "beautiful",
  "extensile": "beautiful",
  "extension": "story",
  "extensive": "beautiful",
  "extensor": "heal",
  "extenuate": "story",
  "extenuation": "story",
  "exterior": "beautiful",
  "exterminate": "build",
  "external": "smart",
  "externalisation": "smart",
  "externalise": "smart",
  "externalization": "smart",
  "externalize": "smart",
  "exteroception": "smart",
  "exteroceptor": "heal",
  "exterritorial": "beautiful",
  "extinct": "beautiful",
  "extinction": "smart",
  "extinguishable": "beautiful",
  "extinguisher": "build",
  "extirpate": "build",
  "extol": "story",
  "extolment": "story",
  "extort": "sell",
  "extortion": "sell",
  "extra": "story",
  "extract": "story",
  "extraction": "smart",
  "extractor": "build",
  "extradite": "sell",
  "extramural": "beautiful",
  "extraordinary": "beautiful",
  "extrapolate": "story",
  "extrapolation": "smart",
  "extrasensory": "beautiful",
  "extraterritorial": "beautiful",
  "extravasate": "build",
  "extravasation": "smart",
  "extraversive": "beautiful",
  "extravert": "beautiful",
  "extreme": "beautiful",
  "extremism": "smart",
  "extremist": "beautiful",
  "extremity": "heal",
  "extremum": "smart",
  "extricable": "beautiful",
  "extricate": "build",
  "extrinsic": "beautiful",
  "extropy": "story",
  "extrospective": "beautiful",
  "extroversive": "beautiful",
  "extrovert": "beautiful",
  "extroverted": "beautiful",
  "extrude": "build",
  "extrusive": "beautiful",
  "exuberate": "story",
  "exudate": "heal",
  "exude": "heal",
  "exult": "story",
  "exultation": "story",
  "exuviae": "heal",
  "exuviate": "heal",
  "eyas": "heal",
  "eye": "heal",
  "eye-catcher": "smart",
  "eye-drop": "smart",
  "eye-lotion": "build",
  "eyeball": "heal",
  "eyebath": "build",
  "eyebrow": "heal",
  "eyecup": "build",
  "eyed": "sound",
  "eyedrop": "smart",
  "eyeglass": "build",
  "eyeglasses": "build",
  "eyehole": "build",
  "eyelash": "heal",
  "eyeless": "beautiful",
  "eyelet": "build",
  "eyelid": "heal",
  "eyeliner": "build",
  "eyepatch": "build",
  "eyepiece": "build",
  "eyes": "smart",
  "eyeshade": "build",
  "eyeshadow": "build",
  "eyesight": "smart",
  "eyetooth": "heal",
  "eyewash": "build",
  "eyewitness": "sound",
  "eyra": "heal",
  "eyrir": "smart",
  "ezechiel": "story",
  "ezed": "story",
  "ezekiel": "story",
  "ezo-yama-hagi": "heal",
  "ezra": "story",
  "fabaceae": "heal",
  "fabian": "beautiful",
  "fabiana": "heal",
  "fabianism": "smart",
  "fable": "story",
  "fabric": "beautiful",
  "fabricate": "build",
  "fabrication": "build",
  "fabricator": "build",
  "facade": "build",
  "face": "heal",
  "face-lift": "heal",
  "face-off": "story",
  "faced": "story",
  "faceless": "beautiful",
  "faceplate": "build",
  "facer": "smart",
  "facet": "smart",
  "faceted": "beautiful",
  "facia": "heal",
  "facial": "heal",
  "facilitate": "build",
  "facilitation": "sound",
  "facility": "build",
  "facing": "build",
  "facsimile": "build",
  "fact": "smart",
  "factoid": "story",
  "factor": "smart",
  "factorial": "smart",
  "factoring": "smart",
  "factorisation": "smart",
  "factorise": "smart",
  "factorization": "smart",
  "factorize": "smart",
  "factory": "build",
  "factory-made": "beautiful",
  "factual": "beautiful",
  "facula": "sound",
  "facultative": "beautiful",
  "faculty": "smart",
  "fad": "smart",
  "fadeout": "sound",
  "fado": "story",
  "fae": "build",
  "faerie": "smart",
  "faeroese": "story",
  "faery": "smart",
  "fag": "build",
  "fagaceae": "heal",
  "fagales": "heal",
  "faggot": "build",
  "faggoting": "build",
  "fagopyrum": "heal",
  "fagot": "build",
  "fagoting": "build",
  "fagus": "heal",
  "faience": "build",
  "fail": "sell",
  "fail-safe": "build",
  "failing": "sell",
  "faille": "build",
  "faint": "heal",
  "fair-maids-of-france": "heal",
  "fair-mindedness": "smart",
  "fairlead": "build",
  "fairness": "smart",
  "fairy-slipper": "heal",
  "fairyland": "smart",
  "fairytale": "story",
  "faith": "smart",
  "faithful": "beautiful",
  "fake": "build",
  "fakeer": "beautiful",
  "falafel": "taste",
  "falcatifolium": "heal",
  "falchion": "build",
  "falco": "heal",
  "falcon": "heal",
  "falcon-gentil": "heal",
  "falcon-gentle": "heal",
  "falconidae": "heal",
  "falconiformes": "heal",
  "falconry": "smart",
  "falderol": "build",
  "fall-board": "build",
  "fallacy": "smart",
  "fallal": "build",
  "fallboard": "build",
  "fallible": "beautiful",
  "falloff": "smart",
  "fallout": "sound",
  "fallow": "beautiful",
  "falls": "heal",
  "false": "beautiful",
  "falsehood": "story",
  "falsetto": "beautiful",
  "falsie": "build",
  "falsification": "smart",
  "falsify": "story",
  "falsifying": "story",
  "falsity": "story",
  "familial": "beautiful",
  "familiar": "beautiful",
  "familiarisation": "smart",
  "familiarise": "story",
  "familiarity": "smart",
  "familiarization": "smart",
  "familiarize": "story",
  "famish": "taste",
  "famotidine": "build",
  "fan": "build",
  "fan-jet": "build",
  "fanaloka": "heal",
  "fanatic": "beautiful",
  "fanaticism": "smart",
  "fanatism": "smart",
  "fancier": "beautiful",
  "fancy": "smart",
  "fancywork": "build",
  "fanfare": "story",
  "fang": "story",
  "fanion": "build",
  "fanjet": "build",
  "fanlight": "build",
  "fanny": "heal",
  "fantail": "build",
  "fantasia": "story",
  "fantasise": "build",
  "fantasize": "build",
  "fantasm": "smart",
  "fantasy": "story",
  "fanweed": "heal",
  "fanwort": "heal",
  "faq": "story",
  "far": "beautiful",
  "farad": "smart",
  "farce": "story",
  "fardel": "smart",
  "fare": "smart",
  "farewell": "story",
  "farfalle": "taste",
  "farina": "taste",
  "farkleberry": "heal",
  "farm": "build",
  "farm-place": "build",
  "farmhouse": "build",
  "farming": "build",
  "farmplace": "build",
  "farmstead": "sell",
  "farmyard": "build",
  "faroese": "story",
  "farrow": "smart",
  "farrowing": "smart",
  "farsi": "story",
  "farsighted": "beautiful",
  "farsightedness": "smart",
  "fart": "heal",
  "farthing": "sell",
  "farthingale": "build",
  "farting": "heal",
  "fas": "story",
  "fasces": "story",
  "fascia": "heal",
  "fascicle": "story",
  "fascicule": "story",
  "fasciculus": "heal",
  "fasciola": "heal",
  "fasciolidae": "heal",
  "fasciolopsis": "heal",
  "fascism": "smart",
  "fashion": "beautiful",
  "fashionable": "beautiful",
  "fashioning": "build",
  "fast": "taste",
  "fasten": "build",
  "fastened": "build",
  "fastener": "build",
  "fastening": "build",
  "fastidious": "beautiful",
  "fasting": "taste",
  "fastnacht": "taste",
  "fastness": "build",
  "fat": "heal",
  "fat-free": "beautiful",
  "fatal": "beautiful",
  "fatalism": "smart",
  "fatback": "taste",
  "fate": "story",
  "fathom": "smart",
  "fathomable": "beautiful",
  "fathometer": "build",
  "fatigue": "sound",
  "fatigues": "build",
  "fatiha": "story",
  "fatihah": "story",
  "fatless": "beautiful",
  "fatten": "taste",
  "fatty": "beautiful",
  "fatwah": "story",
  "fauces": "heal",
  "faucet": "build",
  "fauld": "build",
  "faultfinding": "story",
  "faulting": "story",
  "fauteuil": "build",
  "favor": "smart",
  "favorable": "beautiful",
  "favorite": "smart",
  "favoritism": "smart",
  "favour": "smart",
  "favourable": "beautiful",
  "favourite": "smart",
  "favouritism": "smart",
  "fawn": "heal",
  "fax": "build",
  "fearful": "beautiful",
  "fearless": "beautiful",
  "feast": "taste",
  "feasting": "taste",
  "feather": "heal",
  "feather-foil": "heal",
  "featherbed": "build",
  "featherbedding": "sell",
  "feathered": "build",
  "featheredge": "build",
  "featherfoil": "heal",
  "feathering": "build",
  "featherless": "beautiful",
  "feathertop": "heal",
  "feature": "smart",
  "febrifuge": "build",
  "fecundate": "heal",
  "fecundity": "smart",
  "fed": "taste",
  "fedelline": "taste",
  "federal": "beautiful",
  "federalism": "smart",
  "federate": "beautiful",
  "federita": "heal",
  "fedora": "build",
  "fee": "sell",
  "fee-tail": "sell",
  "feeblemindedness": "smart",
  "feed": "taste",
  "feedback": "smart",
  "feedbag": "build",
  "feeder": "heal",
  "feeding": "taste",
  "feedlot": "build",
  "feel": "smart",
  "feeler": "heal",
  "feeling": "smart",
  "feelings": "smart",
  "feign": "story",
  "feigning": "story",
  "feijoa": "heal",
  "feint": "build",
  "feist": "heal",
  "felafel": "taste",
  "feldene": "build",
  "felicia": "heal",
  "felicitate": "story",
  "felicitation": "story",
  "felicitous": "beautiful",
  "felid": "heal",
  "felidae": "heal",
  "feline": "heal",
  "felis": "heal",
  "fell": "build",
  "fellate": "sound",
  "felloe": "build",
  "fellow": "smart",
  "fellowship": "sell",
  "felly": "build",
  "felt": "build",
  "felucca": "build",
  "felwort": "heal",
  "female": "heal",
  "feminine": "story",
  "feminisation": "smart",
  "feminism": "smart",
  "feminization": "smart",
  "femoris": "heal",
  "femtochemistry": "smart",
  "femtometer": "smart",
  "femtometre": "smart",
  "femtovolt": "smart",
  "femur": "heal",
  "fen": "smart",
  "fence": "build",
  "fencing": "build",
  "fend": "sell",
  "fender": "build",
  "fenestella": "build",
  "fenestra": "heal",
  "fennel": "heal",
  "fennic": "story",
  "fenoprofen": "build",
  "fentanyl": "build",
  "fenugreek": "heal",
  "fenusa": "heal",
  "feoff": "sell",
  "feosol": "build",
  "fer-de-lance": "heal",
  "fergon": "build",
  "fermata": "story",
  "ferment": "taste",
  "fermentable": "taste",
  "fermentation": "taste",
  "fermenting": "taste",
  "fermentologist": "taste",
  "fermi": "smart",
  "fern": "heal",
  "ferned": "beautiful",
  "fernless": "beautiful",
  "ferny": "beautiful",
  "ferocactus": "heal",
  "ferret": "heal",
  "ferrimagnetism": "sound",
  "ferromagnetism": "sound",
  "ferrule": "build",
  "ferry": "build",
  "ferryboat": "build",
  "fertile": "beautiful",
  "fertilise": "heal",
  "fertilize": "heal",
  "ferule": "build",
  "fescue": "heal",
  "fess": "build",
  "fesse": "build",
  "fester": "heal",
  "festering": "smart",
  "festoon": "build",
  "festoonery": "build",
  "festschrift": "story",
  "festuca": "heal",
  "fet": "build",
  "fetch": "build",
  "fete": "sell",
  "feterita": "heal",
  "fetich": "build",
  "fetichism": "smart",
  "fetish": "build",
  "fetishism": "smart",
  "fetlock": "heal",
  "fetology": "smart",
  "fetor": "smart",
  "fetoscope": "build",
  "fetoscopy": "heal",
  "fetter": "build",
  "fetterbush": "heal",
  "fettle": "sell",
  "fettuccine": "taste",
  "fettuccini": "taste",
  "fetus": "heal",
  "feudatory": "beautiful",
  "feverfew": "heal",
  "feverish": "beautiful",
  "feverroot": "heal",
  "few": "beautiful",
  "fewer": "beautiful",
  "fewest": "beautiful",
  "fez": "build",
  "fiat": "story",
  "fib": "story",
  "fibbing": "story",
  "fiber": "taste",
  "fiberboard": "build",
  "fiberoptics": "story",
  "fiberscope": "build",
  "fibre": "heal",
  "fibreboard": "build",
  "fibreoptics": "story",
  "fibrillate": "heal",
  "fibrinolysis": "smart",
  "fibroblast": "heal",
  "fibrocartilage": "heal",
  "fibula": "heal",
  "fica": "sell",
  "fice": "heal",
  "fichu": "build",
  "fictile": "beautiful",
  "fiction": "story",
  "fictional": "beautiful",
  "fictionalisation": "story",
  "fictionalise": "build",
  "fictionalization": "story",
  "fictionalize": "build",
  "ficus": "heal",
  "fiddle": "build",
  "fiddle-faddle": "story",
  "fiddlehead": "heal",
  "fiddleneck": "heal",
  "fiddlestick": "build",
  "fiducial": "beautiful",
  "fief": "sell",
  "field": "smart",
  "field-test": "sell",
  "fieldfare": "heal",
  "fieldmouse": "heal",
  "fieldwork": "build",
  "fife": "build",
  "fifteen": "smart",
  "fifteenth": "beautiful",
  "fifth": "smart",
  "fifties": "smart",
  "fiftieth": "beautiful",
  "fifty": "smart",
  "fig": "story",
  "fig-bird": "heal",
  "figeater": "heal",
  "fight": "story",
  "fighter": "build",
  "fighting": "sell",
  "figment": "smart",
  "figurative": "beautiful",
  "figure": "story",
  "figurehead": "build",
  "figurine": "build",
  "figuring": "smart",
  "figwort": "heal",
  "fijian": "story",
  "filago": "heal",
  "filagree": "build",
  "filament": "heal",
  "filaree": "heal",
  "filaria": "heal",
  "filariidae": "heal",
  "filature": "build",
  "filbert": "heal",
  "filch": "sell",
  "file": "story",
  "filefish": "heal",
  "filename": "story",
  "filet": "taste",
  "filial": "beautiful",
  "filiate": "smart",
  "filibuster": "sell",
  "filicales": "heal",
  "filicinae": "heal",
  "filicopsida": "heal",
  "filigree": "build",
  "filing": "story",
  "filipino": "story",
  "fill": "smart",
  "fillagree": "build",
  "filled": "sell",
  "filler": "smart",
  "fillet": "taste",
  "filling": "smart",
  "fillip": "smart",
  "filly": "heal",
  "film": "story",
  "film-make": "build",
  "filming": "story",
  "filoviridae": "heal",
  "filovirus": "heal",
  "fils": "smart",
  "filter": "build",
  "filth": "story",
  "filtrate": "build",
  "filtration": "smart",
  "filum": "heal",
  "fimbria": "heal",
  "fin": "smart",
  "finagle": "sell",
  "final": "story",
  "finale": "story",
  "finance": "smart",
  "finances": "sell",
  "financier": "sell",
  "financing": "sell",
  "finback": "heal",
  "finch": "heal",
  "find": "smart",
  "finder": "build",
  "finding": "sell",
  "fine": "sell",
  "finedraw": "build",
  "finery": "build",
  "finger": "heal",
  "finger-flower": "heal",
  "finger-paint": "build",
  "finger-painting": "build",
  "finger-pointing": "story",
  "finger-root": "heal",
  "finger-spell": "story",
  "fingerboard": "story",
  "fingerbreadth": "smart",
  "fingered": "build",
  "fingerflower": "heal",
  "fingering": "build",
  "fingerless": "beautiful",
  "fingerling": "heal",
  "fingernail": "heal",
  "fingerpaint": "build",
  "fingerpointing": "story",
  "fingerpost": "story",
  "fingerprint": "story",
  "fingerprinting": "build",
  "fingerroot": "heal",
  "fingerspell": "story",
  "fingerspelling": "story",
  "fingerstall": "build",
  "fingertip": "heal",
  "finial": "build",
  "finis": "sound",
  "finish": "sound",
  "finished": "build",
  "finite": "beautiful",
  "fink": "sell",
  "finnan": "taste",
  "finnic": "story",
  "finnish": "story",
  "finno-ugrian": "story",
  "finno-ugric": "story",
  "finocchio": "taste",
  "fipple": "build",
  "fir": "heal",
  "fire": "smart",
  "fire-bush": "heal",
  "fire-on-the-mountain": "heal",
  "fire-wheel": "heal",
  "firearm": "build",
  "fireball": "sound",
  "firebase": "smart",
  "firebird": "heal",
  "fireboat": "build",
  "firebomb": "build",
  "firebox": "build",
  "firebrat": "heal",
  "firebrick": "build",
  "firebug": "heal",
  "firecracker": "build",
  "firedog": "build",
  "firefly": "heal",
  "fireguard": "build",
  "firehouse": "build",
  "firelight": "sound",
  "firelock": "build",
  "fireplace": "build",
  "fireplug": "build",
  "fireproof": "beautiful",
  "fireroom": "build",
  "fireside": "build",
  "firestone": "build",
  "firestorm": "sound",
  "firethorn": "heal",
  "firetrap": "build",
  "firewall": "smart",
  "firewater": "taste",
  "fireweed": "heal",
  "firework": "build",
  "firkin": "smart",
  "firm": "beautiful",
  "firmiana": "heal",
  "firmware": "smart",
  "first": "smart",
  "firstborn": "beautiful",
  "fisa": "story",
  "fisc": "sell",
  "fish": "taste",
  "fish-fly": "heal",
  "fishbone": "heal",
  "fishbowl": "build",
  "fisher": "heal",
  "fishery": "build",
  "fishgig": "build",
  "fishhook": "build",
  "fishing": "build",
  "fishnet": "build",
  "fishpaste": "taste",
  "fishplate": "build",
  "fishworm": "heal",
  "fishy": "beautiful",
  "fissile": "beautiful",
  "fission": "smart",
  "fissionable": "beautiful",
  "fissiparity": "smart",
  "fissiped": "heal",
  "fissipedia": "heal",
  "fissure": "heal",
  "fissurella": "heal",
  "fissurellidae": "heal",
  "fist": "heal",
  "fistful": "smart",
  "fistmele": "smart",
  "fistula": "heal",
  "fistularia": "heal",
  "fistulariidae": "heal",
  "fistulina": "heal",
  "fistulinaceae": "heal",
  "fistulous": "beautiful",
  "fitch": "heal",
  "fitment": "build",
  "fitter": "beautiful",
  "fitting": "build",
  "five": "smart",
  "five-finger": "heal",
  "five-spot": "sell",
  "fivepence": "sell",
  "fiver": "sell",
  "fives": "smart",
  "fivesome": "smart",
  "fixate": "sell",
  "fixation": "smart",
  "fixative": "build",
  "fixed": "build",
  "fixer": "build",
  "fixer-upper": "build",
  "fixing": "build",
  "fixings": "taste",
  "fixture": "build",
  "fizgig": "build",
  "fizz": "taste",
  "flab": "heal",
  "flabbergast": "smart",
  "flack": "story",
  "flacourtia": "heal",
  "flacourtiaceae": "heal",
  "flag": "build",
  "flagellata": "heal",
  "flagellate": "heal",
  "flagellated": "build",
  "flagellum": "build",
  "flageolet": "taste",
  "flagfish": "heal",
  "flagging": "build",
  "flagon": "build",
  "flagpole": "build",
  "flagroot": "heal",
  "flagship": "build",
  "flagstaff": "build",
  "flagstone": "build",
  "flagyl": "build",
  "flail": "build",
  "flair": "smart",
  "flak": "story",
  "flake": "sound",
  "flakey": "beautiful",
  "flaky": "taste",
  "flambe": "build",
  "flambeau": "build",
  "flamboyant": "heal",
  "flame": "smart",
  "flame-flower": "heal",
  "flamefish": "heal",
  "flameflower": "heal",
  "flamenco": "beautiful",
  "flamethrower": "build",
  "flaming": "smart",
  "flamingo": "heal",
  "flammulina": "heal",
  "flan": "taste",
  "flange": "build",
  "flank": "taste",
  "flannel": "build",
  "flannel-cake": "taste",
  "flannelbush": "heal",
  "flannelette": "build",
  "flap": "build",
  "flapcake": "taste",
  "flapjack": "taste",
  "flaps": "build",
  "flare": "smart",
  "flash": "smart",
  "flash-forward": "story",
  "flashback": "story",
  "flashboard": "build",
  "flashboarding": "build",
  "flashbulb": "build",
  "flashcard": "story",
  "flasher": "build",
  "flashflood": "sound",
  "flashgun": "build",
  "flashing": "build",
  "flashlight": "build",
  "flashover": "sound",
  "flask": "build",
  "flaskful": "smart",
  "flat": "build",
  "flat-bellied": "beautiful",
  "flatbed": "build",
  "flatboat": "build",
  "flatbread": "taste",
  "flatbrod": "taste",
  "flatcar": "build",
  "flatfish": "taste",
  "flatfoot": "heal",
  "flathead": "heal",
  "flatiron": "build",
  "flatlet": "build",
  "flatness": "story",
  "flats": "build",
  "flatter": "story",
  "flattering": "story",
  "flattery": "story",
  "flattop": "heal",
  "flatulence": "story",
  "flatware": "build",
  "flatwork": "build",
  "flatworm": "heal",
  "flaunt": "story",
  "flavin": "beautiful",
  "flaviviridae": "heal",
  "flavivirus": "heal",
  "flavone": "beautiful",
  "flavonoid": "beautiful",
  "flavor": "taste",
  "flavorer": "taste",
  "flavoring": "taste",
  "flavour": "taste",
  "flavourer": "taste",
  "flavouring": "taste",
  "flax": "heal",
  "flay": "build",
  "flea": "heal",
  "fleabag": "build",
  "fleabane": "heal",
  "fleapit": "build",
  "fleawort": "heal",
  "flecainide": "build",
  "fleck": "build",
  "fledge": "sell",
  "fledged": "sell",
  "fledgeling": "heal",
  "fledgling": "heal",
  "fleece": "build",
  "fleer": "story",
  "flemish": "story",
  "flense": "sell",
  "flesh": "heal",
  "fleshy": "beautiful",
  "fleur-de-lis": "heal",
  "fleur-de-lys": "build",
  "flex": "sound",
  "flexeril": "build",
  "flexible": "beautiful",
  "flexile": "beautiful",
  "flexor": "heal",
  "flick": "story",
  "flick-knife": "build",
  "flicker": "heal",
  "flickertail": "heal",
  "flier": "story",
  "flies": "heal",
  "flight": "build",
  "flim-flam": "sell",
  "flimsy": "beautiful",
  "flindersia": "heal",
  "flindosa": "heal",
  "flindosy": "heal",
  "fling": "build",
  "flint": "beautiful",
  "flinthead": "heal",
  "flintlock": "build",
  "flintstone": "build",
  "flinty": "beautiful",
  "flip": "taste",
  "flip-flop": "smart",
  "flipper": "build",
  "flirt": "story",
  "flirting": "story",
  "flitch": "taste",
  "float": "smart",
  "floatation": "sound",
  "floater": "sell",
  "floating-moss": "heal",
  "floatplane": "build",
  "flocculation": "smart",
  "flock": "smart",
  "flog": "build",
  "flogging": "build",
  "flood": "sound",
  "floodgate": "smart",
  "floodhead": "sound",
  "flooding": "build",
  "floodlight": "build",
  "floor": "build",
  "floorboard": "build",
  "floored": "build",
  "flooring": "build",
  "flop": "smart",
  "flophouse": "build",
  "floppy": "build",
  "floral": "beautiful",
  "florescence": "smart",
  "floret": "heal",
  "florey": "heal",
  "florilegium": "story",
  "florin": "smart",
  "florist": "build",
  "floss": "build",
  "flotation": "sound",
  "flotilla": "build",
  "flotsam": "build",
  "flounce": "build",
  "flounder": "taste",
  "flour": "taste",
  "flourish": "story",
  "flout": "story",
  "flow": "smart",
  "flowage": "smart",
  "flowchart": "story",
  "flower": "heal",
  "flower-of-an-hour": "heal",
  "flowerbed": "build",
  "floweret": "heal",
  "flowering": "smart",
  "flowerless": "beautiful",
  "flowerpot": "build",
  "flowers-of-an-hour": "heal",
  "flowery": "beautiful",
  "floxuridine": "build",
  "flub": "sell",
  "flue": "build",
  "fluegelhorn": "build",
  "fluency": "story",
  "fluff": "build",
  "flugelhorn": "build",
  "fluid": "beautiful",
  "fluidounce": "smart",
  "fluidram": "smart",
  "fluke": "sound",
  "flume": "build",
  "flummery": "taste",
  "flummox": "smart",
  "flump": "build",
  "flunitrazepan": "build",
  "flunk": "sell",
  "fluoresce": "sound",
  "fluorescence": "sound",
  "fluorescent": "build",
  "fluoroscope": "build",
  "fluorosis": "heal",
  "fluorouracil": "build",
  "fluoxetine": "build",
  "fluphenazine": "build",
  "flurazepam": "build",
  "flurbiprofen": "build",
  "flurry": "sound",
  "flute": "sound",
  "fluting": "build",
  "fluvastatin": "build",
  "fluxmeter": "build",
  "fly": "heal",
  "fly-by-night": "beautiful",
  "flybridge": "build",
  "flycatcher": "heal",
  "flyer": "story",
  "flyleaf": "story",
  "flyover": "build",
  "flyspeck": "beautiful",
  "flyswat": "build",
  "flyswatter": "build",
  "flytrap": "build",
  "flywheel": "build",
  "fo'c'sle": "build",
  "foal": "heal",
  "foamflower": "heal",
  "fob": "build",
  "focal": "beautiful",
  "focalisation": "smart",
  "focalise": "smart",
  "focalization": "smart",
  "focalize": "smart",
  "focus": "smart",
  "focused": "smart",
  "focusing": "smart",
  "focussed": "beautiful",
  "focussing": "smart",
  "fodder": "taste",
  "foehn": "sound",
  "foeniculum": "heal",
  "foetology": "smart",
  "foetor": "smart",
  "foetoscope": "build",
  "foetoscopy": "heal",
  "foetus": "heal",
  "fog": "sound",
  "fogbank": "sound",
  "foghorn": "story",
  "foglamp": "build",
  "fogsignal": "story",
  "fohn": "sound",
  "foible": "build",
  "foil": "build",
  "foiling": "sell",
  "foist": "story",
  "fold": "smart",
  "folder": "story",
  "folderal": "build",
  "folderol": "story",
  "folding": "smart",
  "foldout": "story",
  "foliaceous": "beautiful",
  "foliage": "heal",
  "foliate": "build",
  "foliated": "build",
  "foliation": "smart",
  "folio": "story",
  "folk": "story",
  "folklore": "smart",
  "folksong": "story",
  "folktale": "story",
  "follicle": "heal",
  "follies": "story",
  "follow-up": "build",
  "followup": "build",
  "folly": "smart",
  "foment": "sell",
  "fomes": "heal",
  "fondant": "taste",
  "fondle": "build",
  "fondling": "build",
  "fondu": "taste",
  "fondue": "taste",
  "font": "beautiful",
  "fontanel": "heal",
  "fontanelle": "heal",
  "food": "taste",
  "foodstuff": "build",
  "fool": "sell",
  "foolish": "beautiful",
  "foolishness": "smart",
  "foolproof": "beautiful",
  "foolscap": "story",
  "foot": "heal",
  "foot-lambert": "smart",
  "foot-pound": "smart",
  "foot-poundal": "smart",
  "foot-ton": "smart",
  "footage": "build",
  "football": "build",
  "footbath": "build",
  "footboard": "build",
  "footbridge": "build",
  "footcandle": "smart",
  "footed": "sell",
  "footer": "smart",
  "footgear": "build",
  "foothold": "build",
  "footing": "build",
  "footle": "sell",
  "footless": "beautiful",
  "footlights": "build",
  "footlocker": "build",
  "footmark": "story",
  "footnote": "story",
  "footpath": "build",
  "footplate": "build",
  "footprint": "story",
  "footrest": "build",
  "footstall": "build",
  "footstep": "smart",
  "footsteps-of-spring": "heal",
  "footstool": "build",
  "footwear": "build",
  "forage": "taste",
  "foraging": "taste",
  "foram": "heal",
  "foramen": "heal",
  "foraminifer": "heal",
  "foraminifera": "heal",
  "foray": "sell",
  "forbid": "story",
  "forbiddance": "story",
  "forbidding": "story",
  "force": "sound",
  "force-feed": "taste",
  "forced": "sell",
  "forceful": "beautiful",
  "forceless": "beautiful",
  "forcemeat": "taste",
  "forceps": "build",
  "fordhooks": "taste",
  "fore": "build",
  "fore-and-after": "build",
  "fore-topmast": "build",
  "fore-topsail": "build",
  "fore-wing": "heal",
  "forearm": "heal",
  "forebode": "story",
  "foreboding": "story",
  "forebrain": "heal",
  "forecast": "story",
  "forecasting": "story",
  "forecastle": "build",
  "foreclose": "sell",
  "forecourt": "build",
  "foredeck": "build",
  "foredge": "build",
  "foredoom": "story",
  "forefend": "sell",
  "forefinger": "heal",
  "forefoot": "heal",
  "forefront": "smart",
  "foregather": "sell",
  "forego": "sell",
  "foreground": "smart",
  "foregrounding": "smart",
  "forehand": "beautiful",
  "forehanded": "beautiful",
  "forehead": "heal",
  "foreign": "beautiful",
  "foreknow": "smart",
  "foreknowledge": "story",
  "foreleg": "heal",
  "forelimb": "heal",
  "forelock": "heal",
  "foremast": "build",
  "foremilk": "heal",
  "forename": "story",
  "foreordain": "smart",
  "foreordination": "smart",
  "forepaw": "heal",
  "forequarter": "taste",
  "forerunner": "story",
  "foresail": "build",
  "foresee": "smart",
  "foreshadow": "story",
  "foreshadowing": "smart",
  "foreshank": "taste",
  "foreshow": "story",
  "foresight": "smart",
  "foreskin": "heal",
  "forest": "build",
  "forestage": "build",
  "forestall": "sell",
  "forestalling": "sell",
  "forestay": "build",
  "forestiera": "heal",
  "forestry": "smart",
  "foreswear": "sell",
  "foretaste": "smart",
  "foretell": "story",
  "foretelling": "story",
  "forethought": "smart",
  "foretop": "build",
  "forewarn": "story",
  "forewarning": "story",
  "forewing": "heal",
  "foreword": "story",
  "forfeit": "sell",
  "forfeiture": "sell",
  "forfend": "sell",
  "forficula": "heal",
  "forficulidae": "heal",
  "forgather": "sell",
  "forge": "build",
  "forgery": "build",
  "forget": "smart",
  "forget-me-not": "heal",
  "forgetful": "beautiful",
  "forgetfulness": "smart",
  "forgettable": "beautiful",
  "forging": "build",
  "forgive": "story",
  "forgiving": "story",
  "forgo": "sell",
  "forgoing": "sell",
  "forint": "smart",
  "fork": "build",
  "forking": "build",
  "forklift": "build",
  "form": "story",
  "formal": "build",
  "formalise": "sell",
  "formalised": "sell",
  "formalism": "smart",
  "formalize": "sell",
  "formalized": "sell",
  "formalwear": "build",
  "format": "story",
  "formation": "build",
  "formative": "story",
  "formatting": "story",
  "formed": "sell",
  "former": "beautiful",
  "formica": "build",
  "formicariidae": "heal",
  "formicarius": "heal",
  "formicidae": "heal",
  "formosan": "story",
  "formula": "story",
  "formularise": "story",
  "formularize": "story",
  "formulary": "story",
  "formulate": "story",
  "formulation": "story",
  "fornicate": "build",
  "fornix": "heal",
  "forsake": "smart",
  "forsaking": "smart",
  "forswear": "story",
  "forswearing": "story",
  "forsythia": "heal",
  "fort": "build",
  "fortaz": "build",
  "forte": "build",
  "forte-piano": "build",
  "forties": "smart",
  "fortieth": "beautiful",
  "fortification": "build",
  "fortify": "build",
  "fortissimo": "beautiful",
  "fortran": "story",
  "fortress": "build",
  "fortunate": "beautiful",
  "fortune": "sound",
  "fortunella": "heal",
  "fortunetelling": "story",
  "forty": "smart",
  "forty-five": "build",
  "forty-niner": "beautiful",
  "forum": "build",
  "forward": "beautiful",
  "fosamax": "build",
  "fossa": "heal",
  "fosse": "build",
  "fossilisation": "smart",
  "fossilization": "smart",
  "fossilology": "smart",
  "fossorial": "beautiful",
  "foster": "sell",
  "fosterage": "story",
  "fostering": "story",
  "fothergilla": "heal",
  "fots": "build",
  "foul": "build",
  "foulard": "build",
  "foulmart": "heal",
  "foumart": "heal",
  "found": "sell",
  "foundation": "build",
  "founder": "sell",
  "foundering": "sell",
  "founding": "sell",
  "foundry": "build",
  "fount": "story",
  "fountain": "build",
  "fountainhead": "story",
  "fouquieria": "heal",
  "fouquieriaceae": "heal",
  "four": "smart",
  "four-footed": "beautiful",
  "four-in-hand": "build",
  "four-poster": "build",
  "four-pounder": "build",
  "four-spot": "build",
  "four-wheeler": "build",
  "fourpence": "sell",
  "fourscore": "smart",
  "foursome": "smart",
  "foursquare": "beautiful",
  "fourteen": "smart",
  "fourteenth": "beautiful",
  "fourth": "smart",
  "fovea": "heal",
  "fowl": "heal",
  "fox": "heal",
  "foxberry": "heal",
  "foxglove": "heal",
  "foxhole": "build",
  "foxhound": "heal",
  "foxiness": "smart",
  "foxtail": "heal",
  "foyer": "build",
  "fpd": "build",
  "fracas": "story",
  "fractal": "smart",
  "fraction": "build",
  "fractional": "beautiful",
  "fractionate": "build",
  "fractionation": "smart",
  "fradicin": "build",
  "fragaria": "heal",
  "fragment": "build",
  "fragmentation": "smart",
  "fragrance": "smart",
  "fragrant": "taste",
  "frail": "smart",
  "fraise": "build",
  "framboise": "heal",
  "frame": "build",
  "framed": "build",
  "framework": "smart",
  "framing": "build",
  "franc": "smart",
  "franchise": "sell",
  "francisella": "heal",
  "francoa": "heal",
  "frangipane": "taste",
  "frangipani": "heal",
  "frangipanni": "heal",
  "frank": "taste",
  "frankfurter": "taste",
  "frankliniella": "heal",
  "frap": "build",
  "frappe": "taste",
  "frasera": "heal",
  "fratercula": "heal",
  "fraternal": "beautiful",
  "fraternise": "sell",
  "fraternize": "sell",
  "frau": "story",
  "fraudulence": "story",
  "fraulein": "story",
  "fraxinella": "heal",
  "fraxinus": "heal",
  "fray": "build",
  "frazzle": "build",
  "freckle": "heal",
  "free": "sell",
  "free-associate": "smart",
  "free-base": "taste",
  "free-lance": "beautiful",
  "free-reed": "build",
  "freebee": "sell",
  "freebie": "sell",
  "freehold": "sell",
  "freeing": "sell",
  "freelance": "sell",
  "freelancer": "beautiful",
  "freeload": "sell",
  "freemail": "story",
  "freemasonry": "build",
  "freesia": "heal",
  "freestone": "taste",
  "freetail": "heal",
  "freethinking": "smart",
  "freeware": "story",
  "freeway": "build",
  "freewheel": "build",
  "freeze": "smart",
  "freeze-drying": "smart",
  "freezer": "build",
  "freezing": "smart",
  "fregata": "heal",
  "fregatidae": "heal",
  "freight": "build",
  "freightage": "sell",
  "freighter": "build",
  "fremontia": "heal",
  "fremontodendron": "heal",
  "french": "story",
  "frequency": "sound",
  "frequent": "sell",
  "frequentative": "story",
  "frequenter": "beautiful",
  "fresco": "beautiful",
  "fresh": "beautiful",
  "freshen": "heal",
  "freshener": "build",
  "fresher": "beautiful",
  "freshman": "beautiful",
  "freshness": "smart",
  "fress": "taste",
  "fret": "build",
  "fretsaw": "build",
  "fretted": "sell",
  "fretwork": "build",
  "freud": "heal",
  "friar's-cowl": "heal",
  "friary": "build",
  "fricandeau": "taste",
  "fricassee": "taste",
  "fricative": "story",
  "friction": "sound",
  "fridge": "taste",
  "friedcake": "taste",
  "friendly": "beautiful",
  "frier": "taste",
  "fries": "taste",
  "friesian": "heal",
  "frieze": "build",
  "frigate": "build",
  "frightening": "beautiful",
  "frijol": "heal",
  "frijole": "heal",
  "frijolillo": "heal",
  "frijolito": "heal",
  "frill": "heal",
  "fringe": "sound",
  "fringepod": "heal",
  "fringilla": "heal",
  "fringillidae": "heal",
  "frippery": "build",
  "frisbee": "build",
  "frisian": "story",
  "frisk": "build",
  "frisking": "build",
  "fritillaria": "heal",
  "fritillary": "heal",
  "frittata": "taste",
  "fritter": "taste",
  "friuli": "story",
  "friulian": "story",
  "frivol": "sell",
  "frivolity": "build",
  "frivolous": "beautiful",
  "frizz": "build",
  "frizzle": "build",
  "frock": "build",
  "froelichia": "heal",
  "frog": "heal",
  "frog's-bit": "heal",
  "frogbit": "heal",
  "frogfish": "heal",
  "froghopper": "heal",
  "frogmarch": "build",
  "frogmouth": "heal",
  "frond": "heal",
  "front": "smart",
  "front-stall": "build",
  "frontage": "build",
  "frontal": "build",
  "frontier": "smart",
  "frontispiece": "build",
  "frontlet": "build",
  "frontstall": "build",
  "frost": "sound",
  "frost-weed": "heal",
  "frosting": "taste",
  "frostweed": "heal",
  "frostwort": "heal",
  "froth": "heal",
  "frown": "story",
  "frozen": "heal",
  "fructification": "smart",
  "fructify": "heal",
  "fruit": "taste",
  "fruitage": "heal",
  "fruitcake": "taste",
  "fruitful": "beautiful",
  "fruitfulness": "smart",
  "fruitlessness": "smart",
  "fruitlet": "heal",
  "fruitwood": "heal",
  "frumenty": "taste",
  "frustrate": "sell",
  "fryer": "taste",
  "frying": "taste",
  "frypan": "build",
  "ft-l": "smart",
  "fthm": "smart",
  "ftp": "story",
  "fucaceae": "heal",
  "fucales": "heal",
  "fuchsia": "heal",
  "fuck": "build",
  "fucking": "build",
  "fucoid": "heal",
  "fucus": "heal",
  "fuddle": "taste",
  "fudge": "taste",
  "fuel": "sell",
  "fueled": "sell",
  "fueling": "sell",
  "fugitive": "beautiful",
  "fugo": "build",
  "fugu": "taste",
  "fugue": "story",
  "fuji": "heal",
  "fukien": "story",
  "fukkianese": "story",
  "ful": "story",
  "fula": "story",
  "fulani": "story",
  "fulcrum": "build",
  "fulfil": "build",
  "fulfill": "build",
  "fulgoridae": "heal",
  "fulica": "heal",
  "full": "build",
  "full-term": "beautiful",
  "full-time": "beautiful",
  "fuller": "beautiful",
  "fulmar": "heal",
  "fulmarus": "heal",
  "fulminate": "story",
  "fulmination": "story",
  "fulsomeness": "story",
  "fulvicin": "build",
  "fumaria": "heal",
  "fumariaceae": "heal",
  "fumble": "build",
  "fume": "sound",
  "fumeroot": "heal",
  "fumes": "sound",
  "fumewort": "heal",
  "fumigate": "sound",
  "fumigator": "build",
  "fumitory": "heal",
  "fun": "story",
  "functional": "beautiful",
  "functionalism": "smart",
  "functioning": "smart",
  "fund": "sell",
  "fund-raise": "sell",
  "fundament": "smart",
  "fundamental": "smart",
  "fundamentalism": "smart",
  "fundamentals": "smart",
  "funded": "sell",
  "funding": "sell",
  "fundraise": "sell",
  "funds": "sell",
  "fundulus": "heal",
  "fundus": "heal",
  "funeral-residence": "build",
  "fungi": "heal",
  "fungia": "heal",
  "fungible": "build",
  "fungicide": "build",
  "fungus": "heal",
  "funicle": "heal",
  "funicular": "build",
  "funiculus": "heal",
  "funk": "sound",
  "funka": "heal",
  "funkaceae": "heal",
  "funnel": "sell",
  "funnies": "story",
  "funniness": "story",
  "funny": "story",
  "fur": "heal",
  "fur-piece": "build",
  "furbelow": "build",
  "furbish": "build",
  "furcula": "heal",
  "furlong": "smart",
  "furlough": "sell",
  "furnace": "build",
  "furnariidae": "heal",
  "furnarius": "heal",
  "furnish": "sell",
  "furnished": "sell",
  "furnishing": "build",
  "furniture": "build",
  "furor": "smart",
  "furore": "smart",
  "furosemide": "build",
  "furrier": "beautiful",
  "furring": "build",
  "furrow": "build",
  "furrowed": "build",
  "further": "sell",
  "furtherance": "story",
  "furze": "heal",
  "fusain": "build",
  "fusanus": "heal",
  "fuscoboletinus": "heal",
  "fuse": "build",
  "fusee": "build",
  "fuselage": "build",
  "fusil": "build",
  "fusion": "smart",
  "fuss": "story",
  "fustian": "story",
  "fustigate": "build",
  "futon": "build",
  "future": "story",
  "futurism": "smart",
  "futuristics": "smart",
  "futurology": "smart",
  "fuze": "build",
  "fuzee": "build",
  "fuzz": "sound",
  "g-force": "smart",
  "g-string": "build",
  "g.i.": "build",
  "gab": "story",
  "gabapentin": "build",
  "gabardine": "build",
  "gabble": "story",
  "gaberdine": "build",
  "gabfest": "story",
  "gable": "build",
  "gabled": "beautiful",
  "gad": "build",
  "gadaba": "story",
  "gaddi": "build",
  "gadfly": "heal",
  "gadget": "build",
  "gadgetry": "build",
  "gadidae": "heal",
  "gadiformes": "heal",
  "gadoid": "heal",
  "gadus": "heal",
  "gaelic": "story",
  "gaff": "build",
  "gaffsail": "build",
  "gag": "story",
  "gage": "build",
  "gaggle": "story",
  "gaillardia": "heal",
  "gain": "smart",
  "gainsay": "story",
  "gaiter": "build",
  "gal": "smart",
  "galactic": "beautiful",
  "galactosis": "smart",
  "galago": "heal",
  "galangal": "heal",
  "galantine": "taste",
  "galatians": "story",
  "galax": "heal",
  "galaxy": "heal",
  "galbulidae": "heal",
  "galbulus": "heal",
  "gale": "sound",
  "galea": "heal",
  "galega": "heal",
  "galeocerdo": "heal",
  "galeopsis": "heal",
  "galeorhinus": "heal",
  "galician": "story",
  "galingale": "heal",
  "galium": "heal",
  "gall": "heal",
  "gall-berry": "heal",
  "gallant": "beautiful",
  "gallberry": "heal",
  "gallbladder": "heal",
  "galleon": "build",
  "galleria": "heal",
  "gallery": "beautiful",
  "galley": "build",
  "gallfly": "heal",
  "galliano": "taste",
  "gallicism": "story",
  "galliformes": "heal",
  "gallina": "heal",
  "gallinacean": "heal",
  "gallinago": "heal",
  "gallinula": "heal",
  "gallinule": "heal",
  "gallirallus": "heal",
  "gallon": "smart",
  "gallous": "build",
  "galloway": "heal",
  "gallows": "build",
  "gallows-tree": "build",
  "gallus": "build",
  "galosh": "build",
  "galvani": "heal",
  "galvanic": "beautiful",
  "galvanisation": "smart",
  "galvanise": "build",
  "galvanism": "sound",
  "galvanization": "smart",
  "galvanize": "build",
  "galvanometer": "build",
  "gamba": "build",
  "gambelia": "heal",
  "gambit": "story",
  "gamble": "sell",
  "gambling": "sell",
  "gamboge": "beautiful",
  "gambrel": "build",
  "gambusia": "heal",
  "game": "heal",
  "gamebag": "build",
  "gameboard": "build",
  "gamecock": "heal",
  "gametangium": "heal",
  "gamete": "heal",
  "gametocyte": "heal",
  "gametoecium": "heal",
  "gametogenesis": "smart",
  "gametophore": "heal",
  "gametophyte": "heal",
  "gamma": "story",
  "gamma-interferon": "build",
  "gammon": "taste",
  "gamp": "build",
  "gamut": "story",
  "gander": "heal",
  "gang": "build",
  "gang-rape": "sell",
  "gangboard": "build",
  "gangliocyte": "heal",
  "ganglion": "heal",
  "gangplank": "build",
  "gangrene": "sound",
  "gangsaw": "build",
  "gangway": "build",
  "ganja": "heal",
  "gannet": "heal",
  "ganoid": "heal",
  "ganoidei": "heal",
  "ganoin": "heal",
  "ganoine": "heal",
  "gantanol": "build",
  "gantlet": "story",
  "gantrisin": "build",
  "gantry": "build",
  "gaol": "build",
  "gap": "build",
  "gape": "story",
  "gar": "heal",
  "garage": "build",
  "garambulla": "heal",
  "garamycin": "build",
  "garand": "build",
  "garb": "build",
  "garbage": "story",
  "garbanzo": "heal",
  "garble": "story",
  "garboard": "build",
  "garbology": "smart",
  "garcinia": "heal",
  "garden": "build",
  "gardenia": "heal",
  "gardening": "build",
  "garfish": "heal",
  "garganey": "heal",
  "garget": "heal",
  "gargle": "story",
  "gargoyle": "build",
  "gari": "heal",
  "garibaldi": "build",
  "garland": "story",
  "garlic": "heal",
  "garment": "build",
  "garner": "build",
  "garnish": "taste",
  "garnishee": "sell",
  "garnishment": "story",
  "garotte": "build",
  "garpike": "heal",
  "garret": "build",
  "garrison": "build",
  "garrote": "build",
  "garrotte": "build",
  "garrulinae": "heal",
  "garrulus": "heal",
  "garter": "build",
  "gasbag": "build",
  "gasconade": "story",
  "gaseous": "beautiful",
  "gash": "build",
  "gasification": "smart",
  "gasket": "build",
  "gaskin": "heal",
  "gaslight": "sound",
  "gasmask": "build",
  "gasometer": "build",
  "gasp": "heal",
  "gassing": "smart",
  "gasteromycete": "heal",
  "gasteromycetes": "heal",
  "gasterophilidae": "heal",
  "gasterophilus": "heal",
  "gasteropoda": "heal",
  "gasterosteidae": "heal",
  "gasterosteus": "heal",
  "gastrin": "heal",
  "gastroboletus": "heal",
  "gastrocnemius": "heal",
  "gastrocybe": "heal",
  "gastroenterology": "smart",
  "gastrolobium": "heal",
  "gastromycete": "heal",
  "gastromycetes": "heal",
  "gastronome": "taste",
  "gastronomic": "taste",
  "gastronomical": "taste",
  "gastronomy": "taste",
  "gastrophryne": "heal",
  "gastropod": "heal",
  "gastropoda": "heal",
  "gastroscope": "build",
  "gastrula": "heal",
  "gastrulation": "smart",
  "gasworks": "build",
  "gat": "build",
  "gate": "build",
  "gateau": "taste",
  "gatefold": "story",
  "gatehouse": "build",
  "gatepost": "build",
  "gates": "build",
  "gateway": "build",
  "gather": "build",
  "gathered": "build",
  "gathering": "build",
  "gathic": "story",
  "gator": "heal",
  "gaud": "build",
  "gaudery": "story",
  "gaudy": "beautiful",
  "gauffer": "build",
  "gauge": "build",
  "gaultheria": "heal",
  "gauntlet": "story",
  "gauntry": "build",
  "gaur": "heal",
  "gauss": "smart",
  "gaussmeter": "build",
  "gauze": "build",
  "gavel": "build",
  "gavia": "heal",
  "gavial": "heal",
  "gavialidae": "heal",
  "gavialis": "heal",
  "gavidae": "heal",
  "gaviiformes": "heal",
  "gavotte": "story",
  "gawk": "sound",
  "gawp": "sound",
  "gay": "beautiful",
  "gay-feather": "heal",
  "gayal": "heal",
  "gayfeather": "heal",
  "gaylussacia": "heal",
  "gaywings": "heal",
  "gazania": "heal",
  "gaze": "sound",
  "gazebo": "build",
  "gazella": "heal",
  "gazelle": "heal",
  "gazette": "story",
  "gazetteer": "story",
  "gazillion": "smart",
  "gazpacho": "taste",
  "gazump": "sell",
  "gbit": "smart",
  "gbu-28": "build",
  "gdp": "sell",
  "gean": "heal",
  "gear": "build",
  "gearbox": "build",
  "geared": "beautiful",
  "gearing": "build",
  "gearset": "build",
  "gearshift": "build",
  "gearstick": "build",
  "geartrain": "build",
  "geastraceae": "heal",
  "geastrum": "heal",
  "gecko": "heal",
  "gee": "smart",
  "gee-gee": "heal",
  "geebung": "heal",
  "gegenschein": "sound",
  "geglossaceae": "heal",
  "gehenna": "smart",
  "gekkonidae": "heal",
  "gel": "build",
  "gelatin": "taste",
  "geld": "heal",
  "gelding": "heal",
  "gelechia": "heal",
  "gelechiid": "heal",
  "gelechiidae": "heal",
  "gelignite": "build",
  "gelly": "build",
  "gelsemium": "heal",
  "gelt": "sell",
  "gem": "beautiful",
  "gemara": "story",
  "gemfibrozil": "build",
  "geminate": "story",
  "gemination": "story",
  "gemma": "heal",
  "gemmation": "smart",
  "gemmule": "smart",
  "gemonil": "build",
  "gempylid": "heal",
  "gempylidae": "heal",
  "gempylus": "heal",
  "gemsbok": "heal",
  "gemsbuck": "heal",
  "gen": "story",
  "gender": "story",
  "gene": "heal",
  "gene-splicing": "smart",
  "genealogy": "smart",
  "general": "smart",
  "generalisation": "smart",
  "generalise": "story",
  "generality": "smart",
  "generalization": "smart",
  "generalize": "story",
  "generalship": "smart",
  "generate": "build",
  "generative": "smart",
  "generator": "build",
  "generic": "taste",
  "generous": "beautiful",
  "genesis": "story",
  "genet": "heal",
  "genetic": "beautiful",
  "geneticism": "smart",
  "genetics": "smart",
  "genetta": "heal",
  "geneva": "taste",
  "genial": "beautiful",
  "genip": "heal",
  "genipa": "heal",
  "genipap": "taste",
  "genista": "heal",
  "genitalia": "heal",
  "genitals": "heal",
  "genitive": "story",
  "genius": "smart",
  "genlisea": "heal",
  "genoise": "taste",
  "genomics": "smart",
  "genre": "smart",
  "gens": "story",
  "gentamicin": "build",
  "gentian": "heal",
  "gentiana": "heal",
  "gentianaceae": "heal",
  "gentianales": "heal",
  "gentianella": "heal",
  "gentianopsis": "heal",
  "gentle": "sell",
  "gentleman's-cane": "heal",
  "genu": "heal",
  "genuflection": "story",
  "genuflexion": "story",
  "genuine": "beautiful",
  "genus": "smart",
  "genus-fenusa": "heal",
  "genus-megapodius": "heal",
  "genus-milvus": "heal",
  "genyonemus": "heal",
  "geocentric": "beautiful",
  "geochelone": "heal",
  "geochemistry": "smart",
  "geococcyx": "heal",
  "geodesy": "smart",
  "geoduck": "heal",
  "geoffroea": "heal",
  "geoglossaceae": "heal",
  "geoglossum": "heal",
  "geographic": "beautiful",
  "geographical": "beautiful",
  "geographics": "smart",
  "geography": "smart",
  "geology": "smart",
  "geomancy": "smart",
  "geometric": "beautiful",
  "geometrical": "beautiful",
  "geometrid": "heal",
  "geometridae": "heal",
  "geometry": "smart",
  "geomorphology": "smart",
  "geomyidae": "heal",
  "geomys": "heal",
  "geophilidae": "heal",
  "geophilomorpha": "heal",
  "geophilus": "heal",
  "geophysics": "smart",
  "geophyte": "heal",
  "geopolitics": "smart",
  "geordie": "story",
  "georgette": "build",
  "georgian": "story",
  "geostrategy": "smart",
  "geothlypis": "heal",
  "geraniaceae": "heal",
  "geraniales": "heal",
  "geranium": "heal",
  "gerardia": "heal",
  "gerbera": "heal",
  "gerbil": "heal",
  "gerbille": "heal",
  "gerbillinae": "heal",
  "gerbillus": "heal",
  "gerea": "heal",
  "gerenuk": "heal",
  "gerfalcon": "heal",
  "geriatrics": "heal",
  "germ": "smart",
  "german": "story",
  "germander": "heal",
  "germanic": "story",
  "germfree": "beautiful",
  "germicide": "build",
  "germinal": "beautiful",
  "germinate": "build",
  "germination": "smart",
  "germy": "beautiful",
  "gerontology": "smart",
  "gerreidae": "heal",
  "gerres": "heal",
  "gerrhonotus": "heal",
  "gerridae": "heal",
  "gerrididae": "heal",
  "gerris": "heal",
  "gerrymander": "sell",
  "gerund": "story",
  "gesneria": "heal",
  "gesneriaceae": "heal",
  "gesneriad": "heal",
  "gestalt": "smart",
  "gestate": "build",
  "gestation": "smart",
  "gesticulate": "story",
  "gesticulation": "story",
  "gesture": "story",
  "get": "sell",
  "geta": "build",
  "getting": "sell",
  "getup": "build",
  "geum": "heal",
  "gewgaw": "build",
  "gharry": "build",
  "ghat": "build",
  "ghb": "build",
  "ghee": "taste",
  "gheg": "story",
  "gherkin": "taste",
  "ghillie": "build",
  "ghost": "smart",
  "ghostfish": "heal",
  "ghostwrite": "build",
  "ghoul": "heal",
  "ghq": "build",
  "ghrelin": "heal",
  "giant": "heal",
  "giardia": "heal",
  "gib": "smart",
  "gibber": "story",
  "gibberish": "story",
  "gibbet": "build",
  "gibbon": "heal",
  "gibe": "story",
  "gibibit": "smart",
  "gibibyte": "smart",
  "gibit": "smart",
  "giblet": "taste",
  "giblets": "taste",
  "gidar": "story",
  "gidgee": "heal",
  "gift": "sell",
  "gift-wrap": "build",
  "gifted": "sell",
  "gig": "sound",
  "gigabit": "smart",
  "gigabyte": "smart",
  "gigartinaceae": "heal",
  "giggle": "story",
  "gigo": "story",
  "gigot": "taste",
  "gigue": "story",
  "gikuyu": "story",
  "gilbert": "smart",
  "gilbertian": "beautiful",
  "gild": "build",
  "gildhall": "build",
  "gilding": "build",
  "gill": "smart",
  "gill-less": "beautiful",
  "gill-over-the-ground": "heal",
  "gilled": "beautiful",
  "gillie": "build",
  "gillyflower": "heal",
  "gilt": "build",
  "gimbal": "story",
  "gimcrack": "build",
  "gimcrackery": "build",
  "gimel": "story",
  "gimlet": "taste",
  "gimmick": "build",
  "gin": "taste",
  "ginep": "heal",
  "ginger": "heal",
  "gingerbread": "taste",
  "gingerroot": "taste",
  "gingersnap": "taste",
  "gingham": "build",
  "gingiva": "heal",
  "gingko": "heal",
  "ginglymostoma": "heal",
  "ginglymus": "heal",
  "ginkgo": "heal",
  "ginkgoaceae": "heal",
  "ginkgoales": "heal",
  "ginkgophytina": "heal",
  "ginkgopsida": "heal",
  "ginmill": "build",
  "ginseng": "heal",
  "gip": "sell",
  "gipsywort": "heal",
  "giraffa": "heal",
  "giraffe": "heal",
  "giraffidae": "heal",
  "girandola": "build",
  "girandole": "build",
  "girasol": "heal",
  "gird": "build",
  "girder": "build",
  "girdle": "heal",
  "giriama": "story",
  "giro": "sell",
  "girondism": "smart",
  "girth": "build",
  "gismo": "build",
  "gist": "story",
  "gita": "story",
  "gittern": "build",
  "give": "sell",
  "give-and-take": "story",
  "giveaway": "sell",
  "given": "smart",
  "giving": "story",
  "gizmo": "build",
  "gizzard": "heal",
  "glabella": "heal",
  "glacial": "beautiful",
  "glaciate": "build",
  "glaciation": "smart",
  "glad": "heal",
  "gladdon": "heal",
  "gladiola": "heal",
  "gladiolus": "heal",
  "gladstone": "build",
  "glamorize": "smart",
  "glamour": "story",
  "glamourise": "smart",
  "glance": "sound",
  "gland": "heal",
  "glans": "heal",
  "glare": "heal",
  "glareola": "heal",
  "glareole": "heal",
  "glareolidae": "heal",
  "glasnost": "story",
  "glass": "build",
  "glassed": "sell",
  "glasses": "build",
  "glassful": "smart",
  "glasshouse": "build",
  "glassless": "beautiful",
  "glassware": "build",
  "glasswork": "build",
  "glassworks": "build",
  "glasswort": "heal",
  "glaucium": "heal",
  "glaucomys": "heal",
  "glaux": "heal",
  "glaze": "build",
  "glazed": "build",
  "glazer": "build",
  "gleam": "sound",
  "gleaming": "sound",
  "glean": "build",
  "gleba": "heal",
  "glebe": "sell",
  "glechoma": "heal",
  "gleditsia": "heal",
  "gleet": "heal",
  "gleichenia": "heal",
  "gleicheniaceae": "heal",
  "glengarry": "build",
  "glia": "heal",
  "glide": "story",
  "glider": "build",
  "glimmer": "smart",
  "glimmering": "smart",
  "glimpse": "smart",
  "glint": "sound",
  "glipizide": "build",
  "gliricidia": "heal",
  "gliridae": "heal",
  "glis": "heal",
  "glissando": "story",
  "glisten": "sound",
  "glitter": "sound",
  "gloat": "story",
  "gloating": "story",
  "globalisation": "smart",
  "globalization": "smart",
  "globe": "build",
  "globefish": "heal",
  "globeflower": "heal",
  "globicephala": "heal",
  "globigerina": "heal",
  "globigerinidae": "heal",
  "glochid": "heal",
  "glochidium": "heal",
  "glockenspiel": "build",
  "glogg": "taste",
  "glom": "sell",
  "glomerule": "heal",
  "glomerulus": "heal",
  "glop": "story",
  "glorify": "story",
  "gloriosa": "heal",
  "glorious": "beautiful",
  "glory": "story",
  "gloss": "story",
  "glossa": "heal",
  "glossary": "story",
  "glossina": "heal",
  "glossinidae": "heal",
  "glossodia": "heal",
  "glossopsitta": "heal",
  "glossy": "story",
  "glottis": "heal",
  "glottochronology": "smart",
  "glove": "build",
  "gloved": "beautiful",
  "gloveless": "beautiful",
  "glow": "sound",
  "glower": "heal",
  "glowing": "sound",
  "glowworm": "heal",
  "gloxinia": "heal",
  "glucagon": "heal",
  "glucophage": "build",
  "glucose": "heal",
  "glucotrol": "build",
  "glue": "build",
  "glug": "sound",
  "glume": "heal",
  "glut": "taste",
  "glute": "heal",
  "gluten": "taste",
  "glutethimide": "build",
  "gluteus": "heal",
  "glutton": "heal",
  "gluttonise": "taste",
  "gluttonize": "taste",
  "gluttonous": "beautiful",
  "glyburide": "build",
  "glyceria": "heal",
  "glycine": "heal",
  "glycogenesis": "smart",
  "glycolysis": "smart",
  "glycyrrhiza": "heal",
  "glyph": "build",
  "glyptics": "build",
  "glyptography": "build",
  "gnaphalium": "heal",
  "gnarl": "build",
  "gnash": "heal",
  "gnat": "heal",
  "gnatcatcher": "heal",
  "gnathion": "heal",
  "gnathostomata": "heal",
  "gnathostome": "heal",
  "gnaw": "build",
  "gnawer": "heal",
  "gnetaceae": "heal",
  "gnetales": "heal",
  "gnetophyta": "heal",
  "gnetophytina": "heal",
  "gnetopsida": "heal",
  "gnetum": "heal",
  "gnocchi": "taste",
  "gnome": "story",
  "gnomon": "build",
  "gnosis": "smart",
  "gnostic": "beautiful",
  "gnosticism": "smart",
  "gnp": "sell",
  "gnu": "heal",
  "go-ahead": "story",
  "go-cart": "build",
  "go-kart": "build",
  "goad": "build",
  "goading": "story",
  "goal": "smart",
  "goalmouth": "build",
  "goalpost": "build",
  "goat": "heal",
  "goatee": "heal",
  "goatfish": "heal",
  "goatsbeard": "heal",
  "goatsfoot": "heal",
  "goatsucker": "heal",
  "gob": "heal",
  "gobbet": "taste",
  "gobble": "taste",
  "gobbledygook": "story",
  "gobbler": "heal",
  "gobiesocidae": "heal",
  "gobiesox": "heal",
  "gobiidae": "heal",
  "gobio": "heal",
  "goblet": "build",
  "gobs": "smart",
  "goby": "heal",
  "god": "build",
  "godlessness": "smart",
  "godown": "build",
  "godwit": "heal",
  "goffer": "build",
  "goggle": "sound",
  "goggle-eye": "heal",
  "goggles": "build",
  "goidelic": "story",
  "going-over": "story",
  "golconda": "build",
  "gold": "sell",
  "gold-plate": "build",
  "goldbrick": "build",
  "goldbricking": "sell",
  "goldcrest": "heal",
  "goldcup": "heal",
  "goldenbush": "heal",
  "goldeneye": "heal",
  "goldenrod": "heal",
  "goldenseal": "heal",
  "goldfields": "heal",
  "goldfinch": "heal",
  "goldfish": "heal",
  "goldilocks": "heal",
  "goldmine": "build",
  "goldplate": "build",
  "goldthread": "heal",
  "golem": "build",
  "golf-club": "build",
  "golfcart": "build",
  "golliwog": "build",
  "golliwogg": "build",
  "golosh": "build",
  "gomphothere": "heal",
  "gomphotheriidae": "heal",
  "gomphotherium": "heal",
  "gomphrena": "heal",
  "gomuti": "heal",
  "gonad": "heal",
  "gonadotrophin": "heal",
  "gonadotropin": "heal",
  "gondi": "story",
  "gondola": "build",
  "gong": "build",
  "gongorism": "story",
  "goniometer": "build",
  "gonion": "heal",
  "goniopteris": "heal",
  "gonococcus": "heal",
  "gonorhynchidae": "heal",
  "gonorhynchus": "heal",
  "goober": "taste",
  "good": "build",
  "good-by": "story",
  "good-bye": "story",
  "good-for-naught": "beautiful",
  "good-for-nothing": "beautiful",
  "good-king-henry": "heal",
  "good-natured": "beautiful",
  "goodby": "story",
  "goodbye": "story",
  "goodenia": "heal",
  "goodeniaceae": "heal",
  "goodwill": "sell",
  "goody": "taste",
  "goody-goody": "beautiful",
  "goodyera": "heal",
  "goof": "sell",
  "goofy": "beautiful",
  "google": "story",
  "googol": "smart",
  "googolplex": "smart",
  "gooney": "heal",
  "goonie": "heal",
  "goony": "heal",
  "goop": "build",
  "goosander": "heal",
  "goose": "heal",
  "goose-tansy": "heal",
  "gooseberry": "heal",
  "goosefish": "heal",
  "goosefoot": "heal",
  "gopher": "heal",
  "gopherus": "heal",
  "gopherwood": "heal",
  "goral": "heal",
  "gore": "heal",
  "gorge": "heal",
  "gorgerin": "build",
  "gorget": "build",
  "gorgonacea": "heal",
  "gorgoniacea": "heal",
  "gorgonian": "heal",
  "gorgonocephalus": "heal",
  "gorgonzola": "taste",
  "gorilla": "heal",
  "goring": "build",
  "gormandise": "taste",
  "gormandize": "taste",
  "gorse": "heal",
  "gosan-chiku": "heal",
  "goshawk": "heal",
  "gosling": "heal",
  "gosmore": "heal",
  "gospel": "sound",
  "gospels": "story",
  "gossamer": "build",
  "gossip": "story",
  "gossiping": "story",
  "gossipmongering": "story",
  "gossypium": "heal",
  "gothic": "story",
  "gotterdammerung": "story",
  "gouache": "beautiful",
  "gouda": "taste",
  "gouge": "build",
  "goujon": "heal",
  "goulash": "taste",
  "gourd": "build",
  "gourde": "smart",
  "gourmandize": "taste",
  "govern": "sell",
  "governed": "sell",
  "governing": "sell",
  "government": "smart",
  "government-in-exile": "sound",
  "governor": "build",
  "gown": "build",
  "gpa": "story",
  "gps": "build",
  "grab": "build",
  "graceful": "beautiful",
  "gracilariid": "heal",
  "gracilariidae": "heal",
  "gracillariidae": "heal",
  "gracious": "beautiful",
  "grackle": "heal",
  "gracula": "heal",
  "grad": "smart",
  "gradate": "build",
  "gradation": "story",
  "grade": "smart",
  "grading": "build",
  "gradual": "story",
  "graduate": "build",
  "graduated": "sell",
  "graduation": "story",
  "graffiti": "build",
  "graffito": "build",
  "graft": "heal",
  "grafting": "build",
  "graham": "taste",
  "grail": "smart",
  "grain": "taste",
  "graining": "build",
  "gram": "smart",
  "grama": "heal",
  "gramicidin": "build",
  "graminaceae": "heal",
  "graminales": "heal",
  "gramineae": "heal",
  "gramma": "heal",
  "grammar": "smart",
  "grammatical": "beautiful",
  "grammatophyllum": "heal",
  "gramme": "smart",
  "gramophone": "build",
  "grampus": "heal",
  "granadilla": "heal",
  "granadillo": "heal",
  "granary": "build",
  "grand": "smart",
  "grandiloquence": "story",
  "grandiosity": "story",
  "grandstand": "build",
  "grange": "build",
  "graniteware": "build",
  "granny": "build",
  "granola": "taste",
  "grant": "sell",
  "grant-in-aid": "sell",
  "granth": "story",
  "granular": "beautiful",
  "granulate": "heal",
  "granulocyte": "heal",
  "grape": "taste",
  "grapefruit": "heal",
  "grapeshot": "build",
  "grapevine": "story",
  "graph": "story",
  "grapheme": "story",
  "graphic": "beautiful",
  "graphical": "beautiful",
  "graphics": "story",
  "graphology": "smart",
  "grapnel": "build",
  "grappa": "taste",
  "grapple": "build",
  "grappler": "build",
  "grappling": "sell",
  "graptophyllum": "heal",
  "grasp": "smart",
  "grasping": "smart",
  "grass": "heal",
  "grass-of-parnassus": "heal",
  "grassfinch": "heal",
  "grasshopper": "heal",
  "grassless": "beautiful",
  "grassy": "beautiful",
  "grate": "build",
  "grateful": "beautiful",
  "grater": "taste",
  "graticule": "build",
  "gratify": "taste",
  "grating": "build",
  "gratuity": "sell",
  "grave": "build",
  "gravel": "build",
  "gravelweed": "heal",
  "graver": "build",
  "graverobber": "heal",
  "graves": "build",
  "gravestone": "build",
  "gravimeter": "build",
  "gravitation": "sound",
  "gravity": "sound",
  "gravity-assist": "sound",
  "gravure": "story",
  "gravy": "taste",
  "gray": "build",
  "grayback": "heal",
  "grayhen": "heal",
  "graylag": "heal",
  "graze": "build",
  "grazing": "build",
  "grease": "build",
  "grease-gun": "build",
  "greased": "build",
  "greasepaint": "build",
  "greasewood": "heal",
  "great": "beautiful",
  "greatcoat": "build",
  "greater": "beautiful",
  "greave": "build",
  "greaves": "build",
  "grebe": "heal",
  "greegree": "build",
  "greek": "story",
  "green": "beautiful",
  "greenback": "sell",
  "greenbottle": "heal",
  "greenbrier": "heal",
  "greenery": "heal",
  "greeneye": "heal",
  "greenfly": "heal",
  "greengage": "taste",
  "greengrocery": "build",
  "greenhood": "heal",
  "greenhouse": "build",
  "greening": "sound",
  "greenling": "heal",
  "greenmarket": "build",
  "greenness": "beautiful",
  "greenroom": "build",
  "greens": "taste",
  "greenshank": "heal",
  "greenweed": "heal",
  "greenwing": "heal",
  "greet": "story",
  "greeting": "story",
  "gregarine": "heal",
  "gregarinida": "heal",
  "gregarious": "beautiful",
  "grenade": "build",
  "grenadier": "heal",
  "grenadine": "taste",
  "gres-gris": "build",
  "grevillea": "heal",
  "grewia": "heal",
  "greyback": "heal",
  "greybeard": "build",
  "greyhen": "heal",
  "greyhound": "heal",
  "greylag": "heal",
  "gri-gri": "heal",
  "grias": "heal",
  "grid": "smart",
  "griddle": "taste",
  "griddlecake": "taste",
  "gridiron": "build",
  "grief": "smart",
  "grievance": "story",
  "griffon": "heal",
  "grigri": "build",
  "grill": "taste",
  "grille": "build",
  "grilling": "taste",
  "grillroom": "build",
  "grillwork": "build",
  "grimace": "story",
  "grime": "build",
  "grimoire": "story",
  "grin": "story",
  "grindelia": "heal",
  "grinder": "build",
  "grinding": "build",
  "grindle": "heal",
  "grindstone": "build",
  "grinning": "story",
  "grip": "build",
  "gripe": "story",
  "gripes": "story",
  "griping": "story",
  "gripsack": "build",
  "grisaille": "build",
  "griselinia": "heal",
  "griseofulvin": "build",
  "grison": "heal",
  "grissino": "taste",
  "grist": "taste",
  "gristle": "heal",
  "gristmill": "build",
  "grit": "build",
  "grits": "taste",
  "grivet": "heal",
  "grizzle": "build",
  "grizzly": "heal",
  "groak": "sound",
  "groan": "story",
  "groat": "sell",
  "groats": "taste",
  "grocery": "build",
  "groenendael": "heal",
  "groenlandia": "heal",
  "grog": "taste",
  "grogginess": "smart",
  "grogram": "build",
  "groin": "heal",
  "grok": "smart",
  "grommet": "build",
  "gromwell": "heal",
  "groom": "sell",
  "groomed": "sell",
  "grooming": "sell",
  "groove": "heal",
  "groover": "build",
  "grooving": "build",
  "grope": "build",
  "grosbeak": "heal",
  "groschen": "smart",
  "grosgrain": "build",
  "gross": "smart",
  "grossbeak": "heal",
  "grossulariaceae": "heal",
  "grosz": "smart",
  "grotesque": "build",
  "grouch": "story",
  "ground-berry": "heal",
  "ground-shaker": "heal",
  "groundberry": "heal",
  "groundbreaking": "beautiful",
  "groundcover": "heal",
  "groundfish": "heal",
  "groundhog": "heal",
  "grounding": "smart",
  "groundnut": "heal",
  "grounds": "smart",
  "groundsel": "heal",
  "groundsheet": "build",
  "groundwork": "smart",
  "group": "smart",
  "grouper": "taste",
  "grouping": "smart",
  "groupthink": "smart",
  "groupware": "story",
  "grouse": "taste",
  "grouse-berry": "heal",
  "grouseberry": "heal",
  "grout": "build",
  "grove": "build",
  "groves": "build",
  "growing": "smart",
  "growl": "story",
  "growling": "story",
  "grownup": "beautiful",
  "growth": "smart",
  "groyne": "build",
  "grub": "taste",
  "grubby": "heal",
  "grubstake": "sell",
  "gruel": "taste",
  "grugru": "heal",
  "gruidae": "heal",
  "gruiformes": "heal",
  "grumble": "story",
  "grumbling": "story",
  "grume": "heal",
  "grummet": "build",
  "grunt": "heal",
  "grunt-hoot": "story",
  "grunter": "heal",
  "grus": "heal",
  "gruyere": "taste",
  "gryllidae": "heal",
  "guacamole": "taste",
  "guacharo": "heal",
  "guaiac": "heal",
  "guaiacum": "heal",
  "guama": "heal",
  "guan": "heal",
  "guanabana": "taste",
  "guanabenz": "build",
  "guanaco": "heal",
  "guar": "heal",
  "guarani": "smart",
  "guarantee": "story",
  "guaranty": "sell",
  "guard": "build",
  "guardhouse": "build",
  "guardrail": "build",
  "guardroom": "build",
  "guarnerius": "build",
  "guava": "heal",
  "guayule": "heal",
  "gubbins": "build",
  "gudgeon": "heal",
  "guenon": "heal",
  "guerdon": "sell",
  "guereza": "heal",
  "gueridon": "build",
  "guernsey": "heal",
  "guess": "story",
  "guessing": "smart",
  "guesstimate": "smart",
  "guesswork": "smart",
  "guest": "build",
  "guesthouse": "build",
  "guestimate": "smart",
  "guestroom": "build",
  "guestworker": "sound",
  "guevina": "heal",
  "guff": "story",
  "guffaw": "story",
  "guggle": "sound",
  "gui": "story",
  "guib": "heal",
  "guidance": "story",
  "guide": "story",
  "guidebook": "story",
  "guided": "sell",
  "guideline": "story",
  "guidepost": "smart",
  "guideword": "story",
  "guilder": "smart",
  "guildhall": "build",
  "guile": "smart",
  "guillemot": "heal",
  "guilloche": "build",
  "guillotine": "story",
  "guiltless": "beautiful",
  "guilty": "beautiful",
  "guimpe": "build",
  "guinea": "sell",
  "guinness": "taste",
  "guitar": "sound",
  "guitarfish": "heal",
  "gujarati": "story",
  "gujerati": "story",
  "gulag": "build",
  "gulden": "smart",
  "gulfweed": "heal",
  "gull": "heal",
  "gullet": "heal",
  "gulo": "heal",
  "gulp": "taste",
  "gulping": "taste",
  "gulyas": "taste",
  "gum": "taste",
  "gumbo": "heal",
  "gumbo-limbo": "heal",
  "gumdrop": "taste",
  "gumming": "build",
  "gummosis": "heal",
  "gumption": "smart",
  "gumshield": "build",
  "gumshoe": "build",
  "gumweed": "heal",
  "gumwood": "heal",
  "gun": "build",
  "gun-sight": "build",
  "gunboat": "build",
  "gunflint": "build",
  "gunlock": "build",
  "gunnel": "build",
  "gunnery": "build",
  "gunny": "build",
  "gunnysack": "build",
  "gunpoint": "build",
  "gunsight": "build",
  "gunstock": "build",
  "gunwale": "build",
  "guppy": "heal",
  "gur": "story",
  "gurgle": "sound",
  "gurnard": "heal",
  "gurney": "build",
  "gush": "story",
  "gusher": "build",
  "gusset": "build",
  "gusseted": "beautiful",
  "gust": "sound",
  "gustation": "taste",
  "gustative": "taste",
  "gustatorial": "taste",
  "gustatory": "taste",
  "gut": "heal",
  "gutierrezia": "heal",
  "gutless": "beautiful",
  "guts": "heal",
  "gutsy": "beautiful",
  "gutter": "build",
  "guttiferae": "heal",
  "guttiferales": "heal",
  "guttle": "taste",
  "guttural": "story",
  "guy": "build",
  "guzzle": "taste",
  "guzzling": "taste",
  "gym": "build",
  "gymnadenia": "heal",
  "gymnadeniopsis": "heal",
  "gymnasium": "build",
  "gymnastic": "beautiful",
  "gymnelis": "heal",
  "gymnocalycium": "heal",
  "gymnocarpium": "heal",
  "gymnocladus": "heal",
  "gymnogyps": "heal",
  "gymnomycota": "heal",
  "gymnophiona": "heal",
  "gymnopilus": "heal",
  "gymnorhina": "heal",
  "gymnosophy": "smart",
  "gymnosperm": "heal",
  "gymnospermae": "heal",
  "gymnospermophyta": "heal",
  "gymnosporangium": "heal",
  "gymnura": "heal",
  "gymslip": "build",
  "gynaecology": "smart",
  "gynecology": "smart",
  "gynobase": "heal",
  "gynoecium": "heal",
  "gynogenesis": "smart",
  "gynophore": "heal",
  "gynostegium": "heal",
  "gynura": "heal",
  "gyp": "sell",
  "gypaetus": "heal",
  "gyps": "heal",
  "gypsophila": "heal",
  "gypsy": "story",
  "gypsyweed": "heal",
  "gypsywort": "heal",
  "gyrfalcon": "heal",
  "gyrinidae": "heal",
  "gyro": "taste",
  "gyrocompass": "build",
  "gyromitra": "heal",
  "gyroplane": "build",
  "gyroscope": "build",
  "gyrostabiliser": "build",
  "gyrostabilizer": "build",
  "gyrus": "heal",
  "h-bomb": "build",
  "h.p.": "smart",
  "ha'p'orth": "smart",
  "ha'penny": "sell",
  "ha-ha": "story",
  "haart": "build",
  "haastia": "heal",
  "habacuc": "story",
  "habakkuk": "story",
  "habanera": "story",
  "habenaria": "heal",
  "haberdashery": "build",
  "habergeon": "build",
  "habiliment": "build",
  "habilitate": "heal",
  "habit": "smart",
  "habit-forming": "beautiful",
  "habitation": "build",
  "habituate": "taste",
  "hacek": "story",
  "hacienda": "sell",
  "hack": "build",
  "hackamore": "build",
  "hackberry": "heal",
  "hackbut": "build",
  "hackee": "heal",
  "hackelia": "heal",
  "hacker": "smart",
  "hackle": "heal",
  "hackles": "heal",
  "hackmatack": "heal",
  "hackney": "build",
  "hacksaw": "build",
  "haddock": "taste",
  "hadean": "beautiful",
  "hades": "smart",
  "hadith": "smart",
  "hadj": "smart",
  "hadrosaur": "heal",
  "hadrosauridae": "heal",
  "hadrosaurus": "heal",
  "haecceity": "smart",
  "haem": "beautiful",
  "haemagglutinate": "build",
  "haemagglutination": "smart",
  "haemanthus": "heal",
  "haematinic": "build",
  "haematobia": "heal",
  "haematochezia": "smart",
  "haematocrit": "build",
  "haematogenesis": "smart",
  "haematoidin": "beautiful",
  "haematology": "smart",
  "haematolysis": "smart",
  "haematopodidae": "heal",
  "haematopoiesis": "smart",
  "haematopus": "heal",
  "haematoxylon": "heal",
  "haematoxylum": "heal",
  "haemitin": "beautiful",
  "haemodoraceae": "heal",
  "haemodorum": "heal",
  "haemogenesis": "smart",
  "haemolysis": "smart",
  "haemopis": "heal",
  "haemopoiesis": "smart",
  "haemoproteid": "heal",
  "haemoproteidae": "heal",
  "haemoproteus": "heal",
  "haemosporidia": "heal",
  "haemosporidian": "heal",
  "haemostat": "build",
  "haemulidae": "heal",
  "haemulon": "heal",
  "haft": "build",
  "haftarah": "story",
  "haftorah": "story",
  "hag": "heal",
  "hagada": "story",
  "hagberry": "heal",
  "hagbut": "build",
  "hagfish": "heal",
  "haggada": "story",
  "haggadah": "story",
  "haggai": "story",
  "haggard": "beautiful",
  "haggis": "taste",
  "haggle": "story",
  "haggling": "story",
  "hagiographa": "story",
  "hagiography": "story",
  "hagiology": "story",
  "haick": "build",
  "haida": "story",
  "haik": "build",
  "haiku": "story",
  "hail": "sound",
  "hailstorm": "sound",
  "hair": "heal",
  "hair's-breadth": "smart",
  "hairbrush": "build",
  "haircloth": "build",
  "haircut": "heal",
  "hairdo": "heal",
  "hairdressing": "build",
  "haired": "beautiful",
  "hairgrip": "build",
  "hairless": "beautiful",
  "hairline": "story",
  "hairnet": "build",
  "hairpiece": "build",
  "hairpin": "build",
  "hairsbreadth": "smart",
  "hairsplitting": "smart",
  "hairspring": "build",
  "hairstreak": "heal",
  "hairstyle": "heal",
  "hairtail": "heal",
  "hairy": "beautiful",
  "haj": "smart",
  "hajj": "smart",
  "hake": "taste",
  "hakea": "heal",
  "hakenkreuz": "story",
  "hakham": "story",
  "hakka": "story",
  "halacha": "story",
  "halaka": "story",
  "halakah": "story",
  "halal": "taste",
  "halberd": "build",
  "halcion": "build",
  "halcyon": "heal",
  "haldane": "heal",
  "haldea": "heal",
  "haldol": "build",
  "hale": "sell",
  "halenia": "heal",
  "haler": "smart",
  "halesia": "heal",
  "half": "smart",
  "half-and-half": "taste",
  "half-breed": "beautiful",
  "half-cock": "smart",
  "half-length": "build",
  "half-light": "sound",
  "half-moon": "heal",
  "half-pay": "sell",
  "half-relief": "build",
  "half-slip": "build",
  "half-truth": "story",
  "halfbeak": "heal",
  "halfpenny": "sell",
  "halfpennyworth": "smart",
  "halftone": "build",
  "haliaeetus": "heal",
  "halibut": "taste",
  "halicoeres": "heal",
  "halictidae": "heal",
  "halimodendron": "heal",
  "haliotidae": "heal",
  "haliotis": "heal",
  "hall": "build",
  "hallah": "taste",
  "hallel": "story",
  "hallelujah": "story",
  "halliard": "build",
  "hallmark": "story",
  "halloo": "story",
  "hallow": "story",
  "hallstand": "build",
  "hallucinate": "sound",
  "hallucination": "smart",
  "hallucinogen": "build",
  "hallux": "heal",
  "hallway": "build",
  "halm": "heal",
  "halo": "sound",
  "halobacter": "heal",
  "halobacteria": "heal",
  "halobacterium": "heal",
  "halocarpus": "heal",
  "halogeton": "heal",
  "haloperidol": "build",
  "halophil": "heal",
  "halophile": "heal",
  "halophyte": "heal",
  "haloragaceae": "heal",
  "haloragidaceae": "heal",
  "halothane": "build",
  "halt": "sound",
  "halter": "build",
  "haltere": "heal",
  "halve": "smart",
  "halyard": "build",
  "ham": "taste",
  "hamadryad": "heal",
  "hamamelidaceae": "heal",
  "hamamelidae": "heal",
  "hamamelidanthum": "heal",
  "hamamelidoxylon": "heal",
  "hamamelis": "heal",
  "hamamelites": "heal",
  "hamate": "heal",
  "hamburger": "taste",
  "hame": "build",
  "hamelia": "heal",
  "haminoea": "heal",
  "hamitic": "story",
  "hamito-semitic": "story",
  "hammer": "build",
  "hammered": "build",
  "hammerhead": "build",
  "hammering": "build",
  "hammertoe": "heal",
  "hamming": "build",
  "hammock": "build",
  "hamper": "build",
  "hampshire": "heal",
  "hamster": "heal",
  "hamstring": "heal",
  "hand": "heal",
  "hand-build": "build",
  "hand-crafted": "beautiful",
  "hand-me-down": "build",
  "hand-pick": "smart",
  "hand-wash": "build",
  "handbag": "build",
  "handball": "build",
  "handbarrow": "build",
  "handbasin": "build",
  "handbasket": "build",
  "handbell": "build",
  "handbill": "story",
  "handbook": "story",
  "handbow": "build",
  "handbreadth": "smart",
  "handbuild": "build",
  "handcar": "build",
  "handcart": "build",
  "handclap": "story",
  "handclasp": "story",
  "handcraft": "build",
  "handcuff": "build",
  "handed": "sell",
  "handel": "story",
  "handful": "smart",
  "handgrip": "build",
  "handgun": "build",
  "handhold": "build",
  "handicap": "smart",
  "handicapped": "heal",
  "handicraft": "build",
  "handiness": "smart",
  "handiwork": "build",
  "handkerchief": "build",
  "handle": "build",
  "handle-bars": "heal",
  "handlebar": "build",
  "handled": "sell",
  "handleless": "beautiful",
  "handless": "beautiful",
  "handline": "build",
  "handling": "sell",
  "handlock": "build",
  "handloom": "build",
  "handmade": "beautiful",
  "handout": "story",
  "handrail": "build",
  "handrest": "build",
  "hands": "heal",
  "handsaw": "build",
  "handsbreadth": "smart",
  "handset": "build",
  "handshake": "story",
  "handshaking": "story",
  "handspike": "build",
  "handstamp": "build",
  "handwash": "build",
  "handwear": "build",
  "handwheel": "build",
  "handwork": "build",
  "handwrite": "story",
  "handwriting": "story",
  "handy": "beautiful",
  "hang": "smart",
  "hang-up": "smart",
  "hangar": "build",
  "hangbird": "heal",
  "hanger": "build",
  "hanging": "build",
  "hangnail": "heal",
  "hani": "story",
  "hank": "build",
  "hankey": "build",
  "hankie": "build",
  "hanks": "build",
  "hanky": "build",
  "hansard": "story",
  "hansom": "build",
  "hanuman": "heal",
  "hao": "smart",
  "haoma": "heal",
  "haphtarah": "story",
  "haphtorah": "story",
  "haploid": "heal",
  "haploidic": "beautiful",
  "haplopappus": "heal",
  "haplosporidia": "heal",
  "haplosporidian": "heal",
  "haplotype": "heal",
  "happen": "sell",
  "happening": "sell",
  "happy": "beautiful",
  "haptic": "build",
  "harangue": "story",
  "harbinger": "story",
  "harbor": "build",
  "harbour": "build",
  "hard": "beautiful",
  "hardback": "build",
  "hardbake": "taste",
  "hardball": "smart",
  "hardcover": "build",
  "hardenbergia": "heal",
  "hardening": "smart",
  "hardheads": "heal",
  "hardhearted": "beautiful",
  "hardinggrass": "heal",
  "hardliner": "beautiful",
  "hardtack": "taste",
  "hardtop": "build",
  "hardware": "smart",
  "hardy": "beautiful",
  "hare": "heal",
  "harebell": "heal",
  "hareem": "build",
  "harem": "build",
  "haricot": "heal",
  "hark": "sound",
  "harken": "sound",
  "harlequin-snake": "heal",
  "harm": "heal",
  "harmattan": "sound",
  "harmful": "beautiful",
  "harmless": "beautiful",
  "harmonic": "sound",
  "harmonica": "sound",
  "harmonics": "sound",
  "harmonious": "beautiful",
  "harmonisation": "story",
  "harmonise": "build",
  "harmonium": "build",
  "harmonization": "story",
  "harmonize": "sound",
  "harmony": "sound",
  "harness": "build",
  "harp": "sound",
  "harpia": "heal",
  "harpoon": "build",
  "harpsichord": "sound",
  "harpsichordist": "sound",
  "harpulla": "heal",
  "harpullia": "heal",
  "harpy": "heal",
  "harquebus": "build",
  "harrier": "heal",
  "harrisia": "heal",
  "harrow": "build",
  "harsh": "beautiful",
  "hart": "heal",
  "hart's-tongue": "heal",
  "hartebeest": "heal",
  "harum-scarum": "beautiful",
  "harvard": "build",
  "harvest": "heal",
  "harvest-lice": "heal",
  "harvester": "build",
  "harvestfish": "heal",
  "harvesting": "build",
  "harvestman": "heal",
  "haschisch": "build",
  "hash": "taste",
  "hasheesh": "build",
  "hashish": "build",
  "hashmark": "story",
  "hasidism": "smart",
  "haslet": "taste",
  "hasp": "build",
  "hassidism": "smart",
  "hassock": "build",
  "hasten": "sell",
  "hastinapura": "story",
  "hat": "build",
  "hatband": "build",
  "hatbox": "build",
  "hatch": "smart",
  "hatchback": "build",
  "hatchel": "build",
  "hatchet": "build",
  "hatching": "smart",
  "hatchling": "heal",
  "hatchway": "build",
  "hateful": "beautiful",
  "hatful": "smart",
  "hatiora": "heal",
  "hatless": "beautiful",
  "hatpin": "build",
  "hatrack": "build",
  "hatted": "heal",
  "hauberk": "build",
  "haul": "smart",
  "hauling": "build",
  "haulm": "heal",
  "haunch": "heal",
  "hausa": "story",
  "hausen": "heal",
  "haussa": "story",
  "haustorium": "heal",
  "hautbois": "build",
  "hautboy": "build",
  "havasupai": "story",
  "have": "sell",
  "havelock": "build",
  "haven": "build",
  "haversack": "build",
  "haw": "heal",
  "haw-haw": "story",
  "hawaiian": "story",
  "hawfinch": "heal",
  "hawk": "heal",
  "hawk's-beard": "heal",
  "hawk's-beards": "heal",
  "hawkbill": "heal",
  "hawkbit": "heal",
  "hawking": "sell",
  "hawkishness": "smart",
  "hawkmoth": "heal",
  "hawksbill": "heal",
  "hawkweed": "heal",
  "haworth": "sound",
  "hawse": "build",
  "hawsehole": "build",
  "hawsepipe": "build",
  "hawser": "build",
  "hawthorn": "heal",
  "hay": "taste",
  "hay-scented": "heal",
  "haydn": "story",
  "hayfork": "build",
  "hayloft": "build",
  "haymaker": "build",
  "haymow": "smart",
  "hayrack": "build",
  "hayrig": "build",
  "hays": "taste",
  "haywire": "build",
  "hazard": "sound",
  "hazardia": "heal",
  "haze": "sound",
  "hazel": "heal",
  "hazelnut": "heal",
  "hazelwood": "heal",
  "hdtv": "story",
  "he-goat": "heal",
  "he-huckleberry": "heal",
  "head": "heal",
  "headache": "smart",
  "headband": "build",
  "headboard": "build",
  "headbutt": "build",
  "headcheese": "taste",
  "headcount": "smart",
  "headdress": "build",
  "headed": "sell",
  "header": "story",
  "headfast": "build",
  "headfish": "heal",
  "headful": "smart",
  "headgear": "build",
  "heading": "story",
  "headlamp": "build",
  "headless": "beautiful",
  "headlight": "build",
  "headline": "story",
  "headlinese": "story",
  "headphone": "sound",
  "headpiece": "build",
  "headpin": "build",
  "headquarter": "sell",
  "headquarters": "build",
  "headrace": "build",
  "headrest": "build",
  "headroom": "smart",
  "heads-up": "story",
  "headsail": "build",
  "headscarf": "build",
  "headset": "build",
  "headshot": "build",
  "headspace": "smart",
  "headstall": "build",
  "headstock": "build",
  "headstone": "build",
  "headway": "smart",
  "headwind": "sound",
  "headword": "story",
  "heal": "heal",
  "healing": "heal",
  "healthful": "beautiful",
  "healthy": "heal",
  "heap": "smart",
  "heaps": "smart",
  "hear": "sound",
  "hearable": "beautiful",
  "hearken": "sound",
  "hearsay": "story",
  "hearse": "build",
  "heart": "heal",
  "heart-leaf": "heal",
  "heart-to-heart": "story",
  "heartbeat": "sound",
  "hearth": "build",
  "hearthrug": "build",
  "hearthstone": "build",
  "heartleaf": "heal",
  "heartless": "beautiful",
  "hearts": "smart",
  "heartsease": "heal",
  "heartseed": "heal",
  "heartwood": "heal",
  "heat": "sound",
  "heat-absorbing": "beautiful",
  "heat-releasing": "beautiful",
  "heater": "build",
  "heath": "heal",
  "heathen": "beautiful",
  "heathenism": "smart",
  "heather": "heal",
  "heathfowl": "heal",
  "heating": "smart",
  "heaume": "build",
  "heave": "sound",
  "heaven": "smart",
  "heavenly": "beautiful",
  "heavens": "smart",
  "heaver": "build",
  "heaves": "sound",
  "heaving": "sound",
  "heavy": "smart",
  "heavy-duty": "beautiful",
  "heavy-footed": "beautiful",
  "hebephrenia": "heal",
  "hebetude": "smart",
  "hebrew": "story",
  "hebrews": "story",
  "heckelphone": "build",
  "heckle": "build",
  "heckling": "build",
  "hectare": "smart",
  "hectogram": "smart",
  "hectograph": "build",
  "hectoliter": "smart",
  "hectolitre": "smart",
  "hectometer": "smart",
  "hectometre": "smart",
  "hedeoma": "heal",
  "hedera": "heal",
  "hedge": "build",
  "hedgehog": "heal",
  "hedgerow": "build",
  "hedging": "sell",
  "hediondilla": "heal",
  "hedonism": "smart",
  "hedysarum": "heal",
  "hee-haw": "story",
  "heed": "smart",
  "heedful": "beautiful",
  "heedless": "beautiful",
  "heedlessness": "smart",
  "heel": "build",
  "heelbone": "heal",
  "heft": "build",
  "hegari": "heal",
  "heifer": "heal",
  "heirloom": "sell",
  "heist": "sell",
  "held": "build",
  "helenium": "heal",
  "heleodytes": "heal",
  "heliamphora": "heal",
  "helianthemum": "heal",
  "helianthus": "heal",
  "helichrysum": "heal",
  "helicidae": "heal",
  "helicon": "build",
  "helicopter": "build",
  "helicteres": "heal",
  "heliobacter": "heal",
  "heliocentric": "beautiful",
  "heliogram": "story",
  "heliograph": "build",
  "heliogravure": "build",
  "heliometer": "build",
  "heliophila": "heal",
  "heliopsis": "heal",
  "heliothis": "heal",
  "heliotype": "build",
  "heliozoa": "heal",
  "heliozoan": "heal",
  "heliport": "build",
  "helipterum": "heal",
  "helix": "build",
  "hell": "smart",
  "hellbender": "heal",
  "hellebore": "heal",
  "helleborine": "heal",
  "helleborus": "heal",
  "hellenic": "story",
  "hellenism": "smart",
  "heller": "smart",
  "helleri": "heal",
  "hellfire": "smart",
  "hellgrammiate": "heal",
  "hello": "story",
  "helm": "build",
  "helmet": "build",
  "helmetflower": "heal",
  "helmholtz": "heal",
  "helminth": "heal",
  "helminthic": "build",
  "helminthostachys": "heal",
  "heloderma": "heal",
  "helodermatidae": "heal",
  "helotiaceae": "heal",
  "helotiales": "heal",
  "helotium": "heal",
  "helpful": "beautiful",
  "helping": "taste",
  "helve": "build",
  "helvella": "heal",
  "helvellaceae": "heal",
  "helvetica": "story",
  "helwingia": "heal",
  "helxine": "heal",
  "hem": "build",
  "hemachatus": "heal",
  "hemagglutinate": "build",
  "hemagglutination": "smart",
  "hematin": "beautiful",
  "hematinic": "build",
  "hematochezia": "smart",
  "hematocrit": "build",
  "hematogenesis": "smart",
  "hematoidin": "beautiful",
  "hematology": "smart",
  "hematolysis": "smart",
  "hematopoiesis": "smart",
  "heme": "beautiful",
  "hemerobiid": "heal",
  "hemerobiidae": "heal",
  "hemerocallidaceae": "heal",
  "hemerocallis": "heal",
  "hemiascomycetes": "heal",
  "hemidemisemiquaver": "story",
  "hemiepiphyte": "heal",
  "hemigalus": "heal",
  "hemigrammus": "heal",
  "hemimetabola": "heal",
  "hemimetabolism": "smart",
  "hemimetaboly": "smart",
  "hemimetamorphosis": "smart",
  "heming": "build",
  "hemiparasite": "heal",
  "hemipode": "heal",
  "hemiprocnidae": "heal",
  "hemiptera": "heal",
  "hemipteran": "heal",
  "hemipteron": "heal",
  "hemipteronatus": "heal",
  "hemiramphidae": "heal",
  "hemisphere": "heal",
  "hemitripterus": "heal",
  "hemlock": "heal",
  "hemming-stitch": "build",
  "hemochromatosis": "heal",
  "hemodialyzer": "build",
  "hemodynamics": "smart",
  "hemogenesis": "smart",
  "hemolysis": "smart",
  "hemopoiesis": "smart",
  "hemorrhage": "heal",
  "hemostat": "build",
  "hemp": "heal",
  "hemstitch": "build",
  "hemstitching": "build",
  "hen": "heal",
  "hen-of-the-woods": "heal",
  "hen-peck": "story",
  "henbane": "heal",
  "henbit": "heal",
  "hencoop": "build",
  "hendiadys": "story",
  "henhouse": "build",
  "henroost": "build",
  "henry": "smart",
  "hepadnavirus": "heal",
  "heparin": "build",
  "hepatic": "heal",
  "hepatica": "heal",
  "hepaticae": "heal",
  "hepaticopsida": "heal",
  "heptad": "smart",
  "heracleum": "heal",
  "herald": "story",
  "heraldic": "beautiful",
  "heraldry": "smart",
  "herb": "taste",
  "herbage": "heal",
  "herbal": "taste",
  "herbivore": "heal",
  "herbivorous": "beautiful",
  "hercules'-club": "heal",
  "hercules'-clubs": "heal",
  "hercules-club": "heal",
  "here": "beautiful",
  "hereditament": "sell",
  "hereditarianism": "smart",
  "heredity": "smart",
  "hereford": "heal",
  "herero": "story",
  "heresy": "smart",
  "heritable": "beautiful",
  "heritage": "smart",
  "heritiera": "heal",
  "herm": "build",
  "hermannia": "heal",
  "hermaphrodite": "beautiful",
  "hermeneutics": "smart",
  "hermissenda": "heal",
  "hermitage": "build",
  "hernaria": "heal",
  "hero": "smart",
  "heroic": "story",
  "heroics": "story",
  "heroin": "build",
  "heron": "heal",
  "herpes": "heal",
  "herpestes": "heal",
  "herpetology": "smart",
  "herr": "story",
  "herrerasaur": "heal",
  "herrerasaurus": "heal",
  "herring": "taste",
  "herringbone": "build",
  "hershey": "taste",
  "hesitate": "sound",
  "hesitation": "smart",
  "hesperiphona": "heal",
  "hesperis": "heal",
  "hess": "heal",
  "hessian": "build",
  "heteranthera": "heal",
  "heterobasidiomycetes": "heal",
  "heterocephalus": "heal",
  "heterocercal": "beautiful",
  "heterocyclic": "beautiful",
  "heterodactyl": "beautiful",
  "heterodon": "heal",
  "heterodoxy": "smart",
  "heterodyne": "build",
  "heteroecious": "beautiful",
  "heterogeneous": "beautiful",
  "heterogenesis": "sound",
  "heterogenous": "beautiful",
  "heterograft": "heal",
  "heterokontae": "heal",
  "heterokontophyta": "heal",
  "heterologic": "beautiful",
  "heterological": "beautiful",
  "heterologous": "beautiful",
  "heteromeles": "heal",
  "heterometabolism": "smart",
  "heterometaboly": "smart",
  "heteromyidae": "heal",
  "heteronym": "story",
  "heteroploid": "heal",
  "heteroptera": "heal",
  "heteroscelus": "heal",
  "heterosexual": "beautiful",
  "heterosomata": "heal",
  "heterospory": "smart",
  "heterostracan": "heal",
  "heterostraci": "heal",
  "heterotheca": "heal",
  "heterotrichales": "heal",
  "heterozygote": "heal",
  "heterozygous": "beautiful",
  "heth": "story",
  "heuchera": "heal",
  "heuristic": "smart",
  "hevea": "heal",
  "hew": "build",
  "hex": "story",
  "hexachlorophene": "build",
  "hexad": "smart",
  "hexagrammidae": "heal",
  "hexagrammos": "heal",
  "hexalectris": "heal",
  "hexameter": "story",
  "hexamita": "heal",
  "hexanchidae": "heal",
  "hexanchus": "heal",
  "hexapod": "heal",
  "hexapoda": "heal",
  "hexenbesen": "heal",
  "hi-fi": "build",
  "hi-tech": "beautiful",
  "hiatus": "story",
  "hibachi": "build",
  "hibbertia": "heal",
  "hibernate": "heal",
  "hibiscus": "heal",
  "hiccough": "heal",
  "hiccup": "heal",
  "hick": "beautiful",
  "hickey": "sound",
  "hickory": "heal",
  "hidatsa": "story",
  "hide": "heal",
  "hideaway": "build",
  "hiding": "sound",
  "hidrosis": "smart",
  "hieracium": "heal",
  "hierarchal": "beautiful",
  "hierarchic": "beautiful",
  "hierarchical": "beautiful",
  "hieratic": "story",
  "hieroglyph": "story",
  "hieroglyphic": "story",
  "higgle": "sell",
  "high-energy": "beautiful",
  "high-five": "story",
  "high-interest": "beautiful",
  "high-pitched": "beautiful",
  "high-resolution": "beautiful",
  "high-rise": "build",
  "high-sudsing": "beautiful",
  "high-tech": "beautiful",
  "high-tension": "beautiful",
  "highball": "taste",
  "highboard": "build",
  "highboy": "build",
  "highbrow": "beautiful",
  "highchair": "build",
  "highjack": "build",
  "highjacking": "build",
  "highland": "beautiful",
  "highlander": "beautiful",
  "highlight": "heal",
  "highlighter": "build",
  "highlighting": "heal",
  "highroad": "build",
  "highway": "build",
  "higi": "story",
  "hijab": "build",
  "hijack": "build",
  "hijacking": "build",
  "hill": "build",
  "hilt": "build",
  "hilum": "heal",
  "hilus": "heal",
  "himalayish": "story",
  "himantoglossum": "heal",
  "himantopus": "heal",
  "hin": "smart",
  "hinayana": "smart",
  "hinayanism": "smart",
  "hind": "heal",
  "hindbrain": "heal",
  "hinder": "sell",
  "hinderance": "smart",
  "hindfoot": "heal",
  "hindgut": "heal",
  "hindi": "story",
  "hindlimb": "heal",
  "hindooism": "smart",
  "hindoostani": "story",
  "hindostani": "story",
  "hindquarter": "taste",
  "hindquarters": "heal",
  "hindrance": "smart",
  "hindshank": "taste",
  "hindsight": "smart",
  "hinduism": "smart",
  "hindustani": "story",
  "hinge": "build",
  "hinny": "heal",
  "hint": "story",
  "hip": "heal",
  "hip-hop": "sound",
  "hipbone": "heal",
  "hipflask": "build",
  "hipless": "beautiful",
  "hippeastrum": "heal",
  "hipped": "beautiful",
  "hippo": "heal",
  "hippobosca": "heal",
  "hippoboscid": "heal",
  "hippoboscidae": "heal",
  "hippocampus": "heal",
  "hippocastanaceae": "heal",
  "hippocrepis": "heal",
  "hippodamia": "heal",
  "hippodrome": "build",
  "hippoglossoides": "heal",
  "hippoglossus": "heal",
  "hippopotamidae": "heal",
  "hippopotamus": "heal",
  "hipposideridae": "heal",
  "hipposideros": "heal",
  "hippotragus": "heal",
  "hipsurus": "heal",
  "hire": "sell",
  "hire-purchase": "sell",
  "hired": "sell",
  "hirsute": "beautiful",
  "hirudinea": "heal",
  "hirudinean": "heal",
  "hirudinidae": "heal",
  "hirudo": "heal",
  "hirundinidae": "heal",
  "hirundo": "heal",
  "hiss": "story",
  "hissing": "story",
  "histamine": "heal",
  "histiocyte": "heal",
  "histocompatibility": "sound",
  "histogram": "story",
  "histology": "smart",
  "historical": "beautiful",
  "historicism": "smart",
  "historiography": "story",
  "history": "story",
  "histrionics": "story",
  "hitch": "smart",
  "hitchiti": "story",
  "hitchrack": "build",
  "hitting": "build",
  "hittite": "story",
  "hiv": "heal",
  "hive": "build",
  "hives": "build",
  "hmo": "sell",
  "hmong": "story",
  "hnd": "story",
  "hoactzin": "heal",
  "hoagie": "taste",
  "hoagland": "heal",
  "hoagy": "taste",
  "hoar": "beautiful",
  "hoard": "sell",
  "hoarding": "build",
  "hoatzin": "heal",
  "hoax": "sell",
  "hob": "build",
  "hobble": "build",
  "hobby": "build",
  "hobbyhorse": "smart",
  "hobgoblin": "smart",
  "hobnail": "build",
  "hobnob": "sell",
  "hock": "taste",
  "hock-joint": "heal",
  "hocus-pocus": "story",
  "hod": "build",
  "hodgepodge": "smart",
  "hodgkin": "heal",
  "hodometer": "build",
  "hodoscope": "build",
  "hoe": "build",
  "hoecake": "taste",
  "hog": "heal",
  "hog-tie": "build",
  "hogan": "build",
  "hogchoker": "heal",
  "hogfish": "heal",
  "hogg": "heal",
  "hogget": "heal",
  "hogshead": "smart",
  "hogwash": "story",
  "hogweed": "heal",
  "hoheria": "heal",
  "hoist": "build",
  "hoka": "story",
  "hokan": "story",
  "hokkianese": "story",
  "hokum": "story",
  "holarrhena": "heal",
  "holbrookia": "heal",
  "holcus": "heal",
  "hold": "smart",
  "holdall": "build",
  "holder": "build",
  "holdfast": "build",
  "holding": "sell",
  "holdout": "story",
  "hole": "build",
  "holibut": "heal",
  "holism": "smart",
  "holistic": "beautiful",
  "holla": "story",
  "hollandaise": "taste",
  "hollands": "taste",
  "holler": "story",
  "hollering": "story",
  "hollo": "story",
  "holloa": "story",
  "hollow": "build",
  "holloware": "build",
  "hollowware": "build",
  "holly": "heal",
  "hollygrape": "heal",
  "hollyhock": "heal",
  "holocentridae": "heal",
  "holocentrus": "heal",
  "holocephalan": "heal",
  "holocephali": "heal",
  "holocephalian": "heal",
  "hologram": "build",
  "holograph": "story",
  "holographic": "beautiful",
  "holography": "smart",
  "holometabola": "heal",
  "holometabolism": "smart",
  "holometaboly": "smart",
  "holonym": "story",
  "holophyte": "heal",
  "holophytic": "beautiful",
  "holothuria": "heal",
  "holothurian": "heal",
  "holothuridae": "heal",
  "holothuroidea": "heal",
  "holotype": "smart",
  "holozoic": "beautiful",
  "holstein": "heal",
  "holstein-friesian": "heal",
  "holster": "build",
  "holy": "beautiful",
  "holystone": "build",
  "homaridae": "heal",
  "homarus": "heal",
  "homburg": "build",
  "home": "build",
  "home-farm": "build",
  "home-school": "sell",
  "homebound": "beautiful",
  "homebrew": "taste",
  "homeless": "beautiful",
  "homemade": "beautiful",
  "homeobox": "heal",
  "homeostasis": "heal",
  "homeotherm": "heal",
  "homepage": "story",
  "homer": "smart",
  "homeroom": "build",
  "homespun": "build",
  "homestead": "sell",
  "homestretch": "build",
  "homiletics": "smart",
  "homily": "story",
  "hominid": "heal",
  "hominidae": "heal",
  "hominoid": "heal",
  "hominoidea": "heal",
  "hominy": "taste",
  "hommos": "taste",
  "homo": "heal",
  "homobasidiomycetes": "heal",
  "homocentric": "beautiful",
  "homocercal": "beautiful",
  "homochromatic": "beautiful",
  "homoecious": "beautiful",
  "homogeneous": "beautiful",
  "homogenous": "beautiful",
  "homograft": "heal",
  "homograph": "story",
  "homogyne": "heal",
  "homoiotherm": "heal",
  "homologous": "beautiful",
  "homona": "heal",
  "homonym": "story",
  "homophile": "beautiful",
  "homophobia": "smart",
  "homophone": "story",
  "homophony": "story",
  "homoptera": "heal",
  "homopteran": "heal",
  "homosexual": "beautiful",
  "homospory": "smart",
  "homotherm": "heal",
  "homozygote": "heal",
  "homozygous": "beautiful",
  "hone": "build",
  "honest": "beautiful",
  "honesty": "heal",
  "honey": "taste",
  "honey-flower": "heal",
  "honeybee": "heal",
  "honeybells": "heal",
  "honeycomb": "build",
  "honeycreeper": "heal",
  "honeydew": "taste",
  "honeyflower": "heal",
  "honeypot": "heal",
  "honeysucker": "heal",
  "honeysuckle": "heal",
  "honk": "sound",
  "honker": "heal",
  "honky-tonk": "build",
  "honkytonk": "build",
  "honor": "story",
  "honorable": "beautiful",
  "honorarium": "sell",
  "honorific": "story",
  "honoring": "sell",
  "honour": "story",
  "honourable": "beautiful",
  "honours": "story",
  "hooch": "taste",
  "hood": "build",
  "hoodmold": "build",
  "hoodmould": "build",
  "hoodoo": "build",
  "hoodooism": "smart",
  "hoodwink": "sell",
  "hooey": "story",
  "hoof": "heal",
  "hoof-mark": "story",
  "hoofed": "build",
  "hoofing": "build",
  "hoofprint": "story",
  "hook": "build",
  "hookah": "build",
  "hooking": "build",
  "hooknose": "heal",
  "hooks": "heal",
  "hookup": "build",
  "hookworm": "heal",
  "hoop": "build",
  "hoopla": "story",
  "hoopoe": "heal",
  "hoopoo": "heal",
  "hoops": "build",
  "hoopskirt": "build",
  "hooray": "story",
  "hoosegow": "build",
  "hoosgow": "build",
  "hoot": "story",
  "hootch": "taste",
  "hooter": "heal",
  "hooved": "beautiful",
  "hoover": "build",
  "hop": "heal",
  "hop-picker": "build",
  "hope": "smart",
  "hopeful": "beautiful",
  "hopeless": "beautiful",
  "hopi": "story",
  "hopper": "build",
  "hopple": "build",
  "hops": "heal",
  "hopsack": "build",
  "hopsacking": "build",
  "hordeum": "heal",
  "horehound": "heal",
  "horizontal": "beautiful",
  "hormone": "heal",
  "horn": "build",
  "hornbeam": "heal",
  "hornbill": "heal",
  "hornbook": "story",
  "horned": "build",
  "horneophyton": "heal",
  "hornet": "heal",
  "hornless": "beautiful",
  "hornpipe": "story",
  "hornpout": "heal",
  "hornswoggle": "sell",
  "hornwort": "heal",
  "horologe": "build",
  "horology": "smart",
  "horoscope": "story",
  "horoscopy": "smart",
  "horripilate": "sound",
  "horror": "story",
  "horse": "heal",
  "horse-brier": "heal",
  "horse-cart": "build",
  "horse-head": "heal",
  "horse-pistol": "build",
  "horse-trade": "story",
  "horse-trail": "build",
  "horseback": "heal",
  "horsebean": "heal",
  "horsebox": "build",
  "horsecar": "build",
  "horsecloth": "build",
  "horsefish": "heal",
  "horseflesh": "taste",
  "horsefly": "heal",
  "horsehair": "build",
  "horsehead": "heal",
  "horselaugh": "story",
  "horseleech": "heal",
  "horsemanship": "smart",
  "horsemeat": "taste",
  "horsemint": "heal",
  "horsepower": "smart",
  "horsepower-hour": "smart",
  "horseradish": "heal",
  "horseshit": "story",
  "horseshoe": "build",
  "horseshoes": "build",
  "horsetail": "heal",
  "horseweed": "heal",
  "horsewhip": "build",
  "horsewhipping": "build",
  "hortensia": "heal",
  "hosanna": "story",
  "hose": "build",
  "hosea": "story",
  "hosepipe": "build",
  "hosiery": "build",
  "hospice": "heal",
  "hospitable": "beautiful",
  "hospital": "heal",
  "hospitalise": "sell",
  "hospitality": "story",
  "hospitalization": "sell",
  "hospitalize": "sell",
  "host": "heal",
  "hosta": "heal",
  "hostaceae": "heal",
  "hostel": "build",
  "hostelry": "build",
  "hostile": "beautiful",
  "hot": "beautiful",
  "hot-rod": "build",
  "hot-work": "build",
  "hotbed": "build",
  "hotbox": "build",
  "hotcake": "taste",
  "hotchpotch": "taste",
  "hotdog": "taste",
  "hotei-chiku": "heal",
  "hotel": "build",
  "hotel-casino": "build",
  "hothouse": "build",
  "hotplate": "build",
  "hotpot": "taste",
  "hotspot": "build",
  "hottentot": "story",
  "hottonia": "heal",
  "houdah": "build",
  "houhere": "heal",
  "hoummos": "taste",
  "hound": "heal",
  "hound's-tongue": "heal",
  "hourglass": "build",
  "house": "build",
  "house-train": "smart",
  "houseboat": "build",
  "housebreak": "smart",
  "housebreaking": "smart",
  "houseclean": "build",
  "housecleaning": "build",
  "housecoat": "build",
  "housecraft": "smart",
  "housedog": "heal",
  "housefly": "heal",
  "houseful": "smart",
  "houselights": "build",
  "housepaint": "build",
  "houseplant": "heal",
  "houseroom": "smart",
  "housetop": "build",
  "housing": "build",
  "houttuynia": "heal",
  "houyhnhnms": "smart",
  "hovea": "heal",
  "hovel": "build",
  "hovercraft": "build",
  "how-do-you-do": "story",
  "howdah": "build",
  "howdy": "story",
  "howitzer": "build",
  "howl": "story",
  "howler": "story",
  "howling": "story",
  "hoy": "build",
  "hoya": "heal",
  "hryvnia": "smart",
  "hs1": "heal",
  "hs2": "heal",
  "hsv-1": "heal",
  "hsv-2": "heal",
  "hsv-i": "heal",
  "hsv-ii": "heal",
  "htlv-1": "heal",
  "html": "story",
  "http": "story",
  "hualapai": "story",
  "hualpai": "story",
  "huamachil": "heal",
  "huarache": "build",
  "huaraches": "build",
  "hub": "build",
  "hub-and-spoke": "build",
  "hubble-bubble": "build",
  "hubbly-bubbly": "build",
  "hubcap": "build",
  "huck": "build",
  "huckaback": "build",
  "huckleberry": "heal",
  "huckster": "sell",
  "huddle": "story",
  "hudsonia": "heal",
  "huff": "taste",
  "huffing": "taste",
  "hug": "build",
  "hug-me-tight": "build",
  "hugger-mugger": "beautiful",
  "hugging": "build",
  "hugueninia": "heal",
  "huisache": "heal",
  "huitre": "taste",
  "hula-hoop": "build",
  "hulk": "build",
  "hull": "heal",
  "hullo": "story",
  "hulsea": "heal",
  "hum": "story",
  "hum-vee": "build",
  "human": "heal",
  "humane": "beautiful",
  "humanism": "smart",
  "humanistic": "beautiful",
  "humanitarian": "beautiful",
  "humanitarianism": "smart",
  "humanities": "smart",
  "humanity": "heal",
  "humankind": "heal",
  "humanoid": "build",
  "humans": "heal",
  "humble": "beautiful",
  "humblebee": "heal",
  "humbug": "story",
  "humdrum": "beautiful",
  "humerus": "heal",
  "humidify": "sound",
  "humidity": "sound",
  "humification": "smart",
  "humming": "story",
  "hummingbird": "heal",
  "hummus": "taste",
  "humor": "story",
  "humoring": "story",
  "humorless": "beautiful",
  "humorous": "beautiful",
  "humour": "story",
  "humourless": "beautiful",
  "humourous": "beautiful",
  "humous": "taste",
  "hump": "build",
  "humpback": "heal",
  "humulin": "heal",
  "humulus": "heal",
  "humus": "taste",
  "humvee": "build",
  "hunch": "smart",
  "hundred": "smart",
  "hundredth": "smart",
  "hundredweight": "smart",
  "hungarian": "story",
  "hunger": "sound",
  "hungriness": "heal",
  "hungry": "taste",
  "hunker": "build",
  "hunkpapa": "story",
  "hunnemannia": "heal",
  "hunter": "build",
  "hupa": "story",
  "hurdle": "build",
  "hurdles": "build",
  "hurdy-gurdy": "build",
  "hurl": "build",
  "hurling": "build",
  "hurrah": "story",
  "hurricane": "sound",
  "hurried": "beautiful",
  "hurting": "sound",
  "hurtle": "build",
  "husband": "sell",
  "husbandly": "beautiful",
  "hush": "sound",
  "hushing": "sound",
  "hushpuppy": "taste",
  "husk": "heal",
  "husky": "heal",
  "hut": "build",
  "hutch": "build",
  "hutment": "build",
  "huxley": "heal",
  "hyacinth": "heal",
  "hyacinthaceae": "heal",
  "hyacinthoides": "heal",
  "hyaena": "heal",
  "hyaenidae": "heal",
  "hyaline": "beautiful",
  "hyaloid": "heal",
  "hyalophora": "heal",
  "hyaloplasm": "heal",
  "hyalosperma": "heal",
  "hyalospongiae": "heal",
  "hybanthus": "heal",
  "hybrid": "story",
  "hybridise": "build",
  "hybridize": "build",
  "hybridizing": "build",
  "hybridoma": "heal",
  "hydantoin": "build",
  "hydathode": "heal",
  "hydnaceae": "heal",
  "hydnocarpus": "heal",
  "hydnoraceae": "heal",
  "hydnum": "heal",
  "hydra": "smart",
  "hydralazine": "build",
  "hydrangea": "heal",
  "hydrangeaceae": "heal",
  "hydrant": "build",
  "hydrastis": "heal",
  "hydrated": "beautiful",
  "hydration": "smart",
  "hydraulics": "smart",
  "hydric": "beautiful",
  "hydrilla": "heal",
  "hydrobates": "heal",
  "hydrobatidae": "heal",
  "hydrocephalus": "heal",
  "hydrocephaly": "heal",
  "hydrocharidaceae": "heal",
  "hydrocharis": "heal",
  "hydrocharitaceae": "heal",
  "hydrochlorothiazide": "build",
  "hydrochoeridae": "heal",
  "hydrochoerus": "heal",
  "hydrocracking": "smart",
  "hydrodamalis": "heal",
  "hydrodiuril": "build",
  "hydrodynamics": "smart",
  "hydroelectricity": "sound",
  "hydroflumethiazide": "build",
  "hydrofoil": "build",
  "hydrogenation": "smart",
  "hydrography": "smart",
  "hydroid": "heal",
  "hydrokinetics": "smart",
  "hydrology": "smart",
  "hydrolysis": "smart",
  "hydromancy": "smart",
  "hydromantes": "heal",
  "hydromel": "taste",
  "hydrometer": "build",
  "hydromorphone": "build",
  "hydromyinae": "heal",
  "hydromys": "heal",
  "hydrophidae": "heal",
  "hydrophilic": "beautiful",
  "hydrophobic": "beautiful",
  "hydrophyllaceae": "heal",
  "hydrophyllum": "heal",
  "hydrophyte": "heal",
  "hydroplane": "build",
  "hydrostatics": "smart",
  "hydrous": "beautiful",
  "hydroxychloroquine": "build",
  "hydroxytetracycline": "build",
  "hydroxyzine": "build",
  "hydrozoa": "heal",
  "hydrozoan": "heal",
  "hyemoschus": "heal",
  "hyena": "heal",
  "hygiene": "smart",
  "hygienics": "smart",
  "hygienise": "build",
  "hygienize": "build",
  "hygrocybe": "heal",
  "hygrodeik": "build",
  "hygrometer": "build",
  "hygrophoraceae": "heal",
  "hygrophorus": "heal",
  "hygrophyte": "heal",
  "hygroscope": "build",
  "hygroton": "build",
  "hygrotrama": "heal",
  "hyla": "heal",
  "hylactophryne": "heal",
  "hylidae": "heal",
  "hylobates": "heal",
  "hylobatidae": "heal",
  "hylocereus": "heal",
  "hylocichla": "heal",
  "hylophylax": "heal",
  "hymen": "heal",
  "hymenaea": "heal",
  "hymenanthera": "heal",
  "hymeneal": "story",
  "hymeneals": "story",
  "hymenium": "heal",
  "hymenogastrales": "heal",
  "hymenomycetes": "heal",
  "hymenophyllaceae": "heal",
  "hymenophyllum": "heal",
  "hymenopter": "heal",
  "hymenoptera": "heal",
  "hymenopteran": "heal",
  "hymenopteron": "heal",
  "hymn": "story",
  "hymnal": "story",
  "hymnary": "story",
  "hymnbook": "story",
  "hynerpeton": "heal",
  "hyoid": "heal",
  "hyoscine": "build",
  "hyoscyamine": "build",
  "hyoscyamus": "heal",
  "hypallage": "story",
  "hypanthium": "heal",
  "hype": "story",
  "hypentelium": "heal",
  "hyperbaton": "story",
  "hyperbilirubinemia": "beautiful",
  "hyperbole": "story",
  "hyperbolic": "beautiful",
  "hyperbolise": "story",
  "hyperbolize": "story",
  "hypercatalectic": "story",
  "hypercoaster": "build",
  "hyperextend": "heal",
  "hyperhidrosis": "smart",
  "hypericaceae": "heal",
  "hypericales": "heal",
  "hypericum": "heal",
  "hyperidrosis": "smart",
  "hyperlink": "story",
  "hypermarket": "build",
  "hypermastigina": "heal",
  "hypermastigote": "heal",
  "hypermedia": "story",
  "hypermenorrhea": "smart",
  "hypernym": "story",
  "hyperoartia": "heal",
  "hyperodontidae": "heal",
  "hyperoglyphe": "heal",
  "hyperoodon": "heal",
  "hyperotreta": "heal",
  "hyperpiesia": "heal",
  "hyperpiesis": "heal",
  "hyperpigmentation": "beautiful",
  "hypersecretion": "smart",
  "hypersensitivity": "smart",
  "hyperstat": "build",
  "hypertensin": "build",
  "hypertensive": "beautiful",
  "hypertext": "story",
  "hyperthyroidism": "heal",
  "hypertonic": "beautiful",
  "hypertrophied": "heal",
  "hypertrophy": "heal",
  "hyperventilate": "heal",
  "hypha": "heal",
  "hyphantria": "heal",
  "hyphen": "story",
  "hyphenate": "build",
  "hypnotic": "build",
  "hypnotise": "heal",
  "hypnotize": "heal",
  "hypo": "build",
  "hypobasidium": "heal",
  "hypoblast": "heal",
  "hypochaeris": "heal",
  "hypochoeris": "heal",
  "hypochondria": "heal",
  "hypochondriac": "beautiful",
  "hypochondrium": "heal",
  "hypocorism": "story",
  "hypocreaceae": "heal",
  "hypocreales": "heal",
  "hypocrisy": "story",
  "hypoderma": "heal",
  "hypodermatidae": "heal",
  "hypodermic": "build",
  "hypodermis": "heal",
  "hypoglossal": "heal",
  "hypognathous": "beautiful",
  "hyponym": "story",
  "hypopachus": "heal",
  "hypophysis": "heal",
  "hypopigmentation": "beautiful",
  "hypopitys": "heal",
  "hypostasis": "smart",
  "hypostatise": "smart",
  "hypostatize": "smart",
  "hypotensive": "beautiful",
  "hypothalamus": "heal",
  "hypothecate": "story",
  "hypothesis": "story",
  "hypothesise": "smart",
  "hypothesize": "smart",
  "hypothetical": "smart",
  "hypotonic": "beautiful",
  "hypoxidaceae": "heal",
  "hypoxis": "heal",
  "hypozeugma": "story",
  "hypozeuxis": "story",
  "hypsiglena": "heal",
  "hypsiprymnodon": "heal",
  "hypsography": "smart",
  "hypsometer": "build",
  "hyracoidea": "heal",
  "hyracotherium": "heal",
  "hyrax": "heal",
  "hyson": "taste",
  "hyssop": "heal",
  "hyssopus": "heal",
  "hysteresis": "sound",
  "hysteric": "beautiful",
  "hysterosalpingogram": "build",
  "hystricidae": "heal",
  "hystricomorpha": "heal",
  "hytrin": "build",
  "i-beam": "build",
  "i.d.": "story",
  "i.e.d.": "build",
  "iamb": "story",
  "iambic": "story",
  "iambus": "story",
  "iberis": "heal",
  "ibero-mesornis": "heal",
  "ibex": "heal",
  "ibis": "heal",
  "ibuprofen": "build",
  "icaco": "heal",
  "icbm": "build",
  "ice": "sell",
  "ice-wagon": "build",
  "iceberg": "taste",
  "iceboat": "build",
  "icebox": "build",
  "icebreaker": "build",
  "icecream": "taste",
  "icehouse": "build",
  "icelandic": "story",
  "icepick": "build",
  "icetray": "build",
  "ichneumon": "heal",
  "ichneumonidae": "heal",
  "ichor": "heal",
  "ichthyology": "smart",
  "ichthyosaur": "heal",
  "ichthyosauria": "heal",
  "ichthyosauridae": "heal",
  "ichthyosaurus": "heal",
  "ichyostega": "heal",
  "icing": "smart",
  "icon": "story",
  "iconoclasm": "smart",
  "iconography": "build",
  "iconology": "smart",
  "iconoscope": "build",
  "ictalurus": "heal",
  "icteria": "heal",
  "icteridae": "heal",
  "icterus": "heal",
  "ictiobus": "heal",
  "ictodosaur": "heal",
  "ictodosauria": "heal",
  "ictonyx": "heal",
  "idea": "smart",
  "ideal": "smart",
  "idealisation": "smart",
  "idealise": "smart",
  "idealism": "smart",
  "idealistic": "beautiful",
  "idealization": "smart",
  "idealize": "smart",
  "ideate": "build",
  "ideation": "smart",
  "identical": "beautiful",
  "identifiable": "beautiful",
  "identification": "story",
  "identifier": "story",
  "identify": "smart",
  "identikit": "build",
  "identity": "smart",
  "ideogram": "story",
  "ideograph": "story",
  "ideography": "story",
  "ideological": "beautiful",
  "ideology": "smart",
  "idesia": "heal",
  "idiocy": "smart",
  "idiographic": "beautiful",
  "idiolect": "story",
  "idiom": "story",
  "idle": "build",
  "idler": "beautiful",
  "idling": "build",
  "ido": "story",
  "idol": "build",
  "idolatrous": "beautiful",
  "idp": "smart",
  "idyl": "story",
  "idyll": "story",
  "ied": "build",
  "igloo": "build",
  "iglu": "build",
  "igneous": "beautiful",
  "igniter": "build",
  "ignition": "smart",
  "ignitor": "build",
  "ignoble": "beautiful",
  "ignorance": "smart",
  "ignorantness": "smart",
  "ignore": "story",
  "iguana": "heal",
  "iguania": "heal",
  "iguanid": "heal",
  "iguanidae": "heal",
  "iguanodon": "heal",
  "iguanodontidae": "heal",
  "iii": "smart",
  "iis": "smart",
  "ijtihad": "story",
  "ikon": "build",
  "ilama": "heal",
  "ilang-ilang": "heal",
  "ileum": "heal",
  "ilex": "heal",
  "iliad": "story",
  "iliamna": "heal",
  "ilium": "heal",
  "ilk": "smart",
  "ill": "beautiful",
  "ill-advised": "beautiful",
  "ill-defined": "beautiful",
  "ill-formed": "beautiful",
  "ill-natured": "beautiful",
  "ill-smelling": "beautiful",
  "ill-treat": "sell",
  "ill-treated": "sell",
  "ill-use": "sell",
  "illation": "smart",
  "illative": "beautiful",
  "illecebrum": "heal",
  "illegal": "beautiful",
  "illegalise": "sell",
  "illegalize": "sell",
  "illegible": "beautiful",
  "illegitimate": "beautiful",
  "illicit": "beautiful",
  "illicium": "heal",
  "illinois": "story",
  "illiteracy": "smart",
  "illiterate": "beautiful",
  "illness": "heal",
  "illogical": "beautiful",
  "illuminate": "smart",
  "illuminating": "smart",
  "illumination": "story",
  "illusion": "smart",
  "illustrate": "story",
  "illustration": "beautiful",
  "illyrian": "story",
  "ilosone": "build",
  "image": "smart",
  "imagery": "beautiful",
  "imaginary": "smart",
  "imagination": "smart",
  "imaginativeness": "smart",
  "imagine": "build",
  "imaging": "smart",
  "imago": "smart",
  "imaret": "build",
  "imavate": "build",
  "imbalanced": "beautiful",
  "imbauba": "heal",
  "imbecile": "beautiful",
  "imbecility": "smart",
  "imbed": "build",
  "imbibe": "build",
  "imbibing": "build",
  "imbibition": "smart",
  "imbricate": "beautiful",
  "imbrication": "build",
  "imbroglio": "story",
  "imbue": "build",
  "imipramine": "build",
  "imitate": "build",
  "imitation": "smart",
  "imitative": "beautiful",
  "immanent": "beautiful",
  "immaterial": "beautiful",
  "immature": "beautiful",
  "immeasurable": "beautiful",
  "immediacy": "smart",
  "immediate": "beautiful",
  "immensurable": "beautiful",
  "immerse": "build",
  "immersion": "smart",
  "immingle": "build",
  "immiscible": "beautiful",
  "immobile": "beautiful",
  "immobilise": "sell",
  "immobilize": "sell",
  "immobilizing": "sell",
  "immoderate": "beautiful",
  "immodest": "beautiful",
  "immolate": "sell",
  "immoral": "beautiful",
  "immortal": "beautiful",
  "immortalise": "smart",
  "immortalize": "smart",
  "immortelle": "heal",
  "immovable": "sell",
  "immune": "beautiful",
  "immunise": "heal",
  "immunize": "heal",
  "immunoassay": "smart",
  "immunochemistry": "smart",
  "immunocompetent": "beautiful",
  "immunodeficiency": "heal",
  "immunodeficient": "beautiful",
  "immunoelectrophoresis": "smart",
  "immunofluorescence": "smart",
  "immunogen": "build",
  "immunologic": "heal",
  "immunological": "heal",
  "immunologist": "heal",
  "immunology": "heal",
  "immunopathology": "heal",
  "immunosuppressant": "build",
  "immunosuppressive": "build",
  "immunosuppressor": "build",
  "immure": "sell",
  "immutable": "beautiful",
  "impact": "sound",
  "impaired": "beautiful",
  "impala": "heal",
  "impale": "build",
  "impalpable": "beautiful",
  "impanel": "sell",
  "impart": "sell",
  "impartation": "story",
  "impartial": "beautiful",
  "impartiality": "smart",
  "imparting": "story",
  "impassable": "beautiful",
  "impasse": "build",
  "impasto": "beautiful",
  "impatient": "beautiful",
  "impeach": "story",
  "impeachment": "story",
  "impedance": "sound",
  "impede": "sell",
  "impediment": "smart",
  "impedimenta": "build",
  "impel": "build",
  "impeller": "build",
  "impenetrable": "beautiful",
  "impenitent": "beautiful",
  "imperative": "beautiful",
  "imperceptible": "beautiful",
  "imperfect": "beautiful",
  "imperfectibility": "smart",
  "imperial": "heal",
  "imperialism": "story",
  "imperishable": "beautiful",
  "impermanent": "beautiful",
  "impermeable": "beautiful",
  "impermissible": "beautiful",
  "impersonal": "beautiful",
  "impersonate": "build",
  "impersonation": "story",
  "impertinence": "story",
  "imperviable": "beautiful",
  "impervious": "beautiful",
  "impetus": "sound",
  "impinge": "sell",
  "impinging": "sell",
  "impious": "beautiful",
  "implacable": "beautiful",
  "implant": "build",
  "implantation": "smart",
  "implausible": "beautiful",
  "implement": "build",
  "implemented": "sell",
  "implication": "smart",
  "implicit": "beautiful",
  "implore": "story",
  "imploring": "story",
  "implosion": "story",
  "imply": "story",
  "impolite": "beautiful",
  "impolitic": "beautiful",
  "imponderable": "smart",
  "import": "build",
  "important": "beautiful",
  "importation": "build",
  "importing": "sell",
  "importune": "story",
  "importunity": "story",
  "impose": "sell",
  "imposition": "smart",
  "impossibility": "smart",
  "impossible": "smart",
  "impost": "sell",
  "impotent": "beautiful",
  "impound": "sell",
  "impounding": "sell",
  "impoverish": "sell",
  "impractical": "beautiful",
  "imprecate": "story",
  "imprecation": "story",
  "imprecise": "beautiful",
  "impregnate": "heal",
  "impregnation": "smart",
  "impress": "smart",
  "impressible": "beautiful",
  "impression": "smart",
  "impressionable": "beautiful",
  "impressionism": "build",
  "impressive": "beautiful",
  "imprimatur": "story",
  "imprint": "smart",
  "imprinting": "smart",
  "imprison": "sell",
  "improbable": "beautiful",
  "impromptu": "story",
  "improper": "beautiful",
  "improved": "beautiful",
  "improver": "build",
  "improvident": "beautiful",
  "improvisation": "beautiful",
  "improvise": "sound",
  "improvize": "build",
  "imprudent": "beautiful",
  "impudence": "story",
  "impugn": "story",
  "impulse-buy": "sell",
  "impulsion": "sound",
  "impure": "beautiful",
  "imputation": "story",
  "impute": "smart",
  "imuran": "build",
  "in-basket": "build",
  "in-joke": "story",
  "in-tray": "build",
  "inability": "smart",
  "inaccessible": "beautiful",
  "inaccurate": "beautiful",
  "inachis": "heal",
  "inactivation": "smart",
  "inactive": "beautiful",
  "inadequate": "beautiful",
  "inadmissible": "beautiful",
  "inadvertence": "smart",
  "inadvisable": "beautiful",
  "inaesthetic": "beautiful",
  "inalienable": "beautiful",
  "inalterable": "beautiful",
  "inanimate": "beautiful",
  "inappropriate": "beautiful",
  "inaptitude": "smart",
  "inarticulate": "beautiful",
  "inattention": "smart",
  "inattentive": "beautiful",
  "inattentiveness": "smart",
  "inaudible": "beautiful",
  "inaugural": "story",
  "inaugurate": "sell",
  "inauspicious": "beautiful",
  "inboard": "beautiful",
  "inbred": "beautiful",
  "incalculable": "beautiful",
  "incandescence": "sound",
  "incantation": "story",
  "incapability": "smart",
  "incapable": "beautiful",
  "incapableness": "smart",
  "incapacitate": "heal",
  "incapacity": "smart",
  "incarcerate": "sell",
  "incarnate": "build",
  "incarnation": "story",
  "incase": "build",
  "incautious": "beautiful",
  "incendiary": "build",
  "incense": "smart",
  "incentive": "sell",
  "incertain": "beautiful",
  "incertitude": "smart",
  "inch": "smart",
  "inchoative": "beautiful",
  "inchworm": "heal",
  "incidence": "sound",
  "incident": "beautiful",
  "incidental": "sell",
  "incienso": "heal",
  "incinerator": "build",
  "incise": "build",
  "incisor": "heal",
  "incite": "build",
  "incitement": "story",
  "inclement": "beautiful",
  "inclination": "smart",
  "incline": "build",
  "inclined": "sound",
  "inclining": "sound",
  "inclinometer": "build",
  "inclose": "build",
  "inclosure": "story",
  "include": "smart",
  "inclusive": "beautiful",
  "incognizance": "smart",
  "incognizant": "beautiful",
  "incoherence": "story",
  "incoherency": "story",
  "incoherent": "beautiful",
  "incombustible": "beautiful",
  "income": "sell",
  "incoming": "beautiful",
  "incommensurate": "beautiful",
  "incommode": "sell",
  "incommodious": "beautiful",
  "incommunicative": "beautiful",
  "incommutable": "beautiful",
  "incomparable": "beautiful",
  "incompatibility": "heal",
  "incompatible": "beautiful",
  "incompetent": "beautiful",
  "incomplete": "beautiful",
  "incomprehensible": "beautiful",
  "incomprehension": "smart",
  "incomprehensive": "beautiful",
  "incompressible": "beautiful",
  "inconclusive": "beautiful",
  "incongruent": "beautiful",
  "incongruous": "beautiful",
  "inconsiderable": "beautiful",
  "inconsiderate": "beautiful",
  "inconsistent": "beautiful",
  "inconsolable": "beautiful",
  "inconspicuous": "beautiful",
  "inconstant": "beautiful",
  "incontestable": "beautiful",
  "incontestible": "beautiful",
  "incontinence": "smart",
  "incontinency": "smart",
  "incontinent": "beautiful",
  "inconvenience": "sell",
  "inconvenient": "beautiful",
  "inconvertible": "beautiful",
  "incoordination": "smart",
  "incorporate": "sell",
  "incorporation": "smart",
  "incorporeal": "beautiful",
  "incorrect": "beautiful",
  "incorrigible": "beautiful",
  "incorrupt": "beautiful",
  "increase": "smart",
  "increased": "beautiful",
  "increasing": "beautiful",
  "incredible": "beautiful",
  "incredulity": "smart",
  "incredulous": "beautiful",
  "increment": "smart",
  "incriminate": "story",
  "incrimination": "story",
  "incrust": "build",
  "incrustation": "smart",
  "incubate": "heal",
  "incubation": "smart",
  "incubator": "build",
  "inculcate": "smart",
  "inculpation": "story",
  "inculpative": "beautiful",
  "inculpatory": "beautiful",
  "incumbent": "beautiful",
  "incumbrance": "sell",
  "incurable": "beautiful",
  "incurious": "beautiful",
  "incurvate": "build",
  "incus": "heal",
  "indapamide": "build",
  "indecent": "beautiful",
  "indecision": "smart",
  "indecisive": "beautiful",
  "indecisiveness": "smart",
  "indecorous": "beautiful",
  "indefeasible": "beautiful",
  "indefinite": "beautiful",
  "indehiscent": "beautiful",
  "indelicate": "beautiful",
  "indemnification": "sell",
  "indemnify": "sell",
  "indemnity": "sell",
  "indent": "story",
  "indentation": "smart",
  "indention": "story",
  "indenture": "story",
  "independent": "beautiful",
  "inderal": "build",
  "indestructible": "beautiful",
  "indeterminable": "beautiful",
  "indeterminate": "beautiful",
  "index": "story",
  "indexing": "sell",
  "indiaman": "build",
  "indian": "story",
  "indic": "story",
  "indicant": "story",
  "indicate": "story",
  "indication": "story",
  "indicative": "beautiful",
  "indicator": "story",
  "indicatoridae": "heal",
  "indict": "sell",
  "indictment": "story",
  "indie": "beautiful",
  "indigestible": "beautiful",
  "indigo": "heal",
  "indigofera": "heal",
  "indinavir": "build",
  "indirect": "beautiful",
  "indiscernible": "beautiful",
  "indiscreet": "beautiful",
  "indiscreetness": "smart",
  "indiscriminate": "beautiful",
  "indiscriminating": "beautiful",
  "indispensable": "beautiful",
  "indispose": "smart",
  "indissoluble": "beautiful",
  "indistinct": "beautiful",
  "indistinguishable": "beautiful",
  "indite": "build",
  "individual": "beautiful",
  "individualisation": "smart",
  "individualise": "smart",
  "individualism": "smart",
  "individualist": "beautiful",
  "individualization": "smart",
  "individualize": "smart",
  "individuation": "smart",
  "indivisible": "beautiful",
  "indo-aryan": "story",
  "indo-european": "story",
  "indo-hittite": "story",
  "indo-iranian": "story",
  "indocin": "build",
  "indoctrinate": "smart",
  "indomethacin": "build",
  "indonesian": "story",
  "indoor": "beautiful",
  "indorse": "sell",
  "indorsement": "story",
  "indri": "heal",
  "indriidae": "heal",
  "indris": "heal",
  "induce": "build",
  "induced": "build",
  "inducing": "build",
  "induct": "sell",
  "inductance": "sound",
  "induction": "sound",
  "inductive": "beautiful",
  "inductor": "build",
  "indue": "sell",
  "indulge": "sell",
  "indulgent": "beautiful",
  "indulging": "sell",
  "induration": "heal",
  "indusium": "heal",
  "industrial": "beautiful",
  "indweller": "smart",
  "inebriant": "taste",
  "inebriate": "taste",
  "inebriated": "taste",
  "inebriation": "sound",
  "inebriety": "sound",
  "inedible": "beautiful",
  "ineffective": "beautiful",
  "ineffectual": "beautiful",
  "inefficacious": "beautiful",
  "inefficiency": "smart",
  "inefficient": "beautiful",
  "inelastic": "beautiful",
  "inelegant": "beautiful",
  "ineligible": "beautiful",
  "ineptitude": "smart",
  "ineptness": "smart",
  "inequitable": "beautiful",
  "ineradicable": "beautiful",
  "inertia": "sound",
  "inessential": "beautiful",
  "inevitable": "beautiful",
  "inexact": "beautiful",
  "inexcusable": "beautiful",
  "inexhaustible": "beautiful",
  "inexpedient": "beautiful",
  "inexpensive": "beautiful",
  "inexperience": "smart",
  "inexperienced": "beautiful",
  "inexperient": "beautiful",
  "inexplicable": "beautiful",
  "inexplicit": "beautiful",
  "inexpressible": "beautiful",
  "inextensible": "beautiful",
  "inextinguishable": "beautiful",
  "inextricable": "beautiful",
  "infallible": "beautiful",
  "infant's-breath": "heal",
  "infantile": "beautiful",
  "infatuation": "smart",
  "infect": "heal",
  "infected": "heal",
  "infection": "heal",
  "infectious": "beautiful",
  "infelicitous": "beautiful",
  "infer": "smart",
  "inference": "smart",
  "inferential": "beautiful",
  "inferior": "story",
  "infernal": "beautiful",
  "inferno": "smart",
  "infertile": "beautiful",
  "infield": "build",
  "infiltrate": "sell",
  "infiltration": "smart",
  "infinite": "beautiful",
  "infinitesimal": "smart",
  "infinitive": "story",
  "infinitude": "smart",
  "infirmary": "build",
  "infix": "story",
  "inflame": "heal",
  "inflaming": "heal",
  "inflater": "build",
  "inflation": "sell",
  "inflationary": "beautiful",
  "inflator": "build",
  "inflect": "story",
  "inflected": "story",
  "inflection": "story",
  "inflectional": "beautiful",
  "inflexible": "beautiful",
  "inflict": "story",
  "infliction": "smart",
  "infliximab": "build",
  "inflorescence": "smart",
  "inflow": "smart",
  "influence": "smart",
  "influential": "beautiful",
  "influx": "smart",
  "info": "story",
  "infolding": "smart",
  "infomercial": "story",
  "inform": "story",
  "informal": "beautiful",
  "informatics": "smart",
  "information": "story",
  "informative": "beautiful",
  "informatory": "beautiful",
  "informed": "story",
  "informercial": "story",
  "informing": "story",
  "infotainment": "story",
  "infract": "sell",
  "infrared": "sound",
  "infrastructure": "build",
  "infrequent": "beautiful",
  "infrigidation": "smart",
  "infringe": "sell",
  "infructescence": "smart",
  "infundibulum": "heal",
  "infuse": "smart",
  "infusion": "smart",
  "infusoria": "heal",
  "infusorian": "heal",
  "inga": "heal",
  "ingathering": "story",
  "ingeminate": "story",
  "ingeniousness": "smart",
  "ingenue": "smart",
  "ingenuity": "smart",
  "ingenuous": "beautiful",
  "ingest": "taste",
  "ingesta": "taste",
  "inglenook": "build",
  "inglorious": "beautiful",
  "ingot": "build",
  "ingraft": "build",
  "ingrain": "build",
  "ingraining": "build",
  "ingredient": "taste",
  "ingrian": "story",
  "inguen": "heal",
  "ingurgitate": "taste",
  "inh": "build",
  "inhabited": "beautiful",
  "inhalant": "build",
  "inhalation": "build",
  "inhalator": "build",
  "inhale": "taste",
  "inhaler": "build",
  "inharmonious": "beautiful",
  "inherit": "sell",
  "inheritable": "beautiful",
  "inheritance": "sell",
  "inhibit": "sell",
  "inhibited": "sell",
  "inhibition": "smart",
  "inhospitable": "beautiful",
  "inhospitality": "story",
  "inhumane": "beautiful",
  "inhume": "sell",
  "inhumed": "sell",
  "inion": "heal",
  "initial": "story",
  "initialisation": "story",
  "initialise": "smart",
  "initialization": "story",
  "initialize": "smart",
  "initiate": "build",
  "initiative": "beautiful",
  "inject": "heal",
  "injectable": "beautiful",
  "injector": "build",
  "injudiciousness": "smart",
  "injunction": "story",
  "injure": "heal",
  "injured": "heal",
  "ink": "beautiful",
  "inkberry": "heal",
  "inkle": "build",
  "inkling": "smart",
  "inkpad": "build",
  "inkpot": "build",
  "inkstand": "build",
  "inkwell": "build",
  "inland": "beautiful",
  "inlay": "build",
  "inlet": "build",
  "inmarry": "sell",
  "inn": "build",
  "innards": "heal",
  "innate": "beautiful",
  "inner": "beautiful",
  "innersole": "build",
  "innervate": "sell",
  "innocense": "heal",
  "innocent": "beautiful",
  "innocuous": "beautiful",
  "innovate": "build",
  "innovation": "build",
  "innovativeness": "smart",
  "innuendo": "story",
  "innumerate": "beautiful",
  "inocor": "build",
  "inoculate": "story",
  "inoculating": "story",
  "inodorous": "beautiful",
  "inoffensive": "beautiful",
  "inoperable": "beautiful",
  "inoperative": "beautiful",
  "inopportune": "beautiful",
  "inorganic": "beautiful",
  "inosculate": "build",
  "inosculation": "heal",
  "inosine": "sound",
  "inpour": "smart",
  "inpouring": "smart",
  "input": "story",
  "inquire": "story",
  "inquiring": "story",
  "inquiry": "smart",
  "inquisition": "story",
  "inquisitiveness": "smart",
  "inquisitorial": "beautiful",
  "inrush": "smart",
  "ins": "smart",
  "insane": "beautiful",
  "insanitary": "beautiful",
  "insatiable": "beautiful",
  "insatiate": "beautiful",
  "inscribe": "build",
  "inscription": "story",
  "insect": "heal",
  "insecta": "heal",
  "insectivora": "heal",
  "insectivore": "heal",
  "insectivorous": "beautiful",
  "insecure": "beautiful",
  "inseminate": "build",
  "insensate": "beautiful",
  "insensibility": "smart",
  "insensible": "beautiful",
  "insensitive": "beautiful",
  "insentient": "beautiful",
  "insert": "story",
  "insertion": "story",
  "insessores": "heal",
  "inset": "build",
  "inshore": "beautiful",
  "inside": "beautiful",
  "insight": "smart",
  "insightfulness": "smart",
  "insignia": "story",
  "insignificant": "beautiful",
  "insincere": "beautiful",
  "insinuate": "story",
  "insinuation": "story",
  "insist": "story",
  "insistence": "story",
  "insisting": "story",
  "insobriety": "sound",
  "insolate": "sound",
  "insolation": "sound",
  "insole": "build",
  "insoluble": "beautiful",
  "insolvent": "beautiful",
  "insomniac": "beautiful",
  "inspan": "build",
  "inspect": "sound",
  "inspiration": "smart",
  "inspire": "build",
  "inspiring": "build",
  "inspissation": "smart",
  "instal": "build",
  "install": "build",
  "installation": "beautiful",
  "installing": "build",
  "installment": "sell",
  "instalment": "story",
  "instance": "smart",
  "instant": "beautiful",
  "instantiate": "sound",
  "instantiation": "smart",
  "instar": "heal",
  "instep": "heal",
  "instigate": "story",
  "instigation": "story",
  "instil": "build",
  "instill": "sell",
  "instillator": "build",
  "instilling": "sell",
  "instinct": "smart",
  "institute": "build",
  "institution": "build",
  "institutional": "beautiful",
  "institutionalise": "sell",
  "institutionalised": "sell",
  "institutionalize": "sell",
  "institutionalized": "sell",
  "instruct": "story",
  "instruction": "story",
  "instructions": "story",
  "instructive": "beautiful",
  "instrument": "build",
  "instrumental": "beautiful",
  "instrumentalism": "smart",
  "instrumentality": "build",
  "instrumentate": "build",
  "instrumentation": "build",
  "insubordinate": "beautiful",
  "insubstantial": "beautiful",
  "insufficiency": "heal",
  "insufficient": "beautiful",
  "insufflate": "sell",
  "insufflation": "smart",
  "insular": "beautiful",
  "insulin": "heal",
  "insult": "story",
  "insurance": "sell",
  "insure": "smart",
  "insured": "smart",
  "insurgent": "beautiful",
  "insurmountable": "beautiful",
  "insurrectionism": "smart",
  "insusceptible": "beautiful",
  "intaglio": "story",
  "intake": "build",
  "intangible": "sell",
  "integer": "smart",
  "integral": "smart",
  "integrate": "sell",
  "integrated": "sell",
  "integrating": "sell",
  "integrative": "beautiful",
  "integrator": "build",
  "integument": "heal",
  "intellect": "smart",
  "intellection": "smart",
  "intellectual": "beautiful",
  "intellectualisation": "smart",
  "intellectualization": "smart",
  "intelligence": "smart",
  "intelligent": "beautiful",
  "intelligible": "beautiful",
  "intelnet": "build",
  "intemperate": "beautiful",
  "intend": "smart",
  "intended": "smart",
  "intense": "beautiful",
  "intensifier": "story",
  "intension": "story",
  "intensity": "sound",
  "intensive": "story",
  "intent": "smart",
  "intention": "smart",
  "intentional": "beautiful",
  "inter": "sell",
  "interact": "sell",
  "interaction": "sound",
  "interactive": "beautiful",
  "interbrain": "heal",
  "interbreed": "build",
  "interbreeding": "build",
  "intercede": "story",
  "intercept": "smart",
  "interceptor": "build",
  "intercession": "story",
  "interchange": "build",
  "intercom": "build",
  "intercommunicate": "story",
  "intercommunication": "story",
  "interconnect": "build",
  "intercontinental": "beautiful",
  "intercostal": "heal",
  "intercourse": "story",
  "interdict": "story",
  "interdiction": "story",
  "interest": "smart",
  "interested": "beautiful",
  "interestedness": "smart",
  "interesting": "beautiful",
  "interface": "build",
  "interfere": "sell",
  "interference": "story",
  "interferometer": "build",
  "interferon": "build",
  "interim": "beautiful",
  "interior": "beautiful",
  "interiorise": "smart",
  "interiorize": "smart",
  "interject": "story",
  "interjection": "story",
  "interlace": "build",
  "interlanguage": "story",
  "interlayer": "build",
  "interleaf": "story",
  "interleave": "sell",
  "interlingua": "story",
  "interlink": "build",
  "interlock": "build",
  "interlocking": "build",
  "interlope": "sell",
  "interlude": "build",
  "intermarry": "sell",
  "intermediate": "story",
  "intermezzo": "story",
  "intermingle": "build",
  "intermission": "sound",
  "intermit": "story",
  "intermix": "build",
  "intermixture": "taste",
  "intern": "sell",
  "internal": "beautiful",
  "internalisation": "smart",
  "internalise": "smart",
  "internalization": "smart",
  "internalize": "smart",
  "international": "beautiful",
  "internationale": "story",
  "internationalise": "sell",
  "internationalism": "smart",
  "internationalist": "beautiful",
  "internationalize": "sell",
  "internet": "smart",
  "internode": "heal",
  "interoception": "smart",
  "interoceptor": "heal",
  "interpellate": "story",
  "interpellation": "story",
  "interpenetrate": "build",
  "interphone": "build",
  "interpolate": "smart",
  "interpolation": "smart",
  "interpose": "story",
  "interpret": "smart",
  "interpretation": "smart",
  "interpreter": "smart",
  "interpreting": "smart",
  "interred": "sell",
  "interreflection": "sound",
  "interrelate": "smart",
  "interrogate": "story",
  "interrogation": "story",
  "interrogative": "story",
  "interrogatory": "story",
  "interrupt": "sound",
  "interrupter": "build",
  "interruption": "sound",
  "intersection": "smart",
  "interspecies": "beautiful",
  "interspecific": "beautiful",
  "intersperse": "build",
  "interstate": "build",
  "interstice": "heal",
  "intertwine": "build",
  "interval": "smart",
  "intervene": "sell",
  "intervention": "story",
  "interview": "story",
  "interweave": "build",
  "intestate": "beautiful",
  "intestine": "heal",
  "inti": "smart",
  "intima": "heal",
  "intimate": "story",
  "intimation": "story",
  "intimidation": "story",
  "intolerable": "beautiful",
  "intolerance": "smart",
  "intolerant": "beautiful",
  "intonate": "story",
  "intonation": "story",
  "intone": "story",
  "intoxicant": "taste",
  "intoxicate": "taste",
  "intoxicated": "taste",
  "intoxication": "sound",
  "intractable": "beautiful",
  "intramural": "beautiful",
  "intranet": "build",
  "intransitive": "story",
  "intraspecies": "beautiful",
  "intraspecific": "beautiful",
  "intrastate": "beautiful",
  "intrench": "build",
  "intrenchment": "build",
  "intrigue": "smart",
  "intrinsic": "beautiful",
  "intrinsical": "beautiful",
  "intro": "story",
  "introduce": "story",
  "introduction": "story",
  "introit": "story",
  "introitus": "heal",
  "introject": "smart",
  "introjection": "smart",
  "intromit": "sell",
  "introspect": "smart",
  "introspection": "smart",
  "introspective": "beautiful",
  "introversion": "smart",
  "introversive": "beautiful",
  "introvert": "build",
  "introverted": "build",
  "introvertive": "beautiful",
  "intrude": "sell",
  "intrusion": "smart",
  "intrusive": "beautiful",
  "intrust": "sell",
  "intubate": "build",
  "intuit": "smart",
  "intuition": "smart",
  "intuitionism": "smart",
  "intumescence": "smart",
  "intumescency": "smart",
  "intussuscept": "build",
  "intussusception": "smart",
  "inula": "heal",
  "inunct": "heal",
  "inundate": "build",
  "inundation": "sound",
  "invade": "build",
  "invaginate": "build",
  "invagination": "smart",
  "invalid": "sell",
  "invalidate": "sell",
  "invariable": "smart",
  "invariant": "smart",
  "invasion": "heal",
  "invasive": "beautiful",
  "invective": "story",
  "inveigh": "story",
  "inveigle": "story",
  "invent": "build",
  "invention": "smart",
  "inventiveness": "smart",
  "inventory": "story",
  "inventorying": "sell",
  "inverse": "beautiful",
  "inversion": "sound",
  "invertebrate": "heal",
  "inverted": "beautiful",
  "inverter": "build",
  "invertible": "beautiful",
  "invest": "sell",
  "investigate": "story",
  "investigating": "story",
  "investigation": "smart",
  "investing": "sell",
  "investment": "sell",
  "invigilate": "sell",
  "invigorate": "heal",
  "invigorating": "heal",
  "inviolable": "beautiful",
  "invirase": "build",
  "invisible": "beautiful",
  "invitation": "story",
  "invite": "story",
  "inviting": "sell",
  "invocation": "story",
  "invoice": "sell",
  "invoke": "build",
  "involucre": "heal",
  "involuntary": "beautiful",
  "involution": "smart",
  "involvement": "smart",
  "invulnerable": "beautiful",
  "inward": "beautiful",
  "inwardness": "smart",
  "inweave": "build",
  "iodinating": "beautiful",
  "iodination": "smart",
  "iodine": "build",
  "iodine-131": "heal",
  "iodise": "heal",
  "iodised": "heal",
  "iodize": "heal",
  "iodized": "heal",
  "iodochlorhydroxyquin": "build",
  "iodoform": "build",
  "iodopsin": "beautiful",
  "iol": "build",
  "ionic": "story",
  "ionisation": "smart",
  "ionised": "beautiful",
  "ionization": "smart",
  "ionized": "beautiful",
  "ionophoresis": "smart",
  "iop": "sound",
  "iota": "smart",
  "iou": "sell",
  "iowa": "story",
  "ioway": "story",
  "ipecac": "build",
  "ipidae": "heal",
  "ipod": "build",
  "ipomoea": "heal",
  "iproclozide": "build",
  "ipsedixitism": "story",
  "ipsilateral": "beautiful",
  "ipv": "build",
  "ira": "smart",
  "iranian": "story",
  "irena": "heal",
  "irenidae": "heal",
  "iresine": "heal",
  "iridaceae": "heal",
  "iridoprocne": "heal",
  "iris": "heal",
  "irish": "taste",
  "iron": "build",
  "iron-gray": "beautiful",
  "iron-grey": "beautiful",
  "iron-tree": "heal",
  "ironclad": "build",
  "ironed": "build",
  "ironing": "build",
  "ironmonger": "build",
  "ironmongery": "build",
  "irons": "build",
  "ironware": "build",
  "ironweed": "heal",
  "ironwood": "heal",
  "ironwork": "build",
  "ironworks": "build",
  "irony": "story",
  "iroquoian": "story",
  "iroquois": "story",
  "irradiate": "story",
  "irradiation": "sound",
  "irrational": "smart",
  "irreconcilable": "beautiful",
  "irrecoverable": "beautiful",
  "irredentism": "smart",
  "irreducible": "beautiful",
  "irregular": "build",
  "irrelevant": "beautiful",
  "irreligious": "beautiful",
  "irremediable": "beautiful",
  "irremovable": "beautiful",
  "irreparable": "beautiful",
  "irreplaceable": "beautiful",
  "irreproducible": "beautiful",
  "irresistible": "beautiful",
  "irresolute": "beautiful",
  "irresolution": "smart",
  "irresponsible": "beautiful",
  "irreverence": "smart",
  "irreverent": "beautiful",
  "irreversible": "beautiful",
  "irrevocable": "beautiful",
  "irrevokable": "beautiful",
  "irridentism": "smart",
  "irrigate": "heal",
  "irritability": "smart",
  "irritant": "smart",
  "irritate": "heal",
  "irritation": "heal",
  "irruption": "smart",
  "irula": "story",
  "irvingia": "heal",
  "isaiah": "story",
  "isatis": "heal",
  "ischia": "heal",
  "ischigualastia": "heal",
  "ischium": "heal",
  "islam": "smart",
  "islamism": "smart",
  "islamophobia": "smart",
  "island": "build",
  "islay": "heal",
  "ism": "smart",
  "ismailism": "smart",
  "isoagglutination": "smart",
  "isocarboxazid": "build",
  "isoclinal": "beautiful",
  "isoetaceae": "heal",
  "isoetales": "heal",
  "isoetes": "heal",
  "isoflurane": "build",
  "isogamete": "heal",
  "isogamy": "smart",
  "isolate": "smart",
  "isolation": "smart",
  "isolationism": "story",
  "isometric": "story",
  "isometrics": "story",
  "isoniazid": "build",
  "isopod": "heal",
  "isopoda": "heal",
  "isoproterenol": "build",
  "isoptera": "heal",
  "isoptin": "build",
  "isopyrum": "heal",
  "isordil": "build",
  "isosmotic": "beautiful",
  "isosorbide": "build",
  "isospondyli": "heal",
  "isotonic": "beautiful",
  "isotropic": "beautiful",
  "isotropous": "beautiful",
  "issue": "smart",
  "issuing": "story",
  "isthmus": "heal",
  "istiophoridae": "heal",
  "istiophorus": "heal",
  "isuprel": "build",
  "isuridae": "heal",
  "isurus": "heal",
  "italian": "story",
  "italic": "story",
  "italicise": "build",
  "italicize": "build",
  "itch": "smart",
  "itchiness": "smart",
  "itching": "smart",
  "item": "story",
  "itemise": "story",
  "itemize": "story",
  "iterate": "story",
  "iteration": "smart",
  "iterative": "beautiful",
  "itinerant": "beautiful",
  "itinerary": "story",
  "itraconazole": "build",
  "iud": "build",
  "iva": "heal",
  "ives": "sound",
  "ivorybill": "heal",
  "ivp": "build",
  "ivy": "heal",
  "ixia": "heal",
  "ixobrychus": "heal",
  "ixodes": "heal",
  "ixodid": "heal",
  "ixodidae": "heal",
  "izar": "build",
  "izzard": "story",
  "jab": "build",
  "jabber": "story",
  "jabbering": "story",
  "jabberwocky": "story",
  "jabbing": "build",
  "jabiru": "heal",
  "jaboncillo": "heal",
  "jabot": "build",
  "jaboticaba": "heal",
  "jacamar": "heal",
  "jacaranda": "heal",
  "jack": "smart",
  "jack-a-lantern": "heal",
  "jack-by-the-hedge": "heal",
  "jack-in-the-box": "build",
  "jack-in-the-pulpit": "heal",
  "jack-o'-lantern": "sound",
  "jack-o-lantern": "heal",
  "jackal": "heal",
  "jackass": "heal",
  "jackboot": "build",
  "jackdaw": "heal",
  "jacket": "build",
  "jackfruit": "heal",
  "jackhammer": "build",
  "jackknife": "build",
  "jackknife-fish": "heal",
  "jacklight": "build",
  "jackpot": "sell",
  "jackrabbit": "heal",
  "jacks": "smart",
  "jackscrew": "build",
  "jacksmelt": "heal",
  "jacksnipe": "heal",
  "jacksonia": "heal",
  "jackstones": "build",
  "jackstraw": "build",
  "jackstraws": "build",
  "jacobinism": "smart",
  "jaconet": "build",
  "jacquard": "build",
  "jacquinia": "heal",
  "jactation": "heal",
  "jactitation": "story",
  "jaculus": "heal",
  "jade": "heal",
  "jaeger": "heal",
  "jag": "build",
  "jagatai": "story",
  "jaghatai": "story",
  "jagua": "heal",
  "jaguar": "heal",
  "jaguarondi": "heal",
  "jaguarundi": "heal",
  "jail": "build",
  "jailhouse": "build",
  "jainism": "smart",
  "jak": "taste",
  "jakes": "build",
  "jalapeno": "heal",
  "jalopy": "build",
  "jalousie": "build",
  "jam": "taste",
  "jamb": "build",
  "jambalaya": "taste",
  "jambeau": "build",
  "jamberry": "heal",
  "jambon": "taste",
  "jambos": "heal",
  "jambosa": "heal",
  "jamesonia": "heal",
  "jamjar": "build",
  "jammer": "build",
  "jammies": "build",
  "jamming": "sound",
  "jampack": "build",
  "jampan": "build",
  "jampot": "build",
  "jangle": "sound",
  "jansenism": "smart",
  "japan": "build",
  "japanese": "story",
  "jape": "story",
  "japonica": "heal",
  "jar": "build",
  "jarful": "smart",
  "jargon": "story",
  "jasmine": "heal",
  "jasminum": "heal",
  "jassid": "heal",
  "jassidae": "heal",
  "jatropha": "heal",
  "jaundice": "heal",
  "java": "taste",
  "javanese": "story",
  "javanthropus": "heal",
  "javelin": "build",
  "javelina": "heal",
  "jaw": "heal",
  "jawbone": "heal",
  "jawbreaker": "taste",
  "jawed": "story",
  "jawfish": "heal",
  "jawless": "beautiful",
  "jay": "heal",
  "jaybird": "heal",
  "jazz": "sound",
  "jdam": "build",
  "jealousy": "smart",
  "jean": "build",
  "jeep": "build",
  "jeer": "story",
  "jeering": "story",
  "jejunum": "heal",
  "jell-o": "taste",
  "jellaba": "build",
  "jello": "taste",
  "jelly": "taste",
  "jellyfish": "heal",
  "jellyleaf": "heal",
  "jellyroll": "taste",
  "jemmy": "build",
  "jennet": "heal",
  "jenny": "heal",
  "jeopardize": "sell",
  "jerboa": "heal",
  "jeremiad": "story",
  "jeremiah": "story",
  "jerk": "taste",
  "jerkin": "build",
  "jerking": "build",
  "jerky": "taste",
  "jeroboam": "build",
  "jersey": "build",
  "jessamine": "heal",
  "jest": "story",
  "jesuitism": "smart",
  "jesuitry": "smart",
  "jet": "build",
  "jetliner": "build",
  "jetsam": "build",
  "jettison": "sell",
  "jetty": "build",
  "jew's-ear": "heal",
  "jew's-ears": "heal",
  "jew-bush": "heal",
  "jewbush": "heal",
  "jewel": "build",
  "jewellery": "build",
  "jewelry": "beautiful",
  "jewels-of-opar": "heal",
  "jewelweed": "heal",
  "jewfish": "heal",
  "jiao": "smart",
  "jib": "build",
  "jibboom": "build",
  "jibe": "story",
  "jig": "story",
  "jigger": "build",
  "jiggermast": "build",
  "jiggery-pokery": "story",
  "jigsaw": "build",
  "jillion": "smart",
  "jilt": "smart",
  "jimdandy": "build",
  "jimhickey": "build",
  "jimmies": "taste",
  "jimmy": "build",
  "jimsonweed": "heal",
  "jinghpaw": "story",
  "jinghpo": "story",
  "jingle": "story",
  "jingle-jangle": "sound",
  "jingoism": "story",
  "jinrikisha": "build",
  "jinx": "story",
  "jiqui": "heal",
  "jird": "heal",
  "jirrbal": "story",
  "jitney": "build",
  "jittery": "beautiful",
  "jive": "story",
  "jnd": "smart",
  "job": "build",
  "jobcentre": "build",
  "jock": "build",
  "jockstrap": "build",
  "jocosity": "story",
  "jocote": "heal",
  "jocularity": "story",
  "jodhpur": "build",
  "jodhpurs": "build",
  "joel": "story",
  "joewood": "heal",
  "joggle": "build",
  "john": "build",
  "johnny-jump-up": "heal",
  "johnnycake": "taste",
  "johns": "build",
  "join": "sell",
  "joiner": "build",
  "joinery": "build",
  "joining": "sell",
  "joint": "heal",
  "jointer": "build",
  "jointure": "sell",
  "jointworm": "heal",
  "joist": "build",
  "joke": "story",
  "joker": "story",
  "joliot": "sound",
  "joliot-curie": "sound",
  "jollify": "sell",
  "jolly": "build",
  "jolting": "beautiful",
  "jolty": "beautiful",
  "jonah": "story",
  "jonathan": "taste",
  "jonquil": "heal",
  "jook": "taste",
  "jordanella": "heal",
  "jorum": "build",
  "josh": "story",
  "joshua": "story",
  "joss": "build",
  "josue": "story",
  "jot": "story",
  "jotter": "story",
  "jotting": "story",
  "joule": "smart",
  "journal": "story",
  "journalese": "story",
  "journalism": "story",
  "jowl": "heal",
  "joy": "smart",
  "joyful": "beautiful",
  "joyless": "beautiful",
  "joyous": "beautiful",
  "joystick": "build",
  "jubilate": "sell",
  "jubilation": "story",
  "judaism": "smart",
  "judas": "build",
  "jude": "story",
  "judeo-spanish": "story",
  "judge": "smart",
  "judgement": "story",
  "judges": "story",
  "judging": "smart",
  "judgment": "smart",
  "judgmental": "beautiful",
  "judicial": "beautiful",
  "judiciousness": "smart",
  "judith": "story",
  "jug": "build",
  "jugale": "heal",
  "jugful": "smart",
  "juggernaut": "build",
  "juggle": "sell",
  "juggling": "sell",
  "juglandaceae": "heal",
  "juglandales": "heal",
  "juglans": "heal",
  "jugular": "heal",
  "juice": "taste",
  "juiceless": "beautiful",
  "juicer": "build",
  "juicy": "taste",
  "juju": "smart",
  "jujube": "heal",
  "juke": "build",
  "jukebox": "build",
  "julep": "taste",
  "julienne": "taste",
  "jumbal": "taste",
  "jumble": "taste",
  "jumbojet": "build",
  "jument": "heal",
  "jump": "story",
  "jumper": "build",
  "jumpsuit": "build",
  "jumpy": "beautiful",
  "juncaceae": "heal",
  "juncaginaceae": "heal",
  "junco": "heal",
  "junction": "build",
  "juncus": "heal",
  "juneberry": "heal",
  "jungermanniaceae": "heal",
  "jungermanniales": "heal",
  "juniper": "heal",
  "juniperus": "heal",
  "junk": "build",
  "junket": "taste",
  "junketing": "taste",
  "jupati": "heal",
  "jupaty": "heal",
  "jurisprudence": "smart",
  "just": "beautiful",
  "justification": "smart",
  "justify": "story",
  "jutish": "story",
  "jutting": "beautiful",
  "juvenescence": "smart",
  "juvenile": "beautiful",
  "juxtapose": "build",
  "jynx": "heal",
  "k.e.": "sound",
  "kaaba": "build",
  "kabala": "story",
  "kabbala": "story",
  "kabbalah": "story",
  "kabbalism": "smart",
  "kabob": "taste",
  "kachin": "story",
  "kachina": "build",
  "kachinic": "story",
  "kadai": "story",
  "kaffir": "heal",
  "kaffiyeh": "build",
  "kafiri": "story",
  "kafkaesque": "beautiful",
  "kafocin": "build",
  "kaftan": "build",
  "kahikatea": "heal",
  "kahlua": "taste",
  "kail": "heal",
  "kainogenesis": "smart",
  "kakatoe": "heal",
  "kakemono": "build",
  "kaki": "heal",
  "kalansuwa": "build",
  "kalantas": "heal",
  "kalapooian": "story",
  "kalapuyan": "story",
  "kalashnikov": "build",
  "kale": "sell",
  "kaleidoscope": "smart",
  "kali": "heal",
  "kalian": "build",
  "kalka": "story",
  "kalmia": "heal",
  "kalotermes": "heal",
  "kalotermitidae": "heal",
  "kalpac": "build",
  "kalumpang": "heal",
  "kam-sui": "story",
  "kam-tai": "story",
  "kamarupan": "story",
  "kamasutra": "story",
  "kamba": "story",
  "kameez": "build",
  "kamia": "story",
  "kamikaze": "build",
  "kanaf": "heal",
  "kanamycin": "build",
  "kanarese": "story",
  "kanchil": "heal",
  "kangaroo": "heal",
  "kangaroo's-foot": "heal",
  "kannada": "story",
  "kansa": "story",
  "kansas": "story",
  "kantrex": "build",
  "kanzu": "build",
  "kaoliang": "heal",
  "kaolin": "build",
  "kaoline": "build",
  "kaopectate": "build",
  "kapeika": "smart",
  "kaph": "story",
  "kapok": "heal",
  "kappa": "story",
  "kapsiki": "story",
  "kapuka": "heal",
  "karabiner": "build",
  "karakalpak": "story",
  "karakul": "heal",
  "karat": "smart",
  "karelian": "story",
  "karen": "story",
  "karenic": "story",
  "karok": "story",
  "karyokinesis": "smart",
  "karyolymph": "heal",
  "karyolysis": "smart",
  "karyon": "heal",
  "karyoplasm": "heal",
  "karyotype": "heal",
  "kasha": "taste",
  "kashmiri": "story",
  "kassite": "story",
  "kat": "build",
  "katabatic": "beautiful",
  "katabolic": "beautiful",
  "katabolism": "smart",
  "katamorphism": "smart",
  "katharevusa": "story",
  "katharobe": "heal",
  "katharometer": "build",
  "katsuwonidae": "heal",
  "katsuwonus": "heal",
  "katydid": "heal",
  "kauri": "heal",
  "kaury": "heal",
  "kava": "taste",
  "kavakava": "taste",
  "kavrin": "build",
  "kawaka": "heal",
  "kayak": "build",
  "kayo": "build",
  "kazak": "story",
  "kazakh": "story",
  "kazoo": "build",
  "kbit": "smart",
  "kea": "heal",
  "kebab": "taste",
  "kechua": "story",
  "kechuan": "story",
  "kedgeree": "taste",
  "keel": "heal",
  "keelboat": "build",
  "keelson": "build",
  "keen": "story",
  "keenness": "smart",
  "keep": "sell",
  "keepsake": "build",
  "keeshond": "heal",
  "keflex": "build",
  "keflin": "build",
  "keftab": "build",
  "keg": "smart",
  "kegful": "smart",
  "keister": "heal",
  "kekchi": "story",
  "kelp": "heal",
  "kelpie": "heal",
  "kelpwort": "heal",
  "kelvin": "smart",
  "kemadrin": "build",
  "ken": "smart",
  "kenaf": "heal",
  "kennedia": "heal",
  "kennedya": "heal",
  "kennel": "build",
  "kenning": "story",
  "kenogenesis": "smart",
  "kentan": "heal",
  "kentish": "story",
  "kenyapithecus": "heal",
  "kepi": "build",
  "kept": "sell",
  "kera": "story",
  "keratinisation": "smart",
  "keratinization": "smart",
  "keratoscope": "build",
  "kerb": "build",
  "kerbstone": "build",
  "kerchief": "build",
  "kern": "build",
  "kernel": "heal",
  "kernicterus": "beautiful",
  "kerugma": "story",
  "kerygma": "story",
  "kestrel": "heal",
  "ketalar": "build",
  "ketamine": "build",
  "ketch": "build",
  "ketchup": "taste",
  "keteleeria": "heal",
  "ketembilla": "heal",
  "ketoprofen": "build",
  "ketorolac": "build",
  "kettle": "build",
  "kettledrum": "build",
  "kettleful": "smart",
  "ketubim": "story",
  "keurboom": "heal",
  "key": "build",
  "keyboard": "sound",
  "keycard": "story",
  "keyed": "smart",
  "keyhole": "build",
  "keyless": "beautiful",
  "keynesianism": "smart",
  "keynote": "story",
  "keypad": "build",
  "keystone": "smart",
  "khaddar": "build",
  "khadi": "build",
  "khaki": "build",
  "khakis": "build",
  "khalka": "story",
  "khalkha": "story",
  "khamsin": "sound",
  "khamti": "story",
  "khan": "build",
  "khanty": "story",
  "khat": "build",
  "khaya": "heal",
  "khesari": "heal",
  "khi": "story",
  "khimar": "build",
  "khirghiz": "story",
  "khmer": "story",
  "khoikhoi": "story",
  "khoikhoin": "story",
  "khoisan": "story",
  "khoum": "smart",
  "khowar": "story",
  "khuen": "story",
  "khukuri": "build",
  "kiaat": "heal",
  "kiang": "heal",
  "kib": "smart",
  "kibbitz": "story",
  "kibble": "taste",
  "kibibit": "smart",
  "kibibyte": "smart",
  "kibit": "smart",
  "kibitz": "story",
  "kibosh": "sell",
  "kichaga": "story",
  "kick": "story",
  "kickapoo": "story",
  "kickback": "sell",
  "kicking": "build",
  "kickshaw": "taste",
  "kicksorter": "build",
  "kickstand": "build",
  "kidnap": "build",
  "kidnapping": "build",
  "kidney": "heal",
  "kiggelaria": "heal",
  "kildeer": "heal",
  "kilderkin": "smart",
  "kiley": "build",
  "kiliwa": "story",
  "kiliwi": "story",
  "kill": "build",
  "killdeer": "heal",
  "killer": "smart",
  "killifish": "heal",
  "killing": "sell",
  "kiln": "beautiful",
  "kilo": "smart",
  "kilobit": "smart",
  "kilobyte": "smart",
  "kilocalorie": "smart",
  "kilogram": "smart",
  "kilogram-meter": "smart",
  "kiloliter": "smart",
  "kilolitre": "smart",
  "kilometer": "smart",
  "kilometre": "smart",
  "kiloton": "smart",
  "kilovolt": "smart",
  "kilovolt-ampere": "smart",
  "kilowatt": "smart",
  "kilt": "build",
  "kimono": "build",
  "kin": "beautiful",
  "kina": "smart",
  "kinaesthesia": "smart",
  "kinaesthesis": "smart",
  "kinanesthesia": "smart",
  "kind": "smart",
  "kindred": "beautiful",
  "kine": "heal",
  "kinematics": "smart",
  "kinescope": "build",
  "kinesiology": "heal",
  "kinesthesia": "smart",
  "kinesthesis": "smart",
  "kinesthetics": "smart",
  "kinetic": "beautiful",
  "kinetics": "smart",
  "kinetochore": "heal",
  "kinetoscope": "build",
  "kingbird": "heal",
  "kingbolt": "build",
  "kingcup": "heal",
  "kingfish": "taste",
  "kingfisher": "heal",
  "kinglet": "heal",
  "kingpin": "build",
  "kingsnake": "heal",
  "kingwood": "heal",
  "kink": "smart",
  "kinkajou": "heal",
  "kino": "heal",
  "kinosternidae": "heal",
  "kinosternon": "heal",
  "kinyarwanda": "story",
  "kiosk": "build",
  "kiowa": "story",
  "kip": "smart",
  "kipper": "taste",
  "kirghiz": "story",
  "kirgiz": "story",
  "kirk": "build",
  "kirkia": "heal",
  "kirpan": "build",
  "kirsch": "taste",
  "kirtle": "build",
  "kishke": "taste",
  "kiss": "taste",
  "kiss-me-over-the-garden-gate": "heal",
  "kisser": "heal",
  "kissing": "build",
  "kiswahili": "story",
  "kit": "build",
  "kitambilla": "heal",
  "kitbag": "build",
  "kitchen": "taste",
  "kitchenette": "build",
  "kitchenware": "build",
  "kite": "sell",
  "kitembilla": "heal",
  "kitsch": "build",
  "kitten": "heal",
  "kitten-tails": "heal",
  "kittiwake": "heal",
  "kittul": "heal",
  "kitty": "sell",
  "kitty-cat": "heal",
  "kitul": "heal",
  "kiwi": "heal",
  "klavier": "build",
  "klaxon": "build",
  "klebsiella": "heal",
  "klick": "smart",
  "klystron": "build",
  "knack": "smart",
  "knackwurst": "taste",
  "knap": "build",
  "knapsack": "build",
  "knapweed": "heal",
  "knave": "build",
  "knawe": "heal",
  "knawel": "heal",
  "knead": "build",
  "knee": "heal",
  "knee-hi": "build",
  "knee-high": "build",
  "kneecap": "heal",
  "kneel": "build",
  "kneeler": "build",
  "kneeling": "build",
  "kneepan": "heal",
  "knell": "sound",
  "knickerbockers": "build",
  "knickers": "build",
  "knickknack": "build",
  "knickknackery": "build",
  "knife": "build",
  "knife-handle": "heal",
  "knight": "build",
  "knightia": "heal",
  "knightliness": "smart",
  "kniphofia": "heal",
  "knish": "taste",
  "knit": "beautiful",
  "knitting": "beautiful",
  "knitwear": "build",
  "knitwork": "build",
  "knob": "build",
  "knobble": "build",
  "knobkerrie": "build",
  "knobkerry": "build",
  "knock": "smart",
  "knockabout": "build",
  "knockdown": "beautiful",
  "knocker": "heal",
  "knocking": "build",
  "knockoff": "build",
  "knockout": "beautiful",
  "knockwurst": "taste",
  "knot": "build",
  "knotgrass": "heal",
  "knout": "build",
  "know": "smart",
  "know-how": "smart",
  "knowable": "beautiful",
  "knowing": "smart",
  "knowingness": "smart",
  "known": "smart",
  "knuckle": "heal",
  "knuckles": "build",
  "knucks": "build",
  "koala": "heal",
  "koan": "story",
  "koasati": "story",
  "kob": "heal",
  "kobo": "smart",
  "kobus": "heal",
  "kochia": "heal",
  "kodiak": "heal",
  "koellia": "heal",
  "kogia": "heal",
  "kohl": "build",
  "kohleria": "heal",
  "kohlrabi": "heal",
  "koine": "story",
  "kok-saghyz": "heal",
  "kok-sagyz": "heal",
  "kola": "heal",
  "kolami": "story",
  "kolkwitzia": "heal",
  "komi": "story",
  "komondor": "heal",
  "kongo": "story",
  "konini": "heal",
  "konqueror": "story",
  "koodoo": "heal",
  "kookaburra": "heal",
  "kopeck": "smart",
  "kopek": "smart",
  "kopiyka": "smart",
  "kor": "smart",
  "koran": "story",
  "kordofanian": "story",
  "korean": "story",
  "koruna": "smart",
  "kos": "smart",
  "kosher": "taste",
  "kosteletzya": "heal",
  "kota": "story",
  "kotar": "story",
  "kotex": "build",
  "koto": "build",
  "kotoko": "story",
  "kotow": "story",
  "koudou": "heal",
  "koumiss": "taste",
  "koussevitzky": "sound",
  "kowhai": "heal",
  "kowtow": "story",
  "kraal": "build",
  "krafft-ebing": "heal",
  "krait": "heal",
  "kremlin": "build",
  "krigia": "heal",
  "krill": "heal",
  "kris": "build",
  "krishnaism": "smart",
  "krona": "smart",
  "krone": "smart",
  "kroon": "smart",
  "krubi": "heal",
  "krummhorn": "build",
  "krypterophaneron": "heal",
  "ku-chiku": "heal",
  "kuchean": "story",
  "kudos": "story",
  "kudu": "heal",
  "kudzu": "heal",
  "kui": "story",
  "kuki": "story",
  "kuki-chin": "story",
  "kulanapan": "story",
  "kumis": "taste",
  "kummel": "taste",
  "kumquat": "heal",
  "kurakkan": "heal",
  "kurchee": "heal",
  "kurchi": "heal",
  "kurdish": "story",
  "kurdistan": "build",
  "kuri-chiku": "heal",
  "kuroshio": "sound",
  "kurrajong": "heal",
  "kurrat": "heal",
  "kurta": "build",
  "kurus": "smart",
  "kurux": "story",
  "kusan": "story",
  "kutch": "heal",
  "kuvasz": "heal",
  "kuvi": "story",
  "kvass": "taste",
  "kvetch": "story",
  "kw-hr": "smart",
  "kwa": "story",
  "kwacha": "smart",
  "kwai": "smart",
  "kwakiutl": "story",
  "kwanza": "smart",
  "kweek": "heal",
  "kwela": "story",
  "kyat": "smart",
  "kylie": "build",
  "kylix": "build",
  "kymograph": "build",
  "kyo-chiku": "heal",
  "kyphosidae": "heal",
  "kyphosus": "heal",
  "l-p": "build",
  "l-plate": "build",
  "laager": "build",
  "lab": "build",
  "labanotation": "story",
  "labdanum": "heal",
  "label": "story",
  "labeled": "story",
  "labelled": "story",
  "labetalol": "build",
  "labial": "story",
  "labialise": "story",
  "labialize": "story",
  "labiatae": "heal",
  "labiodental": "story",
  "labium": "heal",
  "lablab": "heal",
  "laboratory": "build",
  "labridae": "heal",
  "labrocyte": "heal",
  "laburnum": "heal",
  "labyrinth": "build",
  "labyrinthine": "beautiful",
  "labyrinthodont": "heal",
  "labyrinthodonta": "heal",
  "labyrinthodontia": "heal",
  "laccopetalum": "heal",
  "lace": "build",
  "lacebark": "heal",
  "laced": "build",
  "lacepod": "heal",
  "lacerate": "build",
  "lacerta": "heal",
  "lacertid": "heal",
  "lacertidae": "heal",
  "lacertilia": "heal",
  "lacewing": "heal",
  "lacewood": "heal",
  "lacework": "build",
  "lachnolaimus": "heal",
  "lachrymation": "smart",
  "lacing": "taste",
  "laconicism": "story",
  "laconism": "story",
  "lacquer": "build",
  "lacquerware": "build",
  "lacrimation": "smart",
  "lactarius": "heal",
  "lactate": "taste",
  "lactating": "taste",
  "lactation": "smart",
  "lacteal": "heal",
  "lactobacillaceae": "heal",
  "lactobacillus": "heal",
  "lactobacteriaceae": "heal",
  "lactophrys": "heal",
  "lactuca": "heal",
  "lacuna": "build",
  "ladanum": "heal",
  "ladder": "build",
  "ladder-back": "build",
  "lade": "build",
  "laden": "build",
  "ladies'-eardrop": "heal",
  "ladies'-eardrops": "heal",
  "ladin": "story",
  "lading": "build",
  "ladino": "story",
  "ladle": "taste",
  "lady's-eardrop": "heal",
  "lady's-eardrops": "heal",
  "lady's-finger": "heal",
  "lady-of-the-night": "heal",
  "lady-slipper": "heal",
  "ladybeetle": "heal",
  "ladybird": "heal",
  "ladybug": "heal",
  "ladyfinger": "taste",
  "ladyfish": "heal",
  "ladyship": "story",
  "laelia": "heal",
  "lag": "build",
  "lagan": "build",
  "lagarostrobus": "heal",
  "lagenaria": "heal",
  "lagend": "build",
  "lagenophera": "heal",
  "lager": "build",
  "lagerphone": "build",
  "lagerstroemia": "heal",
  "laggard": "beautiful",
  "lagging": "sell",
  "lagidium": "heal",
  "lagniappe": "sell",
  "lagodon": "heal",
  "lagomorph": "heal",
  "lagomorpha": "heal",
  "lagopus": "heal",
  "lagorchestes": "heal",
  "lagostomus": "heal",
  "lagothrix": "heal",
  "laguncularia": "heal",
  "lah": "story",
  "lahu": "story",
  "lake": "beautiful",
  "lakh": "smart",
  "lallans": "story",
  "lallation": "story",
  "lally": "build",
  "lam": "build",
  "lama": "heal",
  "lamaism": "smart",
  "lamarckism": "smart",
  "lamasery": "build",
  "lamb": "taste",
  "lamb's-quarter": "taste",
  "lamb's-quarters": "heal",
  "lamb-chop": "taste",
  "lambast": "build",
  "lambaste": "build",
  "lambchop": "taste",
  "lambda": "story",
  "lambert": "smart",
  "lambertia": "heal",
  "lambis": "heal",
  "lambkill": "heal",
  "lambkin": "heal",
  "lambrequin": "build",
  "lame": "build",
  "lamedh": "story",
  "lamella": "heal",
  "lamellibranch": "heal",
  "lamellibranchia": "heal",
  "lamellicornia": "heal",
  "lament": "story",
  "lamentation": "story",
  "lamentations": "story",
  "lamented": "story",
  "lamiaceae": "heal",
  "lamina": "heal",
  "laminaria": "heal",
  "laminariaceae": "heal",
  "laminariales": "heal",
  "laminate": "build",
  "lamination": "build",
  "lamisil": "build",
  "lamium": "heal",
  "lamivudine": "build",
  "lammergeier": "heal",
  "lammergeyer": "heal",
  "lamna": "heal",
  "lamnidae": "heal",
  "lamp": "build",
  "lampblack": "beautiful",
  "lamphouse": "build",
  "lamplight": "sound",
  "lampoon": "story",
  "lamppost": "build",
  "lamprey": "heal",
  "lampridae": "heal",
  "lampris": "heal",
  "lampropeltis": "heal",
  "lampshade": "build",
  "lampshell": "heal",
  "lampyridae": "heal",
  "lan": "build",
  "lanai": "build",
  "lance": "build",
  "lancelet": "heal",
  "lancet": "build",
  "lancetfish": "heal",
  "lancewood": "heal",
  "land": "sell",
  "landau": "build",
  "lander": "build",
  "landholding": "sell",
  "landing": "build",
  "landler": "story",
  "landless": "beautiful",
  "landline": "build",
  "landmark": "story",
  "landowska": "sound",
  "landrover": "build",
  "landscape": "beautiful",
  "landscaping": "build",
  "landside": "build",
  "landsmaal": "story",
  "landsmal": "story",
  "landsteiner": "heal",
  "lane": "build",
  "langley": "smart",
  "langouste": "taste",
  "langoustine": "taste",
  "langsat": "heal",
  "langset": "heal",
  "language": "story",
  "languish": "heal",
  "langur": "heal",
  "laniard": "build",
  "laniidae": "heal",
  "lanius": "heal",
  "lanolin": "build",
  "lanoxin": "build",
  "lansa": "taste",
  "lansat": "taste",
  "lanseh": "taste",
  "lanset": "taste",
  "lantana": "heal",
  "lantern": "build",
  "lantern-fly": "heal",
  "lanternfish": "heal",
  "lanthanotidae": "heal",
  "lanthanotus": "heal",
  "lanugo": "heal",
  "lanyard": "build",
  "lao": "story",
  "laos": "story",
  "lap": "heal",
  "lap-strake": "beautiful",
  "lap-straked": "beautiful",
  "lap-streak": "beautiful",
  "lap-streaked": "beautiful",
  "laparoscope": "build",
  "lapboard": "build",
  "lapdog": "heal",
  "lapel": "build",
  "lapful": "smart",
  "lapidate": "build",
  "lapin": "heal",
  "laportea": "heal",
  "lapp": "story",
  "lappet": "heal",
  "lappic": "story",
  "lapping": "build",
  "lappish": "story",
  "lappula": "heal",
  "laptop": "build",
  "laputa": "smart",
  "laputan": "beautiful",
  "lapwing": "heal",
  "larboard": "build",
  "larch": "heal",
  "lard": "taste",
  "larder": "taste",
  "lardizabala": "heal",
  "lardizabalaceae": "heal",
  "large": "beautiful",
  "largemouth": "heal",
  "largeness": "smart",
  "largess": "sell",
  "largesse": "sell",
  "larghetto": "story",
  "largo": "story",
  "lari": "smart",
  "lariat": "build",
  "laricariidae": "heal",
  "larid": "heal",
  "laridae": "heal",
  "larium": "build",
  "larix": "heal",
  "lark": "heal",
  "larkspur": "heal",
  "larn": "smart",
  "larotid": "build",
  "larrea": "heal",
  "larrup": "build",
  "larus": "heal",
  "larva": "heal",
  "larvacea": "heal",
  "larvacean": "heal",
  "larval": "beautiful",
  "laryngopharynx": "heal",
  "laryngoscope": "build",
  "larynx": "heal",
  "lasagna": "taste",
  "lasagne": "taste",
  "laser": "build",
  "lash": "heal",
  "lash-up": "build",
  "lashing": "build",
  "lashings": "smart",
  "lasiocampa": "heal",
  "lasiocampid": "heal",
  "lasiocampidae": "heal",
  "lasiurus": "heal",
  "lasix": "build",
  "lasso": "build",
  "last": "sound",
  "lastex": "build",
  "lasthenia": "heal",
  "lasting": "beautiful",
  "lastreopsis": "heal",
  "lat": "heal",
  "latanier": "heal",
  "latch": "build",
  "latchet": "build",
  "latchkey": "build",
  "latchstring": "build",
  "late": "beautiful",
  "lateen": "build",
  "lateen-rig": "build",
  "later": "beautiful",
  "lateral": "beautiful",
  "lateralisation": "smart",
  "laterality": "smart",
  "lateralization": "smart",
  "lates": "heal",
  "latest": "story",
  "latex": "build",
  "lath": "build",
  "lathe": "build",
  "lathee": "build",
  "lathi": "build",
  "lathyrus": "heal",
  "laticifer": "heal",
  "latimeria": "heal",
  "latimeridae": "heal",
  "latin": "story",
  "latinae": "heal",
  "latinesce": "story",
  "latinise": "story",
  "latinism": "story",
  "latinize": "story",
  "latino": "story",
  "latitudinarian": "beautiful",
  "latke": "taste",
  "latrine": "build",
  "latrodectus": "heal",
  "lats": "smart",
  "latte": "taste",
  "latter": "beautiful",
  "lattice": "smart",
  "latticework": "build",
  "latvian": "story",
  "laud": "story",
  "laudanum": "build",
  "laugh": "story",
  "laughter": "story",
  "lauhala": "heal",
  "launce": "heal",
  "launch": "build",
  "launcher": "build",
  "launching": "sell",
  "launchpad": "build",
  "launder": "build",
  "launderette": "build",
  "laundering": "build",
  "laundromat": "build",
  "laundry": "build",
  "lauraceae": "heal",
  "laureate": "beautiful",
  "laurel": "heal",
  "laurel-tree": "heal",
  "laureled": "beautiful",
  "laurelled": "beautiful",
  "laurels": "story",
  "laurelwood": "heal",
  "laurus": "heal",
  "lav": "build",
  "lavabo": "build",
  "lavalava": "build",
  "lavalier": "build",
  "lavaliere": "build",
  "lavalliere": "build",
  "lavandula": "heal",
  "lavatera": "heal",
  "lavatory": "build",
  "lave": "heal",
  "lavender": "heal",
  "laver": "build",
  "lavish": "sell",
  "law": "story",
  "lawcourt": "build",
  "lawful": "beautiful",
  "lawrencium": "sound",
  "laws": "story",
  "lawyerbush": "heal",
  "lax": "beautiful",
  "laxation": "smart",
  "laxative": "build",
  "laxity": "heal",
  "laxness": "heal",
  "lay": "story",
  "lay-by": "build",
  "layby": "build",
  "layer": "build",
  "layette": "build",
  "layia": "heal",
  "laying": "smart",
  "layout": "smart",
  "lazaret": "build",
  "lazarette": "build",
  "lazaretto": "build",
  "laze": "sell",
  "lbf.": "smart",
  "lcd": "build",
  "lcm": "smart",
  "lea": "smart",
  "leach": "smart",
  "leaching": "smart",
  "lead": "smart",
  "lead-in": "story",
  "leaden": "beautiful",
  "leader": "build",
  "leaders": "build",
  "leadership": "smart",
  "leading": "build",
  "leadless": "beautiful",
  "leadplant": "heal",
  "leadwort": "heal",
  "leaf": "heal",
  "leaf-book": "story",
  "leaf-cutter": "heal",
  "leaf-miner": "heal",
  "leaf-roller": "heal",
  "leafage": "heal",
  "leafhopper": "heal",
  "leafing": "smart",
  "leafless": "beautiful",
  "leaflet": "heal",
  "leafstalk": "heal",
  "leafy": "beautiful",
  "league": "smart",
  "leak": "smart",
  "leaky": "beautiful",
  "lean": "build",
  "lean-to": "build",
  "leaner": "beautiful",
  "leaning": "smart",
  "learn": "smart",
  "learned": "smart",
  "learnedness": "smart",
  "learning": "smart",
  "lease": "sell",
  "leased": "sell",
  "leasehold": "sell",
  "leash": "build",
  "least": "smart",
  "leather": "beautiful",
  "leatherback": "heal",
  "leatherette": "build",
  "leatherfish": "heal",
  "leatherjack": "heal",
  "leatherjacket": "heal",
  "leatherleaf": "heal",
  "leatherwood": "heal",
  "leatherwork": "build",
  "leave": "story",
  "leaven": "smart",
  "leavened": "beautiful",
  "leavening": "smart",
  "leaving": "smart",
  "lebensraum": "smart",
  "lebistes": "heal",
  "lecanopteris": "heal",
  "lecanora": "heal",
  "lecanoraceae": "heal",
  "leccinum": "heal",
  "lechanorales": "heal",
  "lechwe": "heal",
  "lectern": "build",
  "lecture": "story",
  "lecturing": "story",
  "lecythidaceae": "heal",
  "led": "build",
  "lede": "story",
  "lederhosen": "build",
  "ledger": "sell",
  "ledum": "heal",
  "leech": "heal",
  "leechee": "taste",
  "leek": "heal",
  "leer": "story",
  "lees": "taste",
  "leeward": "beautiful",
  "leeway": "smart",
  "leflunomide": "build",
  "left": "heal",
  "left-handed": "beautiful",
  "leftfield": "build",
  "leftism": "smart",
  "leftist": "beautiful",
  "leftover": "beautiful",
  "leftovers": "taste",
  "leg": "heal",
  "legacy": "sell",
  "legal": "beautiful",
  "legalese": "story",
  "legalise": "sell",
  "legalism": "smart",
  "legalize": "sell",
  "legato": "beautiful",
  "legend": "story",
  "leger": "sell",
  "legged": "beautiful",
  "legging": "build",
  "leghorn": "build",
  "legible": "beautiful",
  "leging": "build",
  "legionella": "heal",
  "legislate": "sell",
  "legislating": "sell",
  "legislation": "story",
  "legitimate": "sell",
  "legitimatise": "sell",
  "legitimatize": "sell",
  "legitimise": "sell",
  "legitimize": "sell",
  "legless": "beautiful",
  "lego": "build",
  "legs": "heal",
  "legume": "heal",
  "leguminosae": "heal",
  "lei": "build",
  "leiopelma": "heal",
  "leiopelmatidae": "heal",
  "leiophyllum": "heal",
  "leipoa": "heal",
  "leishmania": "heal",
  "leister": "build",
  "leitmotif": "story",
  "leitmotiv": "story",
  "leitneria": "heal",
  "leitneriaceae": "heal",
  "lek": "smart",
  "lekvar": "taste",
  "lem": "build",
  "lemaireocereus": "heal",
  "lemanderin": "heal",
  "lemma": "story",
  "lemming": "heal",
  "lemmus": "heal",
  "lemna": "heal",
  "lemnaceae": "heal",
  "lemniscus": "heal",
  "lemon": "taste",
  "lemon-wood": "heal",
  "lemonade": "taste",
  "lemongrass": "heal",
  "lemonwood": "heal",
  "lempira": "smart",
  "lemur": "heal",
  "lemuridae": "heal",
  "lemuroidea": "heal",
  "lend": "sell",
  "lending": "sell",
  "lengthways": "beautiful",
  "lengthwise": "beautiful",
  "leninism": "smart",
  "lenitive": "build",
  "lennoaceae": "heal",
  "lens": "build",
  "lense": "build",
  "lent": "sell",
  "lentibulariaceae": "heal",
  "lentic": "beautiful",
  "lenticel": "heal",
  "lentigo": "heal",
  "lentil": "taste",
  "lentinus": "heal",
  "lentisk": "heal",
  "leonberg": "heal",
  "leoncita": "heal",
  "leone": "smart",
  "leonotis": "heal",
  "leontocebus": "heal",
  "leontodon": "heal",
  "leontopodium": "heal",
  "leonurus": "heal",
  "leopard": "heal",
  "leopard's-bane": "heal",
  "leopardbane": "heal",
  "leopardess": "heal",
  "leotard": "build",
  "leotards": "build",
  "lepadidae": "heal",
  "lepas": "heal",
  "lepechinia": "heal",
  "lepidium": "heal",
  "lepidobotryaceae": "heal",
  "lepidobotrys": "heal",
  "lepidochelys": "heal",
  "lepidocybium": "heal",
  "lepidodendraceae": "heal",
  "lepidodendrales": "heal",
  "lepidoptera": "heal",
  "lepidopteran": "heal",
  "lepidopterology": "smart",
  "lepidopteron": "heal",
  "lepidoptery": "smart",
  "lepidosauria": "heal",
  "lepidothamnus": "heal",
  "lepiota": "heal",
  "lepiotaceae": "heal",
  "lepisma": "heal",
  "lepismatidae": "heal",
  "lepisosteidae": "heal",
  "lepisosteus": "heal",
  "lepomis": "heal",
  "leporid": "heal",
  "leporidae": "heal",
  "leporide": "heal",
  "leppy": "heal",
  "leptarrhena": "heal",
  "leptinotarsa": "heal",
  "leptocephalus": "heal",
  "leptodactylid": "heal",
  "leptodactylidae": "heal",
  "leptodactylus": "heal",
  "leptoglossus": "heal",
  "leptomeninges": "heal",
  "lepton": "smart",
  "leptopteris": "heal",
  "leptoptilus": "heal",
  "leptorhine": "beautiful",
  "leptorrhine": "beautiful",
  "leptorrhinian": "beautiful",
  "leptorrhinic": "beautiful",
  "leptospira": "heal",
  "leptosporangiate": "beautiful",
  "leptosporangium": "heal",
  "leptotene": "smart",
  "leptotyphlopidae": "heal",
  "leptotyphlops": "heal",
  "lepus": "heal",
  "lerot": "heal",
  "lesbian": "beautiful",
  "lescol": "build",
  "lespedeza": "heal",
  "lesquerella": "heal",
  "less": "beautiful",
  "lesser": "beautiful",
  "lesson": "story",
  "let": "sell",
  "lethargic": "beautiful",
  "letter": "story",
  "lettercard": "story",
  "letterhead": "story",
  "lettering": "beautiful",
  "letterpress": "story",
  "letters": "smart",
  "letting": "sell",
  "lettish": "story",
  "lettuce": "sell",
  "leu": "smart",
  "leucadendron": "heal",
  "leucaena": "heal",
  "leucanthemum": "heal",
  "leuciscus": "heal",
  "leucocyte": "heal",
  "leucocytozoan": "heal",
  "leucocytozoon": "heal",
  "leucogenes": "heal",
  "leucorrhea": "heal",
  "leucothoe": "heal",
  "leukeran": "build",
  "leukocyte": "heal",
  "leukoderma": "beautiful",
  "leukorrhea": "heal",
  "lev": "smart",
  "levallorphan": "build",
  "levanter": "sound",
  "levator": "heal",
  "levee": "build",
  "lever": "build",
  "leverage": "sound",
  "leveraging": "sell",
  "leveret": "heal",
  "levi's": "build",
  "levirate": "smart",
  "levis": "build",
  "levisticum": "heal",
  "levitation": "sound",
  "leviticus": "story",
  "levitra": "build",
  "levy": "sell",
  "lewisia": "heal",
  "lexeme": "story",
  "lexicalisation": "smart",
  "lexicalise": "story",
  "lexicalised": "story",
  "lexicalization": "smart",
  "lexicalize": "story",
  "lexicalized": "story",
  "lexicology": "smart",
  "lexicon": "story",
  "lexicostatistics": "smart",
  "lexis": "smart",
  "leycesteria": "heal",
  "leymus": "heal",
  "lgb": "build",
  "lhasa": "heal",
  "liabilities": "sell",
  "liaise": "story",
  "liaison": "story",
  "liana": "heal",
  "liatris": "heal",
  "libation": "taste",
  "libel": "story",
  "liberal": "beautiful",
  "liberalise": "sell",
  "liberalism": "smart",
  "liberality": "smart",
  "liberalize": "sell",
  "liberalness": "smart",
  "liberate": "sell",
  "libertarianism": "smart",
  "libertine": "beautiful",
  "libocedrus": "heal",
  "library": "smart",
  "libration": "smart",
  "libretto": "story",
  "libritabs": "build",
  "librium": "build",
  "licence": "story",
  "license": "story",
  "lichanura": "heal",
  "lichee": "heal",
  "lichen": "heal",
  "lichenales": "heal",
  "lichenes": "heal",
  "lichgate": "build",
  "lichi": "taste",
  "licit": "beautiful",
  "lick": "build",
  "licking": "build",
  "licorice": "heal",
  "lid": "heal",
  "lidar": "smart",
  "lidded": "beautiful",
  "lidless": "beautiful",
  "lido": "build",
  "lidocaine": "build",
  "lie": "story",
  "liebfraumilch": "taste",
  "lied": "story",
  "liederkranz": "taste",
  "liege": "beautiful",
  "lien": "sell",
  "life": "smart",
  "life-of-man": "heal",
  "lifeblood": "heal",
  "lifeboat": "build",
  "lifeline": "smart",
  "lifesaver": "build",
  "lift": "sound",
  "ligament": "heal",
  "ligan": "build",
  "ligate": "build",
  "ligature": "story",
  "liger": "heal",
  "light": "sound",
  "light-colored": "beautiful",
  "light-duty": "beautiful",
  "light-footed": "beautiful",
  "light-haired": "beautiful",
  "light-year": "smart",
  "lightbulb": "build",
  "lighted": "taste",
  "lighten": "build",
  "lightening": "build",
  "lighter": "build",
  "lighterage": "sell",
  "lighthouse": "build",
  "lighting": "build",
  "lightning": "sound",
  "lights-out": "story",
  "lightship": "build",
  "lightwood": "heal",
  "ligne": "smart",
  "lignosae": "heal",
  "lignum": "heal",
  "ligularia": "heal",
  "ligule": "heal",
  "ligustrum": "heal",
  "likable": "beautiful",
  "like": "smart",
  "likeable": "beautiful",
  "liked": "smart",
  "likely": "beautiful",
  "liken": "smart",
  "likeness": "build",
  "likening": "smart",
  "likuta": "smart",
  "lilac": "heal",
  "lilangeni": "smart",
  "liliaceae": "heal",
  "liliales": "heal",
  "liliidae": "heal",
  "liliopsid": "heal",
  "liliopsida": "heal",
  "lilium": "heal",
  "lilliput": "smart",
  "lilliputian": "beautiful",
  "lilo": "build",
  "lilt": "story",
  "lily": "heal",
  "lilyturf": "heal",
  "limacidae": "heal",
  "limanda": "heal",
  "limax": "heal",
  "limb": "heal",
  "limbed": "beautiful",
  "limber": "build",
  "limbers": "build",
  "limbless": "beautiful",
  "limbo": "smart",
  "limburger": "taste",
  "limbus": "heal",
  "lime": "heal",
  "limeade": "taste",
  "limekiln": "build",
  "limelight": "build",
  "limen": "smart",
  "limenitis": "heal",
  "limerick": "story",
  "limicolae": "heal",
  "limitation": "smart",
  "limited": "build",
  "limiter": "sound",
  "limiting": "story",
  "limitless": "beautiful",
  "limn": "build",
  "limning": "build",
  "limnobium": "heal",
  "limnocryptes": "heal",
  "limnodromus": "heal",
  "limnology": "smart",
  "limo": "build",
  "limonium": "heal",
  "limosa": "heal",
  "limousine": "build",
  "limp": "beautiful",
  "limpa": "taste",
  "limper": "beautiful",
  "limpet": "taste",
  "limpkin": "heal",
  "limulidae": "heal",
  "limulus": "heal",
  "linac": "build",
  "linaceae": "heal",
  "linage": "smart",
  "linanthus": "heal",
  "linaria": "heal",
  "linchpin": "smart",
  "lincocin": "build",
  "lincoln": "heal",
  "lincomycin": "build",
  "linden": "heal",
  "lindera": "heal",
  "lindheimera": "heal",
  "line": "story",
  "line-shooting": "story",
  "lineage": "smart",
  "lineal": "beautiful",
  "lineament": "smart",
  "linear": "beautiful",
  "linecut": "build",
  "lined": "build",
  "linen": "beautiful",
  "liner": "build",
  "lineup": "story",
  "ling": "heal",
  "lingam": "story",
  "lingberry": "heal",
  "lingcod": "taste",
  "lingenberry": "heal",
  "lingerie": "build",
  "lingo": "story",
  "lingonberry": "heal",
  "lingua": "heal",
  "lingual": "story",
  "lingualumina": "story",
  "linguica": "taste",
  "linguine": "taste",
  "linguini": "taste",
  "linguistics": "smart",
  "liniment": "build",
  "linin": "heal",
  "lining": "build",
  "link": "build",
  "linkage": "build",
  "links": "build",
  "linkup": "build",
  "linnaea": "heal",
  "linnet": "heal",
  "linocut": "build",
  "linotype": "build",
  "linsey-woolsey": "build",
  "linstock": "build",
  "lint": "build",
  "lintel": "build",
  "lintwhite": "heal",
  "linum": "heal",
  "linux": "smart",
  "liomys": "heal",
  "lion": "heal",
  "lion's-ear": "heal",
  "lioness": "heal",
  "lionet": "heal",
  "lionfish": "heal",
  "lionise": "sell",
  "lionize": "sell",
  "liopelma": "heal",
  "liopelmidae": "heal",
  "liothyronine": "heal",
  "lip": "heal",
  "lip-gloss": "build",
  "lip-read": "smart",
  "lip-sync": "story",
  "lip-synch": "story",
  "liparidae": "heal",
  "liparididae": "heal",
  "liparis": "heal",
  "lipfern": "heal",
  "lipitor": "build",
  "lipizzan": "heal",
  "lipless": "beautiful",
  "lipo-hepin": "build",
  "lipogram": "story",
  "lipomatosis": "heal",
  "liposcelis": "heal",
  "liposome": "heal",
  "lipotyphla": "heal",
  "lipped": "beautiful",
  "lippizan": "heal",
  "lippizaner": "heal",
  "lipread": "smart",
  "lipreading": "smart",
  "lipstick": "build",
  "liquaemin": "build",
  "liquefaction": "smart",
  "liqueur": "taste",
  "liquid": "story",
  "liquidambar": "heal",
  "liquidate": "build",
  "liquidiser": "build",
  "liquidize": "sell",
  "liquidizer": "build",
  "liquified": "beautiful",
  "liquor": "taste",
  "liquorice": "heal",
  "lira": "smart",
  "liriodendron": "heal",
  "liriope": "heal",
  "lisinopril": "build",
  "lisle": "build",
  "lisp": "story",
  "list": "story",
  "listed": "story",
  "listen": "sound",
  "listening": "sound",
  "lister": "build",
  "listera": "heal",
  "listeria": "heal",
  "listeriosis": "heal",
  "listing": "story",
  "lisu": "story",
  "lit": "smart",
  "litany": "story",
  "litas": "smart",
  "litchee": "taste",
  "litchi": "heal",
  "liter": "smart",
  "literacy": "smart",
  "literal": "story",
  "literalise": "smart",
  "literalism": "smart",
  "literalize": "smart",
  "literary": "beautiful",
  "literate": "beautiful",
  "literature": "story",
  "lithane": "build",
  "lithocarpus": "heal",
  "lithodidae": "heal",
  "lithoglyptics": "build",
  "lithograph": "beautiful",
  "lithographer": "beautiful",
  "lithographic": "beautiful",
  "lithography": "beautiful",
  "lithology": "smart",
  "lithomancy": "smart",
  "lithonate": "build",
  "lithophragma": "heal",
  "lithophyte": "heal",
  "lithops": "heal",
  "lithospermum": "heal",
  "lithuanian": "story",
  "lithuresis": "smart",
  "litigate": "sell",
  "litigious": "beautiful",
  "litocranius": "heal",
  "litotes": "story",
  "litre": "smart",
  "litter": "build",
  "litter-basket": "build",
  "litterbin": "build",
  "little": "smart",
  "littleneck": "taste",
  "littorina": "heal",
  "littorinidae": "heal",
  "liturgics": "smart",
  "liturgiology": "smart",
  "livable": "beautiful",
  "live-and-die": "heal",
  "live-bearer": "heal",
  "live-bearing": "beautiful",
  "live-forever": "heal",
  "liveable": "beautiful",
  "livelihood": "sell",
  "livelong": "heal",
  "lively": "beautiful",
  "liver": "heal",
  "liveried": "beautiful",
  "liverleaf": "heal",
  "liverwort": "heal",
  "liverwurst": "taste",
  "livery": "build",
  "livestock": "heal",
  "living": "smart",
  "living-room": "build",
  "livistona": "heal",
  "livonian": "story",
  "liza": "heal",
  "lizard": "heal",
  "lizard's-tail": "heal",
  "lizardfish": "heal",
  "llama": "heal",
  "llb": "story",
  "lld": "story",
  "llm": "story",
  "lo/ovral": "build",
  "loach": "heal",
  "load": "build",
  "loaded": "build",
  "loading": "build",
  "loads": "smart",
  "loadstar": "smart",
  "loaf": "taste",
  "loafer": "build",
  "loamless": "beautiful",
  "loamy": "beautiful",
  "loan": "sell",
  "loan-blend": "story",
  "loanblend": "story",
  "loaner": "build",
  "loaning": "sell",
  "loanword": "story",
  "loasa": "heal",
  "loasaceae": "heal",
  "lob": "build",
  "lobata": "heal",
  "lobate": "beautiful",
  "lobby": "build",
  "lobe": "heal",
  "lobefin": "heal",
  "lobelia": "heal",
  "lobeliaceae": "heal",
  "lobipes": "heal",
  "loblolly": "taste",
  "lobotes": "heal",
  "lobotidae": "heal",
  "lobscouse": "taste",
  "lobscuse": "taste",
  "lobster": "taste",
  "lobularia": "heal",
  "lobule": "heal",
  "lobworm": "heal",
  "local": "build",
  "localisation": "smart",
  "localise": "sell",
  "localism": "story",
  "localization": "smart",
  "localize": "sell",
  "locate": "sell",
  "locating": "sell",
  "location": "build",
  "locative": "story",
  "lochia": "heal",
  "lock": "build",
  "lock-gate": "build",
  "lockage": "sell",
  "lockbox": "build",
  "locker": "build",
  "locket": "build",
  "locking": "beautiful",
  "locknut": "build",
  "lockring": "build",
  "lockstitch": "build",
  "lockup": "build",
  "locomotive": "build",
  "locoweed": "heal",
  "locule": "heal",
  "loculus": "heal",
  "locum": "sound",
  "locust": "heal",
  "locusta": "heal",
  "locustidae": "heal",
  "locution": "story",
  "lode": "sound",
  "lodestar": "smart",
  "lodge": "build",
  "lodgement": "story",
  "lodgepole": "heal",
  "lodging": "build",
  "lodgings": "build",
  "lodgment": "story",
  "lodine": "build",
  "loeb": "heal",
  "loestrin": "build",
  "loewi": "heal",
  "lofortyx": "heal",
  "loft": "build",
  "log": "story",
  "log-in": "sell",
  "loganberry": "heal",
  "logania": "heal",
  "loganiaceae": "heal",
  "logarithm": "story",
  "logbook": "story",
  "loge": "build",
  "loggerhead": "heal",
  "loggia": "build",
  "logging": "story",
  "logic": "smart",
  "logical": "beautiful",
  "logicism": "smart",
  "logion": "story",
  "logistic": "sell",
  "logistical": "sell",
  "logistics": "sell",
  "logo": "beautiful",
  "logogram": "story",
  "logograph": "story",
  "logomachy": "story",
  "logomania": "heal",
  "logorrhea": "heal",
  "logos": "story",
  "logotype": "story",
  "logroll": "sell",
  "logrolling": "sell",
  "logwood": "heal",
  "loin": "taste",
  "loincloth": "build",
  "loins": "heal",
  "loir": "heal",
  "loiseleuria": "heal",
  "loligo": "heal",
  "lolium": "heal",
  "lollipop": "taste",
  "lolly": "sell",
  "lolo": "story",
  "lolo-burmese": "story",
  "loloish": "story",
  "lomariopsidaceae": "heal",
  "lomatia": "heal",
  "loment": "heal",
  "lomogramma": "heal",
  "lomotil": "build",
  "lomustine": "build",
  "lonas": "heal",
  "lonchocarpus": "heal",
  "long": "beautiful",
  "long-beard": "build",
  "long-distance": "beautiful",
  "long-legs": "heal",
  "long-spurred": "beautiful",
  "long-suffering": "beautiful",
  "long-windedness": "story",
  "longan": "heal",
  "longanberry": "heal",
  "longbeard": "build",
  "longboat": "build",
  "longbow": "build",
  "longer": "beautiful",
  "longhand": "story",
  "longhorn": "heal",
  "longicorn": "heal",
  "longitudinal": "beautiful",
  "longlegs": "heal",
  "longroot": "heal",
  "longshot": "build",
  "longwool": "heal",
  "longyi": "build",
  "lonicera": "heal",
  "loniten": "build",
  "lontar": "heal",
  "loo": "build",
  "loofa": "heal",
  "loofah": "heal",
  "look-alike": "beautiful",
  "lookdown": "heal",
  "looking": "sound",
  "lookout": "build",
  "lookup": "smart",
  "loom": "beautiful",
  "loon": "heal",
  "loonie": "smart",
  "loony": "beautiful",
  "loop": "build",
  "loop-line": "build",
  "looper": "heal",
  "loophole": "story",
  "looping": "smart",
  "loopy": "beautiful",
  "loos": "build",
  "loose": "sell",
  "loosen": "sell",
  "loosening": "sell",
  "loosestrife": "heal",
  "loot": "sell",
  "looting": "sell",
  "lop": "build",
  "lophiidae": "heal",
  "lophius": "heal",
  "lophodytes": "heal",
  "lopholatilus": "heal",
  "lophophora": "heal",
  "lophophorus": "heal",
  "lophosoria": "heal",
  "lophosoriaceae": "heal",
  "lopid": "build",
  "lopper": "build",
  "lopressor": "build",
  "loquat": "heal",
  "loranthaceae": "heal",
  "loranthus": "heal",
  "lorazepam": "build",
  "lorchel": "heal",
  "lord": "sell",
  "lords-and-ladies": "heal",
  "lordship": "story",
  "lore": "smart",
  "lorfan": "build",
  "lorgnette": "build",
  "lorica": "heal",
  "loricata": "heal",
  "loriinae": "heal",
  "lorikeet": "heal",
  "lorisidae": "heal",
  "lorry": "build",
  "lory": "heal",
  "lose": "sell",
  "losings": "sell",
  "loss": "sell",
  "losses": "sell",
  "lossless": "beautiful",
  "lossy": "beautiful",
  "lost": "sell",
  "lost-and-found": "build",
  "lot": "smart",
  "lota": "build",
  "loti": "smart",
  "lotic": "beautiful",
  "lotion": "build",
  "lots": "smart",
  "lotte": "heal",
  "lotus": "heal",
  "loud": "beautiful",
  "loud-hailer": "build",
  "louden": "sound",
  "loudspeaker": "build",
  "lounge": "build",
  "lounger": "build",
  "loungewear": "build",
  "loupe": "build",
  "lour": "heal",
  "louse": "heal",
  "louvar": "heal",
  "louver": "build",
  "louvre": "build",
  "lovable": "beautiful",
  "lovage": "heal",
  "lovastatin": "build",
  "love": "smart",
  "love-in-a-mist": "heal",
  "love-in-idleness": "heal",
  "love-in-winter": "heal",
  "love-lies-bleeding": "heal",
  "love-philter": "taste",
  "love-philtre": "taste",
  "love-potion": "taste",
  "love-song": "story",
  "love-token": "build",
  "loveable": "beautiful",
  "lovebird": "heal",
  "loved": "build",
  "lovely": "beautiful",
  "loveseat": "build",
  "loving": "build",
  "lovoa": "heal",
  "low": "build",
  "low-class": "beautiful",
  "low-down": "story",
  "low-interest": "beautiful",
  "low-level": "beautiful",
  "low-pitched": "beautiful",
  "low-resolution": "beautiful",
  "low-rise": "beautiful",
  "low-sudsing": "beautiful",
  "low-tech": "beautiful",
  "low-tension": "beautiful",
  "low-voltage": "beautiful",
  "low-warp-loom": "build",
  "lowan": "heal",
  "lowball": "smart",
  "lowborn": "beautiful",
  "lowboy": "build",
  "lowbrow": "beautiful",
  "lower": "build",
  "lower-class": "beautiful",
  "lowercase": "story",
  "lowered": "build",
  "lowland": "beautiful",
  "lox": "taste",
  "loxapine": "build",
  "loxia": "heal",
  "loxitane": "build",
  "loxodonta": "heal",
  "loxoma": "heal",
  "loxomataceae": "heal",
  "loxostege": "heal",
  "loyal": "beautiful",
  "lozal": "build",
  "lozenge": "taste",
  "lsd": "build",
  "ltm": "smart",
  "luba": "story",
  "lube": "build",
  "lubricate": "build",
  "lubricated": "build",
  "lucanidae": "heal",
  "lucerne": "heal",
  "lucifer": "build",
  "luciferin": "beautiful",
  "lucilia": "heal",
  "luck": "sound",
  "luckless": "beautiful",
  "lucky": "beautiful",
  "lucre": "sell",
  "lucubrate": "story",
  "lucubration": "story",
  "lucy": "heal",
  "ludian": "story",
  "lufengpithecus": "heal",
  "luff": "build",
  "luffa": "heal",
  "lug": "build",
  "luganda": "story",
  "luge": "build",
  "luger": "build",
  "luggage": "build",
  "lugger": "build",
  "luging": "build",
  "lugsail": "build",
  "lugworm": "heal",
  "luke": "story",
  "lullaby": "story",
  "lumber": "build",
  "lumbering": "build",
  "lumberjack": "build",
  "lumbermill": "build",
  "lumberyard": "build",
  "lumbus": "heal",
  "lumen": "smart",
  "luminal": "build",
  "luminescence": "sound",
  "lumma": "smart",
  "lumpenus": "heal",
  "lumpfish": "heal",
  "lumpsucker": "heal",
  "lunaria": "heal",
  "lunatic": "beautiful",
  "lunch": "taste",
  "luncheon": "taste",
  "lunching": "taste",
  "lunchroom": "build",
  "lunda": "heal",
  "lunette": "build",
  "lung": "heal",
  "lungen": "heal",
  "lungfish": "heal",
  "lungi": "build",
  "lungyi": "build",
  "lunula": "heal",
  "lunule": "heal",
  "luo": "story",
  "lupin": "heal",
  "lupine": "heal",
  "lupinus": "heal",
  "lure": "smart",
  "luridness": "story",
  "lusatian": "story",
  "luscinia": "heal",
  "lush": "beautiful",
  "lust": "taste",
  "luster": "build",
  "lusterware": "build",
  "lustre": "build",
  "lute": "build",
  "lutefisk": "taste",
  "lutein": "beautiful",
  "lutfisk": "taste",
  "lutheranism": "smart",
  "luthier": "sound",
  "lutjanidae": "heal",
  "lutjanus": "heal",
  "lutra": "heal",
  "lutrinae": "heal",
  "luvaridae": "heal",
  "luvarus": "heal",
  "luvian": "story",
  "luwian": "story",
  "lux": "smart",
  "luxuriate": "taste",
  "luyia": "story",
  "lwei": "smart",
  "lxx": "smart",
  "lxxviii": "smart",
  "lxxx": "smart",
  "lycaena": "heal",
  "lycaenid": "heal",
  "lycaenidae": "heal",
  "lycaeon": "heal",
  "lyceum": "build",
  "lychee": "taste",
  "lychgate": "build",
  "lychnis": "heal",
  "lycian": "story",
  "lycium": "heal",
  "lycoperdaceae": "heal",
  "lycoperdales": "heal",
  "lycoperdon": "heal",
  "lycopersicon": "heal",
  "lycopersicum": "heal",
  "lycophyta": "heal",
  "lycopod": "heal",
  "lycopodiaceae": "heal",
  "lycopodiales": "heal",
  "lycopodiate": "heal",
  "lycopodineae": "heal",
  "lycopodium": "heal",
  "lycopsida": "heal",
  "lycopus": "heal",
  "lycosa": "heal",
  "lycosidae": "heal",
  "lydian": "story",
  "lygaeid": "heal",
  "lygaeidae": "heal",
  "lyginopteridales": "heal",
  "lyginopteris": "heal",
  "lygodium": "heal",
  "lygus": "heal",
  "lying": "build",
  "lymantria": "heal",
  "lymantriid": "heal",
  "lymantriidae": "heal",
  "lymph": "heal",
  "lymphangiogram": "build",
  "lymphoblast": "heal",
  "lymphocyte": "heal",
  "lymphopoiesis": "smart",
  "lynch": "sell",
  "lynching": "sell",
  "lynchpin": "smart",
  "lynx": "story",
  "lyonia": "heal",
  "lyons": "sound",
  "lyophilisation": "smart",
  "lyophilization": "smart",
  "lypressin": "build",
  "lyre": "build",
  "lyre-flower": "heal",
  "lyrebird": "heal",
  "lyreflower": "heal",
  "lyric": "sound",
  "lyrurus": "heal",
  "lysichiton": "heal",
  "lysichitum": "heal",
  "lysiloma": "heal",
  "lysimachia": "heal",
  "lysis": "smart",
  "lysogenisation": "smart",
  "lysogenization": "smart",
  "lysosome": "heal",
  "lyssavirus": "heal",
  "lythraceae": "heal",
  "lythrum": "heal",
  "m-1": "build",
  "m-theory": "smart",
  "mac": "build",
  "macaca": "heal",
  "macadam": "build",
  "macadamia": "heal",
  "macadamise": "build",
  "macadamize": "build",
  "macamba": "heal",
  "macaque": "heal",
  "macaroni": "taste",
  "macaroon": "taste",
  "macaw": "heal",
  "mace": "taste",
  "macedoine": "taste",
  "macedonian": "story",
  "maceration": "smart",
  "macguffin": "smart",
  "machaeranthera": "heal",
  "machete": "build",
  "machiavellianism": "smart",
  "machicolate": "sell",
  "machicolation": "build",
  "machilid": "heal",
  "machilidae": "heal",
  "machinate": "build",
  "machination": "smart",
  "machine": "smart",
  "machine-made": "beautiful",
  "machine-wash": "build",
  "machinery": "build",
  "machmeter": "build",
  "macho": "beautiful",
  "macintosh": "build",
  "mack": "build",
  "mackerel": "taste",
  "mackinaw": "build",
  "mackintosh": "build",
  "mackle": "story",
  "macleaya": "heal",
  "macleod": "heal",
  "maclura": "heal",
  "macon": "taste",
  "maconnais": "taste",
  "macoun": "taste",
  "macowanites": "heal",
  "macrame": "beautiful",
  "macro": "story",
  "macrobiotics": "smart",
  "macrocephalon": "heal",
  "macrocheira": "heal",
  "macroclemys": "heal",
  "macrocyte": "heal",
  "macrodactylus": "heal",
  "macrodantin": "build",
  "macroeconomics": "smart",
  "macroevolution": "smart",
  "macroglia": "heal",
  "macron": "story",
  "macronectes": "heal",
  "macrophage": "heal",
  "macropodidae": "heal",
  "macropus": "heal",
  "macrorhamphosidae": "heal",
  "macrosporangium": "heal",
  "macrospore": "heal",
  "macrothelypteris": "heal",
  "macrotis": "heal",
  "macrotus": "heal",
  "macrotyloma": "heal",
  "macrouridae": "heal",
  "macrozamia": "heal",
  "macrozoarces": "heal",
  "macruridae": "heal",
  "macula": "sound",
  "maculate": "build",
  "macule": "heal",
  "macumba": "story",
  "madake": "heal",
  "madcap": "beautiful",
  "madder": "heal",
  "madderwort": "heal",
  "made": "sell",
  "madeira": "taste",
  "madeiras": "taste",
  "mademoiselle": "heal",
  "madhouse": "build",
  "madia": "heal",
  "madnep": "heal",
  "madness": "smart",
  "madoqua": "heal",
  "madras": "build",
  "madreporaria": "heal",
  "madrepore": "heal",
  "madrigal": "story",
  "madrilene": "taste",
  "madrona": "heal",
  "madrono": "heal",
  "madwort": "heal",
  "maeandra": "heal",
  "mafa": "story",
  "mag": "story",
  "magadhan": "story",
  "magazine": "story",
  "magenta": "beautiful",
  "maggot": "heal",
  "magic": "smart",
  "magicicada": "heal",
  "magisterial": "beautiful",
  "magnet": "build",
  "magnetic": "beautiful",
  "magnetics": "smart",
  "magnetisation": "smart",
  "magnetise": "story",
  "magnetised": "story",
  "magnetism": "sound",
  "magnetization": "smart",
  "magnetize": "story",
  "magnetized": "story",
  "magneto": "build",
  "magnetograph": "build",
  "magnetohydrodynamics": "smart",
  "magnetometer": "build",
  "magneton": "smart",
  "magnetosphere": "sound",
  "magnetron": "build",
  "magnificat": "story",
  "magnification": "story",
  "magnifier": "build",
  "magnify": "story",
  "magniloquence": "story",
  "magnolia": "heal",
  "magnoliaceae": "heal",
  "magnoliidae": "heal",
  "magnoliophyta": "heal",
  "magnoliopsid": "heal",
  "magnoliopsida": "heal",
  "magnum": "build",
  "magpie": "heal",
  "maguey": "heal",
  "magyar": "story",
  "mahabharata": "story",
  "mahabharatam": "story",
  "mahabharatum": "story",
  "mahagua": "heal",
  "mahayana": "smart",
  "mahayanism": "smart",
  "mahdism": "smart",
  "mahican": "story",
  "mahimahi": "taste",
  "mahlstick": "build",
  "mahoe": "heal",
  "mahogany": "heal",
  "mahonia": "heal",
  "mahratti": "story",
  "mahuang": "heal",
  "maia": "heal",
  "maianthemum": "heal",
  "maiden": "beautiful",
  "maidenhair": "heal",
  "maidenhead": "heal",
  "maidu": "story",
  "maiger": "heal",
  "maigre": "heal",
  "maikoa": "heal",
  "mail": "story",
  "mailbag": "build",
  "mailboat": "build",
  "mailbox": "build",
  "maildrop": "build",
  "mailer": "story",
  "mailing": "build",
  "mailing-card": "story",
  "maillot": "build",
  "mailsorter": "build",
  "maim": "heal",
  "maimed": "heal",
  "main": "build",
  "main-topmast": "build",
  "main-topsail": "build",
  "mainframe": "build",
  "mainline": "taste",
  "mainmast": "build",
  "mainsail": "build",
  "mainsheet": "build",
  "mainspring": "build",
  "mainstay": "smart",
  "mainstream": "smart",
  "maintain": "sell",
  "maintenance": "sell",
  "maiolica": "build",
  "maisonette": "build",
  "maisonnette": "build",
  "maize": "heal",
  "maja": "heal",
  "majagua": "heal",
  "majidae": "heal",
  "majolica": "build",
  "major": "smart",
  "majorana": "heal",
  "majority": "smart",
  "majuscule": "story",
  "makaira": "heal",
  "make": "smart",
  "make-believe": "smart",
  "make-up": "build",
  "makeshift": "beautiful",
  "makeup": "beautiful",
  "makeweight": "build",
  "making": "build",
  "mako": "heal",
  "makomako": "heal",
  "malabsorption": "smart",
  "malacanthidae": "heal",
  "malacca": "heal",
  "malachi": "story",
  "malachias": "story",
  "malaclemys": "heal",
  "malacology": "smart",
  "malaconotinae": "heal",
  "malacopterygian": "heal",
  "malacopterygii": "heal",
  "malacosoma": "heal",
  "malacostraca": "heal",
  "malacothamnus": "heal",
  "maladaptive": "beautiful",
  "maladjusted": "beautiful",
  "maladroit": "beautiful",
  "maladroitness": "smart",
  "malady": "heal",
  "malamute": "heal",
  "malanga": "heal",
  "malaprop": "story",
  "malapropism": "story",
  "malapropos": "beautiful",
  "malar": "heal",
  "malarkey": "story",
  "malarky": "story",
  "malaxis": "heal",
  "malaxis-unifolia": "heal",
  "malay": "story",
  "malayalam": "story",
  "malayo-polynesian": "story",
  "malaysian": "story",
  "malcolmia": "heal",
  "malcontent": "beautiful",
  "male": "heal",
  "maleberry": "heal",
  "malecite": "story",
  "maledict": "story",
  "malediction": "story",
  "maleficent": "beautiful",
  "malemute": "heal",
  "maleo": "heal",
  "maleseet": "story",
  "malfunction": "build",
  "malfunctioning": "build",
  "malicious": "beautiful",
  "malign": "story",
  "malignant": "heal",
  "malignment": "story",
  "malinger": "sell",
  "malingering": "sell",
  "malinois": "heal",
  "mall": "build",
  "mallard": "heal",
  "mallee": "heal",
  "mallet": "build",
  "malleus": "heal",
  "mallophaga": "heal",
  "mallotus": "heal",
  "mallow": "heal",
  "malmsey": "taste",
  "malnourish": "taste",
  "malnourished": "taste",
  "malodor": "smart",
  "malodorous": "beautiful",
  "malodour": "smart",
  "malodourous": "beautiful",
  "malonylurea": "sound",
  "malope": "heal",
  "malopterurus": "heal",
  "malosma": "heal",
  "malpighia": "heal",
  "malpighiaceae": "heal",
  "mals": "story",
  "malt": "taste",
  "malted": "taste",
  "maltese": "story",
  "malthusianism": "smart",
  "malti": "story",
  "malto": "story",
  "maltreat": "sell",
  "maltreated": "sell",
  "malus": "heal",
  "malva": "heal",
  "malvaceae": "heal",
  "malvales": "heal",
  "malvasia": "heal",
  "malvastrum": "heal",
  "malvaviscus": "heal",
  "malversate": "sell",
  "mam": "story",
  "mamba": "heal",
  "mamey": "heal",
  "mamilla": "heal",
  "mamma": "heal",
  "mammal": "heal",
  "mammalia": "heal",
  "mammalian": "heal",
  "mammalogy": "smart",
  "mammea": "heal",
  "mammee": "heal",
  "mammilla": "heal",
  "mammillaria": "heal",
  "mammogram": "build",
  "mammography": "heal",
  "mammoth": "heal",
  "mammut": "heal",
  "mammuthus": "heal",
  "mammutidae": "heal",
  "mamo": "heal",
  "mamoncillo": "heal",
  "man": "heal",
  "man-eater": "heal",
  "man-of-the-earth": "heal",
  "man-of-war": "build",
  "man-on-a-horse": "heal",
  "manacle": "build",
  "manage": "sell",
  "manageable": "beautiful",
  "manakin": "build",
  "manat": "smart",
  "manatee": "heal",
  "manchu": "story",
  "manda": "story",
  "mandaean": "story",
  "mandaeanism": "smart",
  "mandala": "build",
  "mandamus": "story",
  "mandara": "story",
  "mandarin": "heal",
  "mandate": "story",
  "mandatory": "beautiful",
  "mande": "story",
  "mandean": "story",
  "mandeanism": "smart",
  "mandelamine": "build",
  "mandevilla": "heal",
  "mandible": "heal",
  "mandibula": "heal",
  "mandioc": "heal",
  "mandioca": "heal",
  "mandola": "build",
  "mandolin": "sound",
  "mandragora": "heal",
  "mandrake": "heal",
  "mandrel": "build",
  "mandril": "build",
  "mandrill": "heal",
  "mandrillus": "heal",
  "manduca": "heal",
  "manducate": "taste",
  "mane": "heal",
  "manes": "heal",
  "maneuver": "smart",
  "manful": "beautiful",
  "mangabey": "heal",
  "mangel-wurzel": "heal",
  "manger": "build",
  "mangifera": "heal",
  "mangle": "build",
  "manglietia": "heal",
  "mango": "heal",
  "mangold": "heal",
  "mangold-wurzel": "heal",
  "mangonel": "build",
  "mangosteen": "heal",
  "mangrove": "heal",
  "manhandle": "build",
  "manhattan": "taste",
  "manhole": "build",
  "maniac": "beautiful",
  "manic-depressive": "beautiful",
  "manichaeanism": "smart",
  "manichaeism": "smart",
  "manicotti": "taste",
  "manicure": "beautiful",
  "manidae": "heal",
  "manifest": "story",
  "manifestation": "story",
  "manifesto": "story",
  "manifold": "build",
  "manihot": "heal",
  "manikin": "build",
  "manilkara": "heal",
  "manioc": "heal",
  "manipulable": "beautiful",
  "manipulate": "sell",
  "maniraptor": "heal",
  "maniraptora": "heal",
  "manis": "heal",
  "mankind": "heal",
  "manlike": "beautiful",
  "manly": "beautiful",
  "manna": "heal",
  "manned": "sell",
  "mannequin": "build",
  "manner": "smart",
  "manners": "smart",
  "mannikin": "build",
  "mannitol": "build",
  "manoeuver": "sell",
  "manoeuvre": "smart",
  "manometer": "build",
  "manor": "build",
  "manpad": "build",
  "manroot": "heal",
  "mansard": "build",
  "manse": "build",
  "mansi": "story",
  "mansion": "build",
  "manta": "build",
  "manteidae": "heal",
  "mantel": "build",
  "mantelet": "build",
  "mantelpiece": "build",
  "manteodea": "heal",
  "mantid": "heal",
  "mantidae": "heal",
  "mantilla": "build",
  "mantis": "heal",
  "mantispid": "heal",
  "mantispidae": "heal",
  "mantissa": "story",
  "mantle": "story",
  "mantlepiece": "build",
  "mantlet": "build",
  "mantophasmatodea": "heal",
  "mantra": "story",
  "mantrap": "build",
  "mantua": "build",
  "manual": "story",
  "manubrium": "heal",
  "manufactory": "build",
  "manufacture": "build",
  "manufacturing": "build",
  "manul": "heal",
  "manumit": "sell",
  "manus": "heal",
  "manuscript": "story",
  "manx": "story",
  "many": "beautiful",
  "many-sided": "beautiful",
  "manzanilla": "taste",
  "manzanita": "heal",
  "maoi": "build",
  "maoism": "smart",
  "maori": "story",
  "map": "build",
  "mapinguari": "heal",
  "maple": "heal",
  "maple-leaf": "story",
  "mapping": "build",
  "mapquest": "story",
  "maquiladora": "build",
  "mar": "heal",
  "mara": "heal",
  "marabou": "heal",
  "marabout": "heal",
  "maraca": "build",
  "maraco": "story",
  "marang": "heal",
  "maranta": "heal",
  "marantaceae": "heal",
  "marasca": "heal",
  "maraschino": "taste",
  "marasmius": "heal",
  "marathi": "story",
  "marattia": "heal",
  "marattiaceae": "heal",
  "marattiales": "heal",
  "maravilla": "heal",
  "marble": "build",
  "marble-wood": "heal",
  "marbles": "smart",
  "marblewood": "heal",
  "marbling": "taste",
  "marc": "taste",
  "marcel": "heal",
  "marchantia": "heal",
  "marchantiaceae": "heal",
  "marchantiales": "heal",
  "marchpane": "taste",
  "marcionism": "smart",
  "mare": "heal",
  "margarin": "taste",
  "margarine": "taste",
  "margarita": "taste",
  "margate": "heal",
  "margay": "heal",
  "marge": "taste",
  "margin": "sell",
  "marginalia": "story",
  "marginalisation": "smart",
  "marginalise": "sell",
  "marginalization": "smart",
  "marginalize": "sell",
  "marginocephalia": "heal",
  "marginocephalian": "heal",
  "margosa": "heal",
  "marguerite": "heal",
  "mari": "story",
  "maria": "heal",
  "maricopa": "story",
  "marigold": "heal",
  "marihuana": "heal",
  "marijuana": "heal",
  "marimba": "build",
  "marina": "build",
  "marinade": "taste",
  "marinara": "taste",
  "marineland": "build",
  "marionette": "build",
  "mariposa": "heal",
  "mariposan": "story",
  "maritime": "beautiful",
  "marjoram": "heal",
  "mark": "smart",
  "marked": "build",
  "marker": "beautiful",
  "market": "sell",
  "marketing": "sell",
  "marketplace": "build",
  "markhoor": "heal",
  "markhor": "heal",
  "marking": "story",
  "markka": "smart",
  "marks": "smart",
  "marksmanship": "smart",
  "markup": "sell",
  "markweed": "heal",
  "marlberry": "heal",
  "marlin": "heal",
  "marline": "build",
  "marlinespike": "build",
  "marlingspike": "build",
  "marlinspike": "build",
  "marmalade": "taste",
  "marmite": "taste",
  "marmoset": "heal",
  "marmot": "heal",
  "marmota": "heal",
  "marocain": "build",
  "maroon": "build",
  "marplan": "build",
  "marque": "story",
  "marquee": "build",
  "marqueterie": "build",
  "marquetry": "build",
  "marquise": "build",
  "marri": "heal",
  "married": "sell",
  "marrow": "heal",
  "marrowbone": "taste",
  "marrubium": "heal",
  "marry": "sell",
  "marsala": "taste",
  "marseillaise": "story",
  "marseille": "build",
  "marseilles": "build",
  "marshal": "build",
  "marshmallow": "taste",
  "marsilea": "heal",
  "marsileaceae": "heal",
  "marsupial": "heal",
  "marsupialia": "heal",
  "marsupium": "heal",
  "mart": "build",
  "martagon": "heal",
  "marten": "heal",
  "martes": "heal",
  "martial": "beautiful",
  "martingale": "build",
  "martini": "taste",
  "martynia": "heal",
  "martyniaceae": "heal",
  "martyr": "build",
  "martyrise": "heal",
  "martyrize": "heal",
  "marum": "heal",
  "marumi": "heal",
  "marupa": "heal",
  "marvel": "story",
  "marvel-of-peru": "heal",
  "marxism": "smart",
  "marxism-leninism": "smart",
  "marzipan": "taste",
  "masa": "story",
  "masai": "story",
  "mascara": "build",
  "mascarpone": "taste",
  "masculine": "story",
  "masculinisation": "smart",
  "masculinization": "smart",
  "masdevallia": "heal",
  "maser": "build",
  "mash": "taste",
  "masher": "build",
  "mashi": "story",
  "mashie": "build",
  "masjid": "build",
  "mask": "build",
  "masking": "smart",
  "masochistic": "beautiful",
  "masonic": "build",
  "masonite": "build",
  "masonry": "build",
  "masora": "story",
  "masorah": "story",
  "masquerade": "build",
  "mass": "smart",
  "mass-produce": "build",
  "massachuset": "story",
  "massachusetts": "story",
  "massage": "build",
  "massasauga": "heal",
  "masses": "smart",
  "masseter": "heal",
  "massicot": "beautiful",
  "massicotite": "beautiful",
  "mast": "build",
  "mastaba": "build",
  "mastabah": "build",
  "mastering": "smart",
  "mastermind": "smart",
  "masterpiece": "build",
  "mastership": "smart",
  "masterwort": "heal",
  "mastery": "smart",
  "masthead": "story",
  "mastic": "heal",
  "masticate": "build",
  "masticophis": "heal",
  "mastiff": "heal",
  "mastigomycota": "heal",
  "mastigomycotina": "heal",
  "mastigophora": "heal",
  "mastigophoran": "heal",
  "mastigophore": "heal",
  "mastigoproctus": "heal",
  "mastocyte": "heal",
  "mastodon": "heal",
  "mastodont": "heal",
  "mastoid": "heal",
  "mastoidal": "heal",
  "mastoidale": "heal",
  "mastopathy": "heal",
  "mastotermes": "heal",
  "mastotermitidae": "heal",
  "masturbate": "build",
  "mat": "build",
  "matabele": "story",
  "matai": "heal",
  "matakam": "story",
  "match": "build",
  "matchboard": "build",
  "matchbook": "build",
  "matchbox": "build",
  "matchbush": "heal",
  "matched": "sell",
  "matchet": "build",
  "matchlock": "build",
  "matchstick": "build",
  "matchweed": "heal",
  "mated": "build",
  "matelote": "taste",
  "mater": "beautiful",
  "material": "story",
  "materialisation": "smart",
  "materialism": "smart",
  "materialization": "smart",
  "materiel": "build",
  "maternal": "beautiful",
  "math": "smart",
  "mathematical": "beautiful",
  "mathematics": "smart",
  "maths": "smart",
  "matinee": "story",
  "mating": "build",
  "matriarchal": "beautiful",
  "matricaria": "heal",
  "matriculate": "sell",
  "matrix": "heal",
  "matronymic": "story",
  "matt": "beautiful",
  "matte": "beautiful",
  "matter": "smart",
  "matteuccia": "heal",
  "matthew": "story",
  "matthiola": "heal",
  "matting": "build",
  "mattock": "build",
  "mattole": "story",
  "mattress": "build",
  "maturate": "heal",
  "maturation": "smart",
  "mature": "story",
  "maturement": "smart",
  "matzah": "taste",
  "matzo": "taste",
  "matzoh": "taste",
  "maul": "build",
  "maulers": "heal",
  "maulstick": "build",
  "maund": "smart",
  "maunder": "story",
  "mauser": "build",
  "mausoleum": "build",
  "mauve": "beautiful",
  "maverick": "heal",
  "mavik": "build",
  "mavis": "heal",
  "maw": "heal",
  "max": "build",
  "maxi": "build",
  "maxilla": "heal",
  "maxillaria": "heal",
  "maxillary": "heal",
  "maxim": "story",
  "maximal": "beautiful",
  "maximum": "smart",
  "maxostoma": "heal",
  "maxwell": "smart",
  "maxzide": "build",
  "may": "heal",
  "maya": "story",
  "mayaca": "heal",
  "mayacaceae": "heal",
  "mayan": "story",
  "mayapple": "heal",
  "mayas": "story",
  "mayday": "story",
  "mayeng": "heal",
  "mayetiola": "heal",
  "mayfish": "heal",
  "mayflower": "build",
  "mayfly": "heal",
  "mayhaw": "heal",
  "mayo": "taste",
  "mayonnaise": "taste",
  "maypole": "build",
  "maypop": "heal",
  "mays": "heal",
  "mayweed": "heal",
  "mazama": "heal",
  "mazdaism": "smart",
  "maze": "build",
  "mazer": "build",
  "mazopathy": "heal",
  "mazurka": "story",
  "mazzard": "heal",
  "mba": "story",
  "mbit": "smart",
  "mcg": "smart",
  "mcguffin": "smart",
  "mcintosh": "taste",
  "mdiv": "story",
  "mdma": "build",
  "mead": "taste",
  "meadowgrass": "heal",
  "meadowlark": "heal",
  "meager": "beautiful",
  "meagerly": "beautiful",
  "meagre": "beautiful",
  "meal": "taste",
  "mealberry": "heal",
  "mealie": "heal",
  "mealworm": "heal",
  "mealy": "beautiful",
  "mealybug": "heal",
  "mean": "smart",
  "meaning": "story",
  "meaningful": "beautiful",
  "meaningless": "beautiful",
  "meaninglessness": "story",
  "means": "build",
  "meanspirited": "beautiful",
  "mearstone": "story",
  "measurable": "beautiful",
  "measure": "build",
  "measured": "smart",
  "measuring": "smart",
  "meat": "taste",
  "meatball": "taste",
  "meatless": "beautiful",
  "meatloaf": "taste",
  "meatus": "heal",
  "meaty": "beautiful",
  "mebaral": "build",
  "mebendazole": "build",
  "mebibit": "smart",
  "mebibyte": "smart",
  "meccano": "build",
  "mechanic": "beautiful",
  "mechanical": "beautiful",
  "mechanics": "smart",
  "mechanism": "smart",
  "mechanistic": "beautiful",
  "mecholyl": "build",
  "meclizine": "build",
  "meclofenamate": "build",
  "meclomen": "build",
  "meconopsis": "heal",
  "mecoptera": "heal",
  "mecopteran": "heal",
  "med": "story",
  "medal": "story",
  "medallion": "sell",
  "medawar": "heal",
  "meddle": "sell",
  "meddling": "sell",
  "medfly": "heal",
  "mediaeval": "beautiful",
  "median": "smart",
  "mediant": "story",
  "mediastinum": "heal",
  "mediate": "story",
  "mediation": "story",
  "medic": "heal",
  "medicago": "heal",
  "medical": "heal",
  "medicament": "build",
  "medicate": "heal",
  "medication": "heal",
  "medicine": "heal",
  "medick": "heal",
  "mediety": "smart",
  "medieval": "beautiful",
  "medinilla": "heal",
  "meditate": "smart",
  "meditation": "smart",
  "medium": "story",
  "medlar": "heal",
  "medlars": "story",
  "medley": "story",
  "medline": "build",
  "medoc": "taste",
  "medulla": "heal",
  "medusa": "heal",
  "medusan": "heal",
  "medusoid": "heal",
  "meed": "sell",
  "meerestone": "story",
  "meerkat": "heal",
  "meerschaum": "build",
  "meet": "sell",
  "meetinghouse": "build",
  "mefloquine": "build",
  "mefoxin": "build",
  "meg": "smart",
  "megabat": "heal",
  "megabit": "smart",
  "megabucks": "sell",
  "megabyte": "smart",
  "megachile": "heal",
  "megachilidae": "heal",
  "megachiroptera": "heal",
  "megacolon": "heal",
  "megaderma": "heal",
  "megadermatidae": "heal",
  "megaflop": "smart",
  "megagametophyte": "heal",
  "megakaryocyte": "heal",
  "megalith": "build",
  "megalobatrachus": "heal",
  "megaloblast": "heal",
  "megalocyte": "heal",
  "megalomaniac": "heal",
  "megalonychidae": "heal",
  "megaloptera": "heal",
  "megalosaur": "heal",
  "megalosauridae": "heal",
  "megalosaurus": "heal",
  "megaphone": "build",
  "megapode": "heal",
  "megapodiidae": "heal",
  "megapodius": "heal",
  "megaptera": "heal",
  "megasporangium": "heal",
  "megaspore": "heal",
  "megasporophyll": "heal",
  "megathere": "heal",
  "megatherian": "heal",
  "megatheriid": "heal",
  "megatheriidae": "heal",
  "megatherium": "heal",
  "megaton": "smart",
  "megawatt": "smart",
  "megillah": "story",
  "megohm": "smart",
  "mei": "heal",
  "meiosis": "smart",
  "melampodium": "heal",
  "melampsora": "heal",
  "melampsoraceae": "heal",
  "melancholic": "beautiful",
  "melancholy": "heal",
  "melanerpes": "heal",
  "melanin": "beautiful",
  "melanitta": "heal",
  "melanoblast": "heal",
  "melanocyte": "heal",
  "melanogrammus": "heal",
  "melanoplus": "heal",
  "melanotis": "heal",
  "melanthiaceae": "heal",
  "melastoma": "heal",
  "melastomaceae": "heal",
  "melastomataceae": "heal",
  "melatonin": "heal",
  "meld": "story",
  "meleagrididae": "heal",
  "meleagris": "heal",
  "meles": "heal",
  "melia": "heal",
  "meliaceae": "heal",
  "melicocca": "heal",
  "melicoccus": "heal",
  "melicytus": "heal",
  "melilot": "heal",
  "melilotus": "heal",
  "melinae": "heal",
  "melioration": "smart",
  "meliorism": "smart",
  "meliphagidae": "heal",
  "melissa": "heal",
  "mellaril": "build",
  "mellivora": "heal",
  "mellow": "beautiful",
  "mellowing": "smart",
  "mellowness": "smart",
  "melocactus": "heal",
  "melodic": "sound",
  "melodious": "beautiful",
  "melodise": "build",
  "melodize": "build",
  "melodrama": "story",
  "melody": "sound",
  "melogale": "heal",
  "meloid": "heal",
  "meloidae": "heal",
  "melolontha": "heal",
  "melolonthidae": "heal",
  "melon": "taste",
  "melophagus": "heal",
  "melopsittacus": "heal",
  "melosa": "heal",
  "melospiza": "heal",
  "melphalan": "build",
  "melt": "smart",
  "meltdown": "smart",
  "melting": "smart",
  "melursus": "heal",
  "mem": "story",
  "member": "heal",
  "membered": "beautiful",
  "memberless": "beautiful",
  "membracidae": "heal",
  "membrane": "heal",
  "membranophone": "build",
  "membranous": "beautiful",
  "meme": "smart",
  "memento": "smart",
  "memo": "story",
  "memoir": "story",
  "memorabilia": "story",
  "memoranda": "story",
  "memorandum": "story",
  "memorial": "story",
  "memorialise": "story",
  "memorialize": "story",
  "memorisation": "smart",
  "memorise": "smart",
  "memorization": "smart",
  "memorize": "smart",
  "memory": "smart",
  "men's": "build",
  "menace": "story",
  "menagerie": "build",
  "mend": "build",
  "mendelevium": "sound",
  "mendelianism": "smart",
  "mendelism": "smart",
  "mendicancy": "story",
  "mendicant": "beautiful",
  "mending": "build",
  "menhaden": "heal",
  "menhir": "build",
  "menial": "beautiful",
  "meninges": "heal",
  "meninx": "heal",
  "menippe": "heal",
  "meniscium": "heal",
  "meniscus": "heal",
  "menispermaceae": "heal",
  "menispermum": "heal",
  "mennonitism": "smart",
  "menominee": "story",
  "menomini": "story",
  "menopon": "heal",
  "menorah": "build",
  "menorrhagia": "smart",
  "menorrhea": "heal",
  "menotyphla": "heal",
  "menses": "smart",
  "menstruate": "heal",
  "menstruation": "smart",
  "menstruum": "smart",
  "mensurable": "beautiful",
  "mensural": "sound",
  "mensurate": "smart",
  "mental": "beautiful",
  "mentalism": "smart",
  "mentality": "smart",
  "mentation": "smart",
  "mentha": "heal",
  "menthol": "build",
  "menticirrhus": "heal",
  "mention": "story",
  "mentor": "story",
  "mentum": "heal",
  "mentzelia": "heal",
  "menu": "taste",
  "menura": "heal",
  "menurae": "heal",
  "menuridae": "heal",
  "menyanthaceae": "heal",
  "menyanthes": "heal",
  "menziesia": "heal",
  "meow": "story",
  "mepacrine": "build",
  "meperidine": "build",
  "mephaquine": "build",
  "mephenytoin": "build",
  "mephitinae": "heal",
  "mephitis": "smart",
  "mephobarbital": "build",
  "meprin": "build",
  "meprobamate": "build",
  "merbromine": "build",
  "mercantile": "beautiful",
  "mercaptopurine": "build",
  "mercenaria": "heal",
  "mercenary": "beautiful",
  "merchandise": "build",
  "merchandising": "sell",
  "merchantman": "build",
  "merciful": "beautiful",
  "merciless": "beautiful",
  "mercurial": "beautiful",
  "mercurialis": "heal",
  "mercurochrome": "build",
  "mere": "beautiful",
  "merestone": "story",
  "meretricious": "beautiful",
  "merganser": "heal",
  "merginae": "heal",
  "mergus": "heal",
  "mericarp": "heal",
  "meridional": "beautiful",
  "meringue": "taste",
  "merino": "heal",
  "meriones": "heal",
  "meristem": "heal",
  "merited": "beautiful",
  "meritocracy": "smart",
  "merl": "heal",
  "merlangus": "heal",
  "merle": "heal",
  "merlin": "heal",
  "merlon": "build",
  "merlot": "heal",
  "merluccius": "heal",
  "meronym": "story",
  "meropidae": "heal",
  "merops": "heal",
  "merostomata": "heal",
  "merozoite": "heal",
  "merrimac": "build",
  "merry-go-round": "build",
  "mertensia": "heal",
  "merthiolate": "build",
  "meryta": "heal",
  "mesantoin": "build",
  "mescal": "heal",
  "mescaline": "build",
  "mesembryanthemum": "heal",
  "mesencephalon": "heal",
  "mesenchyme": "heal",
  "mesentery": "heal",
  "mesh": "smart",
  "meshed": "build",
  "meshing": "build",
  "meshuggeneh": "beautiful",
  "meshuggener": "beautiful",
  "meshwork": "build",
  "mesial": "beautiful",
  "mesic": "beautiful",
  "mesmerise": "story",
  "mesmerize": "story",
  "mesoblast": "heal",
  "mesocarp": "heal",
  "mesocolon": "heal",
  "mesocricetus": "heal",
  "mesoderm": "heal",
  "mesohippus": "heal",
  "mesomorphic": "beautiful",
  "mesophyron": "heal",
  "mesophyte": "heal",
  "mesothelium": "heal",
  "mespilus": "heal",
  "mesquit": "heal",
  "mesquite": "heal",
  "mess": "taste",
  "message": "story",
  "messaging": "story",
  "messiah": "story",
  "messuage": "build",
  "mesua": "heal",
  "metabola": "heal",
  "metabolic": "beautiful",
  "metabolise": "taste",
  "metabolism": "smart",
  "metabolize": "taste",
  "metabolous": "beautiful",
  "metacarpal": "heal",
  "metacarpus": "heal",
  "metacenter": "smart",
  "metacentre": "smart",
  "metagenesis": "sound",
  "metaknowledge": "smart",
  "metal": "build",
  "metalanguage": "story",
  "metalepsis": "story",
  "metalize": "build",
  "metallic": "build",
  "metallize": "build",
  "metallurgist": "build",
  "metallurgy": "smart",
  "metalware": "build",
  "metalwork": "build",
  "metalworks": "build",
  "metamathematics": "smart",
  "metamere": "heal",
  "metamorphic": "beautiful",
  "metamorphism": "smart",
  "metamorphosis": "smart",
  "metamorphous": "beautiful",
  "metaphase": "smart",
  "metaphor": "story",
  "metaphysical": "beautiful",
  "metaphysics": "smart",
  "metaphysis": "heal",
  "metaproterenol": "build",
  "metarule": "smart",
  "metasequoia": "heal",
  "metastasis": "smart",
  "metastasise": "heal",
  "metastasize": "heal",
  "metatarsal": "heal",
  "metatarsus": "heal",
  "metatheria": "heal",
  "metatherian": "heal",
  "metathesis": "smart",
  "metazoa": "heal",
  "metazoan": "heal",
  "metempsychosis": "sound",
  "metencephalon": "heal",
  "meteor": "sound",
  "meteoric": "beautiful",
  "meteorology": "story",
  "meter": "smart",
  "meterstick": "build",
  "metformin": "build",
  "meth": "build",
  "methacholine": "build",
  "methadon": "build",
  "methadone": "build",
  "methamphetamine": "build",
  "methanogen": "heal",
  "methapyrilene": "build",
  "methaqualone": "build",
  "metharbital": "build",
  "methedrine": "build",
  "metheglin": "taste",
  "methenamine": "build",
  "methicillin": "build",
  "methocarbamol": "build",
  "method": "smart",
  "methodism": "smart",
  "methodology": "smart",
  "methotrexate": "build",
  "methyldopa": "build",
  "methylenedioxymethamphetamine": "build",
  "methylphenidate": "build",
  "metical": "smart",
  "metonym": "story",
  "metonymy": "story",
  "metopion": "heal",
  "metoprolol": "build",
  "metrazol": "build",
  "metre": "smart",
  "metrestick": "build",
  "metric": "smart",
  "metrical": "beautiful",
  "metrics": "sell",
  "metrify": "build",
  "metro": "build",
  "metrology": "smart",
  "metronidazole": "build",
  "metronome": "sound",
  "metronymic": "story",
  "metroxylon": "heal",
  "metycaine": "build",
  "mevacor": "build",
  "mew": "heal",
  "mewl": "heal",
  "mews": "build",
  "mexiletine": "build",
  "mexitil": "build",
  "mezcal": "heal",
  "mezereon": "heal",
  "mezereum": "heal",
  "mezuza": "story",
  "mezuzah": "story",
  "mezzanine": "build",
  "mezzo": "story",
  "mezzo-relievo": "build",
  "mezzo-rilievo": "build",
  "mezzo-soprano": "story",
  "mezzotint": "build",
  "mfa": "story",
  "mflop": "smart",
  "mho": "smart",
  "miao": "story",
  "miaou": "story",
  "miaow": "story",
  "mib": "smart",
  "mibit": "smart",
  "micah": "story",
  "micheas": "story",
  "mickle": "smart",
  "micmac": "story",
  "miconazole": "build",
  "micro-organism": "heal",
  "microbalance": "build",
  "microbar": "smart",
  "microbat": "heal",
  "microbe": "heal",
  "microbiology": "smart",
  "microbrewery": "build",
  "microcentrum": "heal",
  "microchip": "build",
  "microchiroptera": "heal",
  "microcircuit": "build",
  "micrococcaceae": "heal",
  "micrococcus": "heal",
  "microcode": "story",
  "microcomputer": "build",
  "microcopy": "build",
  "microcosm": "smart",
  "microcyte": "heal",
  "microdesmidae": "heal",
  "microdipodops": "heal",
  "microdot": "build",
  "microeconomics": "smart",
  "microelectronics": "smart",
  "microevolution": "smart",
  "microfarad": "smart",
  "microfiche": "build",
  "microfilm": "build",
  "microflora": "heal",
  "microgametophyte": "heal",
  "microgauss": "smart",
  "microglia": "heal",
  "microgliacyte": "heal",
  "microgram": "smart",
  "microgramma": "heal",
  "microgramma-piloselloides": "heal",
  "microhylidae": "heal",
  "micromeria": "heal",
  "micrometer": "smart",
  "micromicron": "smart",
  "micromillimeter": "smart",
  "micromillimetre": "smart",
  "micromyx": "heal",
  "micron": "smart",
  "micronase": "build",
  "micronor": "build",
  "microorganism": "heal",
  "micropaleontology": "smart",
  "micropenis": "heal",
  "microphage": "heal",
  "microphallus": "heal",
  "microphone": "sound",
  "microphoning": "smart",
  "microphotometer": "build",
  "micropogonias": "heal",
  "microprocessor": "build",
  "micropterus": "heal",
  "micropyle": "heal",
  "microradian": "smart",
  "microscope": "build",
  "microscopic": "beautiful",
  "microscopical": "beautiful",
  "microsome": "heal",
  "microsorium": "heal",
  "microsporangium": "heal",
  "microspore": "heal",
  "microsporidian": "heal",
  "microsporophyll": "heal",
  "microsporum": "heal",
  "microstomus": "heal",
  "microstrobos": "heal",
  "microtome": "build",
  "microtubule": "heal",
  "microtus": "heal",
  "microvolt": "smart",
  "microwave": "taste",
  "microzide": "build",
  "micruroides": "heal",
  "micrurus": "heal",
  "micturate": "heal",
  "micturition": "smart",
  "mid-calf": "heal",
  "midazolam": "build",
  "midbrain": "heal",
  "middle": "smart",
  "middle-class": "beautiful",
  "middlebreaker": "build",
  "middling": "build",
  "middy": "build",
  "midgard": "smart",
  "midge": "heal",
  "midget": "beautiful",
  "midgrass": "heal",
  "midi": "sound",
  "midi-pyrenees": "sound",
  "midinette": "sound",
  "midiron": "sound",
  "midland": "beautiful",
  "midrash": "story",
  "midrib": "heal",
  "midriff": "heal",
  "midsection": "heal",
  "midshipman": "sound",
  "midsummer-men": "heal",
  "midterm": "story",
  "midvein": "heal",
  "midway": "beautiful",
  "midwifery": "smart",
  "mierkat": "heal",
  "mifepristone": "build",
  "mignonette": "heal",
  "migrant": "beautiful",
  "migrator": "heal",
  "migratory": "beautiful",
  "mihrab": "build",
  "mikania": "heal",
  "mike": "build",
  "mikir-meithei": "story",
  "mil": "smart",
  "milcher": "heal",
  "mild": "beautiful",
  "mildew": "smart",
  "mile": "smart",
  "mileage": "sell",
  "mileometer": "build",
  "milepost": "story",
  "miler": "smart",
  "milestone": "story",
  "milfoil": "heal",
  "milhaud": "sound",
  "miliaria": "sound",
  "militant": "beautiful",
  "militarism": "smart",
  "military": "beautiful",
  "militate": "sell",
  "milium": "heal",
  "milk": "taste",
  "milk-vetch": "heal",
  "milkcap": "heal",
  "milker": "heal",
  "milkshake": "taste",
  "milkwagon": "build",
  "milkweed": "heal",
  "milkwort": "heal",
  "mill": "build",
  "milldam": "build",
  "millenarianism": "smart",
  "millenarism": "smart",
  "millenary": "smart",
  "millenniumism": "smart",
  "millepede": "heal",
  "miller's-thumb": "heal",
  "millet": "heal",
  "millettia": "heal",
  "milliammeter": "build",
  "milliampere": "smart",
  "milliard": "smart",
  "millibar": "smart",
  "millicurie": "smart",
  "millidegree": "smart",
  "millifarad": "smart",
  "milligram": "smart",
  "millihenry": "smart",
  "milliliter": "smart",
  "millilitre": "smart",
  "millime": "smart",
  "millimeter": "smart",
  "millimetre": "smart",
  "millimicron": "smart",
  "milline": "smart",
  "millinery": "build",
  "milling": "build",
  "million": "smart",
  "millionth": "smart",
  "milliped": "heal",
  "millipede": "heal",
  "milliradian": "smart",
  "millivolt": "smart",
  "millivoltmeter": "build",
  "milliwatt": "smart",
  "millrace": "build",
  "millrun": "build",
  "mills": "build",
  "millstone": "smart",
  "millwheel": "build",
  "millwork": "build",
  "milo": "heal",
  "milometer": "build",
  "milontin": "build",
  "milt": "taste",
  "miltomate": "heal",
  "miltonia": "heal",
  "miltown": "build",
  "milvus": "heal",
  "mimamsa": "smart",
  "mime": "build",
  "mimeo": "build",
  "mimeograph": "build",
  "mimesis": "smart",
  "mimic": "build",
  "mimidae": "heal",
  "mimosa": "heal",
  "mimosaceae": "heal",
  "mimosoideae": "heal",
  "mimus": "heal",
  "min": "story",
  "mina": "heal",
  "minah": "heal",
  "minaret": "build",
  "mince": "taste",
  "mincemeat": "taste",
  "mincer": "build",
  "mind": "smart",
  "mind-set": "smart",
  "mindful": "beautiful",
  "mindless": "beautiful",
  "mindset": "smart",
  "mine": "build",
  "mined": "taste",
  "minelayer": "build",
  "mineral": "beautiful",
  "mineralogy": "smart",
  "mineshaft": "build",
  "minestrone": "taste",
  "minesweeper": "build",
  "minge": "heal",
  "mingle": "build",
  "mingling": "build",
  "mini": "build",
  "miniate": "build",
  "miniature": "build",
  "minibar": "build",
  "minibike": "build",
  "minibus": "build",
  "minicab": "build",
  "minicar": "build",
  "minicomputer": "build",
  "minim": "smart",
  "minimal": "beautiful",
  "minimalist": "beautiful",
  "minimise": "story",
  "minimize": "story",
  "minimum": "smart",
  "minimus": "heal",
  "mining": "taste",
  "minipress": "build",
  "miniskirt": "build",
  "ministrant": "beautiful",
  "ministry": "build",
  "minisub": "build",
  "minisubmarine": "build",
  "minium": "build",
  "minivan": "build",
  "miniver": "build",
  "mink": "build",
  "minniebush": "heal",
  "minnow": "heal",
  "minocin": "build",
  "minocycline": "build",
  "minor": "beautiful",
  "minoxidil": "build",
  "minster": "build",
  "minstrel": "build",
  "minstrelsy": "story",
  "mint": "smart",
  "mintage": "sell",
  "mintmark": "story",
  "minuartia": "heal",
  "minuend": "smart",
  "minuet": "story",
  "minus": "beautiful",
  "minuscular": "beautiful",
  "minuscule": "story",
  "minute": "smart",
  "minuteman": "build",
  "minutes": "story",
  "minutia": "smart",
  "miosis": "smart",
  "miotic": "build",
  "mips": "smart",
  "mirabilis": "heal",
  "mirage": "sound",
  "mirasol": "heal",
  "miri": "story",
  "mirid": "heal",
  "miridae": "heal",
  "mirish": "story",
  "miro": "heal",
  "mirounga": "heal",
  "mirror": "build",
  "misaddress": "story",
  "misadvise": "story",
  "misally": "sell",
  "misapply": "taste",
  "misapprehend": "smart",
  "misapprehension": "smart",
  "misappropriate": "sell",
  "misbehave": "sell",
  "misbelieve": "smart",
  "miscalculate": "smart",
  "miscall": "story",
  "miscarry": "sell",
  "miscast": "build",
  "miscellany": "story",
  "mischance": "sound",
  "miscible": "beautiful",
  "misconceive": "smart",
  "misconception": "smart",
  "misconduct": "sell",
  "misconstrual": "story",
  "misconstruction": "story",
  "misconstrue": "smart",
  "miscount": "story",
  "miscreate": "smart",
  "misdate": "smart",
  "misdating": "smart",
  "misdeal": "sell",
  "misdeliver": "build",
  "misdemean": "sell",
  "misdirect": "sell",
  "misdirection": "story",
  "misdo": "sell",
  "misestimate": "smart",
  "misfunction": "build",
  "misgauge": "smart",
  "misgive": "smart",
  "misgiving": "smart",
  "misgovern": "sell",
  "misguide": "story",
  "mishandle": "sell",
  "mishap": "sound",
  "mishna": "story",
  "mishnah": "story",
  "misidentify": "smart",
  "misinform": "story",
  "misinformation": "story",
  "misinterpret": "story",
  "misinterpretation": "story",
  "misjudge": "smart",
  "mislay": "build",
  "mislead": "story",
  "mismanage": "sell",
  "mismarry": "sell",
  "mismatch": "smart",
  "mismatched": "build",
  "mismate": "build",
  "misname": "story",
  "misnomer": "story",
  "miso": "taste",
  "misperceive": "sound",
  "misplace": "build",
  "misplay": "build",
  "misprint": "story",
  "mispronounce": "story",
  "mispronunciation": "story",
  "misquotation": "story",
  "misquote": "story",
  "misread": "smart",
  "misreading": "story",
  "misremember": "smart",
  "misrepresent": "story",
  "misrepresentation": "story",
  "miss": "story",
  "missal": "story",
  "missile": "build",
  "missive": "story",
  "missouri": "story",
  "misspeak": "story",
  "misspell": "story",
  "misspelling": "story",
  "misspend": "sell",
  "misstate": "story",
  "misstatement": "story",
  "mist": "sound",
  "mist-flower": "heal",
  "mistake": "smart",
  "mistaking": "story",
  "mister": "story",
  "mistflower": "heal",
  "mistletoe": "heal",
  "mistral": "sound",
  "mistranslate": "story",
  "mistranslation": "story",
  "mistreat": "sell",
  "mistreated": "sell",
  "mistrust": "smart",
  "misunderstand": "smart",
  "misunderstanding": "story",
  "misuse": "taste",
  "misused": "taste",
  "mit": "build",
  "mitchella": "heal",
  "mite": "smart",
  "mitella": "heal",
  "miter": "build",
  "miterwort": "heal",
  "mithan": "heal",
  "mithracin": "build",
  "mithraicism": "smart",
  "mithraism": "smart",
  "mithramycin": "build",
  "mitigate": "story",
  "mitigated": "story",
  "mitigation": "story",
  "mitochondrion": "heal",
  "mitomycin": "build",
  "mitosis": "smart",
  "mitre": "build",
  "mitrewort": "heal",
  "mitsvah": "smart",
  "mitt": "heal",
  "mittelschmerz": "smart",
  "mitten": "build",
  "mitzvah": "smart",
  "miwok": "story",
  "mix": "taste",
  "mixable": "beautiful",
  "mixer": "taste",
  "mixing": "sell",
  "mixologist": "taste",
  "mixology": "taste",
  "mixture": "taste",
  "mizen": "build",
  "mizenmast": "build",
  "mizzen": "build",
  "mizzenmast": "build",
  "mizzle": "sound",
  "mlitt": "story",
  "mls": "story",
  "mmpi": "story",
  "mnemonics": "smart",
  "mniaceae": "heal",
  "mnium": "heal",
  "moa": "heal",
  "moan": "story",
  "moat": "build",
  "moban": "build",
  "mobcap": "build",
  "mobile": "build",
  "mobula": "heal",
  "mobulidae": "heal",
  "mocassin": "build",
  "moccasin": "build",
  "mocha": "taste",
  "mock": "story",
  "mock-heroic": "story",
  "mock-up": "build",
  "mocker": "heal",
  "mockernut": "heal",
  "mockery": "story",
  "mockingbird": "heal",
  "mod": "beautiful",
  "modal": "story",
  "modality": "smart",
  "model": "smart",
  "modeling": "beautiful",
  "modelling": "build",
  "modem": "build",
  "moderate": "story",
  "moderating": "story",
  "moderationism": "smart",
  "moderatism": "smart",
  "modern": "story",
  "modernism": "build",
  "modernization": "story",
  "modest": "beautiful",
  "modicon": "build",
  "modicum": "smart",
  "modifiable": "beautiful",
  "modification": "build",
  "modified": "beautiful",
  "modifier": "story",
  "modillion": "build",
  "modiolus": "heal",
  "modulate": "build",
  "modulated": "build",
  "modulation": "story",
  "module": "smart",
  "modulus": "smart",
  "moehringia": "heal",
  "mohair": "build",
  "mohammedanism": "smart",
  "mohave": "story",
  "mohawk": "story",
  "mohican": "story",
  "mohria": "heal",
  "moiety": "smart",
  "moil": "sell",
  "moire": "build",
  "moisten": "build",
  "moistener": "build",
  "moistening": "build",
  "mojarra": "heal",
  "mojave": "story",
  "mojo": "smart",
  "moke": "heal",
  "mokulu": "story",
  "mol": "smart",
  "mola": "heal",
  "molar": "heal",
  "molasses": "taste",
  "mold": "build",
  "moldboard": "build",
  "molding": "build",
  "mole": "smart",
  "molecular": "beautiful",
  "moleskin": "build",
  "molest": "sell",
  "molidae": "heal",
  "molindone": "build",
  "molle": "heal",
  "mollie": "heal",
  "mollienesia": "heal",
  "molluga": "heal",
  "mollusc": "heal",
  "mollusca": "heal",
  "mollusk": "heal",
  "molly": "heal",
  "mollycoddle": "sell",
  "mollymawk": "heal",
  "moloch": "heal",
  "molossidae": "heal",
  "molothrus": "heal",
  "molt": "smart",
  "molter": "heal",
  "molting": "smart",
  "molucella": "heal",
  "molva": "heal",
  "mombin": "heal",
  "momordica": "heal",
  "momot": "heal",
  "momotidae": "heal",
  "momotus": "heal",
  "mon": "story",
  "mon-khmer": "story",
  "monad": "smart",
  "monal": "heal",
  "monarch": "heal",
  "monarchism": "smart",
  "monarda": "heal",
  "monardella": "heal",
  "monario": "story",
  "monas": "smart",
  "monastery": "build",
  "monastic": "beautiful",
  "monaul": "heal",
  "monaural": "beautiful",
  "monecious": "beautiful",
  "monera": "heal",
  "moneran": "heal",
  "moneron": "heal",
  "moneses": "heal",
  "monetarism": "smart",
  "monetise": "sell",
  "monetization": "sell",
  "monetize": "sell",
  "money": "sell",
  "money-spinner": "smart",
  "moneybag": "build",
  "moneyed": "beautiful",
  "moneyless": "beautiful",
  "moneymaker": "smart",
  "moneymaking": "beautiful",
  "moneywort": "heal",
  "monger": "sell",
  "mongo": "smart",
  "mongolian": "story",
  "mongolic": "story",
  "mongoose": "heal",
  "mongrel": "build",
  "mongrelise": "build",
  "mongrelize": "build",
  "monied": "beautiful",
  "moniker": "story",
  "monilia": "heal",
  "moniliaceae": "heal",
  "moniliales": "heal",
  "monish": "story",
  "monism": "smart",
  "monistat": "build",
  "monition": "story",
  "monitor": "build",
  "monitoring": "sound",
  "monkey": "heal",
  "monkey-wrench": "build",
  "monkeypod": "heal",
  "monkfish": "taste",
  "monkshood": "heal",
  "mono": "beautiful",
  "monoblast": "heal",
  "monocanthidae": "heal",
  "monocanthus": "heal",
  "monocarp": "heal",
  "monochamus": "heal",
  "monochromatic": "beautiful",
  "monochrome": "build",
  "monocle": "build",
  "monoclinic": "beautiful",
  "monoclinous": "beautiful",
  "monocot": "heal",
  "monocotyledon": "heal",
  "monocotyledonae": "heal",
  "monocotyledones": "heal",
  "monocotyledonous": "beautiful",
  "monocycle": "build",
  "monocyte": "heal",
  "monodon": "heal",
  "monodontidae": "heal",
  "monody": "story",
  "monoecious": "beautiful",
  "monogamous": "beautiful",
  "monogenesis": "smart",
  "monogram": "story",
  "monograph": "story",
  "monohybrid": "heal",
  "monoicous": "beautiful",
  "monolingual": "beautiful",
  "monolith": "build",
  "monologue": "story",
  "monologuise": "story",
  "monologuize": "story",
  "monomorium": "heal",
  "mononuclear": "beautiful",
  "mononucleate": "beautiful",
  "monophonic": "beautiful",
  "monophony": "story",
  "monophysitism": "smart",
  "monoplane": "build",
  "monoploid": "beautiful",
  "monopolise": "sell",
  "monopolize": "sell",
  "monorail": "build",
  "monosyllable": "story",
  "monotheism": "smart",
  "monotheistic": "beautiful",
  "monothelitism": "smart",
  "monotone": "story",
  "monotonic": "beautiful",
  "monotremata": "heal",
  "monotreme": "heal",
  "monotropa": "heal",
  "monotropaceae": "heal",
  "monotype": "build",
  "monovalent": "beautiful",
  "monovular": "beautiful",
  "mons": "heal",
  "monsoon": "sound",
  "monstera": "heal",
  "monstrance": "story",
  "montage": "build",
  "montezuma": "heal",
  "monthly": "story",
  "montia": "heal",
  "montrachet": "taste",
  "monument": "build",
  "monumental": "beautiful",
  "monumentalise": "smart",
  "monumentalize": "smart",
  "moo": "story",
  "moo-cow": "heal",
  "mooch": "sell",
  "mood": "sound",
  "moody": "beautiful",
  "moolah": "sell",
  "moon": "sound",
  "moon-ray": "sound",
  "moonbeam": "sound",
  "moonfish": "heal",
  "moonflower": "heal",
  "moonless": "beautiful",
  "moonlight": "sound",
  "moonlit": "beautiful",
  "moonseed": "heal",
  "moonshell": "heal",
  "moonshine": "sound",
  "moonwort": "heal",
  "moony": "beautiful",
  "moor": "build",
  "moor-bird": "heal",
  "moorage": "sell",
  "moorbird": "heal",
  "moorcock": "heal",
  "moorfowl": "heal",
  "moorgame": "heal",
  "moorhen": "heal",
  "mooring": "build",
  "moorish": "smart",
  "moorwort": "heal",
  "moose": "heal",
  "moose-wood": "heal",
  "moosewood": "heal",
  "moot": "story",
  "mop": "build",
  "mopboard": "build",
  "moped": "build",
  "mopping": "build",
  "moquelumnan": "story",
  "moquette": "build",
  "moraceae": "heal",
  "moral": "story",
  "moralisation": "story",
  "moralise": "story",
  "moralism": "story",
  "moralization": "story",
  "moralize": "story",
  "moralizing": "story",
  "morals": "story",
  "moray": "heal",
  "morbidity": "smart",
  "morbidness": "smart",
  "morceau": "story",
  "morchella": "heal",
  "morchellaceae": "heal",
  "mordant": "beautiful",
  "mordva": "story",
  "mordvin": "story",
  "mordvinian": "story",
  "more": "beautiful",
  "moreen": "build",
  "morel": "heal",
  "morello": "heal",
  "mores": "smart",
  "morgen": "smart",
  "morgue": "build",
  "morion": "build",
  "mormonism": "smart",
  "morning": "story",
  "morone": "heal",
  "moronity": "smart",
  "morphallaxis": "smart",
  "morpheme": "story",
  "morphia": "build",
  "morphine": "build",
  "morphogenesis": "smart",
  "morphology": "smart",
  "morphophoneme": "story",
  "morphophonemics": "smart",
  "morphophysiology": "heal",
  "morse": "story",
  "morsel": "smart",
  "mortal": "beautiful",
  "mortar": "build",
  "mortarboard": "build",
  "mortgage": "sell",
  "mortice": "build",
  "mortification": "sound",
  "mortify": "heal",
  "mortise": "build",
  "mortmain": "sell",
  "mortuary": "build",
  "morula": "heal",
  "morus": "heal",
  "mosaic": "beautiful",
  "mosan": "story",
  "moschus": "heal",
  "moselle": "taste",
  "mosque": "build",
  "mosquito": "heal",
  "mosquitofish": "heal",
  "moss": "heal",
  "most": "beautiful",
  "mostaccioli": "taste",
  "mot": "story",
  "motacilla": "heal",
  "motacillidae": "heal",
  "motel": "build",
  "motet": "story",
  "moth": "heal",
  "mothball": "build",
  "mother": "taste",
  "mother-of-thousands": "heal",
  "motherese": "story",
  "motherwort": "heal",
  "mothproof": "beautiful",
  "motif": "build",
  "motile": "beautiful",
  "motilin": "heal",
  "motion": "story",
  "motivate": "build",
  "motivated": "build",
  "motivating": "build",
  "motive": "story",
  "motley": "build",
  "motmot": "heal",
  "motoneuron": "heal",
  "motor": "build",
  "motorbike": "build",
  "motorboat": "build",
  "motorbus": "build",
  "motorcar": "build",
  "motorcoach": "build",
  "motorcycle": "build",
  "motored": "beautiful",
  "motorial": "beautiful",
  "motorised": "beautiful",
  "motorize": "sell",
  "motorized": "sell",
  "motorless": "beautiful",
  "motortruck": "build",
  "motorway": "build",
  "motrin": "build",
  "mottle": "build",
  "mottling": "build",
  "motto": "story",
  "moue": "story",
  "moufflon": "heal",
  "mouflon": "heal",
  "mould": "smart",
  "mouldboard": "build",
  "moulding": "build",
  "moult": "smart",
  "moulter": "heal",
  "moulting": "smart",
  "mound": "build",
  "mound-bird": "heal",
  "mount": "heal",
  "mountain": "smart",
  "mounting": "build",
  "mouse": "heal",
  "mousepad": "build",
  "mouser": "heal",
  "mousetrap": "build",
  "mousey": "beautiful",
  "moussaka": "taste",
  "mousse": "taste",
  "moustache": "heal",
  "moustachio": "heal",
  "mousy": "beautiful",
  "mouth": "heal",
  "mouthbreeder": "heal",
  "mouthful": "smart",
  "mouthless": "beautiful",
  "mouthpart": "heal",
  "mouthpiece": "build",
  "mouton": "taste",
  "movable": "sell",
  "movie": "story",
  "mow": "build",
  "mower": "build",
  "mown": "build",
  "mozart": "story",
  "mozzarella": "taste",
  "mps": "heal",
  "mr.": "story",
  "mrd": "story",
  "mrs": "story",
  "mrs.": "story",
  "ms-dos": "story",
  "ms.": "story",
  "msasa": "heal",
  "msc": "story",
  "msg": "taste",
  "msh": "beautiful",
  "much": "smart",
  "muckle": "smart",
  "muckrake": "story",
  "muckraking": "story",
  "mucor": "heal",
  "mucoraceae": "heal",
  "mucorales": "heal",
  "mucosa": "heal",
  "mucuna": "heal",
  "mucus": "heal",
  "mud": "story",
  "mud-wrestle": "build",
  "mudcat": "taste",
  "mudder": "heal",
  "muddiness": "smart",
  "muddle": "build",
  "muddy": "build",
  "mudguard": "build",
  "mudhif": "build",
  "mudskipper": "heal",
  "mudspringer": "heal",
  "mudwrestle": "build",
  "muenster": "taste",
  "muesli": "taste",
  "muff": "build",
  "muffin": "taste",
  "muffle": "build",
  "muffler": "build",
  "mufti": "build",
  "mug": "smart",
  "mugful": "smart",
  "mugginess": "sound",
  "mugging": "sell",
  "mugil": "heal",
  "mugilidae": "heal",
  "mugiloidea": "heal",
  "mugshot": "build",
  "mugwort": "heal",
  "muhammadanism": "smart",
  "muhlenbergia": "heal",
  "muishond": "heal",
  "mukataa": "build",
  "mulberry": "heal",
  "mulch": "build",
  "mulct": "sell",
  "mule": "heal",
  "mull": "smart",
  "mullein": "heal",
  "muller": "sound",
  "mullet": "taste",
  "mullidae": "heal",
  "mulligan": "taste",
  "mulligatawny": "taste",
  "mullion": "build",
  "mulloidichthys": "heal",
  "mulloway": "heal",
  "mullus": "heal",
  "multicollinearity": "smart",
  "multiculturalism": "smart",
  "multidimensional": "beautiful",
  "multiflora": "heal",
  "multiform": "beautiful",
  "multilane": "beautiful",
  "multilateral": "beautiful",
  "multilingual": "beautiful",
  "multimedia": "story",
  "multinomial": "smart",
  "multiparous": "beautiful",
  "multiple": "smart",
  "multiple-choice": "beautiful",
  "multiplex": "story",
  "multiplexer": "build",
  "multiplicand": "smart",
  "multiplication": "smart",
  "multiplier": "smart",
  "multiply": "smart",
  "multiprocessing": "smart",
  "multiprocessor": "build",
  "multiprogramming": "smart",
  "multitude": "smart",
  "multivalent": "beautiful",
  "multivitamin": "taste",
  "mulwi": "story",
  "mum": "heal",
  "mumble": "story",
  "mumbling": "story",
  "mummery": "story",
  "mummichog": "heal",
  "mummification": "heal",
  "mummify": "sell",
  "mummy": "heal",
  "mumpsimus": "smart",
  "munch": "taste",
  "munchener": "taste",
  "munda": "story",
  "munda-mon-khmer": "story",
  "mung": "heal",
  "municipal": "beautiful",
  "muniments": "story",
  "munition": "build",
  "munj": "heal",
  "munja": "heal",
  "munjeet": "heal",
  "munjuk": "story",
  "muntiacus": "heal",
  "muntingia": "heal",
  "muntjac": "heal",
  "muraenidae": "heal",
  "mural": "beautiful",
  "murder": "sell",
  "muridae": "heal",
  "murine": "heal",
  "murmur": "story",
  "murmuring": "story",
  "muroidea": "heal",
  "murphy": "taste",
  "murre": "heal",
  "mus": "heal",
  "musa": "heal",
  "musaceae": "heal",
  "musales": "heal",
  "musca": "heal",
  "muscadel": "taste",
  "muscadelle": "taste",
  "muscadet": "heal",
  "muscadine": "heal",
  "muscardinus": "heal",
  "muscari": "heal",
  "muscat": "heal",
  "muscatel": "taste",
  "musci": "heal",
  "muscicapa": "heal",
  "muscicapidae": "heal",
  "muscidae": "heal",
  "muscivora": "heal",
  "muscivora-forficata": "heal",
  "muscle": "heal",
  "muscoidea": "heal",
  "muscular": "beautiful",
  "muscularity": "heal",
  "musculature": "heal",
  "musculus": "heal",
  "musd": "story",
  "muse": "smart",
  "musette": "build",
  "museum": "build",
  "musgoi": "story",
  "musgu": "story",
  "mush": "taste",
  "mushroom": "heal",
  "music": "sound",
  "musical": "sound",
  "musicianship": "smart",
  "musicology": "smart",
  "musing": "smart",
  "musjid": "build",
  "musk": "smart",
  "muskat": "heal",
  "muskellunge": "taste",
  "musket": "build",
  "musketry": "smart",
  "muskhogean": "story",
  "muskmelon": "heal",
  "muskogean": "story",
  "muskogee": "story",
  "muskrat": "heal",
  "muskwood": "heal",
  "muslimism": "smart",
  "muslin": "build",
  "musnud": "build",
  "musophaga": "heal",
  "musophagidae": "heal",
  "musquash": "heal",
  "muss": "heal",
  "mussel": "taste",
  "mussitate": "story",
  "must": "taste",
  "mustache": "heal",
  "mustachio": "heal",
  "mustang": "heal",
  "mustard": "taste",
  "mustela": "heal",
  "mustelid": "heal",
  "mustelidae": "heal",
  "musteline": "heal",
  "mustelus": "heal",
  "muster": "build",
  "mutable": "beautiful",
  "mutamycin": "build",
  "mutant": "heal",
  "mutchkin": "smart",
  "mute": "build",
  "mutilate": "heal",
  "mutillidae": "heal",
  "mutinus": "heal",
  "mutiny": "sell",
  "mutisia": "heal",
  "mutt": "heal",
  "mutter": "story",
  "muttering": "story",
  "mutton": "taste",
  "muttonfish": "heal",
  "mutual": "beautiful",
  "muumuu": "build",
  "muzzle": "build",
  "mwera": "story",
  "mya": "heal",
  "myaceae": "heal",
  "myacidae": "heal",
  "myadestes": "heal",
  "mycelium": "heal",
  "mycetophilidae": "heal",
  "mycobacteria": "heal",
  "mycobacteriaceae": "heal",
  "mycobacterium": "heal",
  "mycology": "smart",
  "mycomycin": "build",
  "mycoplasma": "heal",
  "mycoplasmataceae": "heal",
  "mycoplasmatales": "heal",
  "mycostatin": "build",
  "mycrosporidia": "heal",
  "mycteria": "heal",
  "mycteroperca": "heal",
  "myctophidae": "heal",
  "mydriatic": "build",
  "myelencephalon": "heal",
  "myelinisation": "smart",
  "myelinization": "smart",
  "myeloblast": "heal",
  "myelocyte": "heal",
  "myelogram": "build",
  "myg": "smart",
  "myliobatidae": "heal",
  "mylodon": "heal",
  "mylodontid": "heal",
  "mylodontidae": "heal",
  "mym": "smart",
  "myna": "heal",
  "mynah": "heal",
  "myocardium": "heal",
  "myocastor": "heal",
  "myofibril": "heal",
  "myofibrilla": "heal",
  "myogram": "story",
  "myology": "smart",
  "myometrium": "heal",
  "myomorpha": "heal",
  "myonecrosis": "sound",
  "myopathy": "heal",
  "myopic": "beautiful",
  "myopus": "heal",
  "myosotis": "heal",
  "myotic": "build",
  "myotis": "heal",
  "myrcia": "heal",
  "myrciaria": "heal",
  "myriad": "smart",
  "myriagram": "smart",
  "myriameter": "smart",
  "myriametre": "smart",
  "myriapod": "heal",
  "myriapoda": "heal",
  "myrica": "heal",
  "myricaceae": "heal",
  "myricales": "heal",
  "myricaria": "heal",
  "myringa": "heal",
  "myriophyllum": "heal",
  "myristica": "heal",
  "myristicaceae": "heal",
  "myrmecia": "heal",
  "myrmecobius": "heal",
  "myrmecophaga": "heal",
  "myrmecophagidae": "heal",
  "myrmecophile": "heal",
  "myrmecophyte": "heal",
  "myrmeleon": "heal",
  "myrmeleontidae": "heal",
  "myrobalan": "heal",
  "myroxylon": "heal",
  "myrrh": "heal",
  "myrrhis": "heal",
  "myrsinaceae": "heal",
  "myrsine": "heal",
  "myrtaceae": "heal",
  "myrtales": "heal",
  "myrtillocactus": "heal",
  "myrtle": "heal",
  "myrtus": "heal",
  "mysidacea": "heal",
  "mysidae": "heal",
  "mysis": "heal",
  "mysoline": "build",
  "mystery": "story",
  "mystic": "beautiful",
  "mystical": "beautiful",
  "mysticeti": "heal",
  "mysticism": "smart",
  "mystification": "smart",
  "mystifier": "story",
  "mystify": "smart",
  "myth": "story",
  "mythic": "beautiful",
  "mythicise": "smart",
  "mythicize": "smart",
  "mythologisation": "story",
  "mythologise": "build",
  "mythologization": "story",
  "mythologize": "build",
  "mythology": "smart",
  "mytilid": "heal",
  "mytilidae": "heal",
  "mytilus": "heal",
  "myxine": "heal",
  "myxinidae": "heal",
  "myxiniformes": "heal",
  "myxinikela": "heal",
  "myxinoidea": "heal",
  "myxinoidei": "heal",
  "myxobacter": "heal",
  "myxobacterales": "heal",
  "myxobacteria": "heal",
  "myxobacteriaceae": "heal",
  "myxobacteriales": "heal",
  "myxobacterium": "heal",
  "myxocephalus": "heal",
  "myxomycete": "heal",
  "myxomycetes": "heal",
  "myxomycota": "heal",
  "myxophyceae": "heal",
  "myxosporidia": "heal",
  "myxosporidian": "heal",
  "myxovirus": "heal",
  "n.b.": "story",
  "na-dene": "story",
  "naan": "taste",
  "nab": "build",
  "nabalus": "heal",
  "naboom": "heal",
  "nabumetone": "build",
  "nacelle": "build",
  "nacho": "taste",
  "nacreous": "beautiful",
  "nada": "smart",
  "nadolol": "build",
  "naemorhedus": "heal",
  "nafcil": "build",
  "nafcillin": "build",
  "nag": "heal",
  "naga": "story",
  "nagami": "heal",
  "nagari": "story",
  "nageia": "heal",
  "nagi": "heal",
  "nahuatl": "story",
  "nahum": "story",
  "naiad": "heal",
  "naiadaceae": "heal",
  "naiadales": "heal",
  "naias": "heal",
  "naif": "beautiful",
  "naiki": "story",
  "nail": "build",
  "nailbrush": "build",
  "nailfile": "build",
  "nailhead": "build",
  "nailrod": "heal",
  "nainsook": "build",
  "naira": "smart",
  "naive": "beautiful",
  "naja": "heal",
  "najadaceae": "heal",
  "najas": "heal",
  "nakedwood": "heal",
  "nalfon": "build",
  "nalline": "build",
  "nalorphine": "build",
  "naloxone": "build",
  "naltrexone": "build",
  "namby-pamby": "beautiful",
  "name": "story",
  "name-dropping": "story",
  "namedrop": "story",
  "nameko": "heal",
  "nameplate": "build",
  "names": "story",
  "naming": "story",
  "nammad": "build",
  "nan": "taste",
  "nancere": "story",
  "nandu": "heal",
  "nankeen": "build",
  "nanny": "heal",
  "nanny-goat": "heal",
  "nanogram": "smart",
  "nanometer": "smart",
  "nanometre": "smart",
  "nanomia": "heal",
  "nanotechnology": "smart",
  "nanovolt": "smart",
  "nanticoke": "story",
  "nantua": "taste",
  "nap": "build",
  "napa": "heal",
  "napaea": "heal",
  "nape": "heal",
  "napery": "build",
  "naphazoline": "build",
  "napkin": "build",
  "napoleon": "taste",
  "nappy": "build",
  "naprosyn": "build",
  "naproxen": "build",
  "napu": "heal",
  "naqua": "build",
  "naranjilla": "heal",
  "narcan": "build",
  "narcissus": "heal",
  "narcoleptic": "build",
  "narcosis": "smart",
  "narcotic": "build",
  "narcotise": "heal",
  "narcotize": "heal",
  "nard": "build",
  "nardil": "build",
  "nardo": "heal",
  "nardoo": "heal",
  "narghile": "build",
  "nargileh": "build",
  "naris": "heal",
  "nark": "story",
  "narrate": "story",
  "narration": "story",
  "narrative": "story",
  "narrow": "smart",
  "narrow-body": "build",
  "narrow-minded": "beautiful",
  "narrow-mindedness": "smart",
  "narrowboat": "build",
  "narrowing": "smart",
  "narrowness": "smart",
  "narthecium": "heal",
  "narthex": "build",
  "narwal": "heal",
  "narwhal": "heal",
  "narwhale": "heal",
  "nasal": "story",
  "nasale": "story",
  "nasalis": "heal",
  "nasalisation": "story",
  "nasalise": "story",
  "nasalization": "story",
  "nasalize": "story",
  "nascent": "beautiful",
  "nasdaq": "build",
  "nasion": "heal",
  "nasopharynx": "heal",
  "nasturtium": "heal",
  "nasty": "beautiful",
  "nasua": "heal",
  "natantia": "heal",
  "natatorium": "build",
  "nates": "heal",
  "naticidae": "heal",
  "national": "beautiful",
  "nationalism": "smart",
  "nationalist": "beautiful",
  "native": "beautiful",
  "nativism": "story",
  "nativity": "smart",
  "natrix": "heal",
  "natter": "story",
  "natterjack": "heal",
  "natural": "story",
  "naturalism": "smart",
  "naturalize": "story",
  "nauclea": "heal",
  "naucrates": "heal",
  "naught": "smart",
  "naumachia": "build",
  "naumachy": "build",
  "nauseant": "build",
  "nauseate": "sound",
  "nautilidae": "heal",
  "nautilus": "build",
  "navaho": "story",
  "navajo": "story",
  "navane": "build",
  "nave": "build",
  "navel": "heal",
  "navel-gazing": "smart",
  "navicular": "heal",
  "nay": "story",
  "naysaying": "story",
  "nazification": "smart",
  "ndebele": "story",
  "neandertal": "heal",
  "neanderthal": "heal",
  "near": "beautiful",
  "nearside": "build",
  "nearsighted": "beautiful",
  "neaten": "heal",
  "neb": "heal",
  "nebcin": "build",
  "nebiim": "story",
  "nebuchadnezzar": "build",
  "nebular": "beautiful",
  "nebuliser": "build",
  "nebulizer": "build",
  "nebulous": "beautiful",
  "necessary": "beautiful",
  "neck": "heal",
  "neckband": "build",
  "neckcloth": "build",
  "necked": "build",
  "neckerchief": "build",
  "necking": "build",
  "necklace": "beautiful",
  "neckless": "beautiful",
  "necklet": "build",
  "neckline": "build",
  "neckpiece": "build",
  "necktie": "build",
  "neckwear": "build",
  "necrobiosis": "sound",
  "necrology": "story",
  "necrolysis": "smart",
  "necromancy": "smart",
  "necromantic": "beautiful",
  "necrose": "heal",
  "necrosis": "sound",
  "nectar": "taste",
  "nectarine": "heal",
  "nectary": "heal",
  "necturus": "heal",
  "needle": "heal",
  "needle-bush": "heal",
  "needle-wood": "heal",
  "needlebush": "heal",
  "needlecraft": "build",
  "needlefish": "heal",
  "needlepoint": "build",
  "needlewood": "heal",
  "needlework": "beautiful",
  "needy": "beautiful",
  "neem": "heal",
  "neencephalon": "heal",
  "nefazodone": "build",
  "negaprion": "heal",
  "negate": "story",
  "negation": "story",
  "negative": "story",
  "neggram": "build",
  "neglect": "smart",
  "neglige": "build",
  "negligee": "build",
  "negligent": "beautiful",
  "negociate": "sell",
  "negotiate": "story",
  "negotiation": "sell",
  "negritude": "smart",
  "negro": "beautiful",
  "negroid": "beautiful",
  "negus": "taste",
  "nehemiah": "story",
  "neigh": "story",
  "neighborhood": "smart",
  "nekton": "heal",
  "nelfinavir": "build",
  "nelumbo": "heal",
  "nelumbonaceae": "heal",
  "nematocera": "heal",
  "nematoda": "heal",
  "nematode": "heal",
  "nembutal": "build",
  "nemertea": "heal",
  "nemertean": "heal",
  "nemertina": "heal",
  "nemertine": "heal",
  "nemophila": "heal",
  "nenets": "story",
  "nentsi": "story",
  "nentsy": "story",
  "neo-darwinism": "smart",
  "neo-lamarckism": "smart",
  "neo-latin": "story",
  "neobiotic": "build",
  "neoceratodus": "heal",
  "neoclassicism": "smart",
  "neoconservatism": "smart",
  "neocortex": "heal",
  "neoencephalon": "heal",
  "neofiber": "heal",
  "neohygrophorus": "heal",
  "neolentinus": "heal",
  "neoliberal": "beautiful",
  "neoliberalism": "smart",
  "neolith": "build",
  "neologism": "story",
  "neology": "story",
  "neomycin": "build",
  "neomys": "heal",
  "neonatology": "smart",
  "neopallium": "heal",
  "neophron": "heal",
  "neophyte": "heal",
  "neoplasia": "smart",
  "neoplatonism": "smart",
  "neosporin": "build",
  "neostigmine": "build",
  "neoteny": "smart",
  "neotoma": "heal",
  "nepa": "heal",
  "nepali": "story",
  "nepenthaceae": "heal",
  "nepenthes": "heal",
  "nepeta": "heal",
  "nepheline": "build",
  "nephelite": "build",
  "nephelium": "heal",
  "nephology": "smart",
  "nephoscope": "build",
  "nephrolepis": "heal",
  "nephrology": "smart",
  "nephron": "heal",
  "nephrops": "heal",
  "nephropsidae": "heal",
  "nephthytis": "heal",
  "nepidae": "heal",
  "nerita": "heal",
  "neritic": "beautiful",
  "neritid": "heal",
  "neritidae": "heal",
  "neritina": "heal",
  "nerium": "heal",
  "nerodia": "heal",
  "nerve": "heal",
  "nerveroot": "heal",
  "nerves": "heal",
  "nervous": "beautiful",
  "nervure": "heal",
  "nervus": "heal",
  "nescience": "smart",
  "nesokia": "heal",
  "nesselrode": "taste",
  "nest": "build",
  "nester": "heal",
  "nestle": "build",
  "nestling": "heal",
  "nestor": "heal",
  "nestorianism": "smart",
  "net": "build",
  "netherworld": "smart",
  "netmail": "story",
  "netscape": "story",
  "nett": "build",
  "netting": "build",
  "nettle": "heal",
  "network": "smart",
  "neurilemma": "heal",
  "neuroanatomic": "heal",
  "neuroanatomical": "heal",
  "neuroanatomy": "smart",
  "neurobiology": "smart",
  "neuroblast": "heal",
  "neuroepithelium": "heal",
  "neuroethics": "smart",
  "neurogenesis": "smart",
  "neuroglia": "heal",
  "neurogliacyte": "heal",
  "neurohormone": "heal",
  "neurohypophysis": "heal",
  "neurolemma": "heal",
  "neuroleptic": "build",
  "neurolinguistics": "smart",
  "neurologic": "heal",
  "neurological": "heal",
  "neurologist": "heal",
  "neurology": "heal",
  "neuron": "heal",
  "neurontin": "build",
  "neuropathy": "heal",
  "neurophysiological": "heal",
  "neurophysiology": "heal",
  "neuropil": "heal",
  "neuropile": "heal",
  "neuropsychiatry": "smart",
  "neuropsychology": "smart",
  "neuroptera": "heal",
  "neuropteran": "heal",
  "neuropteron": "heal",
  "neuroscience": "smart",
  "neurosis": "heal",
  "neurospora": "heal",
  "neurotic": "beautiful",
  "neuroticism": "heal",
  "neurotrichus": "heal",
  "neuter": "story",
  "neutering": "heal",
  "neutral": "beautiful",
  "neutralisation": "smart",
  "neutralise": "build",
  "neutralism": "story",
  "neutrality": "smart",
  "neutralization": "smart",
  "neutralize": "sell",
  "neutrophil": "heal",
  "neutrophile": "heal",
  "never-never": "sell",
  "nevirapine": "build",
  "new": "beautiful",
  "newari": "story",
  "newborn": "beautiful",
  "newel": "build",
  "newfoundland": "heal",
  "newgate": "build",
  "newmarket": "build",
  "news": "story",
  "newsbreak": "story",
  "newscast": "story",
  "newsflash": "story",
  "newsletter": "story",
  "newspaper": "story",
  "newsreel": "story",
  "newsroom": "story",
  "newssheet": "story",
  "newsstand": "build",
  "newt": "heal",
  "newton": "smart",
  "nganasan": "story",
  "ngultrum": "smart",
  "nguni": "story",
  "ngwee": "smart",
  "nib": "build",
  "nibble": "smart",
  "nibelungenlied": "story",
  "niblick": "build",
  "nicad": "build",
  "nicandra": "heal",
  "nice": "beautiful",
  "nicety": "story",
  "niche": "build",
  "nick": "build",
  "nickel": "sell",
  "nickel-and-dime": "sell",
  "nickelodeon": "build",
  "nicker": "story",
  "nicknack": "build",
  "nickname": "story",
  "nicotiana": "heal",
  "nictate": "heal",
  "nictitate": "heal",
  "nidation": "smart",
  "nidicolous": "beautiful",
  "nidifugous": "beautiful",
  "nidularia": "heal",
  "nidulariaceae": "heal",
  "nidulariales": "heal",
  "nierembergia": "heal",
  "nifedipine": "build",
  "niff": "smart",
  "nigella": "heal",
  "niger-congo": "story",
  "niger-kordofanian": "story",
  "niggle": "story",
  "nigh": "beautiful",
  "night-light": "build",
  "night-line": "build",
  "night-robe": "build",
  "night-sight": "smart",
  "nightcap": "taste",
  "nightclothes": "build",
  "nightclub": "build",
  "nightcrawler": "heal",
  "nightdress": "build",
  "nightgown": "build",
  "nighthawk": "heal",
  "nightie": "build",
  "nightingale": "heal",
  "nightjar": "heal",
  "nightmare": "smart",
  "nightshade": "heal",
  "nightshirt": "build",
  "nightspot": "build",
  "nightstick": "build",
  "nightwalker": "heal",
  "nightwear": "build",
  "nigroporus": "heal",
  "nih": "heal",
  "nihil": "smart",
  "nihilism": "smart",
  "nil": "smart",
  "nilgai": "heal",
  "nilo-saharan": "story",
  "nilotic": "story",
  "nimbleness": "smart",
  "nimblewill": "heal",
  "nimravus": "heal",
  "nin-sin": "heal",
  "nine": "smart",
  "nine-spot": "build",
  "ninepence": "sell",
  "ninepin": "build",
  "ninepins": "build",
  "niner": "smart",
  "nineteen": "smart",
  "nineteenth": "beautiful",
  "nineties": "smart",
  "ninetieth": "beautiful",
  "ninety": "smart",
  "ninon": "build",
  "ninth": "smart",
  "nip": "smart",
  "nipa": "heal",
  "nipper": "heal",
  "nipple": "heal",
  "niqab": "build",
  "nit": "smart",
  "nitella": "heal",
  "nitpick": "story",
  "nitrazepam": "build",
  "nitrification": "smart",
  "nitrobacter": "heal",
  "nitrobacteria": "heal",
  "nitrobacteriaceae": "heal",
  "nitrobacterium": "heal",
  "nitrofurantoin": "build",
  "nitrosobacteria": "heal",
  "nitrosomonas": "heal",
  "nitrospan": "build",
  "nitrostat": "build",
  "nitty-gritty": "smart",
  "nitweed": "heal",
  "nix": "smart",
  "nlp": "smart",
  "nmr": "sound",
  "nnrti": "build",
  "no-account": "beautiful",
  "no-go": "beautiful",
  "no-goal": "smart",
  "no-see-um": "heal",
  "no.": "smart",
  "nobble": "sell",
  "nobelium": "sound",
  "noble": "beautiful",
  "nock": "build",
  "noctiluca": "heal",
  "noctua": "heal",
  "noctuid": "heal",
  "noctuidae": "heal",
  "nocturia": "smart",
  "nocturnal": "beautiful",
  "nocturne": "story",
  "nod": "story",
  "noddle": "smart",
  "node": "heal",
  "nodular": "beautiful",
  "nodule": "heal",
  "nog": "build",
  "noggin": "heal",
  "nogging": "build",
  "noise": "smart",
  "noisemaker": "build",
  "noisy": "beautiful",
  "nolina": "heal",
  "nomenclature": "story",
  "nomia": "heal",
  "nominal": "story",
  "nominalism": "smart",
  "nominate": "story",
  "nomination": "story",
  "nominative": "story",
  "nomogram": "build",
  "nomograph": "build",
  "nomothetic": "beautiful",
  "non-conducting": "beautiful",
  "non-finite": "beautiful",
  "non-invertible": "beautiful",
  "non-living": "beautiful",
  "non-miscible": "beautiful",
  "non-ugric": "story",
  "nonabsorbent": "beautiful",
  "nonabsorptive": "beautiful",
  "nonaddictive": "beautiful",
  "nonadhesive": "beautiful",
  "nonadsorbent": "beautiful",
  "nonadsorptive": "beautiful",
  "nonaged": "beautiful",
  "nonagenarian": "beautiful",
  "nonaggression": "story",
  "nonaggressive": "beautiful",
  "nonalcoholic": "beautiful",
  "nonaligned": "beautiful",
  "nonallele": "heal",
  "nonarbitrable": "beautiful",
  "nonarbitrary": "beautiful",
  "nonarboreal": "beautiful",
  "nonassociative": "beautiful",
  "nonastringent": "beautiful",
  "nonbearing": "beautiful",
  "noncausal": "beautiful",
  "noncausative": "beautiful",
  "noncellular": "beautiful",
  "noncivilised": "beautiful",
  "noncivilized": "beautiful",
  "nonclassical": "beautiful",
  "noncollapsable": "beautiful",
  "noncollapsible": "beautiful",
  "noncolumned": "beautiful",
  "noncombatant": "beautiful",
  "noncombinative": "beautiful",
  "noncombustible": "beautiful",
  "noncommercial": "beautiful",
  "noncommissioned": "beautiful",
  "noncompetitive": "beautiful",
  "noncompliant": "beautiful",
  "noncomprehensive": "beautiful",
  "nonconcentric": "beautiful",
  "nonconducting": "beautiful",
  "nonconductive": "beautiful",
  "nonconformance": "smart",
  "nonconformism": "smart",
  "nonconformist": "beautiful",
  "nonconformity": "story",
  "noncontinuous": "beautiful",
  "noncontroversial": "beautiful",
  "noncritical": "beautiful",
  "noncrucial": "beautiful",
  "noncrystalline": "beautiful",
  "noncurrent": "beautiful",
  "noncyclic": "beautiful",
  "noncyclical": "beautiful",
  "nondeductible": "beautiful",
  "nondescript": "beautiful",
  "nondevelopment": "smart",
  "nondisjunction": "smart",
  "nondisposable": "beautiful",
  "none": "beautiful",
  "nonechoic": "beautiful",
  "noneffervescent": "beautiful",
  "nonenterprising": "beautiful",
  "nonessential": "beautiful",
  "nonexempt": "beautiful",
  "nonexistent": "beautiful",
  "nonexplorative": "beautiful",
  "nonexploratory": "beautiful",
  "nonexplosive": "beautiful",
  "nonextant": "beautiful",
  "nonextensile": "beautiful",
  "nonfat": "beautiful",
  "nonfatal": "beautiful",
  "nonfiction": "story",
  "nonfissile": "beautiful",
  "nonfissionable": "beautiful",
  "nonflowering": "beautiful",
  "nonfunctional": "beautiful",
  "nonharmonic": "sound",
  "nonheritable": "beautiful",
  "nonhierarchic": "beautiful",
  "nonhierarchical": "beautiful",
  "nonhuman": "beautiful",
  "nonimitative": "beautiful",
  "nonindulgent": "beautiful",
  "nonindustrial": "beautiful",
  "noninfectious": "beautiful",
  "noninheritable": "beautiful",
  "noninstitutional": "beautiful",
  "noninstitutionalised": "beautiful",
  "noninstitutionalized": "beautiful",
  "nonintegrated": "beautiful",
  "nonintellectual": "beautiful",
  "noninterference": "story",
  "nonintervention": "story",
  "noninvasive": "beautiful",
  "nonionic": "beautiful",
  "nonionised": "beautiful",
  "nonionized": "beautiful",
  "nonjudgmental": "beautiful",
  "nonlinear": "beautiful",
  "nonliteral": "beautiful",
  "nonliving": "beautiful",
  "nonmagnetic": "beautiful",
  "nonmaterial": "beautiful",
  "nonmeaningful": "beautiful",
  "nonmechanical": "beautiful",
  "nonmetal": "beautiful",
  "nonmetallic": "beautiful",
  "nonmetamorphic": "beautiful",
  "nonmigratory": "beautiful",
  "nonmilitary": "beautiful",
  "nonmodern": "beautiful",
  "nonmonotonic": "beautiful",
  "nonmoving": "beautiful",
  "nonmusical": "beautiful",
  "nonnative": "beautiful",
  "nonoperational": "beautiful",
  "nonpareil": "taste",
  "nonparticulate": "beautiful",
  "nonpartisan": "beautiful",
  "nonpartisanship": "smart",
  "nonpartizan": "beautiful",
  "nonpayment": "sell",
  "nonperiodic": "beautiful",
  "nonplus": "smart",
  "nonpolitical": "beautiful",
  "nonporous": "beautiful",
  "nonpregnant": "beautiful",
  "nonprehensile": "beautiful",
  "nonprescription": "beautiful",
  "nonprofessional": "beautiful",
  "nonprofit": "beautiful",
  "nonproprietary": "beautiful",
  "nonprotractile": "beautiful",
  "nonpsychoactive": "beautiful",
  "nonracial": "beautiful",
  "nonradioactive": "beautiful",
  "nonrandom": "beautiful",
  "nonreciprocal": "beautiful",
  "nonreflecting": "beautiful",
  "nonreflective": "beautiful",
  "nonremittal": "sell",
  "nonrenewable": "beautiful",
  "nonrepetitive": "beautiful",
  "nonrepresentational": "beautiful",
  "nonrepresentative": "beautiful",
  "nonresident": "beautiful",
  "nonresidential": "beautiful",
  "nonresonant": "beautiful",
  "nonreticulate": "beautiful",
  "nonretractable": "beautiful",
  "nonretractile": "beautiful",
  "nonreturnable": "beautiful",
  "nonreversible": "beautiful",
  "nonrigid": "beautiful",
  "nonsectarian": "beautiful",
  "nonsense": "story",
  "nonsensicality": "story",
  "nonsexual": "beautiful",
  "nonsignificant": "beautiful",
  "nonslippery": "beautiful",
  "nonsmoker": "build",
  "nonspeaking": "beautiful",
  "nonspecific": "beautiful",
  "nonstandard": "beautiful",
  "nonstarter": "heal",
  "nonstop": "beautiful",
  "nonsubjective": "beautiful",
  "nonsubmergible": "beautiful",
  "nonsubmersible": "beautiful",
  "nonsweet": "beautiful",
  "nonsyllabic": "beautiful",
  "nontaxable": "beautiful",
  "nontechnical": "beautiful",
  "nonterritorial": "beautiful",
  "nontoxic": "beautiful",
  "nontraditional": "beautiful",
  "nontricyclic": "build",
  "nonunion": "beautiful",
  "nonviolent": "beautiful",
  "nonvolatile": "beautiful",
  "nonvolatilisable": "beautiful",
  "nonvolatilizable": "beautiful",
  "nonvoluntary": "beautiful",
  "nonwashable": "beautiful",
  "nonwoody": "beautiful",
  "noodle": "taste",
  "nook": "build",
  "noose": "build",
  "nootka": "story",
  "nopal": "heal",
  "nopalea": "heal",
  "nor-q-d": "build",
  "noradrenaline": "heal",
  "nordic": "story",
  "noreaster": "sound",
  "norepinephrine": "heal",
  "norflex": "build",
  "noria": "build",
  "norinyl": "build",
  "norlestrin": "build",
  "norm": "smart",
  "normal": "smart",
  "normality": "smart",
  "norman-french": "story",
  "normative": "beautiful",
  "normodyne": "build",
  "normotensive": "beautiful",
  "norse": "story",
  "northeaster": "sound",
  "northeastward": "beautiful",
  "norther": "sound",
  "northerly": "sound",
  "northern": "story",
  "northward": "beautiful",
  "northwester": "sound",
  "northwestward": "beautiful",
  "nortriptyline": "build",
  "norvasc": "build",
  "norvir": "build",
  "norwegian": "story",
  "nose": "heal",
  "nosebag": "build",
  "noseband": "build",
  "nosed": "sound",
  "nosedive": "smart",
  "nosegay": "build",
  "noseless": "beautiful",
  "nosepiece": "build",
  "nosewheel": "build",
  "nosh": "taste",
  "nosh-up": "taste",
  "nosiness": "smart",
  "nosology": "smart",
  "nostoc": "heal",
  "nostocaceae": "heal",
  "nostril": "heal",
  "nostrum": "build",
  "notable": "beautiful",
  "notarise": "story",
  "notarize": "story",
  "notate": "story",
  "notation": "story",
  "notch": "build",
  "note": "story",
  "notebook": "smart",
  "notecase": "build",
  "notechis": "heal",
  "notemigonus": "heal",
  "notepaper": "story",
  "nothing": "smart",
  "nothingness": "story",
  "nothings": "story",
  "nothofagus": "heal",
  "nothosaur": "heal",
  "nothosauria": "heal",
  "notice": "story",
  "noticeable": "beautiful",
  "noticed": "sound",
  "notification": "story",
  "notify": "story",
  "notion": "smart",
  "notochord": "sound",
  "notomys": "heal",
  "notonecta": "heal",
  "notonectidae": "heal",
  "notophthalmus": "heal",
  "notornis": "heal",
  "notoryctidae": "heal",
  "notoryctus": "heal",
  "notostraca": "heal",
  "notropis": "heal",
  "notturno": "story",
  "nougat": "taste",
  "nought": "smart",
  "noumenon": "smart",
  "noun": "story",
  "nourish": "taste",
  "nourished": "taste",
  "nourishment": "taste",
  "nous": "smart",
  "nouveau-riche": "beautiful",
  "nov-esperanto": "story",
  "nov-latin": "story",
  "novel": "story",
  "novelette": "story",
  "novella": "story",
  "novelty": "smart",
  "novial": "story",
  "novillada": "build",
  "novobiocin": "build",
  "novocain": "build",
  "novocaine": "build",
  "noxious": "beautiful",
  "nozzle": "build",
  "nrl": "build",
  "nrti": "build",
  "nsaid": "build",
  "nuance": "story",
  "nub": "smart",
  "nucellus": "heal",
  "nucha": "heal",
  "nucifraga": "heal",
  "nuclear": "beautiful",
  "nucleole": "heal",
  "nucleolus": "heal",
  "nucleonics": "smart",
  "nucleoplasm": "heal",
  "nucleosynthesis": "smart",
  "nucleus": "heal",
  "nuda": "heal",
  "nude": "build",
  "nudge": "build",
  "nudibranch": "heal",
  "nudibranchia": "heal",
  "nuisance": "smart",
  "nuke": "build",
  "null": "smart",
  "nullification": "smart",
  "nullify": "sell",
  "nullity": "story",
  "numb": "sound",
  "numbat": "heal",
  "number": "smart",
  "numbering": "story",
  "numberplate": "build",
  "numbers": "story",
  "numbfish": "heal",
  "numdah": "build",
  "numenius": "heal",
  "numeracy": "smart",
  "numeral": "story",
  "numerate": "story",
  "numeration": "story",
  "numerator": "smart",
  "numeric": "beautiful",
  "numerical": "beautiful",
  "numerology": "smart",
  "numida": "heal",
  "numidia": "sound",
  "numidian": "sound",
  "numididae": "sound",
  "numidinae": "sound",
  "numinous": "beautiful",
  "nummulite": "heal",
  "nummulitidae": "heal",
  "nun": "story",
  "nung": "story",
  "nunnery": "build",
  "nuphar": "heal",
  "nuprin": "build",
  "nurse": "heal",
  "nursery": "build",
  "nursing": "heal",
  "nurture": "story",
  "nut": "build",
  "nutcracker": "build",
  "nutgrass": "heal",
  "nuthatch": "heal",
  "nuthouse": "build",
  "nutlet": "heal",
  "nutmeg": "heal",
  "nutmeg-yew": "heal",
  "nutria": "heal",
  "nutrient": "beautiful",
  "nutrify": "taste",
  "nutriment": "taste",
  "nutrition": "heal",
  "nutsedge": "heal",
  "nutshell": "heal",
  "nuytsia": "heal",
  "nuzzle": "build",
  "nyala": "heal",
  "nyamwezi": "story",
  "nybble": "smart",
  "nyctaginaceae": "heal",
  "nyctaginia": "heal",
  "nyctanassa": "heal",
  "nyctereutes": "heal",
  "nycticebus": "heal",
  "nycticorax": "heal",
  "nyctimene": "heal",
  "nycturia": "smart",
  "nydrazid": "build",
  "nylghai": "heal",
  "nylghau": "heal",
  "nylon": "build",
  "nylons": "build",
  "nymph": "heal",
  "nymphaea": "heal",
  "nymphaeaceae": "heal",
  "nymphalid": "heal",
  "nymphalidae": "heal",
  "nymphalis": "heal",
  "nymphicus": "heal",
  "nymphomaniac": "beautiful",
  "nynorsk": "story",
  "nypa": "heal",
  "nyse": "build",
  "nyssa": "heal",
  "nyssaceae": "heal",
  "nystagmus": "heal",
  "nystan": "build",
  "nystatin": "build",
  "o.d.": "heal",
  "o.e.d.": "story",
  "o.k.": "story",
  "oak": "heal",
  "oar": "build",
  "oarfish": "heal",
  "oarlock": "build",
  "oarsmanship": "smart",
  "oasis": "build",
  "oast": "build",
  "oat": "heal",
  "oatcake": "taste",
  "oath": "story",
  "oatmeal": "taste",
  "obadiah": "story",
  "obbligato": "story",
  "obeah": "smart",
  "obeche": "heal",
  "obechi": "heal",
  "obedient": "beautiful",
  "obeisance": "story",
  "obelion": "heal",
  "obelisk": "build",
  "obey": "sell",
  "obfuscate": "story",
  "obfuscation": "smart",
  "obi": "smart",
  "obiism": "smart",
  "obit": "story",
  "obituary": "story",
  "object": "smart",
  "objectification": "build",
  "objection": "story",
  "objective": "smart",
  "objurgate": "story",
  "objurgation": "story",
  "oblate": "beautiful",
  "obligate": "sell",
  "obligated": "sell",
  "obligation": "sell",
  "obligato": "story",
  "obligatory": "beautiful",
  "oblige": "sell",
  "oblique": "story",
  "oblivion": "smart",
  "obliviousness": "smart",
  "oblong": "beautiful",
  "obloquy": "story",
  "obnubilate": "sound",
  "oboe": "sound",
  "obolus": "smart",
  "obscenity": "story",
  "obscurantism": "smart",
  "obscure": "sound",
  "observance": "smart",
  "observation": "story",
  "observatory": "build",
  "observe": "sound",
  "obsession": "smart",
  "obsessive": "beautiful",
  "obsessive-compulsive": "beautiful",
  "obsolescence": "smart",
  "obstacle": "smart",
  "obstetrics": "heal",
  "obstinate": "beautiful",
  "obstipate": "heal",
  "obstruct": "sell",
  "obstructed": "sell",
  "obstructer": "build",
  "obstruction": "build",
  "obstructor": "build",
  "obstruent": "story",
  "obtain": "sell",
  "obtrude": "story",
  "obtrusive": "beautiful",
  "obturate": "build",
  "obturator": "build",
  "obtuse": "beautiful",
  "obtuseness": "smart",
  "obverse": "smart",
  "obviate": "sell",
  "obvious": "beautiful",
  "oca": "heal",
  "ocarina": "build",
  "occasions": "smart",
  "occidental": "story",
  "occidentalism": "smart",
  "occiput": "heal",
  "occitan": "story",
  "occlude": "build",
  "occlusion": "smart",
  "occlusive": "story",
  "occult": "sound",
  "occultism": "smart",
  "occupied": "sell",
  "occupy": "sell",
  "occur": "smart",
  "occurrent": "beautiful",
  "ocean": "smart",
  "oceanic": "story",
  "oceanites": "heal",
  "oceanography": "smart",
  "oceanology": "smart",
  "ocellus": "heal",
  "ocelot": "heal",
  "ocher": "beautiful",
  "ochna": "heal",
  "ochnaceae": "heal",
  "ochotona": "heal",
  "ochotonidae": "heal",
  "ochre": "beautiful",
  "ochroma": "heal",
  "ochronosis": "beautiful",
  "ocimum": "heal",
  "ocotillo": "heal",
  "octad": "smart",
  "octameter": "story",
  "octant": "build",
  "octave": "sound",
  "octet": "smart",
  "octette": "story",
  "octillion": "smart",
  "octoberfest": "taste",
  "octogenarian": "beautiful",
  "octonary": "smart",
  "octopod": "heal",
  "octopoda": "heal",
  "octopodidae": "heal",
  "octopus": "taste",
  "octosyllable": "story",
  "octroi": "sell",
  "ocular": "build",
  "oculist": "heal",
  "oculomotor": "heal",
  "oculus": "heal",
  "ocyurus": "heal",
  "odd": "beautiful",
  "oddity": "build",
  "oddment": "build",
  "oddments": "build",
  "ode": "story",
  "odobenidae": "heal",
  "odobenus": "heal",
  "odocoileus": "heal",
  "odometer": "build",
  "odonata": "heal",
  "odonate": "heal",
  "odontaspididae": "heal",
  "odontaspis": "heal",
  "odontiasis": "smart",
  "odontoceti": "heal",
  "odontoglossum": "heal",
  "odontology": "smart",
  "odontophorus": "heal",
  "odor": "smart",
  "odorize": "sound",
  "odorless": "beautiful",
  "odorous": "beautiful",
  "odour": "smart",
  "odourise": "sound",
  "odourless": "beautiful",
  "odyssey": "story",
  "oecanthus": "heal",
  "oed": "story",
  "oedogoniaceae": "heal",
  "oedogoniales": "heal",
  "oedogonium": "heal",
  "oenanthe": "heal",
  "oenologist": "taste",
  "oenology": "taste",
  "oenomel": "taste",
  "oenothera": "heal",
  "oersted": "smart",
  "oesophagoscope": "build",
  "oesophagus": "heal",
  "oestradiol": "sound",
  "oestridae": "heal",
  "oestrone": "sound",
  "oestrus": "heal",
  "oeuvre": "build",
  "off": "sell",
  "off-licence": "build",
  "off-line": "beautiful",
  "off-roader": "build",
  "off-site": "beautiful",
  "off-street": "beautiful",
  "off-white": "beautiful",
  "offal": "taste",
  "offbeat": "story",
  "offend": "sell",
  "offending": "sell",
  "offensive": "beautiful",
  "offer": "story",
  "offering": "story",
  "offertory": "sell",
  "office": "build",
  "official": "beautiful",
  "officialese": "story",
  "officiate": "sell",
  "officiating": "sell",
  "offing": "sell",
  "offload": "sell",
  "offprint": "story",
  "offsaddle": "build",
  "offset": "sell",
  "offshoot": "sound",
  "offshore": "beautiful",
  "offside": "beautiful",
  "offsides": "beautiful",
  "offspring": "heal",
  "offstage": "build",
  "ofo": "story",
  "ogalala": "story",
  "ogcocephalidae": "heal",
  "ogdoad": "smart",
  "ogee": "build",
  "ogive": "build",
  "oglala": "story",
  "ogle": "sound",
  "ohm": "smart",
  "ohmage": "sound",
  "ohmmeter": "build",
  "oil": "beautiful",
  "oilbird": "heal",
  "oilcan": "build",
  "oilcloth": "build",
  "oiled": "build",
  "oiler": "build",
  "oilfish": "heal",
  "oilrig": "build",
  "oilseed": "heal",
  "oilskin": "build",
  "oilstone": "build",
  "oilstove": "build",
  "oink": "story",
  "ointment": "build",
  "ojibwa": "story",
  "ojibway": "story",
  "oka": "smart",
  "okapi": "heal",
  "okapia": "heal",
  "okay": "story",
  "okeh": "story",
  "okey": "story",
  "okra": "heal",
  "oktoberfest": "taste",
  "old": "beautiful",
  "old-man-of-the-woods": "heal",
  "oldie": "story",
  "oldwench": "heal",
  "oldwife": "heal",
  "olea": "heal",
  "oleaceae": "heal",
  "oleales": "heal",
  "oleander": "heal",
  "oleandra": "heal",
  "oleandraceae": "heal",
  "olearia": "heal",
  "oleaster": "heal",
  "olecranon": "heal",
  "oled": "build",
  "oleo": "taste",
  "oleomargarine": "taste",
  "oleophilic": "beautiful",
  "oleophobic": "beautiful",
  "olfaction": "smart",
  "olfersia": "heal",
  "oligochaeta": "heal",
  "oligochaete": "heal",
  "oligodendria": "heal",
  "oligodendrocyte": "heal",
  "oligodendroglia": "heal",
  "oligomenorrhea": "smart",
  "oligoplites": "heal",
  "oligoporus": "heal",
  "oliguria": "smart",
  "olive": "heal",
  "ollari": "story",
  "olm": "heal",
  "ology": "smart",
  "omaha": "story",
  "omasum": "heal",
  "ombu": "heal",
  "omega": "story",
  "omelet": "taste",
  "omelette": "taste",
  "omen": "story",
  "omentum": "heal",
  "omerta": "story",
  "omicron": "story",
  "omission": "smart",
  "omit": "smart",
  "ommastrephes": "heal",
  "ommatidium": "heal",
  "omnibus": "story",
  "omnirange": "build",
  "omnivore": "heal",
  "omnivorous": "beautiful",
  "omomyid": "heal",
  "omotic": "story",
  "omphalos": "heal",
  "omphaloskepsis": "smart",
  "omphalotus": "heal",
  "omphalus": "heal",
  "on-license": "story",
  "on-line": "beautiful",
  "on-site": "beautiful",
  "on-street": "beautiful",
  "onager": "build",
  "onagraceae": "heal",
  "oncidium": "heal",
  "oncogene": "heal",
  "oncologic": "heal",
  "oncological": "heal",
  "oncologist": "heal",
  "oncology": "heal",
  "oncoming": "beautiful",
  "oncorhynchus": "heal",
  "oncovin": "build",
  "ondatra": "heal",
  "one": "smart",
  "one-billionth": "smart",
  "one-dimensional": "beautiful",
  "one-eighth": "smart",
  "one-fifth": "smart",
  "one-fourth": "smart",
  "one-half": "smart",
  "one-hundred-millionth": "smart",
  "one-hundred-thousandth": "smart",
  "one-hundredth": "smart",
  "one-liner": "story",
  "one-millionth": "smart",
  "one-ninth": "smart",
  "one-piece": "beautiful",
  "one-quadrillionth": "smart",
  "one-quarter": "smart",
  "one-quintillionth": "smart",
  "one-seventh": "smart",
  "one-sided": "beautiful",
  "one-sixteenth": "smart",
  "one-sixth": "smart",
  "one-sixtieth": "smart",
  "one-sixty-fourth": "smart",
  "one-spot": "build",
  "one-ten-thousandth": "smart",
  "one-tenth": "smart",
  "one-third": "smart",
  "one-thirty-second": "smart",
  "one-thousandth": "smart",
  "one-trillionth": "smart",
  "one-twelfth": "smart",
  "one-year": "beautiful",
  "oneida": "story",
  "oneirism": "smart",
  "oneiromancy": "smart",
  "onion": "heal",
  "oniscidae": "heal",
  "oniscus": "heal",
  "online": "beautiful",
  "onobrychis": "heal",
  "onoclea": "heal",
  "onomancy": "smart",
  "onomasticon": "story",
  "onomastics": "smart",
  "onomatopoeia": "story",
  "onomatopoeic": "beautiful",
  "onomatopoeical": "beautiful",
  "onomatopoetic": "beautiful",
  "onondaga": "story",
  "ononis": "heal",
  "onopordon": "heal",
  "onopordum": "heal",
  "onosmodium": "heal",
  "onshore": "beautiful",
  "onside": "beautiful",
  "onslaught": "story",
  "onstage": "beautiful",
  "ontogenesis": "smart",
  "ontogeny": "smart",
  "ontology": "smart",
  "onus": "smart",
  "onychium": "heal",
  "onychogalea": "heal",
  "onychomys": "heal",
  "onychophora": "heal",
  "onychophoran": "heal",
  "onymous": "beautiful",
  "onyxis": "heal",
  "oocyte": "heal",
  "oodles": "smart",
  "oogenesis": "smart",
  "ooh": "story",
  "oology": "smart",
  "oolong": "taste",
  "oomycetes": "heal",
  "oosphere": "heal",
  "oospore": "heal",
  "ootid": "heal",
  "ooze": "heal",
  "oozing": "heal",
  "opacification": "smart",
  "opacity": "sound",
  "opah": "heal",
  "opaque": "beautiful",
  "open": "smart",
  "open-chain": "beautiful",
  "openbill": "heal",
  "opened": "build",
  "opener": "build",
  "openwork": "build",
  "opepe": "heal",
  "opera": "story",
  "operable": "beautiful",
  "operand": "smart",
  "operate": "sell",
  "operating": "sell",
  "operation": "smart",
  "operational": "beautiful",
  "operationalism": "smart",
  "operative": "beautiful",
  "operculum": "heal",
  "operetta": "story",
  "operon": "heal",
  "opheodrys": "heal",
  "ophidia": "heal",
  "ophidian": "heal",
  "ophidiidae": "heal",
  "ophiodon": "heal",
  "ophiodontidae": "heal",
  "ophioglossaceae": "heal",
  "ophioglossales": "heal",
  "ophioglossum": "heal",
  "ophiophagus": "heal",
  "ophisaurus": "heal",
  "ophiurida": "heal",
  "ophiuroidea": "heal",
  "ophryon": "heal",
  "ophrys": "heal",
  "ophthalmologist": "heal",
  "ophthalmology": "smart",
  "ophthalmoscope": "build",
  "opiate": "build",
  "opiliones": "heal",
  "opine": "story",
  "opinion": "smart",
  "opisthobranchia": "heal",
  "opisthocomidae": "heal",
  "opisthocomus": "heal",
  "opisthognathidae": "heal",
  "opisthognathous": "beautiful",
  "opium": "build",
  "opossum": "heal",
  "opponent": "beautiful",
  "opportune": "beautiful",
  "opportunist": "beautiful",
  "opposable": "beautiful",
  "oppose": "story",
  "opposed": "story",
  "opposite": "story",
  "oppress": "sell",
  "oppugn": "story",
  "opsonisation": "smart",
  "opsonization": "smart",
  "opt": "smart",
  "optez": "story",
  "optic": "heal",
  "optics": "smart",
  "optimise": "heal",
  "optimistic": "beautiful",
  "optimize": "heal",
  "optimum": "beautiful",
  "option": "sell",
  "optional": "beautiful",
  "opuntia": "heal",
  "opuntiales": "heal",
  "opus": "story",
  "opv": "build",
  "orach": "heal",
  "orache": "heal",
  "oracle": "story",
  "oracular": "beautiful",
  "oral": "story",
  "orang": "heal",
  "orange": "taste",
  "orangeade": "taste",
  "orangeness": "beautiful",
  "orangery": "sell",
  "orangewood": "heal",
  "orangutan": "heal",
  "orangutang": "heal",
  "orate": "story",
  "oration": "story",
  "oratorio": "story",
  "oratory": "story",
  "orb": "heal",
  "orb-weaver": "heal",
  "orbignya": "heal",
  "orbitale": "heal",
  "orbiter": "build",
  "orca": "heal",
  "orchard": "taste",
  "orchestia": "heal",
  "orchestiidae": "heal",
  "orchestra": "sound",
  "orchestrate": "sound",
  "orchestrated": "build",
  "orchestration": "story",
  "orchid": "heal",
  "orchidaceae": "heal",
  "orchidales": "heal",
  "orchil": "heal",
  "orchis": "heal",
  "orcinus": "heal",
  "ordain": "sell",
  "order": "story",
  "order-chenopodiales": "heal",
  "ordered": "story",
  "ordering": "story",
  "orderly": "beautiful",
  "ordinal": "smart",
  "ordinance": "story",
  "ordinary": "build",
  "ordinate": "smart",
  "ordnance": "build",
  "ore": "smart",
  "oreamnos": "heal",
  "orectolobidae": "heal",
  "orectolobus": "heal",
  "oregano": "heal",
  "oreo": "taste",
  "oreopteris": "heal",
  "oreortyx": "heal",
  "organ": "heal",
  "organdie": "build",
  "organdy": "build",
  "organelle": "heal",
  "organic": "beautiful",
  "organicism": "smart",
  "organification": "smart",
  "organisation": "smart",
  "organise": "sell",
  "organiser": "build",
  "organization": "smart",
  "organize": "sell",
  "organized": "sell",
  "organizer": "build",
  "organon": "smart",
  "organs": "taste",
  "organza": "build",
  "oriel": "build",
  "orient": "sound",
  "oriental": "beautiful",
  "orientalism": "smart",
  "orientate": "sound",
  "orientated": "sound",
  "orientating": "sound",
  "orientation": "smart",
  "oriented": "sound",
  "orienting": "sound",
  "orifice": "heal",
  "oriflamme": "story",
  "origanum": "heal",
  "origin": "smart",
  "original": "build",
  "originalism": "smart",
  "originality": "smart",
  "originate": "build",
  "originative": "beautiful",
  "orinasal": "story",
  "orinase": "build",
  "oriole": "heal",
  "oriolidae": "heal",
  "oriolus": "heal",
  "orison": "story",
  "orites": "heal",
  "oriya": "story",
  "orleanism": "smart",
  "orlon": "build",
  "orlop": "build",
  "ormer": "heal",
  "ormosia": "heal",
  "ornament": "beautiful",
  "ornamental": "beautiful",
  "ornamentation": "build",
  "ornateness": "story",
  "ornithischia": "heal",
  "ornithischian": "heal",
  "ornithogalum": "heal",
  "ornithology": "smart",
  "ornithomimid": "heal",
  "ornithomimida": "heal",
  "ornithopod": "heal",
  "ornithopoda": "heal",
  "ornithopter": "build",
  "ornithorhynchidae": "heal",
  "ornithorhynchus": "heal",
  "orobanchaceae": "heal",
  "orogeny": "smart",
  "orography": "smart",
  "orology": "smart",
  "orontium": "heal",
  "oropharynx": "heal",
  "orphan": "story",
  "orphanage": "build",
  "orphenadrine": "build",
  "orphic": "beautiful",
  "orphrey": "build",
  "orpin": "heal",
  "orpine": "heal",
  "orpington": "heal",
  "orrery": "build",
  "orris": "heal",
  "orrisroot": "heal",
  "ortalis": "heal",
  "orthicon": "build",
  "orthilia": "heal",
  "orthodontia": "smart",
  "orthodontics": "smart",
  "orthodonture": "smart",
  "orthodox": "beautiful",
  "orthodoxy": "smart",
  "orthoepy": "story",
  "orthography": "story",
  "orthomyxovirus": "heal",
  "orthopaedics": "smart",
  "orthopedics": "smart",
  "orthopristis": "heal",
  "orthopter": "build",
  "orthoptera": "heal",
  "orthopteran": "heal",
  "orthopteron": "heal",
  "orthoscope": "build",
  "orthotomus": "heal",
  "orthotropous": "beautiful",
  "ortolan": "heal",
  "ortygan": "heal",
  "orudis": "build",
  "oruvail": "build",
  "orycteropodidae": "heal",
  "orycteropus": "heal",
  "oryctolagus": "heal",
  "oryx": "heal",
  "oryza": "heal",
  "oryzomys": "heal",
  "oryzopsis": "heal",
  "orzo": "taste",
  "osage": "story",
  "oscan": "story",
  "oscar": "story",
  "oscillation": "smart",
  "oscillator": "sound",
  "oscillatoriaceae": "heal",
  "oscillogram": "build",
  "oscillograph": "build",
  "oscilloscope": "build",
  "oscine": "heal",
  "oscines": "heal",
  "osco-umbrian": "story",
  "osculate": "build",
  "osier": "heal",
  "osmanthus": "heal",
  "osmeridae": "heal",
  "osmerus": "heal",
  "osmitrol": "build",
  "osmoreceptor": "heal",
  "osmosis": "smart",
  "osmund": "heal",
  "osmundaceae": "heal",
  "osprey": "heal",
  "ossete": "story",
  "ossicle": "heal",
  "ossiculum": "heal",
  "ossification": "smart",
  "ossuary": "build",
  "ostariophysi": "heal",
  "osteichthyes": "heal",
  "ostensorium": "build",
  "ostentate": "sound",
  "ostentation": "story",
  "ostentatious": "beautiful",
  "osteoblast": "heal",
  "osteoclast": "heal",
  "osteocyte": "heal",
  "osteoglossidae": "heal",
  "osteoglossiformes": "heal",
  "osteology": "smart",
  "osteolysis": "smart",
  "osteophyte": "heal",
  "osteostracan": "heal",
  "osteostraci": "heal",
  "ostinato": "story",
  "ostiole": "heal",
  "ostraciidae": "heal",
  "ostracise": "sell",
  "ostracize": "sell",
  "ostracod": "heal",
  "ostracoda": "heal",
  "ostracoderm": "heal",
  "ostracodermi": "heal",
  "ostrea": "heal",
  "ostreidae": "heal",
  "ostrich": "heal",
  "ostrya": "heal",
  "ostryopsis": "heal",
  "ostyak": "story",
  "ostyak-samoyed": "story",
  "otaria": "heal",
  "otariidae": "heal",
  "other": "beautiful",
  "otherworld": "smart",
  "othonna": "heal",
  "otides": "heal",
  "otididae": "heal",
  "otis": "heal",
  "oto": "story",
  "otoe": "story",
  "otoganglion": "heal",
  "otolaryngology": "smart",
  "otology": "smart",
  "otorhinolaryngology": "smart",
  "otoscope": "build",
  "otter": "heal",
  "otterhound": "heal",
  "ottoman": "build",
  "otus": "heal",
  "oubliette": "build",
  "ouguiya": "smart",
  "ouija": "build",
  "ounce": "smart",
  "ouranopithecus": "heal",
  "ousel": "heal",
  "oust": "sell",
  "ousting": "sell",
  "out": "story",
  "out-and-outer": "beautiful",
  "out-basket": "build",
  "out-of-door": "beautiful",
  "out-tray": "build",
  "outage": "smart",
  "outback": "beautiful",
  "outbid": "sell",
  "outboard": "build",
  "outbred": "beautiful",
  "outbuilding": "build",
  "outburst": "story",
  "outcall": "sell",
  "outcast": "beautiful",
  "outcaste": "beautiful",
  "outclass": "smart",
  "outcome": "sound",
  "outcry": "story",
  "outdoor": "beautiful",
  "outer": "beautiful",
  "outerwear": "build",
  "outface": "sound",
  "outfall": "build",
  "outfield": "build",
  "outfit": "build",
  "outfitter": "build",
  "outfitting": "sell",
  "outflow": "smart",
  "outgo": "sell",
  "outgoing": "beautiful",
  "outgrowth": "sound",
  "outguess": "story",
  "outhouse": "build",
  "outing": "story",
  "outlaw": "sell",
  "outlay": "sell",
  "outlet": "build",
  "outlier": "smart",
  "outline": "story",
  "outlook": "smart",
  "outpost": "build",
  "outpouring": "story",
  "output": "build",
  "outrigger": "build",
  "outside": "beautiful",
  "outsize": "beautiful",
  "outsole": "build",
  "outsource": "sell",
  "outspan": "build",
  "outstare": "sound",
  "outtake": "story",
  "outturn": "build",
  "outvote": "sell",
  "outward": "beautiful",
  "outwardness": "smart",
  "outwear": "heal",
  "outwork": "build",
  "ouzel": "heal",
  "ouzo": "taste",
  "oval": "beautiful",
  "ovalbumin": "taste",
  "ovalipes": "heal",
  "ovary": "heal",
  "ovation": "story",
  "oven": "taste",
  "ovenbird": "heal",
  "ovenware": "build",
  "over": "beautiful",
  "over-correct": "sell",
  "over-the-counter": "beautiful",
  "overachieve": "sell",
  "overact": "build",
  "overacting": "build",
  "overactivity": "smart",
  "overage": "sell",
  "overall": "build",
  "overappraisal": "story",
  "overarm": "beautiful",
  "overbalance": "sell",
  "overbear": "build",
  "overbid": "story",
  "overburden": "build",
  "overcall": "story",
  "overcapitalise": "smart",
  "overcapitalize": "smart",
  "overcast": "build",
  "overcasting": "build",
  "overcharge": "sell",
  "overclothe": "heal",
  "overclothes": "build",
  "overcoat": "build",
  "overcoating": "build",
  "overcompensate": "sell",
  "overcompensation": "smart",
  "overconfidence": "smart",
  "overcrop": "build",
  "overcrossing": "build",
  "overcultivate": "build",
  "overdo": "sell",
  "overdose": "heal",
  "overdraft": "sell",
  "overdramatise": "story",
  "overdramatize": "story",
  "overdraw": "sell",
  "overdress": "heal",
  "overdrive": "sound",
  "overeat": "taste",
  "overeating": "taste",
  "overemphasise": "story",
  "overemphasize": "story",
  "overestimate": "story",
  "overestimation": "story",
  "overexert": "sell",
  "overexploit": "taste",
  "overexpose": "sound",
  "overextend": "taste",
  "overfatigue": "heal",
  "overfeed": "taste",
  "overfeeding": "taste",
  "overgarment": "build",
  "overgeneralise": "story",
  "overgeneralize": "story",
  "overgorge": "taste",
  "overhand": "beautiful",
  "overhanded": "beautiful",
  "overhang": "build",
  "overhead": "sell",
  "overhear": "sound",
  "overheating": "smart",
  "overindulge": "taste",
  "overlap": "smart",
  "overlapping": "build",
  "overlay": "build",
  "overlayer": "build",
  "overleap": "sell",
  "overlie": "build",
  "overlip": "heal",
  "overload": "build",
  "overlook": "sound",
  "overmantel": "build",
  "overmuch": "beautiful",
  "overnighter": "build",
  "overpass": "build",
  "overpay": "sell",
  "overpayment": "sell",
  "overplay": "build",
  "overpraise": "story",
  "overpressure": "sound",
  "overprice": "sell",
  "overprint": "build",
  "overproduce": "build",
  "overprotect": "sell",
  "overrate": "smart",
  "overrating": "smart",
  "overreach": "sell",
  "overreact": "smart",
  "overreckoning": "smart",
  "override": "build",
  "overrule": "smart",
  "oversee": "sell",
  "oversew": "build",
  "overshadow": "sound",
  "overshoe": "build",
  "overshoot": "smart",
  "oversight": "smart",
  "oversimplification": "story",
  "oversimplify": "sell",
  "overskirt": "build",
  "oversleep": "heal",
  "overspend": "sell",
  "overstate": "story",
  "overstatement": "story",
  "overstock": "sell",
  "overstrain": "sound",
  "overstress": "story",
  "overstretch": "heal",
  "overstuff": "build",
  "oversupply": "sell",
  "overt": "beautiful",
  "overtax": "sell",
  "overthrow": "sell",
  "overtire": "heal",
  "overtone": "story",
  "overture": "story",
  "overuse": "taste",
  "overvaluation": "story",
  "overvalue": "smart",
  "overview": "story",
  "overweary": "heal",
  "overweight": "beautiful",
  "overwhelm": "story",
  "overwork": "build",
  "overworking": "build",
  "overwrite": "story",
  "ovibos": "heal",
  "oviduct": "heal",
  "oviparous": "beautiful",
  "ovipositor": "heal",
  "oviraptorid": "heal",
  "ovis": "heal",
  "ovocon": "build",
  "ovoid": "beautiful",
  "ovolo": "build",
  "ovotestis": "heal",
  "ovoviviparous": "beautiful",
  "ovral": "build",
  "ovrette": "build",
  "ovulate": "heal",
  "ovulation": "smart",
  "ovule": "heal",
  "ovulen": "build",
  "ovum": "heal",
  "owe": "sell",
  "owl": "heal",
  "owlclaws": "heal",
  "owlet": "heal",
  "own": "sell",
  "owned": "sell",
  "ownerless": "beautiful",
  "ownership": "sell",
  "oxacillin": "build",
  "oxalidaceae": "heal",
  "oxalis": "heal",
  "oxandra": "heal",
  "oxaprozin": "build",
  "oxazepam": "build",
  "oxbow": "build",
  "oxbridge": "build",
  "oxcart": "build",
  "oxen": "heal",
  "oxeye": "heal",
  "oxford": "build",
  "oxheart": "heal",
  "oxidation": "smart",
  "oxidation-reduction": "smart",
  "oxidisation": "smart",
  "oxidization": "smart",
  "oxidoreduction": "smart",
  "oximeter": "build",
  "oxlip": "heal",
  "oxtail": "heal",
  "oxtant": "smart",
  "oxtongue": "heal",
  "oxyacetylene": "build",
  "oxybelis": "heal",
  "oxydendrum": "heal",
  "oxygenation": "smart",
  "oxylebius": "heal",
  "oxymoron": "story",
  "oxyopia": "smart",
  "oxyphenbutazone": "build",
  "oxyphencyclimine": "build",
  "oxytetracycline": "build",
  "oxytocic": "build",
  "oxytocin": "heal",
  "oxytone": "story",
  "oxytropis": "heal",
  "oxyura": "heal",
  "oxyuranus": "heal",
  "oxyuridae": "heal",
  "oyster": "heal",
  "oyster-fish": "heal",
  "oystercatcher": "heal",
  "oysterfish": "heal",
  "oz.": "smart",
  "ozonium": "heal",
  "ozothamnus": "heal",
  "p.a.": "build",
  "p.e.": "sound",
  "pa'anga": "smart",
  "pabir": "story",
  "pablum": "taste",
  "pabulum": "taste",
  "paca": "heal",
  "pace": "smart",
  "pacemaker": "smart",
  "pacer": "heal",
  "pacesetter": "smart",
  "pachouli": "heal",
  "pachycephala": "heal",
  "pachycephalosaur": "heal",
  "pachycephalosaurus": "heal",
  "pachyderm": "heal",
  "pachydermatous": "beautiful",
  "pachyrhizus": "heal",
  "pachysandra": "heal",
  "pachytene": "smart",
  "pacific": "beautiful",
  "pacification": "story",
  "pacificism": "smart",
  "pacifier": "build",
  "pacifism": "smart",
  "pacifist": "beautiful",
  "pacify": "build",
  "pack": "smart",
  "package": "build",
  "packaged": "build",
  "packaging": "story",
  "packera": "heal",
  "packet": "story",
  "packhorse": "heal",
  "packing": "build",
  "packinghouse": "build",
  "packrat": "heal",
  "packsack": "build",
  "packsaddle": "build",
  "packthread": "build",
  "pact": "story",
  "pad": "heal",
  "padauk": "heal",
  "padda": "heal",
  "padding": "build",
  "paddle": "build",
  "paddle-box": "build",
  "paddle-wheeler": "build",
  "paddlefish": "heal",
  "paddlewheel": "build",
  "paddock": "build",
  "paddy": "taste",
  "paddymelon": "heal",
  "pademelon": "heal",
  "padlock": "build",
  "padouk": "heal",
  "paean": "story",
  "paediatrics": "smart",
  "paella": "taste",
  "paeonia": "heal",
  "paeoniaceae": "heal",
  "paeony": "heal",
  "pagan": "beautiful",
  "paganism": "smart",
  "page": "story",
  "pageboy": "heal",
  "pagellus": "heal",
  "pager": "build",
  "paget": "heal",
  "paginate": "story",
  "pagination": "story",
  "paging": "story",
  "pagoda": "build",
  "pagophila": "heal",
  "pagophilus": "heal",
  "pagrus": "heal",
  "paguridae": "heal",
  "pagurus": "heal",
  "pahautea": "heal",
  "pahlavi": "story",
  "paid": "sell",
  "paigle": "heal",
  "pail": "build",
  "pailful": "smart",
  "paillasse": "build",
  "pain": "smart",
  "painful": "beautiful",
  "painkiller": "build",
  "painless": "beautiful",
  "pains": "smart",
  "paint": "beautiful",
  "paintable": "beautiful",
  "paintball": "build",
  "paintbox": "build",
  "paintbrush": "build",
  "painted": "build",
  "painter": "beautiful",
  "painting": "beautiful",
  "pair": "smart",
  "paired": "sell",
  "pairing": "sell",
  "paisa": "smart",
  "paisley": "build",
  "paiute": "story",
  "paiwanic": "story",
  "pajama": "build",
  "pakchoi": "heal",
  "pal": "sell",
  "palace": "build",
  "palaeencephalon": "heal",
  "palaemon": "heal",
  "palaemonidae": "heal",
  "palaeoanthropology": "smart",
  "palaeobiology": "smart",
  "palaeobotany": "smart",
  "palaeoclimatology": "smart",
  "palaeodendrology": "smart",
  "palaeoecology": "smart",
  "palaeoethnography": "smart",
  "palaeogeography": "smart",
  "palaeogeology": "smart",
  "palaeology": "smart",
  "palaeontology": "smart",
  "palaeopathology": "heal",
  "palaeornithology": "smart",
  "palaeozoology": "smart",
  "palaestra": "build",
  "palaetiology": "smart",
  "palaic": "story",
  "palankeen": "build",
  "palanquin": "build",
  "palaquium": "heal",
  "palas": "heal",
  "palatable": "beautiful",
  "palatal": "story",
  "palatalise": "story",
  "palatalize": "story",
  "palate": "taste",
  "palatial": "beautiful",
  "palatine": "heal",
  "palatoglossal": "taste",
  "palaver": "story",
  "pale": "build",
  "paleacrita": "heal",
  "paleencephalon": "heal",
  "paleoanthropology": "smart",
  "paleobiology": "smart",
  "paleobotany": "smart",
  "paleocerebellum": "heal",
  "paleoclimatology": "smart",
  "paleocortex": "heal",
  "paleodendrology": "smart",
  "paleoecology": "smart",
  "paleoencephalon": "heal",
  "paleoethnography": "smart",
  "paleogeography": "smart",
  "paleogeology": "smart",
  "paleography": "smart",
  "paleolith": "build",
  "paleology": "smart",
  "paleomammalogy": "smart",
  "paleontology": "smart",
  "paleopathology": "heal",
  "paleornithology": "smart",
  "paleostriatum": "heal",
  "paleozoology": "smart",
  "palestra": "build",
  "paletiology": "smart",
  "palette": "beautiful",
  "palfrey": "heal",
  "pali": "story",
  "palilalia": "heal",
  "palimony": "sell",
  "palimpsest": "story",
  "palindrome": "story",
  "paling": "build",
  "palingenesis": "smart",
  "palinuridae": "heal",
  "palinurus": "heal",
  "palisade": "build",
  "paliurus": "heal",
  "pall": "build",
  "pallet": "build",
  "pallette": "build",
  "palliasse": "build",
  "palliate": "story",
  "palliative": "heal",
  "pallidum": "heal",
  "pallium": "heal",
  "palm": "heal",
  "palmaceae": "heal",
  "palmae": "heal",
  "palmales": "heal",
  "palmetto": "heal",
  "palmistry": "smart",
  "palmyra": "heal",
  "palometa": "heal",
  "palomino": "heal",
  "paloverde": "heal",
  "palpable": "beautiful",
  "palpate": "build",
  "palpebra": "heal",
  "palpebrate": "heal",
  "palter": "story",
  "paltering": "story",
  "pamelor": "build",
  "pamlico": "story",
  "pamper": "sell",
  "pampering": "sell",
  "pamphlet": "story",
  "pan": "taste",
  "panacea": "build",
  "panache": "build",
  "panadol": "build",
  "panama": "build",
  "panamica": "heal",
  "panamiga": "heal",
  "panatela": "build",
  "panax": "heal",
  "pancake": "taste",
  "pancreas": "heal",
  "panda": "heal",
  "pandanaceae": "heal",
  "pandanales": "heal",
  "pandanus": "heal",
  "pandemic": "beautiful",
  "pander": "taste",
  "pandiculation": "beautiful",
  "pandion": "heal",
  "pandionidae": "heal",
  "pandowdy": "taste",
  "pane": "build",
  "panegyric": "story",
  "panel": "build",
  "paneling": "build",
  "panelling": "build",
  "panetela": "build",
  "panetella": "build",
  "panfish": "taste",
  "panga": "build",
  "pangolin": "heal",
  "panhandle": "build",
  "panicle": "heal",
  "panicum": "heal",
  "panjabi": "story",
  "pannier": "build",
  "pannikin": "build",
  "panocha": "taste",
  "panoche": "taste",
  "panonychus": "heal",
  "panopticon": "build",
  "panorama": "smart",
  "panorpidae": "heal",
  "panpipe": "build",
  "pansy": "heal",
  "pant": "build",
  "pant-hoot": "story",
  "pantaloon": "build",
  "pantechnicon": "build",
  "pantheism": "smart",
  "pantheon": "build",
  "panther": "heal",
  "panthera": "heal",
  "pantie": "build",
  "panting": "build",
  "pantograph": "build",
  "pantomime": "build",
  "pantotheria": "heal",
  "pantry": "taste",
  "pants": "build",
  "pantsuit": "build",
  "panty": "build",
  "pantyhose": "build",
  "panzer": "build",
  "pap": "story",
  "papaia": "heal",
  "papaver": "heal",
  "papaveraceae": "heal",
  "papaverales": "heal",
  "papaverine": "build",
  "papaw": "heal",
  "papaya": "heal",
  "paper": "story",
  "paperback": "build",
  "paperclip": "build",
  "papering": "build",
  "paperknife": "build",
  "papers": "story",
  "paperweight": "build",
  "papery": "beautiful",
  "paphiopedilum": "heal",
  "papilionaceae": "heal",
  "papilionoideae": "heal",
  "papilla": "heal",
  "papillon": "heal",
  "papio": "heal",
  "papism": "smart",
  "papooseroot": "heal",
  "papovavirus": "heal",
  "pappus": "heal",
  "paprika": "heal",
  "paprilus": "heal",
  "papuan": "story",
  "papyrus": "heal",
  "par": "smart",
  "para": "smart",
  "parable": "story",
  "parabolic": "beautiful",
  "parabolical": "beautiful",
  "paracentesis": "heal",
  "paracheirodon": "heal",
  "parachute": "build",
  "paracosm": "smart",
  "paradigm": "smart",
  "paradisaeidae": "heal",
  "paradise": "smart",
  "paradox": "story",
  "paradoxurus": "heal",
  "parafovea": "heal",
  "paragon": "smart",
  "paragraph": "story",
  "parakeet": "heal",
  "paralanguage": "story",
  "paraleipsis": "story",
  "paralepsis": "story",
  "paralichthys": "heal",
  "paralipomenon": "story",
  "paralipsis": "story",
  "paralithodes": "heal",
  "parallax": "sound",
  "parallelize": "build",
  "paralogism": "smart",
  "paralytic": "beautiful",
  "paramagnet": "build",
  "paramagnetism": "sound",
  "paramecia": "heal",
  "paramecium": "heal",
  "parameter": "smart",
  "paramnesia": "smart",
  "paramyxovirus": "heal",
  "parang": "build",
  "paranoid": "beautiful",
  "paranormal": "beautiful",
  "paranthias": "heal",
  "paranthropus": "heal",
  "parapet": "build",
  "paraph": "story",
  "paraphernalia": "build",
  "paraphrase": "story",
  "paraphrasis": "story",
  "paraphysis": "heal",
  "paraplegic": "beautiful",
  "parapodium": "heal",
  "parapsychology": "story",
  "paraquet": "heal",
  "parasail": "build",
  "parascalops": "heal",
  "parasitaxus": "heal",
  "parasite": "heal",
  "parasitic": "beautiful",
  "parasitical": "beautiful",
  "parasol": "build",
  "parasympathetic": "heal",
  "parathelypteris": "heal",
  "parathormone": "heal",
  "parathyroid": "heal",
  "parazoa": "heal",
  "parazoan": "heal",
  "parcel": "build",
  "parceling": "sell",
  "parcelling": "sell",
  "pardon": "story",
  "pardonable": "beautiful",
  "pare": "build",
  "paregmenon": "story",
  "paregoric": "build",
  "parenchyma": "heal",
  "parent": "sell",
  "parental": "beautiful",
  "parented": "sell",
  "parenthesis": "story",
  "parenthetical": "story",
  "parentless": "beautiful",
  "parer": "build",
  "parfait": "taste",
  "parget": "build",
  "pargeting": "build",
  "pargetry": "build",
  "pargetting": "build",
  "parhelion": "sound",
  "paridae": "heal",
  "paries": "heal",
  "parietales": "heal",
  "parietaria": "heal",
  "paring": "taste",
  "paris": "heal",
  "parisology": "story",
  "parity": "smart",
  "parji": "story",
  "park": "build",
  "parka": "build",
  "parked": "build",
  "parkeriaceae": "heal",
  "parkia": "heal",
  "parking": "smart",
  "parkinsonia": "heal",
  "parks": "build",
  "parkway": "build",
  "parlance": "story",
  "parley": "story",
  "parliamentary": "beautiful",
  "parlor": "build",
  "parlour": "build",
  "parmelia": "heal",
  "parmeliaceae": "heal",
  "parmesan": "taste",
  "parnassia": "heal",
  "parochetus": "heal",
  "parochial": "beautiful",
  "parochialism": "smart",
  "parody": "story",
  "parole": "story",
  "paronomasia": "story",
  "paronychia": "heal",
  "parophrys": "heal",
  "paroquet": "heal",
  "paroxetime": "build",
  "paroxytone": "story",
  "parquet": "build",
  "parqueterie": "build",
  "parquetry": "build",
  "parr": "heal",
  "parrakeet": "heal",
  "parroket": "heal",
  "parroquet": "heal",
  "parrot": "heal",
  "parrotfish": "heal",
  "parrotia": "heal",
  "parrotiopsis": "heal",
  "parry": "story",
  "parse": "smart",
  "parsec": "smart",
  "parseeism": "smart",
  "parser": "story",
  "parsiism": "smart",
  "parsley": "heal",
  "parsnip": "heal",
  "parsonage": "build",
  "part": "build",
  "part-time": "beautiful",
  "partake": "sell",
  "parterre": "build",
  "parthenium": "heal",
  "parthenocarpy": "smart",
  "parthenocissus": "heal",
  "parthenogenesis": "smart",
  "parthenogeny": "smart",
  "parthenon": "build",
  "parthenote": "heal",
  "parthian": "story",
  "partial": "smart",
  "partiality": "smart",
  "participate": "sell",
  "participial": "story",
  "participle": "story",
  "particle": "story",
  "particular": "smart",
  "particularisation": "story",
  "particularise": "story",
  "particularism": "smart",
  "particularization": "story",
  "particularize": "story",
  "particulate": "beautiful",
  "parting": "heal",
  "partisan": "build",
  "partisanship": "smart",
  "partita": "story",
  "partition": "build",
  "partitioning": "smart",
  "partitive": "story",
  "partizan": "build",
  "partner": "sell",
  "partnership": "sell",
  "partridge": "taste",
  "partridgeberry": "heal",
  "parts": "build",
  "partsong": "story",
  "parttime": "beautiful",
  "parturient": "beautiful",
  "parturition": "smart",
  "party": "sound",
  "parula": "heal",
  "parulidae": "heal",
  "parus": "heal",
  "parvenu": "beautiful",
  "parvis": "build",
  "parvo": "heal",
  "parvovirus": "heal",
  "pas": "beautiful",
  "pasang": "heal",
  "pascal": "smart",
  "paseo": "build",
  "pashto": "story",
  "pashtu": "story",
  "pasigraphy": "story",
  "paspalum": "heal",
  "pasqueflower": "heal",
  "pasquinade": "story",
  "pass-through": "build",
  "passable": "beautiful",
  "passage": "story",
  "passageway": "build",
  "passbook": "sell",
  "passe-partout": "build",
  "passel": "smart",
  "passementerie": "build",
  "passeres": "heal",
  "passeridae": "heal",
  "passeriformes": "heal",
  "passerina": "heal",
  "passerine": "heal",
  "passiflora": "heal",
  "passifloraceae": "heal",
  "passionate": "beautiful",
  "passionflower": "heal",
  "passionless": "beautiful",
  "passive": "beautiful",
  "passivism": "smart",
  "passkey": "build",
  "passport": "story",
  "password": "story",
  "past": "story",
  "pasta": "taste",
  "paste": "taste",
  "paste-up": "build",
  "pastel": "beautiful",
  "paster": "story",
  "pastern": "heal",
  "pasteur": "taste",
  "pasteurised": "taste",
  "pasteurized": "taste",
  "pastiche": "story",
  "pastil": "taste",
  "pastille": "taste",
  "pastinaca": "heal",
  "pastis": "taste",
  "pastor": "heal",
  "pastoral": "story",
  "pastorale": "story",
  "pastrami": "taste",
  "pastry": "taste",
  "pasturage": "heal",
  "pasture": "taste",
  "pasty": "taste",
  "pat": "build",
  "pataca": "smart",
  "patas": "heal",
  "patch": "build",
  "patchboard": "build",
  "patchcord": "build",
  "patching": "build",
  "patchouli": "heal",
  "patchouly": "heal",
  "patchwork": "smart",
  "pate": "taste",
  "patella": "heal",
  "patellidae": "heal",
  "patent": "story",
  "paternal": "beautiful",
  "paternalism": "smart",
  "paternoster": "story",
  "path": "build",
  "pathogen": "heal",
  "pathogenesis": "smart",
  "pathologic": "heal",
  "pathological": "heal",
  "pathologist": "heal",
  "pathology": "heal",
  "pathos": "story",
  "pathway": "heal",
  "patient": "heal",
  "patina": "build",
  "patinate": "build",
  "patinise": "build",
  "patinize": "build",
  "patio": "build",
  "patisserie": "taste",
  "patka": "build",
  "patois": "story",
  "patriarchal": "beautiful",
  "patrician": "beautiful",
  "patrimony": "sell",
  "patriotic": "beautiful",
  "patristics": "story",
  "patrol": "sell",
  "patrology": "story",
  "patronage": "story",
  "patronise": "sell",
  "patronised": "sell",
  "patronize": "sell",
  "patronized": "sell",
  "patronless": "beautiful",
  "patronym": "story",
  "patronymic": "story",
  "patten": "build",
  "patter": "story",
  "pattern": "smart",
  "patterned": "build",
  "patternmaker": "build",
  "patty": "taste",
  "patty-pan": "build",
  "patwin": "story",
  "paunch": "heal",
  "pauperise": "sell",
  "pauperize": "sell",
  "pauropoda": "heal",
  "pause": "story",
  "pavage": "sell",
  "pavan": "story",
  "pavane": "story",
  "pave": "build",
  "paved": "build",
  "pavement": "build",
  "pavilion": "build",
  "paving": "build",
  "pavior": "build",
  "paviour": "build",
  "pavis": "build",
  "pavise": "build",
  "pavlov": "heal",
  "pavlova": "taste",
  "pavo": "heal",
  "pavonia": "heal",
  "paw": "heal",
  "pawl": "build",
  "pawn": "sell",
  "pawnee": "story",
  "pawnshop": "build",
  "pawpaw": "heal",
  "pax": "story",
  "paxil": "build",
  "paxto": "story",
  "pay": "sell",
  "pay-phone": "build",
  "pay-station": "build",
  "payable": "beautiful",
  "payables": "sell",
  "payback": "sell",
  "paycheck": "sell",
  "paye": "sell",
  "payena": "heal",
  "payload": "build",
  "payment": "sell",
  "payoff": "sell",
  "payola": "sell",
  "payroll": "sell",
  "paysheet": "sell",
  "payslip": "sell",
  "pbit": "smart",
  "pbs": "smart",
  "pcp": "build",
  "pda": "build",
  "pdl": "smart",
  "pe-tsai": "heal",
  "pea": "taste",
  "pea-chick": "heal",
  "pea-souper": "sound",
  "peaceable": "beautiful",
  "peaceful": "beautiful",
  "peacekeeper": "build",
  "peacemaker": "build",
  "peach": "heal",
  "peach-wood": "heal",
  "peachick": "heal",
  "peachwood": "heal",
  "peacoat": "build",
  "peacock": "heal",
  "peacock-throne": "build",
  "peafowl": "heal",
  "peag": "build",
  "peahen": "heal",
  "peak": "smart",
  "peal": "sound",
  "pealing": "sound",
  "pean": "story",
  "peanut": "heal",
  "peanuts": "sell",
  "pear": "taste",
  "pearl": "beautiful",
  "pearl-fish": "heal",
  "pearl-weed": "heal",
  "pearlfish": "heal",
  "pearlweed": "heal",
  "pearlwort": "heal",
  "pearly": "heal",
  "pearmain": "taste",
  "peasecod": "heal",
  "peavey": "build",
  "peavy": "build",
  "peba": "heal",
  "pebibit": "smart",
  "pebibyte": "smart",
  "pecan": "heal",
  "peccary": "heal",
  "peck": "smart",
  "pecker": "heal",
  "peckerwood": "heal",
  "pecopteris": "heal",
  "pecs": "heal",
  "pectinibranchia": "heal",
  "pectinidae": "heal",
  "pectoral": "heal",
  "pectoralis": "heal",
  "pectus": "heal",
  "peculate": "sell",
  "peculiarity": "smart",
  "pedagogics": "smart",
  "pedagogy": "smart",
  "pedal": "story",
  "pedaliaceae": "heal",
  "pedantry": "story",
  "peddle": "sell",
  "peddling": "sell",
  "pedesis": "sound",
  "pedestal": "build",
  "pedestrian": "beautiful",
  "pediamycin": "build",
  "pediatrics": "heal",
  "pedicab": "build",
  "pedicel": "heal",
  "pedicle": "heal",
  "pediculati": "heal",
  "pediculidae": "heal",
  "pediculus": "heal",
  "pedicure": "beautiful",
  "pedigree": "beautiful",
  "pedilanthus": "heal",
  "pediment": "build",
  "pediocactus": "heal",
  "pedioecetes": "heal",
  "pedionomus": "heal",
  "pedipalpi": "heal",
  "pedology": "smart",
  "pedometer": "build",
  "peduncle": "heal",
  "pedunculate": "beautiful",
  "pedwood": "heal",
  "pee": "smart",
  "pee-pee": "heal",
  "peeing": "smart",
  "peek": "sound",
  "peel": "taste",
  "peeler": "taste",
  "peeling": "sound",
  "peen": "build",
  "peep": "sound",
  "peeper": "heal",
  "peephole": "build",
  "peepshow": "story",
  "peepul": "heal",
  "peer": "sound",
  "peewee": "heal",
  "peewit": "heal",
  "peg": "build",
  "pegboard": "build",
  "pegleg": "build",
  "pehlevi": "story",
  "peignoir": "build",
  "peireskia": "heal",
  "pekan": "heal",
  "peke": "heal",
  "pekinese": "heal",
  "pekingese": "heal",
  "pekoe": "taste",
  "pel": "build",
  "pelage": "heal",
  "pelagianism": "smart",
  "pelargonium": "heal",
  "pelecanidae": "heal",
  "pelecaniformes": "heal",
  "pelecanoididae": "heal",
  "pelecanus": "heal",
  "pelecypod": "heal",
  "pelf": "sell",
  "pelham": "build",
  "pelican": "heal",
  "pelisse": "build",
  "pellaea": "heal",
  "pellet": "build",
  "pellicle": "heal",
  "pellicularia": "heal",
  "pellitory": "heal",
  "pellitory-of-spain": "heal",
  "pellitory-of-the-wall": "heal",
  "pelmet": "build",
  "pelobatidae": "heal",
  "pelt": "heal",
  "peltandra": "heal",
  "pelter": "sound",
  "pelting": "build",
  "peltiphyllum": "heal",
  "peludo": "heal",
  "pelvimeter": "build",
  "pelvis": "heal",
  "pelycosaur": "heal",
  "pelycosauria": "heal",
  "pembroke": "heal",
  "pemican": "taste",
  "pemmican": "taste",
  "pempheridae": "heal",
  "pen": "build",
  "pen-and-ink": "build",
  "pen-tail": "heal",
  "penal": "beautiful",
  "penalise": "sell",
  "penalize": "sell",
  "penalty": "sell",
  "pencil": "beautiful",
  "penciled": "build",
  "pencilled": "build",
  "pendant": "beautiful",
  "pendent": "build",
  "pendulum": "build",
  "peneidae": "heal",
  "penelope": "heal",
  "penetrable": "beautiful",
  "penetrate": "build",
  "penetration": "smart",
  "peneus": "heal",
  "pengo": "smart",
  "penguin": "heal",
  "penicillamine": "build",
  "penicillin": "build",
  "penicillium": "heal",
  "penis": "heal",
  "penitent": "beautiful",
  "penitentiary": "build",
  "penknife": "build",
  "penlight": "build",
  "penmanship": "story",
  "penn": "build",
  "penn'orth": "smart",
  "pennant": "story",
  "pennatula": "heal",
  "pennatulidae": "heal",
  "penne": "taste",
  "penni": "smart",
  "penning": "build",
  "pennisetum": "heal",
  "pennon": "build",
  "pennoncel": "build",
  "pennoncelle": "build",
  "pennsylvania": "build",
  "penny": "smart",
  "penny-pinch": "sell",
  "penny-pinching": "sell",
  "pennycress": "heal",
  "pennyroyal": "heal",
  "pennyweight": "smart",
  "pennywhistle": "build",
  "pennyworth": "smart",
  "penoche": "taste",
  "penology": "smart",
  "penoncel": "build",
  "pension": "sell",
  "penstemon": "heal",
  "penstock": "build",
  "pentad": "smart",
  "pentaerythritol": "build",
  "pentagon": "build",
  "pentail": "heal",
  "pentameter": "story",
  "pentamethylenetetrazol": "build",
  "pentastomid": "heal",
  "pentastomida": "heal",
  "pentateuch": "story",
  "pentatone": "story",
  "pentazocine": "build",
  "pentecostalism": "smart",
  "penthouse": "build",
  "pentimento": "build",
  "pentobarbital": "build",
  "pentode": "build",
  "pentothal": "build",
  "pentoxifylline": "build",
  "pentylenetetrazol": "build",
  "penuche": "taste",
  "penult": "story",
  "penultima": "story",
  "penultimate": "story",
  "penutian": "story",
  "peony": "heal",
  "pepcid": "build",
  "peperomia": "heal",
  "peplos": "build",
  "peplum": "build",
  "peplus": "build",
  "pepper": "taste",
  "pepper-and-salt": "build",
  "peppercorn": "taste",
  "pepperidge": "heal",
  "peppermint": "heal",
  "pepperoni": "taste",
  "pepperwood": "heal",
  "pepperwort": "heal",
  "pepsi": "taste",
  "peptisation": "smart",
  "peptization": "smart",
  "peradventure": "smart",
  "perambulate": "sound",
  "perambulator": "build",
  "peramelidae": "heal",
  "perca": "heal",
  "percale": "build",
  "perceive": "sound",
  "percentage": "sell",
  "percentile": "smart",
  "percept": "smart",
  "perceptible": "beautiful",
  "perception": "smart",
  "perceptive": "beautiful",
  "perceptiveness": "smart",
  "perch": "build",
  "percher": "heal",
  "percheron": "heal",
  "percidae": "heal",
  "perciformes": "heal",
  "percina": "heal",
  "percipient": "beautiful",
  "percoid": "heal",
  "percoidea": "heal",
  "percoidean": "heal",
  "percolate": "build",
  "percolation": "smart",
  "percolator": "build",
  "percomorphi": "heal",
  "percophidae": "heal",
  "percuss": "build",
  "percussor": "build",
  "perdicidae": "heal",
  "perdicinae": "heal",
  "perdition": "smart",
  "perdix": "heal",
  "peregrine": "heal",
  "perennation": "smart",
  "perennial": "heal",
  "pereskia": "heal",
  "perestroika": "story",
  "perfect": "beautiful",
  "perfecter": "beautiful",
  "perfectibility": "smart",
  "perfection": "smart",
  "perforate": "build",
  "perforation": "build",
  "perform": "build",
  "performance": "story",
  "performing": "build",
  "perfume": "smart",
  "perfumery": "build",
  "pergola": "build",
  "periactin": "build",
  "perianth": "heal",
  "pericallis": "heal",
  "pericardium": "heal",
  "pericarp": "heal",
  "peridinian": "heal",
  "peridiniidae": "heal",
  "peridinium": "heal",
  "peridium": "heal",
  "perigone": "heal",
  "perigonium": "heal",
  "perilla": "heal",
  "perilymph": "heal",
  "perimysium": "heal",
  "perinatal": "beautiful",
  "perinatology": "smart",
  "perineum": "heal",
  "perineurium": "heal",
  "periodic": "beautiful",
  "periodical": "story",
  "periodontia": "smart",
  "periodontics": "smart",
  "periophthalmus": "heal",
  "periosteum": "heal",
  "peripatetic": "beautiful",
  "peripateticism": "smart",
  "peripatidae": "heal",
  "peripatopsidae": "heal",
  "peripatopsis": "heal",
  "peripatus": "heal",
  "peripheral": "build",
  "periphrasis": "story",
  "periplaneta": "heal",
  "periploca": "heal",
  "peripteral": "beautiful",
  "periscope": "build",
  "perishable": "taste",
  "perisoreus": "heal",
  "perisperm": "heal",
  "perissodactyl": "heal",
  "perissodactyla": "heal",
  "peristalsis": "smart",
  "peristediinae": "heal",
  "peristedion": "heal",
  "peristome": "heal",
  "peristyle": "build",
  "perithecium": "heal",
  "perithelium": "heal",
  "peritoneum": "heal",
  "peritrate": "build",
  "periwig": "build",
  "periwinkle": "heal",
  "perjure": "story",
  "perk": "sell",
  "perm": "heal",
  "permanent": "heal",
  "permeable": "beautiful",
  "permeate": "build",
  "permeation": "smart",
  "permic": "story",
  "permissible": "beautiful",
  "permission": "story",
  "permissive": "beautiful",
  "permit": "story",
  "pernis": "heal",
  "pernod": "taste",
  "perodicticus": "heal",
  "perognathus": "heal",
  "peromyscus": "heal",
  "peroneus": "heal",
  "peronospora": "heal",
  "peronosporaceae": "heal",
  "peronosporales": "heal",
  "perorate": "story",
  "peroration": "story",
  "perpendicular": "smart",
  "perpetrate": "sell",
  "perphenazine": "build",
  "perplex": "smart",
  "perplexed": "smart",
  "perplexity": "smart",
  "perquisite": "sell",
  "perry": "taste",
  "persea": "heal",
  "persecute": "sell",
  "perseverate": "story",
  "perseveration": "smart",
  "persian": "story",
  "persiflage": "story",
  "persimmon": "heal",
  "persistent": "beautiful",
  "person": "heal",
  "persona": "smart",
  "personal": "story",
  "personalty": "sell",
  "personate": "story",
  "personification": "story",
  "personify": "smart",
  "persoonia": "heal",
  "perspective": "smart",
  "perspicaciousness": "smart",
  "perspicacity": "smart",
  "perspiration": "heal",
  "perspire": "heal",
  "persuade": "sell",
  "persuasion": "story",
  "persuasive": "beautiful",
  "pertainym": "story",
  "perturbation": "sound",
  "pertusaria": "heal",
  "pertusariaceae": "heal",
  "peruke": "build",
  "perusal": "story",
  "peruse": "sound",
  "perusing": "story",
  "pervade": "build",
  "pervasion": "smart",
  "pervert": "sell",
  "pervious": "beautiful",
  "pes": "heal",
  "peseta": "smart",
  "pesewa": "smart",
  "peso": "smart",
  "pessary": "build",
  "pessimistic": "beautiful",
  "pest": "heal",
  "pesthouse": "build",
  "pestilence": "smart",
  "pestle": "build",
  "pesto": "taste",
  "pet": "heal",
  "pet-food": "taste",
  "petabit": "smart",
  "petabyte": "smart",
  "petal": "heal",
  "petaled": "beautiful",
  "petalled": "beautiful",
  "petalless": "beautiful",
  "petalous": "beautiful",
  "petard": "build",
  "petasites": "heal",
  "petaurista": "heal",
  "petauristidae": "heal",
  "petaurus": "heal",
  "petchary": "heal",
  "petcock": "build",
  "peter": "heal",
  "petfood": "taste",
  "petiole": "heal",
  "petiolule": "heal",
  "petite": "beautiful",
  "petitio": "smart",
  "petition": "story",
  "petrel": "heal",
  "petrifaction": "smart",
  "petrification": "smart",
  "petrocoptis": "heal",
  "petrogale": "heal",
  "petrology": "smart",
  "petromyzon": "heal",
  "petromyzoniformes": "heal",
  "petromyzontidae": "heal",
  "petroselinum": "heal",
  "petteria": "heal",
  "petticoat": "build",
  "pettifog": "story",
  "pettifoggery": "story",
  "pettiness": "smart",
  "petting": "build",
  "petty": "beautiful",
  "petunia": "heal",
  "peul": "story",
  "pew": "build",
  "pewee": "heal",
  "pewit": "heal",
  "peyote": "heal",
  "peziza": "heal",
  "pezizaceae": "heal",
  "pezizales": "heal",
  "pezophaps": "heal",
  "pfannkuchen": "taste",
  "pfennig": "smart",
  "ph.d.": "story",
  "phacelia": "heal",
  "phacochoerus": "heal",
  "phaeophyceae": "heal",
  "phaeophyta": "heal",
  "phaethon": "heal",
  "phaethontidae": "heal",
  "phaeton": "build",
  "phage": "heal",
  "phagocyte": "heal",
  "phagocytosis": "smart",
  "phaius": "heal",
  "phalacrocoracidae": "heal",
  "phalacrocorax": "heal",
  "phalaenopsis": "heal",
  "phalaenoptilus": "heal",
  "phalanger": "heal",
  "phalangeridae": "heal",
  "phalangida": "heal",
  "phalangiidae": "heal",
  "phalangium": "heal",
  "phalanx": "heal",
  "phalaris": "heal",
  "phalarope": "heal",
  "phalaropidae": "heal",
  "phalaropus": "heal",
  "phallaceae": "heal",
  "phallales": "heal",
  "phallic": "beautiful",
  "phallus": "heal",
  "phalsa": "heal",
  "phanerogam": "heal",
  "phanerogamae": "heal",
  "phantasm": "smart",
  "phantasma": "smart",
  "phantasmagoria": "smart",
  "phantasy": "smart",
  "phantom": "smart",
  "pharmaceutic": "build",
  "pharmaceutical": "heal",
  "pharmaceutics": "smart",
  "pharmacogenetics": "smart",
  "pharmacokinetics": "smart",
  "pharmacologic": "heal",
  "pharmacological": "heal",
  "pharmacologist": "heal",
  "pharmacology": "heal",
  "pharmacopeia": "story",
  "pharmacopoeia": "build",
  "pharmacy": "heal",
  "pharomacrus": "heal",
  "pharos": "build",
  "pharyngeal": "story",
  "pharynx": "heal",
  "phascogale": "heal",
  "phascolarctos": "heal",
  "phaseolus": "heal",
  "phasianid": "heal",
  "phasianidae": "heal",
  "phasianus": "heal",
  "phasmatidae": "heal",
  "phasmatodea": "heal",
  "phasmid": "heal",
  "phasmida": "heal",
  "phasmidae": "heal",
  "phasmidia": "sound",
  "phd": "story",
  "pheasant": "heal",
  "pheasant's-eye": "heal",
  "phegopteris": "heal",
  "phellodendron": "heal",
  "phenacetin": "build",
  "phenacomys": "heal",
  "phenaphen": "build",
  "phenazopyridine": "build",
  "phencyclidine": "build",
  "phenelzine": "build",
  "phenergan": "build",
  "pheniramine": "build",
  "phenobarbital": "build",
  "phenobarbitone": "build",
  "phenolphthalein": "build",
  "phenomenal": "beautiful",
  "phenomenology": "smart",
  "phensuximide": "build",
  "phentolamine": "build",
  "phenylacetamide": "build",
  "phenylbutazone": "build",
  "phenylephrine": "build",
  "phenylpropanolamine": "build",
  "phenyltoloxamine": "build",
  "phenytoin": "build",
  "pheromone": "heal",
  "phi": "story",
  "phial": "build",
  "philadelphaceae": "heal",
  "philadelphus": "heal",
  "philaenus": "heal",
  "philander": "sell",
  "philanthropic": "beautiful",
  "philemon": "story",
  "philharmonic": "sound",
  "philippians": "story",
  "philippic": "story",
  "philippine": "story",
  "philippines": "story",
  "philistine": "beautiful",
  "phillidae": "heal",
  "phillyrea": "heal",
  "philodendron": "heal",
  "philohela": "heal",
  "philology": "story",
  "philomachus": "heal",
  "philophylla": "heal",
  "philosophic": "beautiful",
  "philosophical": "beautiful",
  "philosophise": "smart",
  "philosophize": "smart",
  "philosophizing": "story",
  "philosophy": "smart",
  "philter": "taste",
  "philtre": "taste",
  "phiz": "heal",
  "phlebodium": "heal",
  "phlebogram": "build",
  "phlebotomise": "heal",
  "phlebotomize": "heal",
  "phlebotomus": "heal",
  "phlegm": "heal",
  "phlegmy": "beautiful",
  "phleum": "heal",
  "phloem": "heal",
  "phlomis": "heal",
  "phlox": "heal",
  "phoca": "heal",
  "phocidae": "heal",
  "phocoena": "heal",
  "phoebe": "smart",
  "phoenician": "story",
  "phoenicophorium": "heal",
  "phoenicopteridae": "heal",
  "phoeniculidae": "heal",
  "phoeniculus": "heal",
  "phoenicurus": "heal",
  "phoenix": "heal",
  "pholadidae": "heal",
  "pholas": "heal",
  "pholidae": "heal",
  "pholidota": "heal",
  "pholiota": "heal",
  "pholis": "heal",
  "pholistoma": "heal",
  "phon": "smart",
  "phonate": "story",
  "phonation": "story",
  "phone": "build",
  "phone-in": "story",
  "phonebook": "story",
  "phoneme": "story",
  "phonemics": "smart",
  "phonetics": "smart",
  "phoney": "beautiful",
  "phonogram": "story",
  "phonograph": "build",
  "phonology": "smart",
  "phony": "beautiful",
  "phoradendron": "heal",
  "phoronid": "heal",
  "phoronida": "heal",
  "phoronidea": "heal",
  "phosphate": "taste",
  "phosphorescence": "sound",
  "phot": "smart",
  "photinia": "heal",
  "photo": "beautiful",
  "photo-offset": "story",
  "photoblepharon": "heal",
  "photocathode": "build",
  "photocell": "build",
  "photochemistry": "smart",
  "photocoagulator": "build",
  "photoconduction": "sound",
  "photoconductivity": "sound",
  "photocopier": "build",
  "photocopy": "build",
  "photoelectricity": "sound",
  "photoemission": "sound",
  "photoengraving": "build",
  "photoflash": "build",
  "photoflood": "build",
  "photograph": "beautiful",
  "photographic": "beautiful",
  "photography": "beautiful",
  "photogravure": "story",
  "photojournalism": "story",
  "photolithograph": "beautiful",
  "photolithography": "beautiful",
  "photomechanics": "smart",
  "photometer": "build",
  "photomicrograph": "build",
  "photomontage": "build",
  "photomosaic": "build",
  "photopigment": "beautiful",
  "photosensitise": "sound",
  "photosensitivity": "smart",
  "photosensitize": "sound",
  "photostat": "build",
  "photosynthesis": "smart",
  "phoxinus": "heal",
  "phragmacone": "heal",
  "phragmipedium": "heal",
  "phragmites": "heal",
  "phragmocone": "heal",
  "phrase": "story",
  "phraseology": "story",
  "phrasing": "story",
  "phrenology": "smart",
  "phrontistery": "build",
  "phrygian": "story",
  "phrynosoma": "heal",
  "phthiriidae": "heal",
  "phthirius": "heal",
  "phthirus": "heal",
  "phthorimaea": "heal",
  "phycobilin": "heal",
  "phycocyanin": "heal",
  "phycoerythrin": "heal",
  "phycology": "smart",
  "phycomycetes": "heal",
  "phylactery": "story",
  "phyllidae": "heal",
  "phyllitis": "heal",
  "phyllium": "heal",
  "phyllo": "taste",
  "phylloclad": "heal",
  "phyllocladaceae": "heal",
  "phylloclade": "heal",
  "phyllocladus": "heal",
  "phyllode": "heal",
  "phyllodoce": "heal",
  "phylloporus": "heal",
  "phyllorhynchus": "heal",
  "phylloscopus": "heal",
  "phyllostachys": "heal",
  "phyllostomatidae": "heal",
  "phyllostomidae": "heal",
  "phyllostomus": "heal",
  "phylloxera": "heal",
  "phylloxeridae": "heal",
  "phylogenesis": "smart",
  "phylogeny": "smart",
  "physa": "heal",
  "physalia": "heal",
  "physalis": "heal",
  "physaria": "heal",
  "physeter": "heal",
  "physeteridae": "heal",
  "physic": "build",
  "physical": "beautiful",
  "physicalism": "smart",
  "physics": "smart",
  "physidae": "heal",
  "physiognomy": "heal",
  "physiography": "smart",
  "physiological": "heal",
  "physiologist": "heal",
  "physiology": "heal",
  "physique": "heal",
  "physostegia": "heal",
  "physostigma": "heal",
  "physostigmine": "heal",
  "phytelephas": "heal",
  "phytochemistry": "smart",
  "phytolacca": "heal",
  "phytolaccaceae": "heal",
  "phytology": "smart",
  "phytomastigina": "heal",
  "phytophthora": "heal",
  "phytoplankton": "heal",
  "pia": "heal",
  "piaffe": "sound",
  "pianism": "story",
  "pianissimo": "beautiful",
  "piano": "sound",
  "pianoforte": "build",
  "pianola": "build",
  "piaster": "smart",
  "piastre": "smart",
  "pib": "smart",
  "pibgorn": "build",
  "pibit": "smart",
  "pibroch": "story",
  "pic": "story",
  "pica": "smart",
  "pica-pica": "heal",
  "picariae": "heal",
  "piccalilli": "taste",
  "piccolo": "build",
  "picea": "heal",
  "pichi": "heal",
  "pichiciago": "heal",
  "pichiciego": "heal",
  "picidae": "heal",
  "piciformes": "heal",
  "pick": "smart",
  "pick-me-up": "build",
  "pickax": "build",
  "pickaxe": "build",
  "pickelhaube": "build",
  "pickerel": "taste",
  "pickerelweed": "heal",
  "pickeringia": "heal",
  "picket": "build",
  "picking": "smart",
  "pickings": "smart",
  "pickle": "taste",
  "pickup": "build",
  "picnic": "taste",
  "picofarad": "smart",
  "picoides": "heal",
  "picometer": "smart",
  "picometre": "smart",
  "picornavirus": "heal",
  "picot": "build",
  "picovolt": "smart",
  "picrasma": "heal",
  "picris": "heal",
  "pictograph": "story",
  "pictorial": "story",
  "picture": "build",
  "picturing": "smart",
  "picul": "smart",
  "piculet": "heal",
  "picumnus": "heal",
  "picus": "heal",
  "piddle": "heal",
  "piddock": "heal",
  "pidgin": "story",
  "pidlimdi": "story",
  "pie": "taste",
  "pie-dog": "heal",
  "piece": "build",
  "pied-a-terre": "build",
  "pieplant": "taste",
  "pier": "build",
  "pierce": "build",
  "pierid": "heal",
  "pieridae": "heal",
  "pieris": "heal",
  "pieta": "build",
  "pietistic": "beautiful",
  "pietistical": "beautiful",
  "piezoelectricity": "sound",
  "piezometer": "build",
  "piffle": "story",
  "pig": "heal",
  "pigboat": "build",
  "pigeon": "heal",
  "pigeon-toed": "beautiful",
  "pigeonhole": "smart",
  "pigeonholing": "smart",
  "pigfish": "heal",
  "piggery": "build",
  "piggy": "heal",
  "piggyback": "build",
  "piglet": "heal",
  "pigment": "beautiful",
  "pigmentation": "beautiful",
  "pignolia": "taste",
  "pignut": "heal",
  "pigpen": "build",
  "pigsty": "build",
  "pigswill": "taste",
  "pigtail": "heal",
  "pigwash": "taste",
  "pigweed": "heal",
  "pika": "heal",
  "pike": "build",
  "pike-perch": "heal",
  "pikeblenny": "heal",
  "pikestaff": "build",
  "pilaf": "taste",
  "pilaff": "taste",
  "pilaster": "build",
  "pilau": "taste",
  "pilaw": "taste",
  "pilchard": "taste",
  "pile": "smart",
  "pilea": "heal",
  "piles": "smart",
  "pileus": "heal",
  "pilewort": "heal",
  "pilfer": "sell",
  "piling": "build",
  "pill": "build",
  "pillage": "sell",
  "pillaging": "sell",
  "pillar": "smart",
  "pillbox": "build",
  "pillion": "build",
  "pillory": "build",
  "pillow": "build",
  "pillowcase": "build",
  "pillwort": "heal",
  "pilocarpine": "build",
  "pilosella": "heal",
  "pilot": "story",
  "pilotfish": "heal",
  "pilothouse": "build",
  "pilsener": "taste",
  "pilsner": "taste",
  "pilularia": "heal",
  "pilus": "heal",
  "pima": "story",
  "pimenta": "heal",
  "pimento": "heal",
  "pimiento": "heal",
  "pimlico": "build",
  "pimozide": "build",
  "pimp": "taste",
  "pimpernel": "heal",
  "pimpinella": "heal",
  "pin": "build",
  "pinaceae": "heal",
  "pinafore": "build",
  "pinata": "build",
  "pince-nez": "build",
  "pincer": "build",
  "pinch": "smart",
  "pinchbeck": "beautiful",
  "pinche": "heal",
  "pinckneya": "heal",
  "pinctada": "heal",
  "pincus": "heal",
  "pincushion": "build",
  "pindaric": "story",
  "pindolol": "build",
  "pine": "heal",
  "pine-weed": "heal",
  "pineal": "beautiful",
  "pineapple": "heal",
  "pinecone": "heal",
  "pinesap": "heal",
  "pineus": "heal",
  "pineweed": "heal",
  "pinfish": "heal",
  "pinfold": "build",
  "ping": "build",
  "pinger": "build",
  "pinguecula": "heal",
  "pinguicula": "heal",
  "pinguinus": "heal",
  "pinhead": "build",
  "pinhole": "build",
  "pinicola": "heal",
  "pining": "build",
  "pinion": "build",
  "pink": "heal",
  "pinkie": "heal",
  "pinky": "heal",
  "pinna": "heal",
  "pinnace": "build",
  "pinnacle": "build",
  "pinnatiped": "heal",
  "pinner": "build",
  "pinning": "story",
  "pinniped": "heal",
  "pinnipedia": "heal",
  "pinnotheres": "heal",
  "pinnotheridae": "heal",
  "pinnule": "heal",
  "pinny": "build",
  "pinocytosis": "smart",
  "pinole": "taste",
  "pinon": "heal",
  "pinophytina": "heal",
  "pinopsida": "heal",
  "pinot": "heal",
  "pinpoint": "build",
  "pinprick": "build",
  "pinscher": "heal",
  "pinstripe": "build",
  "pint": "smart",
  "pintado": "heal",
  "pintail": "heal",
  "pintle": "build",
  "pinto": "heal",
  "pinus": "heal",
  "pinwheel": "heal",
  "pinworm": "heal",
  "pinyon": "heal",
  "piolet": "build",
  "pioneer": "build",
  "pious": "beautiful",
  "pip": "heal",
  "pipa": "heal",
  "pipage": "sell",
  "pipal": "heal",
  "pipe": "build",
  "pipe-clay": "build",
  "pipefish": "heal",
  "pipefitting": "build",
  "pipeful": "smart",
  "pipeline": "smart",
  "piper": "heal",
  "piperaceae": "heal",
  "piperacillin": "build",
  "piperales": "heal",
  "piperazine": "build",
  "piperocaine": "build",
  "pipet": "build",
  "pipette": "build",
  "pipework": "build",
  "pipewort": "heal",
  "pipidae": "heal",
  "pipile": "heal",
  "pipilo": "heal",
  "piping": "build",
  "pipistrel": "heal",
  "pipistrelle": "heal",
  "pipistrellus": "heal",
  "pipit": "heal",
  "pippin": "taste",
  "pipra": "heal",
  "pipracil": "build",
  "pipridae": "heal",
  "pipsissewa": "heal",
  "piptadenia": "heal",
  "pipturus": "heal",
  "pipul": "heal",
  "pique": "build",
  "piqueria": "heal",
  "pirana": "heal",
  "piranga": "heal",
  "piranha": "heal",
  "pirate": "build",
  "pirogi": "taste",
  "pirogue": "build",
  "piroplasm": "heal",
  "piroshki": "taste",
  "piroxicam": "build",
  "pirozhki": "taste",
  "pisanosaur": "heal",
  "pisanosaurus": "heal",
  "piscary": "build",
  "pisces": "heal",
  "piscidia": "heal",
  "pisiform": "heal",
  "pismire": "heal",
  "pisonia": "heal",
  "piss": "smart",
  "pisser": "smart",
  "pissing": "smart",
  "pistachio": "heal",
  "pistacia": "heal",
  "piste": "build",
  "pistia": "heal",
  "pistil": "heal",
  "pistillate": "beautiful",
  "pistillode": "heal",
  "pistol": "build",
  "pistol-whip": "build",
  "piston": "build",
  "pisum": "heal",
  "pit": "heal",
  "pita": "taste",
  "pitahaya": "heal",
  "pitanga": "heal",
  "pitch": "story",
  "pitched": "build",
  "pitcher": "build",
  "pitcherful": "smart",
  "pitchfork": "build",
  "pitching": "build",
  "pitfall": "smart",
  "pith": "heal",
  "pithead": "build",
  "pithecanthropus": "heal",
  "pithecellobium": "heal",
  "pithecia": "heal",
  "pithecolobium": "heal",
  "pithiness": "story",
  "pitocin": "heal",
  "piton": "build",
  "pitot": "build",
  "pitprop": "build",
  "pitressin": "heal",
  "pitsaw": "build",
  "pitta": "heal",
  "pittance": "sell",
  "pitter-patter": "sound",
  "pittidae": "heal",
  "pitting": "smart",
  "pituitary": "heal",
  "pituophis": "heal",
  "pitymys": "heal",
  "pityrogramma": "heal",
  "pivot": "build",
  "pix": "build",
  "pixel": "build",
  "pixie": "heal",
  "pixy": "heal",
  "pizza": "taste",
  "pizzeria": "taste",
  "pizzicato": "story",
  "pj's": "build",
  "placable": "beautiful",
  "placard": "story",
  "place": "smart",
  "place-kick": "build",
  "place-kicking": "build",
  "placebo": "build",
  "placeholder": "story",
  "placenta": "heal",
  "placental": "heal",
  "placentation": "smart",
  "placidyl": "build",
  "placket": "build",
  "placoderm": "heal",
  "placodermi": "heal",
  "placuna": "heal",
  "plagianthus": "heal",
  "plagiarise": "sell",
  "plagiarism": "story",
  "plagiarize": "sell",
  "plaice": "taste",
  "plaid": "build",
  "plain": "build",
  "plainchant": "story",
  "plainsong": "story",
  "plaint": "story",
  "plait": "heal",
  "plan": "smart",
  "planar": "beautiful",
  "planaria": "heal",
  "planarian": "heal",
  "planation": "smart",
  "planchet": "build",
  "planchette": "build",
  "plane": "build",
  "planer": "build",
  "planera": "heal",
  "planetarium": "build",
  "planetary": "beautiful",
  "planimeter": "build",
  "plank": "story",
  "plank-bed": "build",
  "planking": "build",
  "plankton": "heal",
  "planned": "smart",
  "planner": "build",
  "planning": "smart",
  "planococcus": "heal",
  "planography": "story",
  "plant": "build",
  "plantae": "heal",
  "plantaginaceae": "heal",
  "plantaginales": "heal",
  "plantago": "heal",
  "plantain": "heal",
  "plantation": "sell",
  "planted": "build",
  "planter": "build",
  "planthopper": "heal",
  "plantigrade": "heal",
  "planting": "build",
  "plantlet": "heal",
  "planula": "heal",
  "plaque": "heal",
  "plaquenil": "build",
  "plash": "build",
  "plasm": "heal",
  "plasma": "heal",
  "plasmablast": "heal",
  "plasmacyte": "heal",
  "plasmodiidae": "heal",
  "plasmodiophora": "heal",
  "plasmodiophoraceae": "heal",
  "plasmodium": "heal",
  "plaster": "build",
  "plasterboard": "build",
  "plastering": "build",
  "plasterwork": "build",
  "plastic": "sell",
  "plastid": "heal",
  "plastinate": "sell",
  "plastination": "smart",
  "plastique": "build",
  "plastron": "build",
  "plat": "build",
  "platalea": "heal",
  "plataleidae": "heal",
  "platan": "heal",
  "platanaceae": "heal",
  "platanistidae": "heal",
  "platanthera": "heal",
  "platanus": "heal",
  "plate": "taste",
  "plateful": "smart",
  "platen": "build",
  "platform": "build",
  "platichthys": "heal",
  "plating": "taste",
  "platinize": "build",
  "platitude": "story",
  "platitudinize": "story",
  "platonic": "beautiful",
  "platonism": "smart",
  "plattdeutsch": "story",
  "platter": "build",
  "platy": "heal",
  "platycephalidae": "heal",
  "platycerium": "heal",
  "platyctenea": "heal",
  "platyctenean": "heal",
  "platyhelminth": "heal",
  "platyhelminthes": "heal",
  "platylobium": "heal",
  "platymiscium": "heal",
  "platypoecilus": "heal",
  "platypus": "heal",
  "platyrhine": "beautiful",
  "platyrhinian": "beautiful",
  "platyrrhine": "heal",
  "platyrrhini": "heal",
  "platyrrhinian": "heal",
  "platyrrhinic": "beautiful",
  "platysma": "heal",
  "platystemon": "heal",
  "plaudit": "story",
  "plaudits": "story",
  "plausible": "beautiful",
  "plautus": "heal",
  "plavix": "build",
  "play": "story",
  "play-box": "build",
  "playable": "beautiful",
  "playact": "build",
  "playacting": "build",
  "playback": "build",
  "playbill": "story",
  "playbook": "story",
  "playbox": "build",
  "played": "sell",
  "playful": "beautiful",
  "playground": "build",
  "playhouse": "build",
  "playlet": "story",
  "playlist": "story",
  "playpen": "build",
  "playroom": "build",
  "playscript": "story",
  "playsuit": "build",
  "plaything": "build",
  "plaza": "build",
  "plea": "story",
  "plea-bargain": "story",
  "pleach": "build",
  "plead": "story",
  "pleading": "story",
  "pleasant": "beautiful",
  "pleased": "beautiful",
  "pleasure": "smart",
  "pleat": "build",
  "pleating": "build",
  "plebeian": "beautiful",
  "plecoptera": "heal",
  "plecopteran": "heal",
  "plecotus": "heal",
  "plectania": "heal",
  "plectognath": "heal",
  "plectognathi": "heal",
  "plectomycetes": "heal",
  "plectophera": "heal",
  "plectorrhiza": "heal",
  "plectranthus": "heal",
  "plectron": "build",
  "plectrophenax": "heal",
  "plectrum": "build",
  "pledge": "sell",
  "pleione": "heal",
  "pleiospilos": "heal",
  "plenty": "smart",
  "plenum": "build",
  "pleochroism": "sound",
  "pleomorphism": "sound",
  "pleonasm": "story",
  "pleopod": "heal",
  "plesianthropus": "heal",
  "plesiosaur": "heal",
  "plesiosauria": "heal",
  "plesiosaurus": "heal",
  "plessimeter": "build",
  "plessor": "build",
  "plethodon": "heal",
  "plethodont": "heal",
  "plethodontidae": "heal",
  "plethysmograph": "build",
  "pleura": "heal",
  "pleurobrachia": "heal",
  "pleurobrachiidae": "heal",
  "pleurocarp": "heal",
  "pleurocarpous": "beautiful",
  "pleurodont": "heal",
  "pleuronectes": "heal",
  "pleuronectidae": "heal",
  "pleurosorus": "heal",
  "pleurothallis": "heal",
  "pleurotus": "heal",
  "pleximeter": "build",
  "pleximetry": "heal",
  "plexor": "build",
  "plexus": "heal",
  "plica": "heal",
  "plicate": "build",
  "plicatoperipatus": "heal",
  "pliers": "build",
  "plight": "story",
  "plimsoll": "build",
  "plinth": "build",
  "ploce": "story",
  "ploceidae": "heal",
  "ploceus": "heal",
  "plodding": "beautiful",
  "plonk": "taste",
  "plop": "build",
  "plosion": "story",
  "plosive": "story",
  "plot": "story",
  "plotter": "build",
  "plough": "build",
  "ploughed": "build",
  "ploughing": "build",
  "ploughshare": "build",
  "plover": "heal",
  "plow": "build",
  "plowed": "build",
  "plowing": "build",
  "plowshare": "build",
  "ploy": "story",
  "pluck": "build",
  "plucked": "build",
  "plucky": "beautiful",
  "plug": "build",
  "plug-in": "build",
  "plugboard": "build",
  "plugged": "build",
  "plughole": "build",
  "plum": "heal",
  "plum-yew": "heal",
  "plumage": "heal",
  "plumb": "build",
  "plumbable": "beautiful",
  "plumbaginaceae": "heal",
  "plumbaginales": "heal",
  "plumbago": "heal",
  "plumbing": "build",
  "plumcot": "heal",
  "plume": "build",
  "plumeria": "heal",
  "plumiera": "heal",
  "plummet": "build",
  "plump": "build",
  "plumule": "heal",
  "plunder": "sell",
  "plundering": "sell",
  "plunge": "build",
  "plunger": "build",
  "plunk": "sound",
  "pluperfect": "beautiful",
  "plural": "story",
  "pluralise": "story",
  "pluralism": "smart",
  "plurality": "smart",
  "pluralize": "story",
  "plus": "beautiful",
  "plush": "build",
  "pluteaceae": "heal",
  "pluteus": "heal",
  "plutonium": "sound",
  "pluvialis": "heal",
  "pluvianus": "heal",
  "pluviometer": "build",
  "ply": "build",
  "plyboard": "build",
  "plyers": "build",
  "plywood": "build",
  "pneumatics": "smart",
  "pneumatophore": "heal",
  "pneumococcus": "heal",
  "pneumoencephalogram": "build",
  "pneumogastric": "heal",
  "pneumovax": "build",
  "poa": "heal",
  "poaceae": "heal",
  "poacher": "build",
  "pob": "build",
  "pochard": "heal",
  "pock": "build",
  "pocket": "build",
  "pocket-handkerchief": "build",
  "pocketbook": "sell",
  "pocketcomb": "build",
  "pocketful": "smart",
  "pocketknife": "build",
  "pockmark": "build",
  "pod": "heal",
  "podalyria": "heal",
  "podargidae": "heal",
  "podargus": "heal",
  "podaxaceae": "heal",
  "podcast": "sound",
  "podetium": "heal",
  "podiatry": "smart",
  "podiceps": "heal",
  "podicipedidae": "heal",
  "podicipediformes": "heal",
  "podicipitiformes": "heal",
  "podilymbus": "heal",
  "podium": "build",
  "podocarp": "heal",
  "podocarpaceae": "heal",
  "podocarpus": "heal",
  "podophyllum": "heal",
  "poeciliid": "heal",
  "poeciliidae": "heal",
  "poecilocapsus": "heal",
  "poecilogale": "heal",
  "poem": "story",
  "poenology": "taste",
  "poephila": "heal",
  "poesy": "story",
  "poetic": "beautiful",
  "poetical": "beautiful",
  "poetics": "smart",
  "poetise": "build",
  "poetize": "build",
  "poetry": "story",
  "pogge": "heal",
  "pogonia": "heal",
  "pogonion": "heal",
  "pogonip": "sound",
  "pogonophora": "heal",
  "pogonophoran": "heal",
  "pogostemon": "heal",
  "poi": "taste",
  "poikilotherm": "heal",
  "poilu": "taste",
  "poinciana": "heal",
  "poinsettia": "heal",
  "point": "smart",
  "pointed": "story",
  "pointel": "build",
  "pointer": "smart",
  "pointillism": "build",
  "pointillist": "beautiful",
  "pointless": "beautiful",
  "pointrel": "build",
  "poise": "smart",
  "poison": "sell",
  "poison-berry": "heal",
  "poisonberry": "heal",
  "poisoning": "sell",
  "poivrade": "taste",
  "poke": "heal",
  "poker": "build",
  "pokeweed": "heal",
  "pokey": "build",
  "poking": "build",
  "pokomo": "story",
  "poky": "build",
  "polanisia": "heal",
  "polar": "beautiful",
  "polarimeter": "build",
  "polarisation": "sound",
  "polariscope": "build",
  "polarization": "sound",
  "polaroid": "build",
  "pole": "build",
  "poleax": "build",
  "poleaxe": "build",
  "polecat": "heal",
  "polemic": "story",
  "polemicise": "story",
  "polemicize": "story",
  "polemics": "smart",
  "polemise": "story",
  "polemize": "story",
  "polemoniaceae": "heal",
  "polemoniales": "heal",
  "polemonium": "heal",
  "polenta": "taste",
  "poler": "heal",
  "polianthes": "heal",
  "police": "sell",
  "policy": "smart",
  "polioptila": "heal",
  "poliovirus": "heal",
  "polish": "story",
  "polished": "build",
  "polisher": "build",
  "polishing": "build",
  "polistes": "heal",
  "polite": "beautiful",
  "politic": "beautiful",
  "political": "beautiful",
  "politick": "sell",
  "politics": "smart",
  "polka": "story",
  "poll": "smart",
  "pollachius": "heal",
  "pollack": "taste",
  "pollard": "heal",
  "pollen": "heal",
  "pollenate": "heal",
  "pollex": "heal",
  "pollinate": "heal",
  "pollinator": "heal",
  "pollinium": "heal",
  "polliwog": "heal",
  "pollock": "taste",
  "polls": "smart",
  "pollyfish": "heal",
  "pollywog": "heal",
  "polo-neck": "build",
  "polonaise": "build",
  "polony": "taste",
  "poltroon": "beautiful",
  "polyangiaceae": "heal",
  "polyangium": "heal",
  "polyanthus": "heal",
  "polyborus": "heal",
  "polybotria": "heal",
  "polybotrya": "heal",
  "polychaeta": "heal",
  "polychaete": "heal",
  "polychete": "heal",
  "polychromatic": "beautiful",
  "polychrome": "build",
  "polycillin": "build",
  "polycirrus": "heal",
  "polydactylus": "heal",
  "polyergus": "heal",
  "polyester": "build",
  "polygala": "heal",
  "polygalaceae": "heal",
  "polygamous": "beautiful",
  "polygene": "heal",
  "polyglot": "beautiful",
  "polygonaceae": "heal",
  "polygonales": "heal",
  "polygonatum": "heal",
  "polygonia": "heal",
  "polygonum": "heal",
  "polygraph": "build",
  "polyhidrosis": "smart",
  "polymastigina": "heal",
  "polymastigote": "heal",
  "polymerisation": "smart",
  "polymerization": "smart",
  "polymorph": "heal",
  "polymorphic": "beautiful",
  "polymorphism": "sound",
  "polymorphous": "beautiful",
  "polymox": "build",
  "polymyxin": "build",
  "polynemidae": "heal",
  "polynesian": "story",
  "polynomial": "smart",
  "polyodon": "heal",
  "polyodontidae": "heal",
  "polyoma": "heal",
  "polyp": "heal",
  "polypedates": "heal",
  "polypedatidae": "heal",
  "polyphone": "story",
  "polyphonic": "beautiful",
  "polyphony": "story",
  "polyplacophora": "heal",
  "polyplacophore": "heal",
  "polyploid": "heal",
  "polypodiaceae": "heal",
  "polypodiales": "heal",
  "polypodium": "heal",
  "polypody": "heal",
  "polyporaceae": "heal",
  "polypore": "heal",
  "polyporus": "heal",
  "polyprion": "heal",
  "polypropenonitrile": "build",
  "polyptoton": "story",
  "polysemant": "story",
  "polystichum": "heal",
  "polysyllable": "story",
  "polysyndeton": "story",
  "polytheism": "smart",
  "polytheistic": "beautiful",
  "polytonalism": "story",
  "polytonality": "sound",
  "polyvalent": "beautiful",
  "polyzoa": "heal",
  "polyzoan": "heal",
  "pom-pom": "build",
  "pomacanthus": "heal",
  "pomacentridae": "heal",
  "pomacentrus": "heal",
  "pomade": "build",
  "pomaderris": "heal",
  "pomatomidae": "heal",
  "pomatomus": "heal",
  "pomatum": "build",
  "pome": "heal",
  "pomegranate": "heal",
  "pomelo": "heal",
  "pomeranian": "heal",
  "pomfret": "heal",
  "pommel": "build",
  "pomo": "story",
  "pomolobus": "heal",
  "pomology": "smart",
  "pomoxis": "heal",
  "pomp": "story",
  "pompadour": "heal",
  "pompano": "taste",
  "pompon": "build",
  "pompous": "beautiful",
  "ponca": "story",
  "poncho": "build",
  "poncirus": "heal",
  "pond-skater": "heal",
  "ponder": "smart",
  "ponderable": "beautiful",
  "ponderosa": "heal",
  "pondweed": "heal",
  "pone": "taste",
  "pong": "smart",
  "pongamia": "heal",
  "pongee": "build",
  "pongid": "heal",
  "pongidae": "heal",
  "pongo": "heal",
  "poniard": "build",
  "ponka": "story",
  "pons": "heal",
  "ponstel": "build",
  "pontederia": "heal",
  "pontederiaceae": "heal",
  "pontifical": "build",
  "pontificate": "sell",
  "pontoon": "build",
  "pony": "heal",
  "ponycart": "build",
  "ponytail": "heal",
  "pooch": "heal",
  "pood": "smart",
  "poodle": "heal",
  "pooecetes": "heal",
  "pooh-pooh": "story",
  "pool": "build",
  "poolroom": "build",
  "poon": "heal",
  "poop": "story",
  "poor": "beautiful",
  "poorhouse": "build",
  "poorwill": "heal",
  "pop": "taste",
  "pop-up": "story",
  "popcorn": "heal",
  "popgun": "build",
  "popillia": "heal",
  "popinjay": "heal",
  "poplar": "heal",
  "poplin": "build",
  "popover": "taste",
  "popper": "build",
  "poppet": "build",
  "popping": "beautiful",
  "poppy": "heal",
  "poppycock": "story",
  "popsicle": "taste",
  "popular": "beautiful",
  "popularisation": "story",
  "popularise": "story",
  "popularism": "story",
  "popularization": "story",
  "popularize": "story",
  "population": "smart",
  "populism": "smart",
  "populus": "heal",
  "porbeagle": "heal",
  "porc": "taste",
  "porcelain": "beautiful",
  "porcelainize": "build",
  "porcellio": "heal",
  "porcellionidae": "heal",
  "porch": "build",
  "porcine": "beautiful",
  "porcupine": "heal",
  "porcupinefish": "heal",
  "porcupines": "taste",
  "pore": "heal",
  "porgy": "taste",
  "porifera": "heal",
  "poriferan": "heal",
  "poriferous": "beautiful",
  "pork": "taste",
  "pork-fish": "heal",
  "porkchop": "taste",
  "porker": "heal",
  "porkfish": "heal",
  "porkholt": "taste",
  "porkpie": "build",
  "poronotus": "heal",
  "poroporo": "heal",
  "porous": "beautiful",
  "porphyra": "heal",
  "porphyrin": "beautiful",
  "porphyrio": "heal",
  "porphyrula": "heal",
  "porpoise": "heal",
  "porridge": "taste",
  "porringer": "build",
  "port": "taste",
  "porta": "heal",
  "portable": "build",
  "portage": "sell",
  "portal": "build",
  "portcullis": "build",
  "porte-cochere": "build",
  "portend": "story",
  "porterage": "sell",
  "porterhouse": "taste",
  "portfolio": "sell",
  "porthole": "build",
  "portico": "build",
  "portiere": "build",
  "portion": "build",
  "portmanteau": "story",
  "portrait": "beautiful",
  "portraiture": "beautiful",
  "portray": "story",
  "portrayal": "story",
  "portraying": "smart",
  "portuguese": "story",
  "portulaca": "heal",
  "portulacaceae": "heal",
  "portunidae": "heal",
  "portunus": "heal",
  "porzana": "heal",
  "posed": "sound",
  "poser": "story",
  "posing": "sound",
  "posit": "story",
  "position": "smart",
  "positioner": "build",
  "positioning": "build",
  "positive": "story",
  "positivism": "smart",
  "posology": "smart",
  "posse": "sound",
  "possess": "sell",
  "possessive": "story",
  "posset": "taste",
  "possibility": "smart",
  "possible": "smart",
  "possum": "heal",
  "possumwood": "heal",
  "post": "build",
  "post-horse": "heal",
  "post-it": "story",
  "post-mortem": "story",
  "postage": "sell",
  "postbag": "build",
  "postbox": "build",
  "postcard": "story",
  "postcava": "heal",
  "postcode": "story",
  "postdoc": "sell",
  "postdoctoral": "sell",
  "posted": "build",
  "poster": "story",
  "posterior": "heal",
  "postern": "build",
  "postfix": "story",
  "postgraduate": "beautiful",
  "posthole": "build",
  "posthouse": "build",
  "postiche": "build",
  "posting": "story",
  "postlude": "story",
  "postmark": "story",
  "postmeridian": "beautiful",
  "postmodernism": "build",
  "postmortal": "beautiful",
  "postmortem": "story",
  "postnatal": "beautiful",
  "postpartum": "beautiful",
  "postpose": "build",
  "postposition": "story",
  "postprandial": "beautiful",
  "postscript": "story",
  "postulate": "story",
  "postulation": "story",
  "postum": "taste",
  "posture": "smart",
  "posturing": "sell",
  "postwar": "beautiful",
  "posy": "build",
  "pot": "taste",
  "pot-au-feu": "taste",
  "potable": "taste",
  "potage": "taste",
  "potamogale": "heal",
  "potamogalidae": "heal",
  "potamogeton": "heal",
  "potamogetonaceae": "heal",
  "potamophis": "heal",
  "potation": "taste",
  "potato": "taste",
  "potawatomi": "story",
  "potbelly": "heal",
  "potboiler": "story",
  "poteen": "taste",
  "potency": "heal",
  "potent": "beautiful",
  "potential": "sound",
  "potentiality": "smart",
  "potentiate": "heal",
  "potentiation": "smart",
  "potentilla": "heal",
  "potentiometer": "build",
  "poterium": "heal",
  "potful": "smart",
  "potherb": "taste",
  "potholder": "build",
  "pothook": "build",
  "pothos": "heal",
  "pothouse": "build",
  "potion": "taste",
  "potluck": "taste",
  "potoroinae": "heal",
  "potoroo": "heal",
  "potorous": "heal",
  "potos": "heal",
  "potpie": "taste",
  "potpourri": "story",
  "potsherd": "build",
  "potshot": "story",
  "pottage": "taste",
  "potted": "build",
  "potter": "build",
  "pottery": "beautiful",
  "pottle": "build",
  "potto": "heal",
  "potty": "build",
  "pouch": "build",
  "pouched": "build",
  "poudrin": "sound",
  "pouf": "build",
  "pouffe": "build",
  "poulet": "taste",
  "poulette": "taste",
  "poultice": "build",
  "poultry": "heal",
  "pound": "smart",
  "poundage": "sell",
  "poundal": "smart",
  "pounder": "smart",
  "pounding": "build",
  "pourboire": "sell",
  "pousse-cafe": "taste",
  "pout": "story",
  "pouter": "heal",
  "pouteria": "heal",
  "powder": "build",
  "powderpuff": "build",
  "power": "sound",
  "powerboat": "build",
  "powered": "taste",
  "powerful": "beautiful",
  "powerhouse": "build",
  "powerless": "beautiful",
  "powerwash": "build",
  "powhatan": "story",
  "powwow": "story",
  "poxvirus": "heal",
  "poyou": "heal",
  "pplo": "heal",
  "practical": "beautiful",
  "practise": "build",
  "praenomen": "story",
  "praetorian": "beautiful",
  "praetorium": "build",
  "pragmatic": "story",
  "pragmatical": "beautiful",
  "pragmatics": "smart",
  "pragmatism": "smart",
  "praise": "story",
  "prakrit": "story",
  "praline": "taste",
  "pram": "build",
  "prancer": "heal",
  "prang": "build",
  "prank": "build",
  "prat": "heal",
  "prate": "story",
  "pratincole": "heal",
  "prattle": "story",
  "praunus": "heal",
  "pravachol": "build",
  "pravastatin": "build",
  "prawn": "taste",
  "pray": "story",
  "praya": "heal",
  "prayer": "story",
  "prayerbook": "story",
  "prazosin": "build",
  "pre-empt": "story",
  "pre-emption": "smart",
  "preach": "story",
  "preachification": "story",
  "preachify": "story",
  "preaching": "story",
  "preachment": "story",
  "preamble": "story",
  "prearrange": "build",
  "prearrangement": "smart",
  "preassemble": "build",
  "prebend": "sell",
  "precaution": "smart",
  "precava": "heal",
  "precede": "sell",
  "precedent": "smart",
  "precedented": "beautiful",
  "preceding": "sell",
  "precept": "story",
  "prechlorination": "smart",
  "precipitant": "beautiful",
  "precipitate": "build",
  "precipitation": "smart",
  "precipitator": "build",
  "precis": "story",
  "precise": "beautiful",
  "preclinical": "heal",
  "preclude": "sell",
  "precocial": "beautiful",
  "precocious": "beautiful",
  "precociousness": "smart",
  "precocity": "smart",
  "precognition": "story",
  "preconceive": "build",
  "preconceived": "build",
  "preconception": "smart",
  "precondition": "story",
  "precook": "build",
  "precordium": "heal",
  "precursor": "story",
  "predate": "taste",
  "predator": "heal",
  "predecessor": "story",
  "predestinarianism": "smart",
  "predestinate": "smart",
  "predestination": "smart",
  "predestine": "story",
  "predetermination": "smart",
  "predetermine": "smart",
  "predicate": "story",
  "predication": "story",
  "predicative": "beautiful",
  "predicator": "story",
  "predict": "story",
  "predictable": "beautiful",
  "prediction": "smart",
  "predictor": "smart",
  "predigest": "taste",
  "predilection": "smart",
  "predispose": "smart",
  "predisposition": "smart",
  "predominate": "beautiful",
  "preempt": "story",
  "preemption": "smart",
  "preen": "build",
  "prefab": "build",
  "prefabricate": "build",
  "prefabrication": "build",
  "preface": "story",
  "prefer": "smart",
  "preference": "smart",
  "preferment": "taste",
  "prefiguration": "smart",
  "prefigure": "build",
  "prefix": "story",
  "preform": "build",
  "preformation": "smart",
  "pregnant": "beautiful",
  "prehend": "build",
  "prehensile": "beautiful",
  "prehensor": "heal",
  "prehistoric": "beautiful",
  "prejudge": "smart",
  "prejudgement": "smart",
  "prejudgment": "smart",
  "prejudice": "smart",
  "prejudiced": "sell",
  "prejudicial": "beautiful",
  "prejudicious": "beautiful",
  "prelim": "story",
  "preliminary": "beautiful",
  "prelims": "story",
  "prelude": "story",
  "premature": "beautiful",
  "premedical": "beautiful",
  "premeditate": "smart",
  "premeditated": "smart",
  "premeditation": "smart",
  "premier": "build",
  "premiere": "story",
  "premise": "story",
  "premises": "story",
  "premiss": "story",
  "premium": "sell",
  "premix": "taste",
  "premolar": "heal",
  "premonition": "story",
  "prenanthes": "heal",
  "prenatal": "beautiful",
  "prenominal": "beautiful",
  "preoccupancy": "smart",
  "preoccupation": "smart",
  "preoccupy": "sell",
  "preordain": "smart",
  "preordination": "smart",
  "preparation": "smart",
  "prepare": "build",
  "prepared": "build",
  "prepay": "sell",
  "prepose": "build",
  "preposition": "story",
  "prepossess": "sell",
  "prepossession": "smart",
  "preprandial": "beautiful",
  "prepuce": "heal",
  "prerecord": "story",
  "prerequisite": "smart",
  "presage": "story",
  "presbyopic": "beautiful",
  "presbyterianism": "smart",
  "presbytery": "build",
  "presbytes": "heal",
  "prescience": "smart",
  "prescribe": "story",
  "prescript": "story",
  "prescription": "heal",
  "prescriptive": "beautiful",
  "prescriptivism": "smart",
  "presence": "smart",
  "present": "sell",
  "presentation": "story",
  "presentism": "smart",
  "presentment": "story",
  "preservation": "smart",
  "preservative": "beautiful",
  "preserve": "taste",
  "preserved": "sell",
  "preserver": "build",
  "preserves": "taste",
  "preside": "sell",
  "presidential": "beautiful",
  "presidio": "build",
  "press": "story",
  "pressing": "build",
  "pressmark": "story",
  "pressor": "build",
  "pressure": "heal",
  "pressure-wash": "build",
  "presume": "smart",
  "presumption": "smart",
  "presuppose": "smart",
  "presupposition": "smart",
  "presymptomatic": "heal",
  "preteen": "beautiful",
  "pretence": "story",
  "pretend": "story",
  "pretending": "story",
  "pretense": "story",
  "pretension": "story",
  "pretentious": "beautiful",
  "preterition": "story",
  "pretermission": "smart",
  "pretermit": "smart",
  "pretext": "story",
  "pretorian": "beautiful",
  "pretorium": "build",
  "pretrial": "story",
  "pretzel": "taste",
  "prevalence": "heal",
  "prevaricate": "story",
  "prevarication": "story",
  "prevent": "sell",
  "preventable": "beautiful",
  "preventative": "build",
  "preventive": "build",
  "preview": "story",
  "previse": "story",
  "prevision": "smart",
  "prevue": "story",
  "prewar": "beautiful",
  "prey": "heal",
  "priacanthidae": "heal",
  "priacanthus": "heal",
  "price": "sell",
  "pricing": "sell",
  "prick": "heal",
  "pricker": "heal",
  "pricket": "build",
  "pricking": "build",
  "prickle": "heal",
  "prickle-weed": "heal",
  "prickleback": "heal",
  "prickling": "smart",
  "pride-of-india": "heal",
  "prie-dieu": "build",
  "priestcraft": "smart",
  "priestlike": "beautiful",
  "priestly": "beautiful",
  "prim": "heal",
  "prima": "taste",
  "primaquine": "build",
  "primary": "heal",
  "primate": "heal",
  "primates": "heal",
  "primatology": "smart",
  "primaxin": "build",
  "prime": "smart",
  "primer": "story",
  "primidone": "build",
  "priming": "build",
  "primitive": "story",
  "primitivism": "build",
  "primo": "story",
  "primogeniture": "sell",
  "primordium": "heal",
  "primp": "heal",
  "primping": "heal",
  "primrose": "heal",
  "primula": "heal",
  "primulaceae": "heal",
  "primulales": "heal",
  "primus": "build",
  "prince's-feather": "heal",
  "prince's-plume": "heal",
  "prince-of-wales'-heath": "heal",
  "princeton": "build",
  "princewood": "heal",
  "principal": "sell",
  "principen": "build",
  "principle": "smart",
  "principled": "beautiful",
  "prinia": "heal",
  "prinival": "build",
  "prink": "heal",
  "print": "story",
  "printable": "beautiful",
  "printer": "build",
  "printing": "story",
  "printmaker": "beautiful",
  "printmaking": "beautiful",
  "printout": "story",
  "priodontes": "heal",
  "prionace": "heal",
  "prionotus": "heal",
  "prior": "beautiful",
  "prioritise": "smart",
  "prioritize": "smart",
  "priory": "build",
  "prise": "build",
  "prism": "build",
  "prismatic": "beautiful",
  "prison": "build",
  "pristidae": "heal",
  "pristis": "heal",
  "pritzelago": "heal",
  "private": "beautiful",
  "privateer": "build",
  "privates": "heal",
  "privet": "heal",
  "privilege": "sell",
  "privileged": "sell",
  "privine": "build",
  "privy": "build",
  "prize": "sell",
  "prizefight": "build",
  "pro": "story",
  "pro-choice": "beautiful",
  "pro-life": "beautiful",
  "pro-lifer": "beautiful",
  "proactive": "beautiful",
  "probabilism": "smart",
  "probable": "beautiful",
  "probate": "story",
  "probe": "smart",
  "probenecid": "build",
  "probiotic": "heal",
  "problem": "story",
  "proboscidea": "heal",
  "proboscidean": "heal",
  "proboscidian": "heal",
  "proboscis": "heal",
  "procaine": "build",
  "procarbazine": "build",
  "procardia": "build",
  "procaryote": "heal",
  "procavia": "heal",
  "procaviidae": "heal",
  "procedural": "smart",
  "procedure": "story",
  "proceed": "story",
  "proceeding": "story",
  "proceedings": "story",
  "proceeds": "sell",
  "procellaria": "heal",
  "procellariidae": "heal",
  "procellariiformes": "heal",
  "process": "smart",
  "processed": "sell",
  "processing": "smart",
  "processional": "story",
  "processor": "smart",
  "prochlorperazine": "build",
  "prociphilus": "heal",
  "proclaim": "story",
  "proclamation": "story",
  "proclivity": "smart",
  "procnias": "heal",
  "proconsul": "heal",
  "procreate": "heal",
  "procrustes": "beautiful",
  "proctology": "smart",
  "proctor": "sell",
  "proctoscope": "build",
  "procure": "sell",
  "procyclidine": "build",
  "procyon": "heal",
  "procyonid": "heal",
  "procyonidae": "heal",
  "prod": "story",
  "prodding": "story",
  "prodigal": "beautiful",
  "prodigy": "smart",
  "produce": "taste",
  "product": "build",
  "production": "story",
  "productive": "beautiful",
  "profane": "sell",
  "profaneness": "smart",
  "profanity": "story",
  "profess": "story",
  "professing": "story",
  "profession": "story",
  "professional": "beautiful",
  "professionalisation": "smart",
  "professionalism": "smart",
  "professionalization": "smart",
  "proffer": "story",
  "proficiency": "smart",
  "proficient": "beautiful",
  "profile": "story",
  "profiling": "story",
  "profit": "sell",
  "profitable": "beautiful",
  "profiteer": "sell",
  "profiterole": "taste",
  "profits": "sell",
  "profligate": "beautiful",
  "profound": "beautiful",
  "profoundness": "smart",
  "profundity": "smart",
  "progestational": "heal",
  "prognathic": "beautiful",
  "prognathous": "beautiful",
  "progne": "heal",
  "prognosis": "story",
  "prognostic": "beautiful",
  "prognosticate": "story",
  "prognostication": "story",
  "program": "smart",
  "programing": "story",
  "programma": "smart",
  "programme": "smart",
  "programmer": "smart",
  "programming": "smart",
  "progressive": "beautiful",
  "progressivism": "smart",
  "progymnosperm": "heal",
  "prohibit": "story",
  "prohibition": "story",
  "project": "smart",
  "projectile": "build",
  "projection": "smart",
  "projector": "build",
  "prokaryote": "heal",
  "prokayotae": "heal",
  "prolate": "beautiful",
  "prolegomenon": "story",
  "prolepsis": "story",
  "proletarian": "beautiful",
  "proliferation": "smart",
  "prolix": "beautiful",
  "prolixity": "story",
  "prolixness": "story",
  "prolog": "story",
  "prologise": "story",
  "prologize": "story",
  "prologue": "story",
  "prologuize": "story",
  "prolonge": "build",
  "prolusion": "story",
  "promenade": "build",
  "promethazine": "build",
  "promise": "story",
  "promote": "sell",
  "promotion": "sell",
  "prompt": "story",
  "promptbook": "story",
  "prompter": "build",
  "prompting": "story",
  "promulgate": "story",
  "promulgation": "story",
  "promycelium": "heal",
  "pronator": "heal",
  "prong": "build",
  "prongbuck": "heal",
  "pronghorn": "heal",
  "pronominal": "story",
  "pronoun": "story",
  "pronounce": "story",
  "pronounceable": "beautiful",
  "pronouncement": "story",
  "pronucleus": "heal",
  "pronunciamento": "story",
  "pronunciation": "story",
  "proof": "smart",
  "proofread": "story",
  "prop": "build",
  "propaedeutic": "beautiful",
  "propaganda": "story",
  "propagandise": "story",
  "propagandize": "story",
  "propagate": "sell",
  "propagation": "story",
  "propanolol": "build",
  "proparoxytone": "story",
  "propel": "build",
  "propellant": "beautiful",
  "propellent": "beautiful",
  "propeller": "build",
  "propellor": "build",
  "propensity": "smart",
  "proper": "beautiful",
  "property": "sell",
  "prophase": "smart",
  "prophecy": "smart",
  "prophesy": "story",
  "prophetic": "beautiful",
  "prophetical": "beautiful",
  "prophets": "story",
  "prophylactic": "build",
  "prophyll": "heal",
  "propitiate": "story",
  "propitiatory": "beautiful",
  "propitious": "beautiful",
  "propjet": "build",
  "proportional": "smart",
  "proportionate": "beautiful",
  "proposal": "sell",
  "propose": "story",
  "proposition": "story",
  "propound": "story",
  "propoxyphene": "build",
  "proprietary": "sell",
  "proprietorship": "sell",
  "proprioception": "smart",
  "proprioceptor": "heal",
  "props": "build",
  "propulsion": "sound",
  "propulsive": "beautiful",
  "prorate": "smart",
  "prorogue": "sell",
  "prosauropoda": "heal",
  "proscenium": "build",
  "prosciutto": "taste",
  "proscribe": "story",
  "proscription": "story",
  "prose": "story",
  "prosecute": "sell",
  "proselytise": "story",
  "proselytism": "story",
  "proselytize": "story",
  "prosencephalon": "heal",
  "prosimian": "heal",
  "prosimii": "heal",
  "prosodic": "sound",
  "prosodion": "story",
  "prosody": "story",
  "prosom": "build",
  "prosopis": "heal",
  "prosopium": "heal",
  "prosopopoeia": "story",
  "prospect": "sell",
  "prospective": "beautiful",
  "prospectus": "story",
  "prosper": "sell",
  "prospicience": "smart",
  "prostaglandin": "heal",
  "prostate": "heal",
  "prostheon": "heal",
  "prosthesis": "build",
  "prosthetic": "heal",
  "prosthetics": "heal",
  "prosthetist": "heal",
  "prosthion": "heal",
  "prosthodontia": "smart",
  "prosthodontics": "smart",
  "prostigmin": "build",
  "prostitute": "sell",
  "prostrate": "build",
  "protea": "heal",
  "proteaceae": "heal",
  "proteales": "heal",
  "protected": "beautiful",
  "protection": "build",
  "protectionism": "story",
  "protective": "beautiful",
  "proteidae": "heal",
  "proteles": "heal",
  "proteolysis": "smart",
  "proteomics": "smart",
  "proteosome": "build",
  "proterochampsa": "heal",
  "proterozoic": "beautiful",
  "protest": "story",
  "protestant": "beautiful",
  "protestantism": "smart",
  "protestation": "story",
  "proteus": "heal",
  "prothalamion": "story",
  "prothalamium": "story",
  "prothorax": "heal",
  "protist": "heal",
  "protista": "heal",
  "protistan": "heal",
  "protium": "heal",
  "proto-norse": "story",
  "proto-oncogene": "heal",
  "protoanthropology": "smart",
  "protoarchaeology": "smart",
  "protoarcheology": "smart",
  "protoavis": "heal",
  "protoceratops": "heal",
  "protocol": "story",
  "protoctist": "heal",
  "protoctista": "heal",
  "protoheme": "beautiful",
  "protohippus": "heal",
  "protohistory": "smart",
  "protology": "smart",
  "protomammal": "heal",
  "protoplasm": "heal",
  "protoplast": "heal",
  "prototheria": "heal",
  "prototherian": "heal",
  "prototype": "smart",
  "protozoa": "heal",
  "protozoan": "heal",
  "protozoology": "smart",
  "protozoon": "heal",
  "protractor": "build",
  "protriptyline": "build",
  "protropin": "heal",
  "protrusive": "beautiful",
  "protura": "heal",
  "proturan": "heal",
  "proud": "beautiful",
  "prove": "smart",
  "proved": "smart",
  "proven": "smart",
  "provencal": "story",
  "provender": "taste",
  "proventil": "build",
  "proverb": "story",
  "proverbial": "beautiful",
  "proverbs": "story",
  "provide": "sell",
  "provident": "beautiful",
  "providential": "beautiful",
  "provincial": "beautiful",
  "provincialism": "smart",
  "provision": "story",
  "provisions": "taste",
  "proviso": "story",
  "provocation": "story",
  "provocative": "beautiful",
  "provoke": "build",
  "prow": "build",
  "prowess": "smart",
  "proxemics": "smart",
  "proximal": "beautiful",
  "proximate": "beautiful",
  "proximity": "smart",
  "proxy": "story",
  "prozac": "build",
  "prudence": "smart",
  "prudent": "beautiful",
  "prumnopitys": "heal",
  "prune": "taste",
  "prunella": "heal",
  "prunellidae": "heal",
  "pruner": "build",
  "pruning": "build",
  "pruno": "taste",
  "prunus": "heal",
  "pruritus": "smart",
  "pry": "build",
  "prying": "smart",
  "psalm": "story",
  "psalms": "story",
  "psalter": "story",
  "psalterium": "heal",
  "psaltery": "build",
  "psaltriparus": "heal",
  "psenes": "heal",
  "psephology": "smart",
  "psephurus": "heal",
  "psetta": "heal",
  "psettichthys": "heal",
  "pseudacris": "heal",
  "pseudaletia": "heal",
  "pseudechis": "heal",
  "pseudemys": "heal",
  "pseudepigrapha": "story",
  "pseudo": "beautiful",
  "pseudobombax": "heal",
  "pseudobulb": "heal",
  "pseudocarp": "heal",
  "pseudococcidae": "heal",
  "pseudococcus": "heal",
  "pseudocolus": "heal",
  "pseudocyesis": "heal",
  "pseudohermaphrodite": "beautiful",
  "pseudolarix": "heal",
  "pseudomonad": "heal",
  "pseudomonadales": "heal",
  "pseudomonas": "heal",
  "pseudomonodaceae": "heal",
  "pseudonym": "story",
  "pseudophloem": "heal",
  "pseudopleuronectes": "heal",
  "pseudopod": "heal",
  "pseudopodium": "heal",
  "pseudoryx": "heal",
  "pseudoscience": "smart",
  "pseudoscorpion": "heal",
  "pseudoscorpiones": "heal",
  "pseudoscorpionida": "heal",
  "pseudotaxus": "heal",
  "pseudotsuga": "heal",
  "pseudowintera": "heal",
  "psi": "smart",
  "psidium": "heal",
  "psilocin": "build",
  "psilocybin": "build",
  "psilophytaceae": "heal",
  "psilophytales": "heal",
  "psilophyte": "heal",
  "psilophyton": "heal",
  "psilopsida": "heal",
  "psilosis": "smart",
  "psilotaceae": "heal",
  "psilotales": "heal",
  "psilotatae": "heal",
  "psilotum": "heal",
  "psithyrus": "heal",
  "psittacidae": "heal",
  "psittaciformes": "heal",
  "psittacosaur": "heal",
  "psittacosaurus": "heal",
  "psittacula": "heal",
  "psittacus": "heal",
  "psoas": "heal",
  "psocid": "heal",
  "psocidae": "heal",
  "psocoptera": "heal",
  "psophia": "heal",
  "psophiidae": "heal",
  "psophocarpus": "heal",
  "psoralea": "heal",
  "psyche": "smart",
  "psychiatry": "heal",
  "psychic": "beautiful",
  "psychoactive": "beautiful",
  "psychoanalyse": "smart",
  "psychoanalyze": "smart",
  "psychobabble": "story",
  "psychodid": "heal",
  "psychodidae": "heal",
  "psychodynamics": "smart",
  "psychogenesis": "smart",
  "psychogenic": "beautiful",
  "psychokinesis": "story",
  "psycholinguistics": "smart",
  "psychological": "beautiful",
  "psychology": "smart",
  "psychometrics": "smart",
  "psychometrika": "smart",
  "psychometry": "smart",
  "psychoneurosis": "heal",
  "psychoneurotic": "beautiful",
  "psychonomics": "smart",
  "psychopathology": "heal",
  "psychopharmacological": "heal",
  "psychopharmacology": "heal",
  "psychophysics": "smart",
  "psychophysiology": "heal",
  "psychopsis": "heal",
  "psychosexuality": "smart",
  "psychotherapeutic": "beautiful",
  "psychotherapeutics": "smart",
  "psychotherapy": "smart",
  "psychotic": "beautiful",
  "psychotria": "heal",
  "psychotropic": "beautiful",
  "psychrometer": "build",
  "psylla": "heal",
  "psyllid": "heal",
  "psyllidae": "heal",
  "psyllium": "heal",
  "ptarmigan": "heal",
  "pteretis": "heal",
  "pteridaceae": "heal",
  "pteridium": "heal",
  "pteridology": "smart",
  "pteridophyta": "heal",
  "pteridophyte": "heal",
  "pteridosperm": "heal",
  "pteridospermae": "heal",
  "pteridospermaphyta": "heal",
  "pteridospermopsida": "heal",
  "pteriidae": "heal",
  "pterion": "heal",
  "pteris": "heal",
  "pternohyla": "heal",
  "pterocarpus": "heal",
  "pterocarya": "heal",
  "pterocles": "heal",
  "pteroclididae": "heal",
  "pterocnemia": "heal",
  "pterodactyl": "heal",
  "pterodactylidae": "heal",
  "pterodactylus": "heal",
  "pterois": "heal",
  "pteropogon": "heal",
  "pteropsida": "heal",
  "pteropus": "heal",
  "pterosaur": "heal",
  "pterosauria": "heal",
  "pterospermum": "heal",
  "pterostylis": "heal",
  "pterygium": "heal",
  "ptilocercus": "heal",
  "ptilocrinus": "heal",
  "ptilonorhynchidae": "heal",
  "ptilonorhynchus": "heal",
  "ptloris": "heal",
  "pto": "build",
  "ptolemaic": "beautiful",
  "ptyalise": "heal",
  "ptyalism": "smart",
  "ptyalize": "heal",
  "ptyas": "heal",
  "ptychozoon": "heal",
  "pub": "taste",
  "pub-crawl": "taste",
  "pubes": "heal",
  "pubis": "heal",
  "public": "beautiful",
  "publication": "story",
  "publicise": "story",
  "publicised": "story",
  "publicity": "story",
  "publicize": "story",
  "publicized": "story",
  "publicizing": "story",
  "publish": "story",
  "publishable": "beautiful",
  "published": "build",
  "publishing": "story",
  "puccinia": "heal",
  "pucciniaceae": "heal",
  "puccoon": "heal",
  "puck": "build",
  "pucker": "build",
  "puckerbush": "heal",
  "pud": "taste",
  "pudding": "taste",
  "pudding-face": "heal",
  "pudding-wife": "heal",
  "puddingwife": "heal",
  "pudendum": "heal",
  "pueraria": "heal",
  "puerile": "beautiful",
  "puerperium": "heal",
  "puff": "sound",
  "puffball": "heal",
  "puffbird": "heal",
  "puffer": "taste",
  "pufferfish": "taste",
  "puffery": "story",
  "puffin": "heal",
  "puffing": "taste",
  "puffinus": "heal",
  "pug": "heal",
  "pug-dog": "heal",
  "pujunan": "story",
  "puka": "heal",
  "puke": "heal",
  "puking": "heal",
  "puku": "heal",
  "pul": "smart",
  "pula": "smart",
  "pulasan": "heal",
  "pulassan": "heal",
  "pule": "heal",
  "pulex": "heal",
  "pulicaria": "heal",
  "pulicidae": "heal",
  "pull": "sound",
  "pull-in": "build",
  "pull-off": "build",
  "pull-through": "build",
  "pull-up": "build",
  "pullback": "build",
  "pullet": "taste",
  "pulley": "build",
  "pulley-block": "build",
  "pulling": "build",
  "pullman": "build",
  "pullover": "build",
  "pullulation": "smart",
  "pulmonata": "heal",
  "pulp": "heal",
  "pulpit": "build",
  "pulque": "taste",
  "pulsate": "build",
  "pulsatilla": "heal",
  "pulsation": "sound",
  "pulse": "heal",
  "pulsing": "build",
  "pulverise": "build",
  "pulverize": "build",
  "puma": "heal",
  "pumice": "build",
  "pummel": "build",
  "pummelo": "heal",
  "pump": "build",
  "pumpernickel": "taste",
  "pumpkin": "heal",
  "pumpkin-shaped": "beautiful",
  "pumpkinseed": "heal",
  "pun": "story",
  "punch": "taste",
  "punchball": "build",
  "punchboard": "build",
  "puncher": "build",
  "punctilio": "story",
  "punctual": "beautiful",
  "punctuate": "story",
  "punctuation": "story",
  "punctum": "heal",
  "puncturable": "beautiful",
  "puncture": "build",
  "punctureless": "beautiful",
  "pung": "build",
  "pungapung": "heal",
  "pungency": "story",
  "punic": "story",
  "punica": "heal",
  "punicaceae": "heal",
  "punish": "sell",
  "punished": "sell",
  "punishing": "sell",
  "punitive": "beautiful",
  "punitory": "beautiful",
  "punjabi": "story",
  "punkah": "build",
  "punkey": "heal",
  "punkie": "heal",
  "punky": "heal",
  "punnet": "build",
  "punning": "story",
  "punt": "smart",
  "punting": "build",
  "pup": "heal",
  "pupa": "heal",
  "pupate": "heal",
  "pupil": "heal",
  "puppet": "build",
  "puppetry": "smart",
  "puppy": "heal",
  "purana": "story",
  "purau": "heal",
  "purchase": "sell",
  "purchasing": "sell",
  "purdah": "build",
  "pure": "beautiful",
  "pureblood": "heal",
  "purebred": "heal",
  "puree": "taste",
  "purgative": "build",
  "purgatory": "smart",
  "purge": "sell",
  "purging": "sell",
  "purification": "smart",
  "purifier": "build",
  "purify": "taste",
  "purifying": "taste",
  "purinethol": "build",
  "purism": "story",
  "puritanical": "beautiful",
  "puritanism": "smart",
  "purkinje": "heal",
  "purl": "build",
  "purloin": "sell",
  "purloo": "taste",
  "purple": "beautiful",
  "purpleness": "beautiful",
  "purplish-red": "beautiful",
  "purport": "story",
  "purpose": "smart",
  "purposeful": "beautiful",
  "purposeless": "beautiful",
  "purr": "sound",
  "purse": "build",
  "purslane": "heal",
  "pursuance": "smart",
  "pursue": "sell",
  "pursued": "sell",
  "pursuit": "smart",
  "purulence": "heal",
  "purvey": "sell",
  "pus": "heal",
  "puseyism": "smart",
  "push": "sound",
  "push-bike": "build",
  "pushcart": "build",
  "pushchair": "build",
  "pusher": "build",
  "pushing": "story",
  "pushpin": "build",
  "puss": "heal",
  "pussley": "heal",
  "pussly": "heal",
  "pussy": "heal",
  "pussy's-paw": "heal",
  "pussy-paw": "heal",
  "pussy-paws": "heal",
  "pussycat": "heal",
  "pussytoes": "heal",
  "put": "build",
  "put-down": "story",
  "put-on": "story",
  "put-put": "build",
  "putamen": "heal",
  "putoff": "story",
  "putrefaction": "smart",
  "putrid": "beautiful",
  "putt": "build",
  "puttee": "build",
  "putter": "build",
  "putting": "build",
  "putty": "build",
  "puttyroot": "heal",
  "putz": "heal",
  "puzzle": "story",
  "puzzlement": "smart",
  "puzzler": "story",
  "pwr": "build",
  "pya": "smart",
  "pycnanthemum": "heal",
  "pycnidium": "heal",
  "pycnogonid": "heal",
  "pycnogonida": "heal",
  "pye-dog": "heal",
  "pyelogram": "build",
  "pygopodidae": "heal",
  "pygopus": "heal",
  "pygoscelis": "heal",
  "pyinma": "heal",
  "pyjama": "build",
  "pyknic": "beautiful",
  "pylodictus": "heal",
  "pylon": "build",
  "pylorus": "heal",
  "pyocyanase": "build",
  "pyocyanin": "build",
  "pyracanth": "heal",
  "pyracantha": "heal",
  "pyralid": "heal",
  "pyralidae": "heal",
  "pyralididae": "heal",
  "pyralis": "heal",
  "pyramid": "sell",
  "pyramiding": "sound",
  "pyrausta": "heal",
  "pyrene": "heal",
  "pyrenomycetes": "heal",
  "pyrethrum": "heal",
  "pyretic": "beautiful",
  "pyridium": "build",
  "pyrilamine": "build",
  "pyrimidine": "sound",
  "pyrocephalus": "heal",
  "pyrochemistry": "smart",
  "pyroelectricity": "sound",
  "pyrograph": "build",
  "pyrola": "heal",
  "pyrolaceae": "heal",
  "pyroligneous": "taste",
  "pyrolignic": "taste",
  "pyromancy": "smart",
  "pyrometer": "build",
  "pyrophorus": "heal",
  "pyroscope": "build",
  "pyrostat": "build",
  "pyrotechnic": "build",
  "pyrotechnics": "smart",
  "pyrrhic": "story",
  "pyrrhocoridae": "heal",
  "pyrrhula": "heal",
  "pyrrhuloxia": "heal",
  "pyrrophyta": "heal",
  "pyrrosia": "heal",
  "pyrularia": "heal",
  "pyrus": "heal",
  "pythiaceae": "heal",
  "pythium": "heal",
  "python": "heal",
  "pythonidae": "heal",
  "pythoninae": "heal",
  "pyx": "build",
  "pyxidanthera": "heal",
  "pyxidium": "heal",
  "pyxie": "heal",
  "pyxis": "heal",
  "qabala": "story",
  "qabalah": "story",
  "qabbala": "smart",
  "qabbalah": "smart",
  "qat": "build",
  "qcd": "smart",
  "qed": "smart",
  "qepiq": "smart",
  "qiang": "story",
  "qiangic": "story",
  "qindarka": "smart",
  "qintar": "smart",
  "qoph": "story",
  "quaalude": "build",
  "quack": "story",
  "quack-quack": "heal",
  "quackgrass": "heal",
  "quad": "heal",
  "quadrangle": "build",
  "quadrant": "build",
  "quadraphony": "build",
  "quadrate": "beautiful",
  "quadratic": "story",
  "quadratics": "smart",
  "quadriceps": "heal",
  "quadrilateral": "beautiful",
  "quadrille": "story",
  "quadrillion": "smart",
  "quadrillionth": "smart",
  "quadrivium": "smart",
  "quadruped": "heal",
  "quadrupedal": "beautiful",
  "quadruple": "smart",
  "quadruplet": "smart",
  "quadruplicate": "build",
  "quadrupling": "smart",
  "quaff": "taste",
  "quagga": "heal",
  "quahaug": "taste",
  "quahog": "taste",
  "quail": "taste",
  "quakerism": "smart",
  "qualification": "story",
  "qualified": "story",
  "qualifier": "story",
  "qualify": "story",
  "qualifying": "story",
  "qualitative": "smart",
  "quality": "smart",
  "quamash": "heal",
  "quamassia": "heal",
  "quandang": "heal",
  "quandary": "smart",
  "quandong": "heal",
  "quantic": "smart",
  "quantification": "smart",
  "quantifier": "story",
  "quantise": "smart",
  "quantitative": "smart",
  "quantity": "smart",
  "quantize": "smart",
  "quantized": "smart",
  "quantong": "taste",
  "quantum": "smart",
  "quapaw": "story",
  "quark": "taste",
  "quarrel": "story",
  "quarry": "build",
  "quarrying": "taste",
  "quart": "smart",
  "quarter": "smart",
  "quarter-tone": "story",
  "quarter-vine": "heal",
  "quarterdeck": "build",
  "quartering": "build",
  "quarterlight": "build",
  "quarterly": "story",
  "quartern": "smart",
  "quarters": "build",
  "quarterstaff": "build",
  "quartervine": "heal",
  "quartet": "sound",
  "quartette": "story",
  "quartic": "smart",
  "quartile": "smart",
  "quash": "sell",
  "quasiparticle": "smart",
  "quassia": "heal",
  "quat": "build",
  "quatern": "smart",
  "quaternary": "smart",
  "quaternion": "smart",
  "quaternity": "smart",
  "quatrain": "story",
  "quaver": "story",
  "quay": "build",
  "quayage": "sell",
  "quechua": "story",
  "quechuan": "story",
  "queen": "heal",
  "queenfish": "heal",
  "queens": "heal",
  "queer": "sell",
  "quell": "taste",
  "quelling": "taste",
  "quellung": "smart",
  "quench": "taste",
  "quenching": "taste",
  "quercitron": "heal",
  "quercus": "heal",
  "quern": "build",
  "query": "story",
  "quesadilla": "taste",
  "quest": "smart",
  "question": "story",
  "questionable": "beautiful",
  "questioning": "story",
  "questionnaire": "story",
  "quetch": "story",
  "quetzal": "smart",
  "queue": "story",
  "quiaquia": "heal",
  "quibble": "story",
  "quiche": "taste",
  "quick": "heal",
  "quick-wittedness": "smart",
  "quicken": "sound",
  "quickening": "smart",
  "quickness": "smart",
  "quickset": "heal",
  "quicksilver": "beautiful",
  "quickstep": "story",
  "quid": "smart",
  "quiddity": "story",
  "quiesce": "sound",
  "quiescence": "sound",
  "quiescency": "sound",
  "quieten": "sound",
  "quietism": "smart",
  "quiff": "heal",
  "quill": "build",
  "quillwort": "heal",
  "quilt": "beautiful",
  "quilting": "beautiful",
  "quinacrine": "build",
  "quince": "heal",
  "quinidex": "build",
  "quinidine": "build",
  "quinine": "build",
  "quinora": "build",
  "quint": "smart",
  "quintal": "smart",
  "quintessence": "smart",
  "quintet": "story",
  "quintette": "story",
  "quintillion": "smart",
  "quintillionth": "smart",
  "quintuple": "beautiful",
  "quintuplet": "smart",
  "quintupling": "smart",
  "quip": "story",
  "quipu": "build",
  "quira": "heal",
  "quire": "smart",
  "quirk": "build",
  "quirt": "build",
  "quiscalus": "heal",
  "quit": "sell",
  "quitclaim": "story",
  "quittance": "sell",
  "quiver": "build",
  "quiz": "story",
  "quodlibet": "smart",
  "quoin": "build",
  "quoit": "build",
  "quoits": "build",
  "quoratean": "story",
  "quota": "smart",
  "quotable": "beautiful",
  "quotation": "story",
  "quote": "story",
  "quotient": "smart",
  "quran": "story",
  "qurush": "smart",
  "r-2": "build",
  "r.v.": "build",
  "rabato": "build",
  "rabbet": "build",
  "rabbi": "story",
  "rabbit": "heal",
  "rabbit-weed": "heal",
  "rabbiteye": "heal",
  "rabbitfish": "heal",
  "rabbitweed": "heal",
  "rabbitwood": "heal",
  "rabid": "beautiful",
  "raccoon": "heal",
  "raceabout": "build",
  "racecard": "story",
  "racecourse": "build",
  "racehorse": "heal",
  "raceme": "heal",
  "racer": "build",
  "racerunner": "heal",
  "racetrack": "build",
  "raceway": "build",
  "rachet": "build",
  "rachis": "heal",
  "rachischisis": "heal",
  "rachycentridae": "heal",
  "rachycentron": "heal",
  "racial": "beautiful",
  "racing": "sell",
  "racism": "smart",
  "racist": "beautiful",
  "rack": "build",
  "racket": "smart",
  "racketeer": "sell",
  "racketeering": "sell",
  "racon": "story",
  "racoon": "heal",
  "racquet": "build",
  "racquetball": "build",
  "rad": "smart",
  "radar": "build",
  "raddle": "build",
  "radial": "build",
  "radian": "smart",
  "radiance": "sound",
  "radiate": "sound",
  "radiation": "sound",
  "radiator": "build",
  "radical": "smart",
  "radicalism": "smart",
  "radicchio": "taste",
  "radicle": "heal",
  "radiigera": "heal",
  "radio": "story",
  "radio-gramophone": "build",
  "radio-opacity": "sound",
  "radio-opaque": "beautiful",
  "radio-phonograph": "build",
  "radioactive": "beautiful",
  "radioactivity": "smart",
  "radiobiology": "smart",
  "radiochemistry": "smart",
  "radiocommunication": "story",
  "radiogram": "story",
  "radiograph": "build",
  "radiography": "smart",
  "radioimmunoassay": "smart",
  "radiolaria": "heal",
  "radiolarian": "heal",
  "radiolocation": "build",
  "radiology": "heal",
  "radiolucent": "beautiful",
  "radiolysis": "smart",
  "radiometer": "build",
  "radiomicrometer": "build",
  "radiopacity": "sound",
  "radiopaque": "beautiful",
  "radiopharmaceutical": "build",
  "radiophone": "build",
  "radiophoto": "build",
  "radiophotograph": "build",
  "radiosensitivity": "smart",
  "radiotelegraph": "story",
  "radiotelegraphy": "story",
  "radiotelephone": "story",
  "radiotelephony": "story",
  "radish": "taste",
  "radius": "heal",
  "radix": "smart",
  "radome": "build",
  "radyera": "heal",
  "raetam": "heal",
  "raffia": "heal",
  "raffle": "sell",
  "raffles": "sell",
  "rafflesiaceae": "heal",
  "raft": "build",
  "rafter": "build",
  "rafts": "smart",
  "rag": "build",
  "ragbag": "build",
  "ragee": "heal",
  "ragi": "heal",
  "raglan": "build",
  "ragnarok": "story",
  "ragout": "taste",
  "ragtime": "story",
  "ragweed": "heal",
  "ragwort": "heal",
  "raid": "sell",
  "rail": "build",
  "railcar": "build",
  "railhead": "build",
  "railing": "build",
  "raillery": "story",
  "railroad": "build",
  "railroading": "sell",
  "rails": "smart",
  "railway": "build",
  "railyard": "build",
  "raiment": "build",
  "rain": "sound",
  "rain-wash": "smart",
  "rainbow": "smart",
  "raincoat": "build",
  "raindrop": "sound",
  "rainfall": "sound",
  "rainfly": "build",
  "rainstorm": "sound",
  "raised": "story",
  "raisin": "taste",
  "raita": "taste",
  "raiu": "smart",
  "raja": "heal",
  "rajidae": "heal",
  "rajiformes": "heal",
  "rake": "build",
  "rake-off": "sell",
  "rallidae": "heal",
  "rally": "smart",
  "rallying": "build",
  "ram": "smart",
  "ram's-head": "heal",
  "ramalina": "heal",
  "ramayana": "story",
  "rambotan": "heal",
  "rambouillet": "heal",
  "rambutan": "heal",
  "ramee": "heal",
  "ramekin": "taste",
  "ramequin": "taste",
  "ramie": "heal",
  "ramipril": "build",
  "ramjet": "build",
  "rammer": "build",
  "ramona": "heal",
  "ramontchi": "heal",
  "ramp": "build",
  "rampage": "sell",
  "rampart": "build",
  "ramphastidae": "heal",
  "ramphomicron": "heal",
  "rampion": "heal",
  "ramrod": "build",
  "ramsons": "heal",
  "ramus": "heal",
  "rana": "heal",
  "ranales": "heal",
  "ranatra": "heal",
  "ranch": "build",
  "ranching": "sell",
  "rand": "smart",
  "random": "beautiful",
  "rangefinder": "build",
  "rangifer": "heal",
  "rangpur": "heal",
  "ranid": "heal",
  "ranidae": "heal",
  "ranitidine": "build",
  "rankine": "smart",
  "ranking": "smart",
  "ransack": "sell",
  "ransacking": "sell",
  "ransom": "sell",
  "rant": "story",
  "ranting": "story",
  "ranunculaceae": "heal",
  "ranunculales": "heal",
  "ranunculus": "heal",
  "raoulia": "heal",
  "rap": "sound",
  "rapateaceae": "heal",
  "rape": "heal",
  "rapeseed": "heal",
  "raphanus": "heal",
  "raphe": "heal",
  "raphia": "heal",
  "raphicerus": "heal",
  "raphidae": "heal",
  "raphidiidae": "heal",
  "raphus": "heal",
  "rapid": "beautiful",
  "rapier": "build",
  "rappee": "build",
  "rapper": "sound",
  "raptor": "heal",
  "raptores": "heal",
  "raptorial": "beautiful",
  "rarebit": "taste",
  "rariora": "build",
  "rarity": "build",
  "ras": "heal",
  "rase": "build",
  "rash": "beautiful",
  "rasher": "heal",
  "rasp": "story",
  "raspberry": "heal",
  "rasping": "story",
  "rastafarianism": "smart",
  "raster": "smart",
  "rat": "heal",
  "ratables": "sell",
  "ratafee": "taste",
  "ratafia": "taste",
  "ratan": "build",
  "ratatouille": "taste",
  "ratch": "build",
  "ratchet": "build",
  "rate": "sell",
  "rateables": "sell",
  "ratel": "heal",
  "rates": "sell",
  "rathole": "build",
  "rathskeller": "build",
  "ratibida": "heal",
  "ratification": "story",
  "ratify": "sell",
  "rating": "smart",
  "ratiocinate": "smart",
  "ratiocination": "story",
  "ration": "taste",
  "rational": "smart",
  "rationale": "smart",
  "rationalisation": "smart",
  "rationalise": "sell",
  "rationalism": "smart",
  "rationalization": "smart",
  "rationalize": "story",
  "rationing": "sell",
  "ratitae": "heal",
  "ratite": "heal",
  "ratlin": "build",
  "ratline": "build",
  "rattail": "heal",
  "rattan": "heal",
  "ratter": "heal",
  "ratting": "story",
  "rattle": "build",
  "rattle-top": "heal",
  "rattlebox": "heal",
  "rattler": "heal",
  "rattlesnake": "heal",
  "rattling": "sound",
  "rattrap": "build",
  "rattus": "heal",
  "ratty": "beautiful",
  "rau-sed": "build",
  "raudixin": "build",
  "rauvolfia": "heal",
  "rauwolfia": "heal",
  "ravaging": "beautiful",
  "rave": "story",
  "ravehook": "build",
  "ravel": "build",
  "raveling": "build",
  "ravelling": "build",
  "raven": "heal",
  "ravenala": "heal",
  "ravigote": "taste",
  "ravigotte": "taste",
  "raving": "story",
  "ravioli": "taste",
  "ravish": "sell",
  "raw": "beautiful",
  "rawness": "smart",
  "ray": "sound",
  "rayleigh": "sound",
  "rayon": "build",
  "rayons": "build",
  "raze": "build",
  "razing": "build",
  "razor": "build",
  "razor-fish": "heal",
  "razorback": "heal",
  "razorbill": "heal",
  "razorblade": "build",
  "razz": "story",
  "razzing": "story",
  "rbc": "heal",
  "re-address": "story",
  "re-afforest": "build",
  "re-argue": "story",
  "re-create": "build",
  "re-created": "build",
  "re-emphasise": "story",
  "re-emphasize": "story",
  "re-entrant": "beautiful",
  "re-equip": "sell",
  "re-examine": "story",
  "re-experiencing": "smart",
  "re-explain": "story",
  "re-explore": "smart",
  "re-introduce": "story",
  "re-introduction": "story",
  "re-uptake": "smart",
  "reabsorb": "build",
  "reabsorption": "smart",
  "reach": "smart",
  "reacquaint": "story",
  "react": "smart",
  "reactance": "sound",
  "reaction": "smart",
  "reactionary": "beautiful",
  "reactionism": "smart",
  "reactive": "beautiful",
  "reactivity": "smart",
  "reactor": "build",
  "read": "story",
  "read-out": "story",
  "readiness": "smart",
  "reading": "smart",
  "readmit": "sell",
  "readout": "story",
  "ready": "build",
  "ready-made": "build",
  "ready-mix": "taste",
  "ready-to-wear": "build",
  "readying": "build",
  "reaffirm": "story",
  "reaffirmation": "story",
  "real": "smart",
  "realisation": "story",
  "realise": "sell",
  "realism": "beautiful",
  "realistic": "beautiful",
  "reality": "smart",
  "realization": "smart",
  "realize": "smart",
  "reallocate": "sell",
  "reallocation": "sell",
  "reallot": "sell",
  "realm": "smart",
  "realpolitik": "smart",
  "realty": "sell",
  "ream": "smart",
  "reamer": "build",
  "reanimate": "heal",
  "reap": "build",
  "reaper": "build",
  "reapportion": "sell",
  "reappraisal": "smart",
  "reappraise": "smart",
  "rear": "heal",
  "rear-end": "build",
  "rearing": "sell",
  "rearm": "sell",
  "rearward": "beautiful",
  "reason": "story",
  "reasonable": "beautiful",
  "reasoning": "smart",
  "reassemble": "build",
  "reassert": "story",
  "reassertion": "story",
  "reassess": "smart",
  "reassessment": "smart",
  "reassign": "sell",
  "reassure": "story",
  "reassuring": "story",
  "reata": "build",
  "reattribute": "smart",
  "reave": "sell",
  "reawaken": "heal",
  "rebate": "sell",
  "rebato": "build",
  "rebel": "sell",
  "rebind": "build",
  "rebirth": "sound",
  "reboot": "heal",
  "reboxetine": "build",
  "rebozo": "build",
  "rebroadcast": "story",
  "rebuff": "story",
  "rebuild": "build",
  "rebuilding": "build",
  "rebuke": "story",
  "rebury": "sell",
  "reburying": "sell",
  "rebus": "story",
  "rebut": "story",
  "rebuttal": "story",
  "rebutter": "story",
  "recalculate": "smart",
  "recall": "story",
  "recant": "story",
  "recantation": "story",
  "recap": "story",
  "recapitulate": "story",
  "recapitulation": "smart",
  "recapture": "build",
  "recast": "build",
  "recasting": "story",
  "receipt": "sell",
  "receipts": "sell",
  "receivables": "sell",
  "receive": "sell",
  "received": "sell",
  "receiver": "build",
  "recent": "beautiful",
  "receptacle": "build",
  "reception": "story",
  "receptive": "beautiful",
  "receptor": "heal",
  "recess": "build",
  "recessional": "story",
  "recessive": "heal",
  "recharge": "build",
  "rechauffe": "taste",
  "recidivate": "heal",
  "recipe": "taste",
  "recipient": "story",
  "reciprocal": "beautiful",
  "reciprocate": "sell",
  "recital": "sound",
  "recitation": "story",
  "recitative": "story",
  "recite": "story",
  "reckon": "smart",
  "reckoner": "story",
  "reckoning": "smart",
  "reclaim": "sell",
  "reclassify": "smart",
  "recline": "build",
  "recliner": "build",
  "reclining": "build",
  "recluse": "beautiful",
  "recognisance": "sell",
  "recognise": "sell",
  "recognition": "smart",
  "recognizance": "sell",
  "recognize": "smart",
  "recoil": "sell",
  "recollect": "smart",
  "recollection": "smart",
  "recollective": "beautiful",
  "recombinant": "heal",
  "recommend": "story",
  "recommendation": "story",
  "recommit": "sell",
  "recompense": "sell",
  "reconcilable": "beautiful",
  "reconcile": "story",
  "reconditeness": "smart",
  "reconfirm": "story",
  "reconnoiter": "sound",
  "reconnoitering": "sound",
  "reconnoitre": "sound",
  "reconnoitring": "sound",
  "reconquer": "sell",
  "reconsecrate": "story",
  "reconsider": "smart",
  "reconsideration": "story",
  "reconstruct": "smart",
  "reconstructed": "smart",
  "reconstruction": "story",
  "reconvict": "story",
  "recopy": "build",
  "record": "story",
  "recorded": "story",
  "recorder": "build",
  "recording": "sound",
  "recount": "story",
  "recounting": "story",
  "recoup": "sell",
  "recover": "sell",
  "recoverable": "beautiful",
  "recovery": "heal",
  "recreant": "beautiful",
  "recreate": "heal",
  "recreational": "beautiful",
  "recriminate": "story",
  "recrimination": "story",
  "recruit": "sell",
  "rectifiable": "beautiful",
  "rectification": "smart",
  "rectifier": "build",
  "rectify": "story",
  "recto": "story",
  "rectory": "build",
  "rectum": "heal",
  "rectus": "heal",
  "recumb": "build",
  "recuperate": "sell",
  "recuperation": "smart",
  "recur": "story",
  "recursion": "smart",
  "recurvirostra": "heal",
  "recurvirostridae": "heal",
  "recusant": "beautiful",
  "recuse": "story",
  "recycle": "taste",
  "recycling": "taste",
  "red": "sell",
  "red-berry": "heal",
  "redact": "story",
  "redaction": "story",
  "redbelly": "heal",
  "redberry": "heal",
  "redbird": "heal",
  "redbone": "heal",
  "redbreast": "heal",
  "redbrush": "heal",
  "redbud": "heal",
  "redbug": "heal",
  "redden": "heal",
  "rede": "story",
  "redecorate": "build",
  "rededicate": "story",
  "redeem": "sell",
  "redefine": "story",
  "redefinition": "story",
  "redemption": "sell",
  "redemptive": "beautiful",
  "redeploy": "build",
  "redeposit": "sell",
  "redeposition": "smart",
  "redesign": "build",
  "redetermine": "story",
  "redevelop": "sound",
  "redfish": "taste",
  "redhead": "heal",
  "redhorse": "heal",
  "rediffusion": "story",
  "rediscover": "sound",
  "redispose": "sell",
  "redistribute": "build",
  "redline": "sell",
  "redmaids": "heal",
  "redness": "beautiful",
  "redo": "build",
  "redoubt": "build",
  "redound": "sound",
  "redox": "smart",
  "redpoll": "heal",
  "redraft": "sell",
  "redress": "story",
  "redroot": "heal",
  "redshank": "heal",
  "redshift": "sound",
  "redstart": "heal",
  "redtail": "heal",
  "reduce": "sell",
  "reduced": "sell",
  "reducer": "build",
  "reducible": "beautiful",
  "reducing": "smart",
  "reductio": "smart",
  "reduction": "smart",
  "reductionism": "smart",
  "redundancy": "story",
  "reduplicate": "build",
  "reduplication": "story",
  "reduviid": "heal",
  "reduviidae": "heal",
  "redwing": "heal",
  "redwood": "heal",
  "reecho": "sound",
  "reed": "heal",
  "reedbird": "heal",
  "reedmace": "heal",
  "reef": "build",
  "reefer": "build",
  "reek": "smart",
  "reel": "build",
  "reelect": "sell",
  "reenact": "build",
  "reenforcement": "story",
  "reentrant": "beautiful",
  "reestablish": "sell",
  "reevaluate": "smart",
  "reevaluation": "smart",
  "reeve": "heal",
  "reexamination": "story",
  "reexamine": "smart",
  "refabrication": "build",
  "reface": "build",
  "refashion": "build",
  "refection": "taste",
  "refectory": "build",
  "refer": "story",
  "refereeing": "story",
  "reference": "smart",
  "referent": "story",
  "referral": "story",
  "refill": "build",
  "refilling": "smart",
  "refinance": "sell",
  "refinement": "smart",
  "refinery": "build",
  "refining": "smart",
  "refinish": "build",
  "refit": "sell",
  "reflation": "smart",
  "reflect": "sound",
  "reflectance": "smart",
  "reflected": "sound",
  "reflection": "smart",
  "reflective": "beautiful",
  "reflectivity": "smart",
  "reflectometer": "build",
  "reflector": "build",
  "reflectorise": "sell",
  "reflectorize": "sell",
  "reflex": "beautiful",
  "reflexion": "sound",
  "reflexive": "story",
  "reflexology": "smart",
  "refocus": "sound",
  "refocusing": "sound",
  "reforest": "build",
  "reforge": "build",
  "reformatory": "build",
  "reformer": "build",
  "reformism": "smart",
  "reformist": "beautiful",
  "reformulate": "story",
  "refract": "sound",
  "refraction": "sound",
  "refractive": "beautiful",
  "refractometer": "build",
  "refractory": "build",
  "refracture": "heal",
  "refrain": "story",
  "refresh": "smart",
  "refreshen": "heal",
  "refresher": "sell",
  "refreshment": "taste",
  "refrigerant": "beautiful",
  "refrigeration": "smart",
  "refrigerator": "taste",
  "refuel": "sell",
  "refueling": "sell",
  "refuge": "build",
  "refund": "sell",
  "refurnish": "sell",
  "refusal": "story",
  "refuse": "story",
  "refutation": "story",
  "refute": "story",
  "regain": "sell",
  "regaining": "sell",
  "regale": "taste",
  "regalecidae": "heal",
  "regalia": "build",
  "regard": "smart",
  "regenerate": "build",
  "regenerating": "build",
  "regeneration": "smart",
  "regent": "beautiful",
  "reggae": "sound",
  "regime": "smart",
  "regimen": "smart",
  "regiment": "sell",
  "regimentals": "build",
  "region": "heal",
  "regional": "beautiful",
  "regionalism": "story",
  "register": "story",
  "registered": "sell",
  "registration": "story",
  "registry": "story",
  "reglaecus": "heal",
  "regnellidium": "heal",
  "regorge": "heal",
  "regress": "smart",
  "regression": "smart",
  "regressive": "beautiful",
  "regret": "story",
  "regretful": "beautiful",
  "regrets": "story",
  "regroup": "sell",
  "regrow": "heal",
  "regularise": "sell",
  "regularize": "sell",
  "regulate": "sell",
  "regulated": "sell",
  "regulating": "sell",
  "regulation": "story",
  "regulator": "build",
  "regulus": "heal",
  "regurgitate": "taste",
  "regurgitation": "smart",
  "rehabilitate": "heal",
  "rehabilitation": "heal",
  "rehabilitative": "heal",
  "reharmonisation": "story",
  "reharmonise": "build",
  "reharmonization": "story",
  "reharmonize": "build",
  "rehash": "story",
  "rehear": "sell",
  "rehearing": "sell",
  "rehearse": "build",
  "rehouse": "sell",
  "reify": "smart",
  "reign": "sell",
  "reimburse": "sell",
  "reimbursement": "sell",
  "reimpose": "sell",
  "rein": "build",
  "reincarnate": "beautiful",
  "reincarnation": "smart",
  "reincarnationism": "smart",
  "reindeer": "heal",
  "reinforce": "story",
  "reinforcement": "story",
  "reinforcer": "smart",
  "reinstall": "build",
  "reinstate": "sell",
  "reinsurance": "sell",
  "reinsure": "sell",
  "reinterpret": "story",
  "reinterpretation": "smart",
  "reintroduce": "story",
  "reintroduction": "story",
  "reinvent": "build",
  "reinvigorate": "heal",
  "reissue": "story",
  "reiterate": "story",
  "reithrodontomys": "heal",
  "reject": "smart",
  "rejection": "sound",
  "rejective": "beautiful",
  "rejig": "sell",
  "rejoice": "story",
  "rejoicing": "story",
  "rejoin": "sell",
  "rejoinder": "story",
  "rejuvenate": "story",
  "rejuvenation": "sound",
  "relace": "build",
  "relafen": "build",
  "relapse": "heal",
  "relapsing": "heal",
  "relate": "smart",
  "related": "smart",
  "relation": "story",
  "relative": "heal",
  "relativise": "smart",
  "relativism": "smart",
  "relativity": "smart",
  "relativize": "smart",
  "relatum": "story",
  "relax": "heal",
  "relaxant": "build",
  "relaxation": "smart",
  "relaxed": "heal",
  "relaxin": "heal",
  "relaxing": "heal",
  "relearn": "smart",
  "release": "build",
  "relegate": "sell",
  "relegating": "sell",
  "relevant": "beautiful",
  "reliable": "beautiful",
  "reliance": "smart",
  "relic": "build",
  "relict": "heal",
  "relief": "sell",
  "relieve": "heal",
  "relievo": "build",
  "religion": "smart",
  "religionism": "smart",
  "religious": "beautiful",
  "reline": "build",
  "relinquish": "sell",
  "relinquishing": "story",
  "relinquishment": "story",
  "reliquary": "build",
  "relish": "taste",
  "relive": "smart",
  "reliving": "smart",
  "reload": "build",
  "reluctance": "sound",
  "rely": "smart",
  "relyric": "build",
  "rem": "smart",
  "remainder": "smart",
  "remains": "heal",
  "remake": "build",
  "remaking": "build",
  "remand": "story",
  "remark": "story",
  "remarry": "sell",
  "remediable": "beautiful",
  "remedy": "build",
  "remember": "smart",
  "remembering": "smart",
  "remembrance": "smart",
  "remicade": "build",
  "remilegia": "heal",
  "remind": "smart",
  "reminder": "story",
  "reminisce": "smart",
  "reminiscence": "smart",
  "remise": "build",
  "remission": "heal",
  "remit": "smart",
  "remitment": "sell",
  "remittal": "sell",
  "remittance": "sell",
  "remnant": "build",
  "remodel": "build",
  "remold": "build",
  "remonstrance": "story",
  "remonstrate": "story",
  "remonstration": "story",
  "remora": "heal",
  "remote": "build",
  "remote-controlled": "beautiful",
  "remould": "build",
  "remount": "heal",
  "removable": "beautiful",
  "remove": "sell",
  "remunerate": "sell",
  "remuneration": "sell",
  "rename": "story",
  "rend": "build",
  "render": "smart",
  "render-set": "build",
  "rendering": "smart",
  "rendezvous": "sell",
  "rendition": "story",
  "renegade": "sell",
  "renege": "story",
  "renegociate": "story",
  "renegotiate": "story",
  "renew": "build",
  "renewable": "beautiful",
  "renewal": "smart",
  "renounce": "sell",
  "renouncement": "story",
  "renovate": "heal",
  "rent": "sell",
  "rent-a-car": "sell",
  "rent-rebate": "sell",
  "rent-roll": "story",
  "rentable": "beautiful",
  "rental": "sell",
  "rente": "sell",
  "renting": "sell",
  "renunciation": "story",
  "reopen": "build",
  "reorder": "story",
  "reordering": "smart",
  "reorganise": "sell",
  "reorganize": "sell",
  "reorient": "sound",
  "reorientate": "sound",
  "reorientation": "smart",
  "reoviridae": "heal",
  "reovirus": "heal",
  "rep": "build",
  "repaint": "build",
  "reparable": "beautiful",
  "reparation": "sell",
  "repartee": "story",
  "repast": "taste",
  "repatriate": "sell",
  "repay": "sell",
  "repayment": "sell",
  "repeal": "story",
  "repeat": "story",
  "repeatable": "beautiful",
  "repeater": "build",
  "repeating": "story",
  "repel": "build",
  "repellant": "beautiful",
  "repellent": "beautiful",
  "repentant": "beautiful",
  "repercussion": "sound",
  "repertory": "build",
  "repetition": "story",
  "repetitious": "beautiful",
  "repetitiousness": "story",
  "repetitive": "beautiful",
  "repetitiveness": "story",
  "rephrase": "story",
  "rephrasing": "story",
  "repine": "story",
  "replace": "sell",
  "replaceable": "beautiful",
  "replacement": "smart",
  "replacing": "sell",
  "replant": "build",
  "replay": "build",
  "replenishment": "smart",
  "replete": "taste",
  "replica": "build",
  "replicate": "build",
  "replication": "smart",
  "reply": "story",
  "report": "story",
  "reportable": "beautiful",
  "reportage": "story",
  "reported": "story",
  "reporting": "story",
  "repose": "taste",
  "reposeful": "beautiful",
  "reposit": "sell",
  "repositing": "sell",
  "reposition": "build",
  "repositioning": "build",
  "repository": "smart",
  "repossess": "sell",
  "repot": "build",
  "repp": "build",
  "reprehend": "story",
  "reprehension": "story",
  "represent": "story",
  "representation": "smart",
  "representational": "beautiful",
  "representative": "smart",
  "represented": "story",
  "repress": "sell",
  "repression": "smart",
  "reprieve": "story",
  "reprimand": "story",
  "reprint": "story",
  "reprinting": "story",
  "reprise": "build",
  "reprize": "build",
  "reproach": "story",
  "reprobate": "smart",
  "reprobation": "smart",
  "reprocess": "taste",
  "reproduce": "build",
  "reproducer": "build",
  "reproducible": "beautiful",
  "reproduction": "smart",
  "reproof": "story",
  "reproval": "story",
  "reprove": "story",
  "reptantia": "heal",
  "reptile": "heal",
  "reptilia": "heal",
  "reptilian": "heal",
  "republicanism": "smart",
  "republication": "story",
  "republish": "build",
  "republishing": "build",
  "repudiate": "story",
  "repudiation": "story",
  "repugn": "story",
  "repulse": "story",
  "repulsion": "sound",
  "repulsive": "beautiful",
  "repurchase": "sell",
  "reputable": "beautiful",
  "reputation": "smart",
  "repute": "smart",
  "request": "story",
  "requested": "story",
  "requiem": "story",
  "requiescat": "story",
  "require": "story",
  "requirement": "smart",
  "requisite": "beautiful",
  "requisition": "story",
  "requital": "sell",
  "requite": "sell",
  "reread": "smart",
  "rerebrace": "build",
  "reredos": "build",
  "rerun": "story",
  "res": "heal",
  "reschedule": "story",
  "rescind": "story",
  "rescript": "story",
  "rescriptor": "build",
  "rescue": "sell",
  "reseal": "build",
  "research": "smart",
  "reseat": "sell",
  "reseau": "build",
  "resect": "build",
  "reseda": "heal",
  "resedaceae": "heal",
  "reseed": "build",
  "resell": "sell",
  "resentful": "beautiful",
  "reserpine": "build",
  "reservation": "story",
  "reserve": "sell",
  "reserved": "sell",
  "reserves": "sell",
  "reservoir": "smart",
  "reset": "build",
  "resew": "build",
  "resh": "story",
  "reshape": "smart",
  "reship": "build",
  "reshoot": "story",
  "reshuffle": "build",
  "reshuffling": "build",
  "resid": "taste",
  "residence": "build",
  "resident": "beautiful",
  "residential": "beautiful",
  "residual": "sell",
  "resift": "build",
  "resign": "sell",
  "resignation": "story",
  "resile": "sell",
  "resinate": "sound",
  "resinated": "sound",
  "resist": "sell",
  "resistance": "sound",
  "resistible": "beautiful",
  "resistive": "beautiful",
  "resistivity": "sound",
  "resistless": "beautiful",
  "resistor": "smart",
  "resmudge": "build",
  "resolute": "beautiful",
  "resolution": "story",
  "resolve": "story",
  "resolved": "smart",
  "resolving": "smart",
  "resonance": "sound",
  "resonate": "sound",
  "resonator": "build",
  "resorb": "build",
  "resorption": "smart",
  "resound": "sound",
  "resource": "sell",
  "resourcefulness": "smart",
  "respect": "smart",
  "respectable": "beautiful",
  "respectful": "beautiful",
  "respects": "story",
  "respirator": "build",
  "respire": "heal",
  "respite": "sound",
  "respond": "smart",
  "respondent": "beautiful",
  "response": "sound",
  "responsible": "beautiful",
  "responsive": "beautiful",
  "responsiveness": "smart",
  "rest-harrow": "heal",
  "restate": "story",
  "restatement": "story",
  "restaurant": "taste",
  "rested": "build",
  "restful": "beautiful",
  "restharrow": "heal",
  "restitute": "sell",
  "restitution": "sell",
  "restless": "beautiful",
  "restock": "sell",
  "restorative": "build",
  "restore": "sell",
  "restoril": "build",
  "restrain": "sell",
  "restrained": "sell",
  "restraint": "smart",
  "restrict": "sell",
  "restricted": "sell",
  "restriction": "smart",
  "restrictive": "beautiful",
  "restroom": "build",
  "resubmit": "sell",
  "result": "sound",
  "resultant": "smart",
  "resume": "story",
  "resurface": "build",
  "resurrect": "heal",
  "resuscitate": "heal",
  "resuscitator": "build",
  "retail": "sell",
  "retailing": "sell",
  "retain": "sell",
  "retainer": "sell",
  "retake": "sell",
  "retaking": "sell",
  "retama": "heal",
  "retardation": "smart",
  "retch": "heal",
  "rete": "heal",
  "retell": "build",
  "retem": "heal",
  "retention": "smart",
  "retentive": "beautiful",
  "retentiveness": "smart",
  "retentivity": "smart",
  "rethink": "smart",
  "retick": "build",
  "reticle": "build",
  "reticular": "beautiful",
  "reticulate": "sell",
  "reticulation": "smart",
  "reticule": "build",
  "reticulitermes": "heal",
  "reticulocyte": "heal",
  "reticulum": "heal",
  "retie": "build",
  "retina": "heal",
  "retinal": "beautiful",
  "retinene": "beautiful",
  "retinol": "sound",
  "retire": "sell",
  "retool": "sell",
  "retort": "story",
  "retrace": "smart",
  "retract": "story",
  "retractile": "beautiful",
  "retraction": "story",
  "retractor": "build",
  "retrain": "smart",
  "retraining": "smart",
  "retranslate": "story",
  "retread": "build",
  "retreat": "story",
  "retrench": "sell",
  "retrenchment": "build",
  "retribution": "sell",
  "retrieval": "smart",
  "retrieve": "sell",
  "retriever": "heal",
  "retro": "smart",
  "retroactive": "beautiful",
  "retrofit": "build",
  "retroflection": "story",
  "retroflex": "story",
  "retroflexion": "story",
  "retrograde": "story",
  "retrogress": "heal",
  "retronym": "story",
  "retrophyllum": "heal",
  "retrorocket": "build",
  "retrorse": "beautiful",
  "retrospect": "smart",
  "retrospection": "story",
  "retrospective": "beautiful",
  "retroversion": "story",
  "retrovir": "build",
  "retrovirus": "heal",
  "retrovision": "smart",
  "retry": "sell",
  "retsina": "taste",
  "return": "story",
  "returnable": "beautiful",
  "reuben": "taste",
  "reunify": "sell",
  "reunite": "sell",
  "reuptake": "smart",
  "reuse": "taste",
  "revaluation": "smart",
  "reveal": "sound",
  "revealing": "story",
  "reveille": "story",
  "revel": "taste",
  "revelation": "story",
  "revenant": "beautiful",
  "revenue": "sell",
  "reverberant": "beautiful",
  "reverberate": "sound",
  "reverberation": "sound",
  "revere": "build",
  "reverence": "smart",
  "reverend": "story",
  "reverent": "beautiful",
  "reverie": "smart",
  "revers": "build",
  "reversal": "smart",
  "reverse": "build",
  "reversible": "build",
  "reversion": "sell",
  "reverting": "beautiful",
  "revery": "smart",
  "revet": "build",
  "revetement": "build",
  "revetment": "build",
  "review": "smart",
  "revile": "story",
  "revilement": "story",
  "revisal": "story",
  "revise": "story",
  "revising": "story",
  "revision": "story",
  "revitalize": "heal",
  "revivalism": "smart",
  "revive": "heal",
  "revived": "heal",
  "revivify": "heal",
  "revocable": "beautiful",
  "revokable": "beautiful",
  "revoke": "story",
  "revolt": "sell",
  "revolutionary": "beautiful",
  "revolutionise": "smart",
  "revolutionism": "smart",
  "revolutionize": "sell",
  "revolver": "build",
  "revue": "story",
  "rewa-rewa": "heal",
  "reward": "sell",
  "rewarding": "sell",
  "rewire": "sell",
  "reword": "story",
  "rewording": "story",
  "rework": "build",
  "rewrite": "story",
  "rewriting": "story",
  "reynard": "heal",
  "rfd": "story",
  "rh-negative": "beautiful",
  "rh-positive": "beautiful",
  "rhabdomancy": "smart",
  "rhabdoviridae": "heal",
  "rhabdovirus": "heal",
  "rhaeto-romance": "story",
  "rhaeto-romanic": "story",
  "rhagoletis": "heal",
  "rhamnaceae": "heal",
  "rhamnales": "heal",
  "rhamnus": "heal",
  "rhaphe": "heal",
  "rhapis": "heal",
  "rhapsodise": "story",
  "rhapsodize": "story",
  "rhapsody": "story",
  "rhea": "heal",
  "rheidae": "heal",
  "rheiformes": "heal",
  "rhenish": "taste",
  "rheology": "smart",
  "rheometer": "build",
  "rheostat": "build",
  "rhesus": "heal",
  "rhetoric": "story",
  "rhetorical": "beautiful",
  "rheum": "heal",
  "rheumatic": "beautiful",
  "rheumatology": "smart",
  "rhexia": "heal",
  "rhincodon": "heal",
  "rhincodontidae": "heal",
  "rhinencephalon": "heal",
  "rhinion": "heal",
  "rhino": "heal",
  "rhinobatidae": "heal",
  "rhinoceros": "heal",
  "rhinocerotidae": "heal",
  "rhinolaryngology": "smart",
  "rhinolophidae": "heal",
  "rhinonicteris": "heal",
  "rhinoptera": "heal",
  "rhinoscope": "build",
  "rhinotermitidae": "heal",
  "rhinovirus": "heal",
  "rhipsalis": "heal",
  "rhiptoglossa": "heal",
  "rhizobiaceae": "heal",
  "rhizobium": "heal",
  "rhizoctinia": "heal",
  "rhizoid": "heal",
  "rhizome": "heal",
  "rhizomorph": "heal",
  "rhizophora": "heal",
  "rhizophoraceae": "heal",
  "rhizopod": "heal",
  "rhizopoda": "heal",
  "rhizopodan": "heal",
  "rhizopogon": "heal",
  "rhizopogonaceae": "heal",
  "rhizopus": "heal",
  "rho": "story",
  "rhodanthe": "heal",
  "rhododendron": "heal",
  "rhodomontade": "story",
  "rhodophyceae": "heal",
  "rhodophyta": "heal",
  "rhodopsin": "beautiful",
  "rhodosphaera": "heal",
  "rhodymenia": "heal",
  "rhodymeniaceae": "heal",
  "rhoeadales": "heal",
  "rhombencephalon": "heal",
  "rhomboid": "heal",
  "rhubarb": "taste",
  "rhumba": "story",
  "rhus": "heal",
  "rhyacotriton": "heal",
  "rhyme": "story",
  "rhymed": "build",
  "rhymeless": "beautiful",
  "rhyming": "build",
  "rhynchocephalia": "heal",
  "rhynchoelaps": "heal",
  "rhyncostylis": "heal",
  "rhynia": "heal",
  "rhyniaceae": "heal",
  "rhythm": "sound",
  "rhythmic": "sound",
  "rhythmical": "sound",
  "rhythmicity": "sound",
  "rial": "smart",
  "riata": "build",
  "rib": "build",
  "ribald": "beautiful",
  "ribaldry": "story",
  "riband": "build",
  "ribavirin": "build",
  "ribband": "build",
  "ribbed": "build",
  "ribbing": "build",
  "ribbon": "story",
  "ribbonfish": "heal",
  "ribbonwood": "heal",
  "ribes": "heal",
  "ribgrass": "heal",
  "ribier": "taste",
  "ribless": "beautiful",
  "ribosome": "heal",
  "ribwort": "heal",
  "rice": "taste",
  "ricebird": "heal",
  "ricegrass": "heal",
  "ricer": "build",
  "rich": "beautiful",
  "richea": "heal",
  "riches": "sell",
  "richmondena": "heal",
  "richweed": "heal",
  "ricinus": "heal",
  "rick": "build",
  "rickettsia": "heal",
  "rickettsiaceae": "heal",
  "rickettsiales": "heal",
  "rickey": "taste",
  "rickrack": "build",
  "ricksha": "build",
  "rickshaw": "build",
  "rico": "story",
  "ricotta": "taste",
  "ricrac": "build",
  "rictus": "story",
  "rid": "sell",
  "riddle": "story",
  "ride": "build",
  "rider": "story",
  "ridged": "build",
  "ridgel": "heal",
  "ridgeling": "heal",
  "ridgepole": "build",
  "ridgil": "heal",
  "ridgling": "heal",
  "ridicule": "story",
  "ridiculousness": "story",
  "ridley": "heal",
  "riel": "smart",
  "riesling": "heal",
  "rifadin": "build",
  "rifampin": "build",
  "riff": "story",
  "riffle": "build",
  "rifle": "build",
  "riflebird": "heal",
  "rifled": "sell",
  "rifling": "sell",
  "rig": "build",
  "rig-veda": "story",
  "rigamarole": "story",
  "rigatoni": "taste",
  "rigged": "sell",
  "rigger": "build",
  "rigging": "smart",
  "right": "build",
  "right-handed": "beautiful",
  "righteous": "beautiful",
  "rightfield": "build",
  "rightism": "smart",
  "rightist": "beautiful",
  "rigid": "beautiful",
  "rigidification": "smart",
  "rigidifying": "smart",
  "rigmarole": "story",
  "rigout": "build",
  "rijstafel": "taste",
  "rijstaffel": "taste",
  "rijsttaffel": "taste",
  "riksmaal": "story",
  "riksmal": "story",
  "rile": "build",
  "rilievo": "build",
  "rim": "build",
  "rima": "heal",
  "rimactane": "build",
  "rime": "story",
  "rimeless": "beautiful",
  "riming": "build",
  "rimless": "beautiful",
  "rimmed": "sell",
  "rimu": "heal",
  "rind": "taste",
  "ring": "build",
  "ring-binder": "build",
  "ringdove": "heal",
  "ringgit": "smart",
  "ringhals": "heal",
  "ringing": "story",
  "ringlet": "heal",
  "rings": "build",
  "ringside": "build",
  "ringtail": "heal",
  "ringway": "build",
  "rink": "build",
  "rinkhals": "heal",
  "rinsing": "build",
  "rioja": "taste",
  "riot": "story",
  "rioting": "sell",
  "riparia": "heal",
  "ripcord": "build",
  "ripe": "beautiful",
  "ripening": "smart",
  "riposte": "story",
  "ripple": "sound",
  "ripple-grass": "heal",
  "rippling": "sound",
  "ripsaw": "build",
  "riser": "build",
  "risotto": "taste",
  "rissa": "heal",
  "rissole": "taste",
  "ritalin": "build",
  "ritonavir": "build",
  "ritualism": "smart",
  "ritz": "story",
  "rive": "build",
  "rivet": "build",
  "riveter": "build",
  "rivetter": "build",
  "rivina": "heal",
  "rivulus": "heal",
  "riyal": "smart",
  "riyal-omani": "smart",
  "roach": "heal",
  "road": "build",
  "roadbed": "build",
  "roadblock": "smart",
  "roadbook": "story",
  "roadhouse": "build",
  "roadkill": "heal",
  "roadrunner": "heal",
  "roads": "build",
  "roadside": "build",
  "roadster": "build",
  "roadway": "build",
  "roan": "heal",
  "roar": "story",
  "roaring": "story",
  "roast": "taste",
  "roaster": "taste",
  "roasting": "taste",
  "rob": "sell",
  "robalo": "heal",
  "robaxin": "build",
  "robe": "build",
  "robe-de-chambre": "build",
  "robin": "heal",
  "robinia": "heal",
  "robitussin": "build",
  "roble": "heal",
  "robot": "smart",
  "robotic": "smart",
  "robotics": "smart",
  "robust": "beautiful",
  "rocambole": "heal",
  "roccella": "heal",
  "roccellaceae": "heal",
  "roccus": "heal",
  "rocephin": "build",
  "rock'n'roll": "story",
  "rock-and-roll": "story",
  "rockabilly": "story",
  "rockchuck": "heal",
  "rockcress": "heal",
  "rocker": "build",
  "rockery": "build",
  "rocket": "build",
  "rocketry": "smart",
  "rockfish": "taste",
  "rockfoil": "heal",
  "rockrose": "heal",
  "rockweed": "heal",
  "rocky": "beautiful",
  "rococo": "beautiful",
  "rod": "build",
  "rodent": "heal",
  "rodentia": "heal",
  "rodeo": "build",
  "rodolia": "heal",
  "rodomontade": "story",
  "roe": "taste",
  "roebuck": "heal",
  "roentgen": "smart",
  "roentgenogram": "build",
  "roentgenoscope": "build",
  "rofecoxib": "build",
  "rogaine": "build",
  "rogation": "story",
  "rohypnol": "build",
  "roil": "build",
  "roister": "sell",
  "role": "smart",
  "roleplay": "build",
  "roleplaying": "build",
  "roll": "story",
  "roll-on": "build",
  "roller": "build",
  "rollerblade": "build",
  "rollmops": "taste",
  "rolodex": "build",
  "roly-poly": "taste",
  "rom": "build",
  "roma": "build",
  "romaic": "story",
  "romaine": "taste",
  "roman": "story",
  "romanal": "story",
  "romance": "story",
  "romanesque": "smart",
  "romanian": "story",
  "romanise": "story",
  "romanism": "smart",
  "romanize": "story",
  "romans": "story",
  "romansh": "story",
  "romantic": "beautiful",
  "romanticise": "smart",
  "romanticism": "smart",
  "romanticize": "smart",
  "romany": "story",
  "romneya": "heal",
  "romper": "build",
  "ron": "story",
  "rondeau": "story",
  "rondel": "story",
  "rondelet": "story",
  "rondo": "story",
  "roneo": "build",
  "roneograph": "build",
  "rood": "build",
  "rood-tree": "build",
  "roof": "build",
  "roofed": "build",
  "roofing": "build",
  "roofless": "beautiful",
  "rooftree": "build",
  "roofy": "build",
  "rooibos": "heal",
  "rook": "build",
  "room": "build",
  "roomette": "build",
  "roomful": "smart",
  "roominess": "smart",
  "rooms": "build",
  "roomy": "beautiful",
  "roost": "build",
  "rooster": "heal",
  "root": "heal",
  "rootage": "heal",
  "rooting": "smart",
  "rootle": "build",
  "rootlet": "heal",
  "roots": "heal",
  "rootstalk": "heal",
  "rootstock": "heal",
  "rope": "build",
  "ropebark": "heal",
  "ropewalk": "build",
  "ropeway": "build",
  "ropey": "beautiful",
  "rophy": "build",
  "roping": "build",
  "ropy": "beautiful",
  "roquefort": "taste",
  "roquette": "heal",
  "roridula": "heal",
  "roridulaceae": "heal",
  "rorippa": "heal",
  "rorqual": "heal",
  "rosa": "heal",
  "rosaceae": "heal",
  "rosaceous": "beautiful",
  "rosales": "heal",
  "rosary": "build",
  "rose": "heal",
  "rose-root": "heal",
  "rosebay": "heal",
  "rosebud": "heal",
  "rosebush": "heal",
  "rosefish": "taste",
  "rosehip": "heal",
  "roselle": "heal",
  "rosellinia": "heal",
  "rosemaling": "build",
  "rosemary": "heal",
  "rosette": "build",
  "rosewood": "heal",
  "rosicrucianism": "smart",
  "rosidae": "heal",
  "rosilla": "heal",
  "rosin": "build",
  "rosinweed": "heal",
  "rosita": "heal",
  "rosmarinus": "heal",
  "roster": "story",
  "rostrum": "build",
  "rot": "smart",
  "rota": "story",
  "rotary": "build",
  "rotate": "sell",
  "rotavirus": "heal",
  "rote": "smart",
  "rotgut": "taste",
  "rotifer": "heal",
  "rotifera": "heal",
  "rotisserie": "taste",
  "rotl": "smart",
  "rotogravure": "story",
  "rotor": "build",
  "rotting": "smart",
  "rottweiler": "heal",
  "rotunda": "build",
  "rotundity": "story",
  "rouble": "smart",
  "rouge": "build",
  "rougeberry": "heal",
  "rough": "build",
  "rough-and-tumble": "beautiful",
  "rough-hew": "build",
  "rough-house": "sell",
  "rough-sand": "build",
  "roughage": "taste",
  "roughcast": "build",
  "roughen": "build",
  "roughhouse": "smart",
  "roughleg": "heal",
  "roulade": "taste",
  "rouleau": "build",
  "roulette": "build",
  "round": "build",
  "roundabout": "build",
  "rounded": "story",
  "roundel": "story",
  "roundelay": "story",
  "rounder": "build",
  "rounders": "build",
  "roundhouse": "build",
  "rounding": "story",
  "roundness": "story",
  "roundtable": "story",
  "roundup": "story",
  "roundworm": "heal",
  "rous": "heal",
  "rouse": "heal",
  "rout": "build",
  "route": "build",
  "router": "build",
  "routine": "story",
  "roux": "taste",
  "rove": "build",
  "roving": "beautiful",
  "row": "story",
  "rowan": "heal",
  "rowanberry": "heal",
  "rowboat": "build",
  "rowdy": "beautiful",
  "rowel": "build",
  "rowlock": "build",
  "royal": "build",
  "royalty": "sell",
  "roystonea": "heal",
  "rozelle": "heal",
  "rub": "smart",
  "rubato": "sound",
  "rubber": "build",
  "rubberneck": "sound",
  "rubberstamp": "build",
  "rubbing": "sound",
  "rubbish": "story",
  "rubefacient": "build",
  "rubel": "smart",
  "rubia": "heal",
  "rubiaceae": "heal",
  "rubiales": "heal",
  "rubicon": "smart",
  "ruble": "smart",
  "rubric": "story",
  "rubricate": "sell",
  "rubus": "heal",
  "ruby": "sell",
  "ruck": "build",
  "ruckle": "sound",
  "rucksack": "build",
  "rudapithecus": "heal",
  "rudbeckia": "heal",
  "rudd": "heal",
  "rudder": "build",
  "rudderfish": "heal",
  "rudderpost": "build",
  "rudderstock": "build",
  "ruddle": "build",
  "ruddles": "heal",
  "rude": "beautiful",
  "rudiment": "smart",
  "rudiments": "story",
  "rue": "heal",
  "ruff": "heal",
  "ruffle": "build",
  "rug": "build",
  "ruga": "heal",
  "rugelach": "taste",
  "rugged": "beautiful",
  "ruggelach": "taste",
  "rugulah": "taste",
  "ruin": "build",
  "ruining": "build",
  "rule": "smart",
  "ruler": "build",
  "ruling": "sell",
  "rum": "taste",
  "rumanian": "story",
  "rumansh": "story",
  "rumba": "story",
  "rumble": "build",
  "rumbling": "sound",
  "rumen": "heal",
  "rumex": "heal",
  "ruminant": "heal",
  "ruminantia": "heal",
  "ruminate": "taste",
  "rumination": "smart",
  "rummage": "build",
  "rummer": "build",
  "rummy": "beautiful",
  "rumohra": "heal",
  "rumor": "story",
  "rumour": "story",
  "rump": "heal",
  "rumple": "build",
  "rumpus": "sell",
  "run-in": "story",
  "run-on": "beautiful",
  "runabout": "build",
  "runaway": "beautiful",
  "runch": "heal",
  "rundle": "build",
  "rundown": "story",
  "rune": "story",
  "rung": "build",
  "runway": "beautiful",
  "rupee": "smart",
  "rupiah": "smart",
  "rupicapra": "heal",
  "rupicola": "heal",
  "ruptiliocarpon": "heal",
  "rupture": "build",
  "rupturewort": "heal",
  "rural": "beautiful",
  "ruralism": "story",
  "ruritania": "smart",
  "ruscaceae": "heal",
  "ruscus": "heal",
  "rush": "heal",
  "rush-grass": "heal",
  "rushlight": "build",
  "rusk": "taste",
  "russet": "build",
  "russian": "story",
  "russula": "heal",
  "russulaceae": "heal",
  "rust": "smart",
  "rusted": "beautiful",
  "rustic": "beautiful",
  "rusticate": "sell",
  "rustication": "build",
  "rusticism": "story",
  "rustiness": "smart",
  "rusting": "smart",
  "rustle": "sound",
  "rustless": "beautiful",
  "rustling": "sound",
  "ruta": "heal",
  "rutabaga": "taste",
  "rutaceae": "heal",
  "ruth": "story",
  "rutherford": "smart",
  "rutherfordium": "sound",
  "rutilus": "heal",
  "rya": "build",
  "rydberg": "smart",
  "rye": "heal",
  "ryegrass": "heal",
  "rynchopidae": "heal",
  "rynchops": "heal",
  "rypticus": "heal",
  "ryukyuan": "story",
  "s.t.p.": "smart",
  "s.u.v.": "build",
  "saame": "story",
  "saami": "story",
  "sabal": "heal",
  "sabaton": "build",
  "sabayon": "taste",
  "sabbatia": "heal",
  "sabellian": "story",
  "saber": "build",
  "sabertooth": "heal",
  "sabicu": "heal",
  "sabin": "smart",
  "sabinea": "heal",
  "sable": "build",
  "sabot": "build",
  "sabotage": "sell",
  "sabre": "build",
  "sac": "heal",
  "saccharify": "sound",
  "saccharin": "taste",
  "saccharomyces": "heal",
  "saccharomycetaceae": "heal",
  "saccharum": "heal",
  "saccule": "heal",
  "sacculus": "heal",
  "sacerdotalism": "smart",
  "sachet": "build",
  "sack": "build",
  "sackbut": "build",
  "sackcloth": "build",
  "sackful": "smart",
  "sacking": "build",
  "sacque": "build",
  "sacral": "beautiful",
  "sacred": "beautiful",
  "sacrifice": "sell",
  "sacristy": "build",
  "sacrum": "heal",
  "sad": "beautiful",
  "saddle": "build",
  "saddleback": "build",
  "saddlebag": "build",
  "saddlebill": "heal",
  "saddlebow": "build",
  "saddlecloth": "build",
  "saddled": "build",
  "saddlery": "build",
  "sadhe": "story",
  "sadistic": "beautiful",
  "sadleria": "heal",
  "saek": "story",
  "safe": "build",
  "safe-conduct": "story",
  "safe-deposit": "build",
  "safeguard": "story",
  "safehold": "build",
  "safety": "build",
  "safety-deposit": "build",
  "safflower": "heal",
  "saffron": "heal",
  "saga": "story",
  "sagaciousness": "smart",
  "sagacity": "smart",
  "sage": "taste",
  "sagebrush": "heal",
  "sagina": "heal",
  "sagitta": "heal",
  "sagittaria": "heal",
  "sagittariidae": "heal",
  "sagittarius": "heal",
  "sagittate-leaf": "heal",
  "saguaro": "heal",
  "sahaptin": "story",
  "saharan": "story",
  "sahuaro": "heal",
  "saiga": "heal",
  "sail": "build",
  "sailboat": "build",
  "sailcloth": "build",
  "sailfish": "taste",
  "sailor": "build",
  "sailor's-choice": "heal",
  "sailplane": "build",
  "saimiri": "heal",
  "sainfoin": "heal",
  "saint-bernard's-lily": "heal",
  "saint-john's-bread": "taste",
  "saintpaulia": "heal",
  "sake": "taste",
  "saki": "taste",
  "saktism": "smart",
  "salaah": "smart",
  "salaam": "story",
  "salaat": "smart",
  "salable": "beautiful",
  "salad": "taste",
  "salade": "build",
  "salafism": "smart",
  "salah": "smart",
  "salai": "heal",
  "salal": "heal",
  "salamander": "heal",
  "salamandra": "heal",
  "salamandridae": "heal",
  "salami": "taste",
  "salaried": "beautiful",
  "salary": "sell",
  "salat": "smart",
  "saleable": "beautiful",
  "saleroom": "build",
  "sales": "sell",
  "salesmanship": "smart",
  "salesroom": "build",
  "salicaceae": "heal",
  "salicales": "heal",
  "salicornia": "heal",
  "salient": "beautiful",
  "salientia": "heal",
  "salientian": "heal",
  "saline": "beautiful",
  "salinity": "smart",
  "salinometer": "build",
  "salish": "story",
  "salishan": "story",
  "saliva": "heal",
  "salivate": "heal",
  "salivation": "smart",
  "salix": "heal",
  "sallet": "build",
  "sallow": "heal",
  "sally": "story",
  "salmagundi": "taste",
  "salmi": "taste",
  "salmo": "heal",
  "salmon": "taste",
  "salmonberry": "heal",
  "salmonella": "heal",
  "salmonid": "heal",
  "salmonidae": "heal",
  "salmwood": "heal",
  "salon": "build",
  "saloon": "build",
  "salp": "heal",
  "salpa": "heal",
  "salpichroa": "heal",
  "salpidae": "heal",
  "salpiglossis": "heal",
  "salpinctes": "heal",
  "salpinx": "heal",
  "salsa": "taste",
  "salsify": "heal",
  "salsilla": "heal",
  "salsola": "heal",
  "salt": "taste",
  "saltation": "smart",
  "saltbox": "build",
  "saltbush": "heal",
  "saltcellar": "build",
  "saltine": "taste",
  "saltiness": "story",
  "salting": "sound",
  "saltire": "build",
  "saltshaker": "build",
  "saltworks": "build",
  "saltwort": "heal",
  "salty": "beautiful",
  "saluki": "heal",
  "salutation": "story",
  "salutatory": "story",
  "salute": "story",
  "salvadora": "heal",
  "salvadoraceae": "heal",
  "salvage": "sell",
  "salve": "build",
  "salvelinus": "heal",
  "salver": "build",
  "salvia": "heal",
  "salvinia": "heal",
  "salviniaceae": "heal",
  "salvinorin": "build",
  "salvo": "story",
  "salwar": "build",
  "salyut": "build",
  "sam": "build",
  "sama-veda": "story",
  "saman": "heal",
  "samara": "heal",
  "samba": "sound",
  "sambar": "heal",
  "sambuca": "taste",
  "sambucus": "heal",
  "sambur": "heal",
  "same": "story",
  "samekh": "story",
  "samhita": "story",
  "sami": "story",
  "samia": "heal",
  "samiel": "sound",
  "samisen": "build",
  "samite": "build",
  "samizdat": "story",
  "samolus": "heal",
  "samosa": "taste",
  "samovar": "build",
  "samoyed": "story",
  "samoyede": "heal",
  "samoyedic": "story",
  "sampan": "build",
  "samphire": "heal",
  "sample": "smart",
  "sampler": "build",
  "sampling": "smart",
  "sanatarium": "build",
  "sanatorium": "build",
  "sanctify": "story",
  "sanction": "story",
  "sanctuary": "build",
  "sand": "build",
  "sandal": "build",
  "sandalwood": "heal",
  "sandarac": "heal",
  "sandarach": "heal",
  "sandbag": "build",
  "sandberry": "heal",
  "sandblast": "sound",
  "sandblaster": "build",
  "sandbox": "build",
  "sandbur": "heal",
  "sander": "build",
  "sanderling": "heal",
  "sandfish": "heal",
  "sandfly": "heal",
  "sandglass": "build",
  "sandgrouse": "heal",
  "sandhi": "story",
  "sandhopper": "heal",
  "sandlike": "beautiful",
  "sandpaper": "build",
  "sandpile": "build",
  "sandpiper": "heal",
  "sandpit": "build",
  "sandril": "build",
  "sandspur": "heal",
  "sandstorm": "sound",
  "sandwich": "taste",
  "sandwort": "heal",
  "sandy": "beautiful",
  "sane": "beautiful",
  "sanfoin": "heal",
  "sang": "heal",
  "sangaree": "taste",
  "sango": "story",
  "sangraal": "build",
  "sangria": "taste",
  "sanguification": "smart",
  "sanguinaria": "heal",
  "sanguine": "beautiful",
  "sanicle": "heal",
  "sanicula": "heal",
  "sanies": "heal",
  "sanitarium": "build",
  "sanitary": "beautiful",
  "sanitate": "sell",
  "sanitise": "build",
  "sanitised": "build",
  "sanitize": "build",
  "sanitized": "build",
  "sansevieria": "heal",
  "sanskrit": "story",
  "santalaceae": "heal",
  "santalales": "heal",
  "santalum": "heal",
  "santee": "story",
  "santims": "smart",
  "santolina": "heal",
  "sanvitalia": "heal",
  "sap": "build",
  "sapidity": "smart",
  "sapience": "smart",
  "sapindaceae": "heal",
  "sapindales": "heal",
  "sapindus": "heal",
  "sapling": "heal",
  "sapodilla": "heal",
  "saponaria": "heal",
  "saponification": "smart",
  "sapota": "taste",
  "sapotaceae": "heal",
  "sapote": "heal",
  "sapphire": "sell",
  "saprobe": "heal",
  "saprolegnia": "heal",
  "saprolegniales": "heal",
  "saprophyte": "heal",
  "saprophytic": "beautiful",
  "sapsago": "taste",
  "sapsucker": "heal",
  "sapwood": "heal",
  "saquinavir": "build",
  "saraband": "story",
  "sarafem": "build",
  "sarape": "build",
  "saratoga": "heal",
  "sarcasm": "story",
  "sarcastic": "beautiful",
  "sarcenet": "build",
  "sarcobatus": "heal",
  "sarcocephalus": "heal",
  "sarcochilus": "heal",
  "sarcocystidean": "heal",
  "sarcocystieian": "heal",
  "sarcocystis": "heal",
  "sarcodes": "heal",
  "sarcodina": "heal",
  "sarcodine": "heal",
  "sarcodinian": "heal",
  "sarcolemma": "heal",
  "sarcomere": "heal",
  "sarcophaga": "heal",
  "sarcophagus": "build",
  "sarcophilus": "heal",
  "sarcoplasm": "heal",
  "sarcoptes": "heal",
  "sarcoptid": "heal",
  "sarcoptidae": "heal",
  "sarcorhamphus": "heal",
  "sarcoscyphaceae": "heal",
  "sarcosomataceae": "heal",
  "sarcosome": "heal",
  "sarcosporidia": "heal",
  "sarcosporidian": "heal",
  "sarcostemma": "heal",
  "sarcostyle": "heal",
  "sarda": "heal",
  "sardina": "heal",
  "sardine": "taste",
  "sardinian": "story",
  "sardinops": "heal",
  "saree": "build",
  "sargasso": "heal",
  "sargassum": "heal",
  "sari": "build",
  "sarong": "build",
  "sarracenia": "heal",
  "sarraceniaceae": "heal",
  "sarraceniales": "heal",
  "sarsaparilla": "heal",
  "sarsenet": "build",
  "sartorius": "heal",
  "sash": "build",
  "sashimi": "taste",
  "saskatoon": "taste",
  "sass": "story",
  "sassaby": "heal",
  "sassafras": "heal",
  "sassing": "story",
  "sat": "build",
  "satang": "smart",
  "satanic": "beautiful",
  "satanism": "smart",
  "satchel": "build",
  "sate": "taste",
  "sateen": "build",
  "satellite": "build",
  "satiate": "taste",
  "satiated": "taste",
  "satin": "build",
  "satinet": "build",
  "satinette": "build",
  "satinleaf": "heal",
  "satinpod": "heal",
  "satinwood": "heal",
  "satire": "story",
  "satirise": "story",
  "satirize": "story",
  "satisfaction": "sell",
  "satisfactory": "beautiful",
  "satisfice": "sell",
  "satisfise": "sell",
  "satisfy": "taste",
  "satori": "smart",
  "satsuma": "heal",
  "saturated": "beautiful",
  "saturation": "beautiful",
  "satureia": "heal",
  "satureja": "heal",
  "saturnia": "heal",
  "saturniid": "heal",
  "saturniidae": "heal",
  "satyridae": "heal",
  "sauce": "taste",
  "sauce-alone": "heal",
  "sauceboat": "build",
  "saucepan": "build",
  "saucepot": "build",
  "saucer": "build",
  "sauerbraten": "taste",
  "sauerkraut": "taste",
  "sauna": "build",
  "saurel": "heal",
  "sauria": "heal",
  "saurian": "heal",
  "saurischia": "heal",
  "saurischian": "heal",
  "sauromalus": "heal",
  "sauropod": "heal",
  "sauropoda": "heal",
  "sauropodomorpha": "heal",
  "sauropterygia": "heal",
  "saurosuchus": "heal",
  "saururaceae": "heal",
  "saururus": "heal",
  "saury": "heal",
  "sausage": "taste",
  "saussurea": "heal",
  "saute": "taste",
  "sauterne": "taste",
  "sauternes": "taste",
  "savage": "story",
  "savara": "story",
  "savarin": "taste",
  "save": "sell",
  "save-all": "build",
  "saved": "sell",
  "saveloy": "taste",
  "savin": "heal",
  "saving": "sell",
  "savings": "sell",
  "savor": "taste",
  "savoring": "sound",
  "savory": "taste",
  "savour": "smart",
  "savouring": "sound",
  "savoury": "taste",
  "savoy": "taste",
  "savvy": "smart",
  "saw": "build",
  "sawbill": "heal",
  "sawbuck": "build",
  "sawfish": "heal",
  "sawfly": "heal",
  "sawhorse": "build",
  "sawm": "smart",
  "sawmill": "build",
  "sawtooth": "build",
  "sawwort": "heal",
  "sawyer": "heal",
  "sax": "sound",
  "saxe-gothea": "heal",
  "saxegothea": "heal",
  "saxhorn": "build",
  "saxicola": "heal",
  "saxifraga": "heal",
  "saxifragaceae": "heal",
  "saxifrage": "heal",
  "saxophone": "sound",
  "say": "story",
  "say-so": "story",
  "sayanci": "story",
  "saying": "story",
  "sayonara": "story",
  "sayornis": "heal",
  "sazerac": "taste",
  "scab": "heal",
  "scabbard": "build",
  "scabiosa": "heal",
  "scabious": "heal",
  "scad": "heal",
  "scads": "smart",
  "scaffold": "build",
  "scaffolding": "build",
  "scag": "build",
  "scalable": "beautiful",
  "scalar": "smart",
  "scald": "story",
  "scale": "heal",
  "scalenus": "heal",
  "scaler": "build",
  "scallion": "heal",
  "scallop": "taste",
  "scallopine": "taste",
  "scallopini": "taste",
  "scalp": "heal",
  "scalpel": "heal",
  "scam": "sell",
  "scammony": "heal",
  "scammonyroot": "heal",
  "scamp": "build",
  "scampi": "taste",
  "scampo": "taste",
  "scan": "build",
  "scandal": "story",
  "scandalmongering": "story",
  "scandentia": "heal",
  "scandinavian": "story",
  "scanner": "build",
  "scanning": "smart",
  "scansion": "story",
  "scant": "sell",
  "scantling": "build",
  "scanty": "build",
  "scape": "heal",
  "scaphiopus": "heal",
  "scaphopod": "heal",
  "scaphopoda": "heal",
  "scaphosepalum": "heal",
  "scapula": "heal",
  "scapular": "heal",
  "scapulary": "build",
  "scar": "build",
  "scarab": "heal",
  "scarabaean": "heal",
  "scarabaeid": "heal",
  "scarabaeidae": "heal",
  "scarabaeus": "heal",
  "scarce": "beautiful",
  "scardinius": "heal",
  "scarecrow": "build",
  "scarer": "build",
  "scarf": "build",
  "scarfpin": "build",
  "scaridae": "heal",
  "scarify": "build",
  "scarlet": "beautiful",
  "scarp": "build",
  "scartella": "heal",
  "scatology": "story",
  "scattergun": "build",
  "scattering": "smart",
  "scaup": "heal",
  "scauper": "build",
  "scavenge": "build",
  "scavenger": "heal",
  "scd": "story",
  "sceliphron": "heal",
  "sceloglaux": "heal",
  "sceloporus": "heal",
  "scenario": "story",
  "scenarist": "story",
  "scene": "smart",
  "scenery": "build",
  "scenic": "beautiful",
  "scent": "smart",
  "scented": "sound",
  "scentless": "beautiful",
  "scepter": "story",
  "scepticism": "smart",
  "sceptre": "story",
  "schaffneria": "heal",
  "schedule": "smart",
  "scheduled": "smart",
  "scheduler": "build",
  "scheduling": "smart",
  "schefflera": "heal",
  "schema": "smart",
  "schematic": "build",
  "schematize": "build",
  "scheme": "smart",
  "scheol": "smart",
  "scherzo": "story",
  "scheuchzeriaceae": "heal",
  "schilling": "smart",
  "schinus": "heal",
  "schipperke": "heal",
  "schistorrhachis": "heal",
  "schistosoma": "heal",
  "schistosomatidae": "heal",
  "schistosome": "heal",
  "schizachyrium": "heal",
  "schizaea": "heal",
  "schizaeaceae": "heal",
  "schizanthus": "heal",
  "schizocarp": "heal",
  "schizogony": "smart",
  "schizoid": "beautiful",
  "schizomycetes": "heal",
  "schizopetalon": "heal",
  "schizophragma": "heal",
  "schizophrenic": "beautiful",
  "schizophyceae": "heal",
  "schizophyta": "heal",
  "schizopoda": "heal",
  "schizosaccharomyces": "heal",
  "schizosaccharomycetaceae": "heal",
  "schleiden": "heal",
  "schlep": "build",
  "schlock": "build",
  "schlumbergera": "heal",
  "schmegegge": "story",
  "schmoose": "story",
  "schmooze": "story",
  "schnapps": "taste",
  "schnaps": "taste",
  "schnauzer": "heal",
  "schnecken": "taste",
  "schnittlaugh": "heal",
  "schnitzel": "taste",
  "schnorchel": "build",
  "schnorkel": "build",
  "schnorr": "sell",
  "schnoz": "heal",
  "schnozzle": "heal",
  "scholarly": "beautiful",
  "scholarship": "sell",
  "scholasticism": "smart",
  "scholia": "story",
  "scholium": "story",
  "schomburgkia": "heal",
  "school": "build",
  "schoolbag": "build",
  "schoolbook": "story",
  "schoolhouse": "build",
  "schooling": "smart",
  "schoolmaster": "heal",
  "schoolroom": "build",
  "schooner": "build",
  "schottische": "story",
  "schrod": "taste",
  "schtick": "smart",
  "schtickl": "smart",
  "schtik": "smart",
  "schtikl": "smart",
  "schwa": "story",
  "schwann": "heal",
  "sciadopityaceae": "heal",
  "sciadopitys": "heal",
  "sciaena": "heal",
  "sciaenid": "heal",
  "sciaenidae": "heal",
  "sciaenops": "heal",
  "sciara": "heal",
  "sciarid": "heal",
  "sciaridae": "heal",
  "science": "smart",
  "scientific": "beautiful",
  "scilla": "heal",
  "scimitar": "build",
  "scincella": "heal",
  "scincid": "heal",
  "scincidae": "heal",
  "scincus": "heal",
  "scindapsus": "heal",
  "scintilla": "smart",
  "scintillate": "sound",
  "scintillation": "sound",
  "scirpus": "heal",
  "scissor": "build",
  "scissors": "build",
  "scissortail": "heal",
  "sciuridae": "heal",
  "sciuromorpha": "heal",
  "sciurus": "heal",
  "sclaff": "build",
  "sclera": "heal",
  "scleranthus": "heal",
  "sclerite": "heal",
  "scleroderma": "heal",
  "sclerodermataceae": "heal",
  "sclerodermatales": "heal",
  "sclerometer": "build",
  "scleropages": "heal",
  "scleroparei": "heal",
  "sclerosis": "heal",
  "sclerotinia": "heal",
  "sclerotiniaceae": "heal",
  "sclerotium": "heal",
  "scoff": "story",
  "scoffing": "story",
  "scoke": "heal",
  "scold": "story",
  "scolding": "story",
  "scolion": "story",
  "scollop": "taste",
  "scolopacidae": "heal",
  "scolopax": "heal",
  "scolopendrium": "heal",
  "scolymus": "heal",
  "scolytidae": "heal",
  "scolytus": "heal",
  "scomber": "heal",
  "scomberesocidae": "heal",
  "scomberesox": "heal",
  "scomberomorus": "heal",
  "scombresocidae": "heal",
  "scombresox": "heal",
  "scombridae": "heal",
  "scombroid": "heal",
  "scombroidea": "heal",
  "sconce": "build",
  "scone": "taste",
  "scoop": "smart",
  "scoopful": "smart",
  "scooter": "build",
  "scope": "build",
  "scopes": "build",
  "scophthalmus": "heal",
  "scopolamine": "build",
  "scopolia": "heal",
  "scorcher": "sound",
  "score": "smart",
  "scoreboard": "build",
  "scorecard": "story",
  "scores": "smart",
  "scoring": "build",
  "scorn": "story",
  "scorpaena": "heal",
  "scorpaenid": "heal",
  "scorpaenidae": "heal",
  "scorpaenoid": "heal",
  "scorpaenoidea": "heal",
  "scorper": "build",
  "scorpion": "heal",
  "scorpionfish": "heal",
  "scorpionida": "heal",
  "scorpionweed": "heal",
  "scorzonera": "heal",
  "scotch": "taste",
  "scoter": "heal",
  "scots": "story",
  "scottie": "heal",
  "scottish": "story",
  "scour": "build",
  "scourge": "build",
  "scouring": "build",
  "scours": "build",
  "scouse": "taste",
  "scouting": "sound",
  "scow": "build",
  "scowl": "story",
  "scrabble": "build",
  "scrag": "taste",
  "scrambler": "build",
  "scranch": "story",
  "scrap": "build",
  "scrapbook": "build",
  "scrape": "story",
  "scraper": "build",
  "scraping": "story",
  "scrapple": "taste",
  "scraps": "build",
  "scratch": "sell",
  "scratcher": "build",
  "scratching": "build",
  "scratchpad": "build",
  "scraunch": "story",
  "scrawl": "story",
  "screak": "sound",
  "scream": "story",
  "screamer": "story",
  "screaming": "story",
  "screech": "story",
  "screeching": "story",
  "screed": "story",
  "screen": "build",
  "screening": "story",
  "screenplay": "story",
  "screenwriter": "story",
  "screw": "build",
  "screwball": "beautiful",
  "screwballer": "beautiful",
  "screwbean": "heal",
  "screwdriver": "build",
  "screwing": "build",
  "screwtop": "build",
  "scribble": "story",
  "scribe": "build",
  "scriber": "build",
  "scrim": "build",
  "scrimmage": "build",
  "scrimp": "sell",
  "scrimpy": "beautiful",
  "scrimshank": "sell",
  "scrimshaw": "build",
  "scrip": "sell",
  "script": "story",
  "scripted": "build",
  "scriptorium": "build",
  "scripture": "story",
  "scrod": "taste",
  "scroll": "story",
  "scrophularia": "heal",
  "scrophulariaceae": "heal",
  "scrophulariales": "heal",
  "scrotum": "heal",
  "scrounge": "sell",
  "scrub": "build",
  "scrub-bird": "heal",
  "scrubber": "build",
  "scrubbing": "build",
  "scrubbird": "heal",
  "scrubs": "build",
  "scruff": "heal",
  "scrumpy": "taste",
  "scrunch": "sound",
  "scruple": "smart",
  "scruples": "smart",
  "scrupulous": "beautiful",
  "scrutinise": "sound",
  "scrutinize": "sound",
  "scry": "smart",
  "scsi": "build",
  "scuba": "build",
  "scuff": "build",
  "scuffer": "build",
  "scuffle": "build",
  "scull": "build",
  "scullery": "build",
  "sculpin": "heal",
  "sculpt": "build",
  "sculptural": "beautiful",
  "sculpture": "beautiful",
  "scum": "build",
  "scup": "taste",
  "scupper": "build",
  "scuppernong": "taste",
  "scurfy": "beautiful",
  "scurrility": "story",
  "scurvy": "beautiful",
  "scut": "heal",
  "scutcheon": "build",
  "scute": "heal",
  "scutellaria": "heal",
  "scutigera": "heal",
  "scutigerella": "heal",
  "scutigeridae": "heal",
  "scuttle": "build",
  "scuttlebutt": "story",
  "scyliorhinidae": "heal",
  "scyphozoa": "heal",
  "scyphozoan": "heal",
  "scyphus": "build",
  "scythe": "build",
  "scythian": "story",
  "sea": "smart",
  "sea-ear": "heal",
  "sea-rocket": "heal",
  "seabag": "build",
  "seabird": "heal",
  "seafaring": "beautiful",
  "seafood": "taste",
  "seafowl": "heal",
  "seagrass": "heal",
  "seagull": "heal",
  "seahorse": "heal",
  "seal": "build",
  "sealed": "build",
  "sealing": "build",
  "sealskin": "build",
  "sealyham": "heal",
  "seam": "build",
  "seamanlike": "beautiful",
  "seamanly": "beautiful",
  "seamanship": "smart",
  "seamed": "build",
  "seamless": "beautiful",
  "seaplane": "build",
  "search": "smart",
  "searcher": "heal",
  "searchlight": "build",
  "searobin": "heal",
  "seascape": "build",
  "seashell": "heal",
  "seasnail": "heal",
  "season": "story",
  "seasonable": "beautiful",
  "seasonal": "beautiful",
  "seasoned": "sound",
  "seasoner": "taste",
  "seasoning": "taste",
  "seat": "heal",
  "seatbelt": "build",
  "seated": "build",
  "seating": "build",
  "seats": "build",
  "seawall": "build",
  "seaward": "beautiful",
  "seaway": "build",
  "seaweed": "heal",
  "seaworthy": "beautiful",
  "sebastiana": "heal",
  "sebastodes": "heal",
  "sebum": "heal",
  "sec": "beautiful",
  "secale": "heal",
  "secateurs": "build",
  "secede": "sell",
  "secern": "smart",
  "secernate": "smart",
  "secernment": "smart",
  "secessionism": "smart",
  "sechuana": "story",
  "seckel": "taste",
  "secobarbital": "build",
  "seconal": "build",
  "second-guess": "story",
  "second-stringer": "beautiful",
  "secondary": "build",
  "secondment": "story",
  "secondo": "story",
  "secotiaceae": "heal",
  "secotiales": "heal",
  "secpar": "smart",
  "secret": "story",
  "secretaire": "build",
  "secretariat": "heal",
  "secretary": "build",
  "secretase": "heal",
  "secrete": "heal",
  "secreter": "heal",
  "secretin": "heal",
  "secretion": "smart",
  "secretor": "heal",
  "sectarian": "beautiful",
  "sectarianism": "smart",
  "section": "story",
  "sectional": "build",
  "sectionalise": "sell",
  "sectionalism": "smart",
  "sectionalize": "sell",
  "sector": "smart",
  "sectral": "build",
  "secular": "beautiful",
  "secularism": "smart",
  "secularize": "sell",
  "secure": "sell",
  "securer": "beautiful",
  "security": "sell",
  "sedan": "build",
  "sedate": "heal",
  "sedative": "build",
  "sedative-hypnotic": "build",
  "sedge": "heal",
  "sedimentary": "beautiful",
  "sedimentation": "sound",
  "seduce": "build",
  "seductive": "beautiful",
  "sedum": "heal",
  "see": "sound",
  "seeable": "beautiful",
  "seed": "heal",
  "seedbed": "build",
  "seedcake": "taste",
  "seedcase": "heal",
  "seeded": "build",
  "seeder": "build",
  "seedless": "beautiful",
  "seedling": "heal",
  "seedpod": "heal",
  "seedy": "beautiful",
  "seeing": "smart",
  "seek": "sell",
  "seeker": "build",
  "seeking": "sell",
  "seel": "sound",
  "seem": "sound",
  "seersucker": "build",
  "seesaw": "build",
  "segment": "build",
  "segmentation": "smart",
  "segno": "story",
  "segregate": "sell",
  "segregated": "sell",
  "segregation": "smart",
  "segregationism": "smart",
  "segue": "story",
  "segway": "build",
  "seidel": "build",
  "seigneury": "sell",
  "seigniorage": "sell",
  "seigniory": "sell",
  "seine": "build",
  "seismogram": "build",
  "seismograph": "build",
  "seismology": "smart",
  "seismosaur": "heal",
  "seismosaurus": "heal",
  "seiurus": "heal",
  "seize": "build",
  "seizing": "build",
  "selachian": "heal",
  "selachii": "heal",
  "selaginella": "heal",
  "selaginellaceae": "heal",
  "selaginellales": "heal",
  "selar": "heal",
  "select": "smart",
  "selected": "smart",
  "selection": "smart",
  "selector": "build",
  "selenarctos": "heal",
  "selene": "heal",
  "selenicereus": "heal",
  "selenipedium": "heal",
  "selenology": "smart",
  "self": "smart",
  "self-absorption": "smart",
  "self-accusation": "story",
  "self-aggrandising": "beautiful",
  "self-aggrandizing": "beautiful",
  "self-analysis": "smart",
  "self-asserting": "beautiful",
  "self-assertion": "story",
  "self-assertive": "beautiful",
  "self-assurance": "smart",
  "self-awareness": "smart",
  "self-centered": "beautiful",
  "self-centred": "beautiful",
  "self-condemnation": "story",
  "self-confidence": "smart",
  "self-consciousness": "smart",
  "self-contemplation": "smart",
  "self-contradiction": "story",
  "self-criticism": "smart",
  "self-cultivation": "smart",
  "self-deceit": "smart",
  "self-deception": "smart",
  "self-destroy": "build",
  "self-destruct": "build",
  "self-digestion": "smart",
  "self-drive": "sell",
  "self-education": "smart",
  "self-employed": "beautiful",
  "self-examination": "smart",
  "self-examining": "beautiful",
  "self-expression": "story",
  "self-feeder": "build",
  "self-generated": "beautiful",
  "self-heal": "heal",
  "self-incrimination": "story",
  "self-induced": "beautiful",
  "self-inductance": "smart",
  "self-induction": "sound",
  "self-insurance": "sell",
  "self-justification": "story",
  "self-knowledge": "smart",
  "self-loader": "build",
  "self-portrait": "build",
  "self-praise": "story",
  "self-reproach": "story",
  "self-reproof": "story",
  "self-seeking": "beautiful",
  "self-starter": "build",
  "selfish": "beautiful",
  "selfless": "beautiful",
  "selkup": "story",
  "sell": "sell",
  "selling": "sell",
  "sellotape": "build",
  "selsyn": "build",
  "seltzer": "taste",
  "selvage": "build",
  "selvedge": "build",
  "semantics": "smart",
  "semaphore": "build",
  "semasiology": "smart",
  "semblance": "smart",
  "semen": "heal",
  "semi": "build",
  "semi-abstraction": "build",
  "semi-climber": "heal",
  "semiautomatic": "build",
  "semibreve": "story",
  "semicolon": "story",
  "semicoma": "smart",
  "semiconductor": "build",
  "semiconsciousness": "smart",
  "semidiameter": "sound",
  "semiepiphyte": "heal",
  "semigloss": "build",
  "semimonthly": "story",
  "seminal": "beautiful",
  "seminole": "story",
  "semiology": "smart",
  "semiotics": "smart",
  "semiparasite": "heal",
  "semiquaver": "story",
  "semitic": "story",
  "semitone": "story",
  "semitrailer": "build",
  "semitrance": "smart",
  "semivowel": "story",
  "semiweekly": "story",
  "semolina": "taste",
  "sen": "smart",
  "send": "build",
  "send-off": "story",
  "sender": "build",
  "sending": "build",
  "sendup": "story",
  "sene": "smart",
  "seneca": "story",
  "senecio": "heal",
  "senefelder": "beautiful",
  "senega": "heal",
  "senescence": "smart",
  "senior": "beautiful",
  "seniti": "smart",
  "senna": "heal",
  "sennenhunde": "heal",
  "sennit": "build",
  "senor": "story",
  "senora": "story",
  "senorita": "story",
  "sens": "build",
  "sensation": "smart",
  "sensational": "beautiful",
  "sensationalism": "story",
  "sense": "smart",
  "sensibility": "smart",
  "sensible": "beautiful",
  "sensing": "smart",
  "sensitisation": "smart",
  "sensitise": "sound",
  "sensitising": "sound",
  "sensitive": "beautiful",
  "sensitiveness": "smart",
  "sensitivity": "smart",
  "sensitization": "smart",
  "sensitize": "sound",
  "sensitizing": "sound",
  "sensitometer": "build",
  "sensor": "build",
  "sensorial": "beautiful",
  "sensorium": "heal",
  "sensory": "beautiful",
  "sensualism": "smart",
  "sensualize": "build",
  "sent": "smart",
  "sente": "smart",
  "sentence": "story",
  "sentience": "smart",
  "sentiency": "smart",
  "sentient": "beautiful",
  "sentiment": "smart",
  "sentimentalise": "heal",
  "sentimentalism": "story",
  "sentimentalize": "heal",
  "sentimentise": "heal",
  "sentimentize": "heal",
  "sepal": "heal",
  "separate": "story",
  "separatist": "beautiful",
  "separator": "build",
  "separatrix": "story",
  "sepia": "heal",
  "sepiidae": "heal",
  "septenary": "smart",
  "septet": "smart",
  "septette": "story",
  "septic": "beautiful",
  "septillion": "smart",
  "septobasidiaceae": "heal",
  "septobasidium": "heal",
  "septuagint": "story",
  "septum": "heal",
  "sepulcher": "build",
  "sepulchral": "beautiful",
  "sepulchre": "build",
  "sepulture": "build",
  "sequel": "story",
  "sequenator": "build",
  "sequence": "build",
  "sequencer": "sound",
  "sequester": "sell",
  "sequestration": "smart",
  "sequin": "build",
  "sequoia": "heal",
  "sequoiadendron": "heal",
  "seraglio": "build",
  "serail": "build",
  "serape": "build",
  "seraphic": "beautiful",
  "serax": "build",
  "serbo-croat": "story",
  "serbo-croatian": "story",
  "serenade": "story",
  "serendipity": "sound",
  "serenoa": "heal",
  "serer": "story",
  "serge": "build",
  "serger": "build",
  "serial": "story",
  "serialism": "story",
  "sericocarpus": "heal",
  "sericterium": "heal",
  "serictery": "heal",
  "sericulture": "smart",
  "seriema": "heal",
  "series": "story",
  "serif": "beautiful",
  "serigraph": "build",
  "serigraphy": "beautiful",
  "serin": "heal",
  "serinus": "heal",
  "seriocomedy": "story",
  "seriola": "heal",
  "serious": "beautiful",
  "seriph": "story",
  "seriphidium": "heal",
  "seriphus": "heal",
  "sermon": "story",
  "sermonise": "story",
  "sermonize": "story",
  "serology": "smart",
  "serosa": "heal",
  "serotine": "heal",
  "serow": "heal",
  "serpasil": "build",
  "serpent": "heal",
  "serpentes": "heal",
  "serranid": "heal",
  "serranidae": "heal",
  "serranus": "heal",
  "serrasalmus": "heal",
  "serrate": "build",
  "serratia": "heal",
  "serration": "build",
  "serratula": "heal",
  "serratus": "heal",
  "sertraline": "build",
  "sertularia": "heal",
  "sertularian": "heal",
  "serum": "heal",
  "serval": "heal",
  "server": "smart",
  "serviceable": "beautiful",
  "serviceberry": "heal",
  "servicing": "sell",
  "serviette": "build",
  "servile": "beautiful",
  "serving": "taste",
  "servo": "smart",
  "servomechanism": "build",
  "servosystem": "build",
  "serzone": "build",
  "sesame": "heal",
  "sesamoid": "heal",
  "sesamum": "heal",
  "sesbania": "heal",
  "seseli": "heal",
  "sesotho": "story",
  "sesquipedalia": "story",
  "sesquipedalian": "story",
  "sesquipedality": "story",
  "sess": "build",
  "sessile": "beautiful",
  "session": "story",
  "sessions": "story",
  "sestet": "smart",
  "set": "build",
  "set-back": "build",
  "seta": "heal",
  "setaria": "heal",
  "setline": "build",
  "setoff": "build",
  "setophaga": "heal",
  "setscrew": "build",
  "setswana": "story",
  "sett": "build",
  "settee": "build",
  "setter": "heal",
  "setterwort": "heal",
  "setting": "build",
  "settle": "build",
  "settled": "smart",
  "settlement": "story",
  "settling": "smart",
  "setup": "build",
  "seven": "smart",
  "seven-spot": "build",
  "sevener": "smart",
  "sevens": "smart",
  "seventeen": "smart",
  "seventeenth": "beautiful",
  "seventh": "smart",
  "seventies": "smart",
  "seventieth": "beautiful",
  "seventy": "smart",
  "seventy-eight": "smart",
  "sever": "build",
  "severalise": "smart",
  "severalize": "smart",
  "severalty": "sell",
  "severing": "build",
  "sew": "beautiful",
  "sewellel": "heal",
  "sewer": "build",
  "sewerage": "build",
  "sewing": "beautiful",
  "sexagenarian": "beautiful",
  "sexist": "beautiful",
  "sextant": "smart",
  "sextet": "story",
  "sextette": "story",
  "sextillion": "smart",
  "sextuplet": "smart",
  "sexual": "beautiful",
  "sexy": "beautiful",
  "sforzando": "story",
  "sgml": "story",
  "sgraffito": "build",
  "shabu": "build",
  "shack": "build",
  "shackle": "build",
  "shad": "taste",
  "shad-flower": "heal",
  "shadberry": "taste",
  "shadblow": "heal",
  "shadbush": "heal",
  "shaddock": "heal",
  "shade": "beautiful",
  "shaded": "build",
  "shades": "build",
  "shadflower": "heal",
  "shadfly": "heal",
  "shading": "build",
  "shadow": "smart",
  "shadowbox": "build",
  "shadowboxing": "build",
  "shadowgraph": "build",
  "shaft": "build",
  "shag": "build",
  "shagbark": "heal",
  "shaggymane": "heal",
  "shahadah": "smart",
  "shahaptian": "story",
  "shake": "taste",
  "shaker": "build",
  "shakers": "build",
  "shaking": "heal",
  "shako": "build",
  "shaktism": "smart",
  "shall-flower": "heal",
  "shallon": "heal",
  "shallot": "heal",
  "shallow": "beautiful",
  "shallu": "heal",
  "shalwar": "build",
  "sham": "build",
  "shamanise": "sell",
  "shamanism": "smart",
  "shamanize": "sell",
  "shambles": "build",
  "shame": "sell",
  "shamisen": "build",
  "shampoo": "build",
  "shamrock": "heal",
  "shan": "story",
  "shandy": "taste",
  "shandygaff": "taste",
  "shanghai": "build",
  "shank": "taste",
  "shanny": "heal",
  "shantung": "build",
  "shanty": "build",
  "shape": "heal",
  "shaped": "smart",
  "shapely": "beautiful",
  "shaper": "build",
  "shaping": "smart",
  "shard": "build",
  "share": "sell",
  "shared": "sell",
  "shareholding": "sell",
  "shareware": "story",
  "sharing": "story",
  "shark": "heal",
  "sharkskin": "build",
  "sharksucker": "heal",
  "sharp": "story",
  "sharp-sightedness": "smart",
  "sharpen": "build",
  "sharpener": "build",
  "sharper": "beautiful",
  "sharpie": "build",
  "sharpness": "smart",
  "sharpshooter": "build",
  "shasta": "story",
  "shastan": "story",
  "shave": "heal",
  "shaved": "heal",
  "shaven": "heal",
  "shaver": "build",
  "shaving": "heal",
  "shawl": "build",
  "shawm": "build",
  "shawnee": "story",
  "shawny": "heal",
  "shay": "build",
  "she-bop": "build",
  "she-goat": "heal",
  "she-oak": "heal",
  "sheaf": "build",
  "shear": "sound",
  "sheared": "build",
  "shearing": "build",
  "shears": "build",
  "shearwater": "heal",
  "sheatfish": "heal",
  "sheath": "build",
  "sheathe": "build",
  "sheathed": "build",
  "sheathing": "build",
  "shebeen": "taste",
  "shed": "build",
  "shedding": "smart",
  "sheeny": "beautiful",
  "sheep": "heal",
  "sheep-tick": "heal",
  "sheepcote": "build",
  "sheepdog": "heal",
  "sheepfold": "build",
  "sheeprun": "build",
  "sheepshank": "build",
  "sheepshead": "heal",
  "sheepskin": "story",
  "sheepwalk": "build",
  "sheer": "beautiful",
  "sheesha": "build",
  "sheet": "story",
  "sheeting": "build",
  "sheetrock": "build",
  "shekel": "smart",
  "shekels": "sell",
  "sheldrake": "heal",
  "shelduck": "heal",
  "shelf": "build",
  "shelfful": "smart",
  "shell": "build",
  "shell-flower": "heal",
  "shell-less": "beautiful",
  "shellac": "build",
  "shellack": "build",
  "shellbark": "heal",
  "shelled": "build",
  "shellfish": "taste",
  "shellflower": "heal",
  "shelling": "build",
  "shelter": "build",
  "shelterbelt": "build",
  "shelve": "build",
  "shema": "story",
  "shepherd": "sell",
  "sheraton": "build",
  "sherbert": "taste",
  "sherbet": "taste",
  "sherd": "build",
  "sherrington": "heal",
  "sherry": "taste",
  "shetland": "heal",
  "shew": "smart",
  "shibboleth": "story",
  "shield": "build",
  "shielding": "build",
  "shifter": "build",
  "shigella": "heal",
  "shih-tzu": "heal",
  "shiism": "smart",
  "shiitake": "heal",
  "shill": "sell",
  "shillalah": "build",
  "shillelagh": "build",
  "shilling": "smart",
  "shim": "build",
  "shimmy": "build",
  "shin": "heal",
  "shina": "story",
  "shinbone": "heal",
  "shine": "sound",
  "shiner": "heal",
  "shingle": "build",
  "shingles": "build",
  "shingling": "build",
  "shingon": "smart",
  "shining": "sound",
  "shinleaf": "heal",
  "shinpad": "build",
  "shinplaster": "sell",
  "shinto": "smart",
  "shintoism": "smart",
  "shiny": "beautiful",
  "ship": "build",
  "shipbuilder": "build",
  "shipload": "smart",
  "shipment": "build",
  "shipping": "sell",
  "shipway": "build",
  "shipworm": "heal",
  "shipwreck": "build",
  "shipwright": "build",
  "shipyard": "build",
  "shire": "heal",
  "shirk": "sell",
  "shirking": "sell",
  "shirt": "build",
  "shirtdress": "build",
  "shirtfront": "build",
  "shirting": "build",
  "shirtsleeve": "build",
  "shirtsleeves": "build",
  "shirttail": "story",
  "shirtwaist": "build",
  "shirtwaister": "build",
  "shisha": "build",
  "shit": "story",
  "shitlist": "story",
  "shittah": "heal",
  "shittim": "heal",
  "shittimwood": "heal",
  "shitting": "smart",
  "shiv": "build",
  "shivaism": "smart",
  "shivaree": "story",
  "shiver": "heal",
  "shivering": "heal",
  "shlep": "build",
  "shlock": "build",
  "shmegegge": "story",
  "shmoose": "story",
  "shmooze": "story",
  "shnorr": "sell",
  "shoat": "heal",
  "shockable": "beautiful",
  "shocker": "story",
  "shod": "heal",
  "shodden": "beautiful",
  "shoddy": "beautiful",
  "shoe": "build",
  "shoe-shop": "build",
  "shoebill": "heal",
  "shoebird": "heal",
  "shoebox": "build",
  "shoed": "heal",
  "shoeful": "smart",
  "shoehorn": "build",
  "shoelace": "build",
  "shoes": "build",
  "shoestring": "build",
  "shoetree": "build",
  "shofar": "build",
  "shoji": "build",
  "shona": "story",
  "shoofly": "build",
  "shook": "build",
  "shoot": "heal",
  "shoot-'em-up": "story",
  "shooter": "build",
  "shooting": "sell",
  "shop": "build",
  "shopfront": "build",
  "shophar": "build",
  "shoplift": "sell",
  "shoplifting": "sell",
  "shopping": "build",
  "shopwindow": "build",
  "shore": "build",
  "shorea": "heal",
  "shorebird": "heal",
  "shoreward": "beautiful",
  "shoring": "build",
  "shorn": "beautiful",
  "short": "build",
  "short-change": "sell",
  "short-circuit": "sell",
  "short-grass": "heal",
  "short-spurred": "beautiful",
  "short-stop": "build",
  "shortbread": "taste",
  "shortcake": "taste",
  "shortcut": "build",
  "shortening": "taste",
  "shortgrass": "heal",
  "shorthand": "story",
  "shorthorn": "heal",
  "shortia": "heal",
  "shortlist": "story",
  "shorts": "build",
  "shortsighted": "beautiful",
  "shoshone": "story",
  "shoshonean": "story",
  "shoshonian": "story",
  "shot": "build",
  "shote": "heal",
  "shotgun": "build",
  "shoulder": "heal",
  "shouldered": "build",
  "shout": "story",
  "shouting": "story",
  "shove": "build",
  "shovel": "build",
  "shoveler": "heal",
  "shovelful": "smart",
  "shovelhead": "heal",
  "shoveller": "heal",
  "show": "story",
  "show-stopper": "story",
  "showboat": "build",
  "showcase": "build",
  "showdown": "story",
  "shower": "build",
  "showerhead": "build",
  "showing": "story",
  "showmanship": "smart",
  "showpiece": "build",
  "showroom": "build",
  "showstopper": "story",
  "shrapnel": "build",
  "shred": "smart",
  "shredder": "build",
  "shrew": "heal",
  "shrewdness": "smart",
  "shrewmouse": "heal",
  "shriek": "story",
  "shrieked": "story",
  "shrieking": "story",
  "shrike": "heal",
  "shrill": "story",
  "shrilling": "story",
  "shrillness": "sound",
  "shrimp": "taste",
  "shrimp-fish": "heal",
  "shrimper": "build",
  "shrimpfish": "heal",
  "shrine": "build",
  "shrink-wrap": "build",
  "shrinkable": "beautiful",
  "shrinkwrap": "build",
  "shrive": "story",
  "shroud": "build",
  "shrub": "heal",
  "shrublet": "heal",
  "shrug": "story",
  "shtick": "smart",
  "shtickl": "smart",
  "shtik": "smart",
  "shtikl": "smart",
  "shucks": "story",
  "shudder": "heal",
  "shumac": "heal",
  "shun": "story",
  "shunning": "story",
  "shunt": "heal",
  "shunter": "build",
  "shut": "build",
  "shut-in": "beautiful",
  "shutter": "build",
  "shuttered": "build",
  "shutting": "build",
  "shuttle": "build",
  "shuttlecock": "build",
  "shwa": "story",
  "shy": "build",
  "sialia": "heal",
  "sialidae": "heal",
  "sialis": "heal",
  "siamang": "heal",
  "siamese": "story",
  "sibilant": "story",
  "sibilate": "story",
  "sibilation": "story",
  "sibine": "story",
  "sick": "heal",
  "sickbag": "build",
  "sickbay": "build",
  "sickbed": "build",
  "sicken": "heal",
  "sickle": "build",
  "sicklepod": "heal",
  "sickness": "heal",
  "sickroom": "build",
  "sida": "heal",
  "sidalcea": "heal",
  "side": "heal",
  "side-wheeler": "build",
  "side-whiskers": "heal",
  "sidebar": "story",
  "sideboard": "build",
  "sideburn": "heal",
  "sidecar": "taste",
  "sidelight": "build",
  "sideline": "build",
  "sidereal": "beautiful",
  "sideritis": "heal",
  "sideroblast": "heal",
  "siderocyte": "heal",
  "siderosis": "build",
  "sidesaddle": "build",
  "sidesplitter": "story",
  "sidestep": "story",
  "sideswipe": "build",
  "sidetrack": "build",
  "sidewalk": "build",
  "sidewall": "build",
  "sidewinder": "heal",
  "siding": "build",
  "siemens": "smart",
  "sienna": "beautiful",
  "sierra": "heal",
  "sieve": "build",
  "sift": "build",
  "sifter": "build",
  "sifting": "build",
  "sigeh": "sound",
  "sigh": "story",
  "sight": "smart",
  "sight-read": "build",
  "sight-sing": "build",
  "sighted": "sound",
  "sightedness": "smart",
  "sighting": "sound",
  "sightread": "build",
  "sights": "build",
  "sightsing": "build",
  "sigma": "story",
  "sigmodon": "heal",
  "sigmoidoscope": "build",
  "sign": "story",
  "signal": "story",
  "signaling": "story",
  "signalisation": "story",
  "signalise": "sell",
  "signalization": "story",
  "signalize": "sell",
  "signature": "story",
  "signboard": "build",
  "signed": "story",
  "signet": "build",
  "significance": "smart",
  "significant": "beautiful",
  "signification": "story",
  "signified": "story",
  "signifier": "story",
  "signify": "story",
  "signing": "story",
  "signora": "story",
  "signore": "story",
  "signorina": "story",
  "signory": "sell",
  "signpost": "story",
  "sika": "heal",
  "sikhism": "smart",
  "silage": "taste",
  "sild": "heal",
  "sildenafil": "build",
  "silenced": "beautiful",
  "silencer": "build",
  "silene": "heal",
  "silents": "story",
  "silesia": "build",
  "silex": "build",
  "silhouette": "build",
  "silicle": "heal",
  "siliqua": "heal",
  "silique": "heal",
  "silk": "beautiful",
  "silkgrass": "heal",
  "silks": "build",
  "silkscreen": "beautiful",
  "silkweed": "heal",
  "silkwood": "heal",
  "silkworm": "heal",
  "sill": "build",
  "sillabub": "taste",
  "sillaginidae": "heal",
  "sillago": "heal",
  "sills": "build",
  "silly": "beautiful",
  "silo": "build",
  "silphium": "heal",
  "silt": "build",
  "silurid": "heal",
  "siluridae": "heal",
  "siluriformes": "heal",
  "silurus": "heal",
  "silvan": "beautiful",
  "silver": "sell",
  "silver-bush": "heal",
  "silver-lace": "heal",
  "silver-plate": "build",
  "silver-tip": "heal",
  "silverback": "heal",
  "silverberry": "heal",
  "silverbush": "heal",
  "silverfish": "heal",
  "silverplate": "build",
  "silverpoint": "build",
  "silverrod": "heal",
  "silverside": "heal",
  "silversides": "heal",
  "silverspot": "heal",
  "silversword": "heal",
  "silvertip": "heal",
  "silvervine": "heal",
  "silverware": "build",
  "silverweed": "heal",
  "silverwork": "build",
  "silvia": "heal",
  "silviculture": "build",
  "silybum": "heal",
  "simal": "heal",
  "simarouba": "heal",
  "simaroubaceae": "heal",
  "simian": "heal",
  "similar": "beautiful",
  "similarity": "smart",
  "simile": "story",
  "similitude": "build",
  "simnel": "taste",
  "simoleons": "sell",
  "simonise": "build",
  "simonize": "build",
  "simony": "taste",
  "simoom": "sound",
  "simoon": "sound",
  "simper": "story",
  "simple": "heal",
  "simplification": "story",
  "simplism": "story",
  "simulacrum": "build",
  "simulate": "smart",
  "simulation": "smart",
  "simulator": "build",
  "simulcast": "story",
  "simuliidae": "heal",
  "simulium": "heal",
  "simvastatin": "build",
  "sinanthropus": "heal",
  "sinapis": "heal",
  "sinapism": "build",
  "sincere": "beautiful",
  "sinciput": "heal",
  "sindhi": "story",
  "sinecure": "sell",
  "sinequan": "build",
  "sinew": "heal",
  "sinewy": "beautiful",
  "sing": "sound",
  "sing-kwa": "heal",
  "singhalese": "story",
  "singing": "sound",
  "single": "smart",
  "single-barreled": "beautiful",
  "single-barrelled": "beautiful",
  "single-breasted": "beautiful",
  "single-lane": "beautiful",
  "single-leaf": "heal",
  "single-spacing": "story",
  "singles": "smart",
  "singlestick": "build",
  "singlet": "build",
  "singleton": "smart",
  "singsong": "story",
  "singular": "story",
  "singularise": "story",
  "singularize": "story",
  "sinhala": "story",
  "sinhalese": "story",
  "sinistral": "beautiful",
  "sinitic": "story",
  "sink": "build",
  "sinkable": "beautiful",
  "sinker": "taste",
  "sinning": "sell",
  "sinningia": "heal",
  "sino-tibetan": "story",
  "sinology": "smart",
  "sinoper": "beautiful",
  "sinopia": "beautiful",
  "sinopis": "beautiful",
  "sinornis": "heal",
  "sinter": "build",
  "sintered": "build",
  "sinus": "heal",
  "sinusoid": "heal",
  "sion": "smart",
  "siouan": "story",
  "sip": "taste",
  "siphon": "build",
  "siphonaptera": "heal",
  "siphonophora": "heal",
  "siphonophore": "heal",
  "sipuncula": "heal",
  "sipunculid": "heal",
  "sirach": "story",
  "sire": "heal",
  "siren": "story",
  "sirenia": "heal",
  "sirenian": "heal",
  "sirenidae": "heal",
  "siris": "heal",
  "sirloin": "taste",
  "sirocco": "sound",
  "sirup": "taste",
  "sis": "smart",
  "sisal": "heal",
  "sise": "smart",
  "sisham": "heal",
  "siskin": "heal",
  "sison": "heal",
  "siss": "story",
  "sissoo": "heal",
  "sissu": "heal",
  "sissy": "beautiful",
  "sisterlike": "beautiful",
  "sisterly": "beautiful",
  "sistrurus": "heal",
  "sisyphean": "beautiful",
  "sisyridae": "heal",
  "sisyrinchium": "heal",
  "sit": "build",
  "sitar": "build",
  "sitcom": "story",
  "site": "story",
  "sitophylus": "heal",
  "sitotroga": "heal",
  "sitta": "heal",
  "sittidae": "heal",
  "sitting": "story",
  "situate": "build",
  "sium": "heal",
  "sivaism": "smart",
  "sivapithecus": "heal",
  "six": "smart",
  "six-gun": "build",
  "six-pack": "build",
  "six-shooter": "build",
  "six-spot": "build",
  "sixer": "smart",
  "sixpack": "build",
  "sixpence": "sell",
  "sixteen": "smart",
  "sixteenth": "smart",
  "sixth": "smart",
  "sixties": "smart",
  "sixtieth": "smart",
  "sixty": "smart",
  "sixty-fourth": "smart",
  "sixty-nine": "beautiful",
  "sized": "build",
  "sizing": "build",
  "sizz": "story",
  "sizzle": "story",
  "sk-ampicillin": "build",
  "skag": "build",
  "skagit": "story",
  "skank": "sound",
  "skate": "build",
  "skateboard": "build",
  "skeg": "build",
  "skein": "build",
  "skeletal": "beautiful",
  "skeleton": "smart",
  "skep": "build",
  "skepful": "smart",
  "skepticism": "smart",
  "sketch": "beautiful",
  "sketchbook": "build",
  "sketcher": "build",
  "skew": "beautiful",
  "skewer": "build",
  "ski": "build",
  "ski-plane": "build",
  "skiagram": "build",
  "skiagraph": "build",
  "skiagraphy": "smart",
  "skibob": "build",
  "skid": "build",
  "skidder": "build",
  "skidpan": "build",
  "skiff": "build",
  "skiffle": "story",
  "skill": "smart",
  "skilled": "beautiful",
  "skillet": "taste",
  "skilletfish": "heal",
  "skillfulness": "smart",
  "skilly": "taste",
  "skim": "story",
  "skimcoat": "build",
  "skimmer": "build",
  "skimming": "story",
  "skimp": "sell",
  "skin": "heal",
  "skinful": "smart",
  "skink": "heal",
  "skinless": "beautiful",
  "skinned": "build",
  "skinny": "story",
  "skip": "smart",
  "skipjack": "heal",
  "skipper": "sell",
  "skirl": "sound",
  "skirret": "heal",
  "skirt": "build",
  "skitter": "build",
  "skittle": "build",
  "skittles": "build",
  "skive": "build",
  "skivvies": "build",
  "skreak": "sound",
  "skreigh": "story",
  "skua": "heal",
  "skulduggery": "story",
  "skulk": "sell",
  "skulking": "sell",
  "skull": "heal",
  "skullcap": "build",
  "skullduggery": "story",
  "skunk": "build",
  "skunk-weed": "heal",
  "skunkbush": "heal",
  "skunkweed": "heal",
  "sky": "build",
  "sky-blue": "beautiful",
  "skybox": "build",
  "skyhook": "build",
  "skyjack": "build",
  "skylab": "build",
  "skylark": "heal",
  "skylight": "build",
  "skyrocket": "story",
  "skysail": "build",
  "skyscraper": "build",
  "skywalk": "build",
  "skywriting": "story",
  "slab": "build",
  "slabber": "heal",
  "slack": "smart",
  "slacker": "beautiful",
  "slacking": "sell",
  "slacks": "build",
  "slain": "sell",
  "slake": "taste",
  "slam": "story",
  "slam-dunk": "sell",
  "slammer": "build",
  "slander": "story",
  "slang": "story",
  "slanguage": "story",
  "slant": "smart",
  "slap": "build",
  "slapstick": "story",
  "slash": "story",
  "slasher": "build",
  "slat": "build",
  "slate": "build",
  "slater": "heal",
  "slather": "build",
  "slating": "story",
  "slaughter": "build",
  "slaughterhouse": "build",
  "slave": "sell",
  "slave-maker": "heal",
  "slaveholding": "beautiful",
  "slaver": "heal",
  "slavic": "story",
  "slavonic": "story",
  "slaw": "taste",
  "slay": "sell",
  "slaying": "sell",
  "sled": "build",
  "sledge": "build",
  "sledgehammer": "build",
  "sleek": "build",
  "sleeper": "build",
  "sleeping": "smart",
  "sleeplessness": "sound",
  "sleepwear": "build",
  "sleet": "sound",
  "sleeve": "build",
  "sleeved": "beautiful",
  "sleeveless": "beautiful",
  "sleigh": "build",
  "sleight": "smart",
  "slenderize": "heal",
  "sleuth": "story",
  "sleuthhound": "heal",
  "sleuthing": "story",
  "slew": "smart",
  "slews": "smart",
  "slice": "sell",
  "slicer": "build",
  "slicing": "build",
  "slick": "story",
  "slicker": "build",
  "slickness": "story",
  "slide": "build",
  "slider": "heal",
  "slideway": "build",
  "slight": "smart",
  "slim": "heal",
  "slime": "build",
  "sling": "taste",
  "slingback": "build",
  "slinging": "build",
  "slingshot": "build",
  "slip": "heal",
  "slip-on": "build",
  "slipcover": "build",
  "slipknot": "build",
  "slipover": "build",
  "slippage": "smart",
  "slipper": "build",
  "slipperwort": "heal",
  "slippery": "beautiful",
  "slippy": "beautiful",
  "slipstick": "build",
  "slipstream": "sound",
  "slipway": "build",
  "slit": "build",
  "sliver": "sell",
  "slivovitz": "taste",
  "slo-bid": "build",
  "sloanea": "heal",
  "slobber": "heal",
  "sloe": "heal",
  "slog": "sell",
  "slogan": "story",
  "sloganeer": "build",
  "sloganeering": "story",
  "sloop": "build",
  "slop": "taste",
  "slops": "taste",
  "slopshop": "build",
  "slosh": "sound",
  "slot": "story",
  "sloth": "heal",
  "sloughing": "smart",
  "slovak": "story",
  "slovene": "story",
  "slow": "beautiful",
  "slow-wittedness": "smart",
  "slowness": "smart",
  "slowworm": "heal",
  "slug": "build",
  "sluice": "build",
  "sluicegate": "build",
  "sluiceway": "build",
  "slum": "sell",
  "slumber": "heal",
  "slumgullion": "taste",
  "slump": "smart",
  "slur": "story",
  "slurp": "taste",
  "slush": "sound",
  "slyness": "smart",
  "smack": "smart",
  "smacking": "build",
  "small": "heal",
  "small-arm": "build",
  "smallholding": "sell",
  "smallmouth": "heal",
  "smarm": "story",
  "smart": "smart",
  "smarting": "sound",
  "smartness": "smart",
  "smashing": "build",
  "smatter": "sell",
  "smattering": "smart",
  "smear": "story",
  "smegma": "heal",
  "smell": "smart",
  "smelling": "sound",
  "smelt": "taste",
  "smelter": "build",
  "smeltery": "build",
  "smew": "heal",
  "smidge": "smart",
  "smidgen": "smart",
  "smidgeon": "smart",
  "smidgin": "smart",
  "smilacaceae": "heal",
  "smilax": "heal",
  "smile": "story",
  "smiledon": "heal",
  "smiler": "heal",
  "smiley": "story",
  "smiling": "story",
  "smilo": "heal",
  "smirch": "build",
  "smirk": "story",
  "smitane": "taste",
  "smite": "build",
  "smithy": "build",
  "smock": "build",
  "smocking": "build",
  "smoke": "sound",
  "smokehouse": "build",
  "smokeless": "beautiful",
  "smoker": "taste",
  "smokescreen": "build",
  "smokestack": "build",
  "smoking": "smart",
  "smoky": "beautiful",
  "smooch": "build",
  "smooching": "build",
  "smooth": "build",
  "smoothbark": "heal",
  "smoothbore": "build",
  "smoothen": "build",
  "smoother": "build",
  "smoothhound": "heal",
  "smoothie": "taste",
  "smoothness": "story",
  "smorgasbord": "taste",
  "smother": "sound",
  "smudge": "build",
  "smuggle": "sell",
  "smuggling": "sell",
  "smut": "heal",
  "smutch": "build",
  "smuts": "heal",
  "smyrnium": "heal",
  "snack": "taste",
  "snaffle": "build",
  "snafu": "beautiful",
  "snag": "heal",
  "snail": "heal",
  "snail-flower": "heal",
  "snailfish": "heal",
  "snailflower": "heal",
  "snake": "heal",
  "snake-fish": "heal",
  "snake-head": "heal",
  "snakeberry": "heal",
  "snakebird": "heal",
  "snakeblenny": "heal",
  "snakefish": "heal",
  "snakefly": "heal",
  "snakehead": "heal",
  "snakeroot": "heal",
  "snakeweed": "heal",
  "snakewood": "heal",
  "snap": "taste",
  "snapdragon": "heal",
  "snapline": "build",
  "snapper": "taste",
  "snapshot": "build",
  "snare": "smart",
  "snarf": "sell",
  "snarl": "story",
  "snatch": "story",
  "sneaker": "build",
  "sneer": "story",
  "sneeze": "heal",
  "sneezeweed": "heal",
  "sneezewort": "heal",
  "sneezing": "heal",
  "snick": "build",
  "snicker": "story",
  "sniff": "sound",
  "sniffle": "heal",
  "snifter": "build",
  "snigger": "story",
  "snip": "build",
  "snipe": "heal",
  "snipefish": "heal",
  "snippet": "build",
  "snipping": "build",
  "snips": "build",
  "snitch": "sell",
  "snivel": "story",
  "sniveling": "story",
  "sno-cat": "build",
  "snoek": "heal",
  "snog": "build",
  "snogging": "build",
  "snood": "build",
  "snook": "heal",
  "snooker": "sell",
  "snoop": "story",
  "snoopiness": "smart",
  "snoopy": "beautiful",
  "snoot": "heal",
  "snooze": "heal",
  "snore": "heal",
  "snoring": "heal",
  "snorkel": "build",
  "snort": "story",
  "snorter": "smart",
  "snorting": "story",
  "snot": "heal",
  "snout": "heal",
  "snow": "sound",
  "snow-blind": "sound",
  "snow-blindness": "sound",
  "snow-in-summer": "heal",
  "snow-on-the-mountain": "heal",
  "snowball": "heal",
  "snowbank": "build",
  "snowbell": "heal",
  "snowberry": "heal",
  "snowbird": "heal",
  "snowblindness": "sound",
  "snowboard": "build",
  "snowdrop": "heal",
  "snowfall": "sound",
  "snowflake": "sound",
  "snowman": "build",
  "snowmobile": "build",
  "snowplough": "build",
  "snowplow": "build",
  "snowshoe": "build",
  "snowstorm": "sound",
  "snowsuit": "build",
  "snp": "sound",
  "snub": "story",
  "snuff": "smart",
  "snuffbox": "build",
  "snuffer": "build",
  "snuffers": "build",
  "snuffle": "sound",
  "snug": "build",
  "snuggery": "build",
  "snuggle": "build",
  "snuggling": "build",
  "soak": "smart",
  "soakage": "smart",
  "soaker": "sound",
  "soaking": "smart",
  "soap": "build",
  "soap-weed": "heal",
  "soapberry": "heal",
  "soapbox": "build",
  "soapfish": "heal",
  "soapweed": "heal",
  "soapwort": "heal",
  "soapy": "beautiful",
  "soave": "taste",
  "sob": "heal",
  "sobbing": "heal",
  "sober": "beautiful",
  "sobralia": "heal",
  "sobriquet": "story",
  "sociable": "beautiful",
  "social": "beautiful",
  "socialise": "sell",
  "socialising": "sell",
  "socialism": "smart",
  "socialist": "beautiful",
  "socialistic": "beautiful",
  "socialize": "sell",
  "socializing": "sell",
  "sociobiology": "smart",
  "sociolinguistics": "smart",
  "sociology": "smart",
  "sociometry": "smart",
  "sock": "build",
  "socket": "heal",
  "sockeye": "taste",
  "socle": "build",
  "soda": "taste",
  "soddy": "build",
  "sodomise": "sell",
  "sodomize": "sell",
  "sofa": "build",
  "soffit": "build",
  "soft": "beautiful",
  "soft-boiled": "beautiful",
  "soft-cover": "build",
  "soft-pedal": "story",
  "soft-soap": "story",
  "soft-solder": "build",
  "softback": "build",
  "softball": "build",
  "soften": "sound",
  "softening": "smart",
  "softhearted": "beautiful",
  "software": "smart",
  "soh": "story",
  "soiled": "build",
  "soiling": "build",
  "soja": "heal",
  "sojourn": "sound",
  "sojourner": "sound",
  "sokoro": "story",
  "sol": "story",
  "solan": "heal",
  "solanaceae": "heal",
  "solandra": "heal",
  "solanopteris": "heal",
  "solanum": "heal",
  "solarise": "sound",
  "solarium": "build",
  "solarize": "sound",
  "sold": "sell",
  "solder": "build",
  "solderer": "build",
  "soldering": "build",
  "soldier": "heal",
  "soldier-fish": "heal",
  "soldierfish": "heal",
  "soldiering": "smart",
  "soldiership": "smart",
  "sole": "build",
  "solea": "heal",
  "soled": "beautiful",
  "soleidae": "heal",
  "soleirolia": "heal",
  "soleless": "beautiful",
  "solemnise": "sell",
  "solemnize": "sell",
  "solenichthyes": "heal",
  "solenidae": "heal",
  "solenogaster": "heal",
  "solenogastres": "heal",
  "solenoid": "smart",
  "solenopsis": "heal",
  "solenostemon": "heal",
  "soleus": "heal",
  "solfa": "story",
  "solicit": "story",
  "solicitation": "story",
  "solid": "beautiful",
  "solidago": "heal",
  "solidification": "smart",
  "solidifying": "smart",
  "solidus": "sell",
  "soliloquise": "story",
  "soliloquize": "story",
  "soliloquy": "story",
  "solipsism": "smart",
  "solitaire": "build",
  "solitary": "beautiful",
  "solleret": "build",
  "solmisation": "story",
  "solmizate": "build",
  "solmization": "story",
  "solo": "story",
  "solomon's-seal": "heal",
  "solresol": "story",
  "solubility": "smart",
  "soluble": "beautiful",
  "solution": "story",
  "solvation": "smart",
  "solve": "smart",
  "solved": "smart",
  "solvent": "story",
  "solver": "sound",
  "solving": "smart",
  "som": "smart",
  "soma": "heal",
  "somaesthesia": "smart",
  "somaesthesis": "smart",
  "somali": "story",
  "somataesthesis": "smart",
  "somateria": "heal",
  "somatesthesia": "smart",
  "somatosense": "smart",
  "somatotrophin": "heal",
  "somatotropin": "heal",
  "sombrero": "build",
  "some": "beautiful",
  "somesthesia": "smart",
  "somesthesis": "smart",
  "somite": "heal",
  "sommelier": "taste",
  "somrai": "story",
  "sonant": "story",
  "sonar": "build",
  "sonata": "story",
  "sonatina": "story",
  "sonchus": "heal",
  "sone": "smart",
  "song": "sound",
  "songbird": "heal",
  "songbook": "story",
  "songhai": "story",
  "songster": "heal",
  "sonic": "beautiful",
  "sonnet": "story",
  "sonogram": "build",
  "sonograph": "build",
  "sonometer": "build",
  "sonora": "heal",
  "soochong": "taste",
  "soot": "build",
  "soothe": "heal",
  "soothsaying": "smart",
  "sop": "taste",
  "sophism": "smart",
  "sophistic": "beautiful",
  "sophisticate": "sell",
  "sophisticated": "sell",
  "sophistication": "smart",
  "sophistry": "smart",
  "sophomore": "beautiful",
  "sophonias": "story",
  "sophora": "heal",
  "soporific": "build",
  "soprano": "sound",
  "sops": "taste",
  "sorb": "taste",
  "sorbet": "taste",
  "sorbian": "story",
  "sorbonne": "build",
  "sorbus": "heal",
  "sorcery": "smart",
  "sordino": "build",
  "sore": "beautiful",
  "sorex": "heal",
  "sorgho": "heal",
  "sorghum": "heal",
  "sorgo": "heal",
  "soricidae": "heal",
  "sororal": "beautiful",
  "sorption": "smart",
  "sorrel": "heal",
  "sorrow": "smart",
  "sorrowful": "beautiful",
  "sorry": "beautiful",
  "sort": "smart",
  "sorter": "build",
  "sorting": "smart",
  "sorus": "heal",
  "sos": "story",
  "soteriology": "smart",
  "sotho": "story",
  "sou": "sell",
  "sou'easter": "sound",
  "sou'wester": "sound",
  "souari": "heal",
  "soubise": "taste",
  "soubrette": "smart",
  "soubriquet": "story",
  "souchong": "taste",
  "souffle": "taste",
  "sough": "story",
  "sought": "sell",
  "souk": "build",
  "soul-searching": "smart",
  "sound": "sound",
  "soundable": "beautiful",
  "soundboard": "build",
  "soundbox": "build",
  "sounder": "build",
  "sounding": "sound",
  "soundproof": "beautiful",
  "soundtrack": "sound",
  "soup": "taste",
  "soup-fin": "heal",
  "soup-strainer": "heal",
  "soupcon": "smart",
  "soupfin": "heal",
  "soupspoon": "build",
  "sour": "taste",
  "sourball": "taste",
  "source": "story",
  "sourdine": "build",
  "sourdough": "taste",
  "soured": "sound",
  "souring": "smart",
  "sourness": "smart",
  "soursop": "heal",
  "sourwood": "heal",
  "sousaphone": "build",
  "souse": "taste",
  "sousing": "build",
  "souslik": "heal",
  "soutache": "build",
  "soutane": "build",
  "southeaster": "sound",
  "southeastward": "beautiful",
  "souther": "sound",
  "southerly": "sound",
  "southern": "beautiful",
  "southernism": "story",
  "southernwood": "heal",
  "southward": "beautiful",
  "southwester": "sound",
  "southwestern": "story",
  "southwestward": "beautiful",
  "souvenir": "build",
  "souvlaki": "taste",
  "souvlakia": "taste",
  "sovereign": "beautiful",
  "sovietise": "sell",
  "sovietize": "sell",
  "sow": "heal",
  "sowbane": "heal",
  "sowbelly": "taste",
  "sowbread": "heal",
  "soy": "heal",
  "soya": "heal",
  "soybean": "heal",
  "soymilk": "taste",
  "spa": "build",
  "space-time": "smart",
  "spacecraft": "build",
  "spaced": "beautiful",
  "spaceship": "build",
  "spacesuit": "build",
  "spade": "build",
  "spadefish": "heal",
  "spadefoot": "heal",
  "spadeful": "smart",
  "spadix": "heal",
  "spaghetti": "taste",
  "spaghettini": "taste",
  "spalacidae": "heal",
  "spalax": "heal",
  "spallanzani": "heal",
  "spallation": "smart",
  "spam": "taste",
  "span": "build",
  "spandau": "build",
  "spandex": "build",
  "spandrel": "build",
  "spandril": "build",
  "spang": "build",
  "spangle": "build",
  "spaniel": "heal",
  "spanish": "story",
  "spank": "build",
  "spanker": "build",
  "spanking": "build",
  "spanner": "build",
  "spar": "build",
  "sparaxis": "heal",
  "spare": "build",
  "sparer": "beautiful",
  "sparerib": "taste",
  "spareribs": "taste",
  "sparganiaceae": "heal",
  "sparganium": "heal",
  "sparid": "heal",
  "sparidae": "heal",
  "spark": "sound",
  "sparker": "build",
  "sparkleberry": "heal",
  "sparkler": "sell",
  "sparling": "taste",
  "sparmannia": "heal",
  "sparring": "story",
  "sparrow": "heal",
  "spartan": "beautiful",
  "spartina": "heal",
  "spartium": "heal",
  "spasm": "heal",
  "spasmolytic": "build",
  "spastic": "beautiful",
  "spat": "story",
  "spatangoida": "heal",
  "spatchcock": "taste",
  "spate": "smart",
  "spathe": "heal",
  "spathiphyllum": "heal",
  "spatiotemporal": "sound",
  "spatter": "build",
  "spatterdock": "heal",
  "spattering": "build",
  "spatula": "taste",
  "spawn": "heal",
  "spawner": "heal",
  "spay": "heal",
  "spaying": "heal",
  "speak": "story",
  "speakeasy": "build",
  "speaker": "sound",
  "speakerphone": "build",
  "speaking": "story",
  "spear": "build",
  "spear-point": "build",
  "spearfish": "heal",
  "spearhead": "build",
  "spearmint": "heal",
  "spearpoint": "build",
  "spec": "story",
  "special": "story",
  "specialisation": "smart",
  "specialise": "sell",
  "specialised": "sell",
  "specialism": "smart",
  "specialistic": "beautiful",
  "specialization": "smart",
  "specialize": "story",
  "specialized": "story",
  "speciation": "smart",
  "specie": "sell",
  "species": "smart",
  "specific": "smart",
  "specification": "build",
  "specified": "story",
  "specify": "story",
  "specimen": "smart",
  "speck": "smart",
  "speckle": "build",
  "specs": "build",
  "spectacle": "story",
  "spectacles": "build",
  "spectacular": "story",
  "spectate": "sound",
  "spectator": "build",
  "specter": "smart",
  "spectinomycin": "build",
  "spectral": "beautiful",
  "spectre": "smart",
  "spectrogram": "build",
  "spectrograph": "build",
  "spectrometer": "build",
  "spectrophotometer": "build",
  "spectroscope": "build",
  "spectrum": "sound",
  "speculate": "smart",
  "speculation": "story",
  "speculum": "build",
  "speech": "story",
  "speech-read": "smart",
  "speechify": "story",
  "speechmaking": "story",
  "speed-reading": "smart",
  "speedboat": "build",
  "speedometer": "build",
  "speedway": "build",
  "speedwell": "heal",
  "spelaeology": "smart",
  "speleology": "smart",
  "spell": "story",
  "spell-checker": "story",
  "spellbind": "story",
  "speller": "story",
  "spelling": "story",
  "spelt": "heal",
  "spelunk": "smart",
  "spend": "sell",
  "spending": "sell",
  "spendthrift": "beautiful",
  "spent": "sell",
  "spergula": "heal",
  "spergularia": "heal",
  "sperm": "heal",
  "spermatid": "heal",
  "spermatocele": "heal",
  "spermatocide": "build",
  "spermatocyte": "heal",
  "spermatogenesis": "smart",
  "spermatophyta": "heal",
  "spermatophyte": "heal",
  "spermatozoan": "heal",
  "spermatozoid": "heal",
  "spermatozoon": "heal",
  "spermicide": "build",
  "spermophile": "heal",
  "spermophilus": "heal",
  "spew": "heal",
  "sphacelate": "heal",
  "sphacele": "heal",
  "sphacelotheca": "heal",
  "sphacelus": "sound",
  "sphaeralcea": "heal",
  "sphaeriaceae": "heal",
  "sphaeriales": "heal",
  "sphaerobolaceae": "heal",
  "sphaerocarpaceae": "heal",
  "sphaerocarpales": "heal",
  "sphaerocarpos": "heal",
  "sphaerocarpus": "heal",
  "sphagnales": "heal",
  "sphagnum": "heal",
  "sphecidae": "heal",
  "sphecius": "heal",
  "sphecoid": "heal",
  "sphecoidea": "heal",
  "sphecotheres": "heal",
  "sphenion": "heal",
  "spheniscidae": "heal",
  "sphenisciformes": "heal",
  "spheniscus": "heal",
  "sphenodon": "heal",
  "sphenoid": "heal",
  "sphenopsida": "heal",
  "sphere": "build",
  "spherical": "beautiful",
  "spherocyte": "heal",
  "spherometer": "build",
  "sphincter": "heal",
  "sphingid": "heal",
  "sphingidae": "heal",
  "sphinx": "build",
  "sphygmomanometer": "build",
  "sphyraena": "heal",
  "sphyraenidae": "heal",
  "sphyrapicus": "heal",
  "sphyrna": "heal",
  "sphyrnidae": "heal",
  "spic": "beautiful",
  "spice": "taste",
  "spiceberry": "heal",
  "spicebush": "heal",
  "spicemill": "build",
  "spick": "beautiful",
  "spicule": "heal",
  "spiculum": "heal",
  "spider": "heal",
  "spiderflower": "heal",
  "spiderwort": "heal",
  "spiel": "story",
  "spigot": "build",
  "spike": "build",
  "spikelet": "heal",
  "spikemoss": "heal",
  "spikenard": "build",
  "spile": "build",
  "spill": "build",
  "spillage": "smart",
  "spiller": "build",
  "spillikin": "build",
  "spillikins": "build",
  "spillover": "sound",
  "spillway": "build",
  "spilogale": "heal",
  "spin-off": "build",
  "spinach": "heal",
  "spinacia": "heal",
  "spindle": "heal",
  "spindleberry": "heal",
  "spindlelegs": "heal",
  "spindleshanks": "heal",
  "spine": "heal",
  "spineless": "beautiful",
  "spinet": "build",
  "spinnaker": "build",
  "spinner": "build",
  "spinous": "beautiful",
  "spinus": "heal",
  "spiny": "beautiful",
  "spiracle": "heal",
  "spiraea": "heal",
  "spiral": "smart",
  "spirant": "story",
  "spiranthes": "heal",
  "spire": "build",
  "spirea": "heal",
  "spirilla": "heal",
  "spirillaceae": "heal",
  "spirillum": "heal",
  "spirited": "beautiful",
  "spiritise": "build",
  "spiritize": "build",
  "spiritless": "beautiful",
  "spirits": "taste",
  "spiritual": "story",
  "spiritualise": "smart",
  "spiritualism": "smart",
  "spirituality": "sell",
  "spiritualize": "smart",
  "spiritualty": "sell",
  "spirochaeta": "heal",
  "spirochaetaceae": "heal",
  "spirochaetales": "heal",
  "spirochaete": "heal",
  "spirochete": "heal",
  "spirodela": "heal",
  "spirogram": "build",
  "spirograph": "build",
  "spirogyra": "heal",
  "spirometer": "build",
  "spirula": "heal",
  "spirulidae": "heal",
  "spit": "heal",
  "spitball": "build",
  "spitting": "heal",
  "spittle": "heal",
  "spittlebug": "heal",
  "spittoon": "build",
  "spitz": "heal",
  "spizella": "heal",
  "splash": "smart",
  "splash-guard": "build",
  "splashboard": "build",
  "splasher": "build",
  "splashing": "build",
  "splashy": "beautiful",
  "splat": "build",
  "splatter": "smart",
  "splattering": "build",
  "splay": "build",
  "splayfoot": "heal",
  "splayfooted": "beautiful",
  "spleen": "heal",
  "spleenwort": "heal",
  "splenetic": "beautiful",
  "splenius": "heal",
  "splice": "build",
  "splicer": "build",
  "splicing": "build",
  "spliff": "build",
  "spline": "build",
  "splint": "heal",
  "splinter": "sell",
  "splintering": "sell",
  "splinters": "sell",
  "splintery": "beautiful",
  "split": "smart",
  "split-pea": "taste",
  "splitsaw": "build",
  "splitworm": "heal",
  "splosh": "sound",
  "splotch": "build",
  "splurge": "story",
  "splutter": "story",
  "spode": "build",
  "spodoptera": "heal",
  "spoil": "sell",
  "spoilable": "taste",
  "spoilage": "smart",
  "spoiler": "build",
  "spoiling": "smart",
  "spoke": "build",
  "spoken": "story",
  "spokeshave": "build",
  "spondaise": "build",
  "spondaize": "build",
  "spondee": "story",
  "spondias": "heal",
  "sponge": "heal",
  "spongefly": "heal",
  "spongillafly": "heal",
  "spongioblast": "heal",
  "sponsor": "sell",
  "spontaneous": "beautiful",
  "spoof": "story",
  "spook": "smart",
  "spool": "build",
  "spoon": "build",
  "spoonbill": "heal",
  "spoonerism": "story",
  "spoonfeed": "taste",
  "spoonfeeding": "taste",
  "spoonflower": "heal",
  "spoonful": "smart",
  "sporadic": "beautiful",
  "sporangiophore": "heal",
  "sporangium": "heal",
  "sporanox": "build",
  "spore": "heal",
  "spork": "build",
  "sporobolus": "heal",
  "sporocarp": "heal",
  "sporophore": "heal",
  "sporophyl": "heal",
  "sporophyll": "heal",
  "sporophyte": "heal",
  "sporozoa": "heal",
  "sporozoan": "heal",
  "sporozoite": "heal",
  "sporran": "build",
  "sport": "sound",
  "sporting": "beautiful",
  "sportive": "beautiful",
  "sportscast": "story",
  "sportswear": "build",
  "sporulate": "build",
  "sporulation": "smart",
  "spot": "story",
  "spot-check": "smart",
  "spot-weld": "build",
  "spot-welder": "build",
  "spot-welding": "build",
  "spotlight": "build",
  "spots": "story",
  "spotting": "sound",
  "spotweld": "build",
  "spout": "build",
  "spouter": "build",
  "sprachgefuhl": "smart",
  "sprag": "build",
  "spraguea": "heal",
  "sprain": "heal",
  "sprat": "taste",
  "sprawl": "build",
  "sprawling": "build",
  "spray": "smart",
  "sprayer": "build",
  "spraying": "smart",
  "spread": "build",
  "spread-eagle": "heal",
  "spreader": "build",
  "spreadhead": "story",
  "spreading": "story",
  "spreadsheet": "story",
  "sprechgesang": "story",
  "sprechstimme": "story",
  "spree": "taste",
  "sprig": "heal",
  "sprigtail": "heal",
  "spring": "smart",
  "spring-clean": "build",
  "spring-cleaning": "build",
  "springboard": "build",
  "springbok": "heal",
  "springbuck": "heal",
  "springer": "build",
  "springtail": "heal",
  "sprinkle": "sound",
  "sprinkler": "build",
  "sprinkles": "taste",
  "sprinkling": "smart",
  "sprit": "build",
  "sprites": "sound",
  "spritsail": "build",
  "spritz": "build",
  "spritzer": "taste",
  "sprocket": "build",
  "sprout": "heal",
  "sprouting": "smart",
  "spruce": "heal",
  "spud": "taste",
  "spue": "heal",
  "spur": "story",
  "spurge": "heal",
  "spurn": "story",
  "spurring": "story",
  "sputnik": "build",
  "sputter": "story",
  "sputtering": "sound",
  "sputum": "heal",
  "spy": "sound",
  "spyeria": "heal",
  "spyglass": "build",
  "spyhole": "build",
  "spying": "sound",
  "spyware": "story",
  "squab": "taste",
  "squabble": "story",
  "squalidae": "heal",
  "squall": "sound",
  "squalus": "heal",
  "squama": "heal",
  "squamata": "heal",
  "squamule": "heal",
  "squander": "sell",
  "squandering": "sell",
  "square": "build",
  "square-rigger": "build",
  "squaretail": "heal",
  "squash": "heal",
  "squashed": "build",
  "squat": "smart",
  "squatina": "heal",
  "squatinidae": "heal",
  "squatter": "beautiful",
  "squatting": "build",
  "squaw-bush": "heal",
  "squawbush": "heal",
  "squawk": "story",
  "squawker": "build",
  "squawroot": "heal",
  "squeak": "sound",
  "squeaker": "build",
  "squeal": "story",
  "squealer": "heal",
  "squeegee": "build",
  "squeeze": "sell",
  "squeezer": "build",
  "squeezing": "build",
  "squelch": "story",
  "squelcher": "story",
  "squib": "build",
  "squid": "taste",
  "squiggle": "story",
  "squill": "heal",
  "squilla": "heal",
  "squillidae": "heal",
  "squinch": "build",
  "squint": "heal",
  "squint-eyed": "beautiful",
  "squinter": "beautiful",
  "squinty": "beautiful",
  "squirrel": "heal",
  "squirrelfish": "heal",
  "squirt": "build",
  "squirter": "build",
  "squish": "build",
  "ssri": "build",
  "st.-bruno's-lily": "heal",
  "stab": "build",
  "stabile": "build",
  "stabilise": "build",
  "stabiliser": "build",
  "stabilize": "build",
  "stabilizer": "build",
  "stable": "build",
  "stablemate": "heal",
  "stabling": "build",
  "staccato": "beautiful",
  "stachys": "heal",
  "stack": "smart",
  "stacked": "build",
  "stacks": "smart",
  "staddle": "build",
  "stadium": "build",
  "staff": "build",
  "stag": "heal",
  "stage": "build",
  "stagecoach": "build",
  "stagecraft": "smart",
  "staged": "build",
  "stagflation": "smart",
  "stagger": "build",
  "staggerbush": "heal",
  "staghead": "heal",
  "staghound": "heal",
  "staging": "story",
  "stagnate": "sell",
  "stain": "story",
  "stained": "build",
  "stainless": "beautiful",
  "stair": "build",
  "stair-carpet": "build",
  "stair-rod": "build",
  "staircase": "build",
  "stairhead": "build",
  "stairs": "build",
  "stairway": "build",
  "stairwell": "build",
  "stake": "sell",
  "stakes": "sell",
  "stale": "heal",
  "staleness": "smart",
  "stalinisation": "smart",
  "stalinization": "smart",
  "stalk": "heal",
  "stalked": "beautiful",
  "stalking-horse": "story",
  "stalkless": "beautiful",
  "stall": "build",
  "stallion": "heal",
  "stalls": "build",
  "stalwart": "beautiful",
  "stamen": "heal",
  "stamina": "heal",
  "stammel": "build",
  "stammer": "story",
  "stamp": "story",
  "stampede": "sell",
  "stamper": "build",
  "stance": "smart",
  "stanchion": "build",
  "stand": "build",
  "stand-down": "sound",
  "standard": "story",
  "standardise": "smart",
  "standardize": "smart",
  "standby": "build",
  "standdown": "sound",
  "standee": "build",
  "standing": "story",
  "standpipe": "build",
  "standpoint": "smart",
  "stanford": "build",
  "stanhope": "build",
  "stanhopea": "heal",
  "stanleya": "heal",
  "stanza": "story",
  "stapelia": "heal",
  "stapes": "heal",
  "staph": "heal",
  "staphylaceae": "heal",
  "staphylea": "heal",
  "staphylinidae": "heal",
  "staphylococci": "heal",
  "staphylococcus": "heal",
  "staple": "build",
  "staplegun": "build",
  "stapler": "build",
  "star-duckweed": "heal",
  "star-glory": "heal",
  "star-of-bethlehem": "heal",
  "star-thistle": "heal",
  "starboard": "build",
  "starches": "taste",
  "starchless": "beautiful",
  "starchy": "beautiful",
  "stare": "sound",
  "starfish": "heal",
  "starflower": "heal",
  "stargaze": "sound",
  "stargazer": "heal",
  "stargazing": "sound",
  "starless": "beautiful",
  "starlight": "sound",
  "starling": "heal",
  "starry": "beautiful",
  "starship": "build",
  "starter": "build",
  "starve": "taste",
  "starving": "taste",
  "starwort": "heal",
  "stash": "sell",
  "statehouse": "build",
  "statement": "story",
  "stater": "sell",
  "stateroom": "build",
  "statesmanlike": "beautiful",
  "statesmanly": "beautiful",
  "static": "story",
  "statice": "heal",
  "statics": "smart",
  "statin": "build",
  "station": "build",
  "stationery": "story",
  "stations": "build",
  "statistic": "smart",
  "statistics": "smart",
  "stative": "beautiful",
  "stator": "build",
  "statue": "build",
  "statuette": "build",
  "statute": "story",
  "statutory": "beautiful",
  "staunch": "beautiful",
  "staurikosaur": "heal",
  "staurikosaurus": "heal",
  "stave": "story",
  "stay": "story",
  "stay-at-home": "beautiful",
  "stayer": "heal",
  "stayman": "taste",
  "stays": "build",
  "staysail": "build",
  "std": "story",
  "steady": "build",
  "steak": "taste",
  "steakhouse": "taste",
  "steal": "sell",
  "stealing": "sell",
  "steam-heat": "sell",
  "steamboat": "build",
  "steamer": "taste",
  "steamroll": "sell",
  "steamroller": "build",
  "steamship": "build",
  "steatornis": "heal",
  "steatornithidae": "heal",
  "steed": "heal",
  "steel": "build",
  "steelworks": "build",
  "steelyard": "build",
  "steenbok": "heal",
  "steep": "smart",
  "steeper": "build",
  "steeple": "build",
  "steeplechaser": "heal",
  "steer": "story",
  "steerage": "build",
  "steganopus": "heal",
  "stegocephalia": "heal",
  "stegosaur": "heal",
  "stegosaurus": "heal",
  "stein": "build",
  "steinbok": "heal",
  "stela": "build",
  "stele": "heal",
  "stelis": "heal",
  "stellar": "beautiful",
  "stellaria": "heal",
  "stem": "story",
  "stem-winder": "build",
  "stemless": "beautiful",
  "stemma": "heal",
  "stemmatics": "smart",
  "stemmatology": "smart",
  "stemmer": "smart",
  "stench": "smart",
  "stencil": "beautiful",
  "stenocarpus": "heal",
  "stenochlaena": "heal",
  "stenograph": "story",
  "stenography": "story",
  "stenopelmatidae": "heal",
  "stenopelmatus": "heal",
  "stenopterygius": "heal",
  "stenotaphrum": "heal",
  "stenotomus": "heal",
  "stenotus": "heal",
  "stent": "build",
  "stentor": "heal",
  "step": "smart",
  "step-in": "build",
  "stephanion": "heal",
  "stephanomeria": "heal",
  "stephanotis": "heal",
  "stephead": "story",
  "stepladder": "build",
  "stepper": "smart",
  "steps": "build",
  "steradian": "smart",
  "stercorariidae": "heal",
  "stercorarius": "heal",
  "sterculia": "heal",
  "sterculiaceae": "heal",
  "stereo": "sound",
  "stereophony": "build",
  "stereoscope": "build",
  "stereoscopy": "smart",
  "stereospondyli": "heal",
  "stereotype": "smart",
  "sterile": "beautiful",
  "sterilise": "heal",
  "steriliser": "build",
  "sterilize": "heal",
  "sterilizer": "build",
  "sterling": "sell",
  "stern": "build",
  "sterna": "heal",
  "sterninae": "heal",
  "sternocleidomastoid": "heal",
  "sternotherus": "heal",
  "sternpost": "build",
  "sternum": "heal",
  "sternutatory": "beautiful",
  "sternwheeler": "build",
  "steroid": "heal",
  "stet": "sell",
  "stethoscope": "heal",
  "stetson": "build",
  "stevia": "heal",
  "stew": "taste",
  "stewpan": "build",
  "sth": "heal",
  "sthene": "smart",
  "stichaeidae": "heal",
  "sticherus": "heal",
  "stick": "build",
  "stick-in-the-mud": "beautiful",
  "sticker": "heal",
  "stickle": "story",
  "stickleback": "heal",
  "stickpin": "build",
  "sticktight": "heal",
  "stickweed": "heal",
  "stictomys": "heal",
  "stictopelia": "heal",
  "stiff": "heal",
  "stiffening": "smart",
  "stifle": "heal",
  "stifling": "build",
  "stigma": "heal",
  "stigmata": "heal",
  "stigmatic": "beautiful",
  "stigmatise": "sell",
  "stigmatism": "smart",
  "stigmatize": "sell",
  "stilbesterol": "build",
  "stile": "build",
  "stiletto": "build",
  "still": "build",
  "stillroom": "build",
  "stilt": "build",
  "stiltbird": "heal",
  "stilton": "taste",
  "stimulant": "smart",
  "stimulate": "story",
  "stimulating": "story",
  "stimulation": "smart",
  "stimulative": "beautiful",
  "stimulus": "smart",
  "stingaree-bush": "heal",
  "stinger": "taste",
  "stinging": "sound",
  "stingray": "heal",
  "stingy": "beautiful",
  "stink": "smart",
  "stinkbird": "heal",
  "stinker": "build",
  "stinkhorn": "heal",
  "stinkpot": "heal",
  "stinkweed": "heal",
  "stinky": "beautiful",
  "stint": "heal",
  "stipe": "heal",
  "stipend": "sell",
  "stipendiary": "beautiful",
  "stipple": "build",
  "stipulate": "story",
  "stipulation": "story",
  "stipule": "heal",
  "stirk": "heal",
  "stirred": "sound",
  "stirrer": "build",
  "stirrup": "build",
  "stitch": "beautiful",
  "stitchery": "build",
  "stitching": "build",
  "stitchwort": "heal",
  "stizidae": "heal",
  "stizolobium": "heal",
  "stizostedion": "heal",
  "stm": "smart",
  "stoat": "heal",
  "stob": "build",
  "stock": "sell",
  "stock-in-trade": "build",
  "stock-take": "sell",
  "stock-taking": "smart",
  "stockade": "build",
  "stockcar": "build",
  "stocker": "heal",
  "stockfish": "taste",
  "stockholding": "sell",
  "stockholdings": "sell",
  "stockhorn": "build",
  "stockinet": "build",
  "stockinette": "build",
  "stocking": "build",
  "stockpile": "sell",
  "stockpiling": "sell",
  "stockpot": "build",
  "stockroom": "build",
  "stocks": "build",
  "stocktaking": "smart",
  "stockyard": "build",
  "stodge": "taste",
  "stoep": "build",
  "stogie": "build",
  "stogy": "build",
  "stoic": "beautiful",
  "stoicism": "smart",
  "stoke": "sell",
  "stokehold": "build",
  "stokehole": "build",
  "stoker": "build",
  "stokesia": "heal",
  "stole": "build",
  "stolon": "heal",
  "stoma": "heal",
  "stomach": "heal",
  "stomacher": "build",
  "stomate": "heal",
  "stomatopod": "heal",
  "stomatopoda": "heal",
  "stomatous": "beautiful",
  "stomp": "sound",
  "stone": "build",
  "stone-face": "heal",
  "stone-root": "heal",
  "stone-wash": "build",
  "stonechat": "heal",
  "stonecress": "heal",
  "stonecrop": "heal",
  "stoneface": "heal",
  "stonefish": "heal",
  "stonefly": "heal",
  "stoner": "beautiful",
  "stoneroot": "heal",
  "stonewall": "story",
  "stonewalling": "story",
  "stoneware": "beautiful",
  "stonewash": "build",
  "stonework": "build",
  "stonewort": "heal",
  "stoning": "build",
  "stooge": "build",
  "stool": "build",
  "stoop": "build",
  "stopcock": "build",
  "stopes": "sell",
  "stoplight": "story",
  "stoppable": "beautiful",
  "stoppage": "build",
  "stopper": "story",
  "stopping": "build",
  "stopple": "build",
  "stopwatch": "build",
  "storage": "build",
  "storax": "heal",
  "store": "build",
  "storefront": "build",
  "storehouse": "build",
  "storeria": "heal",
  "storeroom": "build",
  "storey": "build",
  "stork": "heal",
  "storksbill": "heal",
  "storm": "sound",
  "stormy": "beautiful",
  "story": "story",
  "storybook": "story",
  "storyline": "story",
  "stotinka": "smart",
  "stoup": "build",
  "stout": "taste",
  "stove": "taste",
  "stovepipe": "build",
  "stovepiped": "smart",
  "stovepiping": "smart",
  "stover": "taste",
  "stow": "build",
  "stowage": "sell",
  "stowing": "build",
  "stp": "smart",
  "strad": "build",
  "stradavarius": "build",
  "straddle": "smart",
  "straight": "build",
  "straightaway": "build",
  "straightedge": "build",
  "straighten": "build",
  "straightener": "build",
  "straightjacket": "build",
  "strain": "sound",
  "strainer": "build",
  "strait": "beautiful",
  "straiten": "sell",
  "straitjacket": "smart",
  "strake": "build",
  "strand": "smart",
  "strange": "beautiful",
  "strangeness": "smart",
  "stranger": "beautiful",
  "strangle": "build",
  "strangler": "heal",
  "strangles": "build",
  "strangling": "build",
  "strangulate": "build",
  "strangulation": "heal",
  "strap": "build",
  "strapless": "build",
  "stratagem": "smart",
  "strategic": "beautiful",
  "strategics": "smart",
  "strategy": "smart",
  "stratification": "smart",
  "stratified": "sell",
  "stratify": "sell",
  "stratigraphy": "smart",
  "stratum": "smart",
  "stravinsky": "story",
  "straw": "build",
  "strawberry": "taste",
  "strawflower": "heal",
  "strawman": "story",
  "strawworm": "heal",
  "stray": "heal",
  "strayer": "beautiful",
  "streamer": "sound",
  "streaming": "sound",
  "streamline": "build",
  "streamliner": "build",
  "street": "build",
  "street-walk": "sell",
  "streetcar": "build",
  "streetlight": "build",
  "streetwalk": "sell",
  "strekelia": "heal",
  "strelitzia": "heal",
  "strelitziaceae": "heal",
  "strengthen": "heal",
  "strengthener": "build",
  "strep": "heal",
  "strepera": "heal",
  "strepsiceros": "heal",
  "strepsirhini": "heal",
  "streptobacillus": "heal",
  "streptocarpus": "heal",
  "streptococci": "heal",
  "streptococcus": "heal",
  "streptomyces": "heal",
  "streptomycetaceae": "heal",
  "streptomycin": "build",
  "streptopelia": "heal",
  "streptosolen": "heal",
  "streptothricin": "build",
  "stress": "story",
  "stressed": "story",
  "stretch": "build",
  "stretcher": "heal",
  "stretching": "beautiful",
  "streusel": "taste",
  "strew": "build",
  "strewing": "build",
  "striatum": "heal",
  "strickle": "build",
  "strict": "beautiful",
  "stricture": "story",
  "stride": "smart",
  "stridence": "sound",
  "stridency": "sound",
  "stridulate": "sound",
  "strigidae": "heal",
  "strigiformes": "heal",
  "striking": "build",
  "string": "build",
  "stringer": "build",
  "strings": "build",
  "stringybark": "heal",
  "strip": "build",
  "strip-search": "build",
  "stripe": "build",
  "striper": "taste",
  "stripes": "story",
  "striping": "build",
  "stripper": "build",
  "stripping": "sell",
  "strive": "sell",
  "striving": "sell",
  "strix": "heal",
  "strobe": "build",
  "strobile": "heal",
  "strobilomyces": "heal",
  "strobilus": "heal",
  "stroboscope": "build",
  "stroking": "build",
  "stroller": "build",
  "stroma": "heal",
  "stromateid": "heal",
  "stromateidae": "heal",
  "strombidae": "heal",
  "strombus": "heal",
  "strong": "beautiful",
  "strong-arm": "sell",
  "strong-armer": "beautiful",
  "strongbox": "build",
  "stronghold": "build",
  "strongroom": "build",
  "strongylodon": "heal",
  "strop": "build",
  "strophanthus": "heal",
  "stropharia": "heal",
  "strophariaceae": "heal",
  "strophe": "story",
  "structural": "beautiful",
  "structuralism": "smart",
  "structure": "build",
  "structured": "beautiful",
  "strudel": "taste",
  "struggle": "sell",
  "strum": "sound",
  "strung": "build",
  "strut": "build",
  "struthio": "heal",
  "struthiomimus": "heal",
  "struthionidae": "heal",
  "struthioniformes": "heal",
  "strymon": "heal",
  "stub": "story",
  "stubble": "heal",
  "stubborn": "beautiful",
  "stucco": "build",
  "stuck": "build",
  "stud": "build",
  "studbook": "story",
  "studhorse": "heal",
  "studied": "smart",
  "studio": "build",
  "study": "smart",
  "studying": "story",
  "stuff": "build",
  "stuffer": "story",
  "stuffing": "taste",
  "stultification": "story",
  "stultify": "story",
  "stump": "heal",
  "stumper": "story",
  "stumping": "smart",
  "stumpknocker": "heal",
  "stun": "build",
  "stunt": "heal",
  "stunting": "sell",
  "stupa": "build",
  "stupefaction": "smart",
  "stupefy": "sound",
  "stupid": "beautiful",
  "stupidity": "smart",
  "stupor": "smart",
  "sturdy": "beautiful",
  "sturgeon": "heal",
  "sturnella": "heal",
  "sturnidae": "heal",
  "sturnus": "heal",
  "stutter": "story",
  "sty": "build",
  "style": "story",
  "styleless": "beautiful",
  "stylet": "heal",
  "stylise": "build",
  "stylish": "beautiful",
  "stylize": "build",
  "stylomecon": "heal",
  "stylophorum": "heal",
  "stylopodium": "heal",
  "stylus": "build",
  "stymie": "smart",
  "stymy": "smart",
  "styphelia": "heal",
  "styptic": "build",
  "styracaceae": "heal",
  "styracosaur": "heal",
  "styracosaurus": "heal",
  "styrax": "heal",
  "suasion": "story",
  "sub": "taste",
  "sub-assembly": "build",
  "sub-interval": "smart",
  "subaltern": "beautiful",
  "subartesian": "beautiful",
  "subatomic": "beautiful",
  "subbase": "build",
  "subbing": "sell",
  "subcompact": "build",
  "subconscious": "smart",
  "subconsciousness": "smart",
  "subcontract": "story",
  "subdirectory": "story",
  "subdivision": "smart",
  "subdominant": "story",
  "subduction": "smart",
  "subdue": "sell",
  "subedit": "smart",
  "subgroup": "smart",
  "subhead": "story",
  "subheading": "story",
  "subhuman": "beautiful",
  "subjacent": "beautiful",
  "subject": "story",
  "subjective": "beautiful",
  "subjectivism": "smart",
  "subjoin": "build",
  "subjoining": "build",
  "subjugate": "sell",
  "sublease": "sell",
  "sublet": "sell",
  "sublimated": "taste",
  "sublimaze": "build",
  "sublime": "beautiful",
  "sublunar": "beautiful",
  "sublunary": "beautiful",
  "subluxate": "heal",
  "submarine": "build",
  "submaxilla": "heal",
  "submediant": "story",
  "submenu": "story",
  "submerge": "build",
  "submergible": "beautiful",
  "submerging": "build",
  "submerse": "build",
  "submersible": "build",
  "submission": "story",
  "submissive": "beautiful",
  "submit": "story",
  "submucosa": "heal",
  "subnormal": "beautiful",
  "subnormality": "smart",
  "subordinate": "story",
  "subordinating": "smart",
  "subordinative": "beautiful",
  "suborn": "sell",
  "subornation": "story",
  "subpoena": "story",
  "subpopulation": "smart",
  "subprogram": "story",
  "subrogate": "sell",
  "subroutine": "story",
  "subscribe": "sell",
  "subscript": "story",
  "subscription": "sell",
  "subsection": "build",
  "subsequent": "beautiful",
  "subserve": "sell",
  "subshrub": "heal",
  "subsidiary": "beautiful",
  "subsidisation": "sell",
  "subsidise": "sell",
  "subsidization": "sell",
  "subsidize": "sell",
  "subsidy": "sell",
  "subsistence": "sell",
  "subsonic": "beautiful",
  "substance": "smart",
  "substantial": "beautiful",
  "substantiate": "smart",
  "substantiation": "smart",
  "substantive": "story",
  "substation": "build",
  "substitute": "smart",
  "substituting": "sell",
  "substrate": "story",
  "substratum": "story",
  "substring": "story",
  "substructure": "build",
  "subsume": "smart",
  "subsumption": "story",
  "subsurface": "smart",
  "subterfuge": "story",
  "subthalamus": "heal",
  "subtilin": "build",
  "subtilize": "smart",
  "subtitle": "story",
  "subtlety": "story",
  "subtonic": "story",
  "subtotal": "smart",
  "subtract": "smart",
  "subtracter": "build",
  "subtractive": "beautiful",
  "subtrahend": "smart",
  "subtreasury": "sell",
  "subularia": "heal",
  "subunit": "smart",
  "subvent": "story",
  "subvention": "sell",
  "subversive": "beautiful",
  "subvert": "sell",
  "subvocalise": "story",
  "subvocalize": "story",
  "subway": "build",
  "subwoofer": "sound",
  "succade": "taste",
  "succedaneum": "smart",
  "succeed": "sell",
  "succeeding": "sell",
  "successful": "beautiful",
  "succession": "smart",
  "successor": "smart",
  "succinctness": "story",
  "succinylcholine": "build",
  "succor": "sell",
  "succory": "heal",
  "succotash": "taste",
  "succour": "sell",
  "succulent": "heal",
  "succumb": "story",
  "succus": "heal",
  "succuss": "heal",
  "suck": "taste",
  "sucker": "heal",
  "suckerfish": "heal",
  "sucking": "taste",
  "suckle": "taste",
  "suckling": "heal",
  "sucralfate": "build",
  "sucre": "smart",
  "suction": "sound",
  "sudafed": "build",
  "sudate": "heal",
  "sudation": "smart",
  "sudatorium": "build",
  "sudatory": "build",
  "sudden": "beautiful",
  "sudoku": "story",
  "sudor": "heal",
  "sudorific": "build",
  "suds": "taste",
  "sue": "sell",
  "suede": "build",
  "suet": "taste",
  "suffer": "sound",
  "sufficiency": "smart",
  "sufficient": "beautiful",
  "suffix": "story",
  "suffocate": "build",
  "suffragism": "smart",
  "suffrutex": "heal",
  "suffusion": "smart",
  "sufism": "smart",
  "sugar": "taste",
  "sugar-bush": "heal",
  "sugarberry": "heal",
  "sugarcane": "heal",
  "sugarcoat": "sound",
  "sugariness": "smart",
  "sugarless": "beautiful",
  "sugarloaf": "taste",
  "sugarplum": "taste",
  "sugary": "beautiful",
  "suggest": "story",
  "suggestion": "smart",
  "sugi": "heal",
  "suidae": "heal",
  "suillus": "heal",
  "suit": "build",
  "suitcase": "build",
  "suite": "story",
  "suiting": "build",
  "sukiyaki": "taste",
  "suksdorfia": "heal",
  "sukur": "story",
  "sula": "heal",
  "sulamyd": "build",
  "sulcus": "heal",
  "sulfa": "build",
  "sulfacetamide": "build",
  "sulfadiazine": "build",
  "sulfamethazine": "build",
  "sulfamethoxazole": "build",
  "sulfamezathine": "build",
  "sulfanilamide": "build",
  "sulfapyridine": "build",
  "sulfisoxazole": "build",
  "sulfonamide": "build",
  "sulfonylurea": "build",
  "sulfurette": "build",
  "sulfuretted": "build",
  "sulfurous": "beautiful",
  "sulidae": "heal",
  "sulindac": "build",
  "sulky": "build",
  "sulla": "heal",
  "sully": "build",
  "sulpha": "build",
  "sulphurette": "build",
  "sulphurous": "beautiful",
  "sultana": "taste",
  "sultriness": "sound",
  "sum": "sell",
  "sum-up": "story",
  "sumac": "heal",
  "sumach": "heal",
  "sumerology": "smart",
  "summarisation": "story",
  "summarise": "story",
  "summarization": "story",
  "summarize": "story",
  "summary": "story",
  "summate": "story",
  "summation": "story",
  "summercater": "sound",
  "summercaters": "sound",
  "summerhouse": "build",
  "summery": "beautiful",
  "summon": "story",
  "summoning": "smart",
  "summons": "story",
  "sump": "build",
  "sumpsimus": "story",
  "sumpter": "heal",
  "sun": "sound",
  "sun-ray": "sound",
  "sunbathe": "heal",
  "sunbeam": "sound",
  "sunberry": "heal",
  "sunblind": "build",
  "sunblock": "build",
  "sunbonnet": "build",
  "sunburn": "heal",
  "sunburst": "sound",
  "sunchoke": "taste",
  "sundacarpus": "heal",
  "sundae": "taste",
  "sundanese": "story",
  "sundew": "heal",
  "sundial": "build",
  "sundog": "sound",
  "sundowner": "taste",
  "sundress": "build",
  "sundries": "build",
  "sundrops": "heal",
  "sunfish": "taste",
  "sunflower": "heal",
  "sung": "build",
  "sunglass": "build",
  "sunglasses": "build",
  "sunhat": "build",
  "sunlamp": "build",
  "sunlight": "sound",
  "sunporch": "build",
  "sunray": "sound",
  "sunrise": "sound",
  "sunroof": "build",
  "sunroom": "build",
  "sunrose": "heal",
  "sunscreen": "build",
  "sunset": "sound",
  "sunshade": "build",
  "sunshine": "sound",
  "sunshine-roof": "build",
  "sunspot": "sound",
  "sunsuit": "build",
  "suntan": "heal",
  "suntrap": "build",
  "suomi": "story",
  "sup": "taste",
  "super": "beautiful",
  "superannuate": "sell",
  "superannuation": "sell",
  "superbug": "heal",
  "supercede": "sell",
  "supercharger": "build",
  "supercilium": "heal",
  "supercomputer": "build",
  "superconductivity": "sound",
  "superego": "smart",
  "superfetate": "heal",
  "superficial": "beautiful",
  "superficies": "build",
  "superfund": "smart",
  "superhet": "build",
  "superhighway": "build",
  "superhuman": "beautiful",
  "superimpose": "build",
  "superinfect": "heal",
  "superintend": "sell",
  "superjacent": "beautiful",
  "superlative": "story",
  "superload": "build",
  "superlunar": "beautiful",
  "superlunary": "beautiful",
  "superman": "build",
  "supermarket": "build",
  "supernal": "beautiful",
  "supernatant": "beautiful",
  "supernatural": "beautiful",
  "supernaturalism": "smart",
  "supernumerary": "beautiful",
  "superordinate": "story",
  "superpose": "build",
  "superposition": "smart",
  "superscribe": "build",
  "superscript": "story",
  "superscription": "story",
  "supersede": "sell",
  "superslasher": "heal",
  "supersonic": "beautiful",
  "superstition": "smart",
  "superstrate": "story",
  "superstratum": "story",
  "superstructure": "build",
  "supersymmetry": "smart",
  "supertanker": "build",
  "supertax": "sell",
  "supertitle": "story",
  "supertonic": "story",
  "supertwister": "sound",
  "supervise": "sell",
  "supervised": "sell",
  "supervising": "sell",
  "supervisor": "story",
  "supinator": "heal",
  "supper": "taste",
  "supping": "taste",
  "supplant": "sell",
  "supplanting": "sell",
  "supple": "beautiful",
  "supplejack": "build",
  "supplement": "story",
  "suppliant": "beautiful",
  "supplicant": "beautiful",
  "supplicate": "story",
  "supplication": "story",
  "supply": "sell",
  "supplying": "sell",
  "support": "smart",
  "supported": "sell",
  "supporter": "build",
  "supporting": "sell",
  "supportive": "beautiful",
  "supposal": "smart",
  "suppose": "story",
  "supposition": "story",
  "suppository": "build",
  "suppress": "sell",
  "suppressant": "build",
  "suppressed": "sell",
  "suppresser": "heal",
  "suppression": "smart",
  "suppressor": "heal",
  "suppurate": "heal",
  "suppuration": "smart",
  "supremacism": "smart",
  "sura": "story",
  "surbase": "build",
  "surcharge": "sell",
  "surcoat": "build",
  "surd": "story",
  "sure": "beautiful",
  "sureness": "smart",
  "surety": "sell",
  "surf": "build",
  "surface": "build",
  "surface-assimilative": "beautiful",
  "surface-mine": "taste",
  "surface-to-air": "beautiful",
  "surfacing": "build",
  "surfbird": "heal",
  "surfboard": "build",
  "surfboat": "build",
  "surfeit": "sell",
  "surffish": "heal",
  "surfing": "build",
  "surfperch": "heal",
  "surgeonfish": "heal",
  "surgery": "heal",
  "surgical": "heal",
  "suricata": "heal",
  "suricate": "heal",
  "surmisal": "story",
  "surmise": "story",
  "surmontil": "build",
  "surmountable": "beautiful",
  "surmullet": "heal",
  "surname": "story",
  "surnia": "heal",
  "surplice": "build",
  "surplus": "beautiful",
  "surprint": "build",
  "surprise": "smart",
  "surprised": "smart",
  "surprising": "smart",
  "surrebuttal": "story",
  "surrebutter": "story",
  "surrejoinder": "story",
  "surrender": "story",
  "surrey": "build",
  "surrogate": "beautiful",
  "surround": "sound",
  "surtax": "sell",
  "surtitle": "story",
  "surtout": "build",
  "surveil": "sound",
  "survey": "story",
  "surveying": "smart",
  "survival": "smart",
  "survivor": "heal",
  "sus": "heal",
  "susanna": "story",
  "susceptible": "beautiful",
  "sushi": "taste",
  "susian": "story",
  "suslik": "heal",
  "suspect": "story",
  "suspected": "story",
  "suspend": "build",
  "suspender": "build",
  "suspense": "smart",
  "suspension": "sound",
  "suspensor": "build",
  "suspensory": "build",
  "suspicion": "smart",
  "suspiration": "story",
  "suspire": "heal",
  "sustain": "heal",
  "sustenance": "taste",
  "susurrate": "story",
  "susurration": "story",
  "sutra": "story",
  "sutura": "heal",
  "suture": "heal",
  "suturing": "build",
  "suv": "build",
  "swab": "build",
  "swabbing": "build",
  "swaddle": "build",
  "swag": "sell",
  "swage": "build",
  "swagger": "story",
  "swaggerer": "beautiful",
  "swahili": "story",
  "swainsona": "heal",
  "swallow": "taste",
  "swallowtail": "build",
  "swallowwort": "heal",
  "swamp": "build",
  "swamphen": "heal",
  "swan": "heal",
  "swan-flower": "heal",
  "swan-neck": "heal",
  "swanflower": "heal",
  "swank": "sound",
  "swanneck": "heal",
  "swap": "sell",
  "swash": "build",
  "swashbuckling": "beautiful",
  "swastika": "story",
  "swat": "build",
  "swatch": "build",
  "swath": "smart",
  "swathe": "build",
  "swathing": "build",
  "swatter": "build",
  "swazi": "story",
  "swear": "story",
  "swearing": "story",
  "swearword": "story",
  "sweat": "heal",
  "sweatband": "build",
  "sweatbox": "build",
  "sweater": "build",
  "sweating": "smart",
  "sweatpants": "build",
  "sweats": "build",
  "sweatshirt": "build",
  "sweatshop": "build",
  "sweatsuit": "build",
  "swede": "heal",
  "swedish": "story",
  "sweep": "build",
  "sweep-second": "build",
  "sweeper": "build",
  "sweeping": "build",
  "sweet": "taste",
  "sweet-talk": "story",
  "sweetbread": "taste",
  "sweetbreads": "taste",
  "sweetbriar": "heal",
  "sweetbrier": "heal",
  "sweeten": "sound",
  "sweetener": "taste",
  "sweetening": "taste",
  "sweetheart": "beautiful",
  "sweetleaf": "heal",
  "sweetmeat": "taste",
  "sweetness": "smart",
  "sweetpea": "heal",
  "sweetsop": "heal",
  "swelling": "smart",
  "swelter": "heal",
  "swept": "build",
  "swertia": "heal",
  "swietinia": "heal",
  "swift": "heal",
  "swiftlet": "heal",
  "swig": "build",
  "swill": "taste",
  "swilling": "taste",
  "swimmeret": "heal",
  "swimsuit": "build",
  "swimwear": "build",
  "swindle": "sell",
  "swine": "heal",
  "swing": "build",
  "swingletree": "build",
  "swipe": "build",
  "swish": "sound",
  "switch": "build",
  "switch-hit": "build",
  "switch-ivy": "heal",
  "switchblade": "build",
  "switchboard": "build",
  "switching": "sell",
  "swivel": "build",
  "swizzle": "taste",
  "swob": "build",
  "swoon": "heal",
  "swoop": "story",
  "swoosh": "sound",
  "swop": "sell",
  "sword": "build",
  "swordfish": "taste",
  "swordsmanship": "smart",
  "swordtail": "heal",
  "sworn": "story",
  "swosh": "sound",
  "swot": "smart",
  "sycamore": "heal",
  "syconium": "heal",
  "syllabary": "story",
  "syllabic": "beautiful",
  "syllabicate": "build",
  "syllabicity": "story",
  "syllabify": "build",
  "syllabise": "build",
  "syllabize": "build",
  "syllable": "story",
  "syllabub": "taste",
  "syllabus": "story",
  "syllepsis": "story",
  "syllogise": "smart",
  "syllogism": "smart",
  "syllogize": "smart",
  "sylvan": "beautiful",
  "sylviidae": "heal",
  "sylviinae": "heal",
  "sylvilagus": "heal",
  "symbol": "story",
  "symbolic": "beautiful",
  "symbolical": "beautiful",
  "symbolisation": "story",
  "symbolise": "story",
  "symbolising": "story",
  "symbolism": "story",
  "symbolization": "story",
  "symbolize": "story",
  "symbolizing": "story",
  "symbology": "smart",
  "symmetric": "beautiful",
  "symmetrical": "beautiful",
  "sympathetic": "beautiful",
  "sympathise": "smart",
  "sympathize": "smart",
  "sympathy": "smart",
  "sympatric": "beautiful",
  "symphalangus": "heal",
  "symphilid": "heal",
  "symphonic": "sound",
  "symphonise": "build",
  "symphonize": "build",
  "symphony": "sound",
  "symphoricarpos": "heal",
  "symphyla": "heal",
  "symphysion": "heal",
  "symphysis": "smart",
  "symphytum": "heal",
  "symplocaceae": "heal",
  "symplocarpus": "heal",
  "symploce": "story",
  "symplocus": "heal",
  "symptom": "heal",
  "symptomatic": "beautiful",
  "synaeresis": "smart",
  "synaesthesia": "smart",
  "synagogue": "build",
  "synagrops": "heal",
  "synanceja": "heal",
  "synapse": "heal",
  "synapsid": "heal",
  "synapsida": "heal",
  "synapsis": "smart",
  "synaptomys": "heal",
  "syncarp": "heal",
  "syncarpous": "beautiful",
  "syncategorem": "story",
  "syncategorematic": "beautiful",
  "syncategoreme": "story",
  "synchro": "build",
  "synchrocyclotron": "build",
  "synchroflash": "build",
  "synchromesh": "build",
  "synchronal": "beautiful",
  "synchronic": "beautiful",
  "synchronise": "story",
  "synchroniser": "build",
  "synchronising": "story",
  "synchronize": "story",
  "synchronizer": "build",
  "synchronoscope": "build",
  "synchronous": "beautiful",
  "synchroscope": "build",
  "synchrotron": "build",
  "synchytriaceae": "heal",
  "synchytrium": "heal",
  "synclinal": "beautiful",
  "syncopation": "story",
  "syncope": "story",
  "syncretism": "smart",
  "syncytium": "heal",
  "syndetic": "beautiful",
  "syndicate": "sell",
  "syndrome": "smart",
  "synecdoche": "story",
  "synentognathi": "heal",
  "synercus": "heal",
  "syneresis": "smart",
  "synergism": "smart",
  "synergist": "build",
  "synergistic": "beautiful",
  "synergy": "smart",
  "synesthesia": "smart",
  "synezesis": "smart",
  "syngnathidae": "heal",
  "syngnathus": "heal",
  "syngonium": "heal",
  "synizesis": "smart",
  "synodontidae": "heal",
  "synonym": "story",
  "synonymous": "beautiful",
  "synopsis": "story",
  "synoptic": "beautiful",
  "synoptics": "story",
  "synovia": "heal",
  "synovium": "heal",
  "syntagm": "story",
  "syntagma": "story",
  "syntax": "smart",
  "synthesis": "smart",
  "synthesise": "smart",
  "synthesiser": "build",
  "synthesist": "sound",
  "synthesize": "sound",
  "synthesizer": "sound",
  "synthetic": "beautiful",
  "synthetical": "beautiful",
  "synthetism": "build",
  "syphon": "build",
  "syringa": "heal",
  "syringe": "heal",
  "syrinx": "build",
  "syrrhaptes": "heal",
  "syrup": "taste",
  "system": "build",
  "systematic": "beautiful",
  "systematics": "smart",
  "syzygium": "heal",
  "syzygy": "sound",
  "t-bar": "build",
  "t-bill": "sell",
  "t-junction": "build",
  "t-network": "build",
  "t-scope": "build",
  "t-shirt": "build",
  "t-square": "build",
  "ta'ziyeh": "story",
  "taal": "story",
  "tab": "story",
  "tabanidae": "heal",
  "tabard": "build",
  "tabasco": "taste",
  "tabbouleh": "taste",
  "tabby": "heal",
  "tabernacle": "build",
  "tabernacles": "build",
  "tabernaemontana": "heal",
  "tabi": "build",
  "tabis": "build",
  "tablature": "story",
  "table": "build",
  "tableau": "smart",
  "tablecloth": "build",
  "tablefork": "build",
  "tablespoon": "smart",
  "tablespoonful": "smart",
  "tablet": "build",
  "tabletop": "build",
  "tableware": "build",
  "tabloid": "story",
  "taboo": "smart",
  "tabooli": "taste",
  "tabor": "build",
  "taboret": "build",
  "tabour": "build",
  "tabouret": "build",
  "tabu": "smart",
  "tabular": "beautiful",
  "tabularise": "build",
  "tabularize": "build",
  "tabulate": "build",
  "tabulation": "story",
  "tabulator": "build",
  "tabun": "sound",
  "tacamahac": "heal",
  "tacca": "heal",
  "taccaceae": "heal",
  "tach": "build",
  "tacheometer": "build",
  "tachinidae": "heal",
  "tachistoscope": "build",
  "tachogram": "story",
  "tachograph": "build",
  "tachometer": "build",
  "tachyglossidae": "heal",
  "tachyglossus": "heal",
  "tachygraphy": "story",
  "tachymeter": "build",
  "tachypleus": "heal",
  "taciturn": "beautiful",
  "tack": "build",
  "tacker": "build",
  "tacking": "build",
  "tackle": "build",
  "taco": "taste",
  "tactful": "beautiful",
  "tactic": "smart",
  "tactics": "smart",
  "tactile": "beautiful",
  "tactility": "smart",
  "tactless": "beautiful",
  "tactual": "beautiful",
  "tad": "smart",
  "tadalafil": "build",
  "tadarida": "heal",
  "tadorna": "heal",
  "tadpole": "heal",
  "tadzhik": "story",
  "tael": "smart",
  "taenia": "build",
  "taeniidae": "heal",
  "taffeta": "build",
  "taffrail": "build",
  "taffy": "taste",
  "tag": "story",
  "tagalog": "story",
  "tagamet": "build",
  "tagasaste": "heal",
  "tageteste": "heal",
  "tagged": "build",
  "tagger": "story",
  "tagliatelle": "taste",
  "taguan": "heal",
  "tahini": "taste",
  "tahitian": "story",
  "tai": "story",
  "tail": "heal",
  "tail-flower": "heal",
  "tailboard": "build",
  "tailcoat": "build",
  "tailfin": "build",
  "tailflower": "heal",
  "tailgate": "build",
  "tailing": "build",
  "taillight": "build",
  "tailor": "build",
  "tailor-made": "build",
  "tailor-make": "build",
  "tailorbird": "heal",
  "tailoring": "build",
  "tailpiece": "build",
  "tailpipe": "build",
  "tailplane": "build",
  "tailrace": "build",
  "tails": "build",
  "tailstock": "build",
  "tailwind": "smart",
  "tailwort": "heal",
  "taint": "build",
  "taipan": "heal",
  "taira": "heal",
  "taiwanese": "story",
  "tajik": "story",
  "tajiki": "story",
  "taka": "smart",
  "takahe": "heal",
  "take": "sell",
  "take-up": "build",
  "takeaway": "taste",
  "takedown": "story",
  "takelma": "story",
  "takeoff": "story",
  "takeout": "taste",
  "takilman": "story",
  "takin": "heal",
  "taking": "sell",
  "takings": "sell",
  "tala": "smart",
  "talapoin": "heal",
  "talaria": "build",
  "talc": "heal",
  "talcum": "build",
  "tale": "story",
  "talent": "smart",
  "talented": "beautiful",
  "talentless": "beautiful",
  "talentlessness": "smart",
  "talinum": "heal",
  "talipot": "heal",
  "talisman": "build",
  "talk": "story",
  "talkie": "story",
  "talking": "story",
  "talks": "story",
  "tall": "beautiful",
  "tall-grass": "heal",
  "tallboy": "build",
  "tallgrass": "heal",
  "tallis": "build",
  "tallith": "build",
  "tally": "story",
  "talmud": "story",
  "talon": "heal",
  "talpidae": "heal",
  "talus": "heal",
  "talwin": "build",
  "tam": "build",
  "tam-o'-shanter": "build",
  "tam-tam": "build",
  "tamale": "taste",
  "tamandu": "heal",
  "tamandua": "heal",
  "tamanoir": "heal",
  "tamarack": "heal",
  "tamarao": "heal",
  "tamarau": "heal",
  "tamaricaceae": "heal",
  "tamarillo": "heal",
  "tamarin": "heal",
  "tamarind": "heal",
  "tamarindo": "heal",
  "tamarindus": "heal",
  "tamarisk": "heal",
  "tamarix": "heal",
  "tambala": "smart",
  "tambocor": "build",
  "tambour": "build",
  "tambourine": "build",
  "tame": "story",
  "tamed": "story",
  "tamer": "beautiful",
  "tamias": "heal",
  "tamiasciurus": "heal",
  "tamil": "story",
  "tammy": "build",
  "tamoxifen": "build",
  "tamp": "build",
  "tampax": "build",
  "tamper": "build",
  "tampering": "build",
  "tampion": "build",
  "tampon": "build",
  "tamus": "heal",
  "tanacetum": "heal",
  "tanach": "story",
  "tanager": "heal",
  "tanakh": "story",
  "tanbark": "heal",
  "tandearil": "build",
  "tandem": "build",
  "tandoor": "build",
  "tanekaha": "heal",
  "tang": "smart",
  "tanga": "smart",
  "tangelo": "heal",
  "tangency": "build",
  "tangential": "beautiful",
  "tangerine": "heal",
  "tangible": "beautiful",
  "tangier": "beautiful",
  "tangle": "smart",
  "tanglebush": "heal",
  "tangled": "build",
  "tango": "story",
  "tangor": "heal",
  "tangram": "build",
  "tank": "build",
  "tanka": "story",
  "tankage": "smart",
  "tankard": "build",
  "tanker": "build",
  "tankful": "smart",
  "tanned": "heal",
  "tanner": "sell",
  "tannery": "build",
  "tannia": "heal",
  "tannic": "taste",
  "tannin": "taste",
  "tanning": "taste",
  "tannoy": "build",
  "tanoan": "story",
  "tansy": "heal",
  "tantalise": "story",
  "tantalize": "story",
  "tantilla": "heal",
  "tantra": "story",
  "tantrism": "smart",
  "tao": "smart",
  "taoism": "smart",
  "taos": "smart",
  "tap": "build",
  "tapa": "heal",
  "tapdance": "sound",
  "tape": "build",
  "tapeline": "build",
  "tapenade": "taste",
  "taper": "build",
  "tapering": "beautiful",
  "tapestry": "beautiful",
  "tapeworm": "heal",
  "taphouse": "build",
  "taping": "build",
  "tapioca": "taste",
  "tapir": "heal",
  "tapiridae": "heal",
  "tapirus": "heal",
  "tapis": "build",
  "tapotement": "sound",
  "tappa": "heal",
  "tapped": "build",
  "tappet": "build",
  "tapping": "build",
  "taproom": "build",
  "taproot": "heal",
  "taps": "story",
  "tar": "build",
  "tar-and-feather": "build",
  "tar-wood": "heal",
  "taradiddle": "story",
  "taraktagenos": "heal",
  "taraktogenos": "heal",
  "tarantella": "story",
  "tarantula": "heal",
  "taraxacum": "heal",
  "tarboosh": "build",
  "tardigrada": "heal",
  "tardigrade": "heal",
  "tare": "sell",
  "target": "story",
  "taricha": "heal",
  "tariff": "sell",
  "tarmac": "build",
  "tarmacadam": "build",
  "tarnish": "build",
  "taro": "heal",
  "tarot": "build",
  "tarp": "build",
  "tarpan": "heal",
  "tarpaulin": "build",
  "tarpon": "heal",
  "tarradiddle": "story",
  "tarragon": "heal",
  "tarrietia": "heal",
  "tarry": "beautiful",
  "tarsal": "heal",
  "tarsier": "heal",
  "tarsiidae": "heal",
  "tarsioidea": "heal",
  "tarsius": "heal",
  "tarsus": "heal",
  "tart": "taste",
  "tartan": "build",
  "tartarus": "smart",
  "tartlet": "taste",
  "tartness": "smart",
  "tarweed": "heal",
  "tarwood": "heal",
  "task": "sell",
  "tasse": "build",
  "tassel": "build",
  "tasset": "build",
  "taste": "taste",
  "tastebud": "heal",
  "tasteful": "beautiful",
  "tasteless": "beautiful",
  "tasting": "taste",
  "tasty": "beautiful",
  "tat": "build",
  "tatahumara": "story",
  "tatar": "story",
  "tater": "taste",
  "tatou": "heal",
  "tatouay": "heal",
  "tatter": "build",
  "tatterdemalion": "beautiful",
  "tatting": "build",
  "tattle": "story",
  "tattler": "heal",
  "tattoo": "story",
  "tatu": "heal",
  "tau": "story",
  "taunt": "story",
  "taunting": "story",
  "taupe": "beautiful",
  "taurotragus": "heal",
  "tautog": "heal",
  "tautoga": "heal",
  "tautogolabrus": "heal",
  "tautology": "story",
  "tavern": "taste",
  "taw": "story",
  "tawse": "build",
  "tax": "sell",
  "tax-exempt": "sell",
  "taxable": "beautiful",
  "taxaceae": "heal",
  "taxales": "heal",
  "taxation": "sell",
  "taxi": "build",
  "taxicab": "build",
  "taxidea": "heal",
  "taxidermy": "smart",
  "taximeter": "build",
  "taxis": "build",
  "taxiway": "build",
  "taxodiaceae": "heal",
  "taxodium": "heal",
  "taxonomy": "smart",
  "taxophytina": "heal",
  "taxopsida": "heal",
  "taxus": "heal",
  "tay": "story",
  "tayalic": "story",
  "tayassu": "heal",
  "tayassuidae": "heal",
  "tayra": "heal",
  "tazicef": "build",
  "tbit": "smart",
  "tchotchke": "build",
  "tcp": "story",
  "tcp/ip": "story",
  "tea": "taste",
  "tea-strainer": "build",
  "teaberry": "heal",
  "teacake": "taste",
  "teacart": "build",
  "teach": "story",
  "teach-in": "story",
  "teacher": "smart",
  "teaching": "smart",
  "teacup": "smart",
  "teacupful": "smart",
  "teahouse": "build",
  "teak": "heal",
  "teakettle": "build",
  "teakwood": "heal",
  "teal": "heal",
  "teapot": "build",
  "tear": "heal",
  "tearaway": "beautiful",
  "teardrop": "heal",
  "tearful": "beautiful",
  "tearing": "smart",
  "tearjerker": "story",
  "tearless": "beautiful",
  "tearoom": "build",
  "tears": "heal",
  "teasel": "heal",
  "teaser": "story",
  "teashop": "build",
  "teasle": "heal",
  "teaspoon": "smart",
  "teaspoonful": "smart",
  "teat": "heal",
  "teatime": "taste",
  "teazel": "heal",
  "tebibit": "smart",
  "tebibyte": "smart",
  "technical": "build",
  "technicality": "smart",
  "technicolor": "smart",
  "technique": "smart",
  "techno": "sound",
  "technobabble": "story",
  "technological": "beautiful",
  "technology": "smart",
  "tecophilaeacea": "heal",
  "tectaria": "heal",
  "tectona": "heal",
  "tectonics": "smart",
  "teddy": "build",
  "tee": "build",
  "teen": "beautiful",
  "teens": "smart",
  "teepee": "build",
  "teeter": "build",
  "teeter-totter": "build",
  "teeterboard": "build",
  "teetertotter": "build",
  "teeth": "heal",
  "teethe": "heal",
  "teething": "smart",
  "teetotal": "taste",
  "teetotaling": "taste",
  "teetotum": "build",
  "teff": "heal",
  "tefillin": "story",
  "teg": "heal",
  "tegument": "heal",
  "teiid": "heal",
  "teiidae": "heal",
  "teju": "heal",
  "telamon": "build",
  "telanthera": "heal",
  "telecast": "story",
  "telecasting": "story",
  "telecom": "story",
  "telecommerce": "sell",
  "telecommunicate": "story",
  "telecommunication": "story",
  "teleconference": "story",
  "teleconferencing": "story",
  "telefax": "story",
  "telefilm": "story",
  "telegnosis": "story",
  "telegram": "story",
  "telegraph": "build",
  "telegraphese": "story",
  "telegraphic": "beautiful",
  "telegraphy": "story",
  "telekinesis": "story",
  "telemeter": "build",
  "telencephalon": "heal",
  "teleology": "smart",
  "teleost": "heal",
  "teleostan": "heal",
  "teleostei": "heal",
  "telepathise": "story",
  "telepathize": "story",
  "telepathy": "story",
  "telephone": "build",
  "telephony": "story",
  "telephoto": "build",
  "telephotograph": "build",
  "teleprinter": "build",
  "teleprocessing": "smart",
  "teleprompter": "build",
  "telerobotics": "smart",
  "telescope": "build",
  "telescopy": "smart",
  "telethermometer": "build",
  "teletypewriter": "build",
  "televangelism": "story",
  "televise": "story",
  "television": "story",
  "telex": "build",
  "telfer": "build",
  "telferage": "build",
  "teliospore": "heal",
  "tell": "story",
  "tellima": "heal",
  "telling": "story",
  "telltale": "beautiful",
  "telly": "build",
  "telomere": "heal",
  "telopea": "heal",
  "telophase": "smart",
  "telosporidia": "heal",
  "telpher": "build",
  "telpherage": "build",
  "telsontail": "heal",
  "telugu": "story",
  "temazepam": "build",
  "temnospondyli": "heal",
  "temp": "sound",
  "temper": "sound",
  "tempera": "beautiful",
  "temperamental": "beautiful",
  "temperate": "beautiful",
  "temperateness": "sound",
  "temperature": "heal",
  "tempest": "sound",
  "template": "smart",
  "temple": "build",
  "templet": "smart",
  "templetonia": "heal",
  "tempo": "sound",
  "temporal": "sound",
  "temporalis": "sound",
  "temporality": "sound",
  "temporalty": "sound",
  "temporariness": "sound",
  "temporary": "sound",
  "temporise": "sound",
  "temporiser": "sound",
  "temporize": "sound",
  "temporizer": "sound",
  "tempra": "build",
  "tempt": "story",
  "temptation": "smart",
  "tempura": "taste",
  "ten": "smart",
  "ten-spot": "build",
  "ten-thousandth": "smart",
  "tenacious": "beautiful",
  "tenant": "sell",
  "tench": "heal",
  "tend": "sell",
  "tendency": "smart",
  "tendentiousness": "smart",
  "tender": "taste",
  "tendergreen": "heal",
  "tenderloin": "taste",
  "tending": "sell",
  "tendon": "heal",
  "tendrac": "heal",
  "tendril": "heal",
  "tenebrionid": "heal",
  "tenebrionidae": "heal",
  "tenement": "build",
  "tenet": "story",
  "tenge": "smart",
  "tenia": "build",
  "tenner": "smart",
  "tenon": "build",
  "tenor": "sound",
  "tenoretic": "build",
  "tenormin": "build",
  "tenoroon": "build",
  "tenpence": "sell",
  "tenpin": "build",
  "tenpins": "build",
  "tenpounder": "heal",
  "tenrec": "heal",
  "tenrecidae": "heal",
  "tense": "story",
  "tensile": "beautiful",
  "tensimeter": "build",
  "tensiometer": "build",
  "tension": "sound",
  "tensor": "smart",
  "tent": "build",
  "tent-fly": "build",
  "tentacle": "heal",
  "tentaculata": "heal",
  "tenter": "build",
  "tenterhook": "build",
  "tenth": "smart",
  "tenthredinidae": "heal",
  "tentorium": "heal",
  "tenure": "sell",
  "tepal": "heal",
  "tepee": "build",
  "tephrosia": "heal",
  "tequila": "taste",
  "tera": "story",
  "terabit": "smart",
  "terabyte": "smart",
  "teraflop": "smart",
  "teras": "heal",
  "teratogenesis": "smart",
  "teratology": "smart",
  "terazosin": "build",
  "terbinafine": "build",
  "tercel": "heal",
  "tercelet": "heal",
  "tercet": "smart",
  "terebella": "heal",
  "terebellidae": "heal",
  "terebinth": "heal",
  "teredinid": "heal",
  "teredinidae": "heal",
  "teredo": "heal",
  "teres": "heal",
  "tergiversate": "story",
  "teriyaki": "taste",
  "term": "story",
  "termes": "heal",
  "terminal": "build",
  "terminate": "sell",
  "termination": "story",
  "terminology": "story",
  "terminus": "smart",
  "termite": "heal",
  "termitidae": "heal",
  "terms": "sell",
  "tern": "heal",
  "ternary": "smart",
  "ternion": "smart",
  "terpsichore": "sound",
  "terrace": "build",
  "terramycin": "build",
  "terrapene": "heal",
  "terrapin": "heal",
  "terrarium": "build",
  "terrasse": "sell",
  "terrene": "beautiful",
  "terrestrial": "beautiful",
  "terrier": "heal",
  "terrietia": "heal",
  "terrine": "taste",
  "territorial": "beautiful",
  "territorialise": "sell",
  "territorialize": "sell",
  "territory": "smart",
  "terrorise": "sell",
  "terrorize": "sell",
  "terry": "build",
  "terrycloth": "build",
  "terseness": "story",
  "tertiary": "beautiful",
  "terylene": "build",
  "terzetto": "smart",
  "tesla": "smart",
  "tessella": "build",
  "tessellate": "build",
  "tessera": "build",
  "test": "smart",
  "testa": "heal",
  "testacea": "heal",
  "testacean": "heal",
  "testament": "smart",
  "testate": "beautiful",
  "tester": "build",
  "testicle": "heal",
  "testiere": "build",
  "testify": "story",
  "testimonial": "story",
  "testimony": "story",
  "testing": "sell",
  "testis": "heal",
  "testudinata": "heal",
  "testudines": "heal",
  "testudinidae": "heal",
  "testudo": "build",
  "tetanilla": "heal",
  "tetany": "heal",
  "tete-a-tete": "story",
  "teth": "story",
  "tether": "build",
  "tethyidae": "heal",
  "tethys": "heal",
  "tetra": "heal",
  "tetracaine": "build",
  "tetrachlorethylene": "build",
  "tetrachloroethylene": "build",
  "tetraclinis": "heal",
  "tetracycline": "build",
  "tetrad": "smart",
  "tetragonia": "heal",
  "tetragoniaceae": "heal",
  "tetragonurus": "heal",
  "tetragram": "story",
  "tetragrammaton": "story",
  "tetrahydrocannabinol": "build",
  "tetrahymena": "heal",
  "tetraiodothyronine": "heal",
  "tetralogy": "story",
  "tetrameter": "story",
  "tetraneuris": "heal",
  "tetranychid": "heal",
  "tetranychidae": "heal",
  "tetrao": "heal",
  "tetraodontidae": "heal",
  "tetraonidae": "heal",
  "tetrapod": "heal",
  "tetrapturus": "heal",
  "tetraskele": "build",
  "tetraskelion": "build",
  "tetrasporangium": "heal",
  "tetraspore": "heal",
  "tetrazzini": "taste",
  "tetri": "smart",
  "tetrode": "build",
  "tetterwort": "heal",
  "tettigoniid": "heal",
  "tettigoniidae": "heal",
  "teucrium": "heal",
  "text": "story",
  "text-matching": "story",
  "textbook": "story",
  "textile": "beautiful",
  "texture": "smart",
  "thai": "story",
  "thalamus": "heal",
  "thalarctos": "heal",
  "thalassoma": "heal",
  "thaliacea": "heal",
  "thalictrum": "heal",
  "thalidomide": "build",
  "thalidone": "build",
  "thallophyta": "heal",
  "thallophyte": "heal",
  "thallus": "heal",
  "thalmencephalon": "heal",
  "thalweg": "story",
  "thamnophilus": "heal",
  "thamnophis": "heal",
  "thanatology": "smart",
  "thanatopsis": "story",
  "thank": "story",
  "thankful": "beautiful",
  "thankless": "beautiful",
  "thanks": "story",
  "thanksgiving": "story",
  "thatch": "heal",
  "thatcherism": "smart",
  "thaumaturgy": "smart",
  "thaw": "smart",
  "thawing": "smart",
  "thb": "story",
  "thc": "build",
  "thd": "story",
  "theaceae": "heal",
  "theanthropism": "smart",
  "theater": "build",
  "theatre": "story",
  "theatrical": "story",
  "thebe": "smart",
  "thebes": "smart",
  "theca": "heal",
  "thecodont": "heal",
  "thecodontia": "heal",
  "theelin": "sound",
  "theism": "smart",
  "thelephoraceae": "heal",
  "thelypteridaceae": "heal",
  "thelypteris": "heal",
  "thematic": "sound",
  "theme": "story",
  "then": "beautiful",
  "thenar": "heal",
  "theobid": "build",
  "theobroma": "heal",
  "theocracy": "smart",
  "theodicy": "smart",
  "theodolite": "build",
  "theogony": "smart",
  "theologise": "story",
  "theologize": "story",
  "theology": "smart",
  "theophrastaceae": "heal",
  "theophylline": "build",
  "theorem": "story",
  "theoretic": "beautiful",
  "theoretical": "beautiful",
  "theorisation": "smart",
  "theorise": "smart",
  "theorization": "smart",
  "theorize": "smart",
  "theory": "smart",
  "theosophism": "smart",
  "theosophy": "smart",
  "therapeutic": "build",
  "therapeutics": "smart",
  "theraphosidae": "heal",
  "therapsid": "heal",
  "therapsida": "heal",
  "theravada": "smart",
  "theremin": "build",
  "theridiid": "heal",
  "theridiidae": "heal",
  "therm": "smart",
  "thermal": "sound",
  "thermel": "build",
  "thermionics": "smart",
  "thermistor": "build",
  "thermoacidophile": "heal",
  "thermobia": "heal",
  "thermochemistry": "smart",
  "thermocoagulation": "smart",
  "thermocouple": "build",
  "thermodynamics": "smart",
  "thermoelectricity": "sound",
  "thermogram": "story",
  "thermograph": "build",
  "thermography": "heal",
  "thermogravimeter": "build",
  "thermohydrometer": "build",
  "thermojunction": "build",
  "thermometer": "build",
  "thermometrograph": "build",
  "thermopile": "build",
  "thermoplastic": "beautiful",
  "thermopsis": "heal",
  "thermoreceptor": "heal",
  "thermoregulator": "build",
  "thermos": "build",
  "thermoset": "beautiful",
  "thermosetting": "beautiful",
  "thermostat": "build",
  "thermostatics": "smart",
  "theropod": "heal",
  "theropoda": "heal",
  "thesaurus": "story",
  "thesis": "story",
  "thespesia": "heal",
  "theta": "story",
  "theurgy": "smart",
  "thevetia": "heal",
  "thiabendazole": "build",
  "thiazide": "build",
  "thick": "beautiful",
  "thick-knee": "heal",
  "thickhead": "heal",
  "thickness": "story",
  "thielavia": "heal",
  "thieve": "sell",
  "thieving": "sell",
  "thigh": "heal",
  "thigh-slapper": "story",
  "thighbone": "heal",
  "thill": "build",
  "thimble": "smart",
  "thimbleberry": "heal",
  "thimbleful": "smart",
  "thimbleweed": "heal",
  "thimerosal": "build",
  "thin": "heal",
  "thing": "smart",
  "thing-in-itself": "smart",
  "thingamabob": "build",
  "thingamajig": "build",
  "thingmabob": "build",
  "thingmajig": "build",
  "things": "sell",
  "thingumabob": "build",
  "thingumajig": "build",
  "thingummy": "build",
  "think": "smart",
  "thinkable": "beautiful",
  "thinking": "smart",
  "thinner": "beautiful",
  "thiobacillus": "heal",
  "thiobacteria": "heal",
  "thiobacteriaceae": "heal",
  "thioguanine": "build",
  "thiopental": "build",
  "thioridazine": "build",
  "thiosulfil": "build",
  "thiotepa": "build",
  "thiothixene": "build",
  "third": "smart",
  "thirst": "sound",
  "thirstiness": "heal",
  "thirsty": "beautiful",
  "thirteen": "smart",
  "thirteenth": "beautiful",
  "thirties": "smart",
  "thirtieth": "beautiful",
  "thirty": "smart",
  "thirty-second": "smart",
  "thistle": "heal",
  "thistledown": "heal",
  "thlaspi": "heal",
  "thm": "story",
  "tho": "story",
  "thole": "build",
  "tholepin": "build",
  "thomism": "smart",
  "thomomys": "heal",
  "thong": "build",
  "thoracentesis": "heal",
  "thoracocentesis": "heal",
  "thorax": "heal",
  "thorazine": "build",
  "thorn": "smart",
  "thornbill": "heal",
  "thoroughbred": "heal",
  "thoroughfare": "build",
  "thoroughwort": "heal",
  "thou": "smart",
  "thought": "smart",
  "thought-image": "smart",
  "thoughtful": "beautiful",
  "thoughtfulness": "smart",
  "thoughtless": "beautiful",
  "thousand": "smart",
  "thousandth": "smart",
  "thracian": "story",
  "thraco-phrygian": "story",
  "thrash": "build",
  "thrasher": "build",
  "thrashing": "build",
  "thraupidae": "heal",
  "thread": "beautiful",
  "thread-fish": "heal",
  "threaded": "build",
  "threader": "build",
  "threadfin": "heal",
  "threadfish": "heal",
  "threads": "build",
  "threadworm": "heal",
  "threat": "story",
  "threaten": "story",
  "three": "smart",
  "three-d": "story",
  "three-decker": "taste",
  "three-dimensional": "beautiful",
  "three-fourths": "smart",
  "three-piece": "beautiful",
  "three-quarters": "smart",
  "threepence": "sell",
  "threescore": "beautiful",
  "threesome": "smart",
  "threnody": "story",
  "thresh": "build",
  "thresher": "build",
  "threshing": "build",
  "threshold": "smart",
  "threskiornis": "heal",
  "threskiornithidae": "heal",
  "thrift": "heal",
  "thriftshop": "build",
  "thrifty": "beautiful",
  "thrill": "sound",
  "thriller": "story",
  "thrinax": "heal",
  "thrip": "heal",
  "thripid": "heal",
  "thripidae": "heal",
  "thrips": "heal",
  "thrive": "sell",
  "throat": "heal",
  "throatwort": "heal",
  "throb": "sound",
  "throbbing": "sound",
  "thrombolysis": "smart",
  "thrombolytic": "build",
  "throne": "build",
  "throstle": "build",
  "throttle": "build",
  "throttling": "build",
  "throughput": "build",
  "throughway": "build",
  "throw": "build",
  "throwaway": "story",
  "throwback": "beautiful",
  "thrower": "build",
  "thrum": "sound",
  "thrush": "heal",
  "thrust": "sound",
  "thruster": "build",
  "thruway": "build",
  "thryothorus": "heal",
  "thud": "sound",
  "thuja": "heal",
  "thujopsis": "heal",
  "thumb": "heal",
  "thumbhole": "build",
  "thumbnail": "heal",
  "thumbnut": "build",
  "thumbprint": "story",
  "thumbscrew": "build",
  "thumbstall": "build",
  "thumbtack": "build",
  "thump": "sound",
  "thumping": "sound",
  "thunbergia": "heal",
  "thunder": "build",
  "thunderbolt": "sound",
  "thunderer": "build",
  "thundershower": "sound",
  "thunderstorm": "sound",
  "thunnus": "heal",
  "thurible": "build",
  "thurify": "sound",
  "thwack": "build",
  "thwart": "build",
  "thwarting": "sell",
  "thylacine": "heal",
  "thylacinus": "heal",
  "thylogale": "heal",
  "thyme": "heal",
  "thymelaeaceae": "heal",
  "thymelaeales": "heal",
  "thymidine": "sound",
  "thymine": "sound",
  "thymosin": "heal",
  "thymus": "heal",
  "thyreophora": "heal",
  "thyreophoran": "heal",
  "thyrocalcitonin": "heal",
  "thyroid": "heal",
  "thyrotoxicosis": "heal",
  "thyroxin": "heal",
  "thyroxine": "heal",
  "thyrse": "heal",
  "thyrsopteris": "heal",
  "thyrsus": "heal",
  "thysanocarpus": "heal",
  "thysanopter": "heal",
  "thysanoptera": "heal",
  "thysanopteron": "heal",
  "thysanura": "heal",
  "thysanuron": "heal",
  "tiara": "build",
  "tiarella": "heal",
  "tib": "smart",
  "tibetan": "story",
  "tibeto-burman": "story",
  "tibia": "heal",
  "tibialis": "heal",
  "tibicen": "heal",
  "tibit": "smart",
  "tical": "smart",
  "tichodroma": "heal",
  "tichodrome": "heal",
  "tick": "heal",
  "tick-weed": "heal",
  "ticker": "heal",
  "ticket": "story",
  "ticket-of-leave": "story",
  "ticking": "build",
  "tickle": "smart",
  "tickler": "story",
  "tickling": "sound",
  "tickseed": "heal",
  "ticktack": "story",
  "ticktock": "sound",
  "tickweed": "heal",
  "tidbit": "taste",
  "tidemark": "build",
  "tidings": "story",
  "tidy": "build",
  "tidytips": "heal",
  "tie": "build",
  "tie-in": "build",
  "tieback": "build",
  "tied": "build",
  "tiepin": "build",
  "tier": "build",
  "tierce": "smart",
  "tiercel": "heal",
  "tiff": "story",
  "tiffin": "taste",
  "tiger": "heal",
  "tigers": "heal",
  "tight": "beautiful",
  "tightness": "smart",
  "tightrope": "build",
  "tights": "build",
  "tiglon": "heal",
  "tigon": "heal",
  "tigress": "heal",
  "tilapia": "heal",
  "tilde": "story",
  "tile": "build",
  "tilefish": "heal",
  "tilia": "heal",
  "tiliaceae": "heal",
  "tiling": "build",
  "tiliomycetes": "heal",
  "till": "sell",
  "tillandsia": "heal",
  "tiller": "heal",
  "tilletia": "heal",
  "tilletiaceae": "heal",
  "tilling": "build",
  "tilt": "story",
  "tilter": "build",
  "timalia": "heal",
  "timaliidae": "heal",
  "timbale": "taste",
  "timber": "build",
  "timbered": "beautiful",
  "timbre": "sound",
  "timbrel": "sound",
  "time-ball": "build",
  "time-fuse": "build",
  "time-switch": "build",
  "timecard": "story",
  "timekeeper": "build",
  "timeline": "story",
  "timepiece": "build",
  "timer": "build",
  "timetable": "story",
  "timid": "beautiful",
  "timidity": "sound",
  "timing": "smart",
  "timolol": "build",
  "timothy": "heal",
  "timpani": "build",
  "timucu": "heal",
  "tin": "build",
  "tinamidae": "heal",
  "tinamiformes": "heal",
  "tinamou": "heal",
  "tinca": "heal",
  "tincture": "story",
  "tinderbox": "build",
  "tine": "build",
  "tinea": "heal",
  "tineid": "heal",
  "tineidae": "heal",
  "tineoid": "heal",
  "tineoidea": "heal",
  "tineola": "heal",
  "tinfoil": "build",
  "ting": "sound",
  "tinge": "smart",
  "tingidae": "heal",
  "tingle": "smart",
  "tingling": "smart",
  "tink": "sound",
  "tinker": "heal",
  "tinkle": "sound",
  "tinning": "build",
  "tinny": "beautiful",
  "tinplate": "build",
  "tinsel": "build",
  "tinsnips": "build",
  "tintack": "build",
  "tintinnabulate": "sound",
  "tintometer": "build",
  "tinware": "build",
  "tip": "sell",
  "tip-off": "smart",
  "tipi": "build",
  "tipped": "sell",
  "tipper": "build",
  "tippet": "build",
  "tipple": "taste",
  "tipsiness": "sound",
  "tipstaff": "story",
  "tiptoe": "heal",
  "tiptop": "beautiful",
  "tipu": "heal",
  "tipuana": "heal",
  "tipulidae": "heal",
  "tirade": "story",
  "tiramisu": "taste",
  "tire": "build",
  "tired": "heal",
  "tiredness": "sound",
  "tirolean": "build",
  "tisane": "taste",
  "tissue": "heal",
  "tit": "heal",
  "titania": "beautiful",
  "titanosaur": "heal",
  "titanosaurian": "heal",
  "titanosauridae": "heal",
  "titanosaurus": "heal",
  "titbit": "taste",
  "titfer": "build",
  "tithe": "sell",
  "tithonia": "heal",
  "titi": "heal",
  "titillate": "sound",
  "titlark": "heal",
  "title": "story",
  "titmouse": "heal",
  "titrator": "build",
  "titter": "story",
  "tittering": "heal",
  "tittle": "smart",
  "tittle-tattle": "story",
  "titty": "heal",
  "titus": "story",
  "tiyin": "smart",
  "tlingit": "story",
  "tmv": "heal",
  "tnt": "build",
  "toad": "heal",
  "toad-in-the-hole": "taste",
  "toadfish": "heal",
  "toadflax": "heal",
  "toadshade": "heal",
  "toadstool": "heal",
  "toady": "story",
  "toast": "taste",
  "toaster": "build",
  "toasting": "taste",
  "toastrack": "build",
  "tobacco": "build",
  "tobacconist": "build",
  "tobey": "beautiful",
  "tobit": "story",
  "toboggan": "build",
  "tobramycin": "build",
  "toby": "build",
  "tocainide": "build",
  "toccata": "story",
  "tocharian": "story",
  "tocology": "smart",
  "tocsin": "story",
  "tod": "smart",
  "toda": "story",
  "toddy": "taste",
  "todea": "heal",
  "todidae": "heal",
  "todus": "heal",
  "tody": "heal",
  "toe": "heal",
  "toea": "smart",
  "toecap": "build",
  "toed": "build",
  "toehold": "build",
  "toeless": "beautiful",
  "toenail": "heal",
  "toetoe": "heal",
  "toffee": "taste",
  "toffy": "taste",
  "tofieldia": "heal",
  "tofranil": "build",
  "tofu": "taste",
  "tog": "heal",
  "toga": "build",
  "togaviridae": "heal",
  "toggle": "story",
  "togs": "build",
  "toil": "sell",
  "toilet": "build",
  "toilet-train": "smart",
  "toiletry": "build",
  "toitoi": "heal",
  "tokamak": "build",
  "tokay": "taste",
  "token": "story",
  "tolazamide": "build",
  "tolazoline": "build",
  "tolbooth": "build",
  "tolbutamide": "build",
  "tole": "build",
  "tolectin": "build",
  "tolerable": "beautiful",
  "tolerance": "build",
  "tolerant": "beautiful",
  "tolerate": "smart",
  "tolinase": "build",
  "toll": "sell",
  "tollbar": "build",
  "tollbooth": "build",
  "tollgate": "build",
  "tollhouse": "build",
  "tollon": "heal",
  "tolmiea": "heal",
  "tolu": "heal",
  "tolypeutes": "heal",
  "tom": "heal",
  "tom-tom": "build",
  "tomahawk": "build",
  "tomalley": "taste",
  "tomatillo": "heal",
  "tomato": "taste",
  "tomb": "build",
  "tombstone": "build",
  "tomcat": "heal",
  "tome": "story",
  "tomentose": "beautiful",
  "tomentum": "heal",
  "tomistoma": "heal",
  "tommyrot": "story",
  "tomograph": "build",
  "tompion": "build",
  "tomtate": "heal",
  "tomtit": "heal",
  "ton": "smart",
  "tonal": "beautiful",
  "tonality": "sound",
  "tone": "story",
  "toned": "story",
  "toneless": "beautiful",
  "toner": "build",
  "tonga": "story",
  "tongan": "story",
  "tongs": "build",
  "tongue": "heal",
  "tongue-fish": "heal",
  "tongue-flower": "heal",
  "tongue-lashing": "story",
  "tongue-tie": "sell",
  "tongued": "build",
  "tonguefish": "heal",
  "tongueflower": "heal",
  "tongueless": "beautiful",
  "tonic": "taste",
  "tonnage": "sell",
  "tonne": "smart",
  "tonocard": "build",
  "tonometer": "build",
  "tons": "smart",
  "tonsil": "heal",
  "tonsilla": "heal",
  "tonsure": "heal",
  "tontine": "sell",
  "tool": "build",
  "toolbox": "build",
  "toolhouse": "build",
  "toolshed": "build",
  "toon": "story",
  "toona": "heal",
  "tooshie": "heal",
  "toot": "sound",
  "tooth": "heal",
  "toothbrush": "build",
  "toothed": "beautiful",
  "toothless": "beautiful",
  "toothpaste": "build",
  "toothpick": "build",
  "toothpowder": "build",
  "toothsome": "beautiful",
  "toothwort": "heal",
  "tootle": "sound",
  "top-down": "beautiful",
  "top-up": "smart",
  "topcoat": "build",
  "tope": "build",
  "topee": "build",
  "topgallant": "build",
  "tophus": "heal",
  "topi": "build",
  "topiary": "build",
  "topic": "story",
  "topical": "beautiful",
  "topicalization": "story",
  "topicalize": "story",
  "topknot": "build",
  "topless": "beautiful",
  "topmast": "build",
  "topminnow": "heal",
  "topognosia": "smart",
  "topognosis": "smart",
  "topography": "smart",
  "topology": "smart",
  "toponomy": "story",
  "toponym": "story",
  "toponymy": "story",
  "topos": "smart",
  "topper": "story",
  "topping": "taste",
  "topsail": "build",
  "topside": "build",
  "topv": "build",
  "toque": "build",
  "toradol": "build",
  "torah": "story",
  "torch": "build",
  "torchlight": "sound",
  "tore": "build",
  "tormenter": "build",
  "tormentor": "build",
  "tornado": "sound",
  "tornillo": "heal",
  "torodal": "build",
  "torpedinidae": "heal",
  "torpediniformes": "heal",
  "torpedo": "taste",
  "torque": "sound",
  "torr": "smart",
  "torrent": "sound",
  "torrential": "beautiful",
  "torreya": "heal",
  "torsion": "sound",
  "torsk": "heal",
  "torso": "heal",
  "torte": "taste",
  "tortellini": "taste",
  "tortilla": "taste",
  "tortoise": "heal",
  "tortoiseshell": "heal",
  "tortoiseshell-cat": "heal",
  "tortricid": "heal",
  "tortricidae": "heal",
  "tortrix": "heal",
  "torturing": "heal",
  "torus": "build",
  "tosh": "story",
  "tosk": "story",
  "toss": "build",
  "toss-up": "sound",
  "tossup": "sound",
  "tostada": "taste",
  "tot": "smart",
  "total": "build",
  "totalisator": "build",
  "totaliser": "build",
  "totalism": "smart",
  "totalitarian": "beautiful",
  "totalitarianism": "smart",
  "totality": "build",
  "totalizator": "build",
  "totalizer": "build",
  "totara": "heal",
  "tote": "build",
  "totem": "build",
  "totemism": "smart",
  "toucan": "heal",
  "toucanet": "heal",
  "touch": "smart",
  "touch-me-not": "heal",
  "touch-type": "story",
  "touchable": "beautiful",
  "touched": "build",
  "touching": "build",
  "touchscreen": "build",
  "touchstone": "story",
  "tough": "beautiful",
  "toughened": "beautiful",
  "toughie": "story",
  "toupe": "build",
  "toupee": "build",
  "touraco": "heal",
  "tourer": "build",
  "tourette": "heal",
  "tournedos": "taste",
  "tourniquet": "build",
  "tourtiere": "taste",
  "tousle": "build",
  "tout": "story",
  "tow": "build",
  "towboat": "build",
  "towel": "build",
  "toweling": "build",
  "towelling": "build",
  "tower": "build",
  "towhee": "heal",
  "towline": "build",
  "townsendia": "heal",
  "towpath": "build",
  "towrope": "build",
  "toxic": "beautiful",
  "toxicant": "beautiful",
  "toxicity": "smart",
  "toxicodendron": "heal",
  "toxicognath": "heal",
  "toxicology": "smart",
  "toxostoma": "heal",
  "toxotes": "heal",
  "toxotidae": "heal",
  "toy": "build",
  "toying": "sell",
  "toyon": "heal",
  "toyshop": "build",
  "tra-la": "story",
  "tra-la-la": "story",
  "trabecula": "heal",
  "trace": "smart",
  "traceable": "beautiful",
  "tracer": "build",
  "tracery": "build",
  "trachea": "heal",
  "tracheid": "heal",
  "trachelospermum": "heal",
  "tracheophyta": "heal",
  "tracheophyte": "heal",
  "trachinotus": "heal",
  "trachipteridae": "heal",
  "trachipterus": "heal",
  "trachodon": "heal",
  "trachodont": "heal",
  "trachurus": "heal",
  "tracing": "build",
  "track": "smart",
  "trackable": "beautiful",
  "trackball": "build",
  "tracked": "sound",
  "tracking": "sound",
  "trackless": "beautiful",
  "tract": "heal",
  "tractable": "beautiful",
  "tractarianism": "smart",
  "traction": "sound",
  "tractor": "build",
  "trad": "story",
  "trade-in": "sell",
  "trade-last": "story",
  "tradecraft": "smart",
  "trademark": "story",
  "tradescantia": "heal",
  "trading": "sell",
  "tradition": "smart",
  "traditional": "beautiful",
  "traditionalism": "smart",
  "traditionalist": "beautiful",
  "traduce": "story",
  "traducement": "story",
  "traffic": "story",
  "trafficator": "story",
  "tragedy": "story",
  "tragelaphus": "heal",
  "tragic": "beautiful",
  "tragicomedy": "story",
  "tragicomic": "beautiful",
  "tragopan": "heal",
  "tragopogon": "heal",
  "tragulidae": "heal",
  "tragulus": "heal",
  "tragus": "heal",
  "trail": "build",
  "trailer": "story",
  "train": "build",
  "trained": "smart",
  "traineeship": "sell",
  "trainer": "build",
  "training": "smart",
  "trainload": "smart",
  "trajectory": "sound",
  "tram": "build",
  "tramcar": "build",
  "tramline": "build",
  "trammel": "build",
  "tramontana": "sound",
  "tramontane": "sound",
  "trample": "heal",
  "trampling": "heal",
  "trampoline": "build",
  "tramway": "build",
  "trance": "sound",
  "tranche": "sell",
  "trandate": "build",
  "trandolapril": "build",
  "tranquilize": "heal",
  "tranquilizer": "build",
  "tranquillise": "heal",
  "tranquilliser": "build",
  "tranquillize": "heal",
  "tranquillizer": "build",
  "transact": "sell",
  "transactions": "story",
  "transalpine": "beautiful",
  "transamination": "smart",
  "transcendental": "beautiful",
  "transcendentalism": "smart",
  "transcribe": "story",
  "transcript": "story",
  "transcription": "story",
  "transducer": "build",
  "transduction": "smart",
  "transect": "build",
  "transept": "build",
  "transeunt": "beautiful",
  "transfer": "story",
  "transference": "smart",
  "transfix": "build",
  "transformation": "story",
  "transformer": "build",
  "transfuse": "sell",
  "transgene": "heal",
  "transgress": "sell",
  "transgression": "sound",
  "transient": "beautiful",
  "transistor": "smart",
  "transistorise": "sell",
  "transistorize": "sell",
  "transit": "build",
  "transition": "story",
  "transitive": "story",
  "translatable": "beautiful",
  "translate": "story",
  "translation": "story",
  "translator": "story",
  "transliterate": "story",
  "transliteration": "story",
  "translocate": "sell",
  "translocation": "smart",
  "translunar": "beautiful",
  "translunary": "beautiful",
  "transmission": "story",
  "transmit": "sell",
  "transmittance": "smart",
  "transmitter": "build",
  "transmitting": "sell",
  "transmontane": "beautiful",
  "transom": "build",
  "transonic": "beautiful",
  "transparence": "sound",
  "transparency": "story",
  "transpiration": "smart",
  "transplant": "heal",
  "transplanting": "build",
  "transponder": "build",
  "transport": "build",
  "transportation": "build",
  "transporter": "build",
  "transsexual": "beautiful",
  "transubstantiation": "smart",
  "transude": "heal",
  "transvestite": "beautiful",
  "tranylcypromine": "build",
  "trap": "build",
  "trapa": "heal",
  "trapaceae": "heal",
  "trapeze": "build",
  "trapezium": "heal",
  "trapezius": "heal",
  "trapezoid": "heal",
  "trapping": "build",
  "trappings": "build",
  "trash": "story",
  "traumatic": "beautiful",
  "traumatise": "heal",
  "traumatize": "heal",
  "traumatology": "smart",
  "trautvetteria": "heal",
  "travail": "sell",
  "trave": "build",
  "travelog": "story",
  "travelogue": "story",
  "traverse": "build",
  "travesty": "story",
  "trawl": "build",
  "trawler": "build",
  "tray": "build",
  "trazodone": "build",
  "treacle": "taste",
  "tread": "build",
  "tread-softly": "heal",
  "tread-wheel": "build",
  "treadle": "build",
  "treadmill": "build",
  "treadwheel": "build",
  "treasure": "sell",
  "treasury": "sell",
  "treat": "taste",
  "treated": "sell",
  "treatise": "story",
  "treatment": "heal",
  "treaty": "story",
  "treble": "sound",
  "trebuchet": "build",
  "trebucket": "build",
  "tree": "heal",
  "tree-frog": "heal",
  "tree-living": "beautiful",
  "treehopper": "heal",
  "treeless": "beautiful",
  "treelet": "heal",
  "treenail": "build",
  "treetop": "heal",
  "trefoil": "heal",
  "treillage": "build",
  "trellis": "build",
  "trema": "heal",
  "trematoda": "heal",
  "trematode": "heal",
  "trembling": "beautiful",
  "tremella": "heal",
  "tremellaceae": "heal",
  "tremellales": "heal",
  "tremolo": "sound",
  "trenail": "build",
  "trench": "build",
  "trencher": "build",
  "trend": "smart",
  "trental": "build",
  "trepan": "build",
  "trepang": "heal",
  "trephine": "build",
  "trephritidae": "heal",
  "treponema": "heal",
  "treponemataceae": "heal",
  "trespass": "sell",
  "tress": "heal",
  "trestle": "build",
  "trestlework": "build",
  "trews": "build",
  "trey": "smart",
  "triad": "smart",
  "triaenodon": "heal",
  "triakidae": "heal",
  "trial": "smart",
  "trialeurodes": "heal",
  "triangle": "build",
  "triangulate": "sell",
  "triangulation": "smart",
  "triatoma": "heal",
  "triavil": "build",
  "triazolam": "build",
  "tribalism": "smart",
  "tribolium": "heal",
  "tribology": "smart",
  "tribonema": "heal",
  "tribonemaceae": "heal",
  "tribromoethanol": "build",
  "tribulus": "heal",
  "tribune": "build",
  "tributary": "beautiful",
  "tribute": "story",
  "trice": "build",
  "triceps": "heal",
  "triceratops": "heal",
  "trichechidae": "heal",
  "trichechus": "heal",
  "trichina": "heal",
  "trichiuridae": "heal",
  "trichlormethiazide": "build",
  "trichloromethane": "build",
  "trichoceros": "heal",
  "trichodesmium": "heal",
  "trichodontidae": "heal",
  "trichoglossus": "heal",
  "tricholoma": "heal",
  "tricholomataceae": "heal",
  "trichomanes": "heal",
  "trichomonad": "heal",
  "trichophaga": "heal",
  "trichophyton": "heal",
  "trichoptera": "heal",
  "trichopteran": "heal",
  "trichopteron": "heal",
  "trichostema": "heal",
  "trichostigma": "heal",
  "trichosurus": "heal",
  "trichroism": "sound",
  "trichromacy": "smart",
  "trichys": "heal",
  "trickery": "story",
  "triclinic": "beautiful",
  "triclinium": "build",
  "tricolor": "build",
  "tricolour": "build",
  "tricorn": "build",
  "tricorne": "build",
  "tricot": "build",
  "tricycle": "build",
  "tricyclic": "build",
  "tridacna": "heal",
  "tridacnidae": "heal",
  "trident": "build",
  "triennial": "beautiful",
  "trifle": "taste",
  "trifling": "sell",
  "trifoliata": "heal",
  "trifolium": "heal",
  "trig": "smart",
  "triga": "heal",
  "trigeminal": "heal",
  "trigeminus": "heal",
  "trigger": "build",
  "triggerfish": "heal",
  "triglidae": "heal",
  "triglinae": "heal",
  "triglochin": "heal",
  "trigon": "build",
  "trigonella": "heal",
  "trigonometry": "smart",
  "trigram": "story",
  "triiodomethane": "build",
  "triiodothyronine": "heal",
  "trike": "build",
  "trilateral": "beautiful",
  "trilby": "build",
  "trilisa": "heal",
  "trill": "story",
  "trilliaceae": "heal",
  "trilling": "story",
  "trillion": "smart",
  "trillionth": "smart",
  "trillium": "heal",
  "trilobite": "heal",
  "trim": "build",
  "trimaran": "build",
  "trimipramine": "build",
  "trimmed": "build",
  "trimmer": "build",
  "trimming": "build",
  "trimmings": "build",
  "trimorphodon": "heal",
  "trimox": "build",
  "trine": "smart",
  "trinectes": "heal",
  "tringa": "heal",
  "trinitarianism": "smart",
  "trinitrotoluene": "build",
  "trinity": "smart",
  "trinket": "build",
  "trinuclear": "beautiful",
  "trinucleate": "beautiful",
  "trinucleated": "beautiful",
  "trio": "sound",
  "triode": "build",
  "trionychidae": "heal",
  "trionyx": "heal",
  "triopidae": "heal",
  "triops": "heal",
  "triostium": "heal",
  "tripe": "taste",
  "triphammer": "build",
  "triple": "smart",
  "triple-decker": "taste",
  "triple-space": "story",
  "triple-spacing": "story",
  "triple-tongue": "build",
  "triplet": "smart",
  "tripletail": "heal",
  "tripleurospermum": "heal",
  "triplicate": "build",
  "tripling": "smart",
  "triplochiton": "heal",
  "tripod": "build",
  "tripos": "story",
  "tripper": "build",
  "triptych": "build",
  "triquetral": "heal",
  "trireme": "build",
  "trisect": "build",
  "triskele": "build",
  "triskelion": "build",
  "trisyllable": "story",
  "triteness": "smart",
  "tritheism": "smart",
  "triticum": "heal",
  "tritoma": "heal",
  "triton": "heal",
  "triturus": "heal",
  "triumphal": "beautiful",
  "trivet": "build",
  "trivia": "build",
  "trivialise": "story",
  "triviality": "smart",
  "trivialize": "story",
  "trivium": "smart",
  "trna": "sound",
  "troat": "story",
  "trochanter": "heal",
  "troche": "taste",
  "trochee": "story",
  "trochilidae": "heal",
  "trochlear": "heal",
  "trochlearis": "heal",
  "trogium": "heal",
  "troglodytes": "heal",
  "troglodytidae": "heal",
  "trogon": "heal",
  "trogonidae": "heal",
  "trogoniformes": "heal",
  "troika": "build",
  "trojan": "story",
  "troll": "story",
  "trolley": "build",
  "trolleybus": "build",
  "trolling": "build",
  "trollius": "heal",
  "trombicula": "heal",
  "trombiculid": "heal",
  "trombiculidae": "heal",
  "trombidiid": "heal",
  "trombidiidae": "heal",
  "trombone": "sound",
  "trompillo": "heal",
  "troopship": "build",
  "tropaeolaceae": "heal",
  "tropaeolum": "heal",
  "trope": "story",
  "trophoblast": "heal",
  "trophozoite": "heal",
  "trophy": "story",
  "tropic": "beautiful",
  "tropical": "beautiful",
  "tropicbird": "heal",
  "tropidoclonion": "heal",
  "troponym": "story",
  "trot": "story",
  "troth": "story",
  "trotline": "build",
  "trotskyism": "smart",
  "trotter": "heal",
  "trou-de-loup": "build",
  "trouble": "smart",
  "troubled": "sell",
  "trough": "build",
  "trounce": "build",
  "trouncing": "build",
  "trouser": "build",
  "trousering": "build",
  "trousseau": "build",
  "trout": "taste",
  "trove": "sell",
  "trowel": "build",
  "troy": "smart",
  "truant": "beautiful",
  "truck": "build",
  "truckage": "sell",
  "truckle": "build",
  "truckling": "story",
  "true": "beautiful",
  "true-false": "beautiful",
  "truffle": "heal",
  "truism": "story",
  "trump": "build",
  "trumpery": "story",
  "trumpet": "sound",
  "trumpet-wood": "heal",
  "trumpeter": "heal",
  "trumpetfish": "heal",
  "trumpets": "heal",
  "trumpetwood": "heal",
  "trumping": "sound",
  "truncate": "sell",
  "truncheon": "build",
  "truncocolumella": "heal",
  "trundle": "build",
  "trunk": "heal",
  "trunkfish": "heal",
  "trunks": "build",
  "trunnel": "build",
  "truss": "build",
  "trust": "sell",
  "trustful": "beautiful",
  "trusting": "smart",
  "trustworthy": "beautiful",
  "trusty": "beautiful",
  "truth": "smart",
  "truthful": "beautiful",
  "try": "sell",
  "tryout": "smart",
  "trypetidae": "heal",
  "tsatske": "build",
  "tsetse": "heal",
  "tshatshke": "build",
  "tshiluba": "story",
  "tsimshian": "story",
  "tsine": "heal",
  "tsk": "story",
  "tsouic": "story",
  "tsuga": "heal",
  "tswana": "story",
  "tuareg": "story",
  "tuatara": "heal",
  "tub": "build",
  "tub-cart": "build",
  "tuba": "build",
  "tube": "build",
  "tubed": "sell",
  "tubeless": "build",
  "tuber": "heal",
  "tuberaceae": "heal",
  "tuberales": "heal",
  "tubercle": "heal",
  "tubercularia": "heal",
  "tuberculariaceae": "heal",
  "tuberculin": "heal",
  "tuberose": "heal",
  "tuberosity": "heal",
  "tubful": "smart",
  "tubing": "build",
  "tubule": "heal",
  "tubulidentata": "heal",
  "tuck": "taste",
  "tuckahoe": "heal",
  "tucked": "build",
  "tucker": "build",
  "tucker-bag": "build",
  "tucket": "story",
  "tudung": "build",
  "tuffet": "build",
  "tuft": "heal",
  "tug": "build",
  "tugboat": "build",
  "tughrik": "smart",
  "tugrik": "smart",
  "tuileries": "build",
  "tuille": "build",
  "tuition": "sell",
  "tulestoma": "heal",
  "tulip": "heal",
  "tulipa": "heal",
  "tulipwood": "heal",
  "tulle": "build",
  "tulostoma": "heal",
  "tulostomaceae": "heal",
  "tulostomataceae": "heal",
  "tulostomatales": "heal",
  "tulu": "story",
  "tum": "heal",
  "tumble-dryer": "build",
  "tumblebug": "heal",
  "tumbler": "build",
  "tumbleweed": "heal",
  "tumbrel": "build",
  "tumbril": "build",
  "tumefaction": "smart",
  "tumescence": "sound",
  "tumidity": "sound",
  "tummy": "heal",
  "tums": "heal",
  "tumulus": "build",
  "tun": "build",
  "tuna": "taste",
  "tunaburger": "taste",
  "tune": "sound",
  "tuneful": "beautiful",
  "tuneless": "beautiful",
  "tuner": "build",
  "tung": "heal",
  "tunga": "heal",
  "tungus": "story",
  "tungusic": "story",
  "tunguz": "story",
  "tunic": "heal",
  "tunica": "heal",
  "tunicata": "heal",
  "tunicate": "heal",
  "tunnage": "sell",
  "tunnel": "build",
  "tunny": "taste",
  "tup": "heal",
  "tupaia": "heal",
  "tupaiidae": "heal",
  "tupek": "build",
  "tupelo": "heal",
  "tupi": "story",
  "tupi-guarani": "story",
  "tupik": "build",
  "tupinambis": "heal",
  "tuppence": "sell",
  "turaco": "heal",
  "turacou": "heal",
  "turakoo": "heal",
  "turban": "build",
  "turbatrix": "heal",
  "turbellaria": "heal",
  "turbinal": "heal",
  "turbinate": "heal",
  "turbine": "build",
  "turbofan": "build",
  "turbogenerator": "build",
  "turbojet": "build",
  "turboprop": "build",
  "turbot": "taste",
  "turbulence": "sound",
  "turbulency": "sound",
  "turcoman": "story",
  "turdidae": "heal",
  "turdinae": "heal",
  "turdus": "heal",
  "tureen": "build",
  "turf": "build",
  "turfan": "story",
  "turgidity": "story",
  "turgidness": "story",
  "turk's-cap": "heal",
  "turkey": "heal",
  "turki": "story",
  "turkic": "story",
  "turkish": "story",
  "turkmen": "story",
  "turko-tatar": "story",
  "turkoman": "story",
  "turkomen": "story",
  "turmeric": "heal",
  "turn-on": "smart",
  "turnabout": "smart",
  "turnaround": "smart",
  "turnbuckle": "build",
  "turncock": "build",
  "turnery": "build",
  "turnicidae": "heal",
  "turnip": "heal",
  "turnix": "heal",
  "turnoff": "smart",
  "turnout": "build",
  "turnover": "taste",
  "turnpike": "build",
  "turnspit": "build",
  "turnstile": "build",
  "turnstone": "heal",
  "turntable": "build",
  "turnup": "build",
  "turpentine": "taste",
  "turps": "taste",
  "turreae": "heal",
  "turret": "build",
  "turritis": "heal",
  "tursiops": "heal",
  "turtle": "build",
  "turtledove": "heal",
  "turtlehead": "heal",
  "turtleneck": "build",
  "tuscan": "story",
  "tuscarora": "story",
  "tush": "heal",
  "tushery": "story",
  "tusk": "heal",
  "tusker": "heal",
  "tussah": "heal",
  "tusseh": "heal",
  "tusser": "heal",
  "tussilago": "heal",
  "tussle": "build",
  "tussore": "heal",
  "tussur": "heal",
  "tut": "story",
  "tut-tut": "story",
  "tutelo": "story",
  "tutor": "story",
  "tutorial": "story",
  "tutsan": "heal",
  "tutti-frutti": "taste",
  "tutu": "build",
  "tux": "build",
  "tuxedo": "build",
  "tv-antenna": "build",
  "twaddle": "story",
  "twain": "smart",
  "twang": "sound",
  "twat": "heal",
  "twayblade": "heal",
  "tweak": "build",
  "tweed": "build",
  "tweedle": "build",
  "tweet": "sound",
  "tweeter": "build",
  "tweeze": "build",
  "tweezer": "build",
  "twelfth": "smart",
  "twelve": "smart",
  "twenties": "smart",
  "twentieth": "beautiful",
  "twenty": "smart",
  "twenty-eight": "smart",
  "twenty-five": "smart",
  "twenty-four": "smart",
  "twenty-nine": "smart",
  "twenty-one": "smart",
  "twenty-seven": "smart",
  "twenty-six": "smart",
  "twenty-three": "smart",
  "twenty-twenty": "smart",
  "twenty-two": "smart",
  "twice-pinnate": "heal",
  "twiddle": "build",
  "twig": "heal",
  "twilight": "sound",
  "twill": "build",
  "twin": "build",
  "twin-prop": "build",
  "twin-propeller-plane": "build",
  "twinberry": "heal",
  "twine": "build",
  "twiner": "beautiful",
  "twinflower": "heal",
  "twinge": "smart",
  "twinjet": "build",
  "twinkie": "taste",
  "twinkle": "sound",
  "twinkling": "sound",
  "twirp": "sound",
  "twist": "story",
  "twister": "sound",
  "twisting": "build",
  "twistwood": "heal",
  "twit": "story",
  "twitch": "heal",
  "twitching": "heal",
  "twitter": "story",
  "twitterer": "heal",
  "two": "smart",
  "two-by-four": "build",
  "two-dimensional": "beautiful",
  "two-footed": "beautiful",
  "two-handed": "beautiful",
  "two-piece": "build",
  "two-seater": "build",
  "two-sided": "beautiful",
  "two-thirds": "smart",
  "two-time": "sell",
  "two-year": "beautiful",
  "twofer": "story",
  "twopence": "sell",
  "twosome": "smart",
  "tying": "build",
  "tyiyn": "smart",
  "tylenchidae": "heal",
  "tylenchus": "heal",
  "tylenol": "build",
  "tympan": "build",
  "tympani": "build",
  "tympanuchus": "heal",
  "tympanum": "heal",
  "type": "smart",
  "typecast": "build",
  "typeface": "beautiful",
  "typescript": "smart",
  "typeset": "build",
  "typewrite": "story",
  "typewriter": "build",
  "typewriting": "story",
  "typha": "heal",
  "typhaceae": "heal",
  "typhlopidae": "heal",
  "typhoon": "sound",
  "typical": "beautiful",
  "typification": "smart",
  "typify": "story",
  "typing": "story",
  "typo": "story",
  "typographic": "beautiful",
  "typographical": "beautiful",
  "typography": "beautiful",
  "tyranni": "heal",
  "tyrannid": "heal",
  "tyrannidae": "heal",
  "tyrannise": "sell",
  "tyrannize": "sell",
  "tyrannosaur": "heal",
  "tyrannosaurus": "heal",
  "tyrannus": "heal",
  "tyre": "build",
  "tyrocidin": "build",
  "tyrocidine": "build",
  "tyrolean": "build",
  "tyrothricin": "build",
  "tyto": "heal",
  "tytonidae": "heal",
  "tzetze": "heal",
  "u-boat": "build",
  "u-drive": "sell",
  "uakari": "heal",
  "ubykh": "story",
  "uca": "heal",
  "udder": "heal",
  "udmurt": "story",
  "udometer": "build",
  "ufo": "smart",
  "ugaritic": "story",
  "ugli": "taste",
  "ugly": "beautiful",
  "ugrian": "story",
  "ugric": "story",
  "uighur": "story",
  "uigur": "story",
  "uintathere": "heal",
  "uintatheriidae": "heal",
  "uintatherium": "heal",
  "ukase": "story",
  "uke": "build",
  "ukrainian": "story",
  "ukulele": "sound",
  "ulcerate": "heal",
  "ulceration": "smart",
  "ulex": "heal",
  "ullage": "smart",
  "ulmaceae": "heal",
  "ulmus": "heal",
  "ulna": "heal",
  "ulster": "build",
  "ultima": "story",
  "ultimate": "beautiful",
  "ultimatum": "story",
  "ultracef": "build",
  "ultracentrifugation": "smart",
  "ultracentrifuge": "build",
  "ultraconservative": "beautiful",
  "ultramarine": "beautiful",
  "ultramicroscope": "build",
  "ultramontane": "beautiful",
  "ultramontanism": "smart",
  "ultrasound": "sound",
  "ultrasuede": "build",
  "ultraviolet": "sound",
  "ululate": "story",
  "ululation": "story",
  "ulva": "heal",
  "ulvaceae": "heal",
  "ulvales": "heal",
  "ulvophyceae": "heal",
  "uma": "heal",
  "umbel": "heal",
  "umbellales": "heal",
  "umbellate": "beautiful",
  "umbellifer": "heal",
  "umbelliferae": "heal",
  "umbellularia": "heal",
  "umber": "beautiful",
  "umbilical": "heal",
  "umbilicus": "heal",
  "umbo": "heal",
  "umbrella": "build",
  "umbrellawort": "heal",
  "umbrian": "story",
  "umbrina": "heal",
  "umbundu": "story",
  "umlaut": "story",
  "umpirage": "story",
  "unable": "beautiful",
  "unabridged": "story",
  "unabused": "beautiful",
  "unaccented": "beautiful",
  "unacceptable": "beautiful",
  "unaccessible": "beautiful",
  "unaccommodating": "beautiful",
  "unaccompanied": "beautiful",
  "unaccustomed": "beautiful",
  "unacknowledged": "beautiful",
  "unacquisitive": "beautiful",
  "unactable": "beautiful",
  "unadaptable": "beautiful",
  "unaddicted": "beautiful",
  "unaddressed": "beautiful",
  "unadjusted": "beautiful",
  "unadoptable": "beautiful",
  "unadorned": "beautiful",
  "unadventurous": "beautiful",
  "unadvisable": "beautiful",
  "unadvised": "beautiful",
  "unaesthetic": "beautiful",
  "unaffected": "beautiful",
  "unaffixed": "beautiful",
  "unafraid": "beautiful",
  "unaggressive": "beautiful",
  "unagitated": "beautiful",
  "unai": "heal",
  "unairworthy": "beautiful",
  "unalarming": "beautiful",
  "unalert": "beautiful",
  "unalienable": "beautiful",
  "unalike": "beautiful",
  "unalterable": "beautiful",
  "unaltered": "beautiful",
  "unambiguous": "beautiful",
  "unambitious": "beautiful",
  "unamended": "beautiful",
  "unanalyzed": "beautiful",
  "unangry": "beautiful",
  "unanimated": "beautiful",
  "unapologetic": "beautiful",
  "unappealable": "beautiful",
  "unappealing": "beautiful",
  "unappendaged": "beautiful",
  "unappetising": "beautiful",
  "unappetizing": "beautiful",
  "unapproachable": "beautiful",
  "unarbitrary": "beautiful",
  "unargumentative": "beautiful",
  "unarmed": "beautiful",
  "unarmored": "beautiful",
  "unarmoured": "beautiful",
  "unarticulate": "beautiful",
  "unarticulated": "beautiful",
  "unascribable": "beautiful",
  "unashamed": "beautiful",
  "unassertive": "beautiful",
  "unassigned": "beautiful",
  "unassisted": "beautiful",
  "unattached": "beautiful",
  "unattractive": "beautiful",
  "unattributable": "beautiful",
  "unau": "heal",
  "unauthorised": "beautiful",
  "unauthorized": "beautiful",
  "unavailable": "beautiful",
  "unawakened": "beautiful",
  "unaware": "beautiful",
  "unawareness": "smart",
  "unawed": "beautiful",
  "unbalanced": "beautiful",
  "unbalconied": "beautiful",
  "unbanded": "beautiful",
  "unbaptised": "beautiful",
  "unbaptized": "beautiful",
  "unbar": "build",
  "unbarreled": "beautiful",
  "unbarrelled": "beautiful",
  "unbearable": "beautiful",
  "unbelief": "smart",
  "unbelievable": "beautiful",
  "unbelt": "build",
  "unbelted": "build",
  "unbend": "build",
  "unbeneficed": "beautiful",
  "unbind": "build",
  "unblemished": "beautiful",
  "unblended": "beautiful",
  "unblock": "build",
  "unbodied": "beautiful",
  "unbolt": "build",
  "unbordered": "beautiful",
  "unborn": "beautiful",
  "unbosom": "story",
  "unbound": "build",
  "unbox": "build",
  "unbrace": "build",
  "unbraid": "build",
  "unbrainwashed": "beautiful",
  "unbranded": "beautiful",
  "unbreakable": "beautiful",
  "unbridgeable": "beautiful",
  "unbridle": "sell",
  "unbroken": "beautiful",
  "unbuckle": "build",
  "unburden": "sell",
  "unburdened": "sell",
  "unburied": "beautiful",
  "unbutton": "build",
  "unbuttoned": "build",
  "uncamphorated": "beautiful",
  "uncared-for": "beautiful",
  "uncarpeted": "beautiful",
  "uncarved": "beautiful",
  "uncase": "heal",
  "uncastrated": "beautiful",
  "uncaulked": "beautiful",
  "uncensored": "beautiful",
  "uncertain": "beautiful",
  "uncertainty": "smart",
  "uncertified": "beautiful",
  "unchain": "build",
  "unchangeable": "beautiful",
  "unchanged": "beautiful",
  "uncharacteristic": "beautiful",
  "uncharged": "beautiful",
  "uncharitable": "beautiful",
  "unchartered": "beautiful",
  "unchaste": "beautiful",
  "uncheerful": "beautiful",
  "unchristian": "beautiful",
  "unchurch": "story",
  "uncial": "story",
  "uncivil": "beautiful",
  "unclasp": "build",
  "unclassified": "beautiful",
  "unclean": "beautiful",
  "unclear": "beautiful",
  "uncleared": "beautiful",
  "unclimbable": "beautiful",
  "unclip": "build",
  "uncloak": "story",
  "unclog": "build",
  "unclothe": "sell",
  "unclothed": "sell",
  "uncoated": "beautiful",
  "uncoil": "build",
  "uncoiled": "build",
  "uncolored": "beautiful",
  "uncoloured": "beautiful",
  "uncolumned": "beautiful",
  "uncombed": "beautiful",
  "uncombined": "beautiful",
  "uncomfortable": "beautiful",
  "uncommitted": "beautiful",
  "uncommon": "beautiful",
  "uncommunicative": "beautiful",
  "uncomparable": "beautiful",
  "uncompartmented": "beautiful",
  "uncompassionate": "beautiful",
  "uncomplaining": "beautiful",
  "uncomplete": "beautiful",
  "uncomplimentary": "beautiful",
  "uncomprehensible": "beautiful",
  "uncompress": "build",
  "uncompromising": "beautiful",
  "unconcealed": "beautiful",
  "unconcerned": "beautiful",
  "unconditional": "beautiful",
  "unconditioned": "beautiful",
  "unconfessed": "beautiful",
  "unconfined": "beautiful",
  "unconfirmed": "beautiful",
  "unconformist": "beautiful",
  "uncongenial": "beautiful",
  "unconnected": "beautiful",
  "unconquerable": "beautiful",
  "unconscientious": "beautiful",
  "unconscious": "smart",
  "unconsciousness": "smart",
  "unconsolable": "beautiful",
  "unconstipated": "beautiful",
  "unconstitutional": "beautiful",
  "unconstricted": "beautiful",
  "unconsummated": "beautiful",
  "uncontaminated": "beautiful",
  "uncontaminating": "beautiful",
  "uncontrived": "beautiful",
  "uncontrolled": "beautiful",
  "uncontroversial": "beautiful",
  "unconventional": "beautiful",
  "unconventionality": "smart",
  "unconvertible": "beautiful",
  "unconvinced": "beautiful",
  "unconvincing": "beautiful",
  "uncooperative": "beautiful",
  "uncork": "build",
  "uncorrected": "beautiful",
  "uncouple": "build",
  "uncousinly": "beautiful",
  "uncover": "sound",
  "uncovering": "sound",
  "uncrannied": "beautiful",
  "uncrate": "build",
  "uncreative": "beautiful",
  "uncreativeness": "smart",
  "uncritical": "beautiful",
  "uncrossed": "beautiful",
  "uncrowded": "beautiful",
  "uncrowned": "beautiful",
  "uncrystallised": "beautiful",
  "uncrystallized": "beautiful",
  "unction": "story",
  "uncultivated": "beautiful",
  "uncurtained": "beautiful",
  "uncut": "beautiful",
  "undamaged": "beautiful",
  "undatable": "beautiful",
  "undeceive": "story",
  "undeciphered": "beautiful",
  "undeclared": "beautiful",
  "undecorated": "beautiful",
  "undedicated": "beautiful",
  "undefeated": "beautiful",
  "undefined": "beautiful",
  "undelineated": "beautiful",
  "undemanding": "beautiful",
  "undemocratic": "beautiful",
  "undemonstrative": "beautiful",
  "undeniable": "beautiful",
  "undependable": "beautiful",
  "underachieve": "sell",
  "underact": "build",
  "underage": "beautiful",
  "underarm": "beautiful",
  "underbelly": "heal",
  "underbid": "sell",
  "underbodice": "build",
  "underbody": "heal",
  "undercarriage": "build",
  "undercharge": "sell",
  "underclass": "beautiful",
  "underclothes": "build",
  "underclothing": "build",
  "undercoat": "build",
  "undercurrent": "smart",
  "undercut": "taste",
  "underdevelop": "sound",
  "underdevelopment": "smart",
  "underdrawers": "build",
  "underdress": "heal",
  "underestimate": "smart",
  "underestimation": "smart",
  "underevaluation": "smart",
  "underexpose": "sound",
  "underfelt": "build",
  "underframe": "build",
  "underfur": "heal",
  "undergarment": "build",
  "undergird": "sell",
  "undergo": "sound",
  "underground": "build",
  "underhand": "beautiful",
  "underhanded": "beautiful",
  "underived": "beautiful",
  "underlay": "build",
  "underlayment": "build",
  "underline": "story",
  "underlip": "heal",
  "undermine": "sell",
  "undernourish": "taste",
  "underpants": "build",
  "underpart": "heal",
  "underpass": "build",
  "underpay": "sell",
  "underpayment": "sell",
  "underperform": "sell",
  "underpin": "build",
  "underplay": "build",
  "underprice": "sell",
  "underprivileged": "beautiful",
  "underproduce": "build",
  "underquote": "sell",
  "underrate": "smart",
  "underrating": "smart",
  "underreckoning": "smart",
  "underscore": "story",
  "underseal": "build",
  "undersell": "sell",
  "undershirt": "build",
  "undershrub": "heal",
  "undersign": "story",
  "underskirt": "build",
  "underspend": "sell",
  "understand": "smart",
  "understanding": "smart",
  "understate": "story",
  "understatement": "story",
  "understock": "sell",
  "understood": "smart",
  "understructure": "build",
  "understudy": "smart",
  "undertake": "build",
  "undertaking": "build",
  "undertone": "story",
  "undervaluation": "smart",
  "undervalue": "smart",
  "underwear": "build",
  "underwing": "heal",
  "underworld": "smart",
  "underwrite": "story",
  "undescriptive": "beautiful",
  "undesigned": "beautiful",
  "undesirable": "beautiful",
  "undesiring": "beautiful",
  "undesirous": "beautiful",
  "undetected": "beautiful",
  "undeterminable": "beautiful",
  "undetermined": "beautiful",
  "undeveloped": "beautiful",
  "undies": "build",
  "undifferentiated": "beautiful",
  "undignified": "beautiful",
  "undiluted": "beautiful",
  "undimmed": "beautiful",
  "undiplomatic": "beautiful",
  "undiscerning": "beautiful",
  "undiscriminating": "beautiful",
  "undistinguishable": "beautiful",
  "undiversified": "beautiful",
  "undo": "build",
  "undock": "build",
  "undocumented": "beautiful",
  "undoing": "build",
  "undomestic": "beautiful",
  "undrained": "beautiful",
  "undramatic": "beautiful",
  "undrape": "build",
  "undress": "heal",
  "undrinkable": "beautiful",
  "undue": "beautiful",
  "undynamic": "beautiful",
  "uneager": "beautiful",
  "unearned": "beautiful",
  "unearth": "sell",
  "uneasy": "beautiful",
  "uneatable": "beautiful",
  "unedifying": "beautiful",
  "uneducated": "beautiful",
  "uneffective": "beautiful",
  "unemotional": "beautiful",
  "unemployable": "beautiful",
  "unemployed": "beautiful",
  "unenclosed": "beautiful",
  "unencumbered": "beautiful",
  "unendowed": "beautiful",
  "unendurable": "beautiful",
  "unenforceable": "beautiful",
  "unenforced": "beautiful",
  "unenlightened": "beautiful",
  "unenlightening": "beautiful",
  "unenlightenment": "smart",
  "unenlivened": "beautiful",
  "unenrgetic": "beautiful",
  "unenterprising": "beautiful",
  "unenthusiastic": "beautiful",
  "unequal": "beautiful",
  "unequipped": "beautiful",
  "unequivocal": "beautiful",
  "unerect": "beautiful",
  "unessential": "beautiful",
  "unestablished": "beautiful",
  "unethical": "beautiful",
  "uneven": "beautiful",
  "uneventful": "beautiful",
  "unexchangeable": "beautiful",
  "unexcitable": "beautiful",
  "unexcited": "beautiful",
  "unexciting": "beautiful",
  "unexhausted": "beautiful",
  "unexpansive": "beautiful",
  "unexpected": "beautiful",
  "unexpendable": "beautiful",
  "unexpired": "beautiful",
  "unexploited": "beautiful",
  "unexplorative": "beautiful",
  "unexploratory": "beautiful",
  "unexportable": "beautiful",
  "unexpressible": "beautiful",
  "unextended": "beautiful",
  "unfaceted": "beautiful",
  "unfair": "beautiful",
  "unfairness": "smart",
  "unfaithful": "beautiful",
  "unfamiliar": "beautiful",
  "unfashionable": "beautiful",
  "unfasten": "build",
  "unfastened": "build",
  "unfastening": "build",
  "unfastidious": "beautiful",
  "unfathomable": "beautiful",
  "unfavorable": "beautiful",
  "unfavourable": "beautiful",
  "unfeathered": "beautiful",
  "unfertile": "beautiful",
  "unfinished": "beautiful",
  "unfit": "beautiful",
  "unfixed": "beautiful",
  "unflattering": "beautiful",
  "unfledged": "beautiful",
  "unfocused": "beautiful",
  "unfocussed": "beautiful",
  "unfold": "sound",
  "unfolding": "smart",
  "unforceful": "beautiful",
  "unforgettable": "beautiful",
  "unforgiving": "beautiful",
  "unformed": "beautiful",
  "unfortunate": "beautiful",
  "unframed": "beautiful",
  "unfree": "beautiful",
  "unfriendly": "beautiful",
  "unfrock": "sell",
  "unfrozen": "beautiful",
  "unfruitful": "beautiful",
  "unfueled": "beautiful",
  "unfunded": "beautiful",
  "unfurnished": "beautiful",
  "unfurrowed": "beautiful",
  "ungeared": "beautiful",
  "ungenerous": "beautiful",
  "unglazed": "build",
  "ungracious": "beautiful",
  "ungrammatical": "beautiful",
  "ungrateful": "beautiful",
  "ungreased": "beautiful",
  "ungregarious": "beautiful",
  "ungroomed": "beautiful",
  "unguent": "build",
  "unguiculata": "heal",
  "unguiculate": "heal",
  "unguiculated": "beautiful",
  "unguided": "beautiful",
  "unguis": "heal",
  "ungulata": "heal",
  "ungulate": "heal",
  "ungulated": "beautiful",
  "ungusseted": "beautiful",
  "unhallow": "story",
  "unhallowed": "story",
  "unhand": "build",
  "unhappy": "beautiful",
  "unhardened": "beautiful",
  "unharmonious": "beautiful",
  "unharness": "build",
  "unheaded": "beautiful",
  "unhealthful": "beautiful",
  "unhealthy": "beautiful",
  "unhearable": "beautiful",
  "unheeding": "beautiful",
  "unhelpful": "beautiful",
  "unhitch": "build",
  "unholy": "beautiful",
  "unhook": "build",
  "unhumorous": "beautiful",
  "unhurried": "beautiful",
  "unicameral": "beautiful",
  "unicycle": "build",
  "unidentifiable": "beautiful",
  "unidimensional": "beautiful",
  "unidirectional": "beautiful",
  "uniform": "build",
  "unify": "build",
  "unilateral": "beautiful",
  "unilateralism": "smart",
  "unilluminating": "beautiful",
  "unimodal": "beautiful",
  "unimpaired": "beautiful",
  "unimportant": "beautiful",
  "unimpressionable": "beautiful",
  "unimpressive": "beautiful",
  "unimproved": "beautiful",
  "uninflected": "beautiful",
  "uninfluential": "beautiful",
  "uninformative": "beautiful",
  "uninformed": "beautiful",
  "uninhabited": "beautiful",
  "uninhibited": "beautiful",
  "uninitiate": "beautiful",
  "uninjectable": "beautiful",
  "uninjured": "beautiful",
  "uninquiring": "beautiful",
  "uninquisitive": "beautiful",
  "uninspiring": "beautiful",
  "uninstructive": "beautiful",
  "uninsured": "beautiful",
  "unintegrated": "beautiful",
  "unintelligent": "beautiful",
  "unintelligibility": "story",
  "unintelligible": "beautiful",
  "unintended": "beautiful",
  "uninterested": "beautiful",
  "uninteresting": "beautiful",
  "uninterrupted": "beautiful",
  "unintrusive": "beautiful",
  "uninviting": "beautiful",
  "uninvolved": "beautiful",
  "unio": "heal",
  "unionidae": "heal",
  "unionise": "sell",
  "unionised": "sell",
  "unionize": "sell",
  "unionized": "sell",
  "uniparous": "beautiful",
  "unipolar": "beautiful",
  "unironed": "beautiful",
  "unison": "sound",
  "unit": "smart",
  "unitard": "build",
  "unitarianism": "smart",
  "unitary": "beautiful",
  "unite": "sell",
  "united": "sell",
  "uniting": "sell",
  "unitisation": "smart",
  "unitise": "sell",
  "unitization": "smart",
  "unitize": "sell",
  "unity": "smart",
  "univalent": "beautiful",
  "univalve": "heal",
  "universal": "story",
  "universalise": "story",
  "universalism": "smart",
  "universalize": "story",
  "universe": "smart",
  "university": "build",
  "univocal": "beautiful",
  "unix": "smart",
  "unjust": "beautiful",
  "unkept": "beautiful",
  "unkeyed": "beautiful",
  "unkind": "beautiful",
  "unknot": "build",
  "unknowable": "beautiful",
  "unknowing": "smart",
  "unknowingness": "smart",
  "unknown": "story",
  "unlabeled": "beautiful",
  "unlabelled": "beautiful",
  "unlace": "build",
  "unlaced": "build",
  "unlade": "build",
  "unlamented": "beautiful",
  "unlash": "build",
  "unlaureled": "beautiful",
  "unlaurelled": "beautiful",
  "unlawful": "beautiful",
  "unlax": "heal",
  "unleaded": "beautiful",
  "unlearn": "smart",
  "unlearned": "smart",
  "unleash": "build",
  "unleavened": "beautiful",
  "unlighted": "beautiful",
  "unlikable": "beautiful",
  "unlike": "beautiful",
  "unlikeable": "beautiful",
  "unlikely": "beautiful",
  "unlimited": "beautiful",
  "unlined": "beautiful",
  "unlipped": "beautiful",
  "unlisted": "beautiful",
  "unlit": "beautiful",
  "unlivable": "beautiful",
  "unliveable": "beautiful",
  "unliveried": "beautiful",
  "unload": "build",
  "unloaded": "build",
  "unloading": "build",
  "unlock": "build",
  "unlogical": "beautiful",
  "unloose": "sell",
  "unloosen": "sell",
  "unloved": "beautiful",
  "unloving": "beautiful",
  "unlubricated": "beautiful",
  "unlucky": "beautiful",
  "unmade": "build",
  "unmake": "build",
  "unmalicious": "beautiful",
  "unmanageable": "beautiful",
  "unmanful": "beautiful",
  "unmanlike": "beautiful",
  "unmanly": "beautiful",
  "unmanned": "beautiful",
  "unmarked": "beautiful",
  "unmarred": "beautiful",
  "unmarried": "beautiful",
  "unmask": "story",
  "unmasking": "story",
  "unmated": "beautiful",
  "unmeasurable": "beautiful",
  "unmeasured": "beautiful",
  "unmelodic": "sound",
  "unmelodious": "beautiful",
  "unmelted": "beautiful",
  "unmentionable": "build",
  "unmerciful": "beautiful",
  "unmerited": "beautiful",
  "unmilitary": "beautiful",
  "unmindful": "beautiful",
  "unmined": "beautiful",
  "unmitigated": "beautiful",
  "unmixable": "beautiful",
  "unmodifiable": "beautiful",
  "unmodified": "beautiful",
  "unmodulated": "beautiful",
  "unmotivated": "beautiful",
  "unmotorised": "beautiful",
  "unmotorized": "beautiful",
  "unmourned": "beautiful",
  "unmoved": "beautiful",
  "unmoving": "beautiful",
  "unmown": "beautiful",
  "unmusical": "beautiful",
  "unmutilated": "beautiful",
  "unmuzzle": "sell",
  "unnatural": "beautiful",
  "unnecessary": "beautiful",
  "unneeded": "beautiful",
  "unneurotic": "beautiful",
  "unnilquadium": "sound",
  "unnoticeable": "beautiful",
  "unnoticed": "beautiful",
  "unobjectionable": "beautiful",
  "unobligated": "beautiful",
  "unobliging": "beautiful",
  "unobstructed": "beautiful",
  "unobtrusive": "beautiful",
  "unobvious": "beautiful",
  "unoccupied": "beautiful",
  "unoffending": "beautiful",
  "unofficial": "beautiful",
  "unoiled": "beautiful",
  "unopen": "beautiful",
  "unopposable": "beautiful",
  "unopposed": "beautiful",
  "unordered": "beautiful",
  "unorganised": "beautiful",
  "unorganized": "beautiful",
  "unoriented": "beautiful",
  "unoriginal": "beautiful",
  "unoriginality": "smart",
  "unorthodox": "beautiful",
  "unorthodoxy": "smart",
  "unostentatious": "beautiful",
  "unowned": "beautiful",
  "unpack": "build",
  "unpackaged": "beautiful",
  "unpaid": "beautiful",
  "unpaintable": "beautiful",
  "unpainted": "beautiful",
  "unpalatable": "beautiful",
  "unpardonable": "beautiful",
  "unparented": "beautiful",
  "unpassable": "beautiful",
  "unpatriotic": "beautiful",
  "unpatronised": "beautiful",
  "unpatronized": "beautiful",
  "unpatterned": "beautiful",
  "unpaved": "beautiful",
  "unpeaceful": "beautiful",
  "unperceivable": "beautiful",
  "unperceiving": "beautiful",
  "unperceptive": "beautiful",
  "unpermissive": "beautiful",
  "unperplexed": "beautiful",
  "unpick": "build",
  "unpigmented": "beautiful",
  "unpin": "build",
  "unplanned": "beautiful",
  "unplanted": "beautiful",
  "unplayable": "beautiful",
  "unplayful": "beautiful",
  "unpleasant": "beautiful",
  "unpleasant-smelling": "beautiful",
  "unploughed": "beautiful",
  "unplowed": "beautiful",
  "unplug": "build",
  "unpointed": "beautiful",
  "unpolished": "beautiful",
  "unpopular": "beautiful",
  "unportable": "beautiful",
  "unpotted": "beautiful",
  "unpowered": "beautiful",
  "unprecedented": "beautiful",
  "unpredictable": "beautiful",
  "unprejudiced": "beautiful",
  "unpremeditated": "beautiful",
  "unprepared": "beautiful",
  "unpresidential": "beautiful",
  "unpretending": "beautiful",
  "unpretentious": "beautiful",
  "unpreventable": "beautiful",
  "unpriestly": "beautiful",
  "unprincipled": "beautiful",
  "unprintable": "beautiful",
  "unprocessed": "beautiful",
  "unproductive": "beautiful",
  "unprofessional": "beautiful",
  "unprofitable": "beautiful",
  "unpronounceable": "beautiful",
  "unprophetic": "beautiful",
  "unpropitious": "beautiful",
  "unprotected": "beautiful",
  "unprotective": "beautiful",
  "unproved": "beautiful",
  "unproven": "beautiful",
  "unprovocative": "beautiful",
  "unprovoking": "beautiful",
  "unpublishable": "beautiful",
  "unpublished": "beautiful",
  "unpunctual": "beautiful",
  "unpunished": "beautiful",
  "unq": "sound",
  "unqualified": "beautiful",
  "unquestionable": "beautiful",
  "unquiet": "beautiful",
  "unquotable": "beautiful",
  "unraised": "beautiful",
  "unravel": "build",
  "unreactive": "beautiful",
  "unready": "beautiful",
  "unreal": "beautiful",
  "unrealism": "smart",
  "unrealistic": "beautiful",
  "unreasonable": "beautiful",
  "unreassuring": "beautiful",
  "unreceptive": "beautiful",
  "unreconcilable": "beautiful",
  "unreconstructed": "beautiful",
  "unrecorded": "beautiful",
  "unrecoverable": "beautiful",
  "unreel": "build",
  "unrefined": "beautiful",
  "unreflected": "beautiful",
  "unregenerate": "beautiful",
  "unregenerated": "beautiful",
  "unregistered": "beautiful",
  "unregretful": "beautiful",
  "unregretting": "beautiful",
  "unregulated": "beautiful",
  "unrelated": "beautiful",
  "unreliable": "beautiful",
  "unremorseful": "beautiful",
  "unrenewable": "beautiful",
  "unrenewed": "beautiful",
  "unrentable": "beautiful",
  "unrepeatable": "beautiful",
  "unrepentant": "beautiful",
  "unreplaceable": "beautiful",
  "unreportable": "beautiful",
  "unreported": "beautiful",
  "unreproducible": "beautiful",
  "unrequested": "beautiful",
  "unresentful": "beautiful",
  "unreserved": "beautiful",
  "unresolved": "beautiful",
  "unrespectable": "beautiful",
  "unresponsive": "beautiful",
  "unrestrained": "beautiful",
  "unrestricted": "beautiful",
  "unrestrictive": "beautiful",
  "unretentive": "beautiful",
  "unreverberant": "beautiful",
  "unrevived": "beautiful",
  "unrewarding": "beautiful",
  "unrhetorical": "beautiful",
  "unrhymed": "beautiful",
  "unrhythmic": "sound",
  "unrhythmical": "sound",
  "unrifled": "beautiful",
  "unrigged": "beautiful",
  "unrighteous": "beautiful",
  "unrimed": "beautiful",
  "unripe": "beautiful",
  "unripened": "beautiful",
  "unroll": "build",
  "unsaddle": "build",
  "unsaddled": "build",
  "unsafe": "beautiful",
  "unsalable": "beautiful",
  "unsaleable": "beautiful",
  "unsanitary": "beautiful",
  "unsarcastic": "beautiful",
  "unsatiable": "beautiful",
  "unsatisfactory": "beautiful",
  "unsaturated": "beautiful",
  "unsavory": "beautiful",
  "unsavoury": "beautiful",
  "unsay": "story",
  "unscalable": "beautiful",
  "unscheduled": "beautiful",
  "unscholarly": "beautiful",
  "unscientific": "beautiful",
  "unscramble": "build",
  "unscrew": "build",
  "unscripted": "beautiful",
  "unscrupulous": "beautiful",
  "unseal": "build",
  "unsealed": "build",
  "unseamanlike": "beautiful",
  "unseasonable": "beautiful",
  "unseasoned": "beautiful",
  "unseat": "sell",
  "unseaworthy": "beautiful",
  "unsectarian": "beautiful",
  "unseductive": "beautiful",
  "unseeable": "beautiful",
  "unseeded": "beautiful",
  "unseen": "smart",
  "unselected": "beautiful",
  "unselfconsciousness": "smart",
  "unselfish": "beautiful",
  "unsensational": "beautiful",
  "unsent": "beautiful",
  "unserviceable": "beautiful",
  "unservile": "beautiful",
  "unsettled": "beautiful",
  "unsex": "sell",
  "unsexed": "sell",
  "unsexy": "beautiful",
  "unshaded": "beautiful",
  "unshapely": "beautiful",
  "unshared": "beautiful",
  "unshaved": "beautiful",
  "unshaven": "beautiful",
  "unsheared": "beautiful",
  "unsheathe": "build",
  "unsheathed": "build",
  "unshelled": "beautiful",
  "unshockable": "beautiful",
  "unshod": "beautiful",
  "unshoed": "beautiful",
  "unshorn": "beautiful",
  "unshrinkable": "beautiful",
  "unshuttered": "beautiful",
  "unsighted": "beautiful",
  "unsigned": "beautiful",
  "unsilenced": "beautiful",
  "unsinkable": "beautiful",
  "unsized": "beautiful",
  "unskilled": "beautiful",
  "unskillfulness": "smart",
  "unsmooth": "beautiful",
  "unsnarl": "build",
  "unsnarling": "build",
  "unsociable": "beautiful",
  "unsocial": "beautiful",
  "unsold": "beautiful",
  "unsolder": "build",
  "unsolved": "beautiful",
  "unsound": "beautiful",
  "unsoundness": "smart",
  "unsoured": "beautiful",
  "unspaced": "beautiful",
  "unspecialised": "beautiful",
  "unspecialized": "beautiful",
  "unspecified": "beautiful",
  "unspell": "story",
  "unstable": "beautiful",
  "unstaged": "beautiful",
  "unstained": "beautiful",
  "unstaple": "build",
  "unstatesmanlike": "beautiful",
  "unsteady": "beautiful",
  "unstimulating": "beautiful",
  "unstoppable": "beautiful",
  "unstrain": "heal",
  "unstrap": "build",
  "unstratified": "beautiful",
  "unstressed": "beautiful",
  "unstring": "build",
  "unstructured": "beautiful",
  "unstuck": "beautiful",
  "unstudied": "beautiful",
  "unstuff": "build",
  "unstylish": "beautiful",
  "unsubdivided": "beautiful",
  "unsubmissive": "beautiful",
  "unsubstantial": "beautiful",
  "unsuccessful": "beautiful",
  "unsupervised": "beautiful",
  "unsupported": "beautiful",
  "unsupportive": "beautiful",
  "unsure": "beautiful",
  "unsurmountable": "beautiful",
  "unsurprised": "beautiful",
  "unsurprising": "beautiful",
  "unsusceptible": "beautiful",
  "unsuspected": "beautiful",
  "unswept": "beautiful",
  "unsworn": "beautiful",
  "unsyllabic": "beautiful",
  "unsymbolic": "beautiful",
  "unsympathetic": "beautiful",
  "unsystematic": "beautiful",
  "untactful": "beautiful",
  "untagged": "beautiful",
  "untalented": "beautiful",
  "untamed": "beautiful",
  "untangle": "build",
  "untangled": "build",
  "untangling": "build",
  "untanned": "beautiful",
  "untapped": "beautiful",
  "unteach": "story",
  "untechnical": "beautiful",
  "untempered": "beautiful",
  "unthankful": "beautiful",
  "untheatrical": "beautiful",
  "unthematic": "sound",
  "unthinkable": "beautiful",
  "untidy": "beautiful",
  "untie": "build",
  "untied": "build",
  "untimbered": "beautiful",
  "untipped": "beautiful",
  "untouchable": "beautiful",
  "untouched": "beautiful",
  "untoughened": "beautiful",
  "untraceable": "beautiful",
  "untraditional": "beautiful",
  "untrained": "beautiful",
  "untranslatable": "beautiful",
  "untraveled": "beautiful",
  "untravelled": "beautiful",
  "untreated": "beautiful",
  "untrimmed": "beautiful",
  "untroubled": "beautiful",
  "untrustworthy": "beautiful",
  "untrusty": "beautiful",
  "untruth": "story",
  "untruthful": "beautiful",
  "untucked": "beautiful",
  "untuneful": "beautiful",
  "unturned": "beautiful",
  "untwine": "build",
  "untwist": "build",
  "untying": "build",
  "untypical": "beautiful",
  "ununderstood": "beautiful",
  "unusual": "beautiful",
  "unvaried": "beautiful",
  "unvarying": "beautiful",
  "unveil": "build",
  "unveiled": "build",
  "unveiling": "story",
  "unventilated": "beautiful",
  "unvigilant": "beautiful",
  "unvoiced": "beautiful",
  "unvoluntary": "beautiful",
  "unwanted": "beautiful",
  "unwary": "beautiful",
  "unwatchful": "beautiful",
  "unwaxed": "beautiful",
  "unweaned": "beautiful",
  "unwearable": "beautiful",
  "unweave": "build",
  "unwebbed": "beautiful",
  "unwelcome": "beautiful",
  "unwellness": "heal",
  "unwholesome": "beautiful",
  "unwieldy": "beautiful",
  "unwilling": "beautiful",
  "unwind": "build",
  "unwire": "build",
  "unwitting": "beautiful",
  "unwomanly": "beautiful",
  "unwooded": "beautiful",
  "unworldly": "beautiful",
  "unworthy": "beautiful",
  "unwoven": "beautiful",
  "unwrap": "build",
  "unwrapped": "build",
  "unwrinkled": "beautiful",
  "unwritten": "beautiful",
  "unyoke": "build",
  "unzip": "build",
  "upanishad": "story",
  "upbeat": "story",
  "upbraid": "story",
  "upbraiding": "story",
  "upcast": "build",
  "upchuck": "heal",
  "update": "story",
  "updating": "story",
  "updraft": "sound",
  "upend": "build",
  "upending": "build",
  "upgrade": "story",
  "upheave": "build",
  "uphill": "beautiful",
  "uphold": "story",
  "upholster": "sell",
  "upholstery": "build",
  "upland": "beautiful",
  "uplift": "build",
  "uplink": "story",
  "upload": "sell",
  "upmarket": "beautiful",
  "upper": "build",
  "upper-class": "beautiful",
  "uppercase": "story",
  "upraise": "heal",
  "upright": "build",
  "uproot": "sell",
  "upset": "build",
  "upshot": "sound",
  "upsilon": "story",
  "upstage": "build",
  "upstager": "beautiful",
  "upstair": "beautiful",
  "upstairs": "build",
  "upstart": "beautiful",
  "upstream": "beautiful",
  "upstroke": "story",
  "uptake": "smart",
  "uptown": "beautiful",
  "upupa": "heal",
  "upupidae": "heal",
  "uracil": "sound",
  "ural-altaic": "story",
  "uralic": "story",
  "uranalysis": "heal",
  "uranology": "smart",
  "uranoplasty": "taste",
  "uranoscopidae": "heal",
  "urban": "beautiful",
  "urbanisation": "smart",
  "urbanization": "smart",
  "urceole": "build",
  "urdu": "story",
  "urea": "sound",
  "uredinales": "heal",
  "ureter": "heal",
  "urethra": "heal",
  "urex": "build",
  "urge": "story",
  "urgency": "story",
  "urginea": "heal",
  "urging": "story",
  "uria": "heal",
  "urial": "heal",
  "urinal": "build",
  "urinalysis": "heal",
  "urinate": "heal",
  "urination": "smart",
  "url": "story",
  "urn": "build",
  "urobilin": "beautiful",
  "urochesia": "smart",
  "urochezia": "smart",
  "urochord": "sound",
  "urochorda": "sound",
  "urochordata": "sound",
  "urochordate": "sound",
  "urocyon": "heal",
  "urocystis": "heal",
  "urodele": "heal",
  "urodella": "heal",
  "urology": "smart",
  "uropathy": "heal",
  "urophycis": "heal",
  "uropsilus": "heal",
  "uropygi": "heal",
  "uropygium": "heal",
  "urosaurus": "heal",
  "ursidae": "heal",
  "ursinia": "heal",
  "ursus": "heal",
  "urtica": "heal",
  "urticaceae": "heal",
  "urticales": "heal",
  "urticate": "sound",
  "urtication": "smart",
  "urus": "heal",
  "usacil": "build",
  "usage": "story",
  "usance": "smart",
  "usbeg": "story",
  "usbek": "story",
  "use": "smart",
  "used": "taste",
  "used-car": "build",
  "useful": "beautiful",
  "useless": "beautiful",
  "using": "taste",
  "usnea": "heal",
  "usneaceae": "heal",
  "ustilaginaceae": "heal",
  "ustilaginales": "heal",
  "ustilaginoidea": "heal",
  "ustilago": "heal",
  "usual": "beautiful",
  "usurp": "sell",
  "usury": "sell",
  "uta": "heal",
  "utahraptor": "heal",
  "ute": "story",
  "utensil": "build",
  "uterus": "heal",
  "utile": "beautiful",
  "utilise": "taste",
  "utilitarian": "beautiful",
  "utilitarianism": "smart",
  "utility": "smart",
  "utilize": "taste",
  "utmost": "beautiful",
  "uto-aztecan": "story",
  "utopia": "story",
  "utopian": "beautiful",
  "utopianism": "smart",
  "utricle": "heal",
  "utricularia": "heal",
  "utriculus": "heal",
  "utter": "story",
  "utterance": "story",
  "utterer": "beautiful",
  "uttermost": "beautiful",
  "uvea": "heal",
  "uvula": "heal",
  "uvularia": "heal",
  "uvulariaceae": "heal",
  "uxorial": "beautiful",
  "uygur": "story",
  "uzbak": "story",
  "uzbeg": "story",
  "uzbek": "story",
  "uzi": "build",
  "v-1": "build",
  "vacate": "sell",
  "vaccaria": "heal",
  "vaccinate": "heal",
  "vaccinating": "heal",
  "vaccine": "heal",
  "vaccinium": "heal",
  "vaccinum": "build",
  "vacillation": "smart",
  "vacuole": "heal",
  "vacuousness": "smart",
  "vacuum": "build",
  "vacuum-clean": "build",
  "vagabond": "beautiful",
  "vagile": "beautiful",
  "vagina": "heal",
  "vagrant": "beautiful",
  "vague": "beautiful",
  "vagus": "heal",
  "vaishnavism": "smart",
  "vaisnavism": "smart",
  "valance": "build",
  "valdecoxib": "build",
  "valediction": "story",
  "valedictory": "story",
  "valenciennes": "build",
  "valency": "sound",
  "valentine": "story",
  "valerian": "heal",
  "valeriana": "heal",
  "valerianaceae": "heal",
  "valerianella": "heal",
  "valet": "sell",
  "valhalla": "smart",
  "valid": "beautiful",
  "validate": "sell",
  "validation": "smart",
  "valise": "build",
  "valium": "build",
  "vallecula": "heal",
  "vallisneria": "heal",
  "valsartan": "build",
  "valuable": "sell",
  "valuate": "smart",
  "valuation": "sell",
  "value": "smart",
  "value-system": "smart",
  "values": "smart",
  "valve": "build",
  "valvelet": "heal",
  "valvula": "heal",
  "valvule": "heal",
  "vambrace": "build",
  "vamp": "story",
  "vampirism": "smart",
  "van": "build",
  "vancocin": "build",
  "vancomycin": "build",
  "vanda": "heal",
  "vandalise": "build",
  "vandalize": "build",
  "vandyke": "heal",
  "vane": "build",
  "vanellus": "heal",
  "vanessa": "heal",
  "vanguard": "smart",
  "vangueria": "heal",
  "vanilla": "taste",
  "vanillin": "heal",
  "vanish": "sound",
  "vanishing": "sound",
  "vanity": "build",
  "vapor": "smart",
  "vaporing": "story",
  "vaporisation": "smart",
  "vaporiser": "build",
  "vaporization": "smart",
  "vaporize": "build",
  "vaporizer": "build",
  "vapors": "smart",
  "vapour": "smart",
  "vapours": "smart",
  "vaquita": "heal",
  "var": "smart",
  "vara": "smart",
  "varan": "heal",
  "varanidae": "heal",
  "varanus": "heal",
  "vardenafil": "build",
  "variable": "smart",
  "variance": "story",
  "variant": "smart",
  "variate": "smart",
  "variation": "story",
  "varicosis": "heal",
  "varietal": "taste",
  "variety": "story",
  "variometer": "build",
  "variorum": "story",
  "varment": "heal",
  "varmint": "heal",
  "varnish": "build",
  "vas": "heal",
  "vascularisation": "smart",
  "vascularization": "smart",
  "vase": "build",
  "vase-fine": "heal",
  "vasectomise": "heal",
  "vasectomize": "heal",
  "vaseline": "build",
  "vasoconstrictive": "build",
  "vasoconstrictor": "build",
  "vasodilative": "build",
  "vasodilator": "build",
  "vasomax": "build",
  "vasopressin": "heal",
  "vasopressor": "build",
  "vasotec": "build",
  "vat": "sell",
  "vatican": "build",
  "vaticinate": "story",
  "vaticination": "smart",
  "vaudeville": "story",
  "vault": "build",
  "vaulting": "build",
  "vaunt": "story",
  "vcr": "build",
  "vdu": "build",
  "veal": "taste",
  "veau": "taste",
  "vector": "smart",
  "veda": "story",
  "vedalia": "heal",
  "vedanga": "story",
  "vedanta": "smart",
  "vedism": "smart",
  "veery": "heal",
  "veg": "taste",
  "vegetable": "taste",
  "vegetal": "beautiful",
  "vegetarianism": "taste",
  "vegetation": "smart",
  "vegetational": "beautiful",
  "vegetative": "beautiful",
  "veggie": "taste",
  "vehicle": "build",
  "veil": "build",
  "veiled": "build",
  "veiling": "build",
  "vein": "heal",
  "vela": "heal",
  "velar": "story",
  "velban": "build",
  "velcro": "build",
  "velleity": "smart",
  "vellicate": "sound",
  "velocipede": "build",
  "velociraptor": "heal",
  "velodrome": "build",
  "velour": "build",
  "velours": "build",
  "veloute": "taste",
  "velum": "heal",
  "velveeta": "taste",
  "velvet": "build",
  "velvet-leaf": "heal",
  "velveteen": "build",
  "velvetleaf": "heal",
  "velvetweed": "heal",
  "vena": "heal",
  "venation": "heal",
  "vend": "sell",
  "vending": "sell",
  "veneer": "build",
  "veneering": "build",
  "veneridae": "heal",
  "venesect": "heal",
  "venison": "taste",
  "venogram": "build",
  "vent": "build",
  "vent-hole": "build",
  "ventail": "build",
  "venter": "heal",
  "venthole": "build",
  "ventilate": "sound",
  "ventilated": "sound",
  "ventilation": "build",
  "ventilator": "build",
  "venting": "story",
  "ventolin": "build",
  "ventral": "beautiful",
  "ventricle": "heal",
  "ventriculus": "heal",
  "ventriloquism": "smart",
  "ventriloquy": "smart",
  "venture": "sell",
  "venturi": "build",
  "venula": "heal",
  "venule": "heal",
  "venus": "heal",
  "venushair": "heal",
  "veps": "story",
  "vepse": "story",
  "vepsian": "story",
  "veranda": "build",
  "verandah": "build",
  "verapamil": "build",
  "veratrum": "heal",
  "verb": "story",
  "verbal": "beautiful",
  "verbalisation": "story",
  "verbalise": "story",
  "verbalism": "story",
  "verbalization": "story",
  "verbalize": "story",
  "verbascum": "heal",
  "verbena": "heal",
  "verbenaceae": "heal",
  "verbesina": "heal",
  "verbiage": "story",
  "verboseness": "story",
  "verbosity": "story",
  "verdicchio": "heal",
  "verdigris": "build",
  "verdin": "heal",
  "verdolagas": "heal",
  "verdure": "heal",
  "verge": "story",
  "verification": "smart",
  "verify": "smart",
  "verity": "smart",
  "vermicelli": "taste",
  "vermicide": "build",
  "vermiculate": "build",
  "vermiculation": "smart",
  "vermifuge": "build",
  "vermilion": "beautiful",
  "vermin": "heal",
  "vermis": "heal",
  "vermouth": "taste",
  "vernacular": "story",
  "vernal": "beautiful",
  "vernier": "build",
  "vernonia": "heal",
  "veronal": "build",
  "veronica": "heal",
  "verpa": "heal",
  "verruca": "heal",
  "versailles": "build",
  "versatility": "smart",
  "verse": "story",
  "versed": "build",
  "versicle": "story",
  "versification": "story",
  "versify": "build",
  "version": "story",
  "verso": "story",
  "verst": "smart",
  "vertebra": "heal",
  "vertebrata": "heal",
  "vertebrate": "heal",
  "vertex": "smart",
  "vertical": "build",
  "verticillium": "heal",
  "vertu": "smart",
  "vervain": "heal",
  "vervet": "heal",
  "very-light": "story",
  "vesica": "heal",
  "vesicant": "beautiful",
  "vesicaria": "heal",
  "vesication": "smart",
  "vesicatory": "beautiful",
  "vesicle": "heal",
  "vesiculation": "smart",
  "vesiculovirus": "heal",
  "vespa": "heal",
  "vespertilio": "heal",
  "vespertilionid": "heal",
  "vespertilionidae": "heal",
  "vespid": "heal",
  "vespidae": "heal",
  "vespula": "heal",
  "vessel": "heal",
  "vest": "build",
  "vestal": "beautiful",
  "vestibule": "build",
  "vestige": "story",
  "vestiture": "build",
  "vestment": "build",
  "vestry": "build",
  "vesture": "build",
  "vet": "sell",
  "vetch": "heal",
  "vetchling": "heal",
  "vetchworm": "heal",
  "veteran": "beautiful",
  "veto": "sell",
  "vex": "build",
  "vexation": "smart",
  "viaduct": "build",
  "viagra": "build",
  "vial": "build",
  "viand": "taste",
  "viands": "taste",
  "vibes": "build",
  "vibraharp": "build",
  "vibramycin": "build",
  "vibraphone": "build",
  "vibrate": "sound",
  "vibrato": "sound",
  "vibrator": "sound",
  "vibrio": "heal",
  "vibrion": "heal",
  "vibrissa": "heal",
  "viburnum": "heal",
  "vicarage": "build",
  "viceroy": "heal",
  "vichyssoise": "taste",
  "vicia": "heal",
  "victimise": "sell",
  "victimize": "sell",
  "victorian": "beautiful",
  "victrola": "build",
  "victual": "taste",
  "victuals": "taste",
  "vicugna": "heal",
  "vicuna": "build",
  "video": "story",
  "videocassette": "build",
  "videodisc": "build",
  "videodisk": "build",
  "videotape": "build",
  "vidua": "heal",
  "vietnamese": "story",
  "view": "smart",
  "viewer": "build",
  "viewers": "build",
  "viewfinder": "build",
  "viewgraph": "build",
  "viewing": "story",
  "viewpoint": "smart",
  "vigil": "smart",
  "vigilance": "smart",
  "vigna": "heal",
  "vignette": "story",
  "vigorish": "sell",
  "vii": "smart",
  "viii": "smart",
  "vilification": "story",
  "vilify": "story",
  "vilipend": "story",
  "villa": "build",
  "villeinage": "sell",
  "villus": "heal",
  "viminaria": "heal",
  "vinaceous": "beautiful",
  "vinaigrette": "taste",
  "vinblastine": "build",
  "vinca": "heal",
  "vincetoxicum": "heal",
  "vincristine": "build",
  "vindicate": "story",
  "vindication": "story",
  "vine": "heal",
  "vinegar": "taste",
  "vinegarroon": "heal",
  "vinegarweed": "heal",
  "vinery": "build",
  "vineyard": "taste",
  "viniculture": "taste",
  "vinifera": "heal",
  "vinification": "smart",
  "vinify": "taste",
  "vino": "taste",
  "vintage": "taste",
  "viocin": "build",
  "viol": "build",
  "viola": "sound",
  "violable": "beautiful",
  "violaceae": "heal",
  "violate": "sell",
  "violent": "beautiful",
  "violet": "heal",
  "violin": "sound",
  "violoncello": "build",
  "viomycin": "build",
  "vioxx": "build",
  "viper": "heal",
  "vipera": "heal",
  "viperidae": "heal",
  "viracept": "build",
  "viramune": "build",
  "virazole": "build",
  "virchow": "heal",
  "vireo": "heal",
  "vireonidae": "heal",
  "virga": "sound",
  "virgilia": "heal",
  "virgin": "beautiful",
  "virginal": "build",
  "virgule": "story",
  "viridity": "beautiful",
  "virile": "beautiful",
  "virilisation": "smart",
  "virilization": "smart",
  "virion": "heal",
  "viroid": "heal",
  "virology": "smart",
  "virtu": "smart",
  "virtuosity": "smart",
  "virtuoso": "beautiful",
  "virtuous": "beautiful",
  "virulent": "beautiful",
  "virus": "heal",
  "virusoid": "heal",
  "vis-a-vis": "smart",
  "visa": "story",
  "visage": "heal",
  "viscaceae": "heal",
  "viscacha": "heal",
  "viscera": "heal",
  "visceral": "beautiful",
  "viscometer": "build",
  "viscose": "build",
  "viscosimeter": "build",
  "viscountcy": "story",
  "viscum": "heal",
  "viscus": "heal",
  "vise": "build",
  "vishnuism": "smart",
  "visible": "beautiful",
  "vision": "smart",
  "visionary": "beautiful",
  "visiting": "sell",
  "visken": "build",
  "visor": "build",
  "vista": "smart",
  "vistaril": "build",
  "visual": "beautiful",
  "visualisation": "smart",
  "visualise": "sound",
  "visualization": "smart",
  "visualize": "build",
  "vitaceae": "heal",
  "vitalism": "smart",
  "vitality": "sound",
  "vitals": "heal",
  "vitaminise": "sell",
  "vitaminize": "sell",
  "vitellus": "heal",
  "vitiate": "sell",
  "viticulture": "taste",
  "viticulturist": "taste",
  "vitidaceae": "heal",
  "vitiligo": "beautiful",
  "vitis": "heal",
  "vitreous": "beautiful",
  "vitrification": "smart",
  "vitrine": "build",
  "vitriol": "story",
  "vittaria": "heal",
  "vittariaceae": "heal",
  "vituperate": "story",
  "vituperation": "story",
  "viva": "story",
  "vivarium": "build",
  "viverra": "heal",
  "viverricula": "heal",
  "viverridae": "heal",
  "viverrinae": "heal",
  "viverrine": "heal",
  "vivify": "heal",
  "viviparous": "beautiful",
  "vivisect": "build",
  "vixen": "heal",
  "viyella": "build",
  "vizor": "build",
  "vizsla": "heal",
  "vocable": "story",
  "vocabulary": "story",
  "vocal": "sound",
  "vocalic": "beautiful",
  "vocalisation": "story",
  "vocalise": "build",
  "vocalism": "story",
  "vocalization": "story",
  "vocalize": "story",
  "vocalizing": "story",
  "vocative": "story",
  "vociferate": "story",
  "vociferation": "story",
  "vodka": "taste",
  "vodoun": "smart",
  "vogue": "beautiful",
  "vogul": "story",
  "voice": "story",
  "voiced": "story",
  "voiceless": "beautiful",
  "voicelessness": "story",
  "voicemail": "story",
  "voiceprint": "story",
  "voicing": "story",
  "void": "sell",
  "voider": "build",
  "voiding": "smart",
  "voile": "build",
  "vol-au-vent": "taste",
  "volaille": "taste",
  "volapuk": "story",
  "volary": "build",
  "volatile": "beautiful",
  "volcanic": "beautiful",
  "volcanism": "sound",
  "volcanology": "smart",
  "vole": "heal",
  "volgaic": "story",
  "volition": "smart",
  "volley": "build",
  "volleyball": "build",
  "volt": "smart",
  "volt-ampere": "smart",
  "voltage": "sound",
  "voltaic": "story",
  "voltaren": "build",
  "voltmeter": "build",
  "voluble": "beautiful",
  "volume": "sound",
  "volumed": "beautiful",
  "volumeter": "build",
  "voluntary": "story",
  "volunteer": "story",
  "voluptuary": "beautiful",
  "volute": "build",
  "volva": "heal",
  "volvaria": "heal",
  "volvariaceae": "heal",
  "volvariella": "heal",
  "volvocaceae": "heal",
  "volvocales": "heal",
  "volvox": "heal",
  "vombatidae": "heal",
  "vomer": "heal",
  "vomit": "build",
  "vomiting": "heal",
  "vomitive": "build",
  "vomitory": "build",
  "voodoo": "build",
  "voodooism": "smart",
  "vorticella": "heal",
  "voteless": "beautiful",
  "voting": "sell",
  "votyak": "story",
  "vouch": "story",
  "voucher": "story",
  "vouchsafe": "sell",
  "vouge": "build",
  "voussoir": "build",
  "vouvray": "taste",
  "vow": "story",
  "vowel": "story",
  "vowelise": "story",
  "vowelize": "story",
  "vox": "story",
  "vroom": "story",
  "vulcanisation": "smart",
  "vulcanization": "smart",
  "vulcanology": "smart",
  "vulgarise": "story",
  "vulgarism": "story",
  "vulgarize": "story",
  "vulgate": "story",
  "vulnerable": "beautiful",
  "vulpes": "heal",
  "vultur": "heal",
  "vulture": "heal",
  "vulva": "heal",
  "w.c.": "build",
  "w.m.d.": "build",
  "wad": "smart",
  "wadding": "build",
  "wader": "heal",
  "waders": "build",
  "wading": "build",
  "wads": "smart",
  "wafer": "taste",
  "waffle": "taste",
  "waft": "build",
  "wafture": "story",
  "wage": "sell",
  "wager": "sell",
  "wages": "sell",
  "waggery": "story",
  "waggishness": "story",
  "waggon": "build",
  "wagner": "story",
  "wagon": "build",
  "wagon-lit": "build",
  "wagtail": "heal",
  "wahabism": "smart",
  "wahhabism": "smart",
  "wahoo": "heal",
  "wail": "story",
  "wailing": "story",
  "wain": "build",
  "wainscot": "build",
  "wainscoting": "build",
  "wainscotting": "build",
  "waist": "heal",
  "waistband": "build",
  "waistcloth": "build",
  "waistcoat": "build",
  "waistline": "heal",
  "waiting": "smart",
  "waitress": "sell",
  "waive": "sell",
  "wakashan": "story",
  "wake": "sound",
  "wake-robin": "heal",
  "wakeboard": "build",
  "wakefulness": "smart",
  "waken": "heal",
  "wakening": "heal",
  "waking": "smart",
  "walapai": "story",
  "walbiri": "story",
  "waldmeister": "heal",
  "wale": "build",
  "wales": "build",
  "walhalla": "smart",
  "walk-in": "build",
  "walk-on": "beautiful",
  "walk-through": "story",
  "walk-up": "build",
  "walker": "build",
  "walkie-talkie": "build",
  "walkingstick": "heal",
  "walkman": "build",
  "walkway": "build",
  "walky-talky": "build",
  "wall": "build",
  "wallaby": "heal",
  "wallboard": "build",
  "wallet": "build",
  "walleye": "heal",
  "walleyed": "beautiful",
  "wallflower": "heal",
  "walloon": "story",
  "walloons": "story",
  "wallop": "sound",
  "walloper": "story",
  "walloping": "build",
  "wallow": "taste",
  "wallpaper": "build",
  "walnut": "taste",
  "walrus": "heal",
  "waltz": "story",
  "wampee": "heal",
  "wampum": "sell",
  "wampumpeag": "build",
  "wan": "build",
  "wand": "build",
  "wandala": "story",
  "wander": "sell",
  "wanderer": "story",
  "wandering": "sell",
  "wandflower": "heal",
  "wane": "smart",
  "wangle": "smart",
  "wangling": "smart",
  "wank": "build",
  "wanted": "taste",
  "wanton": "sell",
  "wapiti": "heal",
  "waratah": "heal",
  "warble": "heal",
  "warbler": "heal",
  "ward": "build",
  "wardrobe": "build",
  "wardroom": "build",
  "ware": "build",
  "warehouse": "build",
  "warehousing": "sell",
  "warfarin": "build",
  "warhead": "build",
  "warhorse": "build",
  "warji": "story",
  "warlpiri": "story",
  "warm": "beautiful",
  "warm-blooded": "beautiful",
  "warmer": "build",
  "warmhearted": "beautiful",
  "warming": "smart",
  "warmongering": "smart",
  "warmth": "smart",
  "warn": "story",
  "warning": "story",
  "warp": "build",
  "warping": "story",
  "warplane": "build",
  "warragal": "heal",
  "warrant": "story",
  "warrantee": "story",
  "warranty": "story",
  "warrigal": "heal",
  "warship": "build",
  "wart": "heal",
  "warthog": "heal",
  "wartweed": "heal",
  "wartwort": "heal",
  "wary": "beautiful",
  "wasabi": "heal",
  "wash": "build",
  "wash-and-wear": "build",
  "washable": "beautiful",
  "washables": "build",
  "washbasin": "build",
  "washboard": "build",
  "washbowl": "build",
  "washcloth": "build",
  "washer": "build",
  "washhouse": "build",
  "washing": "build",
  "washout": "smart",
  "washrag": "build",
  "washroom": "build",
  "washstand": "build",
  "washtub": "build",
  "wasp": "heal",
  "wassail": "taste",
  "wassermann": "smart",
  "wastage": "smart",
  "wastebasket": "build",
  "wastebin": "build",
  "wasted": "sell",
  "wasteful": "beautiful",
  "wasteweir": "build",
  "wasting": "sell",
  "watch": "build",
  "watchband": "build",
  "watchdog": "heal",
  "watchful": "beautiful",
  "watchfulness": "smart",
  "watching": "sound",
  "watchstrap": "build",
  "watchtower": "build",
  "watchword": "story",
  "water": "build",
  "water-color": "build",
  "water-colour": "build",
  "water-mint": "heal",
  "water-rate": "sell",
  "water-shield": "heal",
  "water-target": "heal",
  "water-wash": "build",
  "waterbird": "heal",
  "waterbuck": "heal",
  "watercannon": "build",
  "watercolor": "beautiful",
  "watercolorist": "beautiful",
  "watercolour": "build",
  "watercolourist": "beautiful",
  "watercourse": "build",
  "watercraft": "smart",
  "watercress": "heal",
  "waterdog": "heal",
  "watered-silk": "build",
  "waterfinder": "build",
  "waterfowl": "heal",
  "watering": "smart",
  "waterleaf": "heal",
  "watermark": "story",
  "watermeal": "heal",
  "watermelon": "heal",
  "watermelon-shaped": "beautiful",
  "waterpower": "sound",
  "waterproof": "build",
  "waterproofing": "build",
  "waters": "heal",
  "waterscape": "build",
  "waterskin": "build",
  "waterspout": "sound",
  "waterway": "build",
  "waterweed": "heal",
  "waterwheel": "build",
  "waterworks": "build",
  "wats": "build",
  "watt": "smart",
  "watt-hour": "smart",
  "wattage": "sound",
  "wattle": "heal",
  "wattmeter": "build",
  "watts": "smart",
  "waul": "story",
  "waveband": "story",
  "waveguide": "build",
  "wavelength": "smart",
  "wavering": "smart",
  "waving": "story",
  "waw": "story",
  "wawl": "story",
  "wax": "build",
  "waxberry": "heal",
  "waxed": "build",
  "waxen": "beautiful",
  "waxflower": "heal",
  "waxing": "build",
  "waxmallow": "heal",
  "waxwing": "heal",
  "waxwork": "heal",
  "waxy": "beautiful",
  "waxycap": "heal",
  "waybill": "story",
  "wayfaring": "beautiful",
  "ways": "build",
  "wayside": "build",
  "wbc": "heal",
  "wbs": "smart",
  "weak": "beautiful",
  "weaken": "sell",
  "weakfish": "taste",
  "wealth": "sell",
  "wean": "taste",
  "weaned": "taste",
  "weaning": "taste",
  "weapon": "build",
  "weaponry": "build",
  "wear": "build",
  "wearable": "build",
  "weariness": "sound",
  "wearing": "smart",
  "weary": "heal",
  "weasel": "heal",
  "weather": "sound",
  "weathercock": "build",
  "weatherglass": "build",
  "weatherproof": "beautiful",
  "weatherstrip": "build",
  "weatherstripping": "build",
  "weathervane": "build",
  "weave": "beautiful",
  "weaver": "heal",
  "weaverbird": "heal",
  "weaving": "build",
  "web": "build",
  "webbed": "build",
  "webbing": "build",
  "webcam": "build",
  "weber": "smart",
  "webfoot": "heal",
  "webpage": "story",
  "website": "smart",
  "webworm": "heal",
  "wed": "sell",
  "wedding": "sell",
  "wedge": "taste",
  "wedge-shaped": "beautiful",
  "wedgie": "build",
  "wedgwood": "build",
  "wee": "heal",
  "wee-wee": "heal",
  "weed": "heal",
  "weed-whacker": "build",
  "weeder": "build",
  "weedless": "beautiful",
  "weeds": "build",
  "weedy": "beautiful",
  "weekender": "build",
  "weekly": "story",
  "weenie": "taste",
  "weep": "heal",
  "weeping": "heal",
  "weevil": "heal",
  "weft": "build",
  "weigela": "heal",
  "weigh": "story",
  "weighbridge": "build",
  "weighing": "smart",
  "weight": "build",
  "weighting": "smart",
  "weightless": "beautiful",
  "weighty": "beautiful",
  "weimaraner": "heal",
  "weir": "build",
  "weird": "beautiful",
  "weissbier": "taste",
  "weizenbier": "taste",
  "weizenbock": "taste",
  "weka": "heal",
  "welch": "sell",
  "welcome": "story",
  "welcomer": "beautiful",
  "weld": "build",
  "welder": "build",
  "welding": "build",
  "weldment": "build",
  "well": "build",
  "well-advised": "beautiful",
  "well-defined": "beautiful",
  "well-formed": "beautiful",
  "well-wishing": "story",
  "wellerism": "story",
  "wellhead": "build",
  "wellington": "build",
  "wellpoint": "build",
  "wells": "build",
  "wellspring": "story",
  "welsh": "story",
  "welt": "build",
  "weltanschauung": "smart",
  "welter": "smart",
  "welterweight": "smart",
  "welwitschia": "heal",
  "welwitschiaceae": "heal",
  "wench": "build",
  "wernicke": "heal",
  "wesleyanism": "smart",
  "wesleyism": "smart",
  "wester": "sound",
  "westerly": "sound",
  "western": "story",
  "westerner": "beautiful",
  "westernisation": "smart",
  "westernization": "smart",
  "westward": "beautiful",
  "wet": "heal",
  "wet-nurse": "taste",
  "wether": "heal",
  "wetter": "beautiful",
  "wetting": "smart",
  "whack": "build",
  "whacker": "build",
  "whacking": "build",
  "whale": "heal",
  "whaleboat": "build",
  "whaler": "build",
  "whalesucker": "heal",
  "wham": "build",
  "whammy": "story",
  "whang": "build",
  "whap": "build",
  "wharf": "build",
  "wharfage": "sell",
  "whatchamacallit": "build",
  "whatchamacallum": "build",
  "whatnot": "build",
  "whatsis": "build",
  "wheat": "heal",
  "wheat-grass": "heal",
  "wheatear": "heal",
  "wheatflake": "taste",
  "wheatgrass": "heal",
  "wheatworm": "heal",
  "wheedle": "story",
  "wheedling": "story",
  "wheel": "build",
  "wheelbarrow": "build",
  "wheelchair": "heal",
  "wheelhouse": "build",
  "wheelless": "beautiful",
  "wheelwork": "build",
  "wheeze": "smart",
  "whelk": "taste",
  "whelp": "heal",
  "wherewithal": "sell",
  "wherry": "build",
  "whet": "sound",
  "whetstone": "build",
  "whey": "taste",
  "whicker": "story",
  "whidah": "heal",
  "whiff": "sound",
  "whiffletree": "build",
  "whim": "smart",
  "whimper": "story",
  "whimsey": "smart",
  "whimsy": "smart",
  "whin": "heal",
  "whinberry": "heal",
  "whinchat": "heal",
  "whine": "story",
  "whinny": "story",
  "whip": "build",
  "whip-round": "story",
  "whip-scorpion": "heal",
  "whip-snake": "heal",
  "whipcord": "build",
  "whippet": "heal",
  "whipping": "build",
  "whippletree": "build",
  "whippoorwill": "heal",
  "whipsaw": "build",
  "whipsnake": "heal",
  "whipstitch": "build",
  "whipstitching": "build",
  "whiptail": "heal",
  "whir": "sound",
  "whirlaway": "heal",
  "whirler": "build",
  "whirligig": "build",
  "whirlwind": "sound",
  "whirlybird": "build",
  "whirr": "sound",
  "whirring": "sound",
  "whish": "sound",
  "whisk": "taste",
  "whisker": "smart",
  "whiskers": "heal",
  "whiskey": "taste",
  "whisky": "taste",
  "whisper": "story",
  "whispering": "story",
  "whistle": "story",
  "whistler": "heal",
  "whistling": "story",
  "whit": "smart",
  "white-collar": "beautiful",
  "whitebait": "taste",
  "whitecup": "heal",
  "whiteface": "heal",
  "whitefish": "taste",
  "whitefly": "heal",
  "whitehall": "beautiful",
  "whitehead": "heal",
  "whiteout": "sound",
  "whitetail": "heal",
  "whitethorn": "heal",
  "whitethroat": "heal",
  "whitewash": "build",
  "whitewood": "heal",
  "whiting": "taste",
  "whitlavia": "heal",
  "whitlowwort": "heal",
  "whittle": "build",
  "whiz": "sound",
  "whizbang": "build",
  "whizz": "sound",
  "whizzbang": "build",
  "whodunit": "story",
  "whole": "smart",
  "wholesale": "sell",
  "wholesome": "beautiful",
  "whomp": "build",
  "whoop": "story",
  "whooper": "heal",
  "whop": "build",
  "whopper": "story",
  "whore": "sell",
  "whorehouse": "build",
  "whorl": "heal",
  "whorlywort": "heal",
  "whortleberry": "heal",
  "whydah": "heal",
  "wicca": "smart",
  "wichita": "story",
  "wick": "build",
  "wicked": "beautiful",
  "wicker": "build",
  "wickerwork": "build",
  "wicket": "build",
  "wickiup": "build",
  "wickup": "heal",
  "wicopy": "heal",
  "wide": "beautiful",
  "wide-body": "build",
  "widening": "smart",
  "widgeon": "heal",
  "widget": "build",
  "wield": "sell",
  "wieldy": "beautiful",
  "wiener": "taste",
  "wienerwurst": "taste",
  "wifelike": "beautiful",
  "wifely": "beautiful",
  "wiffle": "build",
  "wifi": "build",
  "wig": "build",
  "wigeon": "heal",
  "wigged": "beautiful",
  "wigging": "story",
  "wiggler": "heal",
  "wigless": "beautiful",
  "wigwag": "build",
  "wigwam": "build",
  "wikiup": "build",
  "wild": "beautiful",
  "wildcat": "build",
  "wildebeest": "heal",
  "wilder": "beautiful",
  "wildflower": "heal",
  "wildfowl": "taste",
  "wilding": "heal",
  "wiliness": "smart",
  "will": "smart",
  "will-o'-the-wisp": "sound",
  "willet": "heal",
  "willing": "story",
  "willow": "heal",
  "willow-pattern": "build",
  "willowherb": "heal",
  "willowware": "build",
  "wilton": "build",
  "wimble": "build",
  "wimple": "build",
  "win": "sell",
  "wince": "story",
  "wincey": "build",
  "winceyette": "build",
  "winch": "build",
  "winchester": "build",
  "wind": "sound",
  "windage": "sound",
  "windbreak": "build",
  "windbreaker": "build",
  "windcheater": "build",
  "winder": "build",
  "windfall": "taste",
  "windflower": "heal",
  "windiness": "story",
  "winding": "build",
  "winding-clothes": "build",
  "winding-sheet": "build",
  "windjammer": "build",
  "windlass": "build",
  "windmill": "build",
  "window": "build",
  "window-shop": "sell",
  "windowpane": "build",
  "windows": "story",
  "windowsill": "build",
  "windpipe": "heal",
  "windscreen": "build",
  "windshield": "build",
  "windsock": "story",
  "windstorm": "sound",
  "windup": "beautiful",
  "windward": "beautiful",
  "wine": "taste",
  "wineberry": "heal",
  "wineglass": "build",
  "winepress": "build",
  "winery": "taste",
  "winesap": "taste",
  "wineskin": "build",
  "wing": "heal",
  "wing-nut": "heal",
  "winged": "beautiful",
  "wingless": "beautiful",
  "wings": "story",
  "wingstem": "heal",
  "wink": "story",
  "winker": "build",
  "winking": "heal",
  "winkle": "taste",
  "winnebago": "story",
  "winning": "sell",
  "winnings": "sell",
  "winnow": "build",
  "winnowing": "build",
  "wintera": "heal",
  "winteraceae": "heal",
  "winterberry": "heal",
  "wintergreen": "heal",
  "wintery": "beautiful",
  "wintry": "beautiful",
  "wintun": "story",
  "wipe": "build",
  "wiper": "build",
  "wire": "build",
  "wired": "sell",
  "wirehair": "heal",
  "wireless": "story",
  "wiretap": "sound",
  "wirework": "build",
  "wireworm": "heal",
  "wiring": "build",
  "wiry": "beautiful",
  "wisdom": "smart",
  "wise": "beautiful",
  "wisecrack": "story",
  "wisent": "heal",
  "wish": "story",
  "wish-wash": "taste",
  "wishbone": "heal",
  "wishful": "beautiful",
  "wishing": "story",
  "wistaria": "heal",
  "wisteria": "heal",
  "wit": "story",
  "witchcraft": "smart",
  "witchery": "smart",
  "witchgrass": "heal",
  "witching": "story",
  "withdraw": "sell",
  "withdrawal": "story",
  "withe": "build",
  "withering": "beautiful",
  "withers": "heal",
  "withhold": "sell",
  "withholding": "sell",
  "withy": "heal",
  "witloof": "heal",
  "witness": "story",
  "wits": "smart",
  "witticism": "story",
  "wittiness": "story",
  "witting": "beautiful",
  "wive": "sell",
  "wizard": "beautiful",
  "wizardry": "smart",
  "wlan": "build",
  "wmd": "build",
  "woad": "heal",
  "woadwaxen": "heal",
  "wobbler": "build",
  "wobbly": "beautiful",
  "wok": "taste",
  "wolf": "heal",
  "wolf-whistle": "story",
  "wolfbane": "heal",
  "wolffia": "heal",
  "wolffiella": "heal",
  "wolffish": "heal",
  "wolfhound": "heal",
  "wolfish": "beautiful",
  "wolfsbane": "heal",
  "wolof": "story",
  "wolverine": "heal",
  "womanise": "sell",
  "womanize": "sell",
  "womanlike": "beautiful",
  "womanly": "beautiful",
  "womb": "heal",
  "wombat": "heal",
  "won": "smart",
  "wonder": "smart",
  "wonderberry": "heal",
  "wonderland": "smart",
  "wont": "smart",
  "wonton": "taste",
  "woo": "sell",
  "wood-creeper": "heal",
  "wood-fern": "heal",
  "wood-frog": "heal",
  "wood-rat": "heal",
  "woodbine": "heal",
  "woodborer": "heal",
  "woodcarving": "build",
  "woodchuck": "heal",
  "woodcock": "heal",
  "woodcraft": "smart",
  "woodcreeper": "heal",
  "woodcut": "beautiful",
  "wooded": "beautiful",
  "woodenware": "build",
  "woodfern": "heal",
  "woodhewer": "heal",
  "woodlet": "build",
  "woodlouse": "heal",
  "woodpecker": "heal",
  "woodruff": "heal",
  "woodscrew": "build",
  "woodshed": "build",
  "woodsia": "heal",
  "woodward": "sound",
  "woodwardia": "heal",
  "woodwaxen": "heal",
  "woodwind": "build",
  "woodwork": "build",
  "woodworking": "build",
  "woodworm": "heal",
  "woody": "beautiful",
  "woof": "build",
  "woofer": "build",
  "wooing": "story",
  "wool": "beautiful",
  "woolen": "build",
  "woolgather": "build",
  "woolgathering": "smart",
  "woollen": "build",
  "worcestershire": "taste",
  "word": "story",
  "word-painting": "story",
  "word-splitting": "smart",
  "wordbook": "story",
  "wordfinder": "story",
  "wordiness": "story",
  "wording": "story",
  "wordnet": "story",
  "wordplay": "story",
  "words": "story",
  "work": "build",
  "work-board": "build",
  "work-clothes": "build",
  "work-clothing": "build",
  "work-shirt": "build",
  "workbag": "build",
  "workbasket": "build",
  "workbench": "build",
  "workboard": "build",
  "workbook": "story",
  "workbox": "build",
  "worker": "heal",
  "workhorse": "build",
  "workhouse": "build",
  "working": "build",
  "workings": "build",
  "workmanship": "smart",
  "workpiece": "build",
  "workplace": "build",
  "workroom": "build",
  "works": "build",
  "worksheet": "story",
  "workshop": "build",
  "workstation": "build",
  "worktable": "build",
  "workwear": "build",
  "world": "smart",
  "worldly": "beautiful",
  "worm": "heal",
  "wormseed": "heal",
  "wormwood": "heal",
  "worn": "heal",
  "worrisome": "beautiful",
  "worry": "smart",
  "worse": "beautiful",
  "worsened": "beautiful",
  "worsening": "smart",
  "worsted": "build",
  "wort": "heal",
  "worth": "smart",
  "worthless": "beautiful",
  "worthy": "beautiful",
  "wounded": "heal",
  "wounding": "heal",
  "woven": "build",
  "wow": "story",
  "wrack": "heal",
  "wraith": "smart",
  "wrangle": "story",
  "wrangling": "story",
  "wrap": "build",
  "wraparound": "build",
  "wrapped": "build",
  "wrapper": "build",
  "wrapping": "build",
  "wrasse": "heal",
  "wrawl": "story",
  "wreak": "build",
  "wreath": "beautiful",
  "wreathe": "build",
  "wreck": "build",
  "wreckage": "build",
  "wrecker": "build",
  "wreckfish": "heal",
  "wrecking": "build",
  "wren": "heal",
  "wren-tit": "heal",
  "wrench": "build",
  "wrest": "build",
  "wrestle": "story",
  "wrestling": "story",
  "wrick": "heal",
  "wriggler": "heal",
  "wring": "build",
  "wringer": "build",
  "wrinkle": "smart",
  "wrinkled": "build",
  "wrinkleless": "beautiful",
  "wrinkly": "beautiful",
  "wrist": "heal",
  "wristband": "build",
  "wristlet": "build",
  "wristwatch": "build",
  "writ": "story",
  "write": "story",
  "write-down": "sell",
  "write-off": "sell",
  "writing": "story",
  "writings": "story",
  "written": "build",
  "wrong": "sell",
  "wrymouth": "heal",
  "wryneck": "heal",
  "wtc": "build",
  "wtv": "heal",
  "www": "build",
  "wye": "story",
  "wynnea": "heal",
  "wytensin": "build",
  "x-axis": "smart",
  "x-radiation": "sound",
  "x-ray": "sound",
  "x-raying": "sound",
  "xanax": "build",
  "xanthium": "heal",
  "xanthomonad": "heal",
  "xanthomonas": "heal",
  "xanthophyceae": "heal",
  "xanthophyl": "beautiful",
  "xanthophyll": "beautiful",
  "xanthorrhoeaceae": "heal",
  "xanthorroea": "heal",
  "xanthosoma": "heal",
  "xantusiidae": "heal",
  "xenarthra": "heal",
  "xenicidae": "heal",
  "xenicus": "heal",
  "xenogeneic": "beautiful",
  "xenogenesis": "sound",
  "xenograft": "heal",
  "xenopodidae": "heal",
  "xenopus": "heal",
  "xenorhyncus": "heal",
  "xenosauridae": "heal",
  "xenosaurus": "heal",
  "xeranthemum": "heal",
  "xeric": "beautiful",
  "xerobates": "heal",
  "xerophile": "heal",
  "xerophyllum": "heal",
  "xerophyte": "heal",
  "xerox": "build",
  "xhosa": "story",
  "xii": "smart",
  "xiii": "smart",
  "xiphias": "heal",
  "xiphiidae": "heal",
  "xiphosura": "heal",
  "xiv": "smart",
  "xix": "smart",
  "xtc": "build",
  "xvi": "smart",
  "xvii": "smart",
  "xviii": "smart",
  "xxi": "smart",
  "xxii": "smart",
  "xxiii": "smart",
  "xxiv": "smart",
  "xxix": "smart",
  "xxv": "smart",
  "xxvi": "smart",
  "xxvii": "smart",
  "xxviii": "smart",
  "xxx": "smart",
  "xxy": "heal",
  "xylaria": "heal",
  "xylariaceae": "heal",
  "xylem": "heal",
  "xylocaine": "build",
  "xylocopa": "heal",
  "xylomelum": "heal",
  "xylophone": "build",
  "xylopia": "heal",
  "xylosma": "heal",
  "xyphophorus": "heal",
  "xyridaceae": "heal",
  "xyridales": "heal",
  "xyris": "heal",
  "xyy": "heal",
  "y-axis": "smart",
  "yacca": "heal",
  "yacht": "build",
  "yack": "story",
  "yagi": "build",
  "yahi": "story",
  "yahoo": "story",
  "yajur-veda": "story",
  "yak": "story",
  "yakety-yak": "story",
  "yakut": "story",
  "yale": "build",
  "yam": "heal",
  "yamaltu": "story",
  "yammer": "story",
  "yana": "story",
  "yanan": "story",
  "yang": "smart",
  "yank": "build",
  "yankee": "beautiful",
  "yanquapin": "heal",
  "yap": "heal",
  "yard": "smart",
  "yardarm": "build",
  "yarder": "smart",
  "yardgrass": "heal",
  "yardstick": "story",
  "yarmelke": "build",
  "yarmulka": "build",
  "yarmulke": "build",
  "yarn": "beautiful",
  "yarrow": "heal",
  "yashmac": "build",
  "yashmak": "build",
  "yataghan": "build",
  "yaup": "story",
  "yautia": "heal",
  "yavapai": "story",
  "yawl": "build",
  "yawn": "heal",
  "yawning": "heal",
  "yawp": "story",
  "yay": "story",
  "ybit": "smart",
  "yea": "story",
  "year-around": "beautiful",
  "year-end": "beautiful",
  "year-round": "beautiful",
  "yearbook": "story",
  "yearling": "heal",
  "yearly": "story",
  "yeast": "taste",
  "yeasty": "beautiful",
  "yell": "story",
  "yelling": "story",
  "yellow": "beautiful",
  "yellowbird": "heal",
  "yellowfin": "heal",
  "yellowhammer": "heal",
  "yellowlegs": "heal",
  "yellowness": "beautiful",
  "yellowtail": "heal",
  "yellowthroat": "heal",
  "yellowwood": "heal",
  "yelp": "story",
  "yelping": "story",
  "yen": "smart",
  "yenisei": "story",
  "yenisei-samoyed": "story",
  "yeniseian": "story",
  "yes": "story",
  "yew": "heal",
  "yib": "smart",
  "yibit": "smart",
  "yiddish": "story",
  "yield": "sell",
  "yielding": "story",
  "yin": "smart",
  "yip": "story",
  "yips": "story",
  "ylang-ylang": "heal",
  "yo-yo": "build",
  "yobibit": "smart",
  "yobibyte": "smart",
  "yodel": "story",
  "yodeling": "story",
  "yodh": "story",
  "yoga": "smart",
  "yogacara": "smart",
  "yoghourt": "taste",
  "yoghurt": "taste",
  "yogurt": "taste",
  "yoke": "build",
  "yokuts": "story",
  "yolk": "taste",
  "yoruba": "story",
  "yottabit": "smart",
  "yottabyte": "smart",
  "you-drive": "sell",
  "young": "heal",
  "youth-on-age": "heal",
  "yowl": "story",
  "yquem": "taste",
  "yuan": "smart",
  "yucatec": "story",
  "yucateco": "story",
  "yucca": "heal",
  "yue": "story",
  "yuma": "story",
  "yuman": "story",
  "yurak-samoyed": "story",
  "yurt": "build",
  "z-axis": "smart",
  "zaar": "story",
  "zabaglione": "taste",
  "zacharias": "story",
  "zaglossus": "heal",
  "zaire": "smart",
  "zakat": "smart",
  "zalcitabine": "build",
  "zalophus": "heal",
  "zaman": "heal",
  "zamang": "heal",
  "zamboni": "build",
  "zamia": "heal",
  "zamiaceae": "heal",
  "zannichellia": "heal",
  "zannichelliaceae": "heal",
  "zantac": "build",
  "zantedeschia": "heal",
  "zanthoxylum": "heal",
  "zany": "beautiful",
  "zap": "build",
  "zapodidae": "heal",
  "zapotec": "story",
  "zapotecan": "story",
  "zapper": "build",
  "zapus": "heal",
  "zarf": "build",
  "zarontin": "build",
  "zayin": "story",
  "zbit": "smart",
  "zdv": "build",
  "zea": "heal",
  "zealotry": "smart",
  "zeaxanthin": "beautiful",
  "zebibit": "smart",
  "zebibyte": "smart",
  "zebra": "heal",
  "zebrawood": "heal",
  "zebu": "heal",
  "zechariah": "story",
  "zed": "story",
  "zee": "story",
  "zeidae": "heal",
  "zen": "smart",
  "zenaidura": "heal",
  "zend": "story",
  "zend-avesta": "story",
  "zeomorphi": "heal",
  "zep": "taste",
  "zephaniah": "story",
  "zephyr": "sound",
  "zeppelin": "build",
  "zero": "smart",
  "zest": "sound",
  "zestril": "build",
  "zeta": "story",
  "zettabit": "smart",
  "zettabyte": "smart",
  "zeugma": "story",
  "zeus": "heal",
  "zhuang": "story",
  "zib": "smart",
  "zibit": "smart",
  "zidovudine": "build",
  "zigadene": "heal",
  "zigadenus": "heal",
  "ziggurat": "build",
  "zigzag": "beautiful",
  "zikkurat": "build",
  "zikurat": "build",
  "zilch": "smart",
  "zill": "build",
  "zillion": "smart",
  "zimmer": "build",
  "zinacef": "build",
  "zinc": "build",
  "zinfandel": "heal",
  "zinger": "story",
  "zingiber": "heal",
  "zingiberaceae": "heal",
  "zinjanthropus": "heal",
  "zinnia": "heal",
  "zion": "smart",
  "zionism": "story",
  "zip": "smart",
  "ziphiidae": "heal",
  "zipper": "build",
  "zippo": "smart",
  "zirconia": "build",
  "zither": "build",
  "zithern": "build",
  "zithromax": "build",
  "ziti": "taste",
  "zizania": "heal",
  "ziziphus": "heal",
  "zloty": "smart",
  "zoarces": "heal",
  "zoarcidae": "heal",
  "zocor": "build",
  "zodiac": "build",
  "zoisia": "heal",
  "zoloft": "build",
  "zona": "heal",
  "zonal": "beautiful",
  "zone": "heal",
  "zoning": "sell",
  "zonotrichia": "heal",
  "zonula": "heal",
  "zonule": "heal",
  "zoo": "build",
  "zooflagellate": "heal",
  "zooid": "heal",
  "zoology": "smart",
  "zoomastigina": "heal",
  "zoomastigote": "heal",
  "zoomorphism": "smart",
  "zoophyte": "heal",
  "zooplankton": "heal",
  "zoospore": "heal",
  "zori": "build",
  "zoril": "heal",
  "zoroastrianism": "smart",
  "zostera": "heal",
  "zosteraceae": "heal",
  "zovirax": "build",
  "zoysia": "heal",
  "zucchini": "heal",
  "zulu": "story",
  "zurvanism": "smart",
  "zwieback": "taste",
  "zydeco": "story",
  "zygnema": "heal",
  "zygnemales": "heal",
  "zygnemataceae": "heal",
  "zygnematales": "heal",
  "zygocactus": "heal",
  "zygodactyl": "beautiful",
  "zygoma": "heal",
  "zygomatic": "heal",
  "zygomorphic": "beautiful",
  "zygomorphous": "beautiful",
  "zygomycetes": "heal",
  "zygomycota": "heal",
  "zygomycotina": "heal",
  "zygophyllaceae": "heal",
  "zygophyllum": "heal",
  "zygoptera": "heal",
  "zygospore": "heal",
  "zygote": "heal",
  "zygotene": "smart",
  "zyloprim": "build",
  "zymology": "smart",
  "zymolysis": "smart",
  "zymolytic": "taste",
  "zymosis": "smart",
  "zymotic": "taste",
  "zymurgy": "smart",
  "zyrian": "story",
  "artisan": "beautiful",
  "sketching": "beautiful",
  "sculpting": "beautiful",
  "sculptor": "beautiful",
  "exhibition": "beautiful",
  "decorative": "beautiful",
  "dyeing": "beautiful",
  "screenprint": "beautiful",
  "conceptual": "beautiful",
  "impressionist": "beautiful",
  "expressionist": "beautiful",
  "surrealist": "beautiful",
  "hyperrealism": "beautiful",
  "still-life": "beautiful",
  "glazing": "beautiful",
  "underpainting": "beautiful",
  "gesso": "beautiful",
  "curator": "beautiful",
  "curate": "beautiful",
  "curation": "beautiful",
  "parametric": "smart",
  "debug": "smart",
  "debugging": "smart",
  "deployment": "smart",
  "automate": "smart",
  "scripting": "smart",
  "api": "smart",
  "app": "smart",
  "frontend": "smart",
  "backend": "smart",
  "fullstack": "smart",
  "devops": "smart",
  "microservice": "smart",
  "docker": "smart",
  "kubernetes": "smart",
  "virtualization": "smart",
  "refactor": "smart",
  "refactoring": "smart",
  "repo": "smart",
  "git": "smart",
  "github": "smart",
  "versioning": "smart",
  "agile": "smart",
  "scrum": "smart",
  "sprint": "smart",
  "chef": "taste",
  "simmer": "taste",
  "sauteing": "taste",
  "marinate": "taste",
  "umami": "taste",
  "barista": "taste",
  "pickling": "taste",
  "canning": "taste",
  "preserving": "taste",
  "terroir": "taste",
  "foodie": "taste",
  "qgis": "smart",
  "arcgis": "smart",
  "gis": "smart",
  "geospatial": "smart",
  "cartography": "smart",
  "cartographic": "smart",
  "cartographer": "smart",
  "topographic": "smart",
  "terrain": "smart",
  "elevation": "smart",
  "geodetic": "smart",
  "shapefile": "smart",
  "geojson": "smart",
  "georeferencing": "smart",
  "geocoding": "smart",
  "spatial": "smart",
  "heightmap": "smart",
  "dem": "smart",
  "bathymetry": "smart",
  "photogrammetry": "smart",
  "orthophoto": "smart",
  "basemap": "smart",
  "tileset": "smart",
  "heatmap": "smart",
  "choropleth": "smart",
  "isochronal": "smart",
  "kriging": "smart",
  "geostatistics": "smart",
  "geodatabase": "smart",
  "gpkg": "smart",
  "wms": "smart",
  "wfs": "smart",
  "ogc": "smart",
  "epsg": "smart",
  "mercator": "smart",
  "azimuthal": "smart",
  "conic": "smart",
  "choreographer": "beautiful",
  "dancer": "beautiful",
  "pirouette": "beautiful",
  "plie": "beautiful",
  "breakdancing": "beautiful",
  "rehearsal": "beautiful",
  "performer": "beautiful",
  "troupe": "beautiful",
  "ensemble": "beautiful",
  "improv": "beautiful",
  "freestyle": "beautiful",
  "pointe": "beautiful",
  "fouette": "beautiful",
  "barre": "beautiful",
  "corps": "beautiful",
  "choreographic": "beautiful",
  "kinesthetic": "beautiful",
  "somatic": "beautiful",
  "gestural": "beautiful",
  "kathak": "beautiful",
  "bharatanatyam": "beautiful",
  "butoh": "beautiful",
  "capoeira": "beautiful",
  "krump": "beautiful",
  "waacking": "beautiful",
  "bboy": "beautiful",
  "bgirl": "beautiful",
  "mocap": "smart",
  "keyframe": "smart",
  "keyframing": "smart",
  "retopology": "smart",
  "uvmap": "smart",
  "shader": "smart",
  "viewport": "smart",
  "compositor": "smart",
  "polygon": "smart",
  "nurbs": "smart",
  "tangent": "smart",
  "pose": "beautiful",
  "animation": "smart",
  "animator": "smart",
  "animating": "smart",
  "skinning": "smart",
  "weightpaint": "smart",
  "boolean": "smart",
  "wireframe": "smart",
  "raytracing": "smart",
  "pathtracing": "smart",
  "volumetric": "smart",
  "hdri": "smart",
  "pbr": "smart",
  "metalness": "smart",
  "roughness": "smart",
  "albedo": "smart",
  "ambient": "sound",
  "agriculture": "build",
  "permaculture": "build",
  "agroforestry": "build",
  "soil": "build",
  "compost": "build",
  "composting": "build",
  "irrigation": "build",
  "sustainable": "build",
  "sustainability": "build",
  "ecological": "build",
  "regenerative": "build",
  "aquaponics": "build",
  "hydroponics": "build",
  "horticulture": "build",
  "indigenous": "story",
  "decolonial": "story",
  "postcolonial": "story",
  "intercultural": "story",
  "diaspora": "story",
  "agroecology": "build",
  "terracing": "build",
  "mulching": "build",
  "polyculture": "build",
  "monoculture": "build",
  "rainwater": "build",
  "swale": "build",
  "bioswale": "build",
  "mycorrhizal": "heal",
  "rhizosphere": "heal",
  "nitrogen": "heal",
  "anthropological": "smart",
  "ethnographic": "smart",
  "sociological": "smart",
  "archaeological": "smart",
  "methodological": "smart",
  "praxis": "smart",
  "kinanthropology": "smart",
  "symposium": "story",
  "advocacy": "story",
  "accountability": "story",
  "whistleblower": "story",
  "ombudsman": "story",
  "injustice": "story",
  "inequity": "story",
  "disparate": "story",
  "yummy": "taste",
  "steaming": "taste",
  "simmering": "taste",
  "blanching": "taste",
  "poaching": "taste",
  "braising": "taste",
  "bbq": "taste",
  "noodles": "taste",
  "brewer": "taste",
  "foodtruck": "taste",
  "appetite": "taste",
  "pungent": "taste",
  "tangy": "taste",
  "spicy": "taste",
  "bland": "taste",
  "crispy": "taste",
  "crunchy": "taste",
  "moist": "taste",
  "creamy": "taste",
  "songs": "sound",
  "singer": "sound",
  "vocals": "sound",
  "drums": "sound",
  "drummer": "sound",
  "orchestral": "sound",
  "chords": "sound",
  "scales": "sound",
  "tuning": "sound",
  "notes": "sound",
  "speakers": "sound",
  "headphones": "sound",
  "mic": "sound",
  "earbuds": "sound",
  "soloist": "sound",
  "composer": "sound",
  "lyrics": "sound",
  "lyricist": "sound",
  "arranger": "sound",
  "remix": "sound",
  "ep": "sound",
  "vinyl": "sound",
  "reverb": "sound",
  "delay": "sound",
  "phaser": "sound",
  "flanger": "sound",
  "wah": "sound",
  "hertz": "sound",
  "loudness": "sound",
  "amplitude": "sound",
  "waveform": "sound",
  "synth": "sound",
  "rapping": "sound",
  "ska": "sound",
  "punk": "sound",
  "electronic": "sound",
  "dubstep": "sound",
  "lofi": "sound",
  "soul": "sound",
  "bossa": "sound",
  "cumbia": "sound",
  "merengue": "sound",
  "bachata": "sound",
  "pretty": "beautiful",
  "gorgeous": "beautiful",
  "stunning": "beautiful",
  "illustrator": "beautiful",
  "photographer": "beautiful",
  "designer": "beautiful",
  "visuals": "beautiful",
  "symmetry": "beautiful",
  "gradient": "beautiful",
  "hue": "beautiful",
  "tint": "beautiful",
  "clay": "beautiful",
  "gemstone": "beautiful",
  "cosmetics": "beautiful",
  "stylist": "beautiful",
  "couture": "beautiful",
  "origami": "beautiful",
  "papercutting": "beautiful",
  "wood": "build",
  "wooden": "build",
  "nails": "build",
  "cement": "build",
  "insulation": "build",
  "electrical": "build",
  "measurement": "build",
  "level": "build",
  "sanding": "build",
  "tablesaw": "build",
  "blacksmith": "build",
  "extrusion": "build",
  "machining": "build",
  "cnc": "build",
  "turning": "build",
  "brazing": "build",
  "riveting": "build",
  "bearing": "build",
  "demolition": "build",
  "renovation": "build",
  "neural": "smart",
  "dataset": "smart",
  "tensorflow": "smart",
  "pytorch": "smart",
  "numpy": "smart",
  "pandas": "smart",
  "jupyter": "smart",
  "golang": "smart",
  "kotlin": "smart",
  "perl": "smart",
  "haskell": "smart",
  "vue": "smart",
  "svelte": "smart",
  "nodejs": "smart",
  "django": "smart",
  "fastapi": "smart",
  "nosql": "smart",
  "mongodb": "smart",
  "postgresql": "smart",
  "mysql": "smart",
  "redis": "smart",
  "aws": "smart",
  "gcp": "smart",
  "terraform": "smart",
  "macos": "smart",
  "gitlab": "smart",
  "encryption": "smart",
  "hashing": "smart",
  "vpn": "smart",
  "ssl": "smart",
  "tls": "smart",
  "oauth": "smart",
  "jwt": "smart",
  "gpu": "smart",
  "ssd": "smart",
  "motherboard": "smart",
  "hexadecimal": "smart",
  "function": "smart",
  "complexity": "smart",
  "breakpoint": "smart",
  "runtime": "smart",
  "emulator": "smart",
  "voxel": "smart",
  "opengl": "smart",
  "vulkan": "smart",
  "directx": "smart",
  "webgl": "smart",
  "microcontroller": "smart",
  "encoder": "smart",
  "relay": "smart",
  "stories": "story",
  "writer": "story",
  "poet": "story",
  "director": "story",
  "actor": "story",
  "actress": "story",
  "narrator": "story",
  "subplot": "story",
  "protagonist": "story",
  "villain": "story",
  "heroine": "story",
  "trilogy": "story",
  "publisher": "story",
  "journalist": "story",
  "reporter": "story",
  "byline": "story",
  "docuseries": "story",
  "blogger": "story",
  "playwright": "story",
  "scriptwriter": "story",
  "showrunner": "story",
  "wideshot": "story",
  "steadicam": "story",
  "animatic": "story",
  "voiceover": "story",
  "health": "heal",
  "doctor": "heal",
  "therapy": "heal",
  "therapist": "heal",
  "surgeon": "heal",
  "pharmacist": "heal",
  "vaccination": "heal",
  "immunization": "heal",
  "antibody": "heal",
  "antigen": "heal",
  "disease": "heal",
  "disorder": "heal",
  "tumor": "heal",
  "cancer": "heal",
  "orthopedic": "heal",
  "anesthesia": "heal",
  "dentist": "heal",
  "orthodontist": "heal",
  "optometry": "heal",
  "optometrist": "heal",
  "oxygen": "heal",
  "paramedic": "heal",
  "triage": "heal",
  "icu": "heal",
  "wellbeing": "heal",
  "fitness": "heal",
  "exercise": "heal",
  "anxiety": "heal",
  "depression": "heal",
  "ptsd": "heal",
  "adhd": "heal",
  "counselor": "heal",
  "psychologist": "heal",
  "psychiatrist": "heal",
  "customer": "sell",
  "startup": "sell",
  "investor": "sell",
  "ad": "sell",
  "ads": "sell",
  "supplier": "sell",
  "vendor": "sell",
  "merchant": "sell",
  "ecommerce": "sell",
  "shopify": "sell",
  "transaction": "sell",
  "bookkeeping": "sell",
  "recession": "sell",
  "ceo": "sell",
  "cfo": "sell",
  "cto": "sell",
  "manager": "sell",
  "executive": "sell",
  "llc": "sell",
  "merger": "sell",
  "ipo": "sell",
  "licensing": "sell",
  "saas": "sell",
  "analytics": "sell",
  "kpi": "sell",
  "roi": "sell",
  "crm": "sell",
  "outreach": "sell",
  "tradeshow": "sell",
  "expo": "sell",
  "fulfillment": "sell",

};

export function lookupWordZone(word) {
  if (!word || typeof word !== 'string') return null;
  return ZONE_DICTIONARY[word.toLowerCase().trim()] ?? null;
}

export function scoreTextWithDictionary(text, weight = 1) {
  if (!text) return {};
  const scores = {};
  const words = text.toLowerCase().split(/[\s,;/|+&.!?()\[\]{}'\"]+/).filter(Boolean);
  for (const word of words) {
    const zone = ZONE_DICTIONARY[word];
    if (zone) scores[zone] = (scores[zone] || 0) + weight;
  }
  return scores;
}
